// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8 8%27%3e%3cpath fill=%27%237ABA09%27 d=%27M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 12 12%27 width=%2712%27 height=%2712%27 fill=%27none%27 stroke=%27%23D61F05%27%3e%3ccircle cx=%276%27 cy=%276%27 r=%274.5%27/%3e%3cpath stroke-linejoin=%27round%27 d=%27M5.8 3.6h.4L6 6.5z%27/%3e%3ccircle cx=%276%27 cy=%278.2%27 r=%27.6%27 fill=%27%23D61F05%27 stroke=%27none%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("assets/fonts/nucleo-icons.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("assets/fonts/nucleo-icons.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("assets/fonts/nucleo-icons.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("assets/fonts/nucleo-icons.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("assets/fonts/nucleo-icons.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("data:image/gif;base64,R0lGODlhIAAgAPMAAP///wAAAMbGxoSEhLa2tpqamjY2NlZWVtjY2OTk5Ly8vB4eHgQEBAAAAAAAAAAAACH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAIAAgAAAE5xDISWlhperN52JLhSSdRgwVo1ICQZRUsiwHpTJT4iowNS8vyW2icCF6k8HMMBkCEDskxTBDAZwuAkkqIfxIQyhBQBFvAQSDITM5VDW6XNE4KagNh6Bgwe60smQUB3d4Rz1ZBApnFASDd0hihh12BkE9kjAJVlycXIg7CQIFA6SlnJ87paqbSKiKoqusnbMdmDC2tXQlkUhziYtyWTxIfy6BE8WJt5YJvpJivxNaGmLHT0VnOgSYf0dZXS7APdpB309RnHOG5gDqXGLDaC457D1zZ/V/nmOM82XiHRLYKhKP1oZmADdEAAAh+QQJCgAAACwAAAAAIAAgAAAE6hDISWlZpOrNp1lGNRSdRpDUolIGw5RUYhhHukqFu8DsrEyqnWThGvAmhVlteBvojpTDDBUEIFwMFBRAmBkSgOrBFZogCASwBDEY/CZSg7GSE0gSCjQBMVG023xWBhklAnoEdhQEfyNqMIcKjhRsjEdnezB+A4k8gTwJhFuiW4dokXiloUepBAp5qaKpp6+Ho7aWW54wl7obvEe0kRuoplCGepwSx2jJvqHEmGt6whJpGpfJCHmOoNHKaHx61WiSR92E4lbFoq+B6QDtuetcaBPnW6+O7wDHpIiK9SaVK5GgV543tzjgGcghAgAh+QQJCgAAACwAAAAAIAAgAAAE7hDISSkxpOrN5zFHNWRdhSiVoVLHspRUMoyUakyEe8PTPCATW9A14E0UvuAKMNAZKYUZCiBMuBakSQKG8G2FzUWox2AUtAQFcBKlVQoLgQReZhQlCIJesQXI5B0CBnUMOxMCenoCfTCEWBsJColTMANldx15BGs8B5wlCZ9Po6OJkwmRpnqkqnuSrayqfKmqpLajoiW5HJq7FL1Gr2mMMcKUMIiJgIemy7xZtJsTmsM4xHiKv5KMCXqfyUCJEonXPN2rAOIAmsfB3uPoAK++G+w48edZPK+M6hLJpQg484enXIdQFSS1u6UhksENEQAAIfkECQoAAAAsAAAAACAAIAAABOcQyEmpGKLqzWcZRVUQnZYg1aBSh2GUVEIQ2aQOE+G+cD4ntpWkZQj1JIiZIogDFFyHI0UxQwFugMSOFIPJftfVAEoZLBbcLEFhlQiqGp1Vd140AUklUN3eCA51C1EWMzMCezCBBmkxVIVHBWd3HHl9JQOIJSdSnJ0TDKChCwUJjoWMPaGqDKannasMo6WnM562R5YluZRwur0wpgqZE7NKUm+FNRPIhjBJxKZteWuIBMN4zRMIVIhffcgojwCF117i4nlLnY5ztRLsnOk+aV+oJY7V7m76PdkS4trKcdg0Zc0tTcKkRAAAIfkECQoAAAAsAAAAACAAIAAABO4QyEkpKqjqzScpRaVkXZWQEximw1BSCUEIlDohrft6cpKCk5xid5MNJTaAIkekKGQkWyKHkvhKsR7ARmitkAYDYRIbUQRQjWBwJRzChi9CRlBcY1UN4g0/VNB0AlcvcAYHRyZPdEQFYV8ccwR5HWxEJ02YmRMLnJ1xCYp0Y5idpQuhopmmC2KgojKasUQDk5BNAwwMOh2RtRq5uQuPZKGIJQIGwAwGf6I0JXMpC8C7kXWDBINFMxS4DKMAWVWAGYsAdNqW5uaRxkSKJOZKaU3tPOBZ4DuK2LATgJhkPJMgTwKCdFjyPHEnKxFCDhEAACH5BAkKAAAALAAAAAAgACAAAATzEMhJaVKp6s2nIkolIJ2WkBShpkVRWqqQrhLSEu9MZJKK9y1ZrqYK9WiClmvoUaF8gIQSNeF1Er4MNFn4SRSDARWroAIETg1iVwuHjYB1kYc1mwruwXKC9gmsJXliGxc+XiUCby9ydh1sOSdMkpMTBpaXBzsfhoc5l58Gm5yToAaZhaOUqjkDgCWNHAULCwOLaTmzswadEqggQwgHuQsHIoZCHQMMQgQGubVEcxOPFAcMDAYUA85eWARmfSRQCdcMe0zeP1AAygwLlJtPNAAL19DARdPzBOWSm1brJBi45soRAWQAAkrQIykShQ9wVhHCwCQCACH5BAkKAAAALAAAAAAgACAAAATrEMhJaVKp6s2nIkqFZF2VIBWhUsJaTokqUCoBq+E71SRQeyqUToLA7VxF0JDyIQh/MVVPMt1ECZlfcjZJ9mIKoaTl1MRIl5o4CUKXOwmyrCInCKqcWtvadL2SYhyASyNDJ0uIiRMDjI0Fd30/iI2UA5GSS5UDj2l6NoqgOgN4gksEBgYFf0FDqKgHnyZ9OX8HrgYHdHpcHQULXAS2qKpENRg7eAMLC7kTBaixUYFkKAzWAAnLC7FLVxLWDBLKCwaKTULgEwbLA4hJtOkSBNqITT3xEgfLpBtzE/jiuL04RGEBgwWhShRgQExHBAAh+QQJCgAAACwAAAAAIAAgAAAE7xDISWlSqerNpyJKhWRdlSAVoVLCWk6JKlAqAavhO9UkUHsqlE6CwO1cRdCQ8iEIfzFVTzLdRAmZX3I2SfZiCqGk5dTESJeaOAlClzsJsqwiJwiqnFrb2nS9kmIcgEsjQydLiIlHehhpejaIjzh9eomSjZR+ipslWIRLAgMDOR2DOqKogTB9pCUJBagDBXR6XB0EBkIIsaRsGGMMAxoDBgYHTKJiUYEGDAzHC9EACcUGkIgFzgwZ0QsSBcXHiQvOwgDdEwfFs0sDzt4S6BK4xYjkDOzn0unFeBzOBijIm1Dgmg5YFQwsCMjp1oJ8LyIAACH5BAkKAAAALAAAAAAgACAAAATwEMhJaVKp6s2nIkqFZF2VIBWhUsJaTokqUCoBq+E71SRQeyqUToLA7VxF0JDyIQh/MVVPMt1ECZlfcjZJ9mIKoaTl1MRIl5o4CUKXOwmyrCInCKqcWtvadL2SYhyASyNDJ0uIiUd6GGl6NoiPOH16iZKNlH6KmyWFOggHhEEvAwwMA0N9GBsEC6amhnVcEwavDAazGwIDaH1ipaYLBUTCGgQDA8NdHz0FpqgTBwsLqAbWAAnIA4FWKdMLGdYGEgraigbT0OITBcg5QwPT4xLrROZL6AuQAPUS7bxLpoWidY0JtxLHKhwwMJBTHgPKdEQAACH5BAkKAAAALAAAAAAgACAAAATrEMhJaVKp6s2nIkqFZF2VIBWhUsJaTokqUCoBq+E71SRQeyqUToLA7VxF0JDyIQh/MVVPMt1ECZlfcjZJ9mIKoaTl1MRIl5o4CUKXOwmyrCInCKqcWtvadL2SYhyASyNDJ0uIiUd6GAULDJCRiXo1CpGXDJOUjY+Yip9DhToJA4RBLwMLCwVDfRgbBAaqqoZ1XBMHswsHtxtFaH1iqaoGNgAIxRpbFAgfPQSqpbgGBqUD1wBXeCYp1AYZ19JJOYgH1KwA4UBvQwXUBxPqVD9L3sbp2BNk2xvvFPJd+MFCN6HAAIKgNggY0KtEBAAh+QQJCgAAACwAAAAAIAAgAAAE6BDISWlSqerNpyJKhWRdlSAVoVLCWk6JKlAqAavhO9UkUHsqlE6CwO1cRdCQ8iEIfzFVTzLdRAmZX3I2SfYIDMaAFdTESJeaEDAIMxYFqrOUaNW4E4ObYcCXaiBVEgULe0NJaxxtYksjh2NLkZISgDgJhHthkpU4mW6blRiYmZOlh4JWkDqILwUGBnE6TYEbCgevr0N1gH4At7gHiRpFaLNrrq8HNgAJA70AWxQIH1+vsYMDAzZQPC9VCNkDWUhGkuE5PxJNwiUK4UfLzOlD4WvzAHaoG9nxPi5d+jYUqfAhhykOFwJWiAAAIfkECQoAAAAsAAAAACAAIAAABPAQyElpUqnqzaciSoVkXVUMFaFSwlpOCcMYlErAavhOMnNLNo8KsZsMZItJEIDIFSkLGQoQTNhIsFehRww2CQLKF0tYGKYSg+ygsZIuNqJksKgbfgIGepNo2cIUB3V1B3IvNiBYNQaDSTtfhhx0CwVPI0UJe0+bm4g5VgcGoqOcnjmjqDSdnhgEoamcsZuXO1aWQy8KAwOAuTYYGwi7w5h+Kr0SJ8MFihpNbx+4Erq7BYBuzsdiH1jCAzoSfl0rVirNbRXlBBlLX+BP0XJLAPGzTkAuAOqb0WT5AH7OcdCm5B8TgRwSRKIHQtaLCwg1RAAAOwAAAAAAAAAAAA==", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAATCAQAAADYWf5HAAAAkElEQVQoz7X QMQ5AQBCF4dWQSJxC5wwax1Cq1e7BAdxD5SL+Tq/QCM1oNiJidwox0355mXnG/DrEtIQ6azioNZQxI0ykPhTQIwhCR+BmBYtlK7kLJYwWCcJA9M4qdrZrd8pPjZWPtOqdRQy320YSV17OatFC4euts6z39GYMKRPCTKY9UnPQ6P+GtMRfGtPnBCiqhAeJPmkqAAAAAElFTkSuQmCC", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAATCAYAAAByUDbMAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAIGNIUk0AAG2YAABzjgAA+swAAIT6AAB5gQAA/RMAADBtAAASKQ0eJk4AAACASURBVHja7NKhDcJQFIbRV1MSEqaoYwYMYyARR6HZowzAHqguUolHYEgxD9MmTYPpA1JEb/KZK476Q4wxfKvwc6x/WKJE3v+nYkc8cfgIwxpXRNQokjBkOLdQ1wlZCrbFbYDdsRmFYYVqAHVdsBiD7dHg8aYGu2l2NmMz9s/YawDpU8qkYQTHqgAAAABJRU5ErkJggg==", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAATCAYAAAByUDbMAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAIGNIUk0AAG2YAABzjgAA+swAAIT6AAB5gQAA/RMAADBtAAASKQ0eJk4AAACFSURBVHja7NKhDcJQFIbRWwMJCVPgmKGGMZCIo9DsAQOwRxWLIPEIDCnmYR4JaSp4DYKQis/8NznqRkopvlWM2Ij9BYY1Wtx7arEpwaZokHo6Yf4xFhGBGrcOdMUqIqIUq3DoYEdUxVgGFzhn6ILl61aMZXCLB3bv+1Bsgj1mg7CfeNrnAMXSyqQtsCNeAAAAAElFTkSuQmCC", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/*!

 =========================================================
 * Light Bootstrap Dashboard - v2.0.1
 =========================================================

 * Product Page: http://www.creative-tim.com/product/light-bootstrap-dashboard
 * Copyright 2020 Creative Tim (http://www.creative-tim.com)
 * License (http://www.creative-tim.com/license)

 =========================================================

 * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

 */
/*      light colors         */
@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.modal.show .modal-dialog {
  transform: translate(0, 30%);
}
.modal.modal-mini .modal-dialog {
  max-width: 255px;
  margin: 0 auto;
}
.modal .modal-content .modal-header {
  border-bottom: none;
  padding-top: 24px;
  padding-right: 24px;
  padding-bottom: 0;
  padding-left: 24px;
}
.modal .modal-content .modal-header .modal-profile {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  text-align: center;
  line-height: 5.7;
  box-shadow: 0px 1px 20px 0px rgba(0, 0, 0, 0.3);
}
.modal .modal-content .modal-header .modal-profile i {
  font-size: 32px;
  padding-top: 24px;
}
.modal .modal-content .modal-body {
  padding-top: 24px;
  padding-right: 24px;
  padding-bottom: 16px;
  padding-left: 24px;
  line-height: 1.9;
}
.modal .modal-content .modal-body + .modal-footer {
  padding-top: 0;
}
.modal .modal-content .modal-footer {
  border-top: none;
  padding-right: 24px;
  padding-bottom: 16px;
  padding-left: 24px;
  justify-content: space-between;
}
.modal .modal-content .modal-footer .btn {
  margin: 0;
  padding-left: 16px;
  padding-right: 16px;
  width: auto;
}
.modal .modal-content .modal-footer .btn:hover, .modal .modal-content .modal-footer .btnfocus {
  text-decoration: none;
}

/*           Font Smoothing      */
body,
h1, .h1,
h2, .h2,
h3, .h3,
h4, .h4,
h5, .h5,
h6, .h6,
p,
.navbar,
.brand,
.btn-simple,
.alert,
a,
.td-name,
td,
button.close {
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  font-family: "Roboto", "Helvetica Neue", Arial, sans-serif;
  font-weight: 400;
}

button.close {
  font-size: 1.125rem;
}

h1, .h1, h2, .h2, h3, .h3, h4, .h4 {
  font-weight: 300;
  margin: 30px 0 15px;
}

h1, .h1 {
  font-size: 3.25rem;
}

h2, .h2 {
  font-size: 2.25rem;
}

h3, .h3 {
  font-size: 1.75rem;
  margin: 20px 0 10px;
}

h4, .h4 {
  font-size: 1.375rem;
  line-height: 30px;
}

h5, .h5 {
  font-size: 1.125rem;
  margin-bottom: 15px;
}

h6, .h6 {
  font-size: 0.875rem;
  font-weight: 600;
  text-transform: uppercase;
}

p, .p {
  font-size: 1rem;
  line-height: 1.5;
}

h1 small, h2 small, h3 small, h4 small, h5 small, h6 small, .h1 small, .h2 small, .h3 small, .h4 small, .h5 small, .h6 small, h1 .small, h2 .small, h3 .small, h4 .small, h5 .small, h6 .small, .h1 .small, .h2 .small, .h3 .small, .h4 .small, .h5 .small, .h6 .small {
  color: #58595B;
  font-weight: 300;
  line-height: 1.5;
}

h1 small, h2 small, h3 small, h1 .small, h2 .small, h3 .small {
  font-size: 60%;
}

h1 .subtitle {
  display: block;
  margin: 0 0 30px;
}

.text-muted {
  color: #9A9A9A;
}

.text-primary, .text-primary:hover {
  color: #1D62F0 !important;
}

.text-info, .text-info:hover {
  color: #003380 !important;
}

.text-success, .text-success:hover {
  color: #7ABA09 !important;
}

.text-warning, .text-warning:hover {
  color: #FFE200 !important;
}

.text-danger, .text-danger:hover {
  color: #D61F05 !important;
}

.typo-line {
  padding-left: 140px;
  margin-bottom: 40px;
  position: relative;
}
.typo-line .category {
  transform: translateY(-50%);
  top: 50%;
  left: 0px;
  position: absolute;
  font-size: 14px;
  font-weight: 400;
  color: #888888;
  margin-bottom: 0px;
}

blockquote {
  padding: 10px 20px;
  margin: 0 0 20px;
  font-size: 17.5px;
  border-left: 5px solid #eee;
}

.valid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: #7ABA09;
}

.valid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.25rem 0.5rem;
  margin-top: 0.1rem;
  font-size: 0.765625rem;
  color: #000;
  background-color: rgba(122, 186, 9, 0.9);
  border-radius: var(--bs-border-radius);
}

.was-validated :valid ~ .valid-feedback,
.was-validated :valid ~ .valid-tooltip,
.is-valid ~ .valid-feedback,
.is-valid ~ .valid-tooltip {
  display: block;
}

.was-validated .form-control:valid, .form-control.is-valid {
  border-color: #7ABA09;
  padding-right: calc(1.5em + 0.75rem);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.1875rem) center;
  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}
.was-validated .form-control:valid:focus, .form-control.is-valid:focus {
  border-color: #7ABA09;
  box-shadow: 0 0 0 0.25rem rgba(122, 186, 9, 0.25);
}

.was-validated textarea.form-control:valid, textarea.form-control.is-valid {
  padding-right: calc(1.5em + 0.75rem);
  background-position: top calc(0.375em + 0.1875rem) right calc(0.375em + 0.1875rem);
}

.was-validated .form-select:valid, .form-select.is-valid {
  border-color: #7ABA09;
}
.was-validated .form-select:valid:not([multiple]):not([size]), .was-validated .form-select:valid:not([multiple])[size="1"], .form-select.is-valid:not([multiple]):not([size]), .form-select.is-valid:not([multiple])[size="1"] {
  --bs-form-select-bg-icon: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  padding-right: 4.125rem;
  background-position: right 0.75rem center, center right 2.25rem;
  background-size: 16px 12px, calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}
.was-validated .form-select:valid:focus, .form-select.is-valid:focus {
  border-color: #7ABA09;
  box-shadow: 0 0 0 0.25rem rgba(122, 186, 9, 0.25);
}

.was-validated .form-control-color:valid, .form-control-color.is-valid {
  width: calc(3rem + calc(1.5em + 0.75rem));
}

.was-validated .form-check-input:valid, .form-check-input.is-valid {
  border-color: #7ABA09;
}
.was-validated .form-check-input:valid:checked, .form-check-input.is-valid:checked {
  background-color: #7ABA09;
}
.was-validated .form-check-input:valid:focus, .form-check-input.is-valid:focus {
  box-shadow: 0 0 0 0.25rem rgba(122, 186, 9, 0.25);
}
.was-validated .form-check-input:valid ~ .form-check-label, .form-check-input.is-valid ~ .form-check-label {
  color: #7ABA09;
}

.form-check-inline .form-check-input ~ .valid-feedback {
  margin-left: 0.5em;
}

.was-validated .input-group > .form-control:not(:focus):valid, .input-group > .form-control:not(:focus).is-valid,
.was-validated .input-group > .form-select:not(:focus):valid,
.input-group > .form-select:not(:focus).is-valid,
.was-validated .input-group > .form-floating:not(:focus-within):valid,
.input-group > .form-floating:not(:focus-within).is-valid {
  z-index: 3;
}

.invalid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: #D61F05;
}

.invalid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.25rem 0.5rem;
  margin-top: 0.1rem;
  font-size: 0.765625rem;
  color: #fff;
  background-color: rgba(214, 31, 5, 0.9);
  border-radius: var(--bs-border-radius);
}

.was-validated :invalid ~ .invalid-feedback,
.was-validated :invalid ~ .invalid-tooltip,
.is-invalid ~ .invalid-feedback,
.is-invalid ~ .invalid-tooltip {
  display: block;
}

.was-validated .form-control:invalid, .form-control.is-invalid {
  border-color: #D61F05;
  padding-right: calc(1.5em + 0.75rem);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.1875rem) center;
  background-size: calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}
.was-validated .form-control:invalid:focus, .form-control.is-invalid:focus {
  border-color: #D61F05;
  box-shadow: 0 0 0 0.25rem rgba(214, 31, 5, 0.25);
}

.was-validated textarea.form-control:invalid, textarea.form-control.is-invalid {
  padding-right: calc(1.5em + 0.75rem);
  background-position: top calc(0.375em + 0.1875rem) right calc(0.375em + 0.1875rem);
}

.was-validated .form-select:invalid, .form-select.is-invalid {
  border-color: #D61F05;
}
.was-validated .form-select:invalid:not([multiple]):not([size]), .was-validated .form-select:invalid:not([multiple])[size="1"], .form-select.is-invalid:not([multiple]):not([size]), .form-select.is-invalid:not([multiple])[size="1"] {
  --bs-form-select-bg-icon: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  padding-right: 4.125rem;
  background-position: right 0.75rem center, center right 2.25rem;
  background-size: 16px 12px, calc(0.75em + 0.375rem) calc(0.75em + 0.375rem);
}
.was-validated .form-select:invalid:focus, .form-select.is-invalid:focus {
  border-color: #D61F05;
  box-shadow: 0 0 0 0.25rem rgba(214, 31, 5, 0.25);
}

.was-validated .form-control-color:invalid, .form-control-color.is-invalid {
  width: calc(3rem + calc(1.5em + 0.75rem));
}

.was-validated .form-check-input:invalid, .form-check-input.is-invalid {
  border-color: #D61F05;
}
.was-validated .form-check-input:invalid:checked, .form-check-input.is-invalid:checked {
  background-color: #D61F05;
}
.was-validated .form-check-input:invalid:focus, .form-check-input.is-invalid:focus {
  box-shadow: 0 0 0 0.25rem rgba(214, 31, 5, 0.25);
}
.was-validated .form-check-input:invalid ~ .form-check-label, .form-check-input.is-invalid ~ .form-check-label {
  color: #D61F05;
}

.form-check-inline .form-check-input ~ .invalid-feedback {
  margin-left: 0.5em;
}

.was-validated .input-group > .form-control:not(:focus):invalid, .input-group > .form-control:not(:focus).is-invalid,
.was-validated .input-group > .form-select:not(:focus):invalid,
.input-group > .form-select:not(:focus).is-invalid,
.was-validated .input-group > .form-floating:not(:focus-within):invalid,
.input-group > .form-floating:not(:focus-within).is-invalid {
  z-index: 4;
}

/*     General overwrite     */
body,
.wrapper {
  min-height: 100vh;
  position: relative;
}

a {
  color: #003380;
}
a:hover, a:focus {
  color: rgb(0, 38.8078125, 97.4);
  text-decoration: none;
}

a:focus, a:active,
button::-moz-focus-inner,
input::-moz-focus-inner,
input[type=reset]::-moz-focus-inner,
input[type=button]::-moz-focus-inner,
input[type=submit]::-moz-focus-inner,
select::-moz-focus-inner,
input[type=file] > input[type=button]::-moz-focus-inner {
  outline: 0;
}

.ui-slider-handle:focus,
.navbar-toggle,
input:focus {
  outline: 0 !important;
}

/*           Animations              */
.form-control,
.input-group-addon,
.tagsinput,
.navbar,
.navbar .alert {
  transition: all 300ms linear;
}

.animation-transition-fast,
.sidebar .nav .collapse a > span,
.sidebar .sidebar-wrapper > .nav p,
.sidebar .user .info > a > span,
.sidebar .logo a.logo-normal,
.sidebar .user .info .collapse .nav a > span {
  transition: all 150ms linear;
}

.sidebar .nav a,
.table > tbody > tr .td-actions .btn {
  transition: all 150ms ease-in;
}

.btn {
  transition: all 60ms ease-in;
}

.fa, .fas, .far, .fal, .fad, .fab {
  width: 18px;
  text-align: center;
}

.margin-top {
  margin-top: 50px;
}

.wrapper {
  position: relative;
  top: 0;
  height: 100vh;
}

.card .map {
  height: 400px;
}
.card .map .map-big {
  height: 350px;
}

.page-header .page-header-image {
  background-position: center center;
  background-size: cover;
  height: 450px;
  overflow: hidden;
  width: 100%;
  z-index: 1;
}
.page-header .title-container {
  color: #fff;
  position: relative;
  top: 200px;
  z-index: 3;
}
.page-header .filter:after {
  background: rgba(0, 0, 0, 0) linear-gradient(to bottom, #9368e9 0%, #943bea 100%) repeat scroll 0 0/150% 150%;
  content: "";
  display: block;
  height: 450px;
  left: 0;
  opacity: 0.77;
  position: absolute;
  top: 0;
  width: 100%;
  z-index: 2;
}

.form-control,
.input-group-addon,
.tagsinput,
.navbar .alert,
.card-collapse.collapse {
  transition: all 300ms linear;
}

.card .card-body.content-full-width {
  padding: 15px 0px 10px 0px;
}
.card .card-body.content-full-width .accordions .card-title a {
  padding: 0px 0px 5px 15px;
}

.sidebar,
.main-panel,
.sidebar-wrapper,
.navbar-fixed,
.navbar-minimize {
  transition-property: top, bottom, width;
  transition-duration: 0.2s, 0.2s, 0.35s;
  transition-timing-function: linear, linear, ease;
  -webkit-overflow-scrolling: touch;
}

.animation-transition-general,
.sidebar .nav p,
.sidebar .user .photo,
.bootstrap-navbar .user .photo,
.sidebar .user a,
.bootstrap-navbar .user a,
.login-page .card {
  transition: all 300ms linear;
}

.sidebar {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  width: 260px;
  display: block;
  z-index: 999;
  color: #fff;
  font-weight: 200;
  background-size: cover;
  background-position: center center;
}
.sidebar .logo-img {
  width: 30px;
  display: inline-block;
  max-height: 30px;
}
.sidebar .logo-img img {
  width: 35px;
  top: 1px;
  position: absolute;
  left: 0px;
}
.sidebar .logo {
  padding: 12px 0px 9px;
  margin: 0;
  position: relative;
  z-index: 4;
  display: block;
}
.sidebar .logo a.logo-mini {
  /*float: left;
  width: 30px;
  text-align: center;
  margin-left: 23px;
  margin-right: 15px;
  position: relative;*/
  display: none;
}
.sidebar .logo a.logo-normal {
  display: block;
  opacity: 1;
  transform: translate3d(0px, 0, 0);
}
.sidebar .logo .simple-text {
  text-transform: uppercase;
  padding: 5px 0px;
  display: inline-block;
  font-size: 1.125rem;
  font-weight: 400;
  line-height: 30px;
  white-space: nowrap;
  color: #FFFFFF;
  overflow: hidden;
}
.sidebar .logo p {
  float: left;
  font-size: 20px;
  margin: 10px 10px;
  line-height: 20px;
}
.sidebar .logo:before {
  content: "";
  position: absolute;
  bottom: 0px;
  right: 15px;
  width: calc(100% - 30px);
  height: 1px;
}
.sidebar .sidebar-wrapper {
  position: relative;
  max-height: calc(100vh - 75px);
  min-height: 100%;
  overflow: auto;
  width: 260px;
  z-index: 4;
  padding-bottom: 100px;
}
.sidebar .sidebar-wrapper .nav .nav-item [data-toggle=collapse] ~ div .nav .nav-item .nav-link {
  background: transparent;
  padding-left: 55px;
  text-transform: capitalize;
  padding: 5px 15px 5px 15px;
  font-weight: 400;
  font-size: 14px;
}
.sidebar .sidebar-wrapper .nav .nav-item [data-toggle=collapse] ~ div .nav .nav-item:hover .nav-link, .sidebar .sidebar-wrapper .nav .nav-item [data-toggle=collapse] ~ div .nav .nav-item:focus .nav-link, .sidebar .sidebar-wrapper .nav .nav-item [data-toggle=collapse] ~ div .nav .nav-item.active .nav-link {
  background: rgba(255, 255, 255, 0.13);
}
.sidebar .sidebar-wrapper .nav .nav-item [data-toggle=collapse] ~ div .nav .sidebar-normal {
  left: 15px;
}
.sidebar .sidebar-wrapper .nav .nav-link p {
  margin: 0;
  line-height: 30px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  white-space: nowrap;
  position: relative;
  color: #003380;
  transform: translate3d(0px, 0, 0);
  display: block;
  height: auto;
  opacity: 1;
}
.sidebar .sidebar-wrapper .navbar-form.navbar-search-form {
  margin-top: 15px;
  padding-left: 25px;
}
.sidebar .sidebar-wrapper .navbar-form.navbar-search-form input {
  padding-left: 10px;
  padding-top: 5px;
}
.sidebar .sidebar-background {
  /* For browsers that do not support gradients */
  background: #0084CA;
  /* For Safari 5.1 to 6.0 */
  /* For Opera 11.1 to 12.0 */
  /* For Firefox 3.6 to 15 */
  /* Standard syntax */
  background: linear-gradient(#e6f6ff, #29b1fa, #003380);
  padding: 0px;
  min-height: 100%;
  position: absolute;
  z-index: 1;
  height: 100%;
  width: 100%;
  display: block;
  top: 0;
  left: 0;
  background-size: cover;
  background-position: center center;
}
.sidebar .user {
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
  padding-bottom: 20px;
  margin-top: 20px;
}
.sidebar .user .photo {
  width: 34px;
  height: 34px;
  overflow: hidden;
  border-radius: 50%;
  float: left;
  margin-right: 11px;
  margin-left: 23px;
  z-index: 5;
  border: 2px solid rgba(255, 255, 255, 0.3);
}
.sidebar .user .photo img {
  width: 100%;
}
.sidebar .user .info .caret {
  right: 15px;
  top: -5px;
}
.sidebar .user .info a {
  color: #FFFFFF;
  padding: 8px 14px;
  display: block;
  white-space: nowrap;
  line-height: 18px;
}
.sidebar .user .info span {
  position: relative;
  display: block;
}
.sidebar .user .info .collapse .sidebar-normal {
  padding-left: 0;
}
.sidebar .user .profile-dropdown {
  text-align: left !important;
  padding-left: 25px !important;
}
.sidebar .user .profile-dropdown .sidebar-mini,
.sidebar .user .profile-dropdown .sidebar-normal {
  margin-right: 0;
  font-size: 14px;
}
.sidebar .user .profile-dropdown .sidebar-normal {
  left: 15px;
}
.sidebar .caret {
  display: inline-block;
  width: 0;
  height: 0;
  vertical-align: middle;
  border-top: 4px dashed;
  border-top: 4px solid\\9 ;
  border-right: 4px solid transparent;
  border-left: 4px solid transparent;
  margin-top: 13px;
  position: absolute;
  right: 0;
  transition: all 150ms ease-in;
}
.sidebar a[data-toggle=collapse][aria-expanded=true] .caret,
.sidebar .btn[data-toggle=collapse][aria-expanded=true] .caret,
.sidebar a.dropdown-toggle[aria-expanded=true] .caret {
  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=2);
  transform: rotate(180deg);
}
.sidebar .nav {
  float: none;
  display: block;
}
.sidebar .nav .nav-item .nav-link {
  color: #003380;
  margin: 5px 15px 0px 10px;
  opacity: 0.86;
  border-radius: 4px;
  text-transform: uppercase;
  line-height: 30px;
  font-size: 12px;
  font-weight: 600;
  padding: 10px 15px;
  white-space: nowrap;
}
.sidebar .nav .nav-item .nav-link:hover {
  color: rgb(0, 0.19921875, 0.5);
  background: rgba(255, 255, 255, 0.13);
  opacity: 1;
}
.sidebar .nav .nav-item .nav-link i {
  font-size: 28px;
  margin-right: 15px;
  width: 30px;
  text-align: center;
  vertical-align: middle;
  float: left;
}
.sidebar .nav .nav-item:not(.collapse .nav-link):hover .nav-link {
  background: rgba(255, 255, 255, 0.13);
  opacity: 1;
}
.sidebar .nav .nav-item.active .nav-link {
  color: rgb(0, 0.19921875, 0.5);
  opacity: 1;
  background: rgba(255, 255, 255, 0.23);
}
.sidebar .nav .nav-item.separator {
  margin: 15px 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.2);
}
.sidebar .nav .nav-item.separator + .nav-item {
  margin-top: 31px;
}
.sidebar:after, .sidebar:before {
  display: block;
  content: "";
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 2;
}
.sidebar:before {
  opacity: 0.33;
  background: #aaa;
}
.sidebar[data-image]:after, .sidebar.has-image:after {
  opacity: 0.95;
}

.sidebar .logo p,
.bootstrap-navbar .logo p {
  float: left;
  font-size: 20px;
  margin: 10px 10px;
  color: #FFFFFF;
  line-height: 20px;
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
}
.sidebar .logo .logo-text,
.bootstrap-navbar .logo .logo-text {
  text-transform: uppercase;
  padding: 5px 0px 5px 15px;
  display: block;
  font-size: 1.125rem;
  color: #FFFFFF;
  font-weight: 400;
  line-height: 30px;
  white-space: nowrap;
  overflow: hidden;
}
.sidebar .logo .logo-image,
.bootstrap-navbar .logo .logo-image {
  float: left;
  height: 40px;
  width: 40px;
  margin: 0 10px;
}
.sidebar .logo .logo-round,
.bootstrap-navbar .logo .logo-round {
  border-radius: 50%;
  display: block;
  overflow: hidden;
}
.sidebar .logo .logo-round img,
.bootstrap-navbar .logo .logo-round img {
  width: 100%;
}
.sidebar .logo:before,
.bootstrap-navbar .logo:before {
  content: "";
  position: absolute;
  bottom: 0px;
  right: 15px;
  width: calc(100% - 30px);
  height: 1px;
  background-color: rgba(255, 255, 255, 0.3);
}
.sidebar .logo-mini .logo-text,
.bootstrap-navbar .logo-mini .logo-text {
  text-transform: uppercase;
  padding: 7px 0px;
  display: block;
  font-size: 1.125rem;
  color: #FFFFFF;
  font-weight: 400;
  line-height: 30px;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
}
.sidebar[data-color=black]:after,
.bootstrap-navbar[data-color=black]:after {
  background: rgb(120.7, 120.7, 120.7);
  background: linear-gradient(to bottom, rgb(120.7, 120.7, 120.7) 0%, rgba(120.7, 120.7, 120.7, 0.7) 100%);
  background-size: 150% 150%;
}
.sidebar[data-color=blue]:after,
.bootstrap-navbar[data-color=blue]:after {
  background: #003380;
  background: linear-gradient(to bottom, #003380 0%, rgba(83, 60, 225, 0.7) 100%);
  background-size: 150% 150%;
}
.sidebar[data-color=azure]:after,
.bootstrap-navbar[data-color=azure]:after {
  background: #0084CA;
  background: linear-gradient(to bottom, #0084CA 0%, rgba(64, 145, 255, 0.7) 100%);
  background-size: 150% 150%;
}
.sidebar[data-color=green]:after,
.bootstrap-navbar[data-color=green]:after {
  background: #7ABA09;
  background: linear-gradient(to bottom, #7ABA09 0%, rgba(122, 186, 9, 0.7) 100%);
  background-size: 150% 150%;
}
.sidebar[data-color=orange]:after,
.bootstrap-navbar[data-color=orange]:after {
  background: #FFE200;
  background: linear-gradient(to bottom, #FFE200 0%, rgba(255, 82, 33, 0.7) 100%);
  background-size: 150% 150%;
}
.sidebar[data-color=red]:after,
.bootstrap-navbar[data-color=red]:after {
  background: #D61F05;
  background: linear-gradient(to bottom, #D61F05 0%, rgba(187, 5, 2, 0.7) 100%);
  background-size: 150% 150%;
}
.sidebar[data-color=purple]:after,
.bootstrap-navbar[data-color=purple]:after {
  background: #9368E9;
  background: linear-gradient(to bottom, #9368E9 0%, rgba(148, 59, 234, 0.7) 100%);
  background-size: 150% 150%;
}

.main-panel {
  background: rgba(203, 203, 210, 0.15);
  position: relative;
  float: right;
  width: calc(100% - 260px);
}
.main-panel .content {
  padding: 30px 15px;
  min-height: calc(100vh - 123px);
}
.main-panel .footer {
  border-top: 1px solid #e7e7e7;
}
.main-panel .navbar {
  margin-bottom: 0;
}

.sidebar-mini .sidebar .logo a.logo-mini {
  float: left;
  /* width: 30px; */
  text-align: center;
  margin-left: 23px;
  margin-right: 15px;
  position: relative;
  display: block;
}
.sidebar-mini .sidebar .sidebar-wrapper .nav .nav-item:hover .collapse .nav-item .nav-link {
  padding: 5px 15px;
}

.sidebar .sidebar-wrapper .nav [data-toggle=collapse] ~ div > ul > li > a .sidebar-mini,
.sidebar .sidebar-wrapper .user .info [data-toggle=collapse] ~ div > ul > li > a .sidebar-mini {
  text-transform: uppercase;
  float: left;
  width: 30px;
  text-align: center;
  letter-spacing: 1px;
}

.sidebar .sidebar-wrapper > .nav [data-toggle=collapse] ~ div > ul > li > a .sidebar-normal,
.sidebar .sidebar-wrapper .user .info [data-toggle=collapse] ~ div > ul > li > a .sidebar-normal,
.off-canvas-sidebar .sidebar-wrapper > .nav [data-toggle=collapse] ~ div > ul > li > a .sidebar-normal,
.off-canvas-sidebar .sidebar-wrapper .user .info [data-toggle=collapse] ~ div > ul > li > a .sidebar-normal {
  margin: 0;
  position: relative;
  transform: translateX(0px);
  opacity: 1;
  white-space: nowrap;
  display: inline-block;
  line-height: 23px;
}

.sidebar .nav .nav-item .nav-link .sidebar-mini {
  padding-left: 5px !important;
  opacity: 0.86 !important;
}

@media (min-width: 992px) {
  .sidebar-mini .visible-on-sidebar-regular {
    display: none !important;
  }
  .sidebar-mini .visible-on-sidebar-mini {
    display: inline-block !important;
  }
  .sidebar-mini .sidebar {
    width: 80px;
    display: block;
    font-weight: 200;
    z-index: 999;
    position: fixed;
  }
  .sidebar-mini .sidebar .logo a.logo-mini {
    opacity: 1;
  }
  .sidebar-mini .sidebar .logo a.logo-normal {
    opacity: 0;
    transform: translate3d(-25px, 0, 0);
  }
  .sidebar-mini .sidebar .sidebar-wrapper {
    overflow: inherit;
    width: 80px;
    box-shadow: none;
  }
  .sidebar-mini .sidebar .sidebar-wrapper .nav [data-toggle=collapse] ~ div > ul > li > a .sidebar-normal,
  .sidebar-mini .sidebar .sidebar-wrapper .user .info [data-toggle=collapse] ~ div > ul > li > a .sidebar-normal,
  .sidebar-mini .sidebar .sidebar-wrapper .user .info > a > span,
  .sidebar-mini .sidebar .sidebar-wrapper > .nav li > a p {
    transform: translate3d(-25px, 0, 0);
    opacity: 0;
  }
  .sidebar-mini .sidebar .info .collapse .nav li > a {
    margin: 0;
    border-radius: 0;
  }
  .sidebar-mini .sidebar .info .caret {
    opacity: 0;
  }
  .sidebar-mini .sidebar .info [data-toggle=collapse] ~ div > ul > li:last-child > a {
    margin-bottom: 5px;
    border-bottom-left-radius: 3px;
    border-bottom-right-radius: 3px;
  }
  .sidebar-mini .sidebar .info [data-toggle=collapse] ~ div > ul > li:first-child > a {
    margin-top: 5px;
    border-top-left-radius: 3px;
    border-top-right-radius: 3px;
  }
  .sidebar-mini .sidebar .nav .nav-item .nav-link .sidebar-mini {
    padding-left: 30px !important;
  }
  .sidebar-mini .sidebar:hover {
    width: 260px;
  }
  .sidebar-mini .sidebar:hover .logo a.logo-normal {
    opacity: 1;
    transform: translate3d(0px, 0, 0);
  }
  .sidebar-mini .sidebar:hover .nav-item [data-toggle=collapse] ~ div .nav .sidebar-normal {
    left: 0;
  }
  .sidebar-mini .sidebar:hover .caret {
    opacity: 1;
  }
  .sidebar-mini .sidebar:hover .sidebar-wrapper {
    width: 260px;
  }
  .sidebar-mini .sidebar:hover .sidebar-wrapper > .nav li > a p,
  .sidebar-mini .sidebar:hover .sidebar-wrapper > .nav [data-toggle=collapse] ~ div > ul > li > a .sidebar-normal,
  .sidebar-mini .sidebar:hover .sidebar-wrapper .user .info [data-toggle=collapse] ~ div > ul > li > a .sidebar-normal,
  .sidebar-mini .sidebar:hover .sidebar-wrapper .user .info > a > p,
  .sidebar-mini .sidebar:hover .sidebar-wrapper > .nav li > a .caret,
  .sidebar-mini .sidebar:hover .sidebar-wrapper .user .info a span {
    transform: translate3d(0px, 0, 0);
    opacity: 1;
  }
  .sidebar-mini .sidebar:hover .sidebar-wrapper > .nav li.active > a:not([data-toggle=collapse]):before, .sidebar-mini .sidebar:hover .sidebar-wrapper > .nav li.active > a:not([data-toggle=collapse]):after {
    opacity: 0;
  }
  .sidebar-mini .sidebar:hover .nav .nav-item .nav-link .sidebar-mini {
    margin-right: 5px !important;
  }
  .sidebar-mini .sidebar:hover .sidebar-normal {
    padding-left: 10px;
    padding-right: 10px;
    margin: 5px 15px 0px;
    border-radius: 4px;
    color: #FFFFFF;
    opacity: 0.86;
  }
  .sidebar-mini .main-panel {
    width: calc(100% - 80px);
    margin-left: 80px;
  }
  .sidebar-mini .wrapper {
    height: auto;
  }
  .sidebar-mini .sidebar,
  .sidebar-mini .main-panel {
    overflow: visible;
    max-height: none;
    height: auto;
  }
  .sidebar-mini .navbar-fixed {
    width: calc(100% - 80px) !important;
  }
}
.visible-on-sidebar-regular {
  display: inline-block !important;
}

.visible-on-sidebar-mini {
  display: none !important;
}

.navbar-minimize {
  margin-right: 15px;
}

.wrapper-full-page {
  min-height: 100vh;
  height: 100%;
}
.wrapper-full-page .navbar {
  z-index: 1030;
}
.wrapper-full-page .navbar .nav-link i {
  font-size: 18px;
  position: relative;
  right: 10px;
  text-align: center;
}
.wrapper-full-page .navbar .nav-item.active .nav-link {
  background-color: rgba(255, 255, 255, 0.2) !important;
}
.wrapper-full-page .navbar .nav-link:not(.btn):hover {
  background-color: rgba(255, 255, 255, 0.2) !important;
  border-radius: 0.1875rem;
  transition: all 300ms linear;
}
.wrapper-full-page .navbar .navbar-nav .nav-item .nav-link {
  padding: 3px 15px;
}
.wrapper-full-page .footer {
  position: relative;
  z-index: 2;
  background: transparent;
}
.wrapper-full-page .footer .copyright {
  color: rgba(255, 255, 255, 0.7);
}
.wrapper-full-page .footer .copyright a {
  opacity: 1;
}

.full-page .full-page-background {
  position: absolute;
  z-index: 1;
  height: 100%;
  width: 100%;
  display: block;
  top: 0;
  left: 0;
  background-size: cover;
  background-position: center center;
}
.full-page:before, .full-page:after {
  display: block;
  content: "";
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 2;
}
.full-page:before {
  opacity: 0.33;
  background: #000000;
}
.full-page.register-page .content:first-of-type {
  padding-top: 10vh;
}
.full-page > .content {
  min-height: calc(100vh - 70px);
  z-index: 4;
  position: relative;
}
.full-page > .content .card-register .card-title {
  color: #FFFFFF;
}
.full-page > .content .card-register .card-subtitle {
  margin-top: 10px;
  margin-bottom: 0;
  font-size: 21px;
  color: #FFFFFF;
}
.full-page > .content .card-register .footer {
  background-color: transparent;
}
.full-page > .content .card-register .content {
  padding-top: 5%;
}
.full-page > .content .card-register .media {
  color: #FFFFFF;
  margin-bottom: 15px;
}
.full-page > .content .card-register .media .icon {
  float: left;
  margin-right: 5px;
}
.full-page > .content .card-register .media .icon i {
  font-size: 36px;
}
.full-page > .content .card-register .media .media-left,
.full-page > .content .card-register .media .media-body {
  display: table-cell;
  vertical-align: top;
}
.full-page > .content .card-register .media .media-body {
  overflow: hidden;
}
.full-page > .content .card-register .media h4 {
  margin: 0 0 5px 15px;
  text-align: left;
}
.full-page > .content .card-register .media p {
  text-align: justify;
  margin-left: 15px;
}
.full-page > .content:first-of-type {
  padding-top: 20vh;
}
.full-page.register-page .content {
  padding-top: 10vh;
}
.full-page[data-color=black]:after {
  background: rgb(120.7, 120.7, 120.7);
  background: linear-gradient(to bottom, rgb(120.7, 120.7, 120.7) 0%, rgb(120.7, 120.7, 120.7) 100%);
  background-size: 150% 150%;
}
.full-page[data-color=blue]:after {
  background: #1F77D0;
  background: linear-gradient(to bottom, #1F77D0 0%, #533ce1 100%);
  background-size: 150% 150%;
}
.full-page[data-color=azure]:after {
  background: #1DC7EA;
  background: linear-gradient(to bottom, #1DC7EA 0%, #4091ff 100%);
  background-size: 150% 150%;
}
.full-page[data-color=green]:after {
  background: #7ABA09;
  background: linear-gradient(to bottom, #7ABA09 0%, #7ABA09 100%);
  background-size: 150% 150%;
}
.full-page[data-color=orange]:after {
  background: #FFE200;
  background: linear-gradient(to bottom, #FFE200 0%, #ff5221 100%);
  background-size: 150% 150%;
}
.full-page[data-color=red]:after {
  background: #D61F05;
  background: linear-gradient(to bottom, #D61F05 0%, #bb0502 100%);
  background-size: 150% 150%;
}
.full-page[data-color=purple]:after {
  background: #9368E9;
  background: linear-gradient(to bottom, #9368E9 0%, #943bea 100%);
  background-size: 150% 150%;
}

.full-page[data-image]:after,
.full-page.has-image:after {
  opacity: 0.77;
}

.fixed-plugin .dropdown .dropdown-menu {
  border-radius: 10px;
}
.fixed-plugin .dropdown .dropdown-menu li.adjustments-line {
  border-bottom: 1px solid #ddd;
}
.fixed-plugin .dropdown .dropdown-menu li {
  padding: 5px 2px !important;
}
.fixed-plugin .dropdown .dropdown-menu .button-container a {
  font-size: 14px;
}
.fixed-plugin .dropdown .dropdown-menu .adjustments-line .bootstrap-switch {
  position: absolute;
  right: 10px !important;
}
.fixed-plugin .dropdown .dropdown-menu .adjustments-line label {
  margin-bottom: 0.6rem !important;
}

.fixed-plugin li > a,
.fixed-plugin .badge {
  transition: all 0.34s;
  -webkit-transition: all 0.34s;
  -moz-transition: all 0.34s;
}

.fixed-plugin {
  position: fixed;
  top: 200px;
  right: 0;
  width: 64px;
  background: rgba(0, 0, 0, 0.3);
  z-index: 1031;
  border-radius: 8px 0 0 8px;
  text-align: center;
}

.fixed-plugin .fa-cogs {
  color: #FFFFFF;
  padding: 10px;
  border-radius: 0 0 6px 6px;
  width: auto;
}

.fixed-plugin .dropdown-menu {
  right: 80px;
  left: auto;
  width: 290px;
  border-radius: 0.1875rem;
  padding: 0 10px;
}

.fixed-plugin .dropdown-menu:after, .fixed-plugin .dropdown-menu:before {
  right: 10px;
  margin-left: auto;
  left: auto;
}

.fixed-plugin .fa-circle-thin {
  color: #FFFFFF;
}

.fixed-plugin .active .fa-circle-thin {
  color: #00bbff;
}

.fixed-plugin .dropdown-menu > .active > a,
.fixed-plugin .dropdown-menu > .active > a:hover,
.fixed-plugin .dropdown-menu > .active > a:focus {
  color: #777777;
  text-align: center;
}

.fixed-plugin img {
  border-radius: 0;
  width: 100%;
  height: 100px;
  margin: 0 auto;
}

.fixed-plugin .dropdown-menu li > a:hover,
.fixed-plugin .dropdown-menu li > a:focus {
  box-shadow: none;
}

.fixed-plugin .badge {
  border: 3px solid #FFFFFF;
  border-radius: 50%;
  cursor: pointer;
  display: inline-block;
  height: 23px;
  margin-right: 5px;
  position: relative;
  width: 23px;
}

.fixed-plugin .badge.active,
.fixed-plugin .badge:hover {
  border-color: #00bbff;
}

.fixed-plugin .badge-black {
  background-color: #777;
}

.fixed-plugin .badge-azure {
  background-color: #2CA8FF;
}

.fixed-plugin .badge-green {
  background-color: #18ce0f;
}

.fixed-plugin .badge-orange {
  background-color: #f96332;
}

.fixed-plugin .badge-yellow {
  background-color: #FFB236;
}

.fixed-plugin .badge-red {
  background-color: #FF3636;
}

.fixed-plugin .badge-purple {
  background-color: #9368E9;
}

.fixed-plugin h5 {
  font-size: 14px;
  margin: 10px;
}

.fixed-plugin .dropdown-menu li {
  display: block;
  padding: 18px 2px;
  width: 25%;
  float: left;
}

.fixed-plugin li.adjustments-line,
.fixed-plugin li.header-title,
.fixed-plugin li.button-container {
  width: 100%;
  height: 50px;
  min-height: inherit;
}

.fixed-plugin li.button-container {
  height: auto;
}

.fixed-plugin li.button-container div {
  margin-bottom: 5px;
}

.fixed-plugin #sharrreTitle {
  text-align: center;
  padding: 10px 0;
  height: 50px;
}

.fixed-plugin li.header-title {
  height: 30px;
  line-height: 25px;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
}

.fixed-plugin .adjustments-line p {
  float: left;
  display: inline-block;
  margin-bottom: 0;
  font-size: 1em;
  color: #3C4858;
  padding-top: 7px;
}

.fixed-plugin .adjustments-line a .badge-colors {
  position: relative;
  top: -2px;
}

.fixed-plugin .adjustments-line .togglebutton {
  float: right;
}

.fixed-plugin .adjustments-line .togglebutton .toggle {
  margin-right: 0;
}

.fixed-plugin .dropdown-menu > li.adjustments-line > a {
  padding-right: 0;
  padding-left: 0;
  /*border-bottom: 1px solid #ddd;*/
  border-radius: 0;
  margin: 0;
}

.fixed-plugin .dropdown-menu > li > a.img-holder {
  font-size: 16px;
  text-align: center;
  border-radius: 10px;
  background-color: #FFF;
  border: 3px solid #FFF;
  padding-left: 0;
  padding-right: 0;
  opacity: 1;
  cursor: pointer;
  display: block;
  max-height: 100px;
  overflow: hidden;
  padding: 0;
}

.fixed-plugin .dropdown-menu > li > a.switch-trigger:hover,
.fixed-plugin .dropdown-menu > li > a.switch-trigger:focus {
  background-color: transparent;
}

.fixed-plugin .dropdown-menu > li:hover > a.img-holder,
.fixed-plugin .dropdown-menu > li:focus > a.img-holder {
  border-color: rgba(0, 187, 255, 0.53);
}

.fixed-plugin .dropdown-menu > .active > a.img-holder,
.fixed-plugin .dropdown-menu > .active > a.img-holder {
  border-color: #00bbff;
  background-color: #FFFFFF;
}

.fixed-plugin .dropdown-menu > li > a img {
  margin-top: auto;
}

.fixed-plugin .btn-social {
  width: 50%;
  display: block;
  width: 48%;
  float: left;
  font-weight: 600;
}

.fixed-plugin .btn-social i {
  margin-right: 5px;
}

.fixed-plugin .btn-social:first-child {
  margin-right: 2%;
}

.fixed-plugin .adjustments-line a:hover,
.fixed-plugin .adjustments-line a:focus,
.fixed-plugin .adjustments-line a {
  color: transparent;
}

.fixed-plugin .dropdown .dropdown-menu {
  transform: translate3d(0, -5%, 0) !important;
  top: -40px !important;
  opacity: 0;
  left: -303px !important;
  transform-origin: 0 0;
}

.fixed-plugin .dropdown.show .dropdown-menu {
  opacity: 1;
  transform: translate3d(0, 0%, 0) !important;
  transform-origin: 0 0;
  left: -303px !important;
}

.fixed-plugin .dropdown-menu:before,
.fixed-plugin .dropdown-menu:after {
  content: "";
  display: inline-block;
  position: absolute;
  top: 65px;
  width: 16px;
  transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  -moz-transform: translateY(-50%);
}

.fixed-plugin .dropdown-menu:before {
  border-bottom: 16px solid rgba(0, 0, 0, 0);
  border-left: 16px solid rgba(0, 0, 0, 0.2);
  border-top: 16px solid rgba(0, 0, 0, 0);
  right: -16px;
}

.fixed-plugin .dropdown-menu:after {
  border-bottom: 16px solid rgba(0, 0, 0, 0);
  border-left: 16px solid #fff;
  border-top: 16px solid rgba(0, 0, 0, 0);
  right: -15px;
}

.wrapper-full-page ~ .fixed-plugin .dropdown.open .dropdown-menu {
  transform: translateY(-17%);
}

.wrapper-full-page ~ .fixed-plugin .dropdown .dropdown-menu {
  transform: translateY(-19%);
}

.modal-header {
  border: 0 none;
}

.modal-content {
  border: 0 none;
  border-radius: 10px;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.15), 0 0 1px 1px rgba(0, 0, 0, 0.1);
}

.modal-dialog {
  padding-top: 60px;
}

.modal-footer {
  border-top: 0 none;
  padding: 10px 10px;
}

.modal-footer .modal-footer .btn-default.btn-simple {
  font-weight: 400;
}

.modal.fade .modal-dialog {
  transform: none;
  -webkit-transform: none;
  -moz-transform: none;
}

.modal.in .modal-dialog {
  transform: none;
  -webkit-transform: none;
  -moz-transform: none;
}

.modal-small .modal-dialog {
  max-width: 350px;
}

.modal-small .divider {
  margin: 0 auto;
  display: block;
  width: 14px;
  position: relative;
  margin-top: 40px;
  margin-bottom: 30px;
  font-size: 1rem;
}
.modal-small .divider:after {
  position: absolute;
  content: "";
  right: -140px;
  top: 12px;
  height: 1px;
  width: 115px;
  background-color: #E3E3E3;
}
.modal-small .divider:before {
  position: absolute;
  content: "";
  left: -140px;
  top: 12px;
  height: 1px;
  width: 115px;
  background-color: #E3E3E3;
}
.modal-small .modal-footer {
  text-align: center;
}

.social-area {
  text-align: center;
}
.social-area .btn-social {
  margin: 0 10px;
}

.modal-backdrop.in {
  opacity: 0.25;
}

.btn {
  border-width: 2px;
  background-color: transparent;
  font-weight: 400;
  padding: 8px 16px;
  border: 1px solid #888888;
  color: #FFFFFF;
  background-color: #888888;
  cursor: pointer;
  margin-bottom: 5px;
  font-size: 0.875rem;
  line-height: 1.42857143;
}
.btn:hover, .btn:focus, .btn:active, .btn.active, .open > .btn.dropdown-toggle {
  background-color: rgb(120.7, 120.7, 120.7);
  color: #FFFFFF;
  border-color: rgb(120.7, 120.7, 120.7);
}
.btn.disabled, .btn.disabled:hover, .btn.disabled:focus, .btn.disabled.focus, .btn.disabled:active, .btn.disabled.active, .btn:disabled, .btn:disabled:hover, .btn:disabled:focus, .btn:disabled.focus, .btn:disabled:active, .btn:disabled.active, .btn[disabled], .btn[disabled]:hover, .btn[disabled]:focus, .btn[disabled].focus, .btn[disabled]:active, .btn[disabled].active, fieldset[disabled] .btn, fieldset[disabled] .btn:hover, fieldset[disabled] .btn:focus, fieldset[disabled] .btn.focus, fieldset[disabled] .btn:active, fieldset[disabled] .btn.active {
  background-color: #E3E3E3;
  border-color: #EAF0F4;
  cursor: not-allowed;
  pointer-events: all !important;
}
.btn.btn-outline {
  color: #888888;
  background-color: transparent;
  border: 1px solid #888888;
  opacity: 1;
  filter: alpha(opacity=100);
}
.btn.btn-outline:hover, .btn.btn-outline:focus, .btn.btn-outline:active, .btn.btn-outline.active, .open > .btn.btn-outline.dropdown-toggle {
  background-color: rgb(120.7, 120.7, 120.7);
  color: #FFFFFF;
  border: 1px solid rgb(120.7, 120.7, 120.7);
}
.btn.btn-outline .caret {
  border-top-color: #FFFFFF;
}
.btn.btn-link {
  border-color: transparent !important;
  background-color: transparent !important;
  color: #888888;
}
.btn.btn-link:hover, .btn.btn-link:focus, .btn.btn-link:active {
  text-decoration: none;
  border-color: transparent;
  color: rgb(120.7, 120.7, 120.7);
}
.btn .caret {
  border-top-color: #888888;
}
.btn:hover, .btn:focus {
  outline: 0 !important;
  box-shadow: none;
}
.btn:active, .btn.active, .open > .btn.dropdown-toggle {
  box-shadow: none;
  outline: 0 !important;
}
.btn.btn-icon {
  padding: 8px;
}

.btn-primary {
  border: 1px solid #0084CA;
  color: #FFFFFF;
  background-color: #0084CA;
  cursor: pointer;
}
.btn-primary:hover, .btn-primary:focus, .btn-primary:active, .btn-primary.active, .open > .btn-primary.dropdown-toggle {
  background-color: rgb(0, 115.3366336634, 176.5);
  color: #FFFFFF;
  border-color: rgb(0, 115.3366336634, 176.5);
}
.btn-primary.disabled, .btn-primary.disabled:hover, .btn-primary.disabled:focus, .btn-primary.disabled.focus, .btn-primary.disabled:active, .btn-primary.disabled.active, .btn-primary:disabled, .btn-primary:disabled:hover, .btn-primary:disabled:focus, .btn-primary:disabled.focus, .btn-primary:disabled:active, .btn-primary:disabled.active, .btn-primary[disabled], .btn-primary[disabled]:hover, .btn-primary[disabled]:focus, .btn-primary[disabled].focus, .btn-primary[disabled]:active, .btn-primary[disabled].active, fieldset[disabled] .btn-primary, fieldset[disabled] .btn-primary:hover, fieldset[disabled] .btn-primary:focus, fieldset[disabled] .btn-primary.focus, fieldset[disabled] .btn-primary:active, fieldset[disabled] .btn-primary.active {
  background-color: #E3E3E3;
  border-color: #EAF0F4;
  cursor: not-allowed;
  pointer-events: all !important;
}
.btn-primary.btn-outline {
  color: #0084CA;
  background-color: transparent;
  border: 1px solid #0084CA;
  opacity: 1;
  filter: alpha(opacity=100);
}
.btn-primary.btn-outline:hover, .btn-primary.btn-outline:focus, .btn-primary.btn-outline:active, .btn-primary.btn-outline.active, .open > .btn-primary.btn-outline.dropdown-toggle {
  background-color: rgb(0, 115.3366336634, 176.5);
  color: #FFFFFF;
  border: 1px solid rgb(0, 115.3366336634, 176.5);
}
.btn-primary.btn-outline .caret {
  border-top-color: #FFFFFF;
}
.btn-primary.btn-link {
  border-color: transparent !important;
  background-color: transparent !important;
  color: #888888;
}
.btn-primary.btn-link:hover, .btn-primary.btn-link:focus, .btn-primary.btn-link:active {
  text-decoration: none;
  border-color: transparent;
  color: rgb(120.7, 120.7, 120.7);
}
.btn-primary .caret {
  border-top-color: #0084CA;
}

.btn-success {
  border: 1px solid #7ABA09;
  color: #FFFFFF;
  background-color: #7ABA09;
  cursor: pointer;
}
.btn-success:hover, .btn-success:focus, .btn-success:active, .btn-success.active, .open > .btn-success.dropdown-toggle {
  background-color: rgb(106.0461538462, 161.6769230769, 7.8230769231);
  color: #FFFFFF;
  border-color: rgb(106.0461538462, 161.6769230769, 7.8230769231);
}
.btn-success.disabled, .btn-success.disabled:hover, .btn-success.disabled:focus, .btn-success.disabled.focus, .btn-success.disabled:active, .btn-success.disabled.active, .btn-success:disabled, .btn-success:disabled:hover, .btn-success:disabled:focus, .btn-success:disabled.focus, .btn-success:disabled:active, .btn-success:disabled.active, .btn-success[disabled], .btn-success[disabled]:hover, .btn-success[disabled]:focus, .btn-success[disabled].focus, .btn-success[disabled]:active, .btn-success[disabled].active, fieldset[disabled] .btn-success, fieldset[disabled] .btn-success:hover, fieldset[disabled] .btn-success:focus, fieldset[disabled] .btn-success.focus, fieldset[disabled] .btn-success:active, fieldset[disabled] .btn-success.active {
  background-color: #E3E3E3;
  border-color: #EAF0F4;
  cursor: not-allowed;
  pointer-events: all !important;
}
.btn-success.btn-outline {
  color: #7ABA09;
  background-color: transparent;
  border: 1px solid #7ABA09;
  opacity: 1;
  filter: alpha(opacity=100);
}
.btn-success.btn-outline:hover, .btn-success.btn-outline:focus, .btn-success.btn-outline:active, .btn-success.btn-outline.active, .open > .btn-success.btn-outline.dropdown-toggle {
  background-color: rgb(106.0461538462, 161.6769230769, 7.8230769231);
  color: #FFFFFF;
  border: 1px solid rgb(106.0461538462, 161.6769230769, 7.8230769231);
}
.btn-success.btn-outline .caret {
  border-top-color: #FFFFFF;
}
.btn-success.btn-link {
  border-color: transparent !important;
  background-color: transparent !important;
  color: #888888;
}
.btn-success.btn-link:hover, .btn-success.btn-link:focus, .btn-success.btn-link:active {
  text-decoration: none;
  border-color: transparent;
  color: rgb(120.7, 120.7, 120.7);
}
.btn-success .caret {
  border-top-color: #7ABA09;
}

.btn-info {
  border: 1px solid #003380;
  color: #FFFFFF;
  background-color: #003380;
  cursor: pointer;
}
.btn-info:hover, .btn-info:focus, .btn-info:active, .btn-info.active, .open > .btn-info.dropdown-toggle {
  background-color: rgb(0, 38.8078125, 97.4);
  color: #FFFFFF;
  border-color: rgb(0, 38.8078125, 97.4);
}
.btn-info.disabled, .btn-info.disabled:hover, .btn-info.disabled:focus, .btn-info.disabled.focus, .btn-info.disabled:active, .btn-info.disabled.active, .btn-info:disabled, .btn-info:disabled:hover, .btn-info:disabled:focus, .btn-info:disabled.focus, .btn-info:disabled:active, .btn-info:disabled.active, .btn-info[disabled], .btn-info[disabled]:hover, .btn-info[disabled]:focus, .btn-info[disabled].focus, .btn-info[disabled]:active, .btn-info[disabled].active, fieldset[disabled] .btn-info, fieldset[disabled] .btn-info:hover, fieldset[disabled] .btn-info:focus, fieldset[disabled] .btn-info.focus, fieldset[disabled] .btn-info:active, fieldset[disabled] .btn-info.active {
  background-color: #E3E3E3;
  border-color: #EAF0F4;
  cursor: not-allowed;
  pointer-events: all !important;
}
.btn-info.btn-outline {
  color: #003380;
  background-color: transparent;
  border: 1px solid #003380;
  opacity: 1;
  filter: alpha(opacity=100);
}
.btn-info.btn-outline:hover, .btn-info.btn-outline:focus, .btn-info.btn-outline:active, .btn-info.btn-outline.active, .open > .btn-info.btn-outline.dropdown-toggle {
  background-color: rgb(0, 38.8078125, 97.4);
  color: #FFFFFF;
  border: 1px solid rgb(0, 38.8078125, 97.4);
}
.btn-info.btn-outline .caret {
  border-top-color: #FFFFFF;
}
.btn-info.btn-link {
  border-color: transparent !important;
  background-color: transparent !important;
  color: #888888;
}
.btn-info.btn-link:hover, .btn-info.btn-link:focus, .btn-info.btn-link:active {
  text-decoration: none;
  border-color: transparent;
  color: rgb(120.7, 120.7, 120.7);
}
.btn-info .caret {
  border-top-color: #003380;
}

.btn-warning {
  border: 1px solid #FFE200;
  color: #FFFFFF;
  background-color: #FFE200;
  cursor: pointer;
}
.btn-warning:hover, .btn-warning:focus, .btn-warning:active, .btn-warning.active, .open > .btn-warning.dropdown-toggle {
  background-color: rgb(219.3, 194.36, 0);
  color: #FFFFFF;
  border-color: rgb(219.3, 194.36, 0);
}
.btn-warning.disabled, .btn-warning.disabled:hover, .btn-warning.disabled:focus, .btn-warning.disabled.focus, .btn-warning.disabled:active, .btn-warning.disabled.active, .btn-warning:disabled, .btn-warning:disabled:hover, .btn-warning:disabled:focus, .btn-warning:disabled.focus, .btn-warning:disabled:active, .btn-warning:disabled.active, .btn-warning[disabled], .btn-warning[disabled]:hover, .btn-warning[disabled]:focus, .btn-warning[disabled].focus, .btn-warning[disabled]:active, .btn-warning[disabled].active, fieldset[disabled] .btn-warning, fieldset[disabled] .btn-warning:hover, fieldset[disabled] .btn-warning:focus, fieldset[disabled] .btn-warning.focus, fieldset[disabled] .btn-warning:active, fieldset[disabled] .btn-warning.active {
  background-color: #E3E3E3;
  border-color: #EAF0F4;
  cursor: not-allowed;
  pointer-events: all !important;
}
.btn-warning.btn-outline {
  color: #FFE200;
  background-color: transparent;
  border: 1px solid #FFE200;
  opacity: 1;
  filter: alpha(opacity=100);
}
.btn-warning.btn-outline:hover, .btn-warning.btn-outline:focus, .btn-warning.btn-outline:active, .btn-warning.btn-outline.active, .open > .btn-warning.btn-outline.dropdown-toggle {
  background-color: rgb(219.3, 194.36, 0);
  color: #FFFFFF;
  border: 1px solid rgb(219.3, 194.36, 0);
}
.btn-warning.btn-outline .caret {
  border-top-color: #FFFFFF;
}
.btn-warning.btn-link {
  border-color: transparent !important;
  background-color: transparent !important;
  color: #888888;
}
.btn-warning.btn-link:hover, .btn-warning.btn-link:focus, .btn-warning.btn-link:active {
  text-decoration: none;
  border-color: transparent;
  color: rgb(120.7, 120.7, 120.7);
}
.btn-warning .caret {
  border-top-color: #FFE200;
}

.btn-danger {
  border: 1px solid #D61F05;
  color: #FFFFFF;
  background-color: #D61F05;
  cursor: pointer;
}
.btn-danger:hover, .btn-danger:focus, .btn-danger:active, .btn-danger.active, .open > .btn-danger.dropdown-toggle {
  background-color: rgb(174.1315068493, 25.2246575342, 4.0684931507);
  color: #FFFFFF;
  border-color: rgb(174.1315068493, 25.2246575342, 4.0684931507);
}
.btn-danger.disabled, .btn-danger.disabled:hover, .btn-danger.disabled:focus, .btn-danger.disabled.focus, .btn-danger.disabled:active, .btn-danger.disabled.active, .btn-danger:disabled, .btn-danger:disabled:hover, .btn-danger:disabled:focus, .btn-danger:disabled.focus, .btn-danger:disabled:active, .btn-danger:disabled.active, .btn-danger[disabled], .btn-danger[disabled]:hover, .btn-danger[disabled]:focus, .btn-danger[disabled].focus, .btn-danger[disabled]:active, .btn-danger[disabled].active, fieldset[disabled] .btn-danger, fieldset[disabled] .btn-danger:hover, fieldset[disabled] .btn-danger:focus, fieldset[disabled] .btn-danger.focus, fieldset[disabled] .btn-danger:active, fieldset[disabled] .btn-danger.active {
  background-color: #E3E3E3;
  border-color: #EAF0F4;
  cursor: not-allowed;
  pointer-events: all !important;
}
.btn-danger.btn-outline {
  color: #D61F05;
  background-color: transparent;
  border: 1px solid #D61F05;
  opacity: 1;
  filter: alpha(opacity=100);
}
.btn-danger.btn-outline:hover, .btn-danger.btn-outline:focus, .btn-danger.btn-outline:active, .btn-danger.btn-outline.active, .open > .btn-danger.btn-outline.dropdown-toggle {
  background-color: rgb(174.1315068493, 25.2246575342, 4.0684931507);
  color: #FFFFFF;
  border: 1px solid rgb(174.1315068493, 25.2246575342, 4.0684931507);
}
.btn-danger.btn-outline .caret {
  border-top-color: #FFFFFF;
}
.btn-danger.btn-link {
  border-color: transparent !important;
  background-color: transparent !important;
  color: #888888;
}
.btn-danger.btn-link:hover, .btn-danger.btn-link:focus, .btn-danger.btn-link:active {
  text-decoration: none;
  border-color: transparent;
  color: rgb(120.7, 120.7, 120.7);
}
.btn-danger .caret {
  border-top-color: #D61F05;
}

.btn-neutral {
  border: 1px solid #FFFFFF;
  color: #FFFFFF;
  background-color: #FFFFFF;
  cursor: pointer;
}
.btn-neutral:hover, .btn-neutral:focus, .btn-neutral:active, .btn-neutral.active, .open > .btn-neutral.dropdown-toggle {
  background-color: #FFFFFF;
  color: #FFFFFF;
  border-color: #FFFFFF;
}
.btn-neutral.disabled, .btn-neutral.disabled:hover, .btn-neutral.disabled:focus, .btn-neutral.disabled.focus, .btn-neutral.disabled:active, .btn-neutral.disabled.active, .btn-neutral:disabled, .btn-neutral:disabled:hover, .btn-neutral:disabled:focus, .btn-neutral:disabled.focus, .btn-neutral:disabled:active, .btn-neutral:disabled.active, .btn-neutral[disabled], .btn-neutral[disabled]:hover, .btn-neutral[disabled]:focus, .btn-neutral[disabled].focus, .btn-neutral[disabled]:active, .btn-neutral[disabled].active, fieldset[disabled] .btn-neutral, fieldset[disabled] .btn-neutral:hover, fieldset[disabled] .btn-neutral:focus, fieldset[disabled] .btn-neutral.focus, fieldset[disabled] .btn-neutral:active, fieldset[disabled] .btn-neutral.active {
  background-color: #E3E3E3;
  border-color: #EAF0F4;
  cursor: not-allowed;
  pointer-events: all !important;
}
.btn-neutral.btn-outline {
  color: #FFFFFF;
  background-color: transparent;
  border: 1px solid #FFFFFF;
  opacity: 1;
  filter: alpha(opacity=100);
}
.btn-neutral.btn-outline:hover, .btn-neutral.btn-outline:focus, .btn-neutral.btn-outline:active, .btn-neutral.btn-outline.active, .open > .btn-neutral.btn-outline.dropdown-toggle {
  background-color: #FFFFFF;
  color: #FFFFFF;
  border: 1px solid #FFFFFF;
}
.btn-neutral.btn-outline .caret {
  border-top-color: #FFFFFF;
}
.btn-neutral.btn-link {
  border-color: transparent !important;
  background-color: transparent !important;
  color: #888888;
}
.btn-neutral.btn-link:hover, .btn-neutral.btn-link:focus, .btn-neutral.btn-link:active {
  text-decoration: none;
  border-color: transparent;
  color: rgb(120.7, 120.7, 120.7);
}
.btn-neutral .caret {
  border-top-color: #FFFFFF;
}
.btn-neutral:active, .btn-neutral.active, .open > .btn-neutral.dropdown-toggle {
  background-color: #FFFFFF;
  color: #888888;
}
.btn-neutral.btn-fill, .btn-neutral.btn-fill:hover, .btn-neutral.btn-fill:focus {
  color: #888888;
}
.btn-neutral.btn-simple:active, .btn-neutral.btn-simple.active {
  background-color: transparent;
}

.btn:disabled, .btn[disabled], .btn.disabled {
  opacity: 0.5;
  filter: alpha(opacity=50);
}

.btn-round {
  border-width: 1px;
  border-radius: 30px !important;
  padding: 8px 16px;
}
.btn-round.btn-icon {
  padding: 8px;
}

.btn-lg {
  font-size: 1.125rem;
  border-radius: 6px;
  padding: 14px 30px;
  font-weight: 400;
}
.btn-lg.btn-round {
  padding: 15px 30px;
}
.btn-lg.btn-simple {
  padding: 16px 30px;
}

.btn-sm {
  font-size: 0.75rem;
  border-radius: 3px;
  padding: 5px 10px;
}
.btn-sm.btn-round {
  padding: 6px 10px;
}
.btn-sm.btn-simple {
  padding: 7px 10px;
}

.btn-wd {
  min-width: 140px;
}

.btn-group.select {
  width: 100%;
}

.btn-group.select .btn {
  text-align: left;
}

.btn-group.select .caret {
  position: absolute;
  top: 50%;
  margin-top: -1px;
  right: 8px;
}

.btn-social {
  opacity: 0.85;
}

.btn-social {
  padding: 8px 9px;
}
.btn-social .fa, .btn-social .fas, .btn-social .far, .btn-social .fal, .btn-social .fad, .btn-social .fab {
  font-size: 18px;
  width: 20px;
  vertical-align: middle;
  display: inline-block;
}
.btn-social.btn-round {
  padding: 8px;
}
.btn-social.btn-link {
  padding: 8px 5px;
  font-size: 16px;
}
.btn-social.btn-link .fa, .btn-social.btn-link .fas, .btn-social.btn-link .far, .btn-social.btn-link .fal, .btn-social.btn-link .fad, .btn-social.btn-link .fab {
  font-size: 20px;
  position: relative;
  top: -2px;
  width: 24px;
}

.btn-facebook {
  border-color: #3b5998;
  background-color: #3b5998;
  color: #FFFFFF;
}
.btn-facebook:hover, .btn-facebook:focus, .btn-facebook:active, .btn-facebook.active, .open > .btn-facebook.dropdown-toggle {
  background-color: rgb(44.7393364929, 67.4881516588, 115.2606635071);
  color: #FFFFFF;
  border-color: #3b5998;
}
.btn-facebook:disabled, .btn-facebook[disabled], .btn-facebook.disabled {
  background-color: transparent;
  border-color: #3b5998;
}
.btn-facebook.btn-outline {
  color: #3b5998;
  background-color: transparent;
  border: 1px solid #3b5998;
}
.btn-facebook.btn-outline:hover, .btn-facebook.btn-outline:focus, .btn-facebook.btn-outline:active, .btn-facebook.btn-outline.active, .open > .btn-facebook.btn-outline.dropdown-toggle {
  background-color: rgb(44.7393364929, 67.4881516588, 115.2606635071);
  color: #FFFFFF;
  border: 1px solid rgb(44.7393364929, 67.4881516588, 115.2606635071);
}
.btn-facebook.btn-link {
  color: #3b5998;
  background-color: transparent;
  border: 1px solid #3b5998;
}
.btn-facebook.btn-link:hover, .btn-facebook.btn-link:focus, .btn-facebook.btn-link:active, .btn-facebook.btn-link.active, .open > .btn-facebook.btn-link.dropdown-toggle {
  background-color: transparent;
  color: rgb(44.7393364929, 67.4881516588, 115.2606635071);
  border: 1px solid rgb(44.7393364929, 67.4881516588, 115.2606635071);
}

.btn-twitter {
  border-color: #55acee;
  background-color: #55acee;
  color: #FFFFFF;
}
.btn-twitter:hover, .btn-twitter:focus, .btn-twitter:active, .btn-twitter.active, .open > .btn-twitter.dropdown-toggle {
  background-color: rgb(38.6363636364, 149.3636363636, 233.3636363636);
  color: #FFFFFF;
  border-color: #55acee;
}
.btn-twitter:disabled, .btn-twitter[disabled], .btn-twitter.disabled {
  background-color: transparent;
  border-color: #55acee;
}
.btn-twitter.btn-outline {
  color: #55acee;
  background-color: transparent;
  border: 1px solid #55acee;
}
.btn-twitter.btn-outline:hover, .btn-twitter.btn-outline:focus, .btn-twitter.btn-outline:active, .btn-twitter.btn-outline.active, .open > .btn-twitter.btn-outline.dropdown-toggle {
  background-color: rgb(38.6363636364, 149.3636363636, 233.3636363636);
  color: #FFFFFF;
  border: 1px solid rgb(38.6363636364, 149.3636363636, 233.3636363636);
}
.btn-twitter.btn-link {
  color: #55acee;
  background-color: transparent;
  border: 1px solid #55acee;
}
.btn-twitter.btn-link:hover, .btn-twitter.btn-link:focus, .btn-twitter.btn-link:active, .btn-twitter.btn-link.active, .open > .btn-twitter.btn-link.dropdown-toggle {
  background-color: transparent;
  color: rgb(38.6363636364, 149.3636363636, 233.3636363636);
  border: 1px solid rgb(38.6363636364, 149.3636363636, 233.3636363636);
}

.btn-pinterest {
  border-color: #cc2127;
  background-color: #cc2127;
  color: #FFFFFF;
}
.btn-pinterest:hover, .btn-pinterest:focus, .btn-pinterest:active, .btn-pinterest.active, .open > .btn-pinterest.dropdown-toggle {
  background-color: rgb(160.1012658228, 25.8987341772, 30.6075949367);
  color: #FFFFFF;
  border-color: #cc2127;
}
.btn-pinterest:disabled, .btn-pinterest[disabled], .btn-pinterest.disabled {
  background-color: transparent;
  border-color: #cc2127;
}
.btn-pinterest.btn-outline {
  color: #cc2127;
  background-color: transparent;
  border: 1px solid #cc2127;
}
.btn-pinterest.btn-outline:hover, .btn-pinterest.btn-outline:focus, .btn-pinterest.btn-outline:active, .btn-pinterest.btn-outline.active, .open > .btn-pinterest.btn-outline.dropdown-toggle {
  background-color: rgb(160.1012658228, 25.8987341772, 30.6075949367);
  color: #FFFFFF;
  border: 1px solid rgb(160.1012658228, 25.8987341772, 30.6075949367);
}
.btn-pinterest.btn-link {
  color: #cc2127;
  background-color: transparent;
  border: 1px solid #cc2127;
}
.btn-pinterest.btn-link:hover, .btn-pinterest.btn-link:focus, .btn-pinterest.btn-link:active, .btn-pinterest.btn-link.active, .open > .btn-pinterest.btn-link.dropdown-toggle {
  background-color: transparent;
  color: rgb(160.1012658228, 25.8987341772, 30.6075949367);
  border: 1px solid rgb(160.1012658228, 25.8987341772, 30.6075949367);
}

.btn-google {
  border-color: #dd4b39;
  background-color: #dd4b39;
  color: #FFFFFF;
}
.btn-google:hover, .btn-google:focus, .btn-google:active, .btn-google.active, .open > .btn-google.dropdown-toggle {
  background-color: rgb(193.7327586207, 50.8793103448, 33.2672413793);
  color: #FFFFFF;
  border-color: #dd4b39;
}
.btn-google:disabled, .btn-google[disabled], .btn-google.disabled {
  background-color: transparent;
  border-color: #dd4b39;
}
.btn-google.btn-outline {
  color: #dd4b39;
  background-color: transparent;
  border: 1px solid #dd4b39;
}
.btn-google.btn-outline:hover, .btn-google.btn-outline:focus, .btn-google.btn-outline:active, .btn-google.btn-outline.active, .open > .btn-google.btn-outline.dropdown-toggle {
  background-color: rgb(193.7327586207, 50.8793103448, 33.2672413793);
  color: #FFFFFF;
  border: 1px solid rgb(193.7327586207, 50.8793103448, 33.2672413793);
}
.btn-google.btn-link {
  color: #dd4b39;
  background-color: transparent;
  border: 1px solid #dd4b39;
}
.btn-google.btn-link:hover, .btn-google.btn-link:focus, .btn-google.btn-link:active, .btn-google.btn-link.active, .open > .btn-google.btn-link.dropdown-toggle {
  background-color: transparent;
  color: rgb(193.7327586207, 50.8793103448, 33.2672413793);
  border: 1px solid rgb(193.7327586207, 50.8793103448, 33.2672413793);
}

.btn-linkedin {
  border-color: #0976b4;
  background-color: #0976b4;
  color: #FFFFFF;
}
.btn-linkedin:hover, .btn-linkedin:focus, .btn-linkedin:active, .btn-linkedin.active, .open > .btn-linkedin.dropdown-toggle {
  background-color: rgb(6.5714285714, 86.1587301587, 131.4285714286);
  color: #FFFFFF;
  border-color: #0976b4;
}
.btn-linkedin:disabled, .btn-linkedin[disabled], .btn-linkedin.disabled {
  background-color: transparent;
  border-color: #0976b4;
}
.btn-linkedin.btn-outline {
  color: #0976b4;
  background-color: transparent;
  border: 1px solid #0976b4;
}
.btn-linkedin.btn-outline:hover, .btn-linkedin.btn-outline:focus, .btn-linkedin.btn-outline:active, .btn-linkedin.btn-outline.active, .open > .btn-linkedin.btn-outline.dropdown-toggle {
  background-color: rgb(6.5714285714, 86.1587301587, 131.4285714286);
  color: #FFFFFF;
  border: 1px solid rgb(6.5714285714, 86.1587301587, 131.4285714286);
}
.btn-linkedin.btn-link {
  color: #0976b4;
  background-color: transparent;
  border: 1px solid #0976b4;
}
.btn-linkedin.btn-link:hover, .btn-linkedin.btn-link:focus, .btn-linkedin.btn-link:active, .btn-linkedin.btn-link.active, .open > .btn-linkedin.btn-link.dropdown-toggle {
  background-color: transparent;
  color: rgb(6.5714285714, 86.1587301587, 131.4285714286);
  border: 1px solid rgb(6.5714285714, 86.1587301587, 131.4285714286);
}

.btn-dribbble {
  border-color: #ea4c89;
  background-color: #ea4c89;
  color: #FFFFFF;
}
.btn-dribbble:hover, .btn-dribbble:focus, .btn-dribbble:active, .btn-dribbble.active, .open > .btn-dribbble.dropdown-toggle {
  background-color: rgb(228.645, 30.355, 106.91);
  color: #FFFFFF;
  border-color: #ea4c89;
}
.btn-dribbble:disabled, .btn-dribbble[disabled], .btn-dribbble.disabled {
  background-color: transparent;
  border-color: #ea4c89;
}
.btn-dribbble.btn-outline {
  color: #ea4c89;
  background-color: transparent;
  border: 1px solid #ea4c89;
}
.btn-dribbble.btn-outline:hover, .btn-dribbble.btn-outline:focus, .btn-dribbble.btn-outline:active, .btn-dribbble.btn-outline.active, .open > .btn-dribbble.btn-outline.dropdown-toggle {
  background-color: rgb(228.645, 30.355, 106.91);
  color: #FFFFFF;
  border: 1px solid rgb(228.645, 30.355, 106.91);
}
.btn-dribbble.btn-link {
  color: #ea4c89;
  background-color: transparent;
  border: 1px solid #ea4c89;
}
.btn-dribbble.btn-link:hover, .btn-dribbble.btn-link:focus, .btn-dribbble.btn-link:active, .btn-dribbble.btn-link.active, .open > .btn-dribbble.btn-link.dropdown-toggle {
  background-color: transparent;
  color: rgb(228.645, 30.355, 106.91);
  border: 1px solid rgb(228.645, 30.355, 106.91);
}

.btn-github {
  border-color: #000000;
  background-color: #000000;
  color: #FFFFFF;
}
.btn-github:hover, .btn-github:focus, .btn-github:active, .btn-github.active, .open > .btn-github.dropdown-toggle {
  background-color: black;
  color: #FFFFFF;
  border-color: #000000;
}
.btn-github:disabled, .btn-github[disabled], .btn-github.disabled {
  background-color: transparent;
  border-color: #000000;
}
.btn-github.btn-outline {
  color: #000000;
  background-color: transparent;
  border: 1px solid #000000;
}
.btn-github.btn-outline:hover, .btn-github.btn-outline:focus, .btn-github.btn-outline:active, .btn-github.btn-outline.active, .open > .btn-github.btn-outline.dropdown-toggle {
  background-color: black;
  color: #FFFFFF;
  border: 1px solid black;
}
.btn-github.btn-link {
  color: #000000;
  background-color: transparent;
  border: 1px solid #000000;
}
.btn-github.btn-link:hover, .btn-github.btn-link:focus, .btn-github.btn-link:active, .btn-github.btn-link.active, .open > .btn-github.btn-link.dropdown-toggle {
  background-color: transparent;
  color: black;
  border: 1px solid black;
}

.btn-youtube {
  border-color: #e52d27;
  background-color: #e52d27;
  color: #FFFFFF;
}
.btn-youtube:hover, .btn-youtube:focus, .btn-youtube:active, .btn-youtube.active, .open > .btn-youtube.dropdown-toggle {
  background-color: rgb(193.6859504132, 28.694214876, 23.3140495868);
  color: #FFFFFF;
  border-color: #e52d27;
}
.btn-youtube:disabled, .btn-youtube[disabled], .btn-youtube.disabled {
  background-color: transparent;
  border-color: #e52d27;
}
.btn-youtube.btn-outline {
  color: #e52d27;
  background-color: transparent;
  border: 1px solid #e52d27;
}
.btn-youtube.btn-outline:hover, .btn-youtube.btn-outline:focus, .btn-youtube.btn-outline:active, .btn-youtube.btn-outline.active, .open > .btn-youtube.btn-outline.dropdown-toggle {
  background-color: rgb(193.6859504132, 28.694214876, 23.3140495868);
  color: #FFFFFF;
  border: 1px solid rgb(193.6859504132, 28.694214876, 23.3140495868);
}
.btn-youtube.btn-link {
  color: #e52d27;
  background-color: transparent;
  border: 1px solid #e52d27;
}
.btn-youtube.btn-link:hover, .btn-youtube.btn-link:focus, .btn-youtube.btn-link:active, .btn-youtube.btn-link.active, .open > .btn-youtube.btn-link.dropdown-toggle {
  background-color: transparent;
  color: rgb(193.6859504132, 28.694214876, 23.3140495868);
  border: 1px solid rgb(193.6859504132, 28.694214876, 23.3140495868);
}

.btn-stumbleupon {
  border-color: #eb4924;
  background-color: #eb4924;
  color: #FFFFFF;
}
.btn-stumbleupon:hover, .btn-stumbleupon:focus, .btn-stumbleupon:active, .btn-stumbleupon.active, .open > .btn-stumbleupon.dropdown-toggle {
  background-color: rgb(201.589958159, 52.4686192469, 18.410041841);
  color: #FFFFFF;
  border-color: #eb4924;
}
.btn-stumbleupon:disabled, .btn-stumbleupon[disabled], .btn-stumbleupon.disabled {
  background-color: transparent;
  border-color: #eb4924;
}
.btn-stumbleupon.btn-outline {
  color: #eb4924;
  background-color: transparent;
  border: 1px solid #eb4924;
}
.btn-stumbleupon.btn-outline:hover, .btn-stumbleupon.btn-outline:focus, .btn-stumbleupon.btn-outline:active, .btn-stumbleupon.btn-outline.active, .open > .btn-stumbleupon.btn-outline.dropdown-toggle {
  background-color: rgb(201.589958159, 52.4686192469, 18.410041841);
  color: #FFFFFF;
  border: 1px solid rgb(201.589958159, 52.4686192469, 18.410041841);
}
.btn-stumbleupon.btn-link {
  color: #eb4924;
  background-color: transparent;
  border: 1px solid #eb4924;
}
.btn-stumbleupon.btn-link:hover, .btn-stumbleupon.btn-link:focus, .btn-stumbleupon.btn-link:active, .btn-stumbleupon.btn-link.active, .open > .btn-stumbleupon.btn-link.dropdown-toggle {
  background-color: transparent;
  color: rgb(201.589958159, 52.4686192469, 18.410041841);
  border: 1px solid rgb(201.589958159, 52.4686192469, 18.410041841);
}

.btn-reddit {
  border-color: #ff4500;
  background-color: #ff4500;
  color: #FFFFFF;
}
.btn-reddit:hover, .btn-reddit:focus, .btn-reddit:active, .btn-reddit.active, .open > .btn-reddit.dropdown-toggle {
  background-color: rgb(204, 55.2, 0);
  color: #FFFFFF;
  border-color: #ff4500;
}
.btn-reddit:disabled, .btn-reddit[disabled], .btn-reddit.disabled {
  background-color: transparent;
  border-color: #ff4500;
}
.btn-reddit.btn-outline {
  color: #ff4500;
  background-color: transparent;
  border: 1px solid #ff4500;
}
.btn-reddit.btn-outline:hover, .btn-reddit.btn-outline:focus, .btn-reddit.btn-outline:active, .btn-reddit.btn-outline.active, .open > .btn-reddit.btn-outline.dropdown-toggle {
  background-color: rgb(204, 55.2, 0);
  color: #FFFFFF;
  border: 1px solid rgb(204, 55.2, 0);
}
.btn-reddit.btn-link {
  color: #ff4500;
  background-color: transparent;
  border: 1px solid #ff4500;
}
.btn-reddit.btn-link:hover, .btn-reddit.btn-link:focus, .btn-reddit.btn-link:active, .btn-reddit.btn-link.active, .open > .btn-reddit.btn-link.dropdown-toggle {
  background-color: transparent;
  color: rgb(204, 55.2, 0);
  border: 1px solid rgb(204, 55.2, 0);
}

.btn-tumblr {
  border-color: #35465c;
  background-color: #35465c;
  color: #FFFFFF;
}
.btn-tumblr:hover, .btn-tumblr:focus, .btn-tumblr:active, .btn-tumblr.active, .open > .btn-tumblr.dropdown-toggle {
  background-color: rgb(34.3586206897, 45.3793103448, 59.6413793103);
  color: #FFFFFF;
  border-color: #35465c;
}
.btn-tumblr:disabled, .btn-tumblr[disabled], .btn-tumblr.disabled {
  background-color: transparent;
  border-color: #35465c;
}
.btn-tumblr.btn-outline {
  color: #35465c;
  background-color: transparent;
  border: 1px solid #35465c;
}
.btn-tumblr.btn-outline:hover, .btn-tumblr.btn-outline:focus, .btn-tumblr.btn-outline:active, .btn-tumblr.btn-outline.active, .open > .btn-tumblr.btn-outline.dropdown-toggle {
  background-color: rgb(34.3586206897, 45.3793103448, 59.6413793103);
  color: #FFFFFF;
  border: 1px solid rgb(34.3586206897, 45.3793103448, 59.6413793103);
}
.btn-tumblr.btn-link {
  color: #35465c;
  background-color: transparent;
  border: 1px solid #35465c;
}
.btn-tumblr.btn-link:hover, .btn-tumblr.btn-link:focus, .btn-tumblr.btn-link:active, .btn-tumblr.btn-link.active, .open > .btn-tumblr.btn-link.dropdown-toggle {
  background-color: transparent;
  color: rgb(34.3586206897, 45.3793103448, 59.6413793103);
  border: 1px solid rgb(34.3586206897, 45.3793103448, 59.6413793103);
}

.btn-behance {
  border-color: #1769ff;
  background-color: #1769ff;
  color: #FFFFFF;
}
.btn-behance:hover, .btn-behance:focus, .btn-behance:active, .btn-behance.active, .open > .btn-behance.dropdown-toggle {
  background-color: rgb(0, 80.2327586207, 227);
  color: #FFFFFF;
  border-color: #1769ff;
}
.btn-behance:disabled, .btn-behance[disabled], .btn-behance.disabled {
  background-color: transparent;
  border-color: #1769ff;
}
.btn-behance.btn-outline {
  color: #1769ff;
  background-color: transparent;
  border: 1px solid #1769ff;
}
.btn-behance.btn-outline:hover, .btn-behance.btn-outline:focus, .btn-behance.btn-outline:active, .btn-behance.btn-outline.active, .open > .btn-behance.btn-outline.dropdown-toggle {
  background-color: rgb(0, 80.2327586207, 227);
  color: #FFFFFF;
  border: 1px solid rgb(0, 80.2327586207, 227);
}
.btn-behance.btn-link {
  color: #1769ff;
  background-color: transparent;
  border: 1px solid #1769ff;
}
.btn-behance.btn-link:hover, .btn-behance.btn-link:focus, .btn-behance.btn-link:active, .btn-behance.btn-link.active, .open > .btn-behance.btn-link.dropdown-toggle {
  background-color: transparent;
  color: rgb(0, 80.2327586207, 227);
  border: 1px solid rgb(0, 80.2327586207, 227);
}

.form-control::-moz-placeholder {
  color: #A2A2A2;
  opacity: 1;
  filter: alpha(opacity=100);
}

.form-control:-moz-placeholder {
  color: #A2A2A2;
  opacity: 1;
  filter: alpha(opacity=100);
}

.form-control::-webkit-input-placeholder {
  color: #A2A2A2;
  opacity: 1;
  filter: alpha(opacity=100);
}

.form-control:-ms-input-placeholder {
  color: #A2A2A2;
  opacity: 1;
  filter: alpha(opacity=100);
}

.form-control {
  background-color: #FFFFFF;
  border: 1px solid #E3E3E3;
  border-radius: 4px;
  font-size: 0.875rem;
  color: #565656;
  padding: 8px 12px;
  height: 40px;
  box-shadow: none;
}
.form-control:focus {
  background-color: #FFFFFF;
  border: 1px solid #EAF0F4;
  box-shadow: none;
  outline: 0 !important;
  color: #333333;
}
.has-success .form-control, .has-error .form-control, .has-success .form-control:focus, .has-error .form-control:focus {
  border-color: #E3E3E3;
  box-shadow: none;
}
.has-success .form-control:focus {
  border-color: #7ABA09;
  color: #7ABA09;
}
.has-error .form-control {
  color: #D61F05;
}
.has-error .form-control:focus {
  border-color: #D61F05;
}
.form-control + .form-control-feedback {
  border-radius: 6px;
  font-size: 0.875rem;
  margin-top: -7px;
  position: absolute;
  right: 10px;
  top: 50%;
  vertical-align: middle;
}
.open .form-control {
  border-radius: 4px 4px 0 0;
  border-bottom-color: transparent;
}

.input-lg {
  height: 55px;
  padding: 14px 30px;
}

.has-error .form-control-feedback {
  color: #D61F05;
}

.has-success .form-control-feedback {
  color: #7ABA09;
}

.input-group-addon {
  background-color: #FFFFFF;
  border: 1px solid #E3E3E3;
  border-radius: 4px;
}
.has-success .input-group-addon, .has-error .input-group-addon {
  background-color: #FFFFFF;
  border: 1px solid #E3E3E3;
}
.has-error .form-control:focus + .input-group-addon {
  border-color: #D61F05;
  color: #D61F05;
}
.has-success .form-control:focus + .input-group-addon {
  border-color: #7ABA09;
  color: #7ABA09;
}
.form-control:focus + .input-group-addon, .form-control:focus ~ .input-group-addon {
  background-color: #FFFFFF;
  border-color: #58595B;
}

.input-group .form-control:first-child,
.input-group-addon:first-child,
.input-group-btn:first-child > .dropdown-toggle,
.input-group-btn:last-child > .btn:not(:last-child):not(.dropdown-toggle) {
  border-right: 0 none;
}

.input-group .form-control:last-child,
.input-group-addon:last-child,
.input-group-btn:last-child > .dropdown-toggle,
.input-group-btn:first-child > .btn:not(:first-child) {
  border-left: 0 none;
}

.form-control[disabled], .form-control[readonly], fieldset[disabled] .form-control {
  background-color: #F5F5F5;
  color: #888888;
  cursor: not-allowed;
}

.input-group-btn .btn {
  border-width: 1px;
  padding: 8px 16px;
}

.input-group-btn .btn-default:not(.btn-fill) {
  border-color: #A2A2A2;
}

.input-group-btn:last-child > .btn {
  margin-left: 0;
}

.input-group-focus .input-group-addon {
  border-color: #58595B;
}

.star {
  color: #FB404B;
  padding-left: 3px;
}

.card .card-body .control-label {
  text-align: right;
  padding-top: 18px;
}
.card .card-body .form-control-static,
.card .card-body .col-sm-10 .form-check:first-of-type,
.card .card-body .col-sm-4 .form-check:first-of-type {
  padding-top: 8px;
}

.form-group.has-error .error {
  color: #D61F05;
  text-transform: none;
  margin-bottom: 0;
}

.form-group.has-success .error {
  display: none !important;
}

.alert {
  border: 0;
  border-radius: 0;
  color: #FFFFFF;
  padding: 10px 15px;
  font-size: 14px;
}
.container .alert {
  border-radius: 4px;
}
.navbar .alert {
  border-radius: 0;
  left: 0;
  position: absolute;
  right: 0;
  top: 85px;
  width: 100%;
  z-index: 3;
}
.navbar:not(.navbar-transparent) .alert {
  top: 70px;
}
.alert span[data-notify=icon] {
  font-size: 30px;
  display: block;
  left: 15px;
  position: absolute;
  top: 50%;
  margin-top: -15px;
}
.alert i.nc-simple-remove {
  font-size: 12px !important;
  font: bold normal normal 14px/1 "nucleo-icons";
}
.alert button.close {
  border: 0;
  position: absolute;
  right: 10px;
  top: 50%;
  margin-top: -13px;
  z-index: 1033;
  background-color: #FFFFFF;
  display: block;
  border-radius: 50%;
  opacity: 0.4;
  line-height: 9px;
  width: 25px;
  height: 25px;
  outline: 0 !important;
  text-align: center;
  padding: 3px;
  font-weight: 300;
}
.alert button.close:hover {
  opacity: 0.55;
}
.alert .close ~ span {
  display: block;
  max-width: 89%;
}
.alert[data-notify=container] {
  padding: 10px 10px 10px 20px;
  border-radius: 4px;
}
.alert.alert-with-icon {
  padding-left: 65px;
}

.alert-primary {
  background-color: #0084CA;
}

.alert-info {
  background-color: #003380;
}

.alert-success {
  background-color: #7ABA09;
}

.alert-warning {
  background-color: #FFE200;
}

.alert-danger {
  background-color: #D61F05;
}

.table {
  table-layout: fixed;
  background-color: #FFF;
  overflow-x: hidden;
}
.table .radio,
.table .checkbox {
  position: relative;
  height: 20px;
  display: block;
  width: 20px;
  padding: 0px 0px;
  margin: 0px 5px;
}
.table > thead > tr > th,
.table > tbody > tr > th,
.table > tfoot > tr > th,
.table > thead > tr > td,
.table > tbody > tr > td,
.table > tfoot > tr > td {
  padding: 12px 8px;
  vertical-align: middle;
  border-color: #E3E3E3;
}
.table > thead > tr > th {
  border-bottom-width: 1px;
  font-size: 0.75rem;
  text-transform: uppercase;
  color: #58595B;
  font-weight: 400;
  padding-bottom: 5px;
}
.table table > tr > td.td-actions {
  display: inline-flex !important;
}
.table .td-actions .btn {
  opacity: 0.36;
  filter: alpha(opacity=36);
}
.table .td-actions .btn.btn-xs {
  padding-left: 3px;
  padding-right: 3px;
}
.table .td-actions {
  min-width: 90px;
}
.table > tbody > tr {
  position: relative;
  font-size: 14px !important;
}
.table > tbody > tr:hover .td-actions .btn {
  opacity: 1;
  filter: alpha(opacity=100);
}
.table thead th {
  border-bottom: none !important;
  border-top: none !important;
}
.table .btn-info.btn-link {
  color: #003380;
}
.table .btn-danger.btn-link {
  color: #D61F05;
}
.table .btn-success.btn-link {
  color: #7ABA09;
}
.table .btn-warning.btn-link {
  color: #FFE200;
}
.table .form-check .form-check-sign,
.table .form-check .form-check-sign:before,
.table .form-check .form-check-sign:after {
  margin-top: -14px;
}

.card .table tbody td:first-child,
.card .table thead th:first-child {
  padding-left: 15px;
}
.card .table tbody td:last-child,
.card .table thead th:last-child {
  padding-right: 15px;
}

.table-bigboy > thead > tr > th {
  font-size: 0.875rem;
  text-transform: uppercase;
  color: #58595B;
  font-weight: 400;
}
.table-bigboy > tbody > tr > td {
  font-size: 0.875rem;
}
.table-bigboy > tbody > tr > td b {
  display: block;
  margin-bottom: 5px;
}
.table-bigboy .td-name {
  font-weight: 300;
  font-size: 1.125rem;
}
.table-bigboy .td-name {
  min-width: 240px;
}
.table-bigboy .td-number {
  text-align: right;
  min-width: 110px;
}
.table-bigboy .td-number small {
  margin-right: 3px;
}
.table-bigboy .td-actions {
  width: 60px;
  min-width: auto;
}
.table-bigboy .td-actions .btn {
  float: right;
}
.table-bigboy .img-container {
  width: 180px;
  height: 120px;
  overflow: hidden;
  display: block;
  border-radius: 6px;
}
.table-bigboy .img-container img {
  width: 100%;
}

.table-with-links .card-body {
  padding-bottom: 0 !important;
}
.table-with-links .card-body .table .btn {
  margin-bottom: 0 !important;
}
.table-with-links .card-body .table tr td {
  padding: 7px 3px !important;
}

.table-with-switches .card-body,
.regular-table-with-color .card-body {
  padding-bottom: 0 !important;
}
.table-with-switches .card-body .table tbody td:last-child,
.regular-table-with-color .card-body .table tbody td:last-child {
  padding-right: 10px !important;
}

.table-big-boy .card-body {
  padding-bottom: 0 !important;
}
.table-big-boy .card-body .table tbody td:last-child {
  padding-right: 10px !important;
}

.bootstrap-table .table thead th:first-child {
  padding-left: 0 !important;
}
.bootstrap-table .dropdown-menu li a {
  display: block;
  padding: 8px 16px;
  clear: both;
  font-weight: 400;
  line-height: 1.42857143;
  white-space: nowrap;
  color: #333;
}
.bootstrap-table .dropdown-menu li a:hover {
  background-color: #F5F5F5;
}
.bootstrap-table .dropdown-menu li.active a {
  background-color: rgba(68, 125, 247, 0.2);
}

.data-tables table tbody .btn {
  padding: 3px !important;
  font-size: 16px !important;
}
.data-tables .pagination {
  float: right;
}
.data-tables tfoot {
  font-size: 14px;
}

.card-tasks .table tbody td:last-child {
  padding-right: 0;
  display: inline-flex;
}
.card-tasks .table tbody td:last-child .btn {
  padding: 3px;
}
.card-tasks .table tbody td:first-child {
  padding-left: 0;
}
.card-tasks .table-full-width {
  padding-bottom: 0 !important;
}
.card-tasks .card-footer {
  padding-top: 0;
}
.card-tasks .table {
  margin-bottom: 0 !important;
}

.table-full-width {
  margin-left: -15px;
  margin-right: -15px;
  padding: 15px !important;
}

.TableScrollbar {
  overflow-x: hidden !important;
}

.table > thead > tr > td.success,
.table > thead > tr > th.success, .table > thead > tr.success > td, .table > thead > tr.success > th,
.table > tbody > tr > td.success,
.table > tbody > tr > th.success,
.table > tbody > tr.success > td,
.table > tbody > tr.success > th,
.table > tfoot > tr > td.success,
.table > tfoot > tr > th.success,
.table > tfoot > tr.success > td,
.table > tfoot > tr.success > th {
  background-color: #E9F3D7;
}

.table-hover > tbody > tr > td.success:hover,
.table-hover > tbody > tr > th.success:hover, .table-hover > tbody > tr.success:hover > td, .table-hover > tbody > tr:hover > .success, .table-hover > tbody > tr.success:hover > th {
  background-color: rgb(239.4730769231, 246.5307692308, 226.7692307692);
}

.table > thead > tr > td.info,
.table > thead > tr > th.info, .table > thead > tr.info > td, .table > thead > tr.info > th,
.table > tbody > tr > td.info,
.table > tbody > tr > th.info,
.table > tbody > tr.info > td,
.table > tbody > tr.info > th,
.table > tfoot > tr > td.info,
.table > tfoot > tr > th.info,
.table > tfoot > tr.info > td,
.table > tfoot > tr.info > th {
  background-color: #4CA8D9;
}

.table-hover > tbody > tr > td.info:hover,
.table-hover > tbody > tr > th.info:hover, .table-hover > tbody > tr.info:hover > td, .table-hover > tbody > tr:hover > .info, .table-hover > tbody > tr.info:hover > th {
  background-color: rgb(88.6207373272, 174.1341013825, 219.6792626728);
}

.table > thead > tr > td.warning,
.table > thead > tr > th.warning, .table > thead > tr.warning > td, .table > thead > tr.warning > th,
.table > tbody > tr > td.warning,
.table > tbody > tr > th.warning,
.table > tbody > tr.warning > td,
.table > tbody > tr.warning > th,
.table > tfoot > tr > td.warning,
.table > tfoot > tr > th.warning,
.table > tfoot > tr.warning > td,
.table > tfoot > tr.warning > th {
  background-color: rgba(255, 226, 0, 0.2);
}

.table-hover > tbody > tr > td.warning:hover,
.table-hover > tbody > tr > th.warning:hover, .table-hover > tbody > tr.warning:hover > td, .table-hover > tbody > tr:hover > .warning, .table-hover > tbody > tr.warning:hover > th {
  background-color: rgba(255, 227.74, 15.3, 0.2);
}

.table > thead > tr > td.danger,
.table > thead > tr > th.danger, .table > thead > tr.danger > td, .table > thead > tr.danger > th,
.table > tbody > tr > td.danger,
.table > tbody > tr > th.danger,
.table > tbody > tr.danger > td,
.table > tbody > tr.danger > th,
.table > tfoot > tr > td.danger,
.table > tfoot > tr > th.danger,
.table > tfoot > tr.danger > td,
.table > tfoot > tr.danger > th {
  background-color: rgba(214, 31, 5, 0.2);
}

.table-hover > tbody > tr > td.danger:hover,
.table-hover > tbody > tr > th.danger:hover, .table-hover > tbody > tr.danger:hover > td, .table-hover > tbody > tr:hover > .danger, .table-hover > tbody > tr.danger:hover > th {
  background-color: rgba(228.9506849315, 33.1657534247, 5.3493150685, 0.2);
}

.from-check,
.form-check-radio {
  margin-bottom: 12px;
  position: relative;
}

.form-check .form-check-label {
  display: inline-block;
  position: relative;
  cursor: pointer;
  padding-left: 25px;
  line-height: 26px;
  margin-bottom: 0;
  text-transform: capitalize;
}
.form-check .form-check-sign::before,
.form-check .form-check-sign::after {
  font-family: "Font Awesome 5 Pro";
  content: "\\f0c8";
  color: #7ABA09;
  display: inline-block;
  position: absolute;
  width: 19px;
  height: 19px;
  margin-left: -23px;
  font-size: 18px;
  cursor: pointer;
  transition: opacity 0.3s linear;
}
.form-check .form-check-sign::after {
  font-family: "Font Awesome 5 Pro";
  content: "\\f14a";
  text-align: center;
  opacity: 0;
  color: #7ABA09;
  border: 0;
  background-color: inherit;
  margin-left: -23px;
  font-weight: bold;
}
.form-check .form-check-sign::before {
  margin-left: -22px;
}
.form-check.disabled .form-check-label {
  color: #E3E3E3;
  opacity: 0.5;
  cursor: not-allowed;
}

#RegisterValidation .card .form-check .form-check-sign:before {
  margin-left: -27px;
}

.form-check .form-check-input:disabled + .form-check-sign:before,
.form-check .form-check-input:disabled + .form-check-sign:after,
.radio input[type=radio]:disabled + label,
.form-check .form-check-input:disabled:checked + .form-check-sign::after {
  color: #ddd;
  pointer-events: none;
}

.form-check.disabled .form-check-label {
  cursor: not-allowed;
}

.form-check input[type=checkbox],
.form-check-radio input[type=radio] {
  opacity: 0;
  position: absolute;
  visibility: hidden;
}

.form-check input[type=checkbox]:checked + .form-check-sign::after {
  opacity: 1;
}

.form-check input[type=checkbox]:checked + .form-check-sign::before {
  opacity: 0;
}

.form-control input[type=checkbox]:disabled + .form-check-sign::before,
.checkbox input[type=checkbox]:disabled + .form-check-sign::after {
  cursor: not-allowed;
}

.form-check .form-check-label input[type=checkbox]:disabled + .form-check-sign,
.form-check-radio input[type=radio]:disabled + .form-check-sign {
  pointer-events: none !important;
}

.form-check.checkbox-inline {
  display: inline-block;
}

.form-check-radio .form-check-label {
  padding-left: 2.2rem;
}
.form-check-radio.disabled .form-check-label {
  color: #E3E3E3;
  opacity: 0.5;
  cursor: not-allowed;
}

.form-check-radio .form-check-sign::before {
  font-family: "Font Awesome 5 Pro";
  content: "\\f111";
  font-size: 18px;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  display: inline-block;
  position: absolute;
  opacity: 0.5;
  left: 34px;
}

.form-check-radio input[type=radio] + .form-check-sign:after,
.form-check-radio input[type=radio] {
  opacity: 0;
  transition: opacity 0.3s linear;
  content: " ";
  display: block;
  margin-left: 5px;
  font-size: 18px;
}

.form-check-radio input[type=radio]:checked + .form-check-sign::after {
  font-family: "Font Awesome 5 Pro";
  content: "\\f192";
  position: absolute;
  left: 5.3px;
  opacity: 1;
}

.form-check-radio input[type=radio]:checked + .form-check-sign::after {
  opacity: 1;
  transition: opacity 0.3s linear;
}

.form-check input[type=radio]:checked + .form-check-sign::before {
  opacity: 0;
  transition: opacity 0.3s linear;
}

.form-check-radio input[type=radio]:disabled + .form-check-sign::before,
.form-check-radio input[type=radio]:disabled + .form-check-sign::after {
  color: #E3E3E3;
}

.card.stacked-form .form-check .form-check-label, .card.horizontal-form .form-check .form-check-label {
  padding-left: 22px !important;
}

.nav .nav-item .nav-link:hover,
.nav .nav-item .nav-link:focus {
  background-color: transparent;
}

.navbar {
  border: 0;
  font-size: 1rem;
  border-radius: 0;
  min-height: 50px;
  max-height: 61px;
  background-color: rgba(255, 255, 255, 0.96);
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}
.navbar .navbar-brand {
  font-weight: 400;
  margin: 5px 0px;
  font-size: 18px;
  color: #888888;
}
.navbar .navbar-brand:hover {
  color: #5e5e5e;
}
.navbar .navbar-wrapper {
  display: inline-flex;
  align-items: center;
}
.navbar .navbar-toggler {
  width: 37px;
  height: 27px;
  vertical-align: middle;
  outline: 0;
  cursor: pointer;
}
.navbar .navbar-toggler.navbar-toggler-left {
  position: relative;
  left: 0;
  padding-left: 0;
}
.navbar .navbar-toggler.navbar-toggler-right {
  padding-right: 0;
}
.navbar .navbar-toggler .navbar-toggler-bar {
  width: 3px;
  height: 3px;
  border-radius: 50%;
  margin: 0 auto;
}
.navbar .navbar-toggler .burger-lines {
  display: block;
  position: relative;
  background-color: #888;
  width: 24px;
  height: 2px;
  border-radius: 1px;
  margin: 4px auto;
}
.navbar .btn-round.btn-icon {
  padding: 8px 9px;
}
.navbar .navbar-nav .nav-item .nav-link {
  color: #888888;
  padding: 10px 15px;
  margin: 10px 3px;
  position: relative;
  display: inline-flex;
  line-height: 40px;
}
.navbar .navbar-nav .nav-item .nav-link.btn {
  margin: 15px 3px;
  padding: 8px 16px;
}
.navbar .navbar-nav .nav-item .nav-link.btn-round {
  margin: 16px 3px;
}
.navbar .navbar-nav .nav-item .nav-link [class^=fa],
.navbar .navbar-nav .nav-item .nav-link [class^=fas],
.navbar .navbar-nav .nav-item .nav-link [class^=far],
.navbar .navbar-nav .nav-item .nav-link [class^=fal],
.navbar .navbar-nav .nav-item .nav-link [class^=fad],
.navbar .navbar-nav .nav-item .nav-link [class^=fab] {
  font-size: 2.125rem;
  position: relative;
  line-height: 40px;
  top: 1px;
}
.navbar .navbar-nav .nav-item .nav-link:hover {
  color: #003380;
}
.navbar .navbar-nav .nav-item .nav-link .stats {
  margin-left: 10px;
}
.navbar .navbar-nav .nav-item .dropdown-menu {
  border-radius: 10px;
  margin-top: -5px;
}
.navbar .navbar-nav .nav-item .dropdown-menu .dropdown-item:first-child {
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}
.navbar .navbar-nav .nav-item .dropdown-menu .dropdown-item:last-child {
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
}
.navbar .navbar-nav .nav-item .dropdown-menu .divider {
  height: 1px;
  margin: 5px 0;
  overflow: hidden;
  background-color: #e5e5e5;
}
.navbar .navbar-nav .notification {
  position: absolute;
  background-color: #FB404B;
  text-align: center;
  border-radius: 10px;
  min-width: 18px;
  padding: 0 5px;
  height: 18px;
  font-size: 12px;
  color: #FFFFFF;
  font-weight: bold;
  line-height: 18px;
  top: 10px;
  left: 7px;
}
.navbar .navbar-nav .dropdown-toggle:after {
  display: inline-block;
  width: 0;
  height: 0;
  margin-left: 5px;
  margin-top: 18px;
  vertical-align: middle;
  border-top: 4px dashed;
  border-top: 4px solid\\9 ;
  border-right: 4px solid transparent;
  border-left: 4px solid transparent;
}
.navbar .btn {
  margin: 15px 3px;
  font-size: 0.875rem;
}
.navbar .btn-simple {
  font-size: 1rem;
}
.navbar.fixed {
  width: calc(100% - calc(100% - 260px));
  right: 0;
  left: auto;
  border-radius: 0;
}

.navbar-transparent .navbar-brand, [class*=navbar-ct] .navbar-brand {
  color: #FFFFFF;
  margin-left: 10px;
  opacity: 0.9;
  filter: alpha(opacity=90);
}
.navbar-transparent .navbar-brand:focus, .navbar-transparent .navbar-brand:hover, [class*=navbar-ct] .navbar-brand:focus, [class*=navbar-ct] .navbar-brand:hover {
  background-color: transparent;
  opacity: 1;
  filter: alpha(opacity=100);
  color: #FFFFFF;
}
.navbar-transparent .navbar-nav .nav-item .nav-link:not(.btn), [class*=navbar-ct] .navbar-nav .nav-item .nav-link:not(.btn) {
  color: #58595B;
  border-color: #FFFFFF;
  opacity: 0.8;
  filter: alpha(opacity=80);
}
.navbar-transparent .navbar-nav .active .nav-link:not(.btn),
.navbar-transparent .navbar-nav .active .nav-link:hover:not(.btn),
.navbar-transparent .navbar-nav .active .nav-link:focus:not(.btn),
.navbar-transparent .navbar-nav .nav-item .nav-link:not(.btn),
.navbar-transparent .navbar-nav .nav-item .nav-link:hover:not(.btn),
.navbar-transparent .navbar-nav .nav-item .nav-link:focus:not(.btn), [class*=navbar-ct] .navbar-nav .active .nav-link:not(.btn),
[class*=navbar-ct] .navbar-nav .active .nav-link:hover:not(.btn),
[class*=navbar-ct] .navbar-nav .active .nav-link:focus:not(.btn),
[class*=navbar-ct] .navbar-nav .nav-item .nav-link:not(.btn),
[class*=navbar-ct] .navbar-nav .nav-item .nav-link:hover:not(.btn),
[class*=navbar-ct] .navbar-nav .nav-item .nav-link:focus:not(.btn) {
  background-color: transparent;
  border-radius: 3px;
  color: #58595B;
  opacity: 0.8;
  filter: alpha(opacity=80);
}
.navbar-transparent .navbar-nav .active .nav-link:not(.btn):focus, .navbar-transparent .navbar-nav .active .nav-link:not(.btn):hover,
.navbar-transparent .navbar-nav .active .nav-link:hover:not(.btn):focus,
.navbar-transparent .navbar-nav .active .nav-link:hover:not(.btn):hover,
.navbar-transparent .navbar-nav .active .nav-link:focus:not(.btn):focus,
.navbar-transparent .navbar-nav .active .nav-link:focus:not(.btn):hover,
.navbar-transparent .navbar-nav .nav-item .nav-link:not(.btn):focus,
.navbar-transparent .navbar-nav .nav-item .nav-link:not(.btn):hover,
.navbar-transparent .navbar-nav .nav-item .nav-link:hover:not(.btn):focus,
.navbar-transparent .navbar-nav .nav-item .nav-link:hover:not(.btn):hover,
.navbar-transparent .navbar-nav .nav-item .nav-link:focus:not(.btn):focus,
.navbar-transparent .navbar-nav .nav-item .nav-link:focus:not(.btn):hover, [class*=navbar-ct] .navbar-nav .active .nav-link:not(.btn):focus, [class*=navbar-ct] .navbar-nav .active .nav-link:not(.btn):hover,
[class*=navbar-ct] .navbar-nav .active .nav-link:hover:not(.btn):focus,
[class*=navbar-ct] .navbar-nav .active .nav-link:hover:not(.btn):hover,
[class*=navbar-ct] .navbar-nav .active .nav-link:focus:not(.btn):focus,
[class*=navbar-ct] .navbar-nav .active .nav-link:focus:not(.btn):hover,
[class*=navbar-ct] .navbar-nav .nav-item .nav-link:not(.btn):focus,
[class*=navbar-ct] .navbar-nav .nav-item .nav-link:not(.btn):hover,
[class*=navbar-ct] .navbar-nav .nav-item .nav-link:hover:not(.btn):focus,
[class*=navbar-ct] .navbar-nav .nav-item .nav-link:hover:not(.btn):hover,
[class*=navbar-ct] .navbar-nav .nav-item .nav-link:focus:not(.btn):focus,
[class*=navbar-ct] .navbar-nav .nav-item .nav-link:focus:not(.btn):hover {
  opacity: 1;
  filter: alpha(opacity=100);
}
.navbar-transparent .navbar-nav .nav .nav-item .nav-link.btn:hover, [class*=navbar-ct] .navbar-nav .nav .nav-item .nav-link.btn:hover {
  background-color: transparent;
}
.navbar-transparent .navbar-nav .show .nav-link,
.navbar-transparent .navbar-nav .show .nav-link:hover,
.navbar-transparent .navbar-nav .show .nav-link:focus, [class*=navbar-ct] .navbar-nav .show .nav-link,
[class*=navbar-ct] .navbar-nav .show .nav-link:hover,
[class*=navbar-ct] .navbar-nav .show .nav-link:focus {
  background-color: transparent;
  color: #FFFFFF;
  opacity: 1;
  filter: alpha(opacity=100);
}
.navbar-transparent .btn-default, [class*=navbar-ct] .btn-default {
  color: #FFFFFF;
  border-color: #FFFFFF;
}
.navbar-transparent .btn-default.btn-fill, [class*=navbar-ct] .btn-default.btn-fill {
  color: #58595B;
  background-color: #FFFFFF;
  opacity: 0.9;
  filter: alpha(opacity=90);
}
.navbar-transparent .btn-default.btn-fill:hover,
.navbar-transparent .btn-default.btn-fill:focus,
.navbar-transparent .btn-default.btn-fill:active,
.navbar-transparent .btn-default.btn-fill.active,
.navbar-transparent .show .dropdown-toggle.btn-fill.btn-default, [class*=navbar-ct] .btn-default.btn-fill:hover,
[class*=navbar-ct] .btn-default.btn-fill:focus,
[class*=navbar-ct] .btn-default.btn-fill:active,
[class*=navbar-ct] .btn-default.btn-fill.active,
[class*=navbar-ct] .show .dropdown-toggle.btn-fill.btn-default {
  border-color: #FFFFFF;
  opacity: 1;
  filter: alpha(opacity=100);
}

.navbar-transparent .dropdown-menu .divider {
  background-color: rgba(255, 255, 255, 0.2);
}

.navbar-default {
  background-color: rgba(255, 255, 255, 0.96);
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}
.navbar-default .navbar-nav .nav-item .nav-link:not(.btn) {
  color: #58595B;
}
.navbar-default .navbar-nav .active .nav-link,
.navbar-default .navbar-nav .active .nav-link:not(.btn):hover,
.navbar-default .navbar-nav .active .nav-link:not(.btn):focus,
.navbar-default .navbar-nav .nav-item .nav-link:not(.btn):hover,
.navbar-default .navbar-nav .nav-item .nav-link:not(.btn):focus {
  background-color: transparent;
  border-radius: 3px;
  color: #003380;
  opacity: 1;
  filter: alpha(opacity=100);
}
.navbar-default .navbar-nav .show .nav-link,
.navbar-default .navbar-nav .show .nav-link:hover,
.navbar-default .navbar-nav .show .nav-link:focus {
  background-color: transparent;
  color: #003380;
}
.navbar-default .navbar-nav .navbar-toggle:hover, .navbar-default .navbar-nav .navbar-toggle:focus {
  background-color: transparent;
}
.navbar-default:not(.navbar-transparent) .btn-default:hover {
  color: #003380;
  border-color: #003380;
}
.navbar-default:not(.navbar-transparent) .btn-neutral, .navbar-default:not(.navbar-transparent) .btn-neutral:hover, .navbar-default:not(.navbar-transparent) .btn-neutral:active {
  color: #58595B;
}

/*      Navbar with icons            */
.navbar-icons.navbar .navbar-brand {
  margin-top: 12px;
  margin-bottom: 12px;
}
.navbar-icons .navbar-nav .nav-item .nav-link {
  text-align: center;
  padding: 6px 15px;
  margin: 6px 3px;
}
.navbar-icons .navbar-nav [class^=pe] {
  font-size: 30px;
  position: relative;
}
.navbar-icons .navbar-nav p {
  margin: 3px 0 0;
}

.navbar-form {
  box-shadow: none;
}
.navbar-form .form-control {
  border-radius: 0;
  border: 0;
  padding: 0;
  background-color: transparent;
  height: 22px;
  font-size: 1rem;
  line-height: 1.5;
  color: #E3E3E3;
}
.navbar-transparent .navbar-form .form-control, [class*=navbar-ct] .navbar-form .form-control {
  color: #FFFFFF;
  border: 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.6);
}

.navbar-ct-blue {
  background-color: rgb(63.5355648536, 144.539748954, 226.4644351464);
}

.navbar-ct-azure {
  background-color: rgb(98.995951417, 216.3441295547, 240.504048583);
}

.navbar-ct-green {
  background-color: rgb(153.9076923077, 234.6461538462, 11.3538461538);
}

.navbar-ct-orange {
  background-color: rgb(255, 231.8, 51);
}

.navbar-ct-red {
  background-color: rgb(249.5205479452, 48.9726027397, 20.4794520548);
}

.navbar-transparent {
  padding-top: 15px;
  background-color: transparent;
  border-bottom: 1px solid transparent;
  z-index: 999;
}
.navbar-transparent .navbar-toggler .burger-lines {
  background: #FFFFFF;
}

.navbar-toggle {
  margin-top: 19px;
  margin-bottom: 19px;
  border: 0;
}
.navbar-toggle .icon-bar {
  background-color: #FFFFFF;
}
.navbar-toggle .navbar-collapse,
.navbar-toggle .navbar-form {
  border-color: transparent;
}
.navbar-toggle.navbar-default .navbar-toggle:hover, .navbar-toggle.navbar-default .navbar-toggle:focus {
  background-color: transparent;
}

.main-panel .navbar-fixed {
  position: fixed;
  right: 0;
  width: calc(100% - 260px);
  z-index: 1030;
}
.main-panel .navbar-fixed + .content {
  padding-top: 90px;
}

.nav-mobile-menu.nav .navbar-search-form .nc-icon {
  font-size: 28px;
  width: 30px;
  text-align: center;
  vertical-align: middle;
  float: left;
  color: #FFFFFF;
}
.nav-mobile-menu.nav .navbar-search-form .form-control::-webkit-input-placeholder { /* Chrome/Opera/Safari */
  color: #FFFFFF;
}
.nav-mobile-menu.nav .navbar-search-form .form-control::-moz-placeholder { /* Firefox 19+ */
  color: #FFFFFF;
}
.nav-mobile-menu.nav .navbar-search-form .form-control:-ms-input-placeholder { /* IE 10+ */
  color: #FFFFFF;
}
.nav-mobile-menu.nav .navbar-search-form .form-control:-moz-placeholder { /* Firefox 18- */
  color: #FFFFFF;
}

.nav .navbar-search-form .nc-icon {
  color: #888888;
}

.footer {
  background-color: #FFFFFF;
  width: 100%;
}
.footer .footer-menu {
  height: 41px;
}
.footer nav > ul {
  list-style: none;
  margin: 0;
  padding: 0;
  font-weight: normal;
}
.footer nav > ul a:not(.btn) {
  color: #58595B;
  display: block;
  margin-bottom: 3px;
}
.footer nav > ul a:not(.btn):hover, .footer nav > ul a:not(.btn):focus {
  color: rgb(120.7, 120.7, 120.7);
}
.footer .social-area {
  padding: 15px 0;
}
.footer .social-area h5 {
  padding-bottom: 15px;
}
.footer .social-area > a:not(.btn) {
  color: #58595B;
  display: inline-block;
  vertical-align: top;
  padding: 10px 5px;
  font-size: 1.25rem;
  font-weight: normal;
  line-height: 20px;
  text-align: center;
}
.footer .social-area > a:not(.btn):hover, .footer .social-area > a:not(.btn):focus {
  color: rgb(120.7, 120.7, 120.7);
}
.footer .copyright {
  color: rgb(120.7, 120.7, 120.7);
  padding: 10px 15px;
  margin: 10px 3px;
  line-height: 20px;
  font-size: 0.875rem;
}
.footer hr {
  border-color: #A2A2A2;
}
.footer .title {
  color: rgb(120.7, 120.7, 120.7);
}

.footer-default {
  background-color: #F5F5F5;
}

.footer:not(.footer-big) nav > ul {
  font-size: 0.875rem;
}
.footer:not(.footer-big) nav > ul li {
  margin-left: 20px;
  float: left;
}
.footer:not(.footer-big) nav > ul a {
  padding: 10px 0px;
  margin: 10px 10px 10px 0px;
}

.full-page + .footer li a,
.full-page + .footer .copyright {
  color: #58595B !important;
}

.bootstrap-tagsinput {
  overflow-y: auto;
  text-align: left;
}
.bootstrap-tagsinput .badge {
  cursor: pointer;
  overflow: hidden;
  position: relative;
  margin: 5px 3px 5px 0;
  padding: 4px 18px !important;
  padding: 2px 12px;
  border: 1px solid #888888;
  border-radius: 3px;
  color: #888888;
  font-weight: 500;
  font-size: 0.75rem;
  text-transform: uppercase;
  display: inline-block;
  vertical-align: middle;
  background-color: transparent;
  border: 1px solid #888888;
  font-size: 12px !important;
}
.bootstrap-tagsinput .badge.badge-blue, .bootstrap-tagsinput .badge.badge-blue .tagsinput-remove-link {
  border-color: #0084CA;
  color: #0084CA;
}
.bootstrap-tagsinput .badge.badge-azure, .bootstrap-tagsinput .badge.badge-azure .tagsinput-remove-link {
  border-color: #003380;
  color: #003380;
}
.bootstrap-tagsinput .badge.badge-green .tag, .bootstrap-tagsinput .badge.badge-green .tagsinput-remove-link {
  border-color: #7ABA09;
  color: #7ABA09;
}
.bootstrap-tagsinput .badge.badge-orange .tag, .bootstrap-tagsinput .badge.badge-orange .tagsinput-remove-link {
  border-color: #FFE200;
  color: #FFE200;
}
.bootstrap-tagsinput .badge.badgebadge-red .tag, .bootstrap-tagsinput .badge.badgebadge-red .tagsinput-remove-link {
  border-color: #D61F05;
  color: #D61F05;
}
.bootstrap-tagsinput .badge .badge-remove-link {
  transition: all 60ms ease-in;
}
.bootstrap-tagsinput .badge:hover {
  padding-left: 10px;
  padding-right: 18px;
  opacity: 1 !important;
  visibility: visible !important;
}
.bootstrap-tagsinput .badge:hover .badge-remove-link {
  opacity: 1 !important;
  color: black;
  padding-right: 6px;
}
.bootstrap-tagsinput .tagsinput-add {
  color: #000000;
  cursor: pointer;
  display: inline-block;
  font-size: 14px;
  padding: 5px 6px;
  vertical-align: top;
  opacity: 0.8;
  filter: alpha(opacity=80);
}
.bootstrap-tagsinput .tagsinput-add:hover, .bootstrap-tagsinput .tagsinput-add:focus {
  opacity: 1;
  filter: alpha(opacity=100);
}
.bootstrap-tagsinput .tagsinput-add:before {
  content: "\\f067";
  font-family: "FontAwesome";
}
.bootstrap-tagsinput .badge-remove-link {
  cursor: pointer;
  font-size: 12px;
  padding: 3px 0;
  position: absolute;
  right: -3px;
  opacity: 0;
  text-align: right;
  text-decoration: none;
  top: 0;
  width: 100%;
  z-index: 2;
}
.bootstrap-tagsinput .tag:hover .tagsinput-remove-link {
  opacity: 1;
  padding-right: 6px;
}
.bootstrap-tagsinput .badge-remove-link:before {
  content: "\\f00d";
  font-family: "FontAwesome";
  color: #003380;
}
.bootstrap-tagsinput .tagsinput-add-container {
  display: inline-block;
  vertical-align: middle;
}
.bootstrap-tagsinput input {
  background: transparent;
  border: none;
  color: #000000;
  margin: 0;
  outline: medium none !important;
  padding: 0 0 0 5px;
  vertical-align: top;
  width: 40px;
  height: 30px;
}
.bootstrap-tagsinput.badge-fill .badge-blue {
  border-color: #0084CA;
  color: #FFFFFF;
  background-color: #0084CA;
}
.bootstrap-tagsinput.badge-fill .badge-azure {
  border-color: #003380;
  color: #FFFFFF;
  background-color: #003380;
}
.bootstrap-tagsinput.badge-fill.badge-green {
  border-color: #7ABA09;
  color: #FFFFFF;
  background-color: #7ABA09;
}
.bootstrap-tagsinput.badge-fill.badge-orange {
  border-color: #FFE200;
  color: #FFFFFF;
  background-color: #FFE200;
}
.bootstrap-tagsinput.badge-fill.badge-red {
  border-color: #D61F05;
  color: #FFFFFF;
  background-color: #D61F05;
}
.bootstrap-tagsinput.badge-fill .tagsinput-remove-link {
  color: #FFFFFF;
}

/*            Navigation menu                */
.nav-pills > li + li {
  margin-left: 0;
}
.nav-pills > li > a {
  border: 1px solid #003380;
  border-radius: 0;
  color: #003380;
  margin-left: -1px;
}
.nav-pills > li > a:hover, .nav-pills > li > a:focus {
  background-color: #F5F5F5;
}
.nav-pills > li.active > a,
.nav-pills > li.active > a:hover,
.nav-pills > li.active > a:focus {
  background-color: #003380;
  color: #FFFFFF;
}
.nav-pills > li:first-child > a {
  border-radius: 4px 0 0 4px;
  margin: 0;
}
.nav-pills > li:last-child > a {
  border-radius: 0 4px 4px 0;
}

.pagination .page-item .page-link {
  border-radius: 50%;
  margin: 0 2px;
  color: #797979;
  padding: 6px 12px;
}
.pagination .page-item .page-link:hover {
  background-color: #eee;
  border-color: #ddd;
}
.pagination .page-item.active .page-link {
  background-color: #23CCEF;
  border: 0;
  color: #FFFFFF !important;
  padding: 7px 13px;
}
.pagination .page-item:first-child .page-link, .pagination .page-item:last-child .page-link {
  border-radius: 50%;
}

.pagination > li.disabled {
  opacity: 0.4;
}

.pagination.pagination-no-border > li > a,
.pagination.pagination-no-border > li > span {
  border: 0;
}

.pagination > li > a,
.pagination > li > span,
.pagination > li:first-child > a,
.pagination > li:first-child > span,
.pagination > li:last-child > a,
.pagination > li:last-child > span {
  border-radius: 50%;
  margin: 0 2px;
  color: rgb(120.7, 120.7, 120.7);
}

.pagination > li.active > a,
.pagination > li.active > span,
.pagination > li.active > a:hover,
.pagination > li.active > span:hover,
.pagination > li.active > a:focus,
.pagination > li.active > span:focus {
  background-color: #003380;
  border: 0;
  color: #FFFFFF;
  padding: 7px 13px;
}

.nav-pills-blue > li.active > a,
.nav-pills-blue > li.active > a:hover,
.nav-pills-blue > li.active > a:focus {
  background-color: #003380;
}

.pagination-blue > li.active a,
.pagination-blue > li.active a:hover,
.pagination-blue > li.active a:focus,
.pagination-blue > li.active span,
.pagination-blue > li.active span:hover,
.pagination-blue > li.active span:focus {
  background-color: #003380 !important;
}

.nav-pills-azure > li.active > a,
.nav-pills-azure > li.active > a:hover,
.nav-pills-azure > li.active > a:focus {
  background-color: #0084CA;
}

.pagination-azure li.active a,
.pagination-azure li.active a:hover,
.pagination-azure li.active a:focus,
.pagination-azure li.active span,
.pagination-azure li.active span:hover,
.pagination-azure li.active span:focus {
  background-color: #0084CA !important;
}

.nav-pills-green > li.active > a,
.nav-pills-green > li.active > a:hover,
.nav-pills-green > li.active > a:focus {
  background-color: #7ABA09;
}

.pagination-green > li.active a,
.pagination-green > li.active a:hover,
.pagination-green > li.active a:focus,
.pagination-green > li.active span,
.pagination-green > li.active span:hover,
.pagination-green > li.active span:focus {
  background-color: #7ABA09 !important;
}

.nav-pills-orange > li.active > a,
.nav-pills-orange > li.active > a:hover,
.nav-pills-orange > li.active > a:focus {
  background-color: #FFE200;
}

.pagination-orange > li.active a,
.pagination-orange > li.active a:hover,
.pagination-orange > li.active a:focus,
.pagination-orange > li.active span,
.pagination-orange > li.active span:hover,
.pagination-orange > li.active span:focus {
  background-color: #FFE200 !important;
}

.nav-pills-red > li.active > a,
.nav-pills-red > li.active > a:hover,
.nav-pills-red > li.active > a:focus {
  background-color: #D61F05;
}

.pagination-red > li.active a,
.pagination-red > li.active a:hover,
.pagination-red > li.active a:focus,
.pagination-red > li.active span,
.pagination-red > li.active span:hover,
.pagination-red > li.active span:focus {
  background-color: #D61F05 !important;
}

.bootstrap-table .pagination .page-number a {
  padding: 7px 12px;
}

.nav-pills-blue > li > a {
  border: 1px solid #003380;
  color: #003380;
}

.nav-pills-azure > li > a {
  border: 1px solid #0084CA;
  color: #0084CA;
}

.nav-pills-green > li > a {
  border: 1px solid #7ABA09;
  color: #7ABA09;
}

.nav-pills-orange > li > a {
  border: 1px solid #FFE200;
  color: #FFE200;
}

.nav-pills-red > li > a {
  border: 1px solid #D61F05;
  color: #D61F05;
}

.nav-text,
.nav-icons {
  padding: 10px 0 0;
}
.nav-text .nav-item .nav-link,
.nav-icons .nav-item .nav-link {
  display: block;
  padding: 0px 16px;
  color: #58595B;
  text-align: center;
  opacity: 0.8;
  filter: alpha(opacity=80);
}
.nav-text .nav-item .nav-link:hover, .nav-text .nav-item .nav-link:focus,
.nav-icons .nav-item .nav-link:hover,
.nav-icons .nav-item .nav-link:focus {
  background-color: transparent;
  opacity: 1;
  filter: alpha(opacity=100);
}
.nav-text .nav-item:first-child .nav-link,
.nav-icons .nav-item:first-child .nav-link {
  padding-left: 0;
}
.nav-text .nav-item .nav-link.active,
.nav-text .nav-item.active .nav-link,
.nav-icons .nav-item .nav-link.active,
.nav-icons .nav-item.active .nav-link {
  color: #003380;
}

.nav-icons > li {
  display: inline-block;
}
.nav-icons > li > a {
  padding: 0 10px;
  margin-bottom: 10px;
}
.nav-icons > li > a i {
  font-size: 1.375rem;
  margin-bottom: 10px;
  width: 1.375rem;
}

.nav-icons.nav-stacked > li {
  display: block;
}
.nav-icons.nav-stacked > li > a {
  margin-bottom: 20px;
}

.nav-blue > li.active a {
  color: #0084CA;
}

.nav-azure > li.active a {
  color: #003380;
}

.nav-green > li.active a {
  color: #7ABA09;
}

.nav-orange > li.active a {
  color: #FFE200;
}

.nav-red > li.active a {
  color: #D61F05;
}

.nav-text {
  margin: 0 0 10px 0;
}
.nav-text > li > a {
  font-size: 0.875rem;
  text-transform: uppercase;
  padding: 3px 0;
  text-align: left;
  font-weight: 500;
}
.nav-text > li:first-child > a {
  padding-top: 0;
}
.nav-text h4 {
  margin-top: 0;
}

.nav-text:not(.nav-stacked) > li {
  display: inline-block;
}
.nav-text:not(.nav-stacked) > li > a {
  margin-right: 15px;
}

.tab-pane {
  padding: 15px 0;
}

.nav-container {
  display: block;
  width: 100%;
  text-align: center;
}

.content-full-width .nav-tabs li:first-child {
  padding-left: 15px;
}
.content-full-width .tab-pane {
  padding: 15px;
}

.accordions .card {
  border: 0;
  box-shadow: none;
  margin-bottom: 15px;
}
.accordions .card .card-header {
  padding: 0;
  border-bottom: 1px solid #DDDDDD !important;
}
.accordions .card .card-header .card-title {
  margin-top: 0;
  margin-bottom: 0;
  font-size: 18px;
  color: inherit;
}
.accordions .card .card-header .card-title a {
  color: #333;
  padding: 0px 0 5px;
  display: block;
  width: 100%;
  font-size: 16px;
}
.accordions .card .card-header .card-title a:hover {
  color: #797979;
}
.accordions .card .card-header .caret {
  display: inline-block;
  width: 0;
  height: 0;
  margin-left: 2px;
  vertical-align: middle;
  border-top: 4px dashed;
  border-top: 4px solid\\9 ;
  border-right: 4px solid transparent;
  border-left: 4px solid transparent;
  float: right;
  margin-top: 12px;
  margin-right: 15px;
  transition: all 150ms ease-in;
}
.accordions .card .card-header a[data-toggle=collapse][aria-expanded=true] .caret,
.accordions .card .card-header a[data-toggle=collapse-hover][aria-expanded=true] .caret {
  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=2);
  transform: rotate(180deg);
}
.accordions .card .card-header + .card-collapse .card-body {
  box-shadow: inset 0 7px 10px -7px rgba(0, 0, 0, 0.14);
}
.accordions .card .card-collapse.collapse-hover {
  transition: all 300ms linear !important;
}

.card-body-full-width {
  padding: 15px 0 !important;
}
.card-body-full-width .accordions .card-header .card-title a {
  padding: 10px 15px;
}

.content-full-width .nav-tabs .nav-item:first-child {
  padding-left: 15px;
}

.nav-container .nav-icons .nc-icon {
  font-weight: 700;
}

.card-wizard .nav-tabs {
  margin-left: -15px;
  margin-right: -15px;
  margin-top: 10px;
  margin-bottom: 10px;
}
.card-wizard .nav-tabs .nav-item {
  width: 33.33%;
}
.card-wizard .nav-tabs .nav-item .nav-link {
  text-align: center;
  border: none;
  background-color: #9A9A9A;
  color: #FFFFFF;
  text-transform: uppercase;
  border-radius: unset;
}
.card-wizard .nav-tabs .nav-item .nav-link.active {
  background-color: #003380;
}

.progress {
  background-color: #E5E5E5;
  border-radius: 3px;
  box-shadow: none;
  height: 4px;
  margin-bottom: 20px;
}

.progress-thin {
  height: 2px;
}

.progress-bar,
.progress-bar-primary {
  background-color: #0084CA;
}

.progress-bar-info {
  background-color: #003380;
}

.progress-bar-success {
  background-color: #7ABA09;
}

.progress-bar-warning {
  background-color: #FFE200;
}

.progress-bar-danger {
  background-color: #D61F05;
}

/*!
 * jQuery UI Slider 1.10.4
 * http://jqueryui.com
 *
 * Copyright 2014 jQuery Foundation and other contributors
 * Released under the MIT license.
 * http://jquery.org/license
 *
 * http://api.jqueryui.com/slider/#theming
 */
.ui-slider {
  position: relative;
  text-align: left;
}

.ui-slider .ui-slider-handle {
  position: absolute;
  z-index: 2;
  width: 1.2em;
  height: 1.2em;
  cursor: default;
}

.ui-slider .ui-slider-range {
  position: absolute;
  z-index: 1;
  font-size: 0.7em;
  display: block;
  border: 0;
  background-position: 0 0;
}

/* For IE8 - See #6727 */
.ui-slider.ui-state-disabled .ui-slider-handle,
.ui-slider.ui-state-disabled .ui-slider-range {
  filter: inherit;
}

.ui-slider-horizontal {
  height: 4px;
}

.ui-slider-horizontal .ui-slider-handle {
  margin-left: -10px;
  top: -7px;
}

.ui-slider-horizontal .ui-slider-range {
  top: 0;
  height: 100%;
}

.ui-slider-horizontal .ui-slider-range-min {
  left: 0;
}

.ui-slider-horizontal .ui-slider-range-max {
  right: 0;
}

.ui-slider-vertical {
  width: 0.8em;
  height: 100px;
}

.ui-slider-vertical .ui-slider-handle {
  left: -0.3em;
  margin-left: 0;
  margin-bottom: -0.6em;
}

.ui-slider-vertical .ui-slider-range {
  left: 0;
  width: 100%;
}

.ui-slider-vertical .ui-slider-range-min {
  bottom: 0;
}

.ui-slider-vertical .ui-slider-range-max {
  top: 0;
}

/* Component containers
----------------------------------*/
.ui-widget {
  font-size: 1.1em;
}

.ui-widget .ui-widget {
  font-size: 1em;
}

.ui-widget input,
.ui-widget select,
.ui-widget textarea,
.ui-widget button {
  font-size: 1em;
}

.ui-widget-content {
  background-color: #E5E5E5;
}

.ui-widget-content a {
  color: #222222;
}

.ui-widget-header {
  background: #999999;
  color: #222222;
  font-weight: bold;
}

.ui-widget-header a {
  color: #222222;
}

.slider-primary .ui-widget-header {
  background-color: #0084CA;
}

.slider-info .ui-widget-header {
  background-color: #003380;
}

.slider-success .ui-widget-header {
  background-color: #7ABA09;
}

.slider-warning .ui-widget-header {
  background-color: #FFE200;
}

.slider-danger .ui-widget-header {
  background-color: #D61F05;
}

/* Interaction states
----------------------------------*/
.ui-state-default,
.ui-widget-content .ui-state-default,
.ui-widget-header .ui-state-default {
  background: rgb(255, 255, 255); /* Old browsers */ /* FF3.6+ */ /* Chrome,Safari4+ */ /* Chrome10+,Safari5.1+ */ /* Opera 11.10+ */ /* IE10+ */
  background: linear-gradient(to bottom, rgb(255, 255, 255) 0%, rgb(241, 241, 242) 100%); /* W3C */
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr="#ffffff", endColorstr="#f1f1f2",GradientType=0 ); /* IE6-9 */
  border-radius: 50%;
  box-shadow: 0 1px 1px #FFFFFF inset, 0 1px 2px rgba(0, 0, 0, 0.4);
  height: 15px;
  width: 15px;
  cursor: pointer;
}

.ui-state-default a,
.ui-state-default a:link,
.ui-state-default a:visited {
  color: #555555;
  text-decoration: none;
}

.ui-state-hover a,
.ui-state-hover a:hover,
.ui-state-hover a:link,
.ui-state-hover a:visited,
.ui-state-focus a,
.ui-state-focus a:hover,
.ui-state-focus a:link,
.ui-state-focus a:visited {
  color: #212121;
  text-decoration: none;
}

.ui-state-active a,
.ui-state-active a:link,
.ui-state-active a:visited {
  color: #212121;
  text-decoration: none;
}

/* Interaction Cues
----------------------------------*/
.ui-state-highlight,
.ui-widget-content .ui-state-highlight,
.ui-widget-header .ui-state-highlight {
  border: 1px solid #fcefa1;
  background: #fbf9ee;
  color: #363636;
}

.ui-state-highlight a,
.ui-widget-content .ui-state-highlight a,
.ui-widget-header .ui-state-highlight a {
  color: #363636;
}

.ui-state-error,
.ui-widget-content .ui-state-error,
.ui-widget-header .ui-state-error {
  border: 1px solid #D61F05;
  background-color: #D61F05;
  color: #D61F05;
}

.ui-state-error a,
.ui-widget-content .ui-state-error a,
.ui-widget-header .ui-state-error a {
  color: #D61F05;
}

.ui-state-error-text,
.ui-widget-content .ui-state-error-text,
.ui-widget-header .ui-state-error-text {
  color: #D61F05;
}

.ui-priority-primary,
.ui-widget-content .ui-priority-primary,
.ui-widget-header .ui-priority-primary {
  font-weight: bold;
}

.ui-priority-secondary,
.ui-widget-content .ui-priority-secondary,
.ui-widget-header .ui-priority-secondary {
  opacity: 0.7;
  filter: Alpha(Opacity=70);
  font-weight: normal;
}

.ui-state-disabled,
.ui-widget-content .ui-state-disabled,
.ui-widget-header .ui-state-disabled {
  opacity: 0.35;
  filter: Alpha(Opacity=35);
  background-image: none;
}

.ui-state-disabled .ui-icon {
  filter: Alpha(Opacity=35); /* For IE8 - See #6059 */
}

.dropdown-menu {
  visibility: hidden;
  margin: 0;
  padding: 0;
  border-radius: 10px;
  display: block;
  z-index: 9000;
  position: absolute;
  opacity: 0;
  filter: alpha(opacity=0);
  box-shadow: 1px 2px 3px rgba(0, 0, 0, 0.125);
}
.show .dropdown-menu {
  opacity: 1;
  filter: alpha(opacity=100);
  visibility: visible;
}
.select .dropdown-menu {
  border-radius: 0 0 10px 10px;
  box-shadow: none;
  transform-origin: 50% -40px;
  transform: scale(1);
  transition: all 150ms linear;
  margin-top: -20px;
}
.select.show .dropdown-menu {
  margin-top: -1px;
}
.dropdown-menu .dropdown-item {
  padding: 8px 16px;
  color: #333333;
}
.dropdown-menu .dropdown-item img {
  margin-top: -3px;
}
.dropdown-menu .dropdown-item:focus {
  outline: 0 !important;
}
.btn-group.select .dropdown-menu {
  min-width: 100%;
}
.dropdown-menu > li:first-child > a {
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}
.dropdown-menu > li:last-child > a {
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
}
.select .dropdown-menu > li:first-child > a {
  border-radius: 0;
  border-bottom: 0 none;
}
.dropdown-menu .dropdown-item:hover,
.dropdown-menu .dropdown-item:focus {
  background-color: #F5F5F5;
  color: #333333;
  opacity: 1;
  text-decoration: none;
}
.dropdown-menu.dropdown-blue > li > a:hover, .dropdown-menu.dropdown-blue > li > a:focus {
  background-color: #CEEEFF;
}
.dropdown-menu.dropdown-azure > li > a:hover, .dropdown-menu.dropdown-azure > li > a:focus {
  background-color: #4CA8D9;
}
.dropdown-menu.ct-green > li > a:hover, .dropdown-menu.ct-green > li > a:focus {
  background-color: #E9F3D7;
}
.dropdown-menu.dropdown-orange > li > a:hover, .dropdown-menu.dropdown-orange > li > a:focus {
  background-color: rgba(255, 226, 0, 0.2);
}
.dropdown-menu.dropdown-red > li > a:hover, .dropdown-menu.dropdown-red > li > a:focus {
  background-color: rgba(214, 31, 5, 0.2);
}
.dropdown-menu .dropdown-item i[class*=nc-icon] {
  font-size: 18px;
  text-align: center;
  line-height: 25px;
  float: left;
  padding-right: 10px;
}
.dropdown-menu.dropdown-menu-right:before, .dropdown-menu.dropdown-menu-right:after {
  right: 12px !important;
  left: auto !important;
}

.dropdown-with-icons > li > a {
  padding-left: 0px;
  line-height: 28px;
}
.dropdown-with-icons i {
  text-align: center;
  line-height: 28px;
  float: left;
}
.dropdown-with-icons i[class^=pe-] {
  font-size: 24px;
  width: 46px;
}
.dropdown-with-icons i[class^=fa], .dropdown-with-icons i[class^=fas], .dropdown-with-icons i[class^=far], .dropdown-with-icons i[class^=fal], .dropdown-with-icons i[class^=fad], .dropdown-with-icons i[class^=fab] {
  font-size: 14px;
  width: 38px;
}

.btn-group.select {
  overflow: hidden;
}

.btn-group.select.show {
  overflow: visible;
}

.card {
  border-radius: 4px;
  background-color: #FFFFFF;
  margin-bottom: 30px;
}
.card .card-image {
  width: 100%;
  overflow: hidden;
  height: 260px;
  border-radius: 4px 4px 0 0;
  position: relative;
  transform-style: preserve-3d;
}
.card .card-image img {
  width: 100%;
}
.card .filter {
  position: absolute;
  z-index: 2;
  background-color: rgba(0, 0, 0, 0.68);
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  text-align: center;
  opacity: 0;
  filter: alpha(opacity=0);
}
.card .filter .btn {
  position: relative;
  top: 50%;
  transform: translateY(-50%);
}
.card:hover .filter {
  opacity: 1;
  filter: alpha(opacity=100);
}
.card .btn-hover {
  opacity: 0;
  filter: alpha(opacity=0);
}
.card:hover .btn-hover {
  opacity: 1;
  filter: alpha(opacity=100);
}
.card .card-body {
  padding: 15px 15px 10px 15px;
}
.card .card-header {
  padding: 15px 15px 0;
  background-color: #FFFFFF;
  border-bottom: none !important;
}
.card .card-category,
.card label {
  font-size: 0.875rem;
  font-weight: 400;
  color: #58595B;
  margin-bottom: 0px;
}
.card .card-category i,
.card label i {
  font-size: 1rem;
}
.card label {
  font-size: 0.75rem;
  margin-bottom: 5px;
  text-transform: none;
}
.card label a {
  font-size: 0.6rem;
}
.card .card-title {
  margin: 0;
  color: #000000;
  font-weight: 300;
}
.card .avatar {
  height: 100%;
  overflow: hidden;
  border-radius: 50%;
  margin-right: 5px;
}
.card .description {
  font-size: 0.875rem;
  color: #333;
}
.card .card-footer {
  padding: 15px 15px 10px 15px;
  background-color: transparent;
  line-height: 30px;
  border-top: none !important;
  font-size: 14px;
}
.card .card-footer .legend {
  padding: 5px 0;
}
.card .card-footer hr {
  margin-top: 5px;
  margin-bottom: 5px;
}
.card .stats {
  color: #a9a9a9;
}
.card .author {
  font-size: 0.75rem;
  font-weight: 600;
  text-transform: uppercase;
  border-radius: 50%;
  border: 4px solid rgba(255, 255, 255, 0.3);
  overflow: hidden;
  margin: 0 auto;
  transition: all 300ms linear;
}
.card .author i {
  font-size: 0.875rem;
}
.card h6 {
  font-size: 0.75rem;
  margin: 0;
}
.card.card-separator:after {
  height: 100%;
  right: -15px;
  top: 0;
  width: 1px;
  background-color: #A2A2A2;
  card-body: "";
  position: absolute;
}
.card .ct-chart {
  margin: 30px 0 30px;
}
.card .ct-label {
  font-size: 1rem !important;
}
.card .alert {
  border-radius: 4px;
  position: relative;
}
.card .alert.alert-with-icon {
  padding-left: 65px;
}
.card.card-lock .card-body .card-title {
  margin-bottom: 20px;
  color: #FFFFFF;
}
.card.card-lock .card-header .author {
  width: 100px;
  height: 100px;
}

.card-stats .card-body {
  padding: 15px 15px 0px;
}
.card-stats .card-body .numbers {
  text-align: right;
}
.card-stats .card-body .numbers p {
  margin-bottom: 0;
}
.card-stats .card-footer {
  padding: 0px 15px 10px 15px;
}
.card-stats .icon-big {
  font-size: 3em;
  min-height: 64px;
}
.card-stats .icon-big i {
  line-height: 59px;
}

.card-user .card-image {
  height: 110px;
}
.card-user .card-image-plain {
  height: 0;
  margin-top: 110px;
}
.card-user .author {
  text-align: center;
  text-transform: none;
  margin-top: -70px;
}
.card-user .avatar {
  width: 124px;
  height: 124px;
  border: 5px solid #EEEEEE;
  position: relative;
  margin-bottom: 15px;
}
.card-user .avatar.border-gray {
  border-color: #EEEEEE;
}
.card-user .title {
  line-height: 24px;
}
.card-user .card-body {
  min-height: 240px;
}
.card-user .card-header.no-padding {
  padding: 0;
}
.card-user .card-footer .button-container .btn {
  font-size: 16px;
}

.card-user .card-footer,
.card-price .card-footer {
  padding: 5px 15px 10px;
}
.card-user hr,
.card-price hr {
  margin: 5px 15px;
}

.card-plain {
  background-color: transparent;
  box-shadow: none;
  border-radius: 0;
}
.card-plain .card-image {
  border-radius: 4px;
}

.card.card-plain {
  border: none !important;
}
.card.card-plain .card-header {
  background-color: transparent !important;
}

.card.card-login {
  box-shadow: 0 25px 30px -13px rgba(40, 40, 40, 0.4);
  border-radius: 10px;
  padding-top: 10px;
  padding-bottom: 30px;
  transform: translate3d(0, 0px, 0);
  transition: all 300ms linear;
}
.card.card-login .form-check {
  margin-left: -12px;
}
.card.card-login.card-hidden {
  opacity: 0;
  transform: translate3d(0, -60px, 0);
}
.card.card-register .header-text hr {
  border-top: 1px solid rgba(255, 255, 255, 0.3);
}

.ct-label {
  fill: rgba(0, 0, 0, 0.4);
  color: rgba(0, 0, 0, 0.4);
  font-size: 1.3rem;
  line-height: 1;
}

.ct-chart-line .ct-label,
.ct-chart-bar .ct-label {
  display: block;
  display: flex;
}

.ct-label.ct-horizontal.ct-start {
  align-items: flex-end;
  justify-content: flex-start;
  text-align: left;
  text-anchor: start;
}

.ct-label.ct-horizontal.ct-end {
  align-items: flex-start;
  justify-content: flex-start;
  text-align: left;
  text-anchor: start;
}

.ct-label.ct-vertical.ct-start {
  align-items: flex-end;
  justify-content: flex-end;
  text-align: right;
  text-anchor: end;
}

.ct-label.ct-vertical.ct-end {
  align-items: flex-end;
  justify-content: flex-start;
  text-align: left;
  text-anchor: start;
}

.ct-chart-bar .ct-label.ct-horizontal.ct-start {
  align-items: flex-end;
  justify-content: center;
  text-align: center;
  text-anchor: start;
}

.ct-chart-bar .ct-label.ct-horizontal.ct-end {
  align-items: flex-start;
  justify-content: center;
  text-align: center;
  text-anchor: start;
}

.ct-chart-bar.ct-horizontal-bars .ct-label.ct-horizontal.ct-start {
  align-items: flex-end;
  justify-content: flex-start;
  text-align: left;
  text-anchor: start;
}

.ct-chart-bar.ct-horizontal-bars .ct-label.ct-horizontal.ct-end {
  align-items: flex-start;
  justify-content: flex-start;
  text-align: left;
  text-anchor: start;
}

.ct-chart-bar.ct-horizontal-bars .ct-label.ct-vertical.ct-start {
  align-items: center;
  justify-content: flex-end;
  text-align: right;
  text-anchor: end;
}

.ct-chart-bar.ct-horizontal-bars .ct-label.ct-vertical.ct-end {
  align-items: center;
  justify-content: flex-start;
  text-align: left;
  text-anchor: end;
}

.ct-grid {
  stroke: rgba(0, 0, 0, 0.2);
  stroke-width: 1px;
  stroke-dasharray: 2px;
}

.ct-point {
  stroke-width: 8px;
  stroke-linecap: round;
}

.ct-line {
  fill: none;
  stroke-width: 3px;
}

.ct-area {
  stroke: none;
  fill-opacity: 0.8;
}

.ct-bar {
  fill: none;
  stroke-width: 10px;
}

.ct-slice-donut {
  fill: none;
  stroke-width: 60px;
}

.ct-series-a .ct-point, .ct-series-a .ct-line, .ct-series-a .ct-bar, .ct-series-a .ct-slice-donut {
  stroke: #1DC7EA;
}
.ct-series-a .ct-slice-pie, .ct-series-a .ct-area {
  fill: #1DC7EA;
}

.ct-series-b .ct-point, .ct-series-b .ct-line, .ct-series-b .ct-bar, .ct-series-b .ct-slice-donut {
  stroke: #D61F05;
}
.ct-series-b .ct-slice-pie, .ct-series-b .ct-area {
  fill: #D61F05;
}

.ct-series-c .ct-point, .ct-series-c .ct-line, .ct-series-c .ct-bar, .ct-series-c .ct-slice-donut {
  stroke: #FFE200;
}
.ct-series-c .ct-slice-pie, .ct-series-c .ct-area {
  fill: #FFE200;
}

.ct-series-d .ct-point, .ct-series-d .ct-line, .ct-series-d .ct-bar, .ct-series-d .ct-slice-donut {
  stroke: #9368E9;
}
.ct-series-d .ct-slice-pie, .ct-series-d .ct-area {
  fill: #9368E9;
}

.ct-series-e .ct-point, .ct-series-e .ct-line, .ct-series-e .ct-bar, .ct-series-e .ct-slice-donut {
  stroke: #7ABA09;
}
.ct-series-e .ct-slice-pie, .ct-series-e .ct-area {
  fill: #7ABA09;
}

.ct-series-f .ct-point, .ct-series-f .ct-line, .ct-series-f .ct-bar, .ct-series-f .ct-slice-donut {
  stroke: #1F77D0;
}
.ct-series-f .ct-slice-pie, .ct-series-f .ct-area {
  fill: #1F77D0;
}

.ct-series-g .ct-point, .ct-series-g .ct-line, .ct-series-g .ct-bar, .ct-series-g .ct-slice-donut {
  stroke: #58595B;
}
.ct-series-g .ct-slice-pie, .ct-series-g .ct-area {
  fill: #58595B;
}

.ct-series-h .ct-point, .ct-series-h .ct-line, .ct-series-h .ct-bar, .ct-series-h .ct-slice-donut {
  stroke: #dd4b39;
}
.ct-series-h .ct-slice-pie, .ct-series-h .ct-area {
  fill: #dd4b39;
}

.ct-series-i .ct-point, .ct-series-i .ct-line, .ct-series-i .ct-bar, .ct-series-i .ct-slice-donut {
  stroke: #35465c;
}
.ct-series-i .ct-slice-pie, .ct-series-i .ct-area {
  fill: #35465c;
}

.ct-series-j .ct-point, .ct-series-j .ct-line, .ct-series-j .ct-bar, .ct-series-j .ct-slice-donut {
  stroke: #e52d27;
}
.ct-series-j .ct-slice-pie, .ct-series-j .ct-area {
  fill: #e52d27;
}

.ct-series-k .ct-point, .ct-series-k .ct-line, .ct-series-k .ct-bar, .ct-series-k .ct-slice-donut {
  stroke: #55acee;
}
.ct-series-k .ct-slice-pie, .ct-series-k .ct-area {
  fill: #55acee;
}

.ct-series-l .ct-point, .ct-series-l .ct-line, .ct-series-l .ct-bar, .ct-series-l .ct-slice-donut {
  stroke: #cc2127;
}
.ct-series-l .ct-slice-pie, .ct-series-l .ct-area {
  fill: #cc2127;
}

.ct-series-m .ct-point, .ct-series-m .ct-line, .ct-series-m .ct-bar, .ct-series-m .ct-slice-donut {
  stroke: #1769ff;
}
.ct-series-m .ct-slice-pie, .ct-series-m .ct-area {
  fill: #1769ff;
}

.ct-series-n .ct-point, .ct-series-n .ct-line, .ct-series-n .ct-bar, .ct-series-n .ct-slice-donut {
  stroke: #6188e2;
}
.ct-series-n .ct-slice-pie, .ct-series-n .ct-area {
  fill: #6188e2;
}

.ct-series-o .ct-point, .ct-series-o .ct-line, .ct-series-o .ct-bar, .ct-series-o .ct-slice-donut {
  stroke: #a748ca;
}
.ct-series-o .ct-slice-pie, .ct-series-o .ct-area {
  fill: #a748ca;
}

.ct-square {
  display: block;
  position: relative;
  width: 100%;
}
.ct-square:before {
  display: block;
  float: left;
  content: "";
  width: 0;
  height: 0;
  padding-bottom: 100%;
}
.ct-square:after {
  content: "";
  display: table;
  clear: both;
}
.ct-square > svg {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
}

.ct-minor-second {
  display: block;
  position: relative;
  width: 100%;
}
.ct-minor-second:before {
  display: block;
  float: left;
  content: "";
  width: 0;
  height: 0;
  padding-bottom: 93.75%;
}
.ct-minor-second:after {
  content: "";
  display: table;
  clear: both;
}
.ct-minor-second > svg {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
}

.ct-major-second {
  display: block;
  position: relative;
  width: 100%;
}
.ct-major-second:before {
  display: block;
  float: left;
  content: "";
  width: 0;
  height: 0;
  padding-bottom: 88.8888888889%;
}
.ct-major-second:after {
  content: "";
  display: table;
  clear: both;
}
.ct-major-second > svg {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
}

.ct-minor-third {
  display: block;
  position: relative;
  width: 100%;
}
.ct-minor-third:before {
  display: block;
  float: left;
  content: "";
  width: 0;
  height: 0;
  padding-bottom: 83.3333333333%;
}
.ct-minor-third:after {
  content: "";
  display: table;
  clear: both;
}
.ct-minor-third > svg {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
}

.ct-major-third {
  display: block;
  position: relative;
  width: 100%;
}
.ct-major-third:before {
  display: block;
  float: left;
  content: "";
  width: 0;
  height: 0;
  padding-bottom: 80%;
}
.ct-major-third:after {
  content: "";
  display: table;
  clear: both;
}
.ct-major-third > svg {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
}

.ct-perfect-fourth {
  display: block;
  position: relative;
  width: 100%;
}
.ct-perfect-fourth:before {
  display: block;
  float: left;
  content: "";
  width: 0;
  height: 0;
  padding-bottom: 75%;
}
.ct-perfect-fourth:after {
  content: "";
  display: table;
  clear: both;
}
.ct-perfect-fourth > svg {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
}

.ct-perfect-fifth {
  display: block;
  position: relative;
  width: 100%;
}
.ct-perfect-fifth:before {
  display: block;
  float: left;
  content: "";
  width: 0;
  height: 0;
  padding-bottom: 66.6666666667%;
}
.ct-perfect-fifth:after {
  content: "";
  display: table;
  clear: both;
}
.ct-perfect-fifth > svg {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
}

.ct-minor-sixth {
  display: block;
  position: relative;
  width: 100%;
}
.ct-minor-sixth:before {
  display: block;
  float: left;
  content: "";
  width: 0;
  height: 0;
  padding-bottom: 62.5%;
}
.ct-minor-sixth:after {
  content: "";
  display: table;
  clear: both;
}
.ct-minor-sixth > svg {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
}

.ct-golden-section {
  display: block;
  position: relative;
  width: 100%;
}
.ct-golden-section:before {
  display: block;
  float: left;
  content: "";
  width: 0;
  height: 0;
  padding-bottom: 61.804697157%;
}
.ct-golden-section:after {
  content: "";
  display: table;
  clear: both;
}
.ct-golden-section > svg {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
}

.ct-major-sixth {
  display: block;
  position: relative;
  width: 100%;
}
.ct-major-sixth:before {
  display: block;
  float: left;
  content: "";
  width: 0;
  height: 0;
  padding-bottom: 60%;
}
.ct-major-sixth:after {
  content: "";
  display: table;
  clear: both;
}
.ct-major-sixth > svg {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
}

.ct-minor-seventh {
  display: block;
  position: relative;
  width: 100%;
}
.ct-minor-seventh:before {
  display: block;
  float: left;
  content: "";
  width: 0;
  height: 0;
  padding-bottom: 56.25%;
}
.ct-minor-seventh:after {
  content: "";
  display: table;
  clear: both;
}
.ct-minor-seventh > svg {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
}

.ct-major-seventh {
  display: block;
  position: relative;
  width: 100%;
}
.ct-major-seventh:before {
  display: block;
  float: left;
  content: "";
  width: 0;
  height: 0;
  padding-bottom: 53.3333333333%;
}
.ct-major-seventh:after {
  content: "";
  display: table;
  clear: both;
}
.ct-major-seventh > svg {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
}

.ct-octave {
  display: block;
  position: relative;
  width: 100%;
}
.ct-octave:before {
  display: block;
  float: left;
  content: "";
  width: 0;
  height: 0;
  padding-bottom: 50%;
}
.ct-octave:after {
  content: "";
  display: table;
  clear: both;
}
.ct-octave > svg {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
}

.ct-major-tenth {
  display: block;
  position: relative;
  width: 100%;
}
.ct-major-tenth:before {
  display: block;
  float: left;
  content: "";
  width: 0;
  height: 0;
  padding-bottom: 40%;
}
.ct-major-tenth:after {
  content: "";
  display: table;
  clear: both;
}
.ct-major-tenth > svg {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
}

.ct-major-eleventh {
  display: block;
  position: relative;
  width: 100%;
}
.ct-major-eleventh:before {
  display: block;
  float: left;
  content: "";
  width: 0;
  height: 0;
  padding-bottom: 37.5%;
}
.ct-major-eleventh:after {
  content: "";
  display: table;
  clear: both;
}
.ct-major-eleventh > svg {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
}

.ct-major-twelfth {
  display: block;
  position: relative;
  width: 100%;
}
.ct-major-twelfth:before {
  display: block;
  float: left;
  content: "";
  width: 0;
  height: 0;
  padding-bottom: 33.3333333333%;
}
.ct-major-twelfth:after {
  content: "";
  display: table;
  clear: both;
}
.ct-major-twelfth > svg {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
}

.ct-double-octave {
  display: block;
  position: relative;
  width: 100%;
}
.ct-double-octave:before {
  display: block;
  float: left;
  content: "";
  width: 0;
  height: 0;
  padding-bottom: 25%;
}
.ct-double-octave:after {
  content: "";
  display: table;
  clear: both;
}
.ct-double-octave > svg {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
}

@media (min-width: 992px) {
  .navbar-fixed {
    width: calc(100% + 260px);
  }
  .navbar-form {
    padding-left: 15px;
    padding-right: 5px;
  }
  .navbar-form .input-group .form-control {
    margin-left: 10px;
  }
  .nav.nav-mobile-menu {
    display: none;
  }
  .navbar .navbar-nav .nc-icon {
    font-weight: 700;
    margin-top: 10px;
  }
  .navbar .navbar-nav .input-group .nc-icon {
    margin-top: 0;
  }
  .navbar .navbar-nav .dropdown-menu .dropdown-item .nc-icon {
    margin-top: 0;
  }
  .close-layer {
    display: none;
  }
  .navbar-nav .nav-item .dropdown-menu, .dropdown .dropdown-menu {
    transform: scale(0);
    transition: all 370ms cubic-bezier(0.34, 1.61, 0.7, 1);
  }
  .navbar-nav .nav-item.show .dropdown-menu, .dropdown.show .dropdown-menu {
    transform: scale(1);
    transform-origin: 29px -50px;
  }
  .sidebar-mini .sidebar .sidebar-wrapper > .nav [data-toggle=collapse] ~ div > ul > li > a .sidebar-normal, .sidebar-mini .sidebar .sidebar-wrapper .user .info [data-toggle=collapse] ~ div > ul > li > a .sidebar-normal, .sidebar-mini .sidebar .sidebar-wrapper .user .info > a > span,
  .sidebar-mini .sidebar .sidebar-wrapper > .nav li > a span,
  .sidebar-mini .sidebar .sidebar-wrapper > .nav li > a .caret {
    transform: translate3d(-25px, 0, 0);
    opacity: 0;
  }
  .sidebar-mini .sidebar .logo a.logo-mini {
    opacity: 1;
  }
  .sidebar-mini .sidebar .logo a.logo-normal {
    opacity: 0;
  }
  .footer {
    height: 60px;
  }
  .footer .footer-menu {
    float: left;
  }
  .footer .copyright {
    float: right;
  }
  .navbar-nav .nav-item .dropdown-menu:before {
    border-bottom: 11px solid rgba(0, 0, 0, 0.2);
    border-left: 11px solid rgba(0, 0, 0, 0);
    border-right: 11px solid rgba(0, 0, 0, 0);
    content: "";
    display: inline-block;
    position: absolute;
    left: 12px;
    top: -11px;
  }
  .navbar-nav .nav-item .dropdown-menu:after {
    border-bottom: 11px solid #FFFFFF;
    border-left: 11px solid rgba(0, 0, 0, 0);
    border-right: 11px solid rgba(0, 0, 0, 0);
    content: "";
    display: inline-block;
    position: absolute;
    left: 12px;
    top: -10px;
  }
  .navbar-nav.navbar-right .nav-item .dropdown-menu:before {
    left: auto;
    right: 12px;
  }
  .navbar-nav.navbar-right .nav-item .dropdown-menu:after {
    left: auto;
    right: 12px;
  }
  .footer:not(.footer-big) nav > ul li:first-child {
    margin-left: 0;
  }
  .card form [class*=col-] {
    padding: 6px;
  }
  .card form [class*=col-]:first-child {
    padding-left: 15px;
  }
  .card form [class*=col-]:last-child {
    padding-right: 15px;
  }
}
/*          Changes for small display      */
@media (max-width: 991px) {
  .sidebar {
    right: 0 !important;
    left: auto;
    transform: translate3d(260px, 0, 0);
    transition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);
  }
  .nav-open .main-panel {
    position: absolute;
    left: 0;
    transform: translate3d(-260px, 0, 0);
    transition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);
  }
  .nav-open .sidebar {
    transform: translate3d(0px, 0, 0);
    transition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);
  }
  .main-panel {
    transition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);
  }
  .menu-on-left .sidebar {
    left: 0 !important;
    right: auto;
    transform: translate3d(-260px, 0, 0);
    transition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);
  }
  .menu-on-left .main-panel {
    transform: translate3d(0px, 0, 0);
    transition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);
  }
  .nav-open .menu-on-left .main-panel {
    position: absolute;
    left: 0;
    transform: translate3d(260px, 0, 0);
    transition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);
  }
  .nav-open .menu-on-left .sidebar {
    transform: translate3d(0px, 0, 0);
    transition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);
  }
  .nav-item.active-pro {
    position: relative !important;
  }
  .nav-mobile-menu {
    border-bottom: 1px solid rgba(255, 255, 255, 0.2);
    margin-bottom: 15px;
    padding-bottom: 15px;
    padding-top: 5px;
  }
  .nav-mobile-menu .dropdown .dropdown-menu {
    position: static !important;
    float: none;
    width: auto;
    color: #FFFFFF;
    margin-top: 0;
    background-color: transparent;
    border: 0;
    box-shadow: none;
    transform: translate3d(0px, 0px, 0px) !important;
    transition: all 0.5s cubic-bezier(0.685, 0.0473, 0.346, 1);
  }
  .nav-mobile-menu .dropdown .dropdown-menu .dropdown-item {
    margin: 5px 15px 0px 20px;
    border-radius: 4px;
    color: #FFFFFF;
    opacity: 0.86;
    padding: 8px 50px;
  }
  .nav-mobile-menu .dropdown .dropdown-menu .dropdown-item:hover {
    background-color: rgba(255, 255, 255, 0.23);
  }
  .nav-mobile-menu .dropdown .dropdown-menu .dropdown-item .nc-icon {
    margin-left: -40px;
  }
  .nav-mobile-menu .nav-item .nav-link span {
    display: inline-block !important;
  }
  .nav-mobile-menu .nav-item .nav-link .no-icon {
    padding-left: 50px;
  }
  .main-panel {
    width: 100%;
  }
  .navbar-brand {
    padding: 15px 0px;
  }
  .navbar-transparent {
    padding-top: 15px;
  }
  body {
    position: relative;
  }
  .wrapper {
    left: 0;
    background-color: white;
  }
  .navbar .container {
    left: 15px;
    width: 100%;
    position: relative;
    top: -10px;
  }
  .navbar-nav .nav-item {
    float: none;
    position: relative;
    display: block;
  }
  body > .navbar-collapse {
    position: fixed;
    display: block;
    top: 0;
    height: 100%;
    right: 0;
    left: auto;
    z-index: 1032;
    visibility: visible;
    background-color: #999;
    overflow-y: visible;
    border-top: none;
    text-align: left;
    padding: 0;
    transform: translate3d(260px, 0, 0);
    transition: all 0.33s cubic-bezier(0.685, 0.0473, 0.346, 1);
  }
  body > .navbar-collapse > ul {
    position: relative;
    z-index: 4;
    overflow-y: scroll;
    height: calc(100vh - 61px);
    width: 100%;
  }
  body > .navbar-collapse::before {
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    position: absolute;
    background-color: #282828;
    display: block;
    content: "";
    z-index: 1;
  }
  body > .navbar-collapse .logo {
    position: relative;
    z-index: 4;
  }
  body > .navbar-collapse .nav li > a {
    padding: 10px 15px;
  }
  .nav-show .navbar-collapse {
    transform: translate3d(0px, 0, 0);
  }
  .nav-show .navbar .container {
    left: -250px;
  }
  .nav-show .wrapper {
    left: 0;
    transform: translate3d(-260px, 0, 0);
  }
  .navbar-toggle .icon-bar {
    display: block;
    position: relative;
    background: #fff;
    width: 24px;
    height: 2px;
    border-radius: 1px;
    margin: 0 auto;
  }
  .navbar-header .navbar-toggle {
    margin: 10px 15px 10px 0;
    width: 40px;
    height: 40px;
  }
  .bar1,
  .bar2,
  .bar3 {
    outline: 1px solid transparent;
  }
  .bar1 {
    top: 0px;
    animation: topbar-back 500ms 0s;
    animation-fill-mode: forwards;
  }
  .bar2 {
    opacity: 1;
  }
  .bar3 {
    bottom: 0px;
    animation: bottombar-back 500ms 0s;
    animation-fill-mode: forwards;
  }
  .toggled .bar1 {
    top: 6px;
    animation: topbar-x 500ms 0s;
    animation-fill-mode: forwards;
  }
  .toggled .bar2 {
    opacity: 0;
  }
  .toggled .bar3 {
    bottom: 6px;
    animation: bottombar-x 500ms 0s;
    animation-fill-mode: forwards;
  }
  @keyframes topbar-x {
    0% {
      top: 0px;
      transform: rotate(0deg);
    }
    45% {
      top: 6px;
      transform: rotate(145deg);
    }
    75% {
      transform: rotate(130deg);
    }
    100% {
      transform: rotate(135deg);
    }
  }
  @keyframes topbar-back {
    0% {
      top: 6px;
      transform: rotate(135deg);
    }
    45% {
      transform: rotate(-10deg);
    }
    75% {
      transform: rotate(5deg);
    }
    100% {
      top: 0px;
      transform: rotate(0);
    }
  }
  @keyframes bottombar-x {
    0% {
      bottom: 0px;
      transform: rotate(0deg);
    }
    45% {
      bottom: 6px;
      transform: rotate(-145deg);
    }
    75% {
      transform: rotate(-130deg);
    }
    100% {
      transform: rotate(-135deg);
    }
  }
  @keyframes bottombar-back {
    0% {
      bottom: 6px;
      transform: rotate(-135deg);
    }
    45% {
      transform: rotate(10deg);
    }
    75% {
      transform: rotate(-5deg);
    }
    100% {
      bottom: 0px;
      transform: rotate(0);
    }
  }
  @keyframes fadeIn {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
  .dropdown-menu .divider {
    background-color: rgba(229, 229, 229, 0.15);
  }
  .navbar-nav {
    margin: 1px 0;
  }
  .navbar-nav .show .dropdown-menu .nav-item .nav-link {
    padding: 10px 15px 10px 60px;
  }
  [class*=navbar-] .navbar-nav > li > a,
  [class*=navbar-] .navbar-nav > li > a:hover,
  [class*=navbar-] .navbar-nav > li > a:focus,
  [class*=navbar-] .navbar-nav .active > a,
  [class*=navbar-] .navbar-nav .active > a:hover,
  [class*=navbar-] .navbar-nav .active > a:focus,
  [class*=navbar-] .navbar-nav .show .dropdown-menu > li > a,
  [class*=navbar-] .navbar-nav .show .dropdown-menu > li > a:hover,
  [class*=navbar-] .navbar-nav .show .dropdown-menu > li > a:focus,
  [class*=navbar-] .navbar-nav .show .dropdown-menu > li > a:active {
    color: white;
  }
  [class*=navbar-] .navbar-nav > li > a,
  [class*=navbar-] .navbar-nav > li > a:hover,
  [class*=navbar-] .navbar-nav > li > a:focus {
    opacity: 0.7;
    background-color: transparent;
    outline: none;
  }
  [class*=navbar-] .navbar-nav .show .dropdown-menu > li > a:hover,
  [class*=navbar-] .navbar-nav .show .dropdown-menu > li > a:focus {
    background-color: rgba(255, 255, 255, 0.1);
  }
  [class*=navbar-] .navbar-nav.navbar-nav .show .dropdown-menu > li > a:active {
    opacity: 1;
  }
  [class*=navbar-] .navbar-nav .dropdown > a:hover .caret {
    border-bottom-color: #fff;
    border-top-color: #fff;
  }
  [class*=navbar-] .navbar-nav .dropdown > a:active .caret {
    border-bottom-color: white;
    border-top-color: white;
  }
  .dropdown-menu {
    display: none;
  }
  .navbar-fixed-top {
    -webkit-backface-visibility: hidden;
  }
  #bodyClick {
    height: 100%;
    width: 100%;
    position: fixed;
    opacity: 0;
    top: 0;
    left: auto;
    right: 250px;
    content: "";
    z-index: 9999;
    overflow-x: hidden;
  }
  .social-line .btn {
    margin: 0 0 10px 0;
  }
  .subscribe-line .form-control {
    margin: 0 0 10px 0;
  }
  .social-line.pull-right {
    float: none;
  }
  .social-area.pull-right {
    float: none !important;
  }
  .form-control + .form-control-feedback {
    margin-top: -8px;
  }
  .navbar-toggle:hover, .navbar-toggle:focus {
    background-color: transparent !important;
  }
  .btn.dropdown-toggle {
    margin-bottom: 0;
  }
  .media-post .author {
    width: 20%;
    float: none !important;
    display: block;
    margin: 0 auto 10px;
  }
  .media-post .media-body {
    width: 100%;
  }
  .navbar-collapse.collapse.in {
    display: block;
  }
  .navbar-header .collapse, .navbar-toggle {
    display: block !important;
  }
  .navbar-header {
    float: none;
  }
  .navbar-nav .show .dropdown-menu {
    position: static;
    float: none;
    width: auto;
    margin-top: 0;
    background-color: transparent;
    border: 0;
    box-shadow: none;
  }
  .navbar-collapse .navbar-nav p {
    line-height: 40px !important;
    margin: 0;
  }
  .navbar-collapse [class^=pe-7s-] {
    float: left;
    font-size: 20px;
    margin-right: 10px;
  }
}
@media (min-width: 992px) {
  .table-full-width {
    margin-left: -15px;
    margin-right: -15px;
  }
  .table-responsive {
    overflow: visible;
  }
}
@media (max-width: 991px) {
  .table-responsive {
    width: 100%;
    margin-bottom: 15px;
    overflow-x: scroll;
    overflow-y: hidden;
    -ms-overflow-style: -ms-autohiding-scrollbar;
    -webkit-overflow-scrolling: touch;
  }
  .close-layer {
    height: 100%;
    width: 100%;
    position: absolute;
    opacity: 0;
    top: 0;
    left: auto;
    content: "";
    z-index: 9999;
    overflow-x: hidden;
    background-color: rgba(0, 0, 0, 0.35);
    transition: all 370ms ease-in;
  }
  .close-layer.visible {
    opacity: 1;
  }
}
@media (max-width: 768px) {
  .main-panel .navbar.navbar-fixed {
    width: 100% !important;
  }
  .main-panel .typo-line {
    padding-left: 80px;
  }
  .main-panel .slider-success.noUi-target {
    margin-bottom: 15px;
  }
  .card .card-body .control-label {
    text-align: left;
  }
}
.bootstrap-switch {
  display: inline-block;
  direction: ltr;
  cursor: pointer;
  border-radius: 30px;
  border: 0;
  position: relative;
  text-align: left;
  overflow: hidden;
  margin-bottom: 5px;
  line-height: 8px;
  width: 61px !important;
  height: 26px;
  outline: none;
  z-index: 0;
  margin-right: 1px;
  -webkit-user-select: none;
  user-select: none;
  vertical-align: middle;
  transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
}

.bootstrap-switch .bootstrap-switch-container {
  display: inline-flex;
  top: 0;
  height: 26px;
  border-radius: 4px;
  transform: translate3d(0, 0, 0);
  width: 100px !important;
}

.bootstrap-switch .bootstrap-switch-handle-on,
.bootstrap-switch .bootstrap-switch-handle-off,
.bootstrap-switch .bootstrap-switch-label {
  box-sizing: border-box;
  cursor: pointer;
  display: inline-block !important;
  height: 100%;
  color: #fff;
  padding: 6px 10px;
  font-size: 11px;
  text-indent: -5px;
  line-height: 15px;
  transition: 0.25s ease-out;
}
.bootstrap-switch .bootstrap-switch-handle-on i,
.bootstrap-switch .bootstrap-switch-handle-off i,
.bootstrap-switch .bootstrap-switch-label i {
  font-size: 12px;
  line-height: 14px;
}

.bootstrap-switch .bootstrap-switch-handle-on,
.bootstrap-switch .bootstrap-switch-handle-off {
  text-align: center;
  z-index: 1;
  float: left;
  width: 50% !important;
  background-color: #003380;
}

.bootstrap-switch .bootstrap-switch-label {
  text-align: center;
  z-index: 100;
  color: #333333;
  background: #ffffff;
  width: 22px !important;
  height: 22px;
  margin: 2px -11px;
  border-radius: 12px;
  position: relative;
  float: left;
  padding: 0;
  background-color: #FFFFFF;
  box-shadow: 0 1px 1px #FFFFFF inset, 0 1px 1px rgba(0, 0, 0, 0.25);
}

.bootstrap-switch .bootstrap-switch-handle-on {
  border-bottom-left-radius: 3px;
  border-top-left-radius: 3px;
}

.bootstrap-switch .bootstrap-switch-handle-off {
  text-indent: 6px;
}

.bootstrap-switch input[type=radio],
.bootstrap-switch input[type=checkbox] {
  position: absolute !important;
  top: 0;
  left: 0;
  opacity: 0;
  filter: alpha(opacity=0);
  z-index: -1;
}

.bootstrap-switch.bootstrap-switch-animate .bootstrap-switch-container {
  transition: margin-left 0.5s;
}

.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-container {
  margin-left: -2px !important;
}

.bootstrap-switch.bootstrap-switch-off .bootstrap-switch-container {
  margin-left: -37px !important;
}

.bootstrap-switch.bootstrap-switch-on:hover .bootstrap-switch-label {
  width: 26px !important;
  margin: 2px -15px;
}

.bootstrap-switch.bootstrap-switch-off:hover .bootstrap-switch-label {
  width: 26px !important;
  margin: 2px -15px -13px -11px;
}

.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-danger {
  background-color: #D61F05;
}

.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-warning {
  background-color: #FFE200;
}

.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-success {
  background-color: #7ABA09;
}

.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-primary {
  background-color: #003380;
}

.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-info {
  background-color: #0084CA;
}

.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-default {
  background-color: #58595B;
}

.bootstrap-switch.bootstrap-switch-off .bootstrap-switch-danger,
.bootstrap-switch.bootstrap-switch-off .bootstrap-switch-primary,
.bootstrap-switch.bootstrap-switch-off .bootstrap-switch-info,
.bootstrap-switch.bootstrap-switch-off .bootstrap-switch-warning,
.bootstrap-switch.bootstrap-switch-off .bootstrap-switch-success {
  background-color: #cfcfca;
}

/*--------------------------------

nucleo-icons Web Font - built using nucleoapp.com
License - nucleoapp.com/license/

-------------------------------- */
@font-face {
  font-family: "nucleo-icons";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format("svg");
  font-weight: normal;
  font-style: normal;
}
/*------------------------
	base class definition
-------------------------*/
.nc-icon {
  display: inline-block;
  font: normal normal normal 14px/1 "nucleo-icons";
  font-size: inherit;
  speak: none;
  text-transform: none;
  /* Better Font Rendering */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.nc-icon.icon-bold {
  font-weight: 700;
}

/*------------------------
  change icon size
-------------------------*/
.nc-icon.lg {
  font-size: 1.33333333em;
  vertical-align: -16%;
}

.nc-icon.x2 {
  font-size: 2em;
}

.nc-icon.x3 {
  font-size: 3em;
}

/*----------------------------------
  add a square/circle background
-----------------------------------*/
.nc-icon.square,
.nc-icon.circle {
  padding: 0.33333333em;
  vertical-align: -16%;
  background-color: #eee;
}

.nc-icon.circle {
  border-radius: 50%;
}

/*------------------------
  list icons
-------------------------*/
.nc-icon-ul {
  padding-left: 0;
  margin-left: 2.14285714em;
  list-style-type: none;
}

.nc-icon-ul > li {
  position: relative;
}

.nc-icon-ul > li > .nc-icon {
  position: absolute;
  left: -1.57142857em;
  top: 0.14285714em;
  text-align: center;
}

.nc-icon-ul > li > .nc-icon.lg {
  top: 0;
  left: -1.35714286em;
}

.nc-icon-ul > li > .nc-icon.circle,
.nc-icon-ul > li > .nc-icon.square {
  top: -0.19047619em;
  left: -1.9047619em;
}

.all-icons .font-icon-list .font-icon-detail i {
  font-size: 32px;
}

/*------------------------
  spinning icons
-------------------------*/
.nc-icon.spin {
  animation: nc-icon-spin 2s infinite linear;
}
@keyframes nc-icon-spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
/*------------------------
  rotated/flipped icons
-------------------------*/
.nc-icon.rotate-90 {
  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=1);
  transform: rotate(90deg);
}

.nc-icon.rotate-180 {
  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=2);
  transform: rotate(180deg);
}

.nc-icon.rotate-270 {
  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=3);
  transform: rotate(270deg);
}

.nc-icon.flip-y {
  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=0);
  transform: scale(-1, 1);
}

.nc-icon.flip-x {
  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=2);
  transform: scale(1, -1);
}

/*------------------------
	font icons
-------------------------*/
.nc-air-baloon::before {
  content: "\\ea01";
}

.nc-album-2::before {
  content: "\\ea02";
}

.nc-alien-33::before {
  content: "\\ea03";
}

.nc-align-center::before {
  content: "\\ea04";
}

.nc-align-left-2::before {
  content: "\\ea05";
}

.nc-ambulance::before {
  content: "\\ea06";
}

.nc-android::before {
  content: "\\ea07";
}

.nc-app::before {
  content: "\\ea08";
}

.nc-apple::before {
  content: "\\ea09";
}

.nc-atom::before {
  content: "\\ea0a";
}

.nc-attach-87::before {
  content: "\\ea0b";
}

.nc-audio-92::before {
  content: "\\ea0c";
}

.nc-backpack::before {
  content: "\\ea0d";
}

.nc-badge::before {
  content: "\\ea0e";
}

.nc-bag::before {
  content: "\\ea0f";
}

.nc-bank::before {
  content: "\\ea10";
}

.nc-battery-81::before {
  content: "\\ea11";
}

.nc-bell-55::before {
  content: "\\ea12";
}

.nc-bold::before {
  content: "\\ea13";
}

.nc-bulb-63::before {
  content: "\\ea14";
}

.nc-bullet-list-67::before {
  content: "\\ea15";
}

.nc-bus-front-12::before {
  content: "\\ea16";
}

.nc-button-pause::before {
  content: "\\ea17";
}

.nc-button-play::before {
  content: "\\ea18";
}

.nc-button-power::before {
  content: "\\ea19";
}

.nc-camera-20::before {
  content: "\\ea1a";
}

.nc-caps-small::before {
  content: "\\ea1b";
}

.nc-cart-simple::before {
  content: "\\ea1c";
}

.nc-cctv::before {
  content: "\\ea1d";
}

.nc-chart-bar-32::before {
  content: "\\ea1e";
}

.nc-chart-pie-35::before {
  content: "\\ea1f";
}

.nc-chart-pie-36::before {
  content: "\\ea20";
}

.nc-chart::before {
  content: "\\ea21";
}

.nc-chat-round::before {
  content: "\\ea22";
}

.nc-check-2::before {
  content: "\\ea23";
}

.nc-circle-09::before {
  content: "\\ea24";
}

.nc-circle::before {
  content: "\\ea25";
}

.nc-cloud-download-93::before {
  content: "\\ea26";
}

.nc-cloud-upload-94::before {
  content: "\\ea27";
}

.nc-compass-05::before {
  content: "\\ea28";
}

.nc-controller-modern::before {
  content: "\\ea29";
}

.nc-credit-card::before {
  content: "\\ea2a";
}

.nc-delivery-fast::before {
  content: "\\ea2b";
}

.nc-email-83::before {
  content: "\\ea2c";
}

.nc-email-85::before {
  content: "\\ea2d";
}

.nc-explore-2::before {
  content: "\\ea2e";
}

.nc-fav-remove::before {
  content: "\\ea2f";
}

.nc-favourite-28::before {
  content: "\\ea30";
}

.nc-globe-2::before {
  content: "\\ea31";
}

.nc-grid-45::before {
  content: "\\ea32";
}

.nc-headphones-2::before {
  content: "\\ea33";
}

.nc-html5::before {
  content: "\\ea34";
}

.nc-istanbul::before {
  content: "\\ea35";
}

.nc-key-25::before {
  content: "\\ea36";
}

.nc-layers-3::before {
  content: "\\ea37";
}

.nc-light-3::before {
  content: "\\ea38";
}

.nc-lock-circle-open::before {
  content: "\\ea39";
}

.nc-map-big::before {
  content: "\\ea3a";
}

.nc-mobile::before {
  content: "\\ea3c";
}

.nc-money-coins::before {
  content: "\\ea3b";
}

.nc-note-03::before {
  content: "\\ea3d";
}

.nc-notes::before {
  content: "\\ea3e";
}

.nc-notification-70::before {
  content: "\\ea3f";
}

.nc-palette::before {
  content: "\\ea40";
}

.nc-paper-2::before {
  content: "\\ea41";
}

.nc-pin-3::before {
  content: "\\ea42";
}

.nc-planet::before {
  content: "\\ea43";
}

.nc-preferences-circle-rotate::before {
  content: "\\ea44";
}

.nc-puzzle-10::before {
  content: "\\ea45";
}

.nc-quote::before {
  content: "\\ea46";
}

.nc-refresh-02::before {
  content: "\\ea47";
}

.nc-ruler-pencil::before {
  content: "\\ea48";
}

.nc-satisfied::before {
  content: "\\ea49";
}

.nc-scissors::before {
  content: "\\ea4a";
}

.nc-send::before {
  content: "\\ea4b";
}

.nc-settings-90::before {
  content: "\\ea4c";
}

.nc-settings-gear-64::before {
  content: "\\ea4d";
}

.nc-settings-tool-66::before {
  content: "\\ea4e";
}

.nc-simple-add::before {
  content: "\\ea4f";
}

.nc-simple-delete::before {
  content: "\\ea50";
}

.nc-simple-remove::before {
  content: "\\ea51";
}

.nc-single-02::before {
  content: "\\ea52";
}

.nc-single-copy-04::before {
  content: "\\ea53";
}

.nc-spaceship::before {
  content: "\\ea54";
}

.nc-square-pin::before {
  content: "\\ea55";
}

.nc-stre-down::before {
  content: "\\ea56";
}

.nc-stre-left::before {
  content: "\\ea57";
}

.nc-stre-right::before {
  content: "\\ea58";
}

.nc-stre-up::before {
  content: "\\ea59";
}

.nc-sun-fog-29::before {
  content: "\\ea5a";
}

.nc-support-17::before {
  content: "\\ea5b";
}

.nc-tablet-2::before {
  content: "\\ea5c";
}

.nc-tag-content::before {
  content: "\\ea5d";
}

.nc-tap-01::before {
  content: "\\ea5e";
}

.nc-time-alarm::before {
  content: "\\ea5f";
}

.nc-tv-2::before {
  content: "\\ea60";
}

.nc-umbrella-13::before {
  content: "\\ea61";
}

.nc-vector::before {
  content: "\\ea62";
}

.nc-watch-time::before {
  content: "\\ea63";
}

.nc-zoom-split::before {
  content: "\\ea64";
}

/* all icon font classes list here */
/*!
Animate.css - http://daneden.me/animate
Licensed under the MIT license - http://opensource.org/licenses/MIT

Copyright (c) 2015 Daniel Eden
*/
.animated {
  animation-duration: 1s;
  animation-fill-mode: both;
}

.animated.infinite {
  animation-iteration-count: infinite;
}

.animated.hinge {
  animation-duration: 2s;
}

.animated.bounceIn,
.animated.bounceOut {
  animation-duration: 0.75s;
}

.animated.flipOutX,
.animated.flipOutY {
  animation-duration: 0.75s;
}
@keyframes shake {
  from, to {
    transform: translate3d(0, 0, 0);
  }
  10%, 30%, 50%, 70%, 90% {
    transform: translate3d(-10px, 0, 0);
  }
  20%, 40%, 60%, 80% {
    transform: translate3d(10px, 0, 0);
  }
}
.shake {
  animation-name: shake;
}
@keyframes fadeInDown {
  from {
    opacity: 0;
    transform: translate3d(0, -100%, 0);
  }
  to {
    opacity: 1;
    transform: none;
  }
}
.fadeInDown {
  animation-name: fadeInDown;
}
@keyframes fadeOut {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
}
.fadeOut {
  animation-name: fadeOut;
}
@keyframes fadeOutDown {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
    transform: translate3d(0, 100%, 0);
  }
}
.fadeOutDown {
  animation-name: fadeOutDown;
}
@keyframes fadeOutUp {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
    transform: translate3d(0, -100%, 0);
  }
}
.fadeOutUp {
  animation-name: fadeOutUp;
}

.sweet-overlay {
  background-color: rgba(0, 0, 0, 0.4);
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  display: none;
  z-index: 1000;
}

.sweet-alert {
  background-color: #fff;
  font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
  border-radius: 5px;
  box-sizing: border-box;
  text-align: center;
  position: fixed;
  left: 50%;
  top: 50%;
  margin-top: -200px;
  max-height: 90%;
  overflow-x: hidden;
  overflow-y: auto;
  display: none;
  z-index: 2000;
}
.sweet-alert:focus {
  outline: 0;
}
.sweet-alert button {
  margin: 0 5px;
}
.sweet-alert .form-control {
  max-width: 300px;
  margin: 0 auto;
}

.sweet-alert h2 {
  color: #575757;
  text-align: center;
  text-transform: none;
  position: relative;
  padding: 0;
  display: block;
}

.sweet-alert p {
  text-align: center;
  position: relative;
  float: none;
  margin: 0;
  padding: 0;
}

.sweet-alert hr {
  height: 5px;
  color: transparent;
  border: 0;
}

.sweet-alert button.styled {
  color: #fff;
  border: 0;
  box-shadow: none;
  font-size: 17px;
  font-weight: 500;
  border-radius: 5px;
  padding: 10px 32px;
  margin: 0 5px;
  cursor: pointer;
}

.sweet-alert button.styled:focus {
  outline: none;
}

.sweet-alert button.styled.sweet-cancel[disabled] {
  opacity: 0.4;
}

.sweet-alert button.styled.sweet-confirm[disabled] {
  border: 4px solid transparent;
  border-color: transparent;
  width: 40px;
  height: 40px;
  padding: 0;
  margin: 0 30px;
  vertical-align: middle;
  background-color: transparent !important;
  color: transparent;
  cursor: default;
  border-radius: 100%;
  animation: rotate-loading 1.5s linear 0s infinite normal;
}

.sweet-alert button.styled::-moz-focus-inner {
  border: 0;
}

.sweet-alert[data-has-cancel-button=false] button {
  box-shadow: none !important;
}

.sweet-alert .icon {
  width: 80px;
  height: 80px;
  border: 4px solid #808080;
  border-radius: 50%;
  margin: 20px auto;
  padding: 0;
  position: relative;
  box-sizing: content-box;
}

.sweet-alert .icon.error {
  border-color: #f27474;
}

.sweet-alert .icon.error .x-mark {
  position: relative;
  display: block;
}

.sweet-alert .icon.error .line {
  position: absolute;
  height: 5px;
  width: 47px;
  display: block;
  top: 37px;
  border-radius: 2px;
}

.sweet-alert .icon.error .line.left {
  transform: rotate(45deg);
  left: 17px;
}

.sweet-alert .icon.error .line.right {
  transform: rotate(-45deg);
  right: 16px;
}

.sweet-alert .icon.warning {
  border-color: #f8bb86;
}

.sweet-alert .icon.warning .body {
  position: absolute;
  width: 5px;
  height: 47px;
  left: 50%;
  top: 10px;
  border-radius: 2px;
  margin-left: -2px;
  background-color: #f8bb86;
}

.sweet-alert .icon.warning .dot {
  position: absolute;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  margin-left: -3px;
  left: 50%;
  bottom: 10px;
  background-color: #f8bb86;
}

.sweet-alert .icon.info {
  border-color: #c9dae1;
}

.sweet-alert .icon.info::before {
  content: "";
  position: absolute;
  width: 5px;
  height: 29px;
  left: 50%;
  bottom: 17px;
  border-radius: 2px;
  margin-left: -2px;
  background-color: #c9dae1;
}

.sweet-alert .icon.info::after {
  content: "";
  position: absolute;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  margin-left: -3px;
  top: 19px;
  background-color: #c9dae1;
}

.sweet-alert .icon.success {
  border-color: #a5dc86;
}

.sweet-alert .icon.success::before, .sweet-alert .icon.success::after {
  content: "";
  border-radius: 50%;
  position: absolute;
  width: 60px;
  height: 120px;
  background: #fff;
  transform: rotate(45deg);
}

.sweet-alert .icon.success::before {
  border-radius: 120px 0 0 120px;
  top: -7px;
  left: -33px;
  transform: rotate(-45deg);
  transform-origin: 60px 60px;
}

.sweet-alert .icon.success::after {
  border-radius: 0 120px 120px 0;
  top: -11px;
  left: 30px;
  transform: rotate(-45deg);
  transform-origin: 0 60px;
}

.sweet-alert .icon.success .placeholder {
  width: 80px;
  height: 80px;
  border: 4px solid rgba(165, 220, 134, 0.2);
  border-radius: 50%;
  box-sizing: content-box;
  position: absolute;
  left: -4px;
  top: -4px;
  z-index: 2;
}

.sweet-alert .icon.success .fix {
  width: 5px;
  height: 90px;
  background-color: #fff;
  position: absolute;
  left: 28px;
  top: 8px;
  z-index: 1;
  transform: rotate(-45deg);
}

.sweet-alert .icon.success .line {
  height: 5px;
  background-color: #7ABA09;
  display: block;
  border-radius: 2px;
  position: absolute;
  z-index: 2;
}

.sweet-alert .icon.success .line.tip {
  width: 25px;
  left: 14px;
  top: 46px;
  transform: rotate(45deg);
}

.sweet-alert .icon.success .line.long {
  width: 47px;
  right: 8px;
  top: 38px;
  transform: rotate(-45deg);
}

.sweet-alert .sweet-image {
  margin: 20px auto;
}
@keyframes showSweetAlert {
  0% {
    transform: scale(0.7);
  }
  45% {
    transform: scale(1.05);
  }
  80% {
    transform: scale(0.95);
  }
  100% {
    transform: scale(1);
  }
}
@keyframes hideSweetAlert {
  0% {
    transform: scale(1);
  }
  100% {
    transform: scale(0.5);
  }
}
.show-sweet-alert {
  animation: showSweetAlert 0.3s;
}

.show-sweet-alert.no-animation {
  animation: none;
}

.hide-sweet-alert {
  animation: hideSweetAlert 0.2s;
}

.hide-sweet-alert.no-animation {
  animation: none;
}
@keyframes animate-success-tip {
  0% {
    width: 0;
    left: 1px;
    top: 19px;
  }
  54% {
    width: 0;
    left: 1px;
    top: 19px;
  }
  70% {
    width: 50px;
    left: -8px;
    top: 37px;
  }
  84% {
    width: 17px;
    left: 21px;
    top: 48px;
  }
  100% {
    width: 25px;
    left: 14px;
    top: 45px;
  }
}
@keyframes animate-success-long {
  0% {
    width: 0;
    right: 46px;
    top: 54px;
  }
  65% {
    width: 0;
    right: 46px;
    top: 54px;
  }
  84% {
    width: 55px;
    right: 0;
    top: 35px;
  }
  100% {
    width: 47px;
    right: 8px;
    top: 38px;
  }
}
@keyframes rotatePlaceholder {
  0% {
    transform: rotate(-45deg);
  }
  5% {
    transform: rotate(-45deg);
  }
  12% {
    transform: rotate(-405deg);
  }
  100% {
    transform: rotate(-405deg);
  }
}
.animate-success-tip {
  animation: animate-success-tip 0.75s;
}

.animate-success-long {
  animation: animate-success-long 0.75s;
}

.icon.success.animate::after {
  animation: rotatePlaceholder 4.25s ease-in;
}
@keyframes animate-error-icon {
  0% {
    transform: rotateX(100deg);
    opacity: 0;
  }
  100% {
    transform: rotateX(0deg);
    opacity: 1;
  }
}
.animate-error-icon {
  animation: animate-error-icon 0.5s;
}
@keyframes animate-x-mark {
  0% {
    transform: scale(0.4);
    margin-top: 26px;
    opacity: 0;
  }
  50% {
    transform: scale(0.4);
    margin-top: 26px;
    opacity: 0;
  }
  80% {
    transform: scale(1.15);
    margin-top: -6px;
  }
  100% {
    transform: scale(1);
    margin-top: 0;
    opacity: 1;
  }
}
.animate-x-mark {
  animation: animate-x-mark 0.5s;
}
@keyframes pulse-warning {
  0% {
    border-color: #f8d486;
  }
  100% {
    border-color: #f8bb86;
  }
}
.pulse-warning {
  animation: pulse-warning 0.75s infinite alternate;
}
@keyframes pulse-warning-ins {
  0% {
    background-color: #f8d486;
  }
  100% {
    background-color: #f8bb86;
  }
}
.pulse-warning-ins {
  animation: pulse-warning-ins 0.75s infinite alternate;
}
@keyframes rotate-loading {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
svg {
  touch-action: none;
}

.jvectormap-container {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
  touch-action: none;
}

.jvectormap-tip {
  position: absolute;
  display: none;
  border: solid 1px #CDCDCD;
  border-radius: 3px;
  background: #292929;
  color: white;
  font-family: sans-serif, Verdana;
  font-size: smaller;
  padding: 3px;
}

.jvectormap-zoomin, .jvectormap-zoomout, .jvectormap-goback {
  position: absolute;
  left: 10px;
  border-radius: 3px;
  background: #292929;
  padding: 3px;
  color: white;
  cursor: pointer;
  line-height: 10px;
  text-align: center;
  box-sizing: content-box;
}

.jvectormap-zoomin, .jvectormap-zoomout {
  width: 10px;
  height: 10px;
}

.jvectormap-zoomin {
  top: 10px;
}

.jvectormap-zoomout {
  top: 30px;
}

.jvectormap-goback {
  bottom: 10px;
  z-index: 1000;
  padding: 6px;
}

.jvectormap-spinner {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  background: center no-repeat url(${___CSS_LOADER_URL_REPLACEMENT_7___});
}

.jvectormap-legend-title {
  font-weight: bold;
  font-size: 14px;
  text-align: center;
}

.jvectormap-legend-cnt {
  position: absolute;
}

.jvectormap-legend-cnt-h {
  bottom: 0;
  right: 0;
}

.jvectormap-legend-cnt-v {
  top: 0;
  right: 0;
}

.jvectormap-legend {
  background: black;
  color: white;
  border-radius: 3px;
}

.jvectormap-legend-cnt-h .jvectormap-legend {
  float: left;
  margin: 0 10px 10px 0;
  padding: 3px 3px 1px 3px;
}

.jvectormap-legend-cnt-h .jvectormap-legend .jvectormap-legend-tick {
  float: left;
}

.jvectormap-legend-cnt-v .jvectormap-legend {
  margin: 10px 10px 0 0;
  padding: 3px;
}

.jvectormap-legend-cnt-h .jvectormap-legend-tick {
  width: 40px;
}

.jvectormap-legend-cnt-h .jvectormap-legend-tick-sample {
  height: 15px;
}

.jvectormap-legend-cnt-v .jvectormap-legend-tick-sample {
  height: 20px;
  width: 20px;
  display: inline-block;
  vertical-align: middle;
}

.jvectormap-legend-tick-text {
  font-size: 12px;
}

.jvectormap-legend-cnt-h .jvectormap-legend-tick-text {
  text-align: center;
}

.jvectormap-legend-cnt-v .jvectormap-legend-tick-text {
  display: inline-block;
  vertical-align: middle;
  line-height: 20px;
  padding-left: 3px;
}

/**
 * @author zhixin wen <wenzhixin2010@gmail.com>
 * version: 1.8.1
 * https://github.com/wenzhixin/bootstrap-table/
 */
.bootstrap-table .table {
  margin-bottom: 0 !important;
  border-bottom: 1px solid #dddddd;
  border-collapse: collapse !important;
  border-radius: 1px;
}

.bootstrap-table .table,
.bootstrap-table .table > tbody > tr > th,
.bootstrap-table .table > tfoot > tr > th,
.bootstrap-table .table > thead > tr > td,
.bootstrap-table .table > tbody > tr > td,
.bootstrap-table .table > tfoot > tr > td {
  padding: 8px !important;
}

.bootstrap-table .table > tbody > .selected {
  background-color: #CEEEFF;
}

.bootstrap-table .table.table-no-bordered > thead > tr > th,
.bootstrap-table .table.table-no-bordered > tbody > tr > td {
  border-right: 2px solid transparent;
}

.fixed-table-container {
  position: relative;
  clear: both;
}

.fixed-table-container.table-no-bordered {
  border: 1px solid transparent;
}

.fixed-table-footer,
.fixed-table-header {
  overflow: hidden;
}

.fixed-table-footer {
  border-top: 1px solid #dddddd;
}

.fixed-table-body {
  height: 100%;
  overflow: auto;
}

.fixed-table-container table {
  width: 100%;
}

.fixed-table-container thead th {
  height: 0;
  padding: 0;
  margin: 0;
}

.fixed-table-container thead th:first-child {
  border-left: none;
}

.fixed-table-container thead th .th-inner {
  padding: 0 8px;
  line-height: 24px;
  vertical-align: top;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.fixed-table-container thead th .sortable {
  cursor: pointer;
  background-repeat: no-repeat;
  padding-right: 30px;
}

.fixed-table-container thead th .both {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  background-position: right 2px;
}

.fixed-table-container thead th .asc {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
  background-position: right 5px;
}

.fixed-table-container thead th .desc {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
  background-position: right 0px;
}

.fixed-table-container th.detail {
  width: 30px;
}

.fixed-table-container tbody tr:first-child td {
  border-top: none;
}

.fixed-table-container tbody td:first-child {
  border-left: none;
}

/* the same color with .active */
.fixed-table-container tbody .selected td {
  background-color: rgba(245, 245, 245, 0.34);
}

.fixed-table-container .bs-checkbox {
  text-align: center;
}

.fixed-table-container .bs-checkbox .th-inner {
  padding: 8px 0;
}

.fixed-table-container input[type=radio],
.fixed-table-container input[type=checkbox] {
  margin: 0 auto !important;
  cursor: pointer;
}

.fixed-table-container .no-records-found {
  text-align: center;
  background-color: #FFFFFF !important;
  height: 340px;
  border-radius: 10px;
  width: 100%;
  vertical-align: middle;
}

.fixed-table-container .no-records-found td {
  font-weight: 300;
  font-size: 1.375rem;
}

.fixed-table-pagination div.pagination,
.fixed-table-pagination .pagination-detail {
  margin-top: 10px;
  margin-bottom: 10px;
}

.fixed-table-pagination div.pagination .pagination {
  margin: 0;
}

.fixed-table-pagination .pagination a {
  padding: 6px 12px;
  line-height: 1.428571429;
}

.fixed-table-pagination .pagination-info {
  line-height: 34px;
  margin-right: 5px;
}

.fixed-table-pagination .btn-group {
  position: relative;
  display: inline-block;
  vertical-align: middle;
}

.fixed-table-pagination .page-list {
  display: inline-block;
}

.fixed-table-toolbar {
  padding: 5px 15px;
}

.fixed-table-toolbar .columns-left {
  margin-right: 5px;
}

.fixed-table-toolbar .columns-right {
  margin-left: 5px;
}

.fixed-table-toolbar .columns .btn {
  margin: 0 2px;
  border-radius: 30px;
}

.fixed-table-toolbar .columns label {
  display: block;
  padding: 10px 20px;
  border-bottom: 1px solid #eee;
  clear: both;
  margin-bottom: 0;
  font-weight: normal;
  line-height: 1.428571429;
}

.fixed-table-toolbar .columns li:last-child label {
  border-bottom: none;
}

.fixed-table-toolbar .bars,
.fixed-table-toolbar .search,
.fixed-table-toolbar .columns {
  position: relative;
  margin-top: 10px;
  margin-bottom: 10px;
  line-height: 34px;
}

.fixed-table-pagination li.disabled a {
  pointer-events: none;
  cursor: default;
}

.fixed-table-loading {
  display: none;
  position: absolute;
  top: 42px;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 99;
  background-color: #fff;
  text-align: center;
}

.fixed-table-body .card-view .title {
  font-weight: bold;
  display: inline-block;
  min-width: 30%;
  text-align: left !important;
}

/* support bootstrap 2 */
.fixed-table-body thead th .th-inner {
  box-sizing: border-box;
}

.table th, .table td {
  vertical-align: middle;
  box-sizing: border-box;
}

.fixed-table-toolbar .btn-group > .btn-group {
  display: inline-block;
  margin-left: -1px !important;
}

.fixed-table-toolbar .dropdown-menu label {
  cursor: pointer;
}

.fixed-table-toolbar .btn-group > .btn-group > .btn {
  border-radius: 0;
}

.fixed-table-toolbar .btn-group > .btn-group:first-child > .btn {
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}

.fixed-table-toolbar .btn-group > .btn-group:last-child > .btn {
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
}

/* support bootstrap 3 */
.bootstrap-table .table thead > tr > th {
  padding: 0;
  margin: 0;
}

.pull-right .dropdown-menu {
  right: 0;
  left: auto;
}

/* calculate scrollbar width */
p.fixed-table-scroll-inner {
  width: 100%;
  height: 200px;
}

div.fixed-table-scroll-outer {
  top: 0;
  left: 0;
  visibility: hidden;
  width: 200px;
  height: 150px;
  overflow: hidden;
}

.bootstrap-table .fixed-table-pagination {
  margin: 0 10px;
}
.bootstrap-table .fixed-table-pagination:after {
  display: table;
  content: "";
  clear: both;
}
.bootstrap-table .fixed-table-pagination .page-list .btn {
  border-radius: 30px;
}
.bootstrap-table .fixed-table-pagination .page-list .btn-group {
  margin-right: 5px;
}
.bootstrap-table .fixed-table-pagination div.pagination,
.bootstrap-table .fixed-table-pagination .pagination-detail {
  margin-top: 15px;
  margin-bottom: 15px;
}
.bootstrap-table .table.table-striped > thead > tr > td, .bootstrap-table .table.table-striped > tbody > tr > td, .bootstrap-table .table.table-striped > tfoot > tr > td {
  border: none;
}

table.dataTable {
  clear: both;
  margin-top: 6px !important;
  margin-bottom: 6px !important;
  max-width: none !important;
  border-collapse: separate !important;
}

table.dataTable td,
table.dataTable th {
  box-sizing: content-box;
}

table.dataTable td.dataTables_empty,
table.dataTable th.dataTables_empty {
  text-align: center;
}

table.dataTable.nowrap th,
table.dataTable.nowrap td {
  white-space: nowrap;
}

div.dataTables_wrapper div.dataTables_length label {
  font-weight: normal;
  text-align: left;
  white-space: nowrap;
}

div.dataTables_wrapper div.dataTables_length select {
  width: 75px;
  display: inline-block;
}

div.dataTables_wrapper div.dataTables_filter {
  text-align: right;
}

div.dataTables_wrapper div.dataTables_filter label {
  font-weight: normal;
  white-space: nowrap;
  text-align: left;
}

div.dataTables_wrapper div.dataTables_filter input {
  margin-left: 0.5em;
  display: inline-block;
  width: auto;
}

div.dataTables_wrapper div.dataTables_info {
  padding-top: 8px;
  white-space: nowrap;
}

div.dataTables_wrapper div.dataTables_paginate {
  margin: 0;
  white-space: nowrap;
  text-align: right;
}

div.dataTables_wrapper div.dataTables_paginate ul.pagination {
  margin: 2px 0;
  white-space: nowrap;
}

div.dataTables_wrapper div.dataTables_processing {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 200px;
  margin-left: -100px;
  margin-top: -26px;
  text-align: center;
  padding: 1em 0;
}

table.dataTable thead > tr > th.sorting_asc, table.dataTable thead > tr > th.sorting_desc, table.dataTable thead > tr > th.sorting,
table.dataTable thead > tr > td.sorting_asc,
table.dataTable thead > tr > td.sorting_desc,
table.dataTable thead > tr > td.sorting {
  padding-right: 30px;
}

table.dataTable thead > tr > th:active,
table.dataTable thead > tr > td:active {
  outline: none;
}

table.dataTable thead .sorting,
table.dataTable thead .sorting_asc,
table.dataTable thead .sorting_desc,
table.dataTable thead .sorting_asc_disabled,
table.dataTable thead .sorting_desc_disabled {
  cursor: pointer;
  position: relative;
}

table.dataTable thead .sorting:after,
table.dataTable thead .sorting_asc:after,
table.dataTable thead .sorting_desc:after,
table.dataTable thead .sorting_asc_disabled:after,
table.dataTable thead .sorting_desc_disabled:after {
  position: absolute;
  bottom: 8px;
  right: 8px;
  display: block;
  font-family: "Glyphicons Halflings";
  opacity: 0.5;
}

table.dataTable thead .sorting:after {
  opacity: 0.2;
  content: "\\e150";
  /* sort */
}

table.dataTable thead .sorting_asc:after {
  content: "\\e155";
  /* sort-by-attributes */
}

table.dataTable thead .sorting_desc:after {
  content: "\\e156";
  /* sort-by-attributes-alt */
}

table.dataTable thead .sorting_asc_disabled:after,
table.dataTable thead .sorting_desc_disabled:after {
  color: #eee;
}

div.dataTables_scrollHead table.dataTable {
  margin-bottom: 0 !important;
}

div.dataTables_scrollBody table {
  border-top: none;
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}

div.dataTables_scrollBody table thead .sorting:after,
div.dataTables_scrollBody table thead .sorting_asc:after,
div.dataTables_scrollBody table thead .sorting_desc:after {
  display: none;
}

div.dataTables_scrollBody table tbody tr:first-child th,
div.dataTables_scrollBody table tbody tr:first-child td {
  border-top: none;
}

div.dataTables_scrollFoot table {
  margin-top: 0 !important;
  border-top: none;
}

@media screen and (max-width: 767px) {
  div.dataTables_wrapper div.dataTables_length,
  div.dataTables_wrapper div.dataTables_filter,
  div.dataTables_wrapper div.dataTables_info,
  div.dataTables_wrapper div.dataTables_paginate {
    text-align: center;
  }
}
table.dataTable.table-condensed > thead > tr > th {
  padding-right: 20px;
}

table.dataTable.table-condensed .sorting:after,
table.dataTable.table-condensed .sorting_asc:after,
table.dataTable.table-condensed .sorting_desc:after {
  top: 6px;
  right: 6px;
}

table.table-bordered.dataTable th,
table.table-bordered.dataTable td {
  border-left-width: 0;
}

table.table-bordered.dataTable th:last-child, table.table-bordered.dataTable th:last-child,
table.table-bordered.dataTable td:last-child,
table.table-bordered.dataTable td:last-child {
  border-right-width: 0;
}

table.table-bordered.dataTable tbody th,
table.table-bordered.dataTable tbody td {
  border-bottom-width: 0;
}

div.dataTables_scrollHead table.table-bordered {
  border-bottom-width: 0;
}

div.table-responsive > div.dataTables_wrapper > div.row {
  margin: 0;
}

div.table-responsive > div.dataTables_wrapper > div.row > div[class^=col-]:first-child {
  padding-left: 0;
}

div.table-responsive > div.dataTables_wrapper > div.row > div[class^=col-]:last-child {
  padding-right: 0;
}

table.dataTable .btn-simple.btn-icon {
  padding: 3px;
}
table.dataTable thead .sorting:after,
table.dataTable thead .sorting_asc:after,
table.dataTable thead .sorting_desc:after,
table.dataTable thead .sorting_asc_disabled:after,
table.dataTable thead .sorting_desc_disabled:after {
  position: relative;
  display: inline-block;
  bottom: 0px;
  right: -7px;
  font-family: "FontAwesome";
  opacity: 0.8;
}
table.dataTable thead .disabled-sorting.sorting:after,
table.dataTable thead .disabled-sorting.sorting_asc:after,
table.dataTable thead .disabled-sorting.sorting_desc:after,
table.dataTable thead .disabled-sorting.sorting_asc_disabled:after,
table.dataTable thead .disabled-sorting.sorting_desc_disabled:after {
  display: none;
}
table.dataTable thead .sorting:after {
  opacity: 0.4;
  content: "\\f0dc";
}
table.dataTable thead .sorting_asc:after {
  content: "\\f0de";
  top: 3px;
}
table.dataTable thead .sorting_desc:after {
  content: "\\f0dd";
  top: -3px;
}
table.dataTable > thead > tr > th,
table.dataTable > tbody > tr > th,
table.dataTable > tfoot > tr > th,
table.dataTable > thead > tr > td,
table.dataTable > tbody > tr > td,
table.dataTable > tfoot > tr > td {
  padding: 8px !important;
  outline: 0;
}
table.dataTable > thead > tr > th {
  border: none;
}

.fresh-datatables .pagination > li > a,
.fresh-datatables .pagination > li:first-child > a,
.fresh-datatables .pagination > li:first-child > span,
.fresh-datatables .pagination > li:last-child > a,
.fresh-datatables .pagination > li:last-child > span {
  border-radius: 25px;
}

.dataTables_paginate a {
  outline: 0;
}

table.dataTable.dtr-inline.collapsed > tbody > tr > td.child,
table.dataTable.dtr-inline.collapsed > tbody > tr > th.child,
table.dataTable.dtr-inline.collapsed > tbody > tr > td.dataTables_empty {
  cursor: default !important;
}
table.dataTable.dtr-inline.collapsed > tbody > tr > td.child:before,
table.dataTable.dtr-inline.collapsed > tbody > tr > th.child:before,
table.dataTable.dtr-inline.collapsed > tbody > tr > td.dataTables_empty:before {
  display: none !important;
}
table.dataTable.dtr-inline.collapsed > tbody > tr > td:first-child,
table.dataTable.dtr-inline.collapsed > tbody > tr > th:first-child {
  position: relative;
  padding-left: 30px !important;
  cursor: pointer;
}
table.dataTable.dtr-inline.collapsed > tbody > tr > td:first-child:before,
table.dataTable.dtr-inline.collapsed > tbody > tr > th:first-child:before {
  top: 50%;
  margin-top: -9px;
  left: 4px;
  height: 18px;
  width: 18px;
  display: block;
  position: absolute;
  color: #518607;
  border: 0px solid white;
  border-radius: 14px;
  box-shadow: 0 0 3px #444;
  box-sizing: content-box;
  text-align: center;
  font-family: "Courier New", Courier, monospace;
  line-height: 18px;
  content: "+";
  background-color: #FFF;
}
table.dataTable.dtr-inline.collapsed > tbody > tr.parent > td:first-child:before,
table.dataTable.dtr-inline.collapsed > tbody > tr.parent > th:first-child:before {
  content: "-";
  color: #ED362C;
}
table.dataTable.dtr-inline.collapsed > tbody > tr.child td:before {
  display: none;
}

table.dataTable.dtr-inline.collapsed.compact > tbody > tr > td:first-child,
table.dataTable.dtr-inline.collapsed.compact > tbody > tr > th:first-child {
  padding-left: 27px;
}
table.dataTable.dtr-inline.collapsed.compact > tbody > tr > td:first-child:before,
table.dataTable.dtr-inline.collapsed.compact > tbody > tr > th:first-child:before {
  top: 5px;
  left: 4px;
  height: 14px;
  width: 14px;
  border-radius: 14px;
  line-height: 14px;
  text-indent: 3px;
}

table.dataTable.dtr-column > tbody > tr > td.control,
table.dataTable.dtr-column > tbody > tr > th.control {
  position: relative;
  cursor: pointer;
}
table.dataTable.dtr-column > tbody > tr > td.control:before,
table.dataTable.dtr-column > tbody > tr > th.control:before {
  top: 50%;
  left: 50%;
  height: 16px;
  width: 16px;
  margin-top: -10px;
  margin-left: -10px;
  display: block;
  position: absolute;
  color: white;
  border: 2px solid white;
  border-radius: 14px;
  box-shadow: 0 0 3px #444;
  box-sizing: content-box;
  text-align: center;
  font-family: "Courier New", Courier, monospace;
  line-height: 14px;
  content: "+";
  background-color: #31b131;
}
table.dataTable.dtr-column > tbody > tr.parent td.control:before,
table.dataTable.dtr-column > tbody > tr.parent th.control:before {
  content: "-";
  background-color: #d33333;
}

table.dataTable > tbody > tr.child {
  padding: 0.5em 1em;
}
table.dataTable > tbody > tr.child:hover {
  background: transparent !important;
}
table.dataTable > tbody > tr.child ul {
  display: inline-block;
  list-style-type: none;
  margin: 0;
  padding: 0;
}
table.dataTable > tbody > tr.child ul li {
  border-bottom: 1px solid #efefef;
  padding: 0.5em 0;
}
table.dataTable > tbody > tr.child ul li:first-child {
  padding-top: 0;
}
table.dataTable > tbody > tr.child ul li:last-child {
  border-bottom: none;
}
table.dataTable > tbody > tr.child span.dtr-title {
  display: inline-block;
  min-width: 75px;
  font-weight: bold;
}

div.dtr-modal {
  position: fixed;
  box-sizing: border-box;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  z-index: 100;
  padding: 10em 1em;
}
div.dtr-modal div.dtr-modal-display {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 50%;
  height: 50%;
  overflow: auto;
  margin: auto;
  z-index: 102;
  overflow: auto;
  background-color: #f5f5f7;
  border: 1px solid black;
  border-radius: 0.5em;
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.6);
}
div.dtr-modal div.dtr-modal-content {
  position: relative;
  padding: 1em;
}
div.dtr-modal div.dtr-modal-close {
  position: absolute;
  top: 6px;
  right: 6px;
  width: 22px;
  height: 22px;
  border: 1px solid #eaeaea;
  background-color: #f9f9f9;
  text-align: center;
  border-radius: 3px;
  cursor: pointer;
  z-index: 12;
}
div.dtr-modal div.dtr-modal-close:hover {
  background-color: #eaeaea;
}
div.dtr-modal div.dtr-modal-background {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 101;
  background: rgba(0, 0, 0, 0.6);
}

.data-tables .pagination .paginate_button.page-item.first .page-link, .data-tables .pagination .paginate_button.page-item.previous .page-link, .data-tables .pagination .paginate_button.page-item.next .page-link, .data-tables .pagination .paginate_button.page-item.last .page-link {
  border-radius: 25px;
}

@media screen and (max-width: 767px) {
  div.dtr-modal div.dtr-modal-display {
    width: 95%;
  }
  .data-tables .pagination .paginate_button.page-item.first, .data-tables .pagination .paginate_button.page-item.last {
    display: none;
  }
}
/*!
 * FullCalendar v3.6.2 Stylesheet
 * Docs & License: https://fullcalendar.io/
 * (c) 2017 Adam Shaw
 */
.fc {
  direction: ltr;
  text-align: left;
}

.fc-rtl {
  text-align: right;
}

body .fc { /* extra precedence to overcome jqui */
  font-size: 1em;
}

/* Colors
--------------------------------------------------------------------------------------------------*/
.fc-unthemed th,
.fc-unthemed td,
.fc-unthemed thead,
.fc-unthemed tbody,
.fc-unthemed .fc-divider,
.fc-unthemed .fc-row,
.fc-unthemed .fc-popover {
  border-color: #ddd;
}

.fc-unthemed .fc-popover {
  background-color: #fff;
}

.fc-unthemed .fc-divider,
.fc-unthemed .fc-popover .fc-header {
  background: #eee;
}

.fc-unthemed .fc-popover .fc-header .fc-close {
  color: #666;
}

.fc-unthemed .fc-today {
  background: #F5F5F5;
}

.fc-highlight { /* when user is selecting cells */
  background: #bce8f1;
  opacity: 0.3;
  filter: alpha(opacity=30); /* for IE */
}

.fc-bgevent { /* default look for background events */
  background: rgb(143, 223, 130);
  opacity: 0.3;
  filter: alpha(opacity=30); /* for IE */
}

.fc-nonbusiness { /* default look for non-business-hours areas */
  /* will inherit .fc-bgevent's styles */
  background: #d7d7d7;
}

/* Icons (inline elements with styled text that mock arrow icons)
--------------------------------------------------------------------------------------------------*/
.fc-icon {
  display: inline-block;
  width: 1em;
  height: 1em;
  line-height: 1em;
  font-size: 1em;
  text-align: center;
  overflow: hidden;
  font-family: "Courier New", Courier, monospace;
  /* don't allow browser text-selection */
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  user-select: none;
}

/*
Acceptable font-family overrides for individual icons:
	"Arial", sans-serif
	"Times New Roman", serif

NOTE: use percentage font sizes or else old IE chokes
*/
.fc-icon:after {
  position: relative;
  margin: 0 -1em; /* ensures character will be centered, regardless of width */
}

.fc-icon-left-single-arrow:after {
  content: "‹";
  font-weight: bold;
  font-size: 200%;
  top: -7%;
  left: 3%;
}

.fc-icon-right-single-arrow:after {
  content: "›";
  font-weight: bold;
  font-size: 200%;
  top: -7%;
  left: -3%;
}

.fc-icon-left-double-arrow:after {
  content: "«";
  font-size: 160%;
  top: -7%;
}

.fc-icon-right-double-arrow:after {
  content: "»";
  font-size: 160%;
  top: -7%;
}

.fc-icon-left-triangle:after {
  content: "◄";
  font-size: 125%;
  top: 3%;
  left: -2%;
}

.fc-icon-right-triangle:after {
  content: "►";
  font-size: 125%;
  top: 3%;
  left: 2%;
}

.fc-icon-down-triangle:after {
  content: "▼";
  font-size: 125%;
  top: 2%;
}

.fc-icon-x:after {
  content: "×";
  font-size: 200%;
  top: 6%;
}

/* Buttons (styled <button> tags, normalized to work cross-browser)
--------------------------------------------------------------------------------------------------*/
.fc button {
  border-width: 1px;
  background-color: transparent;
  font-weight: 400;
  opacity: 0.8;
  filter: alpha(opacity=80);
  padding: 8px 16px;
  border-color: #888888;
  color: #888888;
}
.fc button:hover, .fc button:focus {
  opacity: 1;
  filter: alpha(opacity=100);
  outline: 0 !important;
}
.fc button:active, .fc button.active, .open > .fc button.dropdown-toggle {
  box-shadow: none;
  outline: 0 !important;
}

/* Firefox has an annoying inner border */
.fc button::-moz-focus-inner {
  margin: 0;
  padding: 0;
}

.fc-state-default { /* non-theme */
  border: 1px solid;
}

.fc-state-default.fc-corner-left { /* non-theme */
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}

.fc-state-default.fc-corner-right { /* non-theme */
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
}

/* icons in buttons */
.fc button .fc-icon { /* non-theme */
  position: relative;
  top: -0.05em; /* seems to be a good adjustment across browsers */
  margin: 0 0.2em;
  vertical-align: middle;
}

/*
  button states
  borrowed from twitter bootstrap (http://twitter.github.com/bootstrap/)
*/
.fc-state-hover,
.fc-state-active,
.fc-state-disabled {
  color: #333333;
  background-color: #e6e6e6;
}

.fc button[disabled],
.fc button[disabled]:focus,
.fc button[disabled]:hover {
  background-color: #E3E3E3;
  border-color: #E3E3E3;
  cursor: default;
  opacity: 0.65;
  filter: alpha(opacity=65);
  margin-left: 0.75em;
}

.fc-state-hover {
  background-color: #F5F5F5;
}

.fc .fc-state-active,
.fc .fc-state-active:focus,
.fc .fc-state-active:hover,
.fc .fc-state-active:active:focus,
.fc .fc-state-active:active:hover,
.fc .fc-state-active:active {
  background-color: #888888;
  color: #FFFFFF;
}

/* Buttons Groups
--------------------------------------------------------------------------------------------------*/
.fc-button-group {
  display: inline-block;
}

/*
every button that is not first in a button group should scootch over one pixel and cover the
previous button's border...
*/
.fc .fc-button-group > * { /* extra precedence b/c buttons have margin set to zero */
  float: left;
  margin: 0 0 0 5px;
}

.fc .fc-button-group > :first-child { /* same */
  margin-left: 0;
}

/* Popover
--------------------------------------------------------------------------------------------------*/
.fc-popover {
  position: absolute;
  box-shadow: 1px 2px 3px rgba(0, 0, 0, 0.125);
}

.fc-popover .fc-header { /* TODO: be more consistent with fc-head/fc-body */
  padding: 2px 4px;
}

.fc-popover .fc-header .fc-title {
  margin: 0 2px;
}

.fc-popover .fc-header .fc-close {
  cursor: pointer;
}

.fc-ltr .fc-popover .fc-header .fc-title,
.fc-rtl .fc-popover .fc-header .fc-close {
  float: left;
}

.fc-rtl .fc-popover .fc-header .fc-title,
.fc-ltr .fc-popover .fc-header .fc-close {
  float: right;
}

/* unthemed */
.fc-unthemed .fc-popover {
  border-width: 1px;
  border-style: solid;
}

.fc-unthemed .fc-popover .fc-header .fc-close {
  font-size: 0.9em;
  margin-top: 2px;
}

/* jqui themed */
.fc-popover > .ui-widget-header + .ui-widget-content {
  border-top: 0; /* where they meet, let the header have the border */
}

/* Misc Reusable Components
--------------------------------------------------------------------------------------------------*/
.fc-divider {
  border-style: solid;
  border-width: 1px;
}

hr.fc-divider {
  height: 0;
  margin: 0;
  padding: 0 0 2px; /* height is unreliable across browsers, so use padding */
  border-width: 1px 0;
}

.fc-clear {
  clear: both;
}

.fc-bg,
.fc-bgevent-skeleton,
.fc-highlight-skeleton,
.fc-helper-skeleton {
  /* these element should always cling to top-left/right corners */
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
}

.fc-bg {
  bottom: 0; /* strech bg to bottom edge */
}

.fc-bg table {
  height: 100%; /* strech bg to bottom edge */
}

/* Tables
--------------------------------------------------------------------------------------------------*/
.fc table {
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;
  border-spacing: 0;
  font-size: 1em; /* normalize cross-browser */
}

.fc th {
  text-align: right;
  border-bottom-width: 1px;
  font-size: 0.875rem;
  text-transform: uppercase;
  color: #58595B;
  font-weight: 400;
  padding-bottom: 3px;
}

.fc td {
  border-style: solid;
  border-width: 1px;
  padding: 0;
  vertical-align: top;
}

.fc td.fc-today {
  border-style: double; /* overcome neighboring borders */
}

.fc .fc-widget-header {
  border: 0;
}

.fc .fc-head .fc-widget-header {
  margin-top: 15px;
}

/* Fake Table Rows
--------------------------------------------------------------------------------------------------*/
.fc .fc-row { /* extra precedence to overcome themes w/ .ui-widget-content forcing a 1px border */
  /* no visible border by default. but make available if need be (scrollbar width compensation) */
  border-style: solid;
  border-width: 0;
}

.fc-row table {
  /* don't put left/right border on anything within a fake row.
     the outer tbody will worry about this */
  border-left: 0 hidden transparent;
  border-right: 0 hidden transparent;
  /* no bottom borders on rows */
  border-bottom: 0 hidden transparent;
}

.fc-row:first-child table {
  border-top: 0 hidden transparent; /* no top border on first row */
}

/* Day Row (used within the header and the DayGrid)
--------------------------------------------------------------------------------------------------*/
.fc-row {
  position: relative;
}

.fc-row .fc-bg {
  z-index: 1;
}

/* highlighting cells & background event skeleton */
.fc-row .fc-bgevent-skeleton,
.fc-row .fc-highlight-skeleton {
  bottom: 0; /* stretch skeleton to bottom of row */
}

.fc-row .fc-bgevent-skeleton table,
.fc-row .fc-highlight-skeleton table {
  height: 100%; /* stretch skeleton to bottom of row */
}

.fc-row .fc-highlight-skeleton td,
.fc-row .fc-bgevent-skeleton td {
  border-color: transparent;
}

.fc-row .fc-bgevent-skeleton {
  z-index: 2;
}

.fc-row .fc-highlight-skeleton {
  z-index: 3;
}

/*
row content (which contains day/week numbers and events) as well as "helper" (which contains
temporary rendered events).
*/
.fc-row .fc-content-skeleton {
  position: relative;
  z-index: 4;
  padding-bottom: 2px; /* matches the space above the events */
}

.fc-row .fc-helper-skeleton {
  z-index: 5;
}

.fc-row .fc-content-skeleton td,
.fc-row .fc-helper-skeleton td {
  /* see-through to the background below */
  background: none; /* in case <td>s are globally styled */
  border-color: transparent;
  /* don't put a border between events and/or the day number */
  border-bottom: 0;
}

.fc-row .fc-content-skeleton tbody td,
.fc-row .fc-helper-skeleton tbody td {
  /* don't put a border between event cells */
  border-top: 0;
}

/* Scrolling Container
--------------------------------------------------------------------------------------------------*/
.fc-scroller { /* this class goes on elements for guaranteed vertical scrollbars */
  overflow-y: scroll;
  overflow-x: hidden;
}

.fc-scroller > * { /* we expect an immediate inner element */
  position: relative; /* re-scope all positions */
  width: 100%; /* hack to force re-sizing this inner element when scrollbars appear/disappear */
  overflow: hidden; /* don't let negative margins or absolute positioning create further scroll */
}

/* Global Event Styles
--------------------------------------------------------------------------------------------------*/
.fc-event {
  position: relative; /* for resize handle and other inner positioning */
  display: block; /* make the <a> tag block */
  font-size: 0.85em;
  line-height: 1.3;
  border-radius: 2px;
  background-color: #CEEEFF; /* default BACKGROUND color */
  font-weight: normal; /* undo jqui's ui-widget-header bold */
}
.fc-event.event-azure {
  background-color: #4CA8D9;
}
.fc-event.event-green {
  background-color: #E9F3D7;
}
.fc-event.event-orange {
  background-color: rgba(255, 226, 0, 0.2);
}
.fc-event.event-red {
  background-color: rgba(214, 31, 5, 0.2);
}

/* overpower some of bootstrap's and jqui's styles on <a> tags */
.fc-event,
.fc-event:hover,
.ui-widget .fc-event {
  color: #000000; /* default TEXT color */
  text-decoration: none; /* if <a> has an href */
}

.fc-event[href],
.fc-event.fc-draggable {
  cursor: pointer; /* give events with links and draggable events a hand mouse pointer */
}

.fc-not-allowed,
.fc-not-allowed .fc-event { /* to override an event's custom cursor */
  cursor: not-allowed;
}

.fc-event .fc-bg { /* the generic .fc-bg already does position */
  z-index: 1;
  background: #fff;
  opacity: 0.25;
  filter: alpha(opacity=25); /* for IE */
}

.fc-event .fc-content {
  position: relative;
  z-index: 2;
}

.fc-event .fc-resizer {
  position: absolute;
  z-index: 3;
}

/* Horizontal Events
--------------------------------------------------------------------------------------------------*/
/* events that are continuing to/from another week. kill rounded corners and butt up against edge */
.fc-ltr .fc-h-event.fc-not-start,
.fc-rtl .fc-h-event.fc-not-end {
  margin-left: 0;
  border-left-width: 0;
  padding-left: 1px; /* replace the border with padding */
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.fc-ltr .fc-h-event.fc-not-end,
.fc-rtl .fc-h-event.fc-not-start {
  margin-right: 0;
  border-right-width: 0;
  padding-right: 1px; /* replace the border with padding */
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

/* resizer */
.fc-h-event .fc-resizer { /* positioned it to overcome the event's borders */
  top: -1px;
  bottom: -1px;
  left: -1px;
  right: -1px;
  width: 5px;
}

/* left resizer  */
.fc-ltr .fc-h-event .fc-start-resizer,
.fc-ltr .fc-h-event .fc-start-resizer:before,
.fc-ltr .fc-h-event .fc-start-resizer:after,
.fc-rtl .fc-h-event .fc-end-resizer,
.fc-rtl .fc-h-event .fc-end-resizer:before,
.fc-rtl .fc-h-event .fc-end-resizer:after {
  right: auto; /* ignore the right and only use the left */
  cursor: w-resize;
}

/* right resizer */
.fc-ltr .fc-h-event .fc-end-resizer,
.fc-ltr .fc-h-event .fc-end-resizer:before,
.fc-ltr .fc-h-event .fc-end-resizer:after,
.fc-rtl .fc-h-event .fc-start-resizer,
.fc-rtl .fc-h-event .fc-start-resizer:before,
.fc-rtl .fc-h-event .fc-start-resizer:after {
  left: auto; /* ignore the left and only use the right */
  cursor: e-resize;
}

/* DayGrid events
----------------------------------------------------------------------------------------------------
We use the full "fc-day-grid-event" class instead of using descendants because the event won't
be a descendant of the grid when it is being dragged.
*/
.fc-day-grid-event {
  margin: 2px 5px 0; /* spacing between events and edges */
  padding: 1px 2px;
}

.fc-day-grid-event .fc-content { /* force events to be one-line tall */
  white-space: nowrap;
  overflow: hidden;
}

.fc-day-grid-event .fc-time {
  font-weight: bold;
}

.fc-day-grid-event .fc-resizer { /* enlarge the default hit area */
  left: -3px;
  right: -3px;
  width: 7px;
}

/* Event Limiting
--------------------------------------------------------------------------------------------------*/
/* "more" link that represents hidden events */
a.fc-more {
  margin: 1px 3px;
  font-size: 0.85em;
  cursor: pointer;
  text-decoration: none;
}

a.fc-more:hover {
  text-decoration: underline;
}

.fc-limited { /* rows and cells that are hidden because of a "more" link */
  display: none;
}

/* popover that appears when "more" link is clicked */
.fc-day-grid .fc-row {
  z-index: 1; /* make the "more" popover one higher than this */
}

.fc-more-popover {
  z-index: 2;
  width: 220px;
}

.fc-more-popover .fc-event-container {
  padding: 10px;
}

/* Toolbar
--------------------------------------------------------------------------------------------------*/
.fc-toolbar {
  text-align: center;
  margin-bottom: 1em;
}

.fc-toolbar .fc-left {
  float: left;
  min-width: 260px;
}

.fc-toolbar .fc-right {
  float: right;
}

.fc-toolbar .fc-center {
  display: inline-block;
}

/* the things within each left/right/center section */
.fc .fc-toolbar > * > * { /* extra precedence to override button border margins */
  float: left;
  margin-left: 0.75em;
}

/* the first thing within each left/center/right section */
.fc .fc-toolbar > * > :first-child { /* extra precedence to override button border margins */
  margin-left: 0;
}

/* title text */
.fc-toolbar h2 {
  margin: 0;
}

/* button layering (for border precedence) */
.fc-toolbar button {
  position: relative;
}

.fc-toolbar .fc-state-hover,
.fc-toolbar .ui-state-hover {
  z-index: 2;
}

.fc-toolbar .fc-state-down {
  z-index: 3;
}

.fc-toolbar .fc-state-active,
.fc-toolbar .ui-state-active {
  z-index: 4;
}

.fc-toolbar button:focus {
  z-index: 5;
}

/* View Structure
--------------------------------------------------------------------------------------------------*/
/* undo twitter bootstrap's box-sizing rules. normalizes positioning techniques */
/* don't do this for the toolbar because we'll want bootstrap to style those buttons as some pt */
.fc-view-container *,
.fc-view-container *:before,
.fc-view-container *:after {
  box-sizing: content-box;
}

.fc-view,
.fc-view > table { /* so dragged elements can be above the view's main element */
  position: relative;
  z-index: 1;
}

/* BasicView
--------------------------------------------------------------------------------------------------*/
/* day row structure */
.fc-basicWeek-view .fc-content-skeleton,
.fc-basicDay-view .fc-content-skeleton {
  /* we are sure there are no day numbers in these views, so... */
  padding-top: 1px; /* add a pixel to make sure there are 2px padding above events */
  padding-bottom: 1em; /* ensure a space at bottom of cell for user selecting/clicking */
}

.fc-basic-view .fc-body .fc-row {
  min-height: 4em; /* ensure that all rows are at least this tall */
}

/* a "rigid" row will take up a constant amount of height because content-skeleton is absolute */
.fc-row.fc-rigid {
  overflow: hidden;
}

.fc-row.fc-rigid .fc-content-skeleton {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
}

/* week and day number styling */
.fc-basic-view .fc-week-number,
.fc-basic-view .fc-day-number {
  padding: 8px;
}

.fc-basic-view .fc-week-number {
  text-align: center;
}

.fc-basic-view .fc-week-number span {
  /* work around the way we do column resizing and ensure a minimum width */
  display: inline-block;
  min-width: 1.25em;
}

.fc-ltr .fc-basic-view .fc-day-number {
  float: right;
}

.fc-rtl .fc-basic-view .fc-day-number {
  text-align: left;
}

.fc-other-month .fc-day-number {
  opacity: 0.3;
  filter: alpha(opacity=30); /* for IE */
  /* opacity with small font can sometimes look too faded
     might want to set the 'color' property instead
     making day-numbers bold also fixes the problem */
}

/* AgendaView all-day area
--------------------------------------------------------------------------------------------------*/
.fc-agenda-view .fc-day-grid {
  position: relative;
  z-index: 2; /* so the "more.." popover will be over the time grid */
}

.fc-agenda-view .fc-day-grid .fc-row {
  min-height: 3em; /* all-day section will never get shorter than this */
}

.fc-agenda-view .fc-day-grid .fc-row .fc-content-skeleton {
  padding-top: 1px; /* add a pixel to make sure there are 2px padding above events */
  padding-bottom: 1em; /* give space underneath events for clicking/selecting days */
}

/* TimeGrid axis running down the side (for both the all-day area and the slot area)
--------------------------------------------------------------------------------------------------*/
.fc .fc-axis { /* .fc to overcome default cell styles */
  vertical-align: middle;
  padding: 0 4px;
  white-space: nowrap;
}

.fc-ltr .fc-axis {
  text-align: right;
}

.fc-rtl .fc-axis {
  text-align: left;
}

.ui-widget td.fc-axis {
  font-weight: normal; /* overcome jqui theme making it bold */
}

/* TimeGrid Structure
--------------------------------------------------------------------------------------------------*/
.fc-time-grid-container,
.fc-time-grid { /* so slats/bg/content/etc positions get scoped within here */
  position: relative;
  z-index: 1;
}

.fc-time-grid {
  min-height: 100%; /* so if height setting is 'auto', .fc-bg stretches to fill height */
}

.fc-time-grid table { /* don't put outer borders on slats/bg/content/etc */
  border: 0 hidden transparent;
}

.fc-time-grid > .fc-bg {
  z-index: 1;
}

.fc-time-grid .fc-slats,
.fc-time-grid > hr { /* the <hr> AgendaView injects when grid is shorter than scroller */
  position: relative;
  z-index: 2;
}

.fc-time-grid .fc-bgevent-skeleton,
.fc-time-grid .fc-content-skeleton {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
}

.fc-time-grid .fc-bgevent-skeleton {
  z-index: 3;
}

.fc-time-grid .fc-highlight-skeleton {
  z-index: 4;
}

.fc-time-grid .fc-content-skeleton {
  z-index: 5;
}

.fc-time-grid .fc-helper-skeleton {
  z-index: 6;
}

/* TimeGrid Slats (lines that run horizontally)
--------------------------------------------------------------------------------------------------*/
.fc-time-grid .fc-slats td {
  height: 1.5em;
  border-bottom: 0; /* each cell is responsible for its top border */
}

.fc-time-grid .fc-slats .fc-minor td {
  border-top-style: dotted;
}

.fc-time-grid .fc-slats .ui-widget-content { /* for jqui theme */
  background: none; /* see through to fc-bg */
}

/* TimeGrid Highlighting Slots
--------------------------------------------------------------------------------------------------*/
.fc-time-grid .fc-highlight-container { /* a div within a cell within the fc-highlight-skeleton */
  position: relative; /* scopes the left/right of the fc-highlight to be in the column */
}

.fc-time-grid .fc-highlight {
  position: absolute;
  left: 0;
  right: 0;
  /* top and bottom will be in by JS */
}

/* TimeGrid Event Containment
--------------------------------------------------------------------------------------------------*/
.fc-time-grid .fc-event-container,
.fc-time-grid .fc-bgevent-container { /* a div within a cell within the fc-bgevent-skeleton */
  position: relative;
}

.fc-ltr .fc-time-grid .fc-event-container { /* space on the sides of events for LTR (default) */
  margin: 0 2.5% 0 2px;
}

.fc-rtl .fc-time-grid .fc-event-container { /* space on the sides of events for RTL */
  margin: 0 2px 0 2.5%;
}

.fc-time-grid .fc-event,
.fc-time-grid .fc-bgevent {
  position: absolute;
  z-index: 1; /* scope inner z-index's */
}

.fc-time-grid .fc-bgevent {
  /* background events always span full width */
  left: 0;
  right: 0;
}

/* Generic Vertical Event
--------------------------------------------------------------------------------------------------*/
.fc-v-event.fc-not-start { /* events that are continuing from another day */
  /* replace space made by the top border with padding */
  border-top-width: 0;
  padding-top: 1px;
  /* remove top rounded corners */
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.fc-v-event.fc-not-end {
  /* replace space made by the top border with padding */
  border-bottom-width: 0;
  padding-bottom: 1px;
  /* remove bottom rounded corners */
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

/* TimeGrid Event Styling
----------------------------------------------------------------------------------------------------
We use the full "fc-time-grid-event" class instead of using descendants because the event won't
be a descendant of the grid when it is being dragged.
*/
.fc-time-grid-event {
  overflow: hidden; /* don't let the bg flow over rounded corners */
}

.fc-time-grid-event .fc-time,
.fc-time-grid-event .fc-title {
  padding: 0 1px;
}

.fc-time-grid-event .fc-time {
  font-size: 0.85em;
  white-space: nowrap;
}

/* short mode, where time and title are on the same line */
.fc-time-grid-event.fc-short .fc-content {
  /* don't wrap to second line (now that contents will be inline) */
  white-space: nowrap;
}

.fc-time-grid-event.fc-short .fc-time,
.fc-time-grid-event.fc-short .fc-title {
  /* put the time and title on the same line */
  display: inline-block;
  vertical-align: top;
}

.fc-time-grid-event.fc-short .fc-time span {
  display: none; /* don't display the full time text... */
}

.fc-time-grid-event.fc-short .fc-time:before {
  content: attr(data-start); /* ...instead, display only the start time */
}

.fc-time-grid-event.fc-short .fc-time:after {
  content: " - "; /* seperate with a dash, wrapped in nbsp's */
}

.fc-time-grid-event.fc-short .fc-title {
  font-size: 0.85em; /* make the title text the same size as the time */
  padding: 0; /* undo padding from above */
}

/* resizer */
.fc-time-grid-event .fc-resizer {
  left: 0;
  right: 0;
  bottom: 0;
  height: 8px;
  overflow: hidden;
  line-height: 8px;
  font-size: 11px;
  font-family: monospace;
  text-align: center;
  cursor: s-resize;
}

.fc-time-grid-event .fc-resizer:after {
  content: "=";
}

.card-calendar .content {
  padding: 0 !important;
}
.card-calendar .fc-toolbar {
  padding-top: 15px;
  padding-left: 15px;
  padding-right: 15px;
}
.card-calendar .fc td:first-child {
  border-left: 0;
}
.card-calendar .fc td:last-child {
  border-right: 0;
}
.card-calendar .fc-basic-view td:last-child.fc-week-number span,
.card-calendar .fc-basic-view td:last-child.fc-day-number {
  padding-right: 15px;
}
.card-calendar .fc .fc-day-header:last-child {
  padding-right: 15px;
}
.card-calendar .fc .fc-row:last-child td {
  border-bottom: 0;
}
.card-calendar .fc .fc-body .fc-widget-content {
  border-bottom: 0;
}

.ct-label {
  fill: rgba(0, 0, 0, 0.4);
  color: rgba(0, 0, 0, 0.4);
  font-size: 1.3rem;
  line-height: 1;
}

.ct-chart-line .ct-label,
.ct-chart-bar .ct-label {
  display: block;
  display: flex;
}

.ct-label.ct-horizontal.ct-start {
  align-items: flex-end;
  justify-content: flex-start;
  text-align: left;
  text-anchor: start;
}

.ct-label.ct-horizontal.ct-end {
  align-items: flex-start;
  justify-content: flex-start;
  text-align: left;
  text-anchor: start;
}

.ct-label.ct-vertical.ct-start {
  align-items: flex-end;
  justify-content: flex-end;
  text-align: right;
  text-anchor: end;
}

.ct-label.ct-vertical.ct-end {
  align-items: flex-end;
  justify-content: flex-start;
  text-align: left;
  text-anchor: start;
}

.ct-chart-bar .ct-label.ct-horizontal.ct-start {
  align-items: flex-end;
  justify-content: center;
  text-align: center;
  text-anchor: start;
}

.ct-chart-bar .ct-label.ct-horizontal.ct-end {
  align-items: flex-start;
  justify-content: center;
  text-align: center;
  text-anchor: start;
}

.ct-chart-bar.ct-horizontal-bars .ct-label.ct-horizontal.ct-start {
  align-items: flex-end;
  justify-content: flex-start;
  text-align: left;
  text-anchor: start;
}

.ct-chart-bar.ct-horizontal-bars .ct-label.ct-horizontal.ct-end {
  align-items: flex-start;
  justify-content: flex-start;
  text-align: left;
  text-anchor: start;
}

.ct-chart-bar.ct-horizontal-bars .ct-label.ct-vertical.ct-start {
  align-items: center;
  justify-content: flex-end;
  text-align: right;
  text-anchor: end;
}

.ct-chart-bar.ct-horizontal-bars .ct-label.ct-vertical.ct-end {
  align-items: center;
  justify-content: flex-start;
  text-align: left;
  text-anchor: end;
}

.ct-grid {
  stroke: rgba(0, 0, 0, 0.2);
  stroke-width: 1px;
  stroke-dasharray: 2px;
}

.ct-point {
  stroke-width: 8px;
  stroke-linecap: round;
}

.ct-line {
  fill: none;
  stroke-width: 3px;
}

.ct-area {
  stroke: none;
  fill-opacity: 0.8;
}

.ct-bar {
  fill: none;
  stroke-width: 10px;
}

.ct-slice-donut {
  fill: none;
  stroke-width: 60px;
}

.ct-series-a .ct-point, .ct-series-a .ct-line, .ct-series-a .ct-bar, .ct-series-a .ct-slice-donut {
  stroke: #1DC7EA;
}
.ct-series-a .ct-slice-pie, .ct-series-a .ct-area {
  fill: #1DC7EA;
}

.ct-series-b .ct-point, .ct-series-b .ct-line, .ct-series-b .ct-bar, .ct-series-b .ct-slice-donut {
  stroke: #D61F05;
}
.ct-series-b .ct-slice-pie, .ct-series-b .ct-area {
  fill: #D61F05;
}

.ct-series-c .ct-point, .ct-series-c .ct-line, .ct-series-c .ct-bar, .ct-series-c .ct-slice-donut {
  stroke: #FFE200;
}
.ct-series-c .ct-slice-pie, .ct-series-c .ct-area {
  fill: #FFE200;
}

.ct-series-d .ct-point, .ct-series-d .ct-line, .ct-series-d .ct-bar, .ct-series-d .ct-slice-donut {
  stroke: #9368E9;
}
.ct-series-d .ct-slice-pie, .ct-series-d .ct-area {
  fill: #9368E9;
}

.ct-series-e .ct-point, .ct-series-e .ct-line, .ct-series-e .ct-bar, .ct-series-e .ct-slice-donut {
  stroke: #7ABA09;
}
.ct-series-e .ct-slice-pie, .ct-series-e .ct-area {
  fill: #7ABA09;
}

.ct-series-f .ct-point, .ct-series-f .ct-line, .ct-series-f .ct-bar, .ct-series-f .ct-slice-donut {
  stroke: #1F77D0;
}
.ct-series-f .ct-slice-pie, .ct-series-f .ct-area {
  fill: #1F77D0;
}

.ct-series-g .ct-point, .ct-series-g .ct-line, .ct-series-g .ct-bar, .ct-series-g .ct-slice-donut {
  stroke: #58595B;
}
.ct-series-g .ct-slice-pie, .ct-series-g .ct-area {
  fill: #58595B;
}

.ct-series-h .ct-point, .ct-series-h .ct-line, .ct-series-h .ct-bar, .ct-series-h .ct-slice-donut {
  stroke: #dd4b39;
}
.ct-series-h .ct-slice-pie, .ct-series-h .ct-area {
  fill: #dd4b39;
}

.ct-series-i .ct-point, .ct-series-i .ct-line, .ct-series-i .ct-bar, .ct-series-i .ct-slice-donut {
  stroke: #35465c;
}
.ct-series-i .ct-slice-pie, .ct-series-i .ct-area {
  fill: #35465c;
}

.ct-series-j .ct-point, .ct-series-j .ct-line, .ct-series-j .ct-bar, .ct-series-j .ct-slice-donut {
  stroke: #e52d27;
}
.ct-series-j .ct-slice-pie, .ct-series-j .ct-area {
  fill: #e52d27;
}

.ct-series-k .ct-point, .ct-series-k .ct-line, .ct-series-k .ct-bar, .ct-series-k .ct-slice-donut {
  stroke: #55acee;
}
.ct-series-k .ct-slice-pie, .ct-series-k .ct-area {
  fill: #55acee;
}

.ct-series-l .ct-point, .ct-series-l .ct-line, .ct-series-l .ct-bar, .ct-series-l .ct-slice-donut {
  stroke: #cc2127;
}
.ct-series-l .ct-slice-pie, .ct-series-l .ct-area {
  fill: #cc2127;
}

.ct-series-m .ct-point, .ct-series-m .ct-line, .ct-series-m .ct-bar, .ct-series-m .ct-slice-donut {
  stroke: #1769ff;
}
.ct-series-m .ct-slice-pie, .ct-series-m .ct-area {
  fill: #1769ff;
}

.ct-series-n .ct-point, .ct-series-n .ct-line, .ct-series-n .ct-bar, .ct-series-n .ct-slice-donut {
  stroke: #6188e2;
}
.ct-series-n .ct-slice-pie, .ct-series-n .ct-area {
  fill: #6188e2;
}

.ct-series-o .ct-point, .ct-series-o .ct-line, .ct-series-o .ct-bar, .ct-series-o .ct-slice-donut {
  stroke: #a748ca;
}
.ct-series-o .ct-slice-pie, .ct-series-o .ct-area {
  fill: #a748ca;
}

.ct-square {
  display: block;
  position: relative;
  width: 100%;
}
.ct-square:before {
  display: block;
  float: left;
  content: "";
  width: 0;
  height: 0;
  padding-bottom: 100%;
}
.ct-square:after {
  content: "";
  display: table;
  clear: both;
}
.ct-square > svg {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
}

.ct-minor-second {
  display: block;
  position: relative;
  width: 100%;
}
.ct-minor-second:before {
  display: block;
  float: left;
  content: "";
  width: 0;
  height: 0;
  padding-bottom: 93.75%;
}
.ct-minor-second:after {
  content: "";
  display: table;
  clear: both;
}
.ct-minor-second > svg {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
}

.ct-major-second {
  display: block;
  position: relative;
  width: 100%;
}
.ct-major-second:before {
  display: block;
  float: left;
  content: "";
  width: 0;
  height: 0;
  padding-bottom: 88.8888888889%;
}
.ct-major-second:after {
  content: "";
  display: table;
  clear: both;
}
.ct-major-second > svg {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
}

.ct-minor-third {
  display: block;
  position: relative;
  width: 100%;
}
.ct-minor-third:before {
  display: block;
  float: left;
  content: "";
  width: 0;
  height: 0;
  padding-bottom: 83.3333333333%;
}
.ct-minor-third:after {
  content: "";
  display: table;
  clear: both;
}
.ct-minor-third > svg {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
}

.ct-major-third {
  display: block;
  position: relative;
  width: 100%;
}
.ct-major-third:before {
  display: block;
  float: left;
  content: "";
  width: 0;
  height: 0;
  padding-bottom: 80%;
}
.ct-major-third:after {
  content: "";
  display: table;
  clear: both;
}
.ct-major-third > svg {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
}

.ct-perfect-fourth {
  display: block;
  position: relative;
  width: 100%;
}
.ct-perfect-fourth:before {
  display: block;
  float: left;
  content: "";
  width: 0;
  height: 0;
  padding-bottom: 75%;
}
.ct-perfect-fourth:after {
  content: "";
  display: table;
  clear: both;
}
.ct-perfect-fourth > svg {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
}

.ct-perfect-fifth {
  display: block;
  position: relative;
  width: 100%;
}
.ct-perfect-fifth:before {
  display: block;
  float: left;
  content: "";
  width: 0;
  height: 0;
  padding-bottom: 66.6666666667%;
}
.ct-perfect-fifth:after {
  content: "";
  display: table;
  clear: both;
}
.ct-perfect-fifth > svg {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
}

.ct-minor-sixth {
  display: block;
  position: relative;
  width: 100%;
}
.ct-minor-sixth:before {
  display: block;
  float: left;
  content: "";
  width: 0;
  height: 0;
  padding-bottom: 62.5%;
}
.ct-minor-sixth:after {
  content: "";
  display: table;
  clear: both;
}
.ct-minor-sixth > svg {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
}

.ct-golden-section {
  display: block;
  position: relative;
  width: 100%;
}
.ct-golden-section:before {
  display: block;
  float: left;
  content: "";
  width: 0;
  height: 0;
  padding-bottom: 61.804697157%;
}
.ct-golden-section:after {
  content: "";
  display: table;
  clear: both;
}
.ct-golden-section > svg {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
}

.ct-major-sixth {
  display: block;
  position: relative;
  width: 100%;
}
.ct-major-sixth:before {
  display: block;
  float: left;
  content: "";
  width: 0;
  height: 0;
  padding-bottom: 60%;
}
.ct-major-sixth:after {
  content: "";
  display: table;
  clear: both;
}
.ct-major-sixth > svg {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
}

.ct-minor-seventh {
  display: block;
  position: relative;
  width: 100%;
}
.ct-minor-seventh:before {
  display: block;
  float: left;
  content: "";
  width: 0;
  height: 0;
  padding-bottom: 56.25%;
}
.ct-minor-seventh:after {
  content: "";
  display: table;
  clear: both;
}
.ct-minor-seventh > svg {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
}

.ct-major-seventh {
  display: block;
  position: relative;
  width: 100%;
}
.ct-major-seventh:before {
  display: block;
  float: left;
  content: "";
  width: 0;
  height: 0;
  padding-bottom: 53.3333333333%;
}
.ct-major-seventh:after {
  content: "";
  display: table;
  clear: both;
}
.ct-major-seventh > svg {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
}

.ct-octave {
  display: block;
  position: relative;
  width: 100%;
}
.ct-octave:before {
  display: block;
  float: left;
  content: "";
  width: 0;
  height: 0;
  padding-bottom: 50%;
}
.ct-octave:after {
  content: "";
  display: table;
  clear: both;
}
.ct-octave > svg {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
}

.ct-major-tenth {
  display: block;
  position: relative;
  width: 100%;
}
.ct-major-tenth:before {
  display: block;
  float: left;
  content: "";
  width: 0;
  height: 0;
  padding-bottom: 40%;
}
.ct-major-tenth:after {
  content: "";
  display: table;
  clear: both;
}
.ct-major-tenth > svg {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
}

.ct-major-eleventh {
  display: block;
  position: relative;
  width: 100%;
}
.ct-major-eleventh:before {
  display: block;
  float: left;
  content: "";
  width: 0;
  height: 0;
  padding-bottom: 37.5%;
}
.ct-major-eleventh:after {
  content: "";
  display: table;
  clear: both;
}
.ct-major-eleventh > svg {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
}

.ct-major-twelfth {
  display: block;
  position: relative;
  width: 100%;
}
.ct-major-twelfth:before {
  display: block;
  float: left;
  content: "";
  width: 0;
  height: 0;
  padding-bottom: 33.3333333333%;
}
.ct-major-twelfth:after {
  content: "";
  display: table;
  clear: both;
}
.ct-major-twelfth > svg {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
}

.ct-double-octave {
  display: block;
  position: relative;
  width: 100%;
}
.ct-double-octave:before {
  display: block;
  float: left;
  content: "";
  width: 0;
  height: 0;
  padding-bottom: 25%;
}
.ct-double-octave:after {
  content: "";
  display: table;
  clear: both;
}
.ct-double-octave > svg {
  display: block;
  position: absolute;
  top: 0;
  left: 0;
}

.ct-blue {
  stroke: #003380 !important;
}

.ct-azure {
  stroke: #0084CA !important;
}

.ct-green {
  stroke: #7ABA09 !important;
}

.ct-orange {
  stroke: #FFE200 !important;
}

.ct-red {
  stroke: #D61F05 !important;
}

/* perfect-scrollbar v0.6.10 */
.ps-container {
  touch-action: none;
  overflow: hidden !important;
  -ms-overflow-style: none;
}

@supports (-ms-overflow-style: none) {
  .ps-container {
    overflow: auto !important;
  }
}
@media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {
  .ps-container {
    overflow: auto !important;
  }
}
.ps-container.ps-active-x > .ps-scrollbar-x-rail,
.ps-container.ps-active-y > .ps-scrollbar-y-rail {
  display: block;
  background-color: transparent;
}

.ps-container.ps-in-scrolling {
  pointer-events: none;
}

.ps-container.ps-in-scrolling.ps-x > .ps-scrollbar-x-rail {
  background-color: #eee;
  opacity: 0.9;
}

.ps-container.ps-in-scrolling.ps-x > .ps-scrollbar-x-rail > .ps-scrollbar-x {
  background-color: #999;
}

.ps-container.ps-in-scrolling.ps-y > .ps-scrollbar-y-rail {
  background-color: #eee;
  opacity: 0.9;
}

.ps-container.ps-in-scrolling.ps-y > .ps-scrollbar-y-rail > .ps-scrollbar-y {
  background-color: #999;
}

.ps-container > .ps-scrollbar-x-rail {
  display: none;
  position: absolute;
  /* please don't change 'position' */
  border-radius: 4px;
  opacity: 0;
  transition: background-color 0.2s linear, opacity 0.2s linear;
  bottom: 3px;
  /* there must be 'bottom' for ps-scrollbar-x-rail */
  height: 8px;
}

.ps-container > .ps-scrollbar-x-rail > .ps-scrollbar-x {
  position: absolute;
  /* please don't change 'position' */
  background-color: #aaa;
  border-radius: 4px;
  transition: background-color 0.2s linear;
  bottom: 0;
  /* there must be 'bottom' for ps-scrollbar-x */
  height: 8px;
}

.ps-container > .ps-scrollbar-y-rail {
  display: none;
  position: absolute;
  /* please don't change 'position' */
  border-radius: 4px;
  opacity: 0;
  transition: background-color 0.2s linear, opacity 0.2s linear;
  right: 3px;
  /* there must be 'right' for ps-scrollbar-y-rail */
  width: 8px;
}

.ps-container > .ps-scrollbar-y-rail > .ps-scrollbar-y {
  position: absolute;
  /* please don't change 'position' */
  background-color: #aaa;
  border-radius: 4px;
  transition: background-color 0.2s linear;
  right: 0;
  /* there must be 'right' for ps-scrollbar-y */
  width: 8px;
}

.ps-container:hover.ps-in-scrolling {
  pointer-events: none;
}

.ps-container:hover.ps-in-scrolling.ps-x > .ps-scrollbar-x-rail {
  background-color: #eee;
  opacity: 0.9;
}

.ps-container:hover.ps-in-scrolling.ps-x > .ps-scrollbar-x-rail > .ps-scrollbar-x {
  background-color: #999;
}

.ps-container:hover.ps-in-scrolling.ps-y > .ps-scrollbar-y-rail {
  background-color: #eee;
  opacity: 0.9;
}

.ps-container:hover.ps-in-scrolling.ps-y > .ps-scrollbar-y-rail > .ps-scrollbar-y {
  background-color: #999;
}

.ps-container:hover > .ps-scrollbar-x-rail,
.ps-container:hover > .ps-scrollbar-y-rail {
  opacity: 0.6;
}

.ps-container:hover > .ps-scrollbar-x-rail:hover {
  background-color: #eee;
  opacity: 0.9;
}

.ps-container:hover > .ps-scrollbar-x-rail:hover > .ps-scrollbar-x {
  background-color: #999;
}

.ps-container:hover > .ps-scrollbar-y-rail:hover {
  background-color: #eee;
  opacity: 0.9;
}

.ps-container:hover > .ps-scrollbar-y-rail:hover > .ps-scrollbar-y {
  background-color: #999;
}

/*!
 * Bootstrap-select v1.12.2 (http://silviomoreto.github.io/bootstrap-select)
 *
 * Copyright 2013-2017 bootstrap-select
 * Licensed under MIT (https://github.com/silviomoreto/bootstrap-select/blob/master/LICENSE)
 */
select.bs-select-hidden,
select.selectpicker {
  display: none !important;
}

.bootstrap-select {
  min-width: 100%;
}

.bootstrap-select > .dropdown-toggle {
  width: 100%;
  padding-right: 25px;
  z-index: 1;
  margin: 0;
}
.bootstrap-select > .dropdown-toggle:after {
  margin-left: -10px;
}

.bootstrap-select > select {
  position: absolute !important;
  bottom: 0;
  left: 50%;
  display: block !important;
  width: 0.5px !important;
  height: 100% !important;
  padding: 0 !important;
  opacity: 0 !important;
  border: none;
  border-top-left-radius: 3px !important;
  border-top-right-radius: 3px !important;
}

.bootstrap-select > select.mobile-device {
  top: 0;
  left: 0;
  display: block !important;
  width: 100% !important;
  z-index: 2;
}

.has-error .bootstrap-select .dropdown-toggle,
.error .bootstrap-select .dropdown-toggle {
  border-color: #b94a48;
}

.bootstrap-select.fit-width {
  width: auto !important;
}

.bootstrap-select:not([class*=col-]):not([class*=form-control]):not(.input-group-btn) {
  width: 100%;
}

.bootstrap-select.form-control {
  margin-bottom: 0;
  padding: 0;
  border: none;
}

.bootstrap-select.form-control:not([class*=col-]) {
  width: 100%;
}

.bootstrap-select.btn-block {
  width: 100%;
}

.bootstrap-select.form-control.input-group-btn {
  z-index: auto;
}

.bootstrap-select.form-control.input-group-btn:not(:first-child):not(:last-child) > .btn {
  border-radius: 0;
}

.bootstrap-select.btn-group:not(.input-group-btn),
.bootstrap-select.btn-group[class*=col-] {
  float: none;
  display: inline-block;
  margin-left: 0;
}

.bootstrap-select.btn-group.dropdown-menu-right,
.bootstrap-select.btn-group[class*=col-].dropdown-menu-right,
.row .bootstrap-select.btn-group[class*=col-].dropdown-menu-right {
  float: right;
}

.form-inline .bootstrap-select.btn-group,
.form-horizontal .bootstrap-select.btn-group,
.form-group .bootstrap-select.btn-group {
  margin-bottom: 0;
}

.form-group-lg .bootstrap-select.btn-group.form-control,
.form-group-sm .bootstrap-select.btn-group.form-control {
  padding: 0;
}

.form-group-lg .bootstrap-select.btn-group.form-control .dropdown-toggle,
.form-group-sm .bootstrap-select.btn-group.form-control .dropdown-toggle {
  height: 100%;
  font-size: inherit;
  line-height: inherit;
  border-radius: inherit;
}

.form-inline .bootstrap-select.btn-group .form-control {
  width: 100%;
}

.bootstrap-select.btn-group.disabled,
.bootstrap-select.btn-group > .disabled {
  cursor: not-allowed;
}

.bootstrap-select.btn-group.disabled:focus,
.bootstrap-select.btn-group > .disabled:focus {
  outline: none !important;
}

.bootstrap-select.btn-group.bs-container {
  position: absolute;
  height: 0 !important;
  padding: 0 !important;
}

.bootstrap-select.btn-group.bs-container .dropdown-menu {
  z-index: 1060;
}

.bootstrap-select.btn-group .dropdown-toggle .filter-option {
  display: inline-block;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 100%;
  text-align: left;
}

.bootstrap-select.btn-group .dropdown-toggle .caret {
  display: none;
}

.bootstrap-select.btn-group[class*=col-] .dropdown-toggle {
  width: 100%;
}

.bootstrap-select.btn-group .dropdown-menu {
  min-width: 100%;
  box-sizing: border-box;
  max-height: 400px !important;
}

.bootstrap-select.btn-group .dropdown-menu.inner {
  position: static;
  float: none;
  border: 0;
  padding: 0;
  margin: 0;
  display: block;
  max-height: 400px !important;
  overflow-y: scroll;
  -ms-overflow-style: auto;
  box-shadow: none;
}

.bootstrap-select.btn-group .dropdown-menu li {
  position: relative;
}

.bootstrap-select.btn-group .dropdown-menu li.active small {
  color: #fff;
}

.bootstrap-select.btn-group .dropdown-menu li.disabled a {
  cursor: not-allowed;
}

.bootstrap-select.btn-group .dropdown-menu li a {
  cursor: pointer;
  -webkit-user-select: none;
  user-select: none;
}

.bootstrap-select.btn-group .dropdown-menu li a.opt {
  position: relative;
  padding-left: 2.25em;
}

.bootstrap-select.btn-group .dropdown-menu li a span.check-mark {
  display: none;
}

.bootstrap-select.btn-group .dropdown-menu li a span.text {
  display: inline-block;
}

.bootstrap-select.btn-group .dropdown-menu li small {
  padding-left: 0.5em;
}

.bootstrap-select.btn-group .dropdown-menu .notify {
  position: absolute;
  bottom: 5px;
  width: 96%;
  margin: 0 2%;
  min-height: 26px;
  padding: 3px 5px;
  background: #f5f5f5;
  border: 1px solid #e3e3e3;
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.05);
  pointer-events: none;
  opacity: 0.9;
  box-sizing: border-box;
}

.bootstrap-select.btn-group .no-results {
  padding: 3px;
  background: #f5f5f5;
  margin: 0 5px;
  white-space: nowrap;
}

.bootstrap-select.btn-group.fit-width .dropdown-toggle .filter-option {
  position: static;
}

.bootstrap-select.btn-group.fit-width .dropdown-toggle .caret {
  position: static;
  top: auto;
  margin-top: -1px;
}

.bootstrap-select.btn-group.show-tick .dropdown-menu li.selected a span.check-mark {
  position: absolute;
  display: inline-block;
  right: 20px;
  margin-top: 3px;
  color: black;
}

.bootstrap-select.btn-group.show-tick .dropdown-menu li a span.text {
  margin-right: 34px;
}

.bootstrap-select.show-menu-arrow.open > .dropdown-toggle {
  z-index: 1061;
}

.bootstrap-select.show-menu-arrow .dropdown-toggle:before {
  content: "";
  border-left: 7px solid transparent;
  border-right: 7px solid transparent;
  border-bottom: 7px solid rgba(204, 204, 204, 0.2);
  position: absolute;
  bottom: -4px;
  left: 9px;
  display: none;
}

.bootstrap-select.show-menu-arrow .dropdown-toggle:after {
  content: "";
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-bottom: 6px solid white;
  position: absolute;
  bottom: -4px;
  left: 10px;
  display: none;
}

.bootstrap-select.show-menu-arrow.dropup .dropdown-toggle:before {
  bottom: auto;
  top: -3px;
  border-top: 7px solid rgba(204, 204, 204, 0.2);
  border-bottom: 0;
}

.bootstrap-select.show-menu-arrow.dropup .dropdown-toggle:after {
  bottom: auto;
  top: -3px;
  border-top: 6px solid white;
  border-bottom: 0;
}

.bootstrap-select.show-menu-arrow.pull-right .dropdown-toggle:before {
  right: 12px;
  left: auto;
}

.bootstrap-select.show-menu-arrow.pull-right .dropdown-toggle:after {
  right: 13px;
  left: auto;
}

.bootstrap-select.show-menu-arrow.open > .dropdown-toggle:before,
.bootstrap-select.show-menu-arrow.open > .dropdown-toggle:after {
  display: block;
}

.bs-searchbox,
.bs-actionsbox,
.bs-donebutton {
  padding: 4px 8px;
}

.bs-actionsbox {
  width: 100%;
  box-sizing: border-box;
}

.bs-actionsbox .btn-group button {
  width: 50%;
}

.bs-donebutton {
  float: left;
  width: 100%;
  box-sizing: border-box;
}

.bs-donebutton .btn-group button {
  width: 100%;
}

.bs-searchbox + .bs-actionsbox {
  padding: 0 8px 4px;
}

.bs-searchbox .form-control {
  margin-bottom: 0;
  width: 100%;
  float: none;
}

.bootstrap-select {
  margin-top: 5px;
}
.bootstrap-select .dropdown-menu.inner li a {
  display: block;
  padding: 8px 16px;
  clear: both;
  font-weight: 400;
  line-height: 1.42857143;
  color: #333;
  white-space: nowrap;
  outline: none;
  font-size: 14px;
}
.bootstrap-select .dropdown-menu.inner li.disabled a:hover, .bootstrap-select .dropdown-menu.inner li.disabled a:focus {
  background-color: transparent;
}
.bootstrap-select .dropdown-menu.inner li a:hover {
  background-color: #F5F5F5 !important;
  color: #333333 !important;
  opacity: 1;
  text-decoration: none;
}
.bootstrap-select .dropdown-menu.open {
  overflow: visible !important;
  display: none;
  visibility: hidden;
}
.bootstrap-select .dropdown-menu.open.show {
  display: block;
  visibility: visible;
}
.bootstrap-select .dropdown-menu.open[x-placement=top-start] {
  top: 0px !important;
}

.show .btn-info.dropdown-toggle {
  background-color: #003380;
  border-color: #003380;
}

/*!
 * Datetimepicker for Bootstrap 3
 * ! version : 4.7.14
 * https://github.com/Eonasdan/bootstrap-datetimepicker/
 */
.sr-only, .bootstrap-datetimepicker-widget table th.next::after, .bootstrap-datetimepicker-widget table th.prev::after, .bootstrap-datetimepicker-widget .picker-switch::after, .bootstrap-datetimepicker-widget .btn[data-action=today]::after, .bootstrap-datetimepicker-widget .btn[data-action=clear]::after, .bootstrap-datetimepicker-widget .btn[data-action=togglePeriod]::after, .bootstrap-datetimepicker-widget .btn[data-action=showMinutes]::after, .bootstrap-datetimepicker-widget .btn[data-action=showHours]::after, .bootstrap-datetimepicker-widget .btn[data-action=decrementMinutes]::after, .bootstrap-datetimepicker-widget .btn[data-action=decrementHours]::after, .bootstrap-datetimepicker-widget .btn[data-action=incrementMinutes]::after, .bootstrap-datetimepicker-widget .btn[data-action=incrementHours]::after {
  position: absolute;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
}

.bootstrap-datetimepicker-widget {
  list-style: none;
}
.bootstrap-datetimepicker-widget.dropdown-menu {
  padding: 4px;
  width: 19em;
}
@media (min-width: 768px) {
  .bootstrap-datetimepicker-widget.dropdown-menu.timepicker-sbs {
    width: 38em;
  }
}
@media (min-width: 992px) {
  .bootstrap-datetimepicker-widget.dropdown-menu.timepicker-sbs {
    width: 38em;
  }
}
@media (min-width: 1200px) {
  .bootstrap-datetimepicker-widget.dropdown-menu.timepicker-sbs {
    width: 38em;
  }
}
.bootstrap-datetimepicker-widget.dropdown-menu.bottom:before {
  border-bottom: 11px solid rgba(0, 0, 0, 0.2);
  border-left: 11px solid rgba(0, 0, 0, 0);
  border-right: 11px solid rgba(0, 0, 0, 0);
  content: "";
  display: inline-block;
  position: absolute;
  left: 12px;
  top: -11px;
}
.bootstrap-datetimepicker-widget.dropdown-menu.bottom:after {
  border-bottom: 11px solid #FFFFFF;
  border-left: 11px solid rgba(0, 0, 0, 0);
  border-right: 11px solid rgba(0, 0, 0, 0);
  content: "";
  display: inline-block;
  position: absolute;
  left: 12px;
  top: -10px;
}
.bootstrap-datetimepicker-widget.dropdown-menu.top {
  margin-top: auto;
  margin-bottom: -20px;
}
.bootstrap-datetimepicker-widget.dropdown-menu.top.open {
  margin-top: auto;
  margin-bottom: 5px;
}
.bootstrap-datetimepicker-widget.dropdown-menu.top:before {
  border-top: 11px solid rgba(0, 0, 0, 0.2);
  border-left: 11px solid rgba(0, 0, 0, 0);
  border-right: 11px solid rgba(0, 0, 0, 0);
  border-bottom: none;
  content: "";
  display: inline-block;
  position: absolute;
  left: 12px;
  bottom: -11px;
  top: auto;
}
.bootstrap-datetimepicker-widget.dropdown-menu.top:after {
  border-top: 11px solid #FFFFFF;
  border-left: 11px solid rgba(0, 0, 0, 0);
  border-right: 11px solid rgba(0, 0, 0, 0);
  border-bottom: none;
  content: "";
  display: inline-block;
  position: absolute;
  left: 12px;
  bottom: -10px;
  top: auto;
}
.bootstrap-datetimepicker-widget.dropdown-menu.pull-right:before {
  left: auto;
  right: 6px;
}
.bootstrap-datetimepicker-widget.dropdown-menu.pull-right:after {
  left: auto;
  right: 7px;
}
.bootstrap-datetimepicker-widget.dropdown-menu.open {
  visibility: visible !important;
  opacity: 1 !important;
  top: 120px !important;
  font-size: 14px !important;
}
.bootstrap-datetimepicker-widget .list-unstyled {
  margin: 0;
}
.bootstrap-datetimepicker-widget a[data-action] {
  padding: 6px 0;
  border-width: 0;
}
.bootstrap-datetimepicker-widget a[data-action]:active {
  box-shadow: none;
}
.bootstrap-datetimepicker-widget .timepicker-hour, .bootstrap-datetimepicker-widget .timepicker-minute, .bootstrap-datetimepicker-widget .timepicker-second {
  width: 56px;
  height: 56px;
  font-weight: 300;
  font-size: 1.375rem;
  margin: 3px;
  border-radius: 50%;
}
.bootstrap-datetimepicker-widget button[data-action] {
  padding: 6px;
}
.bootstrap-datetimepicker-widget .btn[data-action=incrementHours]::after {
  content: "Increment Hours";
}
.bootstrap-datetimepicker-widget .btn[data-action=incrementMinutes]::after {
  content: "Increment Minutes";
}
.bootstrap-datetimepicker-widget .btn[data-action=decrementHours]::after {
  content: "Decrement Hours";
}
.bootstrap-datetimepicker-widget .btn[data-action=decrementMinutes]::after {
  content: "Decrement Minutes";
}
.bootstrap-datetimepicker-widget .btn[data-action=showHours]::after {
  content: "Show Hours";
}
.bootstrap-datetimepicker-widget .btn[data-action=showMinutes]::after {
  content: "Show Minutes";
}
.bootstrap-datetimepicker-widget .btn[data-action=togglePeriod]::after {
  content: "Toggle AM/PM";
}
.bootstrap-datetimepicker-widget .btn[data-action=clear]::after {
  content: "Clear the picker";
}
.bootstrap-datetimepicker-widget .btn[data-action=today]::after {
  content: "Set the date to today";
}
.bootstrap-datetimepicker-widget .picker-switch {
  text-align: center;
  border-radius: 4px;
  font-size: 14px;
}
.bootstrap-datetimepicker-widget .picker-switch::after {
  content: "Toggle Date and Time Screens";
}
.bootstrap-datetimepicker-widget .picker-switch td {
  padding: 0;
  margin: 0;
  height: auto;
  width: auto;
  line-height: inherit;
}
.bootstrap-datetimepicker-widget .picker-switch td span {
  line-height: 2.5;
  height: 2.5em;
  width: 100%;
  border-radius: 4px;
  margin: 2px 0px !important;
}
.bootstrap-datetimepicker-widget .picker-switch td a,
.bootstrap-datetimepicker-widget .picker-switch td a:hover {
  color: #003380;
}
.bootstrap-datetimepicker-widget table {
  width: 100%;
  margin: 0;
}
.bootstrap-datetimepicker-widget table td > div, .bootstrap-datetimepicker-widget table th > div {
  text-align: center;
}
.bootstrap-datetimepicker-widget table th {
  height: 20px;
  line-height: 20px;
  width: 20px;
}
.bootstrap-datetimepicker-widget table th.picker-switch {
  width: 145px;
}
.bootstrap-datetimepicker-widget table th.disabled, .bootstrap-datetimepicker-widget table th.disabled:hover {
  background: none;
  color: #A2A2A2;
  cursor: not-allowed;
}
.bootstrap-datetimepicker-widget table th.prev span, .bootstrap-datetimepicker-widget table th.next span {
  border-radius: 4px;
  height: 27px;
  width: 27px;
  line-height: 28px;
  font-size: 12px;
  border-radius: 50%;
  text-align: center;
}
.bootstrap-datetimepicker-widget table th.prev::after {
  content: "Previous Month";
}
.bootstrap-datetimepicker-widget table th.next::after {
  content: "Next Month";
}
.bootstrap-datetimepicker-widget table th.dow {
  text-align: center;
  border-bottom: 1px solid #E3E3E3;
  font-size: 0.75rem;
  text-transform: uppercase;
  color: #58595B;
  font-weight: 400;
  padding-bottom: 5px;
  padding-top: 10px;
}
.bootstrap-datetimepicker-widget table thead tr:first-child th {
  cursor: pointer;
}
.bootstrap-datetimepicker-widget table thead tr:first-child th:hover span, .bootstrap-datetimepicker-widget table thead tr:first-child th.picker-switch:hover {
  background: #E3E3E3;
}
.bootstrap-datetimepicker-widget table td > div {
  border-radius: 4px;
  height: 54px;
  line-height: 54px;
  width: 54px;
  text-align: center;
}
.bootstrap-datetimepicker-widget table td.cw > div {
  font-size: 0.8em;
  height: 20px;
  line-height: 20px;
  color: #A2A2A2;
}
.bootstrap-datetimepicker-widget table td.day > div {
  height: 30px;
  line-height: 30px;
  width: 30px;
  text-align: center;
  padding: 0px;
  border-radius: 50%;
  margin: 0 auto;
  z-index: -1;
  position: relative;
}
.bootstrap-datetimepicker-widget table td.minute > div, .bootstrap-datetimepicker-widget table td.hour > div {
  border-radius: 50%;
}
.bootstrap-datetimepicker-widget table td.day:hover > div, .bootstrap-datetimepicker-widget table td.hour:hover > div, .bootstrap-datetimepicker-widget table td.minute:hover > div, .bootstrap-datetimepicker-widget table td.second:hover > div {
  background: #E3E3E3;
  cursor: pointer;
}
.bootstrap-datetimepicker-widget table td.old > div, .bootstrap-datetimepicker-widget table td.new > div {
  color: #A2A2A2;
}
.bootstrap-datetimepicker-widget table td.today > div {
  position: relative;
}
.bootstrap-datetimepicker-widget table td.today > div:before {
  content: "";
  display: inline-block;
  border: 0 0 7px 7px solid transparent;
  border-bottom-color: #003380;
  border-top-color: rgba(0, 0, 0, 0.2);
  position: absolute;
  bottom: 4px;
  right: 4px;
}
.bootstrap-datetimepicker-widget table td.active > div, .bootstrap-datetimepicker-widget table td.active:hover > div {
  background-color: #003380;
  color: #FFFFFF;
}
.bootstrap-datetimepicker-widget table td.active.today:before > div {
  border-bottom-color: #fff;
}
.bootstrap-datetimepicker-widget table td.disabled > div, .bootstrap-datetimepicker-widget table td.disabled:hover > div {
  background: none;
  color: #A2A2A2;
  cursor: not-allowed;
}
.bootstrap-datetimepicker-widget table td span {
  display: inline-block;
  width: 56px;
  height: 56px;
  line-height: 56px;
  margin: 3px 3px;
  cursor: pointer;
  border-radius: 50%;
  text-align: center;
}
.bootstrap-datetimepicker-widget table td span:hover {
  background: #E3E3E3;
}
.bootstrap-datetimepicker-widget table td span.active {
  background-color: #003380;
  color: #FFFFFF;
}
.bootstrap-datetimepicker-widget table td span.old {
  color: #A2A2A2;
}
.bootstrap-datetimepicker-widget table td span.disabled, .bootstrap-datetimepicker-widget table td span.disabled:hover {
  background: none;
  color: #A2A2A2;
  cursor: not-allowed;
}
.bootstrap-datetimepicker-widget .timepicker-picker span,
.bootstrap-datetimepicker-widget .timepicker-hours span,
.bootstrap-datetimepicker-widget .timepicker-minutes span {
  border-radius: 50% !important;
}
.bootstrap-datetimepicker-widget .timepicker-picker .table-condensed td a,
.bootstrap-datetimepicker-widget .timepicker-hours .table-condensed td a,
.bootstrap-datetimepicker-widget .timepicker-minutes .table-condensed td a {
  color: #888888;
  background-color: transparent;
}
.bootstrap-datetimepicker-widget.usetwentyfour td.hour {
  height: 27px;
  line-height: 27px;
}

.input-group.date .input-group-addon {
  cursor: pointer;
}

.table-condensed > tbody > tr > td,
.table-condensed > tbody > tr > th,
.table-condensed > tfoot > tr > td,
.table-condensed > tfoot > tr > th,
.table-condensed > thead > tr > td,
.table-condensed > thead > tr > th {
  padding: 1px;
}

.bootstrap-datetimepicker-widget {
  opacity: 0;
  transform: translate3d(0px, -10px, 0px);
}
.bootstrap-datetimepicker-widget.top {
  transform: translate3d(0px, 0px, 0px);
}
.bootstrap-datetimepicker-widget.open {
  opacity: 1;
  transform: translate3d(0, 5px, 0);
  transition: transform 0.5s cubic-bezier(0.215, 0.61, 0.355, 1) 0s;
}

.bootstrap-datetimepicker-widget.dropdown-menu.top {
  top: auto !important;
}

.bootstrap-datetimepicker-widget.open.top {
  transform: translate3d(0, -10px, 0);
}
.bootstrap-datetimepicker-widget.open.top:before {
  border-top: 11px solid #DCD9D1;
  border-left: 11px solid transparent;
  border-right: 11px solid transparent;
  content: "";
  display: inline-block;
  position: absolute;
  left: 12px;
  bottom: -12px;
}
.bootstrap-datetimepicker-widget.open.top:after {
  border-top: 11px solid #FFFFFF;
  border-left: 11px solid transparent;
  border-right: 11px solid transparent;
  content: "";
  display: inline-block;
  position: absolute;
  left: 12px;
  bottom: -11px;
}

/*! nouislider - 9.1.0 - 2016-12-10 16:00:32 */
/* Functional styling;
 * These styles are required for noUiSlider to function.
 * You don't need to change these rules to apply your design.
 */
.noUi-target,
.noUi-target * {
  -webkit-touch-callout: none;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  -webkit-user-select: none;
  touch-action: none;
  user-select: none;
  box-sizing: border-box;
}

.noUi-target {
  position: relative;
  direction: ltr;
}

.noUi-base {
  width: 100%;
  height: 100%;
  position: relative;
  z-index: 1; /* Fix 401 */
}

.noUi-connect {
  position: absolute;
  right: 0;
  top: 0;
  left: 0;
  bottom: 0;
}

.noUi-origin {
  position: absolute;
  height: 0;
  width: 0;
}

.noUi-handle {
  position: relative;
  z-index: 1;
}

.noUi-state-tap .noUi-connect,
.noUi-state-tap .noUi-origin {
  transition: top 0.3s, right 0.3s, bottom 0.3s, left 0.3s;
}

.noUi-state-drag * {
  cursor: inherit !important;
}

/* Painting and performance;
 * Browsers can paint handles in their own layer.
 */
.noUi-base,
.noUi-handle {
  transform: translate3d(0, 0, 0);
}

/* Slider size and handle placement;
 */
.noUi-horizontal {
  height: 4px;
}

.noUi-horizontal .noUi-handle {
  border-radius: 50%;
  background-color: #FFFFFF;
  box-shadow: 0 1px 13px 0 rgba(0, 0, 0, 0.2);
  height: 15px;
  width: 15px;
  cursor: pointer;
  margin-left: -10px;
  margin-top: -6px;
  outline: none;
}

.noUi-vertical {
  width: 18px;
}

.noUi-vertical .noUi-handle {
  width: 28px;
  height: 34px;
  left: -6px;
  top: -17px;
}

/* Styling;
 */
.noUi-target {
  background-color: rgba(182, 182, 182, 0.3);
  border-radius: 3px;
}

.noUi-connect {
  background: #888888;
  border-radius: 3px;
  transition: background 450ms;
}

/* Handles and cursors;
 */
.noUi-draggable {
  cursor: ew-resize;
}

.noUi-vertical .noUi-draggable {
  cursor: ns-resize;
}

.noUi-handle {
  border-radius: 3px;
  background: #FFF;
  cursor: default;
  box-shadow: inset 0 0 1px #FFF, inset 0 1px 7px #EBEBEB, 0 3px 6px -3px #BBB;
  -webkit-transition: 300ms ease 0s;
  -moz-transition: 300ms ease 0s;
  -ms-transition: 300ms ease 0s;
  -o-transform: 300ms ease 0s;
  transition: 300ms ease 0s;
}

.noUi-active {
  transform: scale3d(1.5, 1.5, 1);
}

/* Disabled state;
 */
[disabled] .noUi-connect {
  background: #B8B8B8;
}

[disabled].noUi-target,
[disabled].noUi-handle,
[disabled] .noUi-handle {
  cursor: not-allowed;
}

/* Base;
 *
 */
.noUi-pips,
.noUi-pips * {
  box-sizing: border-box;
}

.noUi-pips {
  position: absolute;
  color: #999;
}

/* Values;
 *
 */
.noUi-value {
  position: absolute;
  text-align: center;
}

.noUi-value-sub {
  color: #ccc;
  font-size: 10px;
}

/* Markings;
 *
 */
.noUi-marker {
  position: absolute;
  background: #CCC;
}

.noUi-marker-sub {
  background: #AAA;
}

.noUi-marker-large {
  background: #AAA;
}

/* Horizontal layout;
 *
 */
.noUi-pips-horizontal {
  padding: 10px 0;
  height: 80px;
  top: 100%;
  left: 0;
  width: 100%;
}

.noUi-value-horizontal {
  transform: translate3d(-50%, 50%, 0);
}

.noUi-marker-horizontal.noUi-marker {
  margin-left: -1px;
  width: 2px;
  height: 5px;
}

.noUi-marker-horizontal.noUi-marker-sub {
  height: 10px;
}

.noUi-marker-horizontal.noUi-marker-large {
  height: 15px;
}

/* Vertical layout;
 *
 */
.noUi-pips-vertical {
  padding: 0 10px;
  height: 100%;
  top: 0;
  left: 100%;
}

.noUi-value-vertical {
  transform: translate3d(0, 50%, 0);
  padding-left: 25px;
}

.noUi-marker-vertical.noUi-marker {
  width: 5px;
  height: 2px;
  margin-top: -1px;
}

.noUi-marker-vertical.noUi-marker-sub {
  width: 10px;
}

.noUi-marker-vertical.noUi-marker-large {
  width: 15px;
}

.noUi-tooltip {
  display: block;
  position: absolute;
  border: 1px solid #D9D9D9;
  border-radius: 3px;
  background: #fff;
  color: #000;
  padding: 5px;
  text-align: center;
}

.noUi-horizontal .noUi-tooltip {
  transform: translate(-50%, 0);
  left: 50%;
  bottom: 120%;
}

.noUi-vertical .noUi-tooltip {
  transform: translate(0, -50%);
  top: 50%;
  right: 120%;
}

.slider-neutral .noUi-connect, .slider-neutral.noUi-connect {
  background-color: #FFFFFF;
}

.slider-primary .noUi-connect, .slider-primary.noUi-connect {
  background-color: #0084CA;
}

.slider-info .noUi-connect, .slider-info.noUi-connect {
  background-color: #003380;
}

.slider-success .noUi-connect, .slider-success.noUi-connect {
  background-color: #7ABA09;
}

.slider-warning .noUi-connect, .slider-warning.noUi-connect {
  background-color: #FFE200;
}

.slider-danger .noUi-connect, .slider-danger.noUi-connect {
  background-color: #D61F05;
}

/*! nouislider - 14.6.3 - 11/19/2020 */
/* Functional styling;
 * These styles are required for noUiSlider to function.
 * You don't need to change these rules to apply your design.
 */
.noUi-target,
.noUi-target * {
  -webkit-touch-callout: none;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  -webkit-user-select: none;
  touch-action: none;
  user-select: none;
  box-sizing: border-box;
}

.noUi-target {
  position: relative;
}

.noUi-base,
.noUi-connects {
  width: 100%;
  height: 100%;
  position: relative;
  z-index: 1;
}

/* Wrapper for all connect elements.
 */
.noUi-connects {
  overflow: hidden;
  z-index: 0;
}

.noUi-connect,
.noUi-origin {
  will-change: transform;
  position: absolute;
  z-index: 1;
  top: 0;
  right: 0;
  -ms-transform-origin: 0 0;
  -webkit-transform-origin: 0 0;
  -webkit-transform-style: preserve-3d;
  transform-origin: 0 0;
  transform-style: flat;
}

.noUi-connect {
  height: 100%;
  width: 100%;
}

.noUi-origin {
  height: 10%;
  width: 10%;
}

/* Offset direction
 */
.noUi-txt-dir-rtl.noUi-horizontal .noUi-origin {
  left: 0;
  right: auto;
}

/* Give origins 0 height/width so they don't interfere with clicking the
 * connect elements.
 */
.noUi-vertical .noUi-origin {
  width: 0;
}

.noUi-horizontal .noUi-origin {
  height: 0;
}

.noUi-handle {
  backface-visibility: hidden;
  position: absolute;
}

.noUi-touch-area {
  height: 100%;
  width: 100%;
}

.noUi-state-tap .noUi-connect,
.noUi-state-tap .noUi-origin {
  transition: transform 0.3s;
}

.noUi-state-drag * {
  cursor: inherit !important;
}

/* Slider size and handle placement;
 */
.noUi-horizontal {
  height: 4px;
}

.noUi-horizontal .noUi-handle {
  width: 15px;
  height: 15px;
  right: -10px;
  top: 0px;
}

.noUi-vertical {
  width: 18px;
}

.noUi-vertical .noUi-handle {
  width: 15px;
  height: 15px;
  right: -6px;
  top: -17px;
}

.noUi-txt-dir-rtl.noUi-horizontal .noUi-handle {
  left: -17px;
  right: auto;
}

/* Styling;
 * Giving the connect element a border radius causes issues with using transform: scale
 */
.noUi-target {
  background: #FAFAFA;
  border-radius: 4px;
}

.noUi-connects {
  border-radius: 3px;
}

.noUi-connect {
  background: #3FB8AF;
}

/* Handles and cursors;
 */
.noUi-draggable {
  cursor: ew-resize;
}

.noUi-vertical .noUi-draggable {
  cursor: ns-resize;
}

.noUi-handle {
  box-shadow: 0 1px 13px 0 rgba(0, 0, 0, 0.2);
  border-radius: 50%;
  background: #FFF;
  cursor: default;
  transition: 300ms ease 0s;
}

/* Handle stripes;
 */
/* Disabled state;
 */
[disabled] .noUi-connect {
  background: #B8B8B8;
}

[disabled].noUi-target,
[disabled].noUi-handle,
[disabled] .noUi-handle {
  cursor: not-allowed;
}

/* Base;
 *
 */
.noUi-pips,
.noUi-pips * {
  box-sizing: border-box;
}

.noUi-pips {
  position: absolute;
  color: #999;
}

/* Values;
 *
 */
.noUi-value {
  position: absolute;
  white-space: nowrap;
  text-align: center;
}

.noUi-value-sub {
  color: #ccc;
  font-size: 10px;
}

/* Markings;
 *
 */
.noUi-marker {
  position: absolute;
  background: #CCC;
}

.noUi-marker-sub {
  background: #AAA;
}

.noUi-marker-large {
  background: #AAA;
}

/* Horizontal layout;
 *
 */
.noUi-pips-horizontal {
  padding: 10px 0;
  height: 80px;
  top: 100%;
  left: 0;
  width: 100%;
}

.noUi-value-horizontal {
  transform: translate(-50%, 50%);
}

.noUi-rtl .noUi-value-horizontal {
  transform: translate(50%, 50%);
}

.noUi-marker-horizontal.noUi-marker {
  margin-left: -1px;
  width: 2px;
  height: 5px;
}

.noUi-marker-horizontal.noUi-marker-sub {
  height: 10px;
}

.noUi-marker-horizontal.noUi-marker-large {
  height: 15px;
}

/* Vertical layout;
 *
 */
.noUi-pips-vertical {
  padding: 0 10px;
  height: 100%;
  top: 0;
  left: 100%;
}

.noUi-value-vertical {
  transform: translate(0, -50%);
  padding-left: 25px;
}

.noUi-rtl .noUi-value-vertical {
  transform: translate(0, 50%);
}

.noUi-marker-vertical.noUi-marker {
  width: 5px;
  height: 2px;
  margin-top: -1px;
}

.noUi-marker-vertical.noUi-marker-sub {
  width: 10px;
}

.noUi-marker-vertical.noUi-marker-large {
  width: 15px;
}

.noUi-tooltip {
  display: block;
  position: absolute;
  border: 1px solid #D9D9D9;
  border-radius: 3px;
  background: #fff;
  color: #000;
  padding: 5px;
  text-align: center;
  white-space: nowrap;
}

.noUi-horizontal .noUi-tooltip {
  transform: translate(-50%, 0);
  left: 50%;
  bottom: 120%;
}

.noUi-vertical .noUi-tooltip {
  transform: translate(0, -50%);
  top: 50%;
  right: 120%;
}

.noUi-horizontal .noUi-origin > .noUi-tooltip {
  transform: translate(50%, 0);
  left: auto;
  bottom: 10px;
}

.noUi-vertical .noUi-origin > .noUi-tooltip {
  transform: translate(0, -18px);
  top: auto;
  right: 28px;
}

.noUi-active {
  transform: scale3d(1.5, 1.5, 1);
}

.slider-primary .noUi-connect {
  background: #003380;
}

.slider-info .noUi-connect {
  background: #0084CA;
}

.slider-success .noUi-connect {
  background: #7ABA09;
}

.slider-warning .noUi-connect {
  background: #FFE200;
}

.slider-danger .noUi-connect {
  background: #D61F05;
}

.rbc-btn {
  color: inherit;
  font: inherit;
  margin: 0;
}

button.rbc-btn {
  overflow: visible;
  text-transform: none;
  -webkit-appearance: button;
  cursor: pointer;
}

button[disabled].rbc-btn {
  cursor: not-allowed;
}

button.rbc-input::-moz-focus-inner {
  border: 0;
  padding: 0;
}

.rbc-calendar {
  box-sizing: border-box;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: stretch;
}

.rbc-calendar *,
.rbc-calendar *:before,
.rbc-calendar *:after {
  box-sizing: inherit;
}

.rbc-abs-full,
.rbc-row-bg {
  overflow: hidden;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}

.rbc-ellipsis,
.rbc-event-label,
.rbc-row-segment .rbc-event-content,
.rbc-show-more {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.rbc-rtl {
  direction: rtl;
}

.rbc-off-range {
  color: #333333;
  opacity: 0.3;
}

.rbc-header {
  overflow: hidden;
  flex: 1 0;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding: 0 3px;
  text-align: right;
  vertical-align: middle;
  font-size: 0.875em;
  min-height: 0;
  border-bottom: 1px solid #DDD;
  color: #999999;
  font-weight: 400;
}
.rbc-header:last-child span {
  padding-right: 15px;
}

.rbc-header > a,
.rbc-header > a:active,
.rbc-header > a:visited {
  color: inherit;
  text-decoration: none;
}

.rbc-row-content {
  position: relative;
  user-select: none;
  -webkit-user-select: none;
  z-index: 4;
  min-height: 153px;
}

.rbc-toolbar {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  font-size: 16px;
  padding-top: 20px;
  padding-left: 20px;
  padding-right: 20px;
}

.rbc-toolbar .rbc-toolbar-label {
  flex-grow: 1;
  padding: 0 10px;
  text-align: center;
  font-family: inherit;
  line-height: 1.5em;
  color: inherit;
  font-weight: 300;
  margin: 0;
  font-size: 2.25em;
}

.rbc-toolbar button {
  display: inline-block;
  margin: 0;
  text-align: center;
  vertical-align: middle;
  background: none;
  background-image: none;
  border: 1px solid #ccc;
  border-radius: 4px;
  line-height: normal;
  white-space: nowrap;
  border-width: 1px;
  background-color: transparent;
  font-weight: 400;
  padding: 8px 16px;
  border-color: #888;
  color: #888;
  font-family: inherit;
  font-size: inherit;
  font: inherit;
}

.rbc-toolbar button:focus {
  outline: none;
}

.rbc-toolbar button.rbc-active, .rbc-toolbar button.rbc-active:hover {
  border-color: #888;
  background-color: #888;
  color: #fff;
}

.rbc-toolbar button:hover {
  color: #373a3c;
  background-color: #e6e6e6;
  border-color: #adadad;
}

.rbc-btn-group {
  display: inline-block;
  white-space: nowrap;
}

.rbc-btn-group > button:first-child:not(:last-child) {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.rbc-btn-group > button:last-child:not(:first-child) {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.rbc-rtl .rbc-btn-group > button:first-child:not(:last-child) {
  border-radius: 4px;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.rbc-rtl .rbc-btn-group > button:last-child:not(:first-child) {
  border-radius: 4px;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.rbc-btn-group > button:not(:first-child):not(:last-child) {
  border-radius: 0;
}

.rbc-btn-group button + button {
  margin-left: -1px;
}

.rbc-rtl .rbc-btn-group button + button {
  margin-left: 0;
  margin-right: -1px;
}

.rbc-btn-group + .rbc-btn-group,
.rbc-btn-group + button {
  margin-left: 10px;
}

.rbc-slot-selecting .rbc-event {
  cursor: inherit;
  pointer-events: none;
}

.rbc-event.rbc-selected {
  background-color: #265985;
}

.rbc-event-label {
  font-size: 80%;
}

.rbc-event-overlaps {
  box-shadow: -1px 1px 5px 0px rgba(51, 51, 51, 0.5);
}

.rbc-event-continues-prior {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
}

.rbc-event-continues-after {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.rbc-event-continues-earlier {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.rbc-event-continues-later {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

.rbc-event-continues-day-after {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}

.rbc-event-continues-day-prior {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}

.rbc-row {
  display: flex;
  flex-direction: row;
}

.rbc-row-segment {
  padding: 2px 6px 1px;
}

.rbc-selected-cell {
  background-color: rgba(0, 0, 0, 0.1);
}

.rbc-show-more {
  background-color: rgba(255, 255, 255, 0.3);
  z-index: 4;
  font-weight: bold;
  font-size: 85%;
  height: auto;
  line-height: normal;
  white-space: nowrap;
}

.rbc-month-view {
  position: relative;
  border: 1px solid #DDD;
  border-bottom: 0px;
  display: flex;
  flex-direction: column;
  flex: 1 0;
  width: 100%;
  user-select: none;
  -webkit-user-select: none;
  height: 100%;
  border-left: none;
  border-right: none;
}

.rbc-month-view {
  border-top: none;
}

.rbc-month-header {
  display: flex;
  flex-direction: row;
}

.rbc-month-row {
  display: flex;
  position: relative;
  flex-direction: column;
  flex: 1 0;
  -ms-flex-preferred-size: 0px;
  overflow: hidden;
  height: 100%;
}

.rbc-month-row + .rbc-month-row {
  border-top: 1px solid #DDD;
}

.rbc-date-cell {
  flex: 1 1;
  min-width: 0;
  padding-left: 5px;
  text-align: left;
}

.rbc-date-cell.rbc-now {
  font-weight: bold;
}

.rbc-date-cell > a,
.rbc-date-cell > a:active,
.rbc-date-cell > a:visited {
  color: inherit;
  text-decoration: none;
}

.rbc-row-bg {
  display: flex;
  flex-direction: row;
  flex: 1 0;
  overflow: hidden;
}

.rbc-day-bg {
  flex: 1 0;
}

.rbc-day-bg + .rbc-day-bg {
  border-left: 1px solid #DDD;
}

.rbc-rtl .rbc-day-bg + .rbc-day-bg {
  border-left-width: 0;
  border-right: 1px solid #DDD;
}

.rbc-overlay {
  position: absolute;
  z-index: 5;
  border: 1px solid #e5e5e5;
  background-color: #fff;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.25);
  padding: 10px;
}

.rbc-overlay > * + * {
  margin-top: 1px;
}

.rbc-overlay-header {
  border-bottom: 1px solid #e5e5e5;
  margin: -10px -10px 5px -10px;
  padding: 2px 10px;
}

.rbc-agenda-view {
  display: flex;
  flex-direction: column;
  flex: 1 0;
  overflow: auto;
}

.rbc-agenda-view table.rbc-agenda-table {
  width: 100%;
  border: 1px solid #DDD;
  border-spacing: 0;
  border-collapse: collapse;
}

.rbc-agenda-view table.rbc-agenda-table tbody > tr > td {
  padding: 5px 10px;
  vertical-align: top;
}

.rbc-agenda-view table.rbc-agenda-table .rbc-agenda-time-cell {
  padding-left: 15px;
  padding-right: 15px;
  text-transform: lowercase;
}

.rbc-agenda-view table.rbc-agenda-table tbody > tr > td + td {
  border-left: 1px solid #DDD;
}

.rbc-rtl .rbc-agenda-view table.rbc-agenda-table tbody > tr > td + td {
  border-left-width: 0;
  border-right: 1px solid #DDD;
}

.rbc-agenda-view table.rbc-agenda-table tbody > tr + tr {
  border-top: 1px solid #DDD;
}

.rbc-agenda-view table.rbc-agenda-table thead > tr > th {
  padding: 3px 5px;
  text-align: left;
  border-bottom: 1px solid #DDD;
}

.rbc-rtl .rbc-agenda-view table.rbc-agenda-table thead > tr > th {
  text-align: right;
}

.rbc-agenda-time-cell {
  text-transform: lowercase;
}

.rbc-agenda-time-cell .rbc-continues-after:after {
  content: " »";
}

.rbc-agenda-time-cell .rbc-continues-prior:before {
  content: "« ";
}

.rbc-agenda-date-cell,
.rbc-agenda-time-cell {
  white-space: nowrap;
}

.rbc-agenda-event-cell {
  width: 100%;
}

.rbc-time-column {
  display: flex;
  flex-direction: column;
  min-height: 100%;
}

.rbc-time-column .rbc-timeslot-group {
  flex: 1 1;
}

.rbc-timeslot-group {
  border-bottom: 1px solid #DDD;
  min-height: 40px;
  display: flex;
  flex-flow: column nowrap;
}

.rbc-time-gutter,
.rbc-header-gutter {
  flex: none;
}

.rbc-label {
  padding: 0 5px;
}

.rbc-day-slot {
  position: relative;
}

.rbc-day-slot .rbc-events-container {
  bottom: 0;
  left: 0;
  position: absolute;
  right: 10px;
  top: 0;
}

.rbc-day-slot .rbc-events-container.rbc-is-rtl {
  left: 10px;
  right: 0;
}

.rbc-day-slot .rbc-event {
  display: flex;
  max-height: 100%;
  min-height: 20px;
  flex-flow: column wrap;
  align-items: flex-start;
  overflow: hidden;
  position: absolute;
}

.rbc-day-slot .rbc-event-label {
  flex: none;
  padding-right: 5px;
  width: auto;
  font-weight: bold;
  box-sizing: content-box;
  color: #fff;
  white-space: nowrap;
}

.rbc-day-slot .rbc-event-content {
  width: 100%;
  flex: 1 1;
  word-wrap: break-word;
  line-height: 1;
  height: 100%;
  min-height: 1em;
}

.rbc-day-slot .rbc-time-slot + .rbc-time-slot {
  border-top: 1px dotted #ddd;
}

.rbc-time-slot {
  flex: 1 0;
}

.rbc-time-slot.rbc-now {
  font-weight: bold;
}

.rbc-day-header {
  text-align: center;
}

.rbc-slot-selection {
  z-index: 10;
  position: absolute;
  background-color: rgba(0, 0, 0, 0.5);
  color: white;
  font-size: 75%;
  width: 100%;
  padding: 3px;
}

.rbc-slot-selecting {
  cursor: move;
}

.rbc-time-view {
  display: flex;
  flex-direction: column;
  flex: 1 1;
  width: 100%;
  border: 1px solid #DDD;
  min-height: 0;
  border-left: none;
  border-right: none;
  border-top: none;
}

.rbc-time-view .rbc-time-gutter {
  white-space: nowrap;
}

.rbc-time-view .rbc-allday-cell {
  box-sizing: content-box;
  width: 100%;
  position: relative;
}

.rbc-time-view .rbc-allday-events {
  position: relative;
  z-index: 4;
}

.rbc-time-view .rbc-row {
  box-sizing: border-box;
  min-height: 20px;
}

.rbc-time-header {
  display: flex;
  flex: 0 0 auto;
  flex-direction: row;
}

.rbc-time-header.rbc-overflowing {
  border-right: 1px solid #DDD;
}

.rbc-rtl .rbc-time-header.rbc-overflowing {
  border-right-width: 0;
  border-left: 1px solid #DDD;
}

.rbc-time-header > .rbc-row:first-child {
  border-bottom: 1px solid #DDD;
}

.rbc-time-header > .rbc-row.rbc-row-resource {
  border-bottom: 1px solid #DDD;
}

.rbc-time-header-content {
  flex: 1 1;
  min-width: 0;
  flex-direction: column;
  border-left: 1px solid #DDD;
}

.rbc-rtl .rbc-time-header-content {
  border-left-width: 0;
  border-right: 1px solid #DDD;
}

.rbc-time-content {
  display: flex;
  flex: 1 0;
  align-items: flex-start;
  width: 100%;
  border-top: 2px solid #DDD;
  overflow-y: auto;
  position: relative;
}

.rbc-time-content > .rbc-time-gutter {
  flex: none;
}

.rbc-time-content > * + * > * {
  border-left: 1px solid #DDD;
}

.rbc-rtl .rbc-time-content > * + * > * {
  border-left-width: 0;
  border-right: 1px solid #DDD;
}

.rbc-time-content > .rbc-day-slot {
  width: 100%;
  user-select: none;
  -webkit-user-select: none;
}

.rbc-current-time-indicator {
  position: absolute;
  z-index: 3;
  height: 1px;
  background-color: #74ad31;
  pointer-events: none;
}

.rbc-event {
  width: 100%;
  position: relative; /* for resize handle and other inner positioning */
  display: block; /* make the <a> tag block */
  font-size: 0.85em;
  border-radius: 2px;
  padding: 0;
  background-color: #CEEEFF; /* default BACKGROUND color */
  font-weight: normal; /* undo jqui's ui-widget-header bold */
  text-align: left;
  border: none;
  padding-bottom: 1px;
  line-height: 1.2;
}
.rbc-event.rbc-event-azure {
  background-color: #4CA8D9;
}
.rbc-event.rbc-event-green {
  background-color: #E9F3D7;
}
.rbc-event.rbc-event-orange {
  background-color: rgba(255, 226, 0, 0.2);
}
.rbc-event.rbc-event-red {
  background-color: rgba(214, 31, 5, 0.2);
}
.rbc-event .rbc-event-content {
  position: relative;
  z-index: 2;
  white-space: nowrap;
  overflow: hidden;
  color: inherit;
  padding: 0 5px;
}

.rbc-day-slot .rbc-event {
  display: block !important;
  height: unset !important;
  max-height: unset !important;
}

.rbc-today {
  background-color: #F5F5F5;
}

@media screen and (max-width: 1373px) {
  .rbc-toolbar {
    display: block;
  }
  .rbc-toolbar .rbc-btn-group {
    display: block;
    text-align: center;
  }
  .rbc-toolbar .rbc-toolbar-label {
    display: block;
    flex-grow: unset;
    padding: 0;
  }
}
.sweet-alert {
  margin: auto !important;
  top: unset !important;
  left: unset !important;
}

.card-wizard {
  min-height: 410px;
  transition: all 300ms linear;
}
.card-wizard[data-color=primary] .moving-tab {
  background-color: #0084CA;
}
.card-wizard[data-color=primary] .picture:hover {
  border-color: #0084CA;
}
.card-wizard[data-color=primary] .choice:hover .icon, .card-wizard[data-color=primary] .choice.active .icon {
  border-color: #0084CA;
  color: #0084CA;
}
.card-wizard[data-color=primary] .checkbox input[type=checkbox]:checked + .checkbox-material .check {
  background-color: #0084CA;
}
.card-wizard[data-color=primary] .radio input[type=radio]:checked ~ .check {
  background-color: #0084CA;
}
.card-wizard[data-color=primary] .radio input[type=radio]:checked ~ .circle {
  border-color: #0084CA;
}
.card-wizard[data-color=green] .moving-tab {
  background-color: #7ABA09;
}
.card-wizard[data-color=green] .picture:hover {
  border-color: #7ABA09;
}
.card-wizard[data-color=green] .choice:hover .icon, .card-wizard[data-color=green] .choice.active .icon {
  border-color: #7ABA09;
  color: #7ABA09;
}
.card-wizard[data-color=green] .checkbox input[type=checkbox]:checked + .checkbox-material .check {
  background-color: #7ABA09;
}
.card-wizard[data-color=green] .radio input[type=radio]:checked ~ .check {
  background-color: #7ABA09;
}
.card-wizard[data-color=green] .radio input[type=radio]:checked ~ .circle {
  border-color: #7ABA09;
}
.card-wizard[data-color=orange] .moving-tab {
  background-color: #FFE200;
}
.card-wizard[data-color=orange] .picture:hover {
  border-color: #FFE200;
}
.card-wizard[data-color=orange] .choice:hover .icon, .card-wizard[data-color=orange] .choice.active .icon {
  border-color: #FFE200;
  color: #FFE200;
}
.card-wizard[data-color=orange] .checkbox input[type=checkbox]:checked + .checkbox-material .check {
  background-color: #FFE200;
}
.card-wizard[data-color=orange] .radio input[type=radio]:checked ~ .check {
  background-color: #FFE200;
}
.card-wizard[data-color=orange] .radio input[type=radio]:checked ~ .circle {
  border-color: #FFE200;
}
.card-wizard[data-color=red] .moving-tab {
  background-color: #D61F05;
}
.card-wizard[data-color=red] .picture:hover {
  border-color: #D61F05;
}
.card-wizard[data-color=red] .choice:hover .icon, .card-wizard[data-color=red] .choice.active .icon {
  border-color: #D61F05;
  color: #D61F05;
}
.card-wizard[data-color=red] .checkbox input[type=checkbox]:checked + .checkbox-material .check {
  background-color: #D61F05;
}
.card-wizard[data-color=red] .radio input[type=radio]:checked ~ .check {
  background-color: #D61F05;
}
.card-wizard[data-color=red] .radio input[type=radio]:checked ~ .circle {
  border-color: #D61F05;
}
.card-wizard[data-color=blue] .moving-tab {
  background-color: #003380;
}
.card-wizard[data-color=blue] .picture:hover {
  border-color: #003380;
}
.card-wizard[data-color=blue] .choice:hover .icon, .card-wizard[data-color=blue] .choice.active .icon {
  border-color: #003380;
  color: #003380;
}
.card-wizard[data-color=blue] .checkbox input[type=checkbox]:checked + .checkbox-material .check {
  background-color: #003380;
}
.card-wizard[data-color=blue] .radio input[type=radio]:checked ~ .check {
  background-color: #003380;
}
.card-wizard[data-color=blue] .radio input[type=radio]:checked ~ .circle {
  border-color: #003380;
}
.card-wizard .card-header {
  padding: 15px 0 !important;
  padding-bottom: 40px;
  background-color: transparent;
}
.card-wizard .card-header .card-title {
  margin-bottom: 0px;
}
.card-wizard .card-header .card-title + .description {
  color: #58595B;
  font-size: 0.875rem;
  font-weight: 400;
  margin: 0px;
  margin-bottom: 40px;
}
.card-wizard .nav-pills .nav-item .nav-link {
  padding: 0.75rem;
}
.card-wizard .nav-pills .nav-item .nav-link,
.card-wizard .nav-pills .nav-item .nav-link.active,
.card-wizard .nav-pills .nav-item .nav-link:hover,
.card-wizard .nav-pills .nav-item .nav-link:focus,
.card-wizard .nav-pills .nav-item .nav-link.active:focus,
.card-wizard .nav-pills .nav-item .nav-link.active:hover {
  background-color: transparent;
  box-shadow: none;
}
.card-wizard .picture-container {
  position: relative;
  cursor: pointer;
  text-align: center;
}
.card-wizard .wizard-navigation {
  position: relative;
}
.card-wizard .wizard-navigation .nav-link {
  display: flex;
  align-items: center;
  justify-content: center;
}
.card-wizard .wizard-navigation .nav-link i,
.card-wizard .moving-tab i {
  display: inline-block;
  font-size: 19px;
  line-height: 18px;
  margin-right: 6px;
  padding: 0;
  vertical-align: bottom;
}
.card-wizard .moving-tab i {
  margin-right: 9px;
}
.card-wizard .picture {
  width: 106px;
  height: 106px;
  background-color: #999999;
  border: 1px solid #E3E3E3;
  color: #FFFFFF;
  border-radius: 50%;
  margin: 5px auto;
  overflow: hidden;
  transition: all 0.2s;
  -webkit-transition: all 0.2s;
}
.card-wizard .picture:hover {
  border-color: #2ca8ff;
}
.card-wizard .moving-tab {
  position: absolute;
  text-align: center;
  padding: 0.75rem;
  font-size: 1rem;
  text-transform: uppercase;
  -webkit-font-smoothing: subpixel-antialiased;
  top: 0px;
  left: 0px;
  background-color: #888888;
  color: #FFFFFF !important;
  cursor: pointer;
  font-weight: 400;
  line-height: 18px;
}
.card-wizard .picture input[type=file] {
  cursor: pointer;
  display: block;
  height: 100%;
  left: 0;
  opacity: 0 !important;
  position: absolute;
  top: 0;
  width: 100%;
}
.card-wizard .picture-src {
  width: 100%;
}
.card-wizard .tab-content {
  min-height: 355px;
  padding: 20px 0;
}
.card-wizard .wizard-footer {
  padding: 0 15px;
}
.card-wizard .wizard-footer .checkbox {
  margin-top: 16px;
}
.card-wizard .disabled {
  display: none;
}
.card-wizard .wizard-header {
  text-align: center;
  padding: 25px 0 35px;
}
.card-wizard .wizard-header h5 {
  margin: 5px 0 0;
}
.card-wizard .nav-pills > li {
  text-align: center;
}
.card-wizard .btn {
  text-transform: uppercase;
}
.card-wizard .info-text {
  text-align: center;
  font-weight: 300;
  margin: 10px 0 30px;
}
.card-wizard .choice {
  text-align: center;
  cursor: pointer;
  margin-top: 20px;
}
.card-wizard .choice[disabled] {
  pointer-events: none;
  cursor: not-allowed;
  opacity: 0.5;
}
.card-wizard .choice .icon {
  text-align: center;
  vertical-align: middle;
  height: 116px;
  width: 116px;
  border-radius: 50%;
  color: #888888;
  margin: 0 auto 20px;
  border: 1px solid #E3E3E3;
  transition: all 0.2s;
  -webkit-transition: all 0.2s;
}
.card-wizard .choice i {
  font-size: 30px;
  line-height: 116px;
  position: absolute;
  left: 0;
  right: 0;
}
.card-wizard .choice:hover .icon, .card-wizard .choice.active .icon {
  border-color: #2ca8ff;
}
.card-wizard .choice input[type=radio],
.card-wizard .choice input[type=checkbox] {
  position: absolute;
  left: -10000px;
  z-index: -1;
}
.card-wizard .btn-finish {
  display: none;
}
.card-wizard .card-title + .description {
  font-size: 3.875rem;
  margin-bottom: 32px;
}
.card-wizard .wizard-title {
  margin: 0;
}
.card-wizard .nav-pills {
  background-color: #58595B;
}
.card-wizard .nav-pills > li + li {
  margin-left: 0;
}
.card-wizard .nav-pills > li > a {
  border: 0 !important;
  border-radius: 0;
  line-height: 18px;
  text-transform: uppercase;
  font-size: 1rem;
  font-weight: 400;
  min-width: 100px;
  text-align: center;
  color: #FFFFFF !important;
}
.card-wizard .nav-pills > li.active > a,
.card-wizard .nav-pills > li.active > a:hover,
.card-wizard .nav-pills > li.active > a:focus,
.card-wizard .nav-pills > li > a:hover,
.card-wizard .nav-pills > li > a:focus {
  background-color: inherit;
  box-shadow: none;
}
.card-wizard .nav-pills > li i {
  display: block;
  font-size: 30px;
  padding: 15px 0;
}
.card-wizard .form-group.select-wizard {
  margin-top: 15px;
}
.card-wizard .dropdown.show .dropdown-menu,
.card-wizard .dropup.show .dropdown-menu {
  transform: translate3d(0, 0px, 0);
}

/*!
* https://github.com/YouCanBookMe/react-datetime
*/
.rdt {
  position: relative;
}
.rdt .form-control:read-only {
  background-color: #fff;
  cursor: pointer;
}
.rdt .rdtPicker {
  transition: all 150ms linear;
  margin-top: -20px;
  visibility: hidden;
  display: block;
  opacity: 0;
}
.rdt.rdtOpen .rdtPicker {
  opacity: 1;
  visibility: visible;
  margin-top: 0;
}

.rdtPicker {
  display: none;
  position: absolute;
  width: 260px;
  padding: 4px;
  margin-top: 1px;
  z-index: 99999 !important;
  background: #fff;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 10px;
  box-shadow: 1px 2px 3px rgba(0, 0, 0, 0.125);
  background-clip: padding-box;
  min-width: 160px;
}
.rdtPicker:before {
  border-bottom: 11px solid rgba(0, 0, 0, 0.2);
  border-left: 11px solid transparent;
  border-right: 11px solid transparent;
  content: "";
  display: inline-block;
  position: absolute;
  left: 12px;
  top: -11px;
}
.rdtPicker:after {
  border-bottom: 11px solid #ffffff;
  border-left: 11px solid transparent;
  border-right: 11px solid transparent;
  content: "";
  display: inline-block;
  position: absolute;
  left: 12px;
  top: -10px;
}

.rdtOpen .rdtPicker {
  display: block;
  top: 49px;
}

.rdtStatic .rdtPicker {
  box-shadow: none;
  position: static;
}

.rdtPicker .rdtTimeToggle {
  text-align: center;
  padding: 5px;
  border-radius: 4px;
}

.rdtPicker table {
  width: 100%;
  margin: 0;
  border-color: #FFFFFF !important;
}

.rdtPicker td,
.rdtPicker th {
  text-align: center;
  padding: 1px;
}

.rdtPicker td {
  cursor: pointer;
}

.rdtDay {
  height: 30px;
  line-height: 33px;
  width: 30px;
  text-align: center;
  padding: 0px;
  border-radius: 50%;
}
.rdtDay.rdtToday.rdtActive, .rdtDay.rdtActive, .rdtDay.rdtActive:hover {
  background-color: #0084CA !important;
  color: #FFFFFF;
}

.rdtDays tr .dow {
  text-align: center;
  border-bottom: 1px solid #e3e3e3;
  font-size: 12px;
  text-transform: uppercase;
  color: #9a9a9a;
  font-weight: 400;
  padding-bottom: 5px;
  padding-top: 10px;
}
.rdtDays tr .rdtOld,
.rdtDays tr .rdtNew {
  color: #A2A2A2;
}

.rdtPicker td.rdtDay:hover,
.rdtPicker td.rdtHour:hover,
.rdtPicker td.rdtMinute:hover,
.rdtPicker td.rdtSecond:hover,
.rdtPicker .rdtTimeToggle:hover {
  background: #eeeeee;
  cursor: pointer;
}

.rdtPicker td.rdtToday {
  position: relative;
}

.rdtPicker td.rdtActive.rdtToday:before {
  border-bottom-color: #fff;
}

.rdtPicker td.rdtDisabled,
.rdtPicker td.rdtDisabled:hover {
  background: none;
  color: #999999;
  cursor: not-allowed;
}

.rdtPicker td span.rdtOld {
  color: #999999;
}

.rdtPicker td span.rdtDisabled,
.rdtPicker td span.rdtDisabled:hover {
  background: none;
  color: #999999;
  cursor: not-allowed;
}

.rdtPicker .dow {
  width: 14.2857%;
  border-bottom: none;
}

.rdtPicker th.rdtSwitch {
  width: 50px;
  padding: 5px;
  border-radius: 4px;
}

.rdtPicker th.rdtNext,
.rdtPicker th.rdtPrev {
  font-size: 21px;
  vertical-align: top;
  border-radius: 50%;
  line-height: 33px;
}

.rdtPrev span,
.rdtNext span {
  display: block;
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Chrome/Safari/Opera */ /* Konqueror */ /* Firefox */ /* Internet Explorer/Edge */
  user-select: none;
}

.rdtPicker th.rdtDisabled,
.rdtPicker th.rdtDisabled:hover {
  background: none;
  color: #999999;
  cursor: not-allowed;
}

.rdtPicker thead tr:first-child th {
  cursor: pointer;
}

.rdtPicker thead tr:first-child th:hover {
  background: #eeeeee;
}

.rdtPicker button {
  border: none;
  background: none;
  cursor: pointer;
}

.rdtPicker button:hover {
  background-color: #eee;
}

.rdtPicker thead button {
  width: 100%;
  height: 100%;
}

td.rdtMonth,
td.rdtYear {
  height: 50px;
  width: 25%;
  cursor: pointer;
}

td.rdtMonth:hover,
td.rdtYear:hover {
  background: #eee;
}

.rdtCounters {
  display: inline-block;
}

.rdtCounters > div {
  float: left;
  width: 40px;
  font-weight: 300;
  margin: 3px;
  border-radius: 50%;
}
.rdtCounters .rdtCounterSeparator {
  width: 0;
  border: 1px solid transparent;
}

.rdtCounter {
  height: 100px;
}

.rdtCounter {
  width: 40px;
}
.rdtCounter .rdtCount {
  padding: 7px;
  height: 40px;
  border: 1px solid transparent;
}

.rdtCounters .rdtCounter:last-child .rdtCount {
  color: #0084CA;
  border-radius: 50%;
  border: 1px solid #0084CA;
}

.rdtCounterSeparator {
  padding: 7px;
  line-height: 100px;
}

.rdtCounter .rdtBtn {
  line-height: 40px;
  cursor: pointer;
  display: block;
  border-radius: 50%;
  color: #EAF0F4;
  transition: all 60ms ease-in;
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Chrome/Safari/Opera */ /* Konqueror */ /* Firefox */ /* Internet Explorer/Edge */
  user-select: none;
}

.rdtCounter .rdtBtn:hover {
  background: #eee;
  color: #797979;
}

.rdtCounter .rdtCount {
  font-size: 1.2em;
}

.rdtMilli {
  vertical-align: middle;
  padding-left: 8px;
  width: 48px;
}

.rdtMilli input {
  width: 100%;
  font-size: 1.2em;
  margin-top: 37px;
}

.rdtMonths,
.rdtYears {
  padding-bottom: 10px;
}
.rdtMonths .rdtMonth,
.rdtMonths .rdtYear,
.rdtYears .rdtMonth,
.rdtYears .rdtYear {
  display: inline-block;
  width: 56px;
  height: 56px;
  line-height: 56px;
  margin: 3px 3px;
  cursor: pointer;
  border-radius: 50%;
  text-align: center;
}
.rdtMonths .rdtMonth.rdtActive,
.rdtMonths .rdtYear.rdtActive,
.rdtYears .rdtMonth.rdtActive,
.rdtYears .rdtYear.rdtActive {
  background-color: #0084CA !important;
  color: #FFFFFF;
}

.rdtTime .rdtCounters .rdtCounterSeparator + .rdtCounter + .rdtCounter .rdtCount {
  font-size: 1rem;
}

.right {
  right: 0%;
}
.right:before {
  border-bottom: 11px solid rgba(0, 0, 0, 0.2);
  border-left: 11px solid transparent;
  border-right: 11px solid transparent;
  content: "";
  display: inline-block;
  position: absolute;
  right: 12px;
  top: -11px;
}
.right:after {
  border-bottom: 11px solid #ffffff;
  border-left: 11px solid transparent;
  border-right: 11px solid transparent;
  content: "";
  display: inline-block;
  position: absolute;
  right: 12px;
  left: "";
  top: -10px;
}

.left:before {
  border-bottom: 11px solid rgba(0, 0, 0, 0.2);
  border-left: 11px solid transparent;
  border-right: 11px solid transparent;
  content: "";
  display: inline-block;
  position: absolute;
  left: 12px;
  top: -11px;
}
.left:after {
  border-bottom: 11px solid #ffffff;
  border-left: 11px solid transparent;
  border-right: 11px solid transparent;
  content: "";
  display: inline-block;
  position: absolute;
  left: 12px;
  top: -10px;
}

.rna-container .alert button.close {
  color: #000;
  display: flex;
  justify-content: center;
  align-items: center;
}
.rna-container .alert button.close span {
  margin-top: -4px;
}

/**
* React Select v1.0.0-rc.10
* ============
* Created by Jed Watson and Joss Mackison for KeystoneJS, https://www.keystonejs.com/
* https://twitter.com/jedwatson https://twitter.com/jossmackison https://twitter.com/keystonejs
* MIT License: https://github.com/JedWatson/react-select
*/
/*
This file was modified entirely by Creative Tim for React-Select v2.0.0
*/
.react-select .react-select__menu {
  border-radius: 0;
  border-bottom-right-radius: 4px;
  border-bottom-left-radius: 4px;
  background-color: #fff;
  border: 1px solid #ccc;
  border-top-color: #e6e6e6;
  box-shadow: 0 1px 0 rgba(0, 0, 0, 0.06);
  box-sizing: border-box;
  margin-top: -1px;
  position: absolute;
  left: 0;
  top: 100%;
  width: 100%;
  z-index: 5;
  -webkit-overflow-scrolling: touch;
}
.react-select .react-select__menu-list {
  overflow-y: auto;
  padding-bottom: unset;
  padding-top: unset;
  position: relative;
  max-height: 200px;
}
.react-select .react-select__option {
  cursor: pointer;
  display: block;
  padding: 8px 10px;
}
.react-select .react-select__menu .react-select__option, .react-select .react-select__menu .react-select__option:active {
  background-color: transparent;
}
.react-select .react-select__menu .react-select__option.react-select__option--is-selected, .react-select .react-select__menu .react-select__option.react-select__option--is-selected:active, .react-select .react-select__menu .react-select__option.react-select__option--is-selected:not(:first-child), .react-select .react-select__menu .react-select__option.react-select__option--is-selected:not(:first-child):active, .react-select .react-select__menu .react-select__option.react-select__option--is-selected.react-select__option--is-focused:not(:first-child), .react-select .react-select__menu .react-select__option.react-select__option--is-selected.react-select__option--is-focused:not(:first-child):active {
  background-color: rgba(0, 126, 255, 0.04);
  color: #333;
}
.react-select .react-select__menu .react-select__option:not(:first-child).react-select__option--is-focused:not(:first-child), .react-select .react-select__menu .react-select__option:not(:first-child).react-select__option--is-focused:not(:first-child):active {
  background-color: rgba(0, 126, 255, 0.08);
  color: #333;
}
.react-select .react-select__menu .react-select__option.react-select__option--is-disabled, .react-select .react-select__menu .react-select__option.react-select__option--is-disabled:active {
  color: #cccccc;
  cursor: default;
}
.react-select .react-select__control {
  background-color: #FFFFFF;
  border-color: #d9d9d9 #ccc #b3b3b3;
  border-radius: 4px;
  border: 1px solid #ccc;
  min-height: 36px;
  height: 36px;
  box-sizing: border-box;
  border-collapse: separate;
  display: table;
  width: 100%;
}
.react-select .react-select__control.react-select__control--menu-is-open {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}
.react-select .react-select__control.react-select__control--is-focused .react-select__dropdown-indicator:after {
  transform: rotate(180deg);
  top: -4px;
}
.react-select .react-select__control.react-select__control--is-focused, .react-select .react-select__control.react-select__control--is-focused:hover {
  border: 1px solid #0084CA;
  box-shadow: none;
}
.react-select .react-select__control .react-select__value-container--has-value .react-select__multi-value {
  display: inline-flex;
  border-radius: 4px;
  background-color: transparent;
}
.react-select .react-select__control .react-select__value-container--has-value .react-select__multi-value + div:not(.react-select__multi-value) {
  display: inline-flex;
}
.react-select .react-select__control .react-select__value-container--has-value .react-select__multi-value .react-select__multi-value__label {
  font-size: 0.9em;
}
.react-select .react-select__control .react-select__value-container--has-value .react-select__single-value {
  top: 48%;
  color: #000000;
}
.react-select .react-select__control .react-select__placeholder {
  color: #EAF0F4;
  line-height: 34px;
  padding-left: 10px;
  padding-right: 10px;
  font-size: 14px;
  left: 0;
  margin-left: 0;
  margin-right: 0;
}
.react-select .react-select__control .react-select__value-container,
.react-select .react-select__control .react-select__indicators {
  display: table-cell;
}
.react-select .react-select__control .react-select__indicators {
  width: 60px;
  padding-right: 10px;
  align-items: flex-end;
  vertical-align: middle;
  text-align: right;
}
.react-select .react-select__control .react-select__indicators .react-select__indicator-separator {
  display: none;
}
.react-select .react-select__control .react-select__indicators .react-select__indicator {
  padding: 0;
  display: inline-block;
}
.react-select .react-select__control .react-select__indicators .react-select__dropdown-indicator:after {
  transition: all 150ms ease 0s;
  border-color: #999 transparent transparent;
  border-style: solid;
  border-width: 5px 5px 2.5px;
  display: inline-block;
  height: 0;
  width: 0;
  position: relative;
  content: "";
}
.react-select .react-select__control .react-select__indicators .react-select__dropdown-indicator:hover:after {
  border-top-color: #666666;
}
.react-select .react-select__control .react-select__indicators .react-select__dropdown-indicator > * {
  display: none;
}
.react-select .react-select__control .react-select__indicators .react-select__clear-indicator:before {
  content: "×";
  display: inline-block;
  font-size: 18px;
  line-height: 1;
  top: 2px;
  position: relative;
  margin-right: 3px;
}
.react-select .react-select__control .react-select__indicators .react-select__clear-indicator > * {
  display: none;
}
.react-select.primary .react-select__control.react-select__control--is-focused, .react-select.primary .react-select__control.react-select__control--is-focused:hover {
  border-color: #0084CA;
}
.react-select.primary .react-select__control .react-select__value-container--has-value .react-select__single-value,
.react-select.primary .react-select__control .react-select__value-container--has-value .react-select__multi-value__label {
  color: #0084CA;
}
.react-select.primary .react-select__multi-value {
  border: 1px solid #0084CA;
}
.react-select.primary .react-select__multi-value .react-select__multi-value__remove {
  color: rgb(0, 115.3366336634, 176.5);
  border-left: 1px solid rgb(0, 115.3366336634, 176.5);
}
.react-select.primary .react-select__multi-value .react-select__multi-value__remove:hover {
  color: #0084CA;
  background-color: transparent;
}
.react-select.success .react-select__control.react-select__control--is-focused, .react-select.success .react-select__control.react-select__control--is-focused:hover {
  border-color: #7ABA09;
}
.react-select.success .react-select__control .react-select__value-container--has-value .react-select__single-value,
.react-select.success .react-select__control .react-select__value-container--has-value .react-select__multi-value__label {
  color: #7ABA09;
}
.react-select.success .react-select__multi-value {
  border: 1px solid #7ABA09;
}
.react-select.success .react-select__multi-value .react-select__multi-value__remove {
  color: rgb(106.0461538462, 161.6769230769, 7.8230769231);
  border-left: 1px solid rgb(106.0461538462, 161.6769230769, 7.8230769231);
}
.react-select.success .react-select__multi-value .react-select__multi-value__remove:hover {
  color: #7ABA09;
  background-color: transparent;
}
.react-select.info .react-select__control.react-select__control--is-focused, .react-select.info .react-select__control.react-select__control--is-focused:hover {
  border-color: #003380;
}
.react-select.info .react-select__control .react-select__value-container--has-value .react-select__single-value,
.react-select.info .react-select__control .react-select__value-container--has-value .react-select__multi-value__label {
  color: #003380;
}
.react-select.info .react-select__multi-value {
  border: 1px solid #003380;
}
.react-select.info .react-select__multi-value .react-select__multi-value__remove {
  color: rgb(0, 38.8078125, 97.4);
  border-left: 1px solid rgb(0, 38.8078125, 97.4);
}
.react-select.info .react-select__multi-value .react-select__multi-value__remove:hover {
  color: #003380;
  background-color: transparent;
}
.react-select.warning .react-select__control.react-select__control--is-focused, .react-select.warning .react-select__control.react-select__control--is-focused:hover {
  border-color: #FFE200;
}
.react-select.warning .react-select__control .react-select__value-container--has-value .react-select__single-value,
.react-select.warning .react-select__control .react-select__value-container--has-value .react-select__multi-value__label {
  color: #FFE200;
}
.react-select.warning .react-select__multi-value {
  border: 1px solid #FFE200;
}
.react-select.warning .react-select__multi-value .react-select__multi-value__remove {
  color: rgb(219.3, 194.36, 0);
  border-left: 1px solid rgb(219.3, 194.36, 0);
}
.react-select.warning .react-select__multi-value .react-select__multi-value__remove:hover {
  color: #FFE200;
  background-color: transparent;
}
.react-select.danger .react-select__control.react-select__control--is-focused, .react-select.danger .react-select__control.react-select__control--is-focused:hover {
  border-color: #D61F05;
}
.react-select.danger .react-select__control .react-select__value-container--has-value .react-select__single-value,
.react-select.danger .react-select__control .react-select__value-container--has-value .react-select__multi-value__label {
  color: #D61F05;
}
.react-select.danger .react-select__multi-value {
  border: 1px solid #D61F05;
}
.react-select.danger .react-select__multi-value .react-select__multi-value__remove {
  color: rgb(174.1315068493, 25.2246575342, 4.0684931507);
  border-left: 1px solid rgb(174.1315068493, 25.2246575342, 4.0684931507);
}
.react-select.danger .react-select__multi-value .react-select__multi-value__remove:hover {
  color: #D61F05;
  background-color: transparent;
}
.react-select .react-select__multi-value {
  border: 1px solid #58595B;
}
.react-select .react-select__multi-value .react-select__multi-value__remove {
  position: relative;
  color: #EAF0F4;
  border-left: 1px solid #EAF0F4;
}
.react-select .react-select__multi-value .react-select__multi-value__remove:hover {
  color: #58595B;
  background-color: transparent;
}
.react-select.react-select--is-disabled .react-select__multi-value--is-disabled .react-select__multi-value__remove {
  display: none;
}
.react-select.react-select--is-disabled .react-select__multi-value--is-disabled.react-select__multi-value {
  background-color: #fcfcfc;
  border: 1px solid #e3e3e3;
}
.react-select.react-select--is-disabled .react-select__control--is-disabled {
  background-color: #f9f9f9;
}

/*      light colors         */
.ReactTable {
  position: relative;
  display: flex;
  flex-direction: column;
  background-color: transparent;
}

.ReactTable .actions-right {
  text-align: right;
}
.ReactTable .actions-left {
  text-align: left;
}
.ReactTable .actions-center {
  text-align: center;
}

.ReactTable * {
  box-sizing: border-box;
}

.ReactTable .rt-table {
  flex: auto 1;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  width: 100%;
  border-collapse: collapse;
  overflow: auto;
  table-layout: fixed;
}

.ReactTable .rt-thead {
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
  -webkit-user-select: none;
  user-select: none;
}

.ReactTable .rt-thead.-headerGroups {
  background: rgba(0, 0, 0, 0.03);
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
}

.ReactTable .rt-thead.-filters {
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
}

.ReactTable .rt-thead.-filters input,
.ReactTable .rt-thead.-filters select {
  border: 1px solid #e3e3e3;
  border-radius: 4px;
  color: #565656;
  font-weight: 400;
  height: 36px;
  background-color: inherit;
  padding-left: 0.8em;
}
.ReactTable .rt-thead.-filters input:focus,
.ReactTable .rt-thead.-filters select:focus {
  outline: none;
  border: 1px solid #aaa;
  color: #333;
}

.ReactTable .rt-thead .rt-tr {
  text-align: center;
}

.ReactTable .rt-thead .rt-th:last-child {
  text-align: right;
  margin: unset;
}

.ReactTable .rt-thead .rt-th.-cursor-pointer > div:first-of-type:after {
  opacity: 0.4;
  content: "\\f0dc";
  position: relative;
  display: inline-block;
  bottom: 0;
  right: -7px;
  font-family: "Font Awesome 5 Pro";
  font-weight: 900;
}

.ReactTable .rt-thead .rt-th.-cursor-pointer.-sort-desc > div:first-of-type:after {
  content: "\\f0dd";
  top: -3px;
  position: relative;
  display: inline-block;
  bottom: 0;
  right: -7px;
  font-family: "Font Awesome 5 Pro";
  font-weight: 900;
  opacity: 0.8;
}

.ReactTable .rt-thead .rt-th.-cursor-pointer.-sort-asc > div:first-of-type:after {
  content: "\\f0de";
  top: 3px;
  position: relative;
  display: inline-block;
  bottom: 0;
  right: -7px;
  font-family: "Font Awesome 5 Pro";
  font-weight: 900;
  opacity: 0.8;
}

.ReactTable .rt-thead .rt-th,
.ReactTable .rt-thead .rt-td {
  font-size: 1.063rem;
  text-align: left;
  font-weight: 300;
  line-height: 2.5em !important;
  padding: 5px 5px;
  line-height: normal;
  position: relative;
  transition: box-shadow 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  box-shadow: inset 0 0 0 0 transparent;
  overflow: hidden;
  white-space: nowrap;
  -moz-text-overflow: ellipsis;
  -ms-text-overflow: ellipsis;
  text-overflow: ellipsis;
}

.ReactTable .rt-thead .rt-th.-cursor-pointer,
.ReactTable .rt-thead .rt-td.-cursor-pointer {
  cursor: pointer;
}

.ReactTable .rt-thead .rt-th:last-child,
.ReactTable .rt-thead .rt-td:last-child {
  border-right: 0;
}

.ReactTable .rt-thead .rt-resizable-header {
  overflow: visible;
}

.ReactTable .rt-thead .rt-resizable-header:last-child {
  overflow: hidden;
}

.ReactTable .rt-thead .rt-resizable-header-content {
  overflow: hidden;
  text-overflow: ellipsis;
}
.ReactTable .rt-thead .rt-resizable-header-content:focus {
  outline: none;
}

.ReactTable .rt-thead .rt-header-pivot {
  border-right-color: #f7f7f7;
}

.ReactTable .rt-thead .rt-header-pivot:after,
.ReactTable .rt-thead .rt-header-pivot:before {
  left: 100%;
  top: 50%;
  border: solid transparent;
  content: " ";
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
}

.ReactTable .rt-thead .rt-header-pivot:after {
  border-color: rgba(255, 255, 255, 0);
  border-left-color: #fff;
  border-width: 8px;
  margin-top: -8px;
}

.ReactTable .rt-thead .rt-header-pivot:before {
  border-color: rgba(102, 102, 102, 0);
  border-left-color: #f7f7f7;
  border-width: 10px;
  margin-top: -10px;
}

.ReactTable .rt-tbody {
  flex: 99999 1 auto;
  display: flex;
  flex-direction: column;
  overflow: auto;
}

.ReactTable .rt-tbody .rt-tr-group {
  border-bottom: solid 1px rgba(0, 0, 0, 0.05);
}

.ReactTable .rt-tbody .rt-tr-group:last-child {
  border-bottom: 0;
}

.ReactTable .rt-tbody .rt-td:last-child {
  border-right: 0;
}

.ReactTable .rt-tbody .rt-expandable {
  cursor: pointer;
}

.ReactTable .rt-tr-group {
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
  align-items: stretch;
}

.ReactTable .rt-tr {
  flex: 1 0 auto;
  display: inline-flex;
}

.ReactTable .rt-th,
.ReactTable .rt-td {
  flex: 1 0;
  white-space: unset;
  text-overflow: ellipsis;
  padding: 7px 5px;
  overflow: hidden;
  transition: 0.3s ease;
  transition-property: width, min-width, padding, opacity;
  margin: auto;
}

.ReactTable .rt-th.-hidden,
.ReactTable .rt-td.-hidden {
  width: 0 !important;
  min-width: 0 !important;
  padding: 0 !important;
  border: 0 !important;
  opacity: 0 !important;
}

.ReactTable .rt-expander {
  display: inline-block;
  position: relative;
  margin: 0;
  color: transparent;
  margin: 0 10px;
}

.ReactTable .rt-expander:after {
  content: "";
  position: absolute;
  width: 0;
  height: 0;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) rotate(-90deg);
  border-left: 5.04px solid transparent;
  border-right: 5.04px solid transparent;
  border-top: 7px solid rgba(0, 0, 0, 0.8);
  transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  cursor: pointer;
}

.ReactTable .rt-expander.-open:after {
  transform: translate(-50%, -50%) rotate(0);
}

.ReactTable .rt-resizer {
  display: inline-block;
  position: absolute;
  width: 36px;
  top: 0;
  bottom: 0;
  right: -18px;
  cursor: col-resize;
  z-index: 10;
}

.ReactTable .rt-tfoot {
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
  box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.15);
}

.ReactTable .rt-tfoot .rt-td {
  border-right: 1px solid rgba(0, 0, 0, 0.05);
}

.ReactTable .rt-tfoot .rt-td:last-child {
  border-right: 0;
}

.ReactTable.-striped .rt-tr.-odd {
  background: rgba(0, 0, 0, 0.03);
}

.ReactTable.-highlight .rt-tbody .rt-tr:not(.-padRow):hover {
  background: rgba(0, 0, 0, 0.05);
}

.ReactTable .-pagination {
  z-index: 1;
  display: flex;
  justify-content: space-between;
  align-items: stretch;
  flex-wrap: wrap;
  padding: 3px;
}

.ReactTable .-pagination input,
.ReactTable .-pagination select {
  border: 1px solid #e3e3e3;
  border-radius: 4px;
  color: #565656;
  font-weight: 400;
  height: 36px;
  background-color: inherit;
  text-align: center;
}
.ReactTable .-pagination input:focus,
.ReactTable .-pagination select:focus {
  outline: none;
  border: 1px solid #aaa;
  color: #333;
}

.ReactTable .-pagination .-btn {
  appearance: none;
  display: block;
  width: 100%;
  height: 100%;
  border: 0;
  border-radius: 3px;
  padding: 6px;
  font-size: 1em;
  color: #FFFFFF;
  background: #0084CA;
  transition: all 0.1s ease;
  cursor: pointer;
  outline: none;
}

.ReactTable .-pagination .-btn[disabled] {
  opacity: 0.5;
  cursor: not-allowed;
}

.ReactTable .-pagination .-btn:not([disabled]):hover {
  background: rgb(0, 115.3366336634, 176.5);
  color: #FFFFFF;
}

.ReactTable .-pagination .-previous,
.ReactTable .-pagination .-next {
  flex: 1 1;
  text-align: center;
}

.ReactTable .-pagination .-center {
  flex: 1.5 1;
  text-align: center;
  margin-bottom: 0;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-around;
}

.ReactTable .-pagination .-pageInfo {
  display: inline-block;
  margin: 3px 10px;
  white-space: nowrap;
}

.ReactTable .-pagination .-pageJump {
  display: inline-block;
}

.ReactTable .-pagination .-pageSizeOptions {
  margin: 3px 10px;
}

.ReactTable .rt-noData {
  display: block;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  background: rgba(255, 255, 255, 0.8);
  transition: all 0.3s ease;
  z-index: 1;
  pointer-events: none;
  padding: 20px;
  color: rgba(0, 0, 0, 0.5);
}

.ReactTable .-loading {
  display: block;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.8);
  transition: all 0.3s ease;
  z-index: -1;
  opacity: 0;
  pointer-events: none;
}

.ReactTable .-loading > div {
  position: absolute;
  display: block;
  text-align: center;
  width: 100%;
  top: 50%;
  left: 0;
  font-size: 15px;
  color: rgba(0, 0, 0, 0.6);
  transform: translateY(-52%);
  transition: all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

.ReactTable .-loading.-active {
  opacity: 1;
  z-index: 2;
  pointer-events: all;
}

.ReactTable .-loading.-active > div {
  transform: translateY(50%);
}

.ReactTable .rt-resizing .rt-th,
.ReactTable .rt-resizing .rt-td {
  transition: none !important;
  cursor: col-resize;
  -webkit-user-select: none;
  user-select: none;
}

.ReactTable .rt-thead .rt-th:focus {
  outline: none;
}

.ReactTable .rt-thead .rt-th {
  font-size: 12px;
  text-transform: uppercase;
  color: #9a9a9a;
  font-weight: 400;
}

.resizer {
  display: inline-block;
  background: blue;
  width: 10px;
  height: 100%;
  position: absolute;
  right: 0;
  top: 0;
  transform: translateX(50%);
  touch-action: none;
}
.resizer.isResizing {
  background: red;
}

.alert {
  border-radius: 0.25rem;
}

.fixed-plugin {
  background-color: unset;
}
.fixed-plugin .dropdown-toggle,
.fixed-plugin .dropdown-toggle:focus,
.fixed-plugin .dropdown-toggle:active {
  background-color: rgba(0, 0, 0, 0.3) !important;
  border: none !important;
  padding: 0;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}
.fixed-plugin .dropdown-toggle .fa-cogs,
.fixed-plugin .dropdown-toggle:focus .fa-cogs,
.fixed-plugin .dropdown-toggle:active .fa-cogs {
  padding-left: 15px;
  padding-right: 15px;
}
.fixed-plugin .dropdown-toggle::after,
.fixed-plugin .dropdown-toggle:focus::after,
.fixed-plugin .dropdown-toggle:active::after {
  display: none;
}

.navbar {
  min-height: unset;
  max-height: unset;
}
.navbar .btn,
.navbar .navbar-brand,
.navbar .navbar-nav .nav-item .nav-link {
  margin: unset;
  align-items: center;
}
.navbar .navbar-nav .dropdown-toggle:after {
  margin-top: 0px;
}

@media (min-width: 992px) {
  .navbar .navbar-nav .nc-icon {
    margin-top: unset;
  }
  .navbar .navbar-nav .notification {
    top: 0px;
  }
}
@media (max-width: 991.98px) {
  .navbar-expand-lg > .container,
  .navbar-expand-lg > .container-fluid,
  .navbar-expand-lg > .container-lg,
  .navbar-expand-lg > .container-md,
  .navbar-expand-lg > .container-sm,
  .navbar-expand-lg > .container-xl {
    padding-right: 15px;
    padding-left: 15px;
  }
}
.card-header-tabs {
  border-bottom: 1px solid #dee2e6;
}

.sidebar[data-color=black]:after {
  background: #282828;
  background: linear-gradient(to bottom, #282828 0%, rgba(17, 17, 17, 0.7) 100%);
  background-size: 150% 150%;
}
.sidebar .logo a.logo-mini, .sidebar .logo-img {
  width: 40px;
}
.sidebar .logo a.logo-mini {
  margin-right: 5px;
}
.sidebar .logo-img img {
  width: 40px;
  top: 6px;
}

.sidebar-mini .sidebar .nav .nav-item .nav-link {
  padding: 10px 12px;
}
.sidebar-mini .sidebar:hover .nav .nav-item .nav-link {
  padding: 10px 15px;
}
.sidebar-mini .main-panel .navbar.fixed-top {
  margin-left: auto;
  width: calc(100% - 80px);
}

.close-layer {
  display: none;
  pointer-events: none;
  width: 0;
  height: 0;
}

@media (max-width: 991px) {
  .nav-open .close-layer {
    width: 100%;
    height: 100%;
    pointer-events: auto;
    display: block;
    opacity: 1;
  }
}
.main-panel .navbar.fixed-top {
  margin-left: auto;
  width: calc(100% - 260px);
}

.full-page[data-color=black]:after {
  background: #282828;
  background: linear-gradient(180deg, #282828 0, rgba(17, 17, 17, 0.4));
  opacity: 0.9;
}

.custom-switch {
  min-height: 26px;
  min-width: 62px;
  padding: 0;
}
.custom-switch .custom-control-label::after {
  width: 22px !important;
  height: 22px !important;
  border-radius: 22px;
  transition: all 0.15s ease-in-out;
  top: 2px;
  left: 2px;
  background-color: white;
}
.custom-switch .custom-control-label::before {
  width: 62px !important;
  height: 26px !important;
  border-radius: 26px;
  left: 0;
  top: 0;
  border: #ddd;
  background: #ddd;
}
.custom-switch .custom-control-input:checked ~ .custom-control-label::after {
  transform: translateX(36px);
}
.custom-switch:hover .custom-control-input:checked ~ .custom-control-label::after {
  margin-left: -6px;
}
.custom-switch:hover .custom-control-label::after {
  width: 28px !important;
}

.react-tagsinput {
  background-color: #fff;
  border-bottom: 2px solid #efefef;
  overflow: hidden;
  padding-top: 5px;
  transition: all 60ms ease-in;
}

.react-tagsinput--focused {
  border-bottom: 2px solid #2196f3;
}

.react-tagsinput-tag {
  cursor: pointer;
  overflow: hidden;
  position: relative;
  margin: 5px 3px 5px 0;
  padding: 2px 12px;
  border: 1px solid #888888;
  border-radius: 3px;
  color: #888888;
  font-weight: 500;
  font-size: 12px;
  text-transform: uppercase;
  display: inline-block;
  vertical-align: middle;
  transition: all 60ms ease-in;
}
.react-tagsinput-tag:hover {
  padding-left: 8px;
  padding-right: 16px;
}
.react-tagsinput-tag:hover a {
  opacity: 1;
  padding-right: 4px;
}
.react-tagsinput-tag a {
  transition: all 60ms ease-in;
  color: #888888;
  cursor: pointer;
  font-size: 12px;
  padding: 2px 0;
  position: absolute;
  right: 0;
  opacity: 0;
  text-align: right;
  text-decoration: none;
  top: 0;
  width: 100%;
  z-index: 2;
}
.react-tagsinput-tag a::before {
  content: "\\f00d";
  font-family: "Font Awesome 5 Free";
  font-weight: 900;
}
.react-tagsinput-tag.tag-blue, .react-tagsinput-tag.tag-blue a {
  border-color: #0084CA;
  color: #0084CA;
}
.react-tagsinput-tag.tag-azure, .react-tagsinput-tag.tag-azure a {
  border-color: #003380;
  color: #003380;
}
.react-tagsinput-tag.tag-green, .react-tagsinput-tag.tag-green a {
  border-color: #7ABA09;
  color: #7ABA09;
}
.react-tagsinput-tag.tag-orange, .react-tagsinput-tag.tag-orange a {
  border-color: #FFE200;
  color: #FFE200;
}
.react-tagsinput-tag.tag-red, .react-tagsinput-tag.tag-red a {
  border-color: #D61F05;
  color: #D61F05;
}
.react-tagsinput-tag.tag-fill.tag-blue {
  border-color: #0084CA;
  color: #FFFFFF;
  background-color: #0084CA;
}
.react-tagsinput-tag.tag-fill.tag-azure {
  border-color: #003380;
  color: #FFFFFF;
  background-color: #003380;
}
.react-tagsinput-tag.tag-fill.tag-green {
  border-color: #7ABA09;
  color: #FFFFFF;
  background-color: #7ABA09;
}
.react-tagsinput-tag.tag-fill.tag-orange {
  border-color: #FFE200;
  color: #FFFFFF;
  background-color: #FFE200;
}
.react-tagsinput-tag.tag-fill.tag-red {
  border-color: #D61F05;
  color: #FFFFFF;
  background-color: #D61F05;
}
.react-tagsinput-tag.tag-fill, .react-tagsinput-tag.tag-fill a {
  color: #FFFFFF;
}

.react-tagsinput-remove {
  cursor: pointer;
  font-weight: bold;
}

.react-tagsinput-input {
  background: transparent;
  border: 0;
  color: #777;
  font-family: sans-serif;
  font-size: 13px;
  font-weight: 400;
  margin-bottom: 6px;
  margin-top: 1px;
  outline: none;
  padding: 5px;
  width: 80px;
}`, "",{"version":3,"sources":["webpack://./src/assets/scss/light-bootstrap-dashboard-pro-react.scss","webpack://./src/assets/scss/lbd/_variables.scss","webpack://./src/assets/scss/lbd/mixins/_morphing-buttons.scss","webpack://./src/assets/scss/lbd/_modals.scss","webpack://./src/assets/scss/lbd/_typography.scss","webpack://./node_modules/bootstrap/scss/mixins/_forms.scss","webpack://./node_modules/bootstrap/scss/_variables.scss","webpack://./node_modules/bootstrap/scss/vendor/_rfs.scss","webpack://./node_modules/bootstrap/scss/mixins/_border-radius.scss","webpack://./src/assets/scss/lbd/_misc.scss","webpack://./src/assets/scss/lbd/mixins/_vendor-prefixes.scss","webpack://./src/assets/scss/lbd/_sidebar-and-main-panel.scss","webpack://./src/assets/scss/lbd/_fixed-plugin.scss","webpack://./src/assets/scss/lbd/_modal.scss","webpack://./src/assets/scss/lbd/_buttons.scss","webpack://./src/assets/scss/lbd/mixins/_buttons.scss","webpack://./src/assets/scss/lbd/mixins/_transparency.scss","webpack://./src/assets/scss/lbd/_social-buttons.scss","webpack://./src/assets/scss/lbd/mixins/_social-buttons.scss","webpack://./src/assets/scss/lbd/_inputs.scss","webpack://./src/assets/scss/lbd/mixins/_inputs.scss","webpack://./src/assets/scss/lbd/_alerts.scss","webpack://./src/assets/scss/lbd/_tables.scss","webpack://./src/assets/scss/lbd/mixins/_table-row.scss","webpack://./src/assets/scss/lbd/_checkbox-radio-switch.scss","webpack://./src/assets/scss/lbd/_navbars.scss","webpack://./src/assets/scss/lbd/mixins/_navbars.scss","webpack://./src/assets/scss/lbd/_footers.scss","webpack://./src/assets/scss/lbd/_tags.scss","webpack://./src/assets/scss/lbd/mixins/_labels.scss","webpack://./src/assets/scss/lbd/_tabs-navs-pagination.scss","webpack://./src/assets/scss/lbd/mixins/_tabs.scss","webpack://./src/assets/scss/lbd/_progress-bars.scss","webpack://./src/assets/scss/lbd/_sliders.scss","webpack://./src/assets/scss/lbd/_dropdown.scss","webpack://./src/assets/scss/lbd/_cards.scss","webpack://./src/assets/scss/lbd/_chartist.scss","webpack://./src/assets/scss/lbd/mixins/_chartist.scss","webpack://./src/assets/scss/lbd/_responsive.scss","webpack://./src/assets/scss/lbd/_bootstrap-switch.scss","webpack://./src/assets/scss/lbd/_partial-nucleo-icons.scss","webpack://./src/assets/scss/lbd/plugins/_animate.scss","webpack://./src/assets/scss/lbd/plugins/_sweetalert2.scss","webpack://./src/assets/scss/lbd/plugins/_jquery.jvectormap.scss","webpack://./src/assets/scss/lbd/plugins/_bootstrap-table.scss","webpack://./src/assets/scss/lbd/plugins/_datatables.net.scss","webpack://./src/assets/scss/lbd/plugins/_fullcalendar.scss","webpack://./src/assets/scss/lbd/plugins/_chartist.scss","webpack://./src/assets/scss/lbd/plugins/_perfect-scrollbar.scss","webpack://./src/assets/scss/lbd/plugins/_bootstrap-select.scss","webpack://./src/assets/scss/lbd/plugins/_datetime-picker.scss","webpack://./src/assets/scss/lbd/plugins/_nouislider.scss","webpack://./src/assets/scss/lbdpr/plugins/_nouislider.scss","webpack://./src/assets/scss/lbdpr/plugins/_react-big-calendar.scss","webpack://./src/assets/scss/lbdpr/plugins/_react-bootstrap-sweetalert.scss","webpack://./src/assets/scss/lbdpr/plugins/_react-bootstrap-wizard.scss","webpack://./src/assets/scss/lbdpr/_mixins.scss","webpack://./src/assets/scss/lbdpr/plugins/_react-datetime.scss","webpack://./src/assets/scss/lbdpr/plugins/_react-notification-alert.scss","webpack://./src/assets/scss/lbdpr/plugins/_react-select.scss","webpack://./src/assets/scss/lbdpr/plugins/_react-table.scss","webpack://./src/assets/scss/lbdpr/_alerts.scss","webpack://./src/assets/scss/lbdpr/_fixed-plugin.scss","webpack://./src/assets/scss/lbdpr/_navbars.scss","webpack://./src/assets/scss/lbdpr/_navs.scss","webpack://./src/assets/scss/lbdpr/_sidebar-and-main-panel.scss","webpack://./src/assets/scss/lbdpr/_switch.scss","webpack://./src/assets/scss/lbdpr/_tags-input.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;;;;;;;;;;;;;;EAAA;ACYA,8BAAA;ACGA;EACI;IAAO,uBAAA;EFIT;EEHE;IAAK,yBAAA;EFMP;AACF;AGtBQ;EAGI,4BAAA;AHgDZ;AG5CQ;EACI,gBAAA;EACA,cAAA;AH8CZ;AG1CQ;EACI,mBAAA;EACA,iBAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;AH4CZ;AG1CY;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,+CAAA;AH4ChB;AG1CgB;EACI,eAAA;EACA,iBAAA;AH4CpB;AGvCQ;EACI,iBAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;EACA,gBAAA;AHyCZ;AGtCQ;EACI,cAAA;AHwCZ;AGrCQ;EACI,gBAAA;EACA,mBAAA;EACA,oBAAA;EACA,kBAAA;EAEA,8BAAA;AHuCZ;AGrCY;EACI,SAAA;EACA,kBAAA;EACA,mBAAA;EACA,WAAA;AHuChB;AGrCgB;EAEI,qBAAA;AHsCpB;;AIvGA,kCAAA;AACA;;;;;;;;;;;;;;;;EAgBI,kCAAA;EACA,mCAAA;EACA,0DAAA;EACA,gBHgMyB;ADtF7B;;AIvGA;EACI,mBH8K2B;ADpE/B;;AIvGA;EACI,gBHuLyB;EGtLzB,mBAAA;AJ0GJ;;AIvGA;EACI,kBHwK2B;AD9D/B;;AIxGA;EACI,kBHsK2B;AD3D/B;;AIzGA;EACI,kBHoK2B;EGnK3B,mBAAA;AJ4GJ;;AI1GA;EACI,mBHiK2B;EGhK3B,iBAAA;AJ6GJ;;AI3GA;EACI,mBH8J2B;EG7J3B,mBAAA;AJ8GJ;;AI5GA;EACI,mBH2J2B;EG1J3B,gBHkKyB;EGjKzB,yBAAA;AJ+GJ;;AI7GA;EACI,eHuJ2B;EGtJ3B,gBH+J2B;AD/C/B;;AI7GA;EACI,cH/ByB;EGgCzB,gBHqJyB;EGpJzB,gBHyJ2B;ADzC/B;;AI7GA;EACI,cAAA;AJgHJ;;AI7GA;EACI,cAAA;EACA,gBAAA;AJgHJ;;AI7GA;EACI,cAAA;AJgHJ;;AI9GA;EACI,yBAAA;AJiHJ;;AI/GA;EACI,yBAAA;AJkHJ;;AIhHA;EACI,yBAAA;AJmHJ;;AIjHA;EACI,yBAAA;AJoHJ;;AIlHA;EACI,yBAAA;AJqHJ;;AIlHA;EACI,mBAAA;EACA,mBAAA;EACA,kBAAA;AJqHJ;AInHI;EACI,2BAAA;EACA,QAAA;EACA,SAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AJqHR;;AIjHA;EACI,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,2BAAA;AJoHJ;;AK7ME;EACE,aAAA;EACA,WAAA;EACA,mBCu0BoC;ECrkBlC,kBALI;EF1PN,cJwaqB;ADzNzB;;AK5ME;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,uBAAA;EACA,kBAAA;EEqPE,sBALI;EF7ON,WAxBc;EAyBd,wCAxBiB;EGHjB,sCAAA;AR0OJ;;AK1MI;;;;EAEE,cAAA;AL+MN;;AK9PI;EAqDE,qBJ6YmB;EI1YjB,oCC81BgC;ED71BhC,yDAAA;EACA,4BAAA;EACA,2DAAA;EACA,gEAAA;AL2MR;AKxMM;EACE,qBJkYiB;EI7Xf,iDApDW;AL0PrB;;AK3QI;EA+EI,oCCu0BgC;EDt0BhC,kFAAA;ALgMR;;AKhRI;EAuFE,qBJ2WmB;AD9KzB;AK1LQ;EAEE,iEAAA;EACA,uBCq5B8B;EDp5B9B,+DAAA;EACA,2EAAA;AL2LV;AKvLM;EACE,qBJ8ViB;EIzVf,iDAxFW;AL6QrB;;AK9RI;EAkHI,yCAAA;ALgLR;;AKlSI;EAyHE,qBJyUmB;AD5JzB;AK3KM;EACE,yBJsUiB;ADzJzB;AK1KM;EACE,iDA/Ga;AL2RrB;AKzKM;EACE,cJ8TiB;ADnJzB;;AKtKI;EACE,kBAAA;ALyKN;;AKnTI;;;;;EAoJM,UAAA;ALuKV;;AKvSE;EACE,aAAA;EACA,WAAA;EACA,mBCu0BoC;ECrkBlC,kBALI;EF1PN,cJwaqB;AD/HzB;;AKtSE;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,aAAA;EACA,eAAA;EACA,uBAAA;EACA,kBAAA;EEqPE,sBALI;EF7ON,WAxBc;EAyBd,uCAxBiB;EGHjB,sCAAA;ARoUJ;;AKpSI;;;;EAEE,cAAA;ALySN;;AKxVI;EAqDE,qBJ6YmB;EI1YjB,oCC81BgC;ED71BhC,yDAAA;EACA,4BAAA;EACA,2DAAA;EACA,gEAAA;ALqSR;AKlSM;EACE,qBJkYiB;EI7Xf,gDApDW;ALoVrB;;AKrWI;EA+EI,oCCu0BgC;EDt0BhC,kFAAA;AL0RR;;AK1WI;EAuFE,qBJ2WmB;ADpFzB;AKpRQ;EAEE,iEAAA;EACA,uBCq5B8B;EDp5B9B,+DAAA;EACA,2EAAA;ALqRV;AKjRM;EACE,qBJ8ViB;EIzVf,gDAxFW;ALuWrB;;AKxXI;EAkHI,yCAAA;AL0QR;;AK5XI;EAyHE,qBJyUmB;ADlEzB;AKrQM;EACE,yBJsUiB;AD/DzB;AKpQM;EACE,gDA/Ga;ALqXrB;AKnQM;EACE,cJ8TiB;ADzDzB;;AKhQI;EACE,kBAAA;ALmQN;;AK7YI;;;;;EAsJM,UAAA;AL+PV;;AS3ZA,8BAAA;AACA;;EAEI,iBAAA;EACA,kBAAA;AT8ZJ;;AS5ZA;EACE,cRCsB;AD8ZxB;AS7ZE;EACG,+BRuHwB;EQtHxB,qBAAA;AT+ZL;;AS3ZA;;;;;;;;EAQI,UAAA;AT8ZJ;;AS5ZA;;;EAGI,qBAAA;AT+ZJ;;AS5ZA,sCAAA;AACA;;;;;ECKI,4BAAA;AVmaJ;;AS/ZA;;;;;;ECJI,4BAAA;AVgbJ;;ASnaA;;ECbI,6BAAA;AVybJ;;ASvaA;EClBI,4BAAA;AVicJ;;AS5aA;EACI,WAAA;EACA,kBAAA;AT+aJ;;AS7aA;EACI,gBAAA;ATgbJ;;AS7aA;EACI,kBAAA;EACA,MAAA;EACA,aAAA;ATgbJ;;AS7aA;EACI,aAAA;ATgbJ;AS9aI;EACI,aAAA;ATgbR;;ASxaI;EACI,kCAAA;EACA,sBAAA;EACA,aAAA;EACA,gBAAA;EACA,WAAA;EACA,UAAA;AT2aR;ASzaI;EACI,WAAA;EACA,kBAAA;EACA,UAAA;EACA,UAAA;AT2aR;ASzaI;EACI,6GAAA;EACA,WAAA;EACA,cAAA;EACA,aAAA;EACA,OAAA;EACA,aAAA;EACA,kBAAA;EACA,MAAA;EACA,WAAA;EACA,UAAA;AT2aR;;ASraA;;;;;EASI,4BAAA;ATwaJ;;ASpaI;EACI,0BAAA;ATuaR;ASnagB;EACI,yBAAA;ATqapB;;AW1iBA;;;;;EAMI,uCAAA;EAEA,sCAAA;EAEA,gDAAA;EACA,iCAAA;AX6iBJ;;AW3iBA;;;;;;;EDwBI,4BAAA;AViiBJ;;AW5iBA;EACI,eAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,YAAA;EACA,cAAA;EACA,YAAA;EACA,WAAA;EACA,gBAAA;EACA,sBAAA;EACA,kCAAA;AX+iBJ;AW7iBI;EACI,WAAA;EACA,qBAAA;EACA,gBAAA;AX+iBR;AW7iBQ;EACI,WAAA;EACA,QAAA;EACA,kBAAA;EACA,SAAA;AX+iBZ;AW3iBI;EACI,qBAAA;EACA,SAAA;EACA,kBAAA;EACA,UAAA;EACA,cAAA;AX6iBR;AW3iBQ;EACI;;;;;sBAAA;EAMA,aAAA;AX6iBZ;AW1iBQ;EACI,cAAA;EACA,UAAA;EDlBJ,iCAAA;AVmkBR;AW7iBQ;EACI,yBAAA;EACA,gBAAA;EACA,qBAAA;EACA,mBVuHmB;EUtHnB,gBVoIiB;EUnIjB,iBAAA;EACA,mBAAA;EACA,cV2BiB;EU1BjB,gBAAA;AX+iBZ;AW5iBQ;EACI,WAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;AX8iBZ;AW3iBQ;EACI,WAAA;EACA,kBAAA;EACA,WAAA;EACA,WAAA;EACA,wBAAA;EACA,WAAA;AX6iBZ;AWziBI;EACI,kBAAA;EACA,8BAAA;EACA,gBAAA;EACA,cAAA;EACA,YAAA;EACA,UAAA;EACA,qBAAA;AX2iBR;AWriBwB;EACI,uBAAA;EACA,kBAAA;EACA,0BAAA;EACA,0BAAA;EACA,gBAAA;EACA,eAAA;AXuiB5B;AWjiB4B;EACI,qCAAA;AXmiBhC;AW/hBoB;EACI,UAAA;AXiiBxB;AW1hBY;EACI,SAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,mBAAA;EACA,kBAAA;EACA,cV9IQ;ES6ChB,iCAAA;ECmGQ,cAAA;EACA,YAAA;EACA,UAAA;AXgiBhB;AW5hBQ;EACI,gBAAA;EACA,kBAAA;AX8hBZ;AW5hBY;EACI,kBAAA;EACA,gBAAA;AX8hBhB;AWzhBI;EACI,+CAAA;EACA,mBVxKgB;EUyKhB,0BAAA;EAEA,2BAAA;EAEA,0BAAA;EAEA,oBAAA;EACA,sDAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,UAAA;EACA,YAAA;EACA,WAAA;EACA,cAAA;EACA,MAAA;EACA,OAAA;EACA,sBAAA;EACA,kCAAA;AX2hBR;AWxhBI;EACI,iDAAA;EACA,oBAAA;EACA,gBAAA;AX0hBR;AWxhBQ;EACI,WAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,UAAA;EACA,0CAAA;AX0hBZ;AWxhBY;EACI,WAAA;AX0hBhB;AWthBY;EACI,WAAA;EACA,SAAA;AXwhBhB;AWthBY;EACI,cV7Ga;EU8Gb,iBAAA;EACA,cAAA;EACA,mBAAA;EACA,iBAAA;AXwhBhB;AWthBY;EACI,kBAAA;EACA,cAAA;AXwhBhB;AWrhBgB;EACI,eAAA;AXuhBpB;AWlhBQ;EACI,2BAAA;EACA,6BAAA;AXohBZ;AWlhBY;;EAEI,eAAA;EACA,eAAA;AXohBhB;AWlhBY;EACI,UAAA;AXohBhB;AW/gBI;EACI,qBAAA;EACA,QAAA;EACA,SAAA;EACA,sBAAA;EACA,sBAAA;EACA,wBAAA;EACA,mCAAA;EACA,kCAAA;EACA,gBAAA;EACA,kBAAA;EACA,QAAA;EDjOJ,6BAAA;AVuvBJ;AWlhBI;;;EAGI,gEAAA;EAGA,yBAAA;AXohBR;AWjhBI;EACI,WAAA;EACA,cAAA;AXmhBR;AWhhBY;EACI,cVjRQ;EUkRR,yBAAA;EACA,aAAA;EACA,kBAAA;EACA,yBAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;AXkhBhB;AWhhBgB;EACI,8BAAA;EACA,qCAAA;EACA,UAAA;AXkhBpB;AW/gBgB;EACI,eAAA;EACA,kBAAA;EACA,WAAA;EACA,kBAAA;EACA,sBAAA;EACA,WAAA;AXihBpB;AW7gBY;EACI,qCAAA;EACA,UAAA;AX+gBhB;AW5gBY;EACI,8BAAA;EACA,UAAA;EACA,qCAAA;AX8gBhB;AW1gBY;EACI,cAAA;EACA,iDAAA;AX4gBhB;AW1gBgB;EACI,gBAAA;AX4gBpB;AWpgBI;EAEI,cAAA;EACA,WAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;AXqgBR;AWlgBI;EACI,aAAA;EACA,gBAAA;AXogBR;AWhgBI;EAEI,aAAA;AXigBR;;AWxfQ;;EACI,WAAA;EACA,eAAA;EACA,iBAAA;EACA,cVhQiB;EUiQjB,iBAAA;EACA,2DAAA;AX4fZ;AWzfQ;;EACI,yBAAA;EACA,yBAAA;EACA,cAAA;EACA,mBVjLmB;EUkLnB,cV1QiB;EU2QjB,gBVrKiB;EUsKjB,iBAAA;EACA,mBAAA;EACA,gBAAA;AX4fZ;AWzfQ;;EACI,WAAA;EACA,YAAA;EACA,WAAA;EACA,cAAA;AX4fZ;AWzfQ;;EACI,kBAAA;EACA,cAAA;EACA,gBAAA;AX4fZ;AW1fY;;EACI,WAAA;AX6fhB;AWzfQ;;EACI,WAAA;EACA,kBAAA;EACA,WAAA;EACA,WAAA;EACA,wBAAA;EACA,WAAA;EACA,0CAAA;AX4fZ;AWvfQ;;EACI,yBAAA;EACA,gBAAA;EACA,cAAA;EACA,mBV1NmB;EU2NnB,cVnTiB;EUoTjB,gBV9MiB;EU+MjB,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;AX0fZ;AWpfI;;EDnVA,oCTgCyB;ES1BzB,wGAAA;EACA,0BAAA;AV20BJ;AW5fI;;EDtVA,mBTjFoB;ESuFpB,+EAAA;EACA,0BAAA;AVs1BJ;AWpgBI;;EDzVA,mBTtFoB;ES4FpB,gFAAA;EACA,0BAAA;AVi2BJ;AW5gBI;;ED5VA,mBTnFoB;ESyFpB,+EAAA;EACA,0BAAA;AV42BJ;AWphBI;;ED/VA,mBTlFoB;ESwFpB,+EAAA;EACA,0BAAA;AVu3BJ;AW5hBI;;EDlWA,mBTpFoB;ES0FpB,6EAAA;EACA,0BAAA;AVk4BJ;AWpiBI;;EDrWA,mBTrFoB;ES2FpB,gFAAA;EACA,0BAAA;AV64BJ;;AWviBA;EACI,qCAAA;EACA,kBAAA;EACA,YAAA;EACA,yBV9O0B;ADwxB9B;AWxiBI;EACI,kBAAA;EACA,+BAAA;AX0iBR;AWviBI;EACI,6BAAA;AXyiBR;AWtiBI;EACI,gBAAA;AXwiBR;;AW9hBY;EACI,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,cAAA;AXiiBhB;AWzhBwB;EACI,iBAAA;AX2hB5B;;AWjhBA;;EAEI,yBAAA;EACA,WAAA;EACA,WAAA;EACA,kBAAA;EAEA,mBAAA;AXmhBJ;;AWhhBA;;;;EAII,SAAA;EACA,kBAAA;EACA,0BAAA;EACA,UAAA;EACA,mBAAA;EACA,qBAAA;EACA,iBAAA;AXmhBJ;;AWjhBA;EACI,4BAAA;EACA,wBAAA;AXohBJ;;AW/gBA;EAEQ;IACI,wBAAA;EXihBV;EW/gBM;IACI,gCAAA;EXihBV;EW/gBM;IACI,WAAA;IACA,cAAA;IACA,gBAAA;IACA,YAAA;IACA,eAAA;EXihBV;EW9gBc;IACI,UAAA;EXghBlB;EW7gBc;IACI,UAAA;IDvfZ,mCAAA;EV2gCN;EW/gBU;IACI,iBAAA;IACA,WAAA;IACA,gBAAA;EXihBd;EW/gBc;;;;IDjgBR,mCAAA;ICsgBY,UAAA;EXqhBlB;EW9gBsB;IACI,SAAA;IACA,gBAAA;EXghB1B;EW5gBc;IACI,UAAA;EX8gBlB;EW3gBc;IACI,kBAAA;IACA,8BAAA;IACA,+BAAA;EX6gBlB;EW1gBc;IACI,eAAA;IACA,2BAAA;IACA,4BAAA;EX4gBlB;EWtgBkB;IACI,6BAAA;EXwgBtB;EWngBU;IACI,YAAA;EXqgBd;EWlgBkB;IACI,UAAA;IDjjBhB,iCAAA;EV0jCN;EWpgBc;IACI,OAAA;EXsgBlB;EWngBc;IACI,UAAA;EXqgBlB;EWlgBc;IACI,YAAA;EXogBlB;EWlgBkB;;;;;;IDjkBZ,iCAAA;ICwkBgB,UAAA;EXwgBtB;EWlgB8B;IAEG,UAAA;EXmgBjC;EW1fsB;IACI,4BAAA;EX4f1B;EWvfc;IACI,kBAAA;IACA,mBAAA;IACA,oBAAA;IACA,kBAAA;IACA,cAAA;IACA,aAAA;EXyflB;EWpfM;IACI,wBAAA;IACA,iBAAA;EXsfV;EWnfM;IACI,YAAA;EXqfV;EWlfM;;IAEI,iBAAA;IACA,gBAAA;IACA,YAAA;EXofV;EWjfM;IACI,mCAAA;EXmfV;AACF;AW7eA;EACI,gCAAA;AX+eJ;;AW7eA;EACI,wBAAA;AXgfJ;;AW9eA;EACI,kBAAA;AXifJ;;AWxeA;EACI,iBAAA;EACA,YAAA;AX2eJ;AWzeI;EACI,aAAA;AX2eR;AWzeY;EACI,eAAA;EACA,kBAAA;EACA,WAAA;EACA,kBAAA;AX2ehB;AWteY;EACI,qDAAA;AXwehB;AWreQ;EACI,qDAAA;EACA,wBAAA;EDxrBR,4BAAA;AVoqCJ;AWxeY;EACI,iBAAA;AX0ehB;AWreI;EACI,kBAAA;EACA,UAAA;EACA,uBAAA;AXueR;AWteQ;EACI,+BAAA;AXweZ;AWveY;EACI,UAAA;AXyehB;;AWleI;EACI,kBAAA;EACA,UAAA;EACA,YAAA;EACA,WAAA;EACA,cAAA;EACA,MAAA;EACA,OAAA;EACA,sBAAA;EACA,kCAAA;AXqeR;AWleI;EAEI,cAAA;EACA,WAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;AXmeR;AWheI;EACI,aAAA;EACA,mBAAA;AXkeR;AW9dQ;EACI,iBAAA;AXgeZ;AW5dI;EACI,8BAAA;EACA,UAAA;EACA,kBAAA;AX8dR;AW3dY;EACI,cVjrBa;AD8oC7B;AW3dY;EACI,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,cVvrBa;ADopC7B;AW3dY;EACI,6BAAA;AX6dhB;AW3dY;EACI,eAAA;AX6dhB;AW1dY;EACI,cAAA;EACA,mBAAA;AX4dhB;AW1dgB;EACI,WAAA;EACA,iBAAA;AX4dpB;AW3doB;EACI,eAAA;AX6dxB;AWzdgB;;EAEI,mBAAA;EACA,mBAAA;AX2dpB;AWzdgB;EACI,gBAAA;AX2dpB;AWzdgB;EACI,oBAAA;EACA,gBAAA;AX2dpB;AWzdgB;EACI,mBAAA;EACA,iBAAA;AX2dpB;AWrdI;EACI,iBAAA;AXudR;AWndQ;EACI,iBAAA;AXqdZ;AWldI;ED9vBA,oCTgCyB;ES1BzB,kGAAA;EACA,0BAAA;AVmtCJ;AWzdI;EDjwBA,mBT0UkB;ESpUlB,gEAAA;EACA,0BAAA;AV6tCJ;AWheI;EDpwBA,mBTqUkB;ES/TlB,gEAAA;EACA,0BAAA;AVuuCJ;AWveI;EDvwBA,mBTwUkB;ESlUlB,gEAAA;EACA,0BAAA;AVivCJ;AW9eI;ED1wBA,mBTyUkB;ESnUlB,gEAAA;EACA,0BAAA;AV2vCJ;AWrfI;ED7wBA,mBTuUkB;ESjUlB,gEAAA;EACA,0BAAA;AVqwCJ;AW5fI;EDhxBA,mBTsUkB;EShUlB,gEAAA;EACA,0BAAA;AV+wCJ;;AWlgBA;;EAEI,aAAA;AXqgBJ;;AYl3CQ;EACI,mBAAA;AZq3CZ;AYp3CY;EACI,6BAAA;AZs3ChB;AYp3CY;EACI,2BAAA;AZs3ChB;AYn3CgB;EACI,eAAA;AZq3CpB;AYj3CgB;EACI,kBAAA;EACA,sBAAA;AZm3CpB;AYj3CgB;EACI,gCAAA;AZm3CpB;;AY52CA;;EAEI,qBAAA;EACA,6BAAA;EACA,0BAAA;AZ+2CJ;;AY52CA;EACI,eAAA;EACA,UAAA;EACA,QAAA;EACA,WAAA;EACA,8BAAA;EACA,aAAA;EACA,0BAAA;EACA,kBAAA;AZ+2CJ;;AY72CA;EACI,cAAA;EACA,aAAA;EACA,0BAAA;EACA,WAAA;AZg3CJ;;AY92CA;EACI,WAAA;EACA,UAAA;EACA,YAAA;EACA,wBAAA;EACA,eAAA;AZi3CJ;;AY/2CA;EACI,WAAA;EACA,iBAAA;EACA,UAAA;AZk3CJ;;AYh3CA;EACI,cAAA;AZm3CJ;;AYj3CA;EACI,cAAA;AZo3CJ;;AYj3CA;;;EAGI,cAAA;EACA,kBAAA;AZo3CJ;;AYj3CA;EACI,gBAAA;EACA,WAAA;EACA,aAAA;EACA,cAAA;AZo3CJ;;AYj3CA;;EAEI,gBAAA;AZo3CJ;;AYj3CA;EACI,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,qBAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,WAAA;AZo3CJ;;AYl3CA;;EAEI,qBAAA;AZq3CJ;;AYl3CA;EACI,sBAAA;AZq3CJ;;AYn3CA;EACI,yBAAA;AZs3CJ;;AYp3CA;EACI,yBAAA;AZu3CJ;;AYr3CA;EACI,yBAAA;AZw3CJ;;AYt3CA;EACI,yBAAA;AZy3CJ;;AYv3CA;EACI,yBAAA;AZ03CJ;;AYx3CA;EACI,yBAAA;AZ23CJ;;AYx3CA;EACI,eAAA;EACA,YAAA;AZ23CJ;;AYz3CA;EACI,cAAA;EACA,iBAAA;EACA,UAAA;EACA,WAAA;AZ43CJ;;AYz3CA;;;EAGI,WAAA;EACA,YAAA;EACA,mBAAA;AZ43CJ;;AYz3CA;EACI,YAAA;AZ43CJ;;AY13CA;EACI,kBAAA;AZ63CJ;;AY13CA;EACI,kBAAA;EACA,eAAA;EACA,YAAA;AZ63CJ;;AY13CA;EACI,YAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;AZ63CJ;;AY13CA;EACI,WAAA;EACA,qBAAA;EACA,gBAAA;EACA,cAAA;EACA,cAAA;EACA,gBAAA;AZ63CJ;;AY13CA;EACI,kBAAA;EACA,SAAA;AZ63CJ;;AY13CA;EACI,YAAA;AZ63CJ;;AY13CA;EACI,eAAA;AZ63CJ;;AY13CA;EACM,gBAAA;EACA,eAAA;EACA,iCAAA;EACA,gBAAA;EACA,SAAA;AZ63CN;;AY33CA;EACM,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,sBAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,UAAA;EACA,eAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,UAAA;AZ83CN;;AY33CA;;EAEI,6BAAA;AZ83CJ;;AY53CA;;EAEI,qCAAA;AZ+3CJ;;AY73CA;;EAEI,qBAAA;EACA,yBAAA;AZg4CJ;;AY73CA;EACI,gBAAA;AZg4CJ;;AY73CA;EACI,UAAA;EACA,cAAA;EACA,UAAA;EACA,WAAA;EACA,gBAAA;AZg4CJ;;AY93CA;EACI,iBAAA;AZi4CJ;;AY/3CA;EACI,gBAAA;AZk4CJ;;AY/3CA;;;EAGI,kBAAA;AZk4CJ;;AY/3CA;EF5KQ,4CAAA;EE8KJ,qBAAA;EACA,UAAA;EACA,uBAAA;EACA,qBAAA;AZs4CJ;;AYp4CA;EACI,UAAA;EFpLI,2CAAA;EEsLJ,qBAAA;EACA,uBAAA;AZ24CJ;;AYx4CA;;EAEI,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,2BAAA;EACA,mCAAA;EACA,gCAAA;AZ24CJ;;AYx4CA;EACI,0CAAA;EACA,0CAAA;EACA,uCAAA;EACA,YAAA;AZ24CJ;;AYx4CA;EACI,0CAAA;EACA,4BAAA;EACA,uCAAA;EACA,YAAA;AZ24CJ;;AYx4CA;EAKI,2BAAA;AZ24CJ;;AYx4CA;EAKI,2BAAA;AZ24CJ;;AazrDA;EACI,cAAA;Ab4rDJ;;Aa1rDA;EACI,cAAA;EACA,mBAAA;EACA,wEAAA;Ab6rDJ;;Aa3rDA;EACI,iBAAA;Ab8rDJ;;Aa5rDA;EACI,kBAAA;EACA,kBAAA;Ab+rDJ;;Aa7rDA;EACI,gBAAA;AbgsDJ;;Aa7rDA;EACI,eAAA;EACA,uBAAA;EACA,oBAAA;AbgsDJ;;Aa9rDA;EACI,eAAA;EACA,uBAAA;EACA,oBAAA;AbisDJ;;Aa9rDI;EACI,gBAAA;AbisDR;;Aa7rDI;EACI,cAAA;EACA,cAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,eZqKuB;AD2hD/B;Aa9rDI;EACI,kBAAA;EACA,WAAA;EACA,aAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,yBZzBqB;ADytD7B;Aa9rDI;EACI,kBAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,yBZlCqB;ADkuD7B;Aa9rDI;EACI,kBAAA;AbgsDR;;Aa7rDA;EACI,kBAAA;AbgsDJ;Aa9rDI;EACI,cAAA;AbgsDR;;Aa7rDA;EACI,aAAA;AbgsDJ;;Ac1wDA;EACI,iBb2GyB;Ea1GzB,6BbmHyB;EalHzB,gBbiNyB;EahNzB,iBAAA;ECFF,yBAAA;EACA,cd2G2B;Ec1G3B,yBdiB2B;EchB3B,eAAA;EDCE,kBAAA;EACA,mBb2L2B;Ea1L3B,uBAAA;AdgxDJ;AejxDE;EAKE,0Cd6GyB;Ec5GzB,cdiGyB;EchGzB,sCd2GyB;ADoqD7B;AexwDI;EAME,yBdDuB;EcEvB,qBdCuB;EcAvB,mBAAA;EACA,8BAAA;AfqwDN;AejwDE;EACE,cddyB;EcezB,6BdiFyB;EchFzB,yBAAA;EClCF,UDmCmB;EChCnB,0BAAA;AhBoyDF;AelwDI;EAKI,0Cd4EqB;Ec3ErB,cdgEqB;Ec/DrB,0CAAA;AfgwDR;Ae7vDI;EACI,yBd2DqB;ADosD7B;Ae3vDE;EACI,oCAAA;EACA,wCAAA;EACA,cdrCuB;ADkyD7B;Ae3vDM;EAGI,qBAAA;EACA,yBdqDmB;EcpDnB,+BdwDmB;ADmsD7B;AetvDE;EACI,yBdlDuB;AD0yD7B;AcrzDI;EAEI,qBAAA;EACA,gBAAA;AdszDR;AcnzDI;EJJM,gBIOD;EACA,qBAAA;AdozDT;AcjzDI;EACI,YbiIwB;ADkrDhC;;Ac5yDA;EC7BE,yBAAA;EACA,cd2G2B;Ec1G3B,yBdDsB;EcEtB,eAAA;Af60DF;Ae30DE;EAKE,+CdiHyB;EchHzB,cdiGyB;EchGzB,2Cd+GyB;AD0tD7B;Ael0DI;EAME,yBdDuB;EcEvB,qBdCuB;EcAvB,mBAAA;EACA,8BAAA;Af+zDN;Ae3zDE;EACE,cdhCoB;EciCpB,6BdiFyB;EchFzB,yBAAA;EClCF,UDmCmB;EChCnB,0BAAA;AhB81DF;Ae5zDI;EAKI,+CdgFqB;Ec/ErB,cdgEqB;Ec/DrB,+CAAA;Af0zDR;AevzDI;EACI,yBd2DqB;AD8vD7B;AerzDE;EACI,oCAAA;EACA,wCAAA;EACA,cdrCuB;AD41D7B;AerzDM;EAGI,qBAAA;EACA,yBdqDmB;EcpDnB,+BdwDmB;AD6vD7B;AehzDE;EACI,yBdpEkB;ADs3DxB;;Acz1DA;EC9BE,yBAAA;EACA,cd2G2B;Ec1G3B,yBdEsB;EcDtB,eAAA;Af23DF;Aez3DE;EAKE,mEdyHyB;EcxHzB,cdiGyB;EchGzB,+DduHyB;ADgwD7B;Aeh3DI;EAME,yBdDuB;EcEvB,qBdCuB;EcAvB,mBAAA;EACA,8BAAA;Af62DN;Aez2DE;EACE,cd7BoB;Ec8BpB,6BdiFyB;EchFzB,yBAAA;EClCF,UDmCmB;EChCnB,0BAAA;AhB44DF;Ae12DI;EAKI,mEdwFqB;EcvFrB,cdgEqB;Ec/DrB,mEAAA;Afw2DR;Aer2DI;EACI,yBd2DqB;AD4yD7B;Aen2DE;EACI,oCAAA;EACA,wCAAA;EACA,cdrCuB;AD04D7B;Aen2DM;EAGI,qBAAA;EACA,yBdqDmB;EcpDnB,+BdwDmB;AD2yD7B;Ae91DE;EACI,yBdjEkB;ADi6DxB;;Act4DA;EC/BE,yBAAA;EACA,cd2G2B;Ec1G3B,yBdIsB;EcHtB,eAAA;Afy6DF;Aev6DE;EAKE,0CdqHyB;EcpHzB,cdiGyB;EchGzB,sCdmHyB;ADkzD7B;Ae95DI;EAME,yBdDuB;EcEvB,qBdCuB;EcAvB,mBAAA;EACA,8BAAA;Af25DN;Aev5DE;EACE,cd3BoB;Ec4BpB,6BdiFyB;EchFzB,yBAAA;EClCF,UDmCmB;EChCnB,0BAAA;AhB07DF;Aex5DI;EAKI,0CdoFqB;EcnFrB,cdgEqB;Ec/DrB,0CAAA;Afs5DR;Aen5DI;EACI,yBd2DqB;AD01D7B;Aej5DE;EACI,oCAAA;EACA,wCAAA;EACA,cdrCuB;ADw7D7B;Aej5DM;EAGI,qBAAA;EACA,yBdqDmB;EcpDnB,+BdwDmB;ADy1D7B;Ae54DE;EACI,yBd/DkB;AD68DxB;;Acn7DA;EChCE,yBAAA;EACA,cd2G2B;Ec1G3B,yBdGsB;EcFtB,eAAA;Afu9DF;Aer9DE;EAKE,uCd6HyB;Ec5HzB,cdiGyB;EchGzB,mCd2HyB;ADw1D7B;Ae58DI;EAME,yBdDuB;EcEvB,qBdCuB;EcAvB,mBAAA;EACA,8BAAA;Afy8DN;Aer8DE;EACE,cd5BoB;Ec6BpB,6BdiFyB;EchFzB,yBAAA;EClCF,UDmCmB;EChCnB,0BAAA;AhBw+DF;Aet8DI;EAKI,uCd4FqB;Ec3FrB,cdgEqB;Ec/DrB,uCAAA;Afo8DR;Aej8DI;EACI,yBd2DqB;ADw4D7B;Ae/7DE;EACI,oCAAA;EACA,wCAAA;EACA,cdrCuB;ADs+D7B;Ae/7DM;EAGI,qBAAA;EACA,yBdqDmB;EcpDnB,+BdwDmB;ADu4D7B;Ae17DE;EACI,yBdhEkB;AD4/DxB;;Ach+DA;ECjCE,yBAAA;EACA,cd2G2B;Ec1G3B,yBdCsB;EcAtB,eAAA;AfqgEF;AengEE;EAKE,kEdkIyB;EcjIzB,cdiGyB;EchGzB,8DdgIyB;ADi4D7B;Ae1/DI;EAME,yBdDuB;EcEvB,qBdCuB;EcAvB,mBAAA;EACA,8BAAA;Afu/DN;Aen/DE;EACE,cd9BoB;Ec+BpB,6BdiFyB;EchFzB,yBAAA;EClCF,UDmCmB;EChCnB,0BAAA;AhBshEF;Aep/DI;EAKI,kEdiGqB;EchGrB,cdgEqB;Ec/DrB,kEAAA;Afk/DR;Ae/+DI;EACI,yBd2DqB;ADs7D7B;Ae7+DE;EACI,oCAAA;EACA,wCAAA;EACA,cdrCuB;ADohE7B;Ae7+DM;EAGI,qBAAA;EACA,yBdqDmB;EcpDnB,+BdwDmB;ADq7D7B;Aex+DE;EACI,yBdlEkB;AD4iExB;;Ac7gEA;EClCE,yBAAA;EACA,cd2G2B;Ec1G3B,yBd0G2B;EczG3B,eAAA;AfmjEF;AejjEE;EAKE,yBdkGyB;EcjGzB,cdiGyB;EchGzB,qBdgGyB;AD+8D7B;AexiEI;EAME,yBdDuB;EcEvB,qBdCuB;EcAvB,mBAAA;EACA,8BAAA;AfqiEN;AejiEE;EACE,cd2EyB;Ec1EzB,6BdiFyB;EchFzB,yBAAA;EClCF,UDmCmB;EChCnB,0BAAA;AhBokEF;AeliEI;EAKI,yBdiEqB;EchErB,cdgEqB;Ec/DrB,yBAAA;AfgiER;Ae7hEI;EACI,yBd2DqB;ADo+D7B;Ae3hEE;EACI,oCAAA;EACA,wCAAA;EACA,cdrCuB;ADkkE7B;Ae3hEM;EAGI,qBAAA;EACA,yBdqDmB;EcpDnB,+BdwDmB;ADm+D7B;AethEE;EACI,yBduCuB;ADi/D7B;AcxjEI;EAGK,yBboEoB;EanEpB,cbtBoB;AD8kE7B;AcrjEI;EAGI,cb5BqB;ADilE7B;AcljEI;EAEI,6BAAA;AdmjER;;Ac9iEK;EExDH,YF2DuB;EExDvB,yBAAA;AhBwmEF;;Ac7iEA;EACI,iBbyCyB;EaxCzB,8BAAA;EACA,iBAAA;AdgjEJ;Ac9iEI;EACI,YbqFwB;AD29DhC;;Ac5iEA;ECEG,mBdyH4B;EcxH5B,kBd0G6B;EczG7B,kBAAA;EDFA,gBbuI0B;AD06D7B;Ae7iEG;EACI,kBAAA;Af+iEP;Ae5iEG;EACI,kBAAA;Af8iEP;;AcrjEA;ECFG,kBduH4B;EctH5B,kBdwG6B;EcvG7B,iBAAA;Af2jEH;AezjEG;EACI,iBAAA;Af2jEP;AexjEG;EACI,iBAAA;Af0jEP;;Ac7jEA;EACI,gBAAA;AdgkEJ;;Ac7jEA;EACI,WAAA;AdgkEJ;;Ac9jEA;EACI,gBAAA;AdikEJ;;Ac/jEA;EACI,kBAAA;EACA,QAAA;EACA,gBAAA;EACA,UAAA;AdkkEJ;;AchkEA;EACI,aAAA;AdmkEJ;;AiBvqEA;EACC,gBAAA;AjB0qED;AiBxqEC;EACC,eAAA;EACA,WAAA;EACA,sBAAA;EACA,qBAAA;AjB0qEF;AiBvqEC;EACC,YAAA;AjByqEF;AiBtqEC;EACC,gBAAA;EACA,eAAA;AjBwqEF;AiBtqEE;EACC,eAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;AjBwqEH;;AiBjqEA;EC5BE,qBjBwYmB;EiBvYnB,yBjBuYmB;EiBtYnB,cjB2G2B;ADslE7B;AkB/rEE;EAKE,mEjBqDwB;EiBpDxB,cjBmGyB;EiBlGzB,qBjB6XiB;ADg0DrB;AkB1rEE;EAGE,6BjBmGyB;EiBlGzB,qBjBsXiB;ADo0DrB;AkBvrEE;EACE,cjBkXiB;EiBjXjB,6BjB6FyB;EiB5FzB,yBAAA;AlByrEJ;AkBvrEI;EAKI,mEjB+BoB;EiB9BpB,cjB6EqB;EiB5ErB,mEAAA;AlBqrER;AkBjrEE;EACE,cjBkWiB;EiBjWjB,6BjB6EyB;EiB5EzB,yBAAA;AlBmrEJ;AkBjrEI;EAKI,6BjBqEqB;EiBpErB,wDjBcoB;EiBbpB,mEAAA;AlB+qER;;AiBhsEA;EChCE,qBjByYkB;EiBxYlB,yBjBwYkB;EiBvYlB,cjB2G2B;ADynE7B;AkBluEE;EAKE,oEjBuDuB;EiBtDvB,cjBmGyB;EiBlGzB,qBjB8XgB;ADk2DpB;AkB7tEE;EAGE,6BjBmGyB;EiBlGzB,qBjBuXgB;ADs2DpB;AkB1tEE;EACE,cjBmXgB;EiBlXhB,6BjB6FyB;EiB5FzB,yBAAA;AlB4tEJ;AkB1tEI;EAKI,oEjBiCmB;EiBhCnB,cjB6EqB;EiB5ErB,oEAAA;AlBwtER;AkBptEE;EACE,cjBmWgB;EiBlWhB,6BjB6EyB;EiB5EzB,yBAAA;AlBstEJ;AkBptEI;EAKI,6BjBqEqB;EiBpErB,yDjBgBmB;EiBfnB,oEAAA;AlBktER;;AiB/tEA;ECpCE,qBjB0YoB;EiBzYpB,yBjByYoB;EiBxYpB,cjB2G2B;AD4pE7B;AkBrwEE;EAKE,mEjByDyB;EiBxDzB,cjBmGyB;EiBlGzB,qBjB+XkB;ADo4DtB;AkBhwEE;EAGE,6BjBmGyB;EiBlGzB,qBjBwXkB;ADw4DtB;AkB7vEE;EACE,cjBoXkB;EiBnXlB,6BjB6FyB;EiB5FzB,yBAAA;AlB+vEJ;AkB7vEI;EAKI,mEjBmCqB;EiBlCrB,cjB6EqB;EiB5ErB,mEAAA;AlB2vER;AkBvvEE;EACE,cjBoWkB;EiBnWlB,6BjB6EyB;EiB5EzB,yBAAA;AlByvEJ;AkBvvEI;EAKI,6BjBqEqB;EiBpErB,wDjBkBqB;EiBjBrB,mEAAA;AlBqvER;;AiB9vEA;ECxCE,qBjB2YiB;EiB1YjB,yBjB0YiB;EiBzYjB,cjB2G2B;AD+rE7B;AkBxyEE;EAKE,mEjB2D0B;EiB1D1B,cjBmGyB;EiBlGzB,qBjBgYe;ADs6DnB;AkBnyEE;EAGE,6BjBmGyB;EiBlGzB,qBjByXe;AD06DnB;AkBhyEE;EACE,cjBqXe;EiBpXf,6BjB6FyB;EiB5FzB,yBAAA;AlBkyEJ;AkBhyEI;EAKI,mEjBqCsB;EiBpCtB,cjB6EqB;EiB5ErB,mEAAA;AlB8xER;AkB1xEE;EACE,cjBqWe;EiBpWf,6BjB6EyB;EiB5EzB,yBAAA;AlB4xEJ;AkB1xEI;EAKI,6BjBqEqB;EiBpErB,wDjBoBsB;EiBnBtB,mEAAA;AlBwxER;;AiB7xEA;EC5CE,qBjB4YmB;EiB3YnB,yBjB2YmB;EiB1YnB,cjB2G2B;ADkuE7B;AkB30EE;EAKE,kEjB6DwB;EiB5DxB,cjBmGyB;EiBlGzB,qBjBiYiB;ADw8DrB;AkBt0EE;EAGE,6BjBmGyB;EiBlGzB,qBjB0XiB;AD48DrB;AkBn0EE;EACE,cjBsXiB;EiBrXjB,6BjB6FyB;EiB5FzB,yBAAA;AlBq0EJ;AkBn0EI;EAKI,kEjBuCoB;EiBtCpB,cjB6EqB;EiB5ErB,kEAAA;AlBi0ER;AkB7zEE;EACE,cjBsWiB;EiBrWjB,6BjB6EyB;EiB5EzB,yBAAA;AlB+zEJ;AkB7zEI;EAKI,6BjBqEqB;EiBpErB,uDjBsBoB;EiBrBpB,kEAAA;AlB2zER;;AiB5zEA;EChDE,qBjB6YmB;EiB5YnB,yBjB4YmB;EiB3YnB,cjB2G2B;ADqwE7B;AkB92EE;EAKE,8CjB+D6B;EiB9D7B,cjBmGyB;EiBlGzB,qBjBkYiB;AD0+DrB;AkBz2EE;EAGE,6BjBmGyB;EiBlGzB,qBjB2XiB;AD8+DrB;AkBt2EE;EACE,cjBuXiB;EiBtXjB,6BjB6FyB;EiB5FzB,yBAAA;AlBw2EJ;AkBt2EI;EAKI,8CjByCyB;EiBxCzB,cjB6EqB;EiB5ErB,8CAAA;AlBo2ER;AkBh2EE;EACE,cjBuWiB;EiBtWjB,6BjB6EyB;EiB5EzB,yBAAA;AlBk2EJ;AkBh2EI;EAKI,6BjBqEqB;EiBpErB,mCjBwByB;EiBvBzB,8CAAA;AlB81ER;;AiB31EA;ECpDE,qBjB8YiB;EiB7YjB,yBjB6YiB;EiB5YjB,cjB2G2B;ADwyE7B;AkBj5EE;EAKE,uBjBiE6B;EiBhE7B,cjBmGyB;EiBlGzB,qBjBmYe;AD4gEnB;AkB54EE;EAGE,6BjBmGyB;EiBlGzB,qBjB4Xe;ADghEnB;AkBz4EE;EACE,cjBwXe;EiBvXf,6BjB6FyB;EiB5FzB,yBAAA;AlB24EJ;AkBz4EI;EAKI,uBjB2CyB;EiB1CzB,cjB6EqB;EiB5ErB,uBAAA;AlBu4ER;AkBn4EE;EACE,cjBwWe;EiBvWf,6BjB6EyB;EiB5EzB,yBAAA;AlBq4EJ;AkBn4EI;EAKI,6BjBqEqB;EiBpErB,YjB0ByB;EiBzBzB,uBAAA;AlBi4ER;;AiB13EA;ECxDE,qBjB+YkB;EiB9YlB,yBjB8YkB;EiB7YlB,cjB2G2B;AD20E7B;AkBp7EE;EAKE,kEjBmE6B;EiBlE7B,cjBmGyB;EiBlGzB,qBjBoYgB;AD8iEpB;AkB/6EE;EAGE,6BjBmGyB;EiBlGzB,qBjB6XgB;ADkjEpB;AkB56EE;EACE,cjByXgB;EiBxXhB,6BjB6FyB;EiB5FzB,yBAAA;AlB86EJ;AkB56EI;EAKI,kEjB6CyB;EiB5CzB,cjB6EqB;EiB5ErB,kEAAA;AlB06ER;AkBt6EE;EACE,cjByWgB;EiBxWhB,6BjB6EyB;EiB5EzB,yBAAA;AlBw6EJ;AkBt6EI;EAKI,6BjBqEqB;EiBpErB,uDjB4ByB;EiB3BzB,kEAAA;AlBo6ER;;AiBz5EA;EC5DE,qBjBgZqB;EiB/YrB,yBjB+YqB;EiB9YrB,cjB2G2B;AD82E7B;AkBv9EE;EAKE,iEjBqEgC;EiBpEhC,cjBmGyB;EiBlGzB,qBjBqYmB;ADglEvB;AkBl9EE;EAGE,6BjBmGyB;EiBlGzB,qBjB8XmB;ADolEvB;AkB/8EE;EACE,cjB0XmB;EiBzXnB,6BjB6FyB;EiB5FzB,yBAAA;AlBi9EJ;AkB/8EI;EAKI,iEjB+C4B;EiB9C5B,cjB6EqB;EiB5ErB,iEAAA;AlB68ER;AkBz8EE;EACE,cjB0WmB;EiBzWnB,6BjB6EyB;EiB5EzB,yBAAA;AlB28EJ;AkBz8EI;EAKI,6BjBqEqB;EiBpErB,sDjB8B4B;EiB7B5B,iEAAA;AlBu8ER;;AiBx7EA;EChEE,qBjBiZiB;EiBhZjB,yBjBgZiB;EiB/YjB,cjB2G2B;ADi5E7B;AkB1/EE;EAKE,mCjBuE6B;EiBtE7B,cjBmGyB;EiBlGzB,qBjBsYe;ADknEnB;AkBr/EE;EAGE,6BjBmGyB;EiBlGzB,qBjB+Xe;ADsnEnB;AkBl/EE;EACE,cjB2Xe;EiB1Xf,6BjB6FyB;EiB5FzB,yBAAA;AlBo/EJ;AkBl/EI;EAKI,mCjBiDyB;EiBhDzB,cjB6EqB;EiB5ErB,mCAAA;AlBg/ER;AkB5+EE;EACE,cjB2We;EiB1Wf,6BjB6EyB;EiB5EzB,yBAAA;AlB8+EJ;AkB5+EI;EAKI,6BjBqEqB;EiBpErB,wBjBgCyB;EiB/BzB,mCAAA;AlB0+ER;;AiBv9EA;ECpEE,qBjBkZiB;EiBjZjB,yBjBiZiB;EiBhZjB,cjB2G2B;ADo7E7B;AkB7hFE;EAKE,kEjByE0B;EiBxE1B,cjBmGyB;EiBlGzB,qBjBuYe;ADopEnB;AkBxhFE;EAGE,6BjBmGyB;EiBlGzB,qBjBgYe;ADwpEnB;AkBrhFE;EACE,cjB4Xe;EiB3Xf,6BjB6FyB;EiB5FzB,yBAAA;AlBuhFJ;AkBrhFI;EAKI,kEjBmDsB;EiBlDtB,cjB6EqB;EiB5ErB,kEAAA;AlBmhFR;AkB/gFE;EACE,cjB4We;EiB3Wf,6BjB6EyB;EiB5EzB,yBAAA;AlBihFJ;AkB/gFI;EAKI,6BjBqEqB;EiBpErB,uDjBkCsB;EiBjCtB,kEAAA;AlB6gFR;;AiBt/EA;ECxEE,qBjBmZkB;EiBlZlB,yBjBkZkB;EiBjZlB,cjB2G2B;ADu9E7B;AkBhkFE;EAKE,4CjB2E6B;EiB1E7B,cjBmGyB;EiBlGzB,qBjBwYgB;ADsrEpB;AkB3jFE;EAGE,6BjBmGyB;EiBlGzB,qBjBiYgB;AD0rEpB;AkBxjFE;EACE,cjB6XgB;EiB5XhB,6BjB6FyB;EiB5FzB,yBAAA;AlB0jFJ;AkBxjFI;EAKI,4CjBqDyB;EiBpDzB,cjB6EqB;EiB5ErB,4CAAA;AlBsjFR;AkBljFE;EACE,cjB6WgB;EiB5WhB,6BjB6EyB;EiB5EzB,yBAAA;AlBojFJ;AkBljFI;EAKI,6BjBqEqB;EiBpErB,iCjBoCyB;EiBnCzB,4CAAA;AlBgjFR;;AmBlmFA;ECMG,cnBqB0B;EexB3B,UIIkB;EJDlB,0BAAA;AhBkmFF;;AmBrmFA;ECGG,cnBqB0B;EexB3B,UIIkB;EJDlB,0BAAA;AhBwmFF;;AmBxmFA;ECAG,cnBqB0B;EexB3B,UIIkB;EJDlB,0BAAA;AhB8mFF;;AmB3mFA;ECHG,cnBqB0B;EexB3B,UIIkB;EJDlB,0BAAA;AhBonFF;;AmB7mFA;EACI,yBlBiGyB;EkBhGzB,yBAAA;EACA,kBlBuK4B;EkBtK5B,mBAAA;EACA,cAAA;ECjBA,iBAAA;EACA,YnB8L2B;ESpLrB,gBSQN;AnBknFJ;AmBhnFI;EACO,yBlBwFkB;EkBvFlB,yBAAA;ETZD,gBSaC;EACA,qBAAA;EACA,cAAA;AnBmnFX;AmBhnFI;EAII,qBlBRqB;ESdnB,gBSuBF;AnBgnFR;AmB7mFI;EACI,qBlBjCgB;EkBkChB,clBlCgB;ADipFxB;AmB7mFI;EACI,clBtCgB;ADqpFxB;AmB7mFI;EACI,qBlBzCgB;ADwpFxB;AmB5mFI;EACI,kBlBsIwB;EkBrIxB,mBlB+IuB;EkB9IvB,gBAAA;EACA,kBAAA;EACA,WAAA;EACA,QAAA;EACA,sBAAA;AnB8mFR;AmB3mFI;EACI,0BAAA;EACA,gCAAA;AnB6mFR;;AmBzmFA;EACI,YAAA;EACA,kBAAA;AnB4mFJ;;AmBxmFI;EACI,clBnEgB;AD8qFxB;;AmBvmFI;EACI,clBvEgB;ADirFxB;;AmBrmFA;EACI,yBlB2ByB;EkB1BzB,yBAAA;EACA,kBlBkG4B;ADsgFhC;AmBtmFI;EAEI,yBlBqBqB;EkBpBrB,yBAAA;AnBumFR;AmBrmFI;EACI,qBlBxFgB;EkByFhB,clBzFgB;ADgsFxB;AmBrmFI;EACI,qBlB3FgB;EkB4FhB,clB5FgB;ADmsFxB;AmBrmFI;EAEI,yBlBQqB;EkBPrB,qBlBzEqB;AD+qF7B;;AmBlmFA;;;;EAII,oBAAA;AnBqmFJ;;AmBnmFA;;;;EAII,mBAAA;AnBsmFJ;;AmBpmFA;EACI,yBlBPyB;EkBQzB,clBpGyB;EkBqGzB,mBAAA;AnBumFJ;;AmBpmFA;EACI,iBlBnByB;EkBoBzB,iBAAA;AnBumFJ;;AmBrmFA;EACI,qBlBvGyB;AD+sF7B;;AmBrmFA;EACI,cAAA;AnBwmFJ;;AmBrmFA;EACI,qBlB5GyB;ADotF7B;;AmBrmFA;EACI,cAAA;EACA,iBAAA;AnBwmFJ;;AmBpmFI;EACI,iBAAA;EACA,iBAAA;AnBumFR;AmBrmFI;;;EAGI,gBAAA;AnBumFR;;AmBlmFI;EACI,clB3JgB;EkB4JhB,oBAAA;EACA,gBAAA;AnBqmFR;;AmBhmFI;EACI,wBAAA;AnBmmFR;;AqB3wFA;EACI,SAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;ArB8wFJ;AqB5wFI;EACI,kBAAA;ArB8wFR;AqB3wFI;EACI,gBAAA;EACA,OAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,UAAA;ArB6wFR;AqB3wFI;EACI,SAAA;ArB6wFR;AqB1wFI;EACI,eAAA;EACA,cAAA;EACA,UAAA;EACA,kBAAA;EACA,QAAA;EACA,iBAAA;ArB4wFR;AqBzwFI;EACI,0BAAA;EACA,8CAAA;ArB2wFR;AqBxwFI;EACI,SAAA;EACA,kBAAA;EACA,WAAA;EACA,QAAA;EACA,iBAAA;EACA,aAAA;EACA,yBAAA;EACA,cAAA;EACA,kBAAA;EACA,YAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,qBAAA;EACA,kBAAA;EACA,YAAA;EACA,gBAAA;ArB0wFR;AqBxwFQ;EACI,aAAA;ArB0wFZ;AqBtwFI;EACI,cAAA;EACA,cAAA;ArBwwFR;AqBrwFI;EACI,4BAAA;EACA,kBpBkHwB;ADqpFhC;AqBpwFI;EACI,kBAAA;ArBswFR;;AqBnwFA;EACI,yBpB1EoB;ADg1FxB;;AqBpwFA;EACK,yBpBxEmB;AD+0FxB;;AqBrwFA;EACI,yBpB7EoB;ADq1FxB;;AqBtwFA;EACK,yBpB/EmB;ADw1FxB;;AqBvwFA;EACK,yBpBpFmB;AD81FxB;;AsBn2FA;EACI,mBAAA;EACA,sBAAA;EACA,kBAAA;AtBs2FJ;AsBp2FG;;EAEK,kBAAA;EACA,YAAA;EACA,cAAA;EACA,WAAA;EACA,gBAAA;EACA,eAAA;AtBs2FR;AsBp2FG;;;;;;EAMI,iBAAA;EACA,sBAAA;EACA,qBrBIsB;ADk2F7B;AsBn2FI;EACI,wBAAA;EACA,kBrByKuB;EqBxKvB,yBAAA;EACA,crBCqB;EqBArB,gBrBsLqB;EqBrLrB,mBAAA;AtBq2FR;AsBl2FI;EACI,+BAAA;AtBo2FR;AsBj2FG;ENnCD,aMoCuB;ENjCvB,yBAAA;AhBq4FF;AsBl2FQ;EACI,iBAAA;EACA,kBAAA;AtBo2FZ;AsBj2FI;EACI,eAAA;AtBm2FR;AsBh2FI;EACI,kBAAA;EACA,0BAAA;AtBk2FR;AsB91FY;ENrDV,UMsD+B;ENnD/B,0BAAA;AhBo5FF;AsB71FI;EACI,8BAAA;EACA,2BAAA;AtB+1FR;AsB51FI;EACI,crB3DgB;ADy5FxB;AsB51FI;EACI,crBjEgB;AD+5FxB;AsB51FI;EACI,crBnEgB;ADi6FxB;AsB51FI;EACI,crBrEgB;ADm6FxB;AsB11FQ;;;EAGI,iBAAA;AtB41FZ;;AsBr1FQ;;EAEI,kBAAA;AtBw1FZ;AsBr1FQ;;EAEI,mBAAA;AtBu1FZ;;AsBj1FI;EACI,mBrBsGuB;EqBrGvB,yBAAA;EACA,crB5EqB;EqB6ErB,gBrByGqB;AD2uF7B;AsBl1FI;EACI,mBrBoFuB;ADgwF/B;AsBl1FQ;EACI,cAAA;EACA,kBAAA;AtBo1FZ;AsBj1FI;EACG,gBrB6FsB;EqB5FtB,mBrBsFwB;AD6vF/B;AsBj1FI;EACI,gBAAA;AtBm1FR;AsBj1FI;EACI,iBAAA;EACA,gBAAA;AtBm1FR;AsBj1FQ;EACI,iBAAA;AtBm1FZ;AsB/0FI;EACI,WAAA;EACA,eAAA;AtBi1FR;AsB/0FQ;EACI,YAAA;AtBi1FZ;AsB90FI;EACI,YAAA;EACA,aAAA;EACA,gBAAA;EACA,cAAA;EAEA,kBrBqCwB;AD0yFhC;AsB70FQ;EACI,WAAA;AtB+0FZ;;AsBv0FI;EACI,4BAAA;AtB00FR;AsBv0FY;EACI,2BAAA;AtBy0FhB;AsBv0FY;EACI,2BAAA;AtBy0FhB;;AsBh0FI;;EACI,4BAAA;AtBo0FR;AsBl0FQ;;EACI,8BAAA;AtBq0FZ;;AsB/zFI;EACI,4BAAA;AtBk0FR;AsBh0FQ;EACI,8BAAA;AtBk0FZ;;AsB5zFI;EACI,0BAAA;AtB+zFR;AsB3zFY;EACI,cAAA;EACA,iBAAA;EACA,WAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,WAAA;AtB6zFhB;AsB3zFgB;EACI,yBAAA;AtB6zFpB;AsBzzFgB;EACI,yCAAA;AtB2zFpB;;AsBhzFY;EACI,uBAAA;EACA,0BAAA;AtBmzFhB;AsB/yFI;EACI,YAAA;AtBizFR;AsB/yFI;EACI,eAAA;AtBizFR;;AsB3yFQ;EACI,gBAAA;EACA,oBAAA;AtB8yFZ;AsB7yFY;EACI,YAAA;AtB+yFhB;AsB5yFQ;EACI,eAAA;AtB8yFZ;AsB3yFI;EACI,4BAAA;AtB6yFR;AsB3yFI;EACI,cAAA;AtB6yFR;AsB3yFI;EACI,2BAAA;AtB6yFR;;AsBzyFA;EACI,kBAAA;EACA,mBAAA;EACA,wBAAA;AtB4yFJ;;AsBzyFA;EACI,6BAAA;AtB4yFJ;;AuBvjGI;;;;;;;;;;EAIE,yBtBQuB;ADwjG7B;;AuB3jGI;;EAKE,qEAAA;AvB2jGN;;AuBzkGI;;;;;;;;;;EAIE,yBtBOuB;AD2kG7B;;AuB7kGI;;EAKE,oEAAA;AvB6kGN;;AuB3lGI;;;;;;;;;;EAIE,wCtBSuB;AD2lG7B;;AuB/lGI;;EAKE,8CAAA;AvB+lGN;;AuB7mGI;;;;;;;;;;EAIE,uCtBUuB;AD4mG7B;;AuBjnGI;;EAKE,wEAAA;AvBinGN;;AwBnoGA;;EAEI,mBAAA;EACA,kBAAA;AxBsoGJ;;AwBloGI;EACI,qBAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,0BAAA;AxBqoGR;AwBloGI;;EAEI,iCAAA;EACA,gBAAA;EACA,cvBfgB;EuBgBhB,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EdNJ,+BAAA;AV+oGJ;AwBtoGI;EACI,iCAAA;EACA,gBAAA;EACA,kBAAA;EACA,UAAA;EACA,cvB9BgB;EuB+BhB,SAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;AxBwoGR;AwBtoGI;EACI,kBAAA;AxBwoGR;AwBroGQ;EACI,cvBrBiB;EuBsBjB,YAAA;EACA,mBAAA;AxBuoGZ;;AwB/nGQ;EACI,kBAAA;AxBkoGZ;;AwB7nGA;;;;EAII,WAAA;EACA,oBAAA;AxBgoGJ;;AwB7nGA;EACI,mBAAA;AxBgoGJ;;AwB7nGA;;EAEI,UAAA;EACA,kBAAA;EACA,kBAAA;AxBgoGJ;;AwB9nGA;EACI,UAAA;AxBioGJ;;AwB9nGA;EACI,UAAA;AxBioGJ;;AwB9nGA;;EAEI,mBAAA;AxBioGJ;;AwB9nGA;;EAEI,+BAAA;AxBioGJ;;AwB9nGA;EACI,qBAAA;AxBioGJ;;AwB5nGI;EACI,oBAAA;AxB+nGR;AwB5nGQ;EACI,cvBpFiB;EuBqFjB,YAAA;EACA,mBAAA;AxB8nGZ;;AwBznGA;EACI,iCAAA;EACA,gBAAA;EACA,eAAA;EACA,mCAAA;EACA,kCAAA;EACA,qBAAA;EACA,kBAAA;EACA,YAAA;EACA,UAAA;AxB4nGJ;;AwBznGA;;EAEI,UAAA;Ed7GA,+BAAA;Ec+GA,YAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;AxBgoGJ;;AwB7nGA;EACI,iCAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;AxBgoGJ;;AwB7nGA;EACI,UAAA;Ed9HA,+BAAA;AVmwGJ;;AwBjoGA;EACI,UAAA;EdnIA,+BAAA;AV4wGJ;;AwBroGA;;EAEI,cvBrIyB;AD6wG7B;;AwBjoGY;EACI,6BAAA;AxBooGhB;;AyBzyGQ;;EAEI,6BAAA;AzB4yGZ;;AyBvyGA;EACI,SxBgGyB;EwB/FzB,exBqM2B;EwBpM3B,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,2CxB8ZwB;EwB7ZxB,2CAAA;AzB0yGJ;AyBxyGI;EACI,gBAAA;EACA,eAAA;EACA,eAAA;EACA,cxBDqB;AD2yG7B;AyBxyGQ;EACI,cAAA;AzB0yGZ;AyBtyGI;EACI,oBAAA;EACA,mBAAA;AzBwyGR;AyBryGI;EACI,WAAA;EACA,YAAA;EACA,sBAAA;EACA,UAAA;EACA,eAAA;AzBuyGR;AyBryGQ;EACI,kBAAA;EACA,OAAA;EACA,eAAA;AzBuyGZ;AyBpyGQ;EACI,gBAAA;AzBsyGZ;AyBnyGQ;EACI,UAAA;EACA,WAAA;EACA,kBAAA;EACA,cAAA;AzBqyGZ;AyBnyGQ;EACI,cAAA;EACA,kBAAA;EACA,sBAAA;EACA,WAAA;EACA,WAAA;EACA,kBAAA;EACA,gBAAA;AzBqyGZ;AyBjyGI;EACI,gBAAA;AzBmyGR;AyB7xGY;EACI,cxBvDa;EwBwDb,kBxB2PiB;EwB1PjB,gBxB2PiB;EwB1PjB,kBAAA;EACA,oBAAA;EACA,iBAAA;AzB+xGhB;AyB7xGgB;EACI,gBxByPa;EwBxPb,iBAAA;AzB+xGpB;AyB5xGgB;EACI,gBxBqPa;ADyiGjC;AyB3xGgB;;;;;;EAMI,mBAAA;EACA,kBAAA;EACA,iBAAA;EACA,QAAA;AzB6xGpB;AyB1xGgB;EACI,cxBjGI;AD63GxB;AyBzxGgB;EACI,iBAAA;AzB2xGpB;AyBvxGY;EACI,mBxBuEe;EwBtEf,gBAAA;AzByxGhB;AyBtxGoB;EACI,4BAAA;EACA,6BAAA;AzBwxGxB;AyBtxGoB;EACI,+BAAA;EACA,gCAAA;AzBwxGxB;AyBpxGgB;EACI,WAAA;EACA,aAAA;EACA,gBAAA;EACA,yBAAA;AzBsxGpB;AyBjxGQ;EACI,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,cAAA;EACA,YAAA;EACA,eAAA;EACA,cxBpCiB;EwBqCjB,iBAAA;EACA,iBAAA;EACA,SAAA;EACA,SAAA;AzBmxGZ;AyBhxGQ;EACI,qBAAA;EACA,QAAA;EACA,SAAA;EACA,gBAAA;EACA,gBAAA;EACA,sBAAA;EACA,sBAAA;EACA,wBAAA;EACA,mCAAA;EACA,kCAAA;AzBkxGZ;AyB/wGI;EACG,gBxBiL0B;EwBhL1B,mBxB0BwB;ADuvG/B;AyB/wGI;EACI,exB0BuB;ADuvG/B;AyB9wGI;EACI,sCAAA;EACA,QAAA;EACA,UAAA;EACA,gBAAA;AzBgxGR;;AyB1wGI;EACI,cxB3EqB;EwB4ErB,iBAAA;ETvLN,YSwLuB;ETrLvB,yBAAA;AhBm8GF;AyB5wGQ;EAEI,6BAAA;ET5LV,US6L2B;ET1L3B,0BAAA;ES2LU,cxBnFiB;ADi2G7B;AyBxwGY;EACI,cxB1Ka;EwB2Kb,qBxB3Fa;Ee3G3B,YSuM+B;ETpM/B,yBAAA;AhB+8GF;AyBrwGY;;;;;;;;;;;EAGI,6BAAA;EACA,kBAAA;EACA,cAAA;ETlNd,YSmN+B;EThN/B,yBAAA;AhBg+GF;AyB9wGgB;;;;;;;;;;;;;;;;;;;;;ETrNd,USuNmC;ETpNnC,0BAAA;AhBw/GF;AyB/xGQ;EACI,6BAAA;AzBiyGZ;AyB7xGY;;;;;EAGI,6BAAA;EACA,cxB1Ha;Ee3G3B,USsO+B;ETnO/B,0BAAA;AhBqgHF;AyB7xGI;EACI,cxBjIqB;EwBkIrB,qBxBlIqB;ADi6G7B;AyB7xGI;EACI,cxBrNqB;EwBsNrB,yBxBtIqB;Ee3G3B,YSkPuB;ET/OvB,yBAAA;AhB+gHF;AyB9xGI;;;;;;;;;EAKI,qBxB9IqB;Ee3G3B,US0PuB;ETvPvB,0BAAA;AhB4hHF;;AyBhyGI;EACI,0CAAA;AzBmyGR;;AyB9xGA;EACI,2CxBoKwB;EwBnKxB,2CAAA;AzBiyGJ;AyB7xGY;EACI,cxBjPa;ADghH7B;AyB3xGQ;;;;;EAKI,6BAAA;EACA,kBAAA;EACA,cxBlRY;EeLtB,USwR2B;ETrR3B,0BAAA;AhBmjHF;AyB1xGY;;;EAGI,6BAAA;EACA,cxB3RQ;ADujHxB;AyBvxGQ;EACI,6BAAA;AzByxGZ;AyBpxGI;EACI,cxBvSgB;EwBwShB,qBxBxSgB;AD8jHxB;AyBpxGI;EAGQ,cxBvRiB;AD2iH7B;;AyBhxGA,sCAAA;AAGI;EACI,gBAAA;EACA,mBAAA;AzBixGR;AyB7wGY;EACI,kBAAA;EACA,iBxBYiB;EwBXjB,exBYiB;ADmwGjC;AyB3wGQ;EACI,eAAA;EACA,kBAAA;AzB6wGZ;AyB3wGQ;EACI,eAAA;AzB6wGZ;;AyBxwGA;EfvUU,gBewUP;AzB4wGH;AyB3wGG;EL1UC,gBAAA;EACA,SAAA;EACA,UAAA;EACA,6BAAA;EKyUI,YAAA;EACA,exBxIuB;EwByIvB,gBxBjIuB;EwBkIvB,cxBhUqB;ADglH7B;AyB9wGI;EAEI,cxBhPqB;EwBiPrB,SxBrPqB;EwBsPrB,iDAAA;AzB+wGR;;AyB1wGA;ECpWI,mEzB6awB;ADqsG5B;;AyB3wGA;ECvWI,kEzB8awB;ADwsG5B;;AyB5wGA;EC1WI,oEzB+awB;AD2sG5B;;AyB7wGA;EC7WI,qCzBgbwB;AD8sG5B;;AyB9wGA;EChXI,mEzBibwB;ADitG5B;;AyB9wGA;EACI,iBAAA;EACA,6BAAA;EACA,oCAAA;EACA,YAAA;AzBixGJ;AyB/wGQ;EACI,mBxB9QiB;AD+hH7B;;AyB5wGA;EACI,gBAAA;EACA,mBAAA;EACA,SxB1RyB;ADyiH7B;AyB7wGI;EACI,yBxBzRqB;ADwiH7B;AyB7wGK;;EAEG,yBAAA;AzB+wGR;AyB5wGI;EAEI,6BAAA;AzB6wGR;;AyBxwGI;EACI,eAAA;EACA,QAAA;EACA,yBAAA;EACA,aAAA;AzB2wGR;AyBzwGI;EACI,iBAAA;AzB2wGR;;AyBtwGI;EACI,eAAA;EACA,WAAA;EACA,kBAAA;EACA,sBAAA;EACA,WAAA;EACA,cxBzTqB;ADkkH7B;AyBrwGQ,oFAAA,wBAAA;EACI,cxB9TiB;ADqkH7B;AyBrwGQ,2EAAA,gBAAA;EACI,cxBjUiB;ADwkH7B;AyBrwGQ,+EAAA,WAAA;EACI,cxBpUiB;AD2kH7B;AyBrwGQ,0EAAA,gBAAA;EACI,cxBvUiB;AD8kH7B;;AyBjwGI;EACI,cAAA;AzBowGR;;A2BhsHA;EACI,yB1B6GyB;E0B5GzB,WAAA;A3BmsHJ;A2BjsHI;EACI,YAAA;A3BmsHR;A2BhsHI;EACI,gBAAA;EACA,SAAA;EACA,UAAA;EACA,mBAAA;A3BksHR;A2BhsHQ;EACI,c1BeiB;E0BdjB,cAAA;EACA,kBAAA;A3BksHZ;A2BjsHY;EAEI,+B1BqGa;AD6lH7B;A2B9rHI;EACI,eAAA;A3BgsHR;A2B/rHQ;EACI,oBAAA;A3BisHZ;A2B9rHI;EACG,c1BDsB;E0BEtB,qBAAA;EACA,mBAAA;EACA,iB1ByS0B;E0BxS1B,kB1BoKwB;E0BnKxB,mBAAA;EACA,iB1BoLuB;E0BnLvB,kBAAA;A3BgsHP;A2B/rHO;EAEI,+B1BgFkB;ADgnH7B;A2B7rHI;EACI,+B1B4EqB;E0B3ErB,kBAAA;EACA,gBAAA;EACA,iBAAA;EACA,mB1BiJuB;AD8iH/B;A2B7rHI;EACI,qB1BzBqB;ADwtH7B;A2B7rHI;EACI,+B1BkEqB;AD6nH7B;;A2B3rHA;EACI,yB1BqDyB;ADyoH7B;;A2B1rHI;EACG,mB1BiIwB;AD4jH/B;A2B5rHO;EACK,iBAAA;EACA,WAAA;A3B8rHZ;A2B5rHQ;EACI,iBAAA;EACA,0BAAA;A3B8rHZ;;A2BzrHA;;EAEI,yBAAA;A3B4rHJ;;A4B1wHA;EAEI,gBAAA;EACA,gBAAA;A5B4wHJ;A4B3wHI;EAEI,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,qBAAA;EACA,4BAAA;ECVH,iBAAA;EACA,yBAAA;EACA,kB5BmL2B;E4BlL3B,c5BiBwB;E4BhBxB,gB5BgNwB;E4B/MxB,kB5B8L0B;E4B7L1B,yBAAA;EACA,qBAAA;EACA,sBAAA;EDIG,6BAAA;EACA,yBAAA;EACA,0BAAA;A5BoxHR;A4BlxHQ;ECJH,qB5BVmB;E4BWnB,c5BXmB;ADoyHxB;A4BlxHQ;ECRH,qB5BLmB;E4BMnB,c5BNmB;ADmyHxB;A4BlxHQ;ECZH,qB5BPmB;E4BQnB,c5BRmB;ADyyHxB;A4BlxHQ;EChBH,qB5BNmB;E4BOnB,c5BPmB;AD4yHxB;A4BlxHQ;ECpBH,qB5BRmB;E4BSnB,c5BTmB;ADkzHxB;A4BjxHQ;ElBDJ,4BAAA;AVyxHJ;A4BnxHI;EACI,kBAAA;EACA,mBAAA;EACA,qBAAA;EACA,8BAAA;A5BqxHR;A4BpxHQ;EACI,qBAAA;EACA,YAAA;EACA,kBAAA;A5BsxHZ;A4BjxHI;EACI,c3BlCqB;E2BmCrB,eAAA;EACA,qBAAA;EACA,eAAA;EACA,gBAAA;EACA,mBAAA;EZ3DN,YY4DuB;EZzDvB,yBAAA;AhB60HF;A4BlxHQ;EZ9DN,UYgE2B;EZ7D3B,0BAAA;AhBi1HF;A4BjxHI;EACI,gBAAA;EACA,0BAAA;A5BmxHR;A4BhxHI;EAEI,eAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;EACA,iBAAA;EACA,qBAAA;EACA,MAAA;EACA,WAAA;EACA,UAAA;A5BixHR;A4B/wHI;EACI,UAAA;EACA,kBAAA;A5BixHR;A4B/wHI;EACI,gBAAA;EACA,0BAAA;EACA,c3BxFgB;ADy2HxB;A4B/wHI;EACI,qBAAA;EACA,sBAAA;A5BixHR;A4B/wHI;EACI,uBAAA;EACA,YAAA;EACA,c3BlFqB;E2BmFrB,SAAA;EACA,+BAAA;EACA,kBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;A5BixHR;A4B5wHQ;ECnGH,qB5BdmB;E4BenB,c5B4FwB;E4B3FxB,yB5BhBmB;ADk4HxB;A4B9wHQ;ECtGH,qB5BTmB;E4BUnB,c5B4FwB;E4B3FxB,yB5BXmB;ADk4HxB;A4BhxHQ;ECzGH,qB5BXmB;E4BYnB,c5B4FwB;E4B3FxB,yB5BbmB;ADy4HxB;A4BlxHQ;EC5GH,qB5BVmB;E4BWnB,c5B4FwB;E4B3FxB,yB5BZmB;AD64HxB;A4BpxHQ;EC/GH,qB5BZmB;E4BanB,c5B4FwB;E4B3FxB,yB5BdmB;ADo5HxB;A4BrxHI;EACI,c3BvBqB;AD8yH7B;;A8B55HA,8CAAA;AAGI;EACI,cAAA;A9B65HR;A8B35HI;EACI,yBAAA;EACA,gBAAA;EACA,c7BDgB;E6BEhB,iBAAA;A9B65HR;A8B35HQ;EAEI,yBAAA;A9B45HZ;A8Bz5HI;;;EAGI,yB7BZgB;E6BahB,cAAA;A9B25HR;A8Bz5HI;EACI,0BAAA;EACA,SAAA;A9B25HR;A8Bz5HI;EACI,0BAAA;A9B25HR;;A8Bp5HQ;EACI,kBAAA;EACA,aAAA;EACA,cAAA;EACA,iBAAA;A9Bu5HZ;A8Br5HY;EACI,sBAAA;EACA,kBAAA;A9Bu5HhB;A8Bl5HY;EACI,yBAAA;EACA,SAAA;EACA,yBAAA;EACA,iBAAA;A9Bo5HhB;A8B34HY;EACI,kBAAA;A9B64HhB;;A8Bv4HA;EACI,YAAA;A9B04HJ;;A8Bv4HA;;EAEI,SAAA;A9B04HJ;;A8Bx4HA;;;;;;EAMI,kBAAA;EACA,aAAA;EACA,+B7BqCyB;ADs2H7B;;A8Bz4HA;;;;;;EAMI,yB7BpFoB;E6BqFpB,SAAA;EACA,cAAA;EACA,iBAAA;A9B44HJ;;A8Bv4HQ;;;EAGG,yB7B/Fa;ADy+HxB;;A8Bn4HQ;;;;;;EAMI,oCAAA;A9Bs4HZ;;A8B/3HQ;;;EAGG,yB7B3Ha;AD6/HxB;;A8B33HQ;;;;;;EAMI,oCAAA;A9B83HZ;;A8Bv3HQ;;;EAGG,yB7B/Ia;ADygIxB;;A8Bn3HQ;;;;;;EAMI,oCAAA;A9Bs3HZ;;A8B/2HQ;;;EAGG,yB7BrKa;ADuhIxB;;A8B32HQ;;;;;;EAMI,oCAAA;A9B82HZ;;A8Bv2HQ;;;EAGG,yB7B9La;ADwiIxB;;A8Bn2HQ;;;;;;EAMI,oCAAA;A9Bs2HZ;;A8B51HY;EACI,iBAAA;A9B+1HhB;;A8Bz1HA;EChOI,yBAAA;EACA,c9BMoB;ADujIxB;;A8B31HA;ECnOI,yBAAA;EACA,c9BCoB;ADikIxB;;A8B71HA;ECtOI,yBAAA;EACA,c9BIoB;ADmkIxB;;A8B/1HA;ECzOI,yBAAA;EACA,c9BKoB;ADukIxB;;A8Bj2HA;EC5OI,yBAAA;EACA,c9BGoB;AD8kIxB;;A8Bl2HA;;EAEI,iBAAA;A9Bq2HJ;A8Bn2HI;;EACI,cAAA;EACA,iBAAA;EACA,c7B1NqB;E6B2NrB,kBAAA;EdtPN,YcuPuB;EdpPvB,yBAAA;AhB2lIF;A8Br2HQ;;;EAEI,6B7BzIiB;EelH3B,Uc4P2B;EdzP3B,0BAAA;AhBkmIF;A8Bt2HI;;EACI,eAAA;A9By2HR;A8Bv2HI;;;;EAEG,c7B/PiB;AD0mIxB;;A8Bp2HA;EACI,qBAAA;A9Bu2HJ;A8Bt2HK;EACG,eAAA;EACA,mBAAA;A9Bw2HR;A8Bt2HI;EACI,mB7BzEuB;E6B0EvB,mBAAA;EACA,e7B3EuB;ADm7H/B;;A8Bp2HA;EACI,cAAA;A9Bu2HJ;A8Bt2HI;EACI,mBAAA;A9Bw2HR;;A8Bp2HA;EACI,c7BhSoB;ADuoIxB;;A8Br2HA;EACI,c7B9RoB;ADsoIxB;;A8Bt2HA;EACI,c7BnSoB;AD4oIxB;;A8Bv2HA;EACI,c7BrSoB;AD+oIxB;;A8Bx2HA;EACI,c7B1SoB;ADqpIxB;;A8Bx2HA;EACI,kB7B9H2B;ADy+H/B;A8Bz2HI;EACI,mB7BxGuB;E6ByGvB,yBAAA;EACA,cAAA;EACA,gBAAA;EACA,gB7BrGqB;ADg9H7B;A8Bx2HI;EACI,cAAA;A9B02HR;A8Bx2HI;EACI,aAAA;A9B02HR;;A8Br2HI;EACI,qBAAA;A9Bw2HR;A8Bt2HI;EACI,kBAAA;A9Bw2HR;;A8Bp2HA;EACI,eAAA;A9Bu2HJ;;A8Bp2HA;EACI,cAAA;EACA,WAAA;EACA,kBAAA;A9Bu2HJ;;A8Bn2HQ;EACI,kB7BpMmB;AD0iI/B;A8Bn2HI;EACI,a7BxMuB;AD6iI/B;;A8B71HI;EACI,SAAA;EACA,gBAAA;EACA,mBAAA;A9Bg2HR;A8B91HQ;EACI,UAAA;EACA,2CAAA;A9Bg2HZ;A8B91HY;EACI,aAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;A9Bg2HhB;A8B91HgB;EACI,WAAA;EACA,kBAAA;EACA,cAAA;EACA,WAAA;EACA,eAAA;A9Bg2HpB;A8B91HoB;EACI,cAAA;A9Bg2HxB;A8B31HY;EACI,qBAAA;EACA,QAAA;EACA,SAAA;EACA,gBAAA;EACA,sBAAA;EACA,sBAAA;EACA,wBAAA;EACA,mCAAA;EACA,kCAAA;EACA,YAAA;EACA,gBAAA;EACA,kBAAA;EpBzWZ,6BAAA;AV2sIJ;A8B91HY;;EAEI,gEAAA;EAGA,yBAAA;A9Bg2HhB;A8B31HY;EACI,qDAAA;A9B61HhB;A8Bz1HQ;EAKI,uCAAA;A9B21HZ;;A8Bp1HA;EACI,0BAAA;A9Bu1HJ;A8Bl1HgB;EACI,kBAAA;A9Bo1HpB;;A8Bv0HQ;EACI,kBAAA;A9B00HZ;;A8Bp0HI;EACI,gBAAA;A9Bu0HR;;A8B/zHI;EACI,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;A9Bk0HR;A8Bh0HQ;EACI,aAAA;A9Bk0HZ;A8Bj0HY;EACI,kBAAA;EACA,YAAA;EACA,yBAAA;EACA,c7B/Wa;E6BgXb,yBAAA;EACA,oBAAA;A9Bm0HhB;A8Bj0HgB;EACI,yB7B1dI;AD6xIxB;;AgCryIA;EACI,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,mBAAA;AhCwyIJ;;AgCtyIA;EACI,WAAA;AhCyyIJ;;AgCtyIA;;EAEG,yB/BVqB;ADmzIxB;;AgCvyIA;EACI,yB/BRoB;ADkzIxB;;AgCxyIA;EACG,yB/BbqB;ADwzIxB;;AgCzyIA;EACG,yB/BfqB;AD2zIxB;;AgC1yIA;EACG,yB/BpBqB;ADi0IxB;;AiCr0IA;;;;;;;;;EAAA;AAWA;EACC,kBAAA;EACA,gBAAA;AjCu0ID;;AiCr0IA;EACC,kBAAA;EACA,UAAA;EACA,YAAA;EACA,aAAA;EACA,eAAA;AjCw0ID;;AiCt0IA;EACC,kBAAA;EACA,UAAA;EACA,gBAAA;EACA,cAAA;EACA,SAAA;EACA,wBAAA;AjCy0ID;;AiCt0IA,wBAAA;AACA;;EAEC,eAAA;AjCy0ID;;AiCt0IA;EACC,WAAA;AjCy0ID;;AiCv0IA;EACI,kBAAA;EACA,SAAA;AjC00IJ;;AiCx0IA;EACC,MAAA;EACA,YAAA;AjC20ID;;AiCz0IA;EACC,OAAA;AjC40ID;;AiC10IA;EACC,QAAA;AjC60ID;;AiC10IA;EACC,YAAA;EACA,aAAA;AjC60ID;;AiC30IA;EACC,YAAA;EACA,cAAA;EACA,qBAAA;AjC80ID;;AiC50IA;EACC,OAAA;EACA,WAAA;AjC+0ID;;AiC70IA;EACC,SAAA;AjCg1ID;;AiC90IA;EACC,MAAA;AjCi1ID;;AiC90IA;mCAAA;AAEA;EACC,gBAAA;AjCi1ID;;AiC/0IA;EACC,cAAA;AjCk1ID;;AiCh1IA;;;;EAIC,cAAA;AjCm1ID;;AiCj1IA;EACC,yBAAA;AjCo1ID;;AiCl1IA;EACC,cAAA;AjCq1ID;;AiCn1IA;EACC,mBAAA;EACA,cAAA;EACA,iBAAA;AjCs1ID;;AiCp1IA;EACC,cAAA;AjCu1ID;;AiCp1IA;EACG,yBhCvGqB;AD87IxB;;AiCr1IA;EACI,yBhCrGoB;AD67IxB;;AiCt1IA;EACG,yBhC1GqB;ADm8IxB;;AiCv1IA;EACG,yBhC5GqB;ADs8IxB;;AiCx1IA;EACG,yBhCjHqB;AD48IxB;;AiCx1IA;mCAAA;AAEA;;;EAGC,8BAAA,EAAA,iBAAA,EACG,WAAA,EACA,oBAAA,EACA,yBAAA,EACA,iBAAA,EACA,UAAA;EACA,sFAAA,EAAA,QAAA;EACA,mHAAA,EAAA,UAAA;EAEA,kBAAA;EACA,iEAAA;EACH,YAAA;EACA,WAAA;EACA,eAAA;AjC01ID;;AiCx1IA;;;EAGC,cAAA;EACA,qBAAA;AjC21ID;;AiCx1IA;;;;;;;;EAQC,cAAA;EACA,qBAAA;AjC21ID;;AiCz1IA;;;EAGC,cAAA;EACA,qBAAA;AjC41ID;;AiCz1IA;mCAAA;AAEA;;;EAGC,yBAAA;EACA,mBAAA;EACA,cAAA;AjC41ID;;AiC11IA;;;EAGC,cAAA;AjC61ID;;AiC31IA;;;EAGC,yBAAA;EACA,yBhCnLuB;EgCoLvB,chCpLuB;ADkhJxB;;AiC51IA;;;EAGC,chCzLuB;ADwhJxB;;AiC71IA;;;EAGC,chC9LuB;AD8hJxB;;AiC91IA;;;EAGC,iBAAA;AjCi2ID;;AiC/1IA;;;EAGC,YAAA;EACA,yBAAA;EACA,mBAAA;AjCk2ID;;AiCh2IA;;;EAGC,aAAA;EACA,yBAAA;EACA,sBAAA;AjCm2ID;;AiCj2IA;EACC,yBAAA,EAAA,wBAAA;AjCo2ID;;AkC7jJA;EACI,kBAAA;EACA,SAAA;EACA,UAAA;EACA,mBjCqL2B;EiCpL3B,cAAA;EACA,aAAA;EACA,kBAAA;ElBJF,UkBMmB;ElBHnB,wBAAA;ENMQ,4CwBFN;AlCikJJ;AkC/jJI;ElBTF,UkBUuB;ElBPvB,0BAAA;EkBQM,mBAAA;AlCkkJR;AkChkJI;EACG,4BjC+MoB;ESpNjB,gBwBMH;ExBmEC,2BTuJqB;ES/LrB,mBAAA;EARJ,4BAAA;EwBfG,iBAAA;AlC+kJP;AkC7kJI;EACI,gBAAA;AlC+kJR;AkC5kJI;EACG,iBAAA;EACA,cAAA;AlC8kJP;AkC5kJO;EACI,gBAAA;AlC8kJX;AkC3kJI;EACI,qBAAA;AlC6kJR;AkC1kJI;EACI,eAAA;AlC4kJR;AkCzkJI;EACG,4BjC4IwB;EiC3IxB,6BjC2IwB;ADg8I/B;AkCxkJI;EACI,+BjCuIuB;EiCtIvB,gCjCsIuB;ADo8I/B;AkCvkJI;EACI,gBAAA;EACA,qBAAA;AlCykJR;AkCtkJI;;EAEI,yBjCoDqB;EiCnDrB,cAAA;EACA,UAAA;EACA,qBAAA;AlCwkJR;AkCrkJI;EAEI,yBjCvDqB;AD6nJ7B;AkCpkJI;EAEI,yBjC1DqB;AD+nJ7B;AkCnkJI;EAEI,yBjC7DqB;ADioJ7B;AkClkJI;EAEI,wCjChEqB;ADmoJ7B;AkCjkJI;EAEI,uCjCnEqB;ADqoJ7B;AkC9jJQ;EACI,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,WAAA;EACA,mBAAA;AlCgkJZ;AkC3jJQ;EAEI,sBAAA;EACA,qBAAA;AlC4jJZ;;AkCrjJI;EACI,iBAAA;EACA,iBAAA;AlCwjJR;AkCtjJI;EACI,kBAAA;EACA,iBAAA;EACA,WAAA;AlCwjJR;AkCtjJQ;EACK,eAAA;EACA,WAAA;AlCwjJb;AkCtjJQ;EAMI,eAAA;EACA,WAAA;AlCmjJZ;;AkC7iJA;EACI,gBAAA;AlCgjJJ;;AkC9iJA;EACI,iBAAA;AlCijJJ;;AmC5rJA;EACI,kBlCsL4B;EkCrL5B,yBlC4GyB;EkC3GzB,mBAAA;AnC+rJJ;AmC7rJI;EACI,WAAA;EACA,gBAAA;EACA,aAAA;EACA,0BAAA;EACA,kBAAA;EAGA,4BAAA;AnC+rJR;AmC7rJQ;EACI,WAAA;AnC+rJZ;AmC5rJI;EACI,kBAAA;EACA,UAAA;EACA,qCAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EnBxBN,UmB0BuB;EnBvBvB,wBAAA;AhBqtJF;AmC5rJQ;EzBgFN,kBAAA;EACA,QAAA;EAGA,2BAAA;AV+mJF;AmC/rJI;EnBhCF,UmBiCuB;EnB9BvB,0BAAA;AhBguJF;AmChsJI;EnBnCF,UmBoCuB;EnBjCvB,wBAAA;AhBouJF;AmCjsJI;EnBtCF,UmBuCuB;EnBpCvB,0BAAA;AhBwuJF;AmClsJI;EACI,4BAAA;AnCosJR;AmClsJI;EACI,oBAAA;EACA,yBlC6DqB;EkC5DrB,8BAAA;AnCosJR;AmCjsJI;;EAEI,mBlC2IuB;EkC1IvB,gBlC4JqB;EkC3JrB,clC3BqB;EkC4BrB,kBAAA;AnCmsJR;AmCjsJQ;;EACI,elCkJmB;ADkjJ/B;AmChsJI;EACI,kBlCkIuB;EkCjIvB,kBAAA;EACA,oBAAA;AnCksJR;AmCjsJQ;EACI,iBlC6HmB;ADskJ/B;AmC/rJI;EACI,SlC+BqB;EkC9BrB,clCrDqB;EkCsDrB,gBlCsIqB;AD2jJ7B;AmC/rJI;EACI,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,iBAAA;AnCisJR;AmC/rJI;EACI,mBlC4GuB;EkC3GvB,WAAA;AnCisJR;AmC/rJI;EACI,4BAAA;EACA,6BlC0BqB;EkCzBrB,iBAAA;EACA,2BAAA;EACA,eAAA;AnCisJR;AmC/rJQ;EACI,cAAA;AnCisJZ;AmC9rJQ;EACI,eAAA;EACA,kBAAA;AnCgsJZ;AmC7rJI;EACI,cAAA;AnC+rJR;AmC5rJI;EACI,kBlCsFuB;EkCrFvB,gBlCuGqB;EkCtGrB,yBAAA;EACA,kBAAA;EAGA,0CAAA;EACA,gBAAA;EACA,cAAA;EAKA,4BAAA;AnC4rJR;AmC1rJI;EACI,mBlCoEuB;ADwnJ/B;AmC1rJI;EACI,kBlCmEuB;EkClEvB,SAAA;AnC4rJR;AmC1rJI;EACI,YAAA;EACA,YAAA;EACA,MAAA;EACA,UAAA;EACA,yBlC9GqB;EkC+GrB,aAAA;EACA,kBAAA;AnC4rJR;AmCzrJI;EACI,mBAAA;AnC2rJR;AmCvrJI;EACI,0BAAA;AnCyrJR;AmCtrJI;EACI,kBlC+BwB;EkC9BxB,kBAAA;AnCwrJR;AmCtrJQ;EACI,kBAAA;AnCwrJZ;AmCnrJQ;EACI,mBAAA;EACA,clCrDiB;AD0uJ7B;AmClrJY;EACI,YAAA;EACA,aAAA;AnCorJhB;;AmC1qJI;EACI,sBAAA;AnC6qJR;AmC3qJQ;EACI,iBAAA;AnC6qJZ;AmC3qJY;EACI,gBAAA;AnC6qJhB;AmCzqJI;EACI,2BAAA;AnC2qJR;AmCzqJI;EACI,cAAA;EACA,gBAAA;AnC2qJR;AmCzqJQ;EACI,iBAAA;AnC2qJZ;;AmCnqJI;EACI,aAAA;AnCsqJR;AmCpqJI;EACI,SAAA;EACA,iBAAA;AnCsqJR;AmCpqJI;EACI,kBAAA;EACA,oBAAA;EACA,iBAAA;AnCsqJR;AmCpqJI;EACI,YAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;AnCsqJR;AmCpqJQ;EACI,qBAAA;AnCsqJZ;AmCnqJI;EACI,iBAAA;AnCqqJR;AmCnqJI;EACI,iBAAA;AnCqqJR;AmCnqJI;EACI,UAAA;AnCqqJR;AmCjqJQ;EACI,eAAA;AnCmqJZ;;AmC5pJI;;EACI,sBAAA;AnCgqJR;AmC9pJI;;EACI,gBAAA;AnCiqJR;;AmC9pJA;EACI,6BAAA;EACA,gBAAA;EACA,gBAAA;AnCiqJJ;AmC/pJI;EACI,kBAAA;AnCiqJR;;AmC7pJA;EACI,uBAAA;AnCgqJJ;AmC9pJI;EACI,wCAAA;AnCgqJR;;AmC3pJI;EACI,mDAAA;EACA,mBAAA;EACA,iBAAA;EACA,oBAAA;EzBhNA,iCAAA;EAhCJ,4BAAA;AVw5JJ;AmCpqJQ;EACI,kBAAA;AnCsqJZ;AmCpqJQ;EACI,UAAA;EzBxNJ,mCAAA;AVm4JR;AmCpqJY;EACI,8CAAA;AnCsqJhB;;AoCz1JE;EAxDA,wBC7Bc;ED8Bd,yBC9Bc;ED+Bd,iBC9Ba;ED+Bb,cC5BoB;ArCi7JtB;;AoC51JE;;EArEA,cAAA;EAKA,aAAA;ApCs6JF;;AoCj2JE;EA3FA,qBA4F4B;EAxF5B,2BAwFsC;EArFpC,gBAAA;EAuFA,kBAAA;ApC22JJ;;AoCx2JE;EAjGA,uBAkG4B;EA9F5B,2BA8FwC;EA3FtC,gBAAA;EA6FA,kBAAA;ApCk3JJ;;AoC/2JE;EAvGA,qBAwG4B;EApG5B,yBAoGsC;EA/FpC,iBAAA;EAiGA,gBAAA;ApCy3JJ;;AoCt3JE;EA7GA,qBA8G4B;EA1G5B,2BA0GsC;EAvGpC,gBAAA;EAyGA,kBAAA;ApCg4JJ;;AoC73JE;EAnHA,qBAoH4B;EAhH5B,uBAgHsC;EAzGpC,kBAAA;EA2GA,kBAAA;ApCu4JJ;;AoCp4JE;EAzHA,uBA0H4B;EAtH5B,uBAsHwC;EA/GtC,kBAAA;EAiHA,kBAAA;ApC84JJ;;AoC34JE;EA/HA,qBAgI4B;EA5H5B,2BA4HsC;EAzHpC,gBAAA;EA2HA,kBAAA;ApCq5JJ;;AoCl5JE;EArIA,uBAsI4B;EAlI5B,2BAkIwC;EA/HtC,gBAAA;EAiIA,kBAAA;ApC45JJ;;AoCz5JE;EA3IA,mBA6I4B;EAzI5B,yBAyIoC;EApIlC,iBAAA;EAsIA,gBAAA;ApCk6JJ;;AoC/5JE;EAlJA,mBAmJ4B;EA/I5B,2BA+IoC;EA5IlC,gBAAA;EA8IA,gBAAA;ApCy6JJ;;AoCt6JE;EAvHA,0BC7Bc;ED8Bd,iBC5Bc;ED+BZ,qBChCgB;ArC+jKpB;;AoCx6JE;EAlHA,iBC/Bc;EDgCd,qBC9Be;ArC4jKjB;;AoCz6JE;EAjHA,UAAA;EACA,iBCvCc;ArCqkKhB;;AoC16JE;EA5GA,YAAA;EACA,iBC1CgB;ArCokKlB;;AoC36JE;EA3GA,UAAA;EACA,kBC5Ca;ArCskKf;;AoC56JE;EA1GA,UAAA;EACA,kBC9Ce;ArCwkKjB;;AoCthKE;EACE,eA2GY;ApC86JhB;AoCthKE;EACE,aAuGY;ApCi7JhB;;AoC7hKE;EACE,eA2GY;ApCq7JhB;AoC7hKE;EACE,aAuGY;ApCw7JhB;;AoCpiKE;EACE,eA2GY;ApC47JhB;AoCpiKE;EACE,aAuGY;ApC+7JhB;;AoC3iKE;EACE,eA2GY;ApCm8JhB;AoC3iKE;EACE,aAuGY;ApCs8JhB;;AoCljKE;EACE,eA2GY;ApC08JhB;AoCljKE;EACE,aAuGY;ApC68JhB;;AoCzjKE;EACE,eA2GY;ApCi9JhB;AoCzjKE;EACE,aAuGY;ApCo9JhB;;AoChkKE;EACE,eA2GY;ApCw9JhB;AoChkKE;EACE,aAuGY;ApC29JhB;;AoCvkKE;EACE,eA2GY;ApC+9JhB;AoCvkKE;EACE,aAuGY;ApCk+JhB;;AoC9kKE;EACE,eA2GY;ApCs+JhB;AoC9kKE;EACE,aAuGY;ApCy+JhB;;AoCrlKE;EACE,eA2GY;ApC6+JhB;AoCrlKE;EACE,aAuGY;ApCg/JhB;;AoC5lKE;EACE,eA2GY;ApCo/JhB;AoC5lKE;EACE,aAuGY;ApCu/JhB;;AoCnmKE;EACE,eA2GY;ApC2/JhB;AoCnmKE;EACE,aAuGY;ApC8/JhB;;AoC1mKE;EACE,eA2GY;ApCkgKhB;AoC1mKE;EACE,aAuGY;ApCqgKhB;;AoCjnKE;EACE,eA2GY;ApCygKhB;AoCjnKE;EACE,aAuGY;ApC4gKhB;;AoCxnKE;EACE,eA2GY;ApCghKhB;AoCxnKE;EACE,aAuGY;ApCmhKhB;;AoCtgKM;EA/NJ,cAAA;EACA,kBAAA;EACA,WAHyC;ApC4uK3C;AoCvuKE;EACE,cAAA;EACA,WAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,oBAAA;ApCyuKJ;AoCtuKE;EACE,WAAA;EACA,cAAA;EACA,WAAA;ApCwuKJ;AoCruKE;EACE,cAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;ApCuuKJ;;AoC/hKM;EA/NJ,cAAA;EACA,kBAAA;EACA,WAHyC;ApCqwK3C;AoChwKE;EACE,cAAA;EACA,WAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,sBAAA;ApCkwKJ;AoC/vKE;EACE,WAAA;EACA,cAAA;EACA,WAAA;ApCiwKJ;AoC9vKE;EACE,cAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;ApCgwKJ;;AoCxjKM;EA/NJ,cAAA;EACA,kBAAA;EACA,WAHyC;ApC8xK3C;AoCzxKE;EACE,cAAA;EACA,WAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,8BAAA;ApC2xKJ;AoCxxKE;EACE,WAAA;EACA,cAAA;EACA,WAAA;ApC0xKJ;AoCvxKE;EACE,cAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;ApCyxKJ;;AoCjlKM;EA/NJ,cAAA;EACA,kBAAA;EACA,WAHyC;ApCuzK3C;AoClzKE;EACE,cAAA;EACA,WAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,8BAAA;ApCozKJ;AoCjzKE;EACE,WAAA;EACA,cAAA;EACA,WAAA;ApCmzKJ;AoChzKE;EACE,cAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;ApCkzKJ;;AoC1mKM;EA/NJ,cAAA;EACA,kBAAA;EACA,WAHyC;ApCg1K3C;AoC30KE;EACE,cAAA;EACA,WAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,mBAAA;ApC60KJ;AoC10KE;EACE,WAAA;EACA,cAAA;EACA,WAAA;ApC40KJ;AoCz0KE;EACE,cAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;ApC20KJ;;AoCnoKM;EA/NJ,cAAA;EACA,kBAAA;EACA,WAHyC;ApCy2K3C;AoCp2KE;EACE,cAAA;EACA,WAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,mBAAA;ApCs2KJ;AoCn2KE;EACE,WAAA;EACA,cAAA;EACA,WAAA;ApCq2KJ;AoCl2KE;EACE,cAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;ApCo2KJ;;AoC5pKM;EA/NJ,cAAA;EACA,kBAAA;EACA,WAHyC;ApCk4K3C;AoC73KE;EACE,cAAA;EACA,WAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,8BAAA;ApC+3KJ;AoC53KE;EACE,WAAA;EACA,cAAA;EACA,WAAA;ApC83KJ;AoC33KE;EACE,cAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;ApC63KJ;;AoCrrKM;EA/NJ,cAAA;EACA,kBAAA;EACA,WAHyC;ApC25K3C;AoCt5KE;EACE,cAAA;EACA,WAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,qBAAA;ApCw5KJ;AoCr5KE;EACE,WAAA;EACA,cAAA;EACA,WAAA;ApCu5KJ;AoCp5KE;EACE,cAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;ApCs5KJ;;AoC9sKM;EA/NJ,cAAA;EACA,kBAAA;EACA,WAHyC;ApCo7K3C;AoC/6KE;EACE,cAAA;EACA,WAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,6BAAA;ApCi7KJ;AoC96KE;EACE,WAAA;EACA,cAAA;EACA,WAAA;ApCg7KJ;AoC76KE;EACE,cAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;ApC+6KJ;;AoCvuKM;EA/NJ,cAAA;EACA,kBAAA;EACA,WAHyC;ApC68K3C;AoCx8KE;EACE,cAAA;EACA,WAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,mBAAA;ApC08KJ;AoCv8KE;EACE,WAAA;EACA,cAAA;EACA,WAAA;ApCy8KJ;AoCt8KE;EACE,cAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;ApCw8KJ;;AoChwKM;EA/NJ,cAAA;EACA,kBAAA;EACA,WAHyC;ApCs+K3C;AoCj+KE;EACE,cAAA;EACA,WAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,sBAAA;ApCm+KJ;AoCh+KE;EACE,WAAA;EACA,cAAA;EACA,WAAA;ApCk+KJ;AoC/9KE;EACE,cAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;ApCi+KJ;;AoCzxKM;EA/NJ,cAAA;EACA,kBAAA;EACA,WAHyC;ApC+/K3C;AoC1/KE;EACE,cAAA;EACA,WAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,8BAAA;ApC4/KJ;AoCz/KE;EACE,WAAA;EACA,cAAA;EACA,WAAA;ApC2/KJ;AoCx/KE;EACE,cAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;ApC0/KJ;;AoClzKM;EA/NJ,cAAA;EACA,kBAAA;EACA,WAHyC;ApCwhL3C;AoCnhLE;EACE,cAAA;EACA,WAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,mBAAA;ApCqhLJ;AoClhLE;EACE,WAAA;EACA,cAAA;EACA,WAAA;ApCohLJ;AoCjhLE;EACE,cAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;ApCmhLJ;;AoC30KM;EA/NJ,cAAA;EACA,kBAAA;EACA,WAHyC;ApCijL3C;AoC5iLE;EACE,cAAA;EACA,WAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,mBAAA;ApC8iLJ;AoC3iLE;EACE,WAAA;EACA,cAAA;EACA,WAAA;ApC6iLJ;AoC1iLE;EACE,cAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;ApC4iLJ;;AoCp2KM;EA/NJ,cAAA;EACA,kBAAA;EACA,WAHyC;ApC0kL3C;AoCrkLE;EACE,cAAA;EACA,WAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,qBAAA;ApCukLJ;AoCpkLE;EACE,WAAA;EACA,cAAA;EACA,WAAA;ApCskLJ;AoCnkLE;EACE,cAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;ApCqkLJ;;AoC73KM;EA/NJ,cAAA;EACA,kBAAA;EACA,WAHyC;ApCmmL3C;AoC9lLE;EACE,cAAA;EACA,WAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,8BAAA;ApCgmLJ;AoC7lLE;EACE,WAAA;EACA,cAAA;EACA,WAAA;ApC+lLJ;AoC5lLE;EACE,cAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;ApC8lLJ;;AoCt5KM;EA/NJ,cAAA;EACA,kBAAA;EACA,WAHyC;ApC4nL3C;AoCvnLE;EACE,cAAA;EACA,WAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,mBAAA;ApCynLJ;AoCtnLE;EACE,WAAA;EACA,cAAA;EACA,WAAA;ApCwnLJ;AoCrnLE;EACE,cAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;ApCunLJ;;AsC/oLA;EAEI;IACI,yBAAA;EtCipLN;EsC9oLE;IACI,kBAAA;IACA,kBAAA;EtCgpLN;EsC7oLU;IACI,iBAAA;EtC+oLd;EsC1oLE;IACI,aAAA;EtC4oLN;EsCvoLU;IACI,gBAAA;IACA,gBAAA;EtCyoLd;EsCtoLc;IACI,aAAA;EtCwoLlB;EsCpoLc;IACI,aAAA;EtCsoLlB;EsCjoLE;IACI,aAAA;EtCmoLN;EsChoLE;I5BEI,mBAAA;IARJ,sDAAA;EVkpLF;EsCxoLE;I5BFI,mBAAA;IAwCA,4BTkJoB;ED49K1B;EsC9oLE;;;I5BQA,mCAAA;I4BJI,UAAA;EtCopLN;EsC9oLc;IACI,UAAA;EtCgpLlB;EsC9oLc;IACI,UAAA;EtCgpLlB;EsC1oLE;IACI,YAAA;EtC4oLN;EsC3oLM;IACI,WAAA;EtC6oLV;EsC3oLM;IACI,YAAA;EtC6oLV;EsC1oLE;IACI,4CAAA;IACA,wCAAA;IACA,yCAAA;IACA,WAAA;IACA,qBAAA;IACA,kBAAA;IACA,UAAA;IACA,UAAA;EtC4oLN;EsC1oLE;IACI,iCAAA;IACA,wCAAA;IACA,yCAAA;IACA,WAAA;IACA,qBAAA;IACA,kBAAA;IACA,UAAA;IACA,UAAA;EtC4oLN;EsCzoLE;IACI,UAAA;IACA,WAAA;EtC2oLN;EsCxoLE;IACI,UAAA;IACA,WAAA;EtC0oLN;EsCroLS;IACE,cAAA;EtCuoLX;EsChoLU;IACI,YAAA;EtCkoLd;EsChoLU;IACI,kBAAA;EtCkoLd;EsChoLU;IACI,mBAAA;EtCkoLd;AACF;AsC7nLA,4CAAA;AAEA;EAEI;IACI,mBAAA;IACA,UAAA;I5BjFJ,mCAAA;IAxBA,0DAAA;EVgvLF;EsCjoLM;IACI,kBAAA;IACA,OAAA;I5BzFR,oCAAA;IAxBA,0DAAA;EV8vLF;EsCxoLM;I5B9FJ,iCAAA;IAxBA,0DAAA;EV0wLF;EsC9oLE;I5B5HA,0DAAA;EVixLF;EsC/oLM;IACI,kBAAA;IACA,WAAA;I5B5GR,oCAAA;IAxBA,0DAAA;EV+xLF;EsCvpLM;I5BhHJ,iCAAA;IAxBA,0DAAA;EV2yLF;EsC3pLc;IACI,kBAAA;IACA,OAAA;I5B1HhB,mCAAA;IAxBA,0DAAA;EVyzLF;EsClqLc;I5B/HZ,iCAAA;IAxBA,0DAAA;EVq0LF;EsCrqLE;IACI,6BAAA;EtCuqLN;EsCpqLE;IACI,iDAAA;IACA,mBAAA;IACA,oBAAA;IACA,gBAAA;EtCsqLN;EsCnqLU;IACI,2BAAA;IACA,WAAA;IACA,WAAA;IACA,crCtGa;IqCuGb,aAAA;IACA,6BAAA;IACA,SAAA;IAEA,gBAAA;IACA,gDAAA;I5BrLZ,0DAAA;EV+1LF;EsCvqLc;IACI,yBAAA;IACA,kBAAA;IACA,crClHS;IqCmHT,aAAA;IACA,iBAAA;EtCyqLlB;EsCxqLkB;IACI,2CAAA;EtC0qLtB;EsCxqLkB;IACI,kBAAA;EtC0qLtB;EsClqLc;IACI,gCAAA;EtCoqLlB;EsClqLc;IACI,kBAAA;EtCoqLlB;EsC/pLE;IACI,WAAA;EtCiqLN;EsC9pLE;IACI,iBAAA;EtCgqLN;EsC9pLE;IACI,iBAAA;EtCgqLN;EsC7pLE;IACK,kBAAA;EtC+pLP;EsC7pLE;IACG,OAAA;IACA,uBAAA;EtC+pLL;EsC7pLE;IACI,UAAA;IACA,WAAA;IACA,kBAAA;IACA,UAAA;EtC+pLN;EsC3pLM;IACI,WAAA;IACA,kBAAA;IACA,cAAA;EtC6pLV;EsCzpLE;IACI,eAAA;IACA,cAAA;IACA,MAAA;IACA,YAAA;IACA,QAAA;IACA,UAAA;IACA,aAAA;IACA,mBAAA;IACA,sBAAA;IACA,mBAAA;IACA,gBAAA;IACA,gBAAA;IACA,UAAA;I5BjPA,mCAAA;IAhBJ,2DAAA;EVs6LF;EsCjqLM;IACI,kBAAA;IACA,UAAA;IACA,kBAAA;IACA,0BAAA;IACA,WAAA;EtCmqLV;EsChqLM;IACI,MAAA;IACA,OAAA;IACA,YAAA;IACA,WAAA;IACA,kBAAA;IACA,yBAAA;IACA,cAAA;IACA,WAAA;IACA,UAAA;EtCkqLV;EsC/pLM;IACI,kBAAA;IACA,UAAA;EtCiqLV;EsC9pLM;IACI,kBAAA;EtCgqLV;EsC7pLE;I5BlRI,iCAAA;EVs7LN;EsCjqLE;IACI,YAAA;EtCmqLN;EsCjqLE;IACI,OAAA;I5BzRA,oCAAA;EVi8LN;EsCrqLE;IACM,cAAA;IACA,kBAAA;IACA,gBAAA;IACA,WAAA;IACA,WAAA;IACA,kBAAA;IACA,cAAA;EtCuqLR;EsCpqLE;IACI,wBAAA;IACA,WAAA;IACA,YAAA;EtCsqLN;EsCpqLE;;;IAGE,8BAAA;EtCsqLJ;EsCpqLE;IACE,QAAA;I5BtOD,+BAAA;IAGA,6BAAA;EV+4LH;EsCzqLE;IACE,UAAA;EtC2qLJ;EsCzqLE;IACE,WAAA;I5B7OD,kCAAA;IAGA,6BAAA;EV25LH;EsC9qLE;IACE,QAAA;I5BjPD,4BAAA;IAGA,6BAAA;EVo6LH;EsCnrLE;IACE,UAAA;EtCqrLJ;EsCnrLE;IACE,WAAA;I5BxPD,+BAAA;IAGA,6BAAA;EVg7LH;EU56LE;IACE;MAAI,QAAA;MAAU,uBAAA;IVg7LhB;IU/6LE;MAAK,QAAA;MAAU,yBAAA;IVm7LjB;IUl7LE;MAAK,yBAAA;IVq7LP;IUp7LE;MAAM,yBAAA;IVu7LR;EACF;EUv6LE;IACE;MAAK,QAAA;MAAU,yBAAA;IV28LjB;IU18LE;MAAM,yBAAA;IV68LR;IU58LE;MAAM,uBAAA;IV+8LR;IU98LE;MAAO,QAAA;MAAU,oBAAA;IVk9LnB;EACF;EUh8LE;IACE;MAAI,WAAA;MAAa,uBAAA;IVo+LnB;IUn+LE;MAAK,WAAA;MAAa,0BAAA;IVu+LpB;IUt+LE;MAAK,0BAAA;IVy+LP;IUx+LE;MAAM,0BAAA;IV2+LR;EACF;EU39LE;IACE;MAAK,WAAA;MAAY,0BAAA;IV+/LnB;IU9/LE;MAAM,wBAAA;IVigMR;IUhgME;MAAM,wBAAA;IVmgMR;IUlgME;MAAO,WAAA;MAAY,oBAAA;IVsgMrB;EACF;EsC10LE;IACE;MAAI,UAAA;ItC63LN;IsC53LE;MAAM,UAAA;ItC+3LR;EACF;EsC73LE;IACI,2CAAA;EtC+3LN;EsC53LE;IACI,aAAA;EtC83LN;EsC33LU;IACI,4BAAA;EtC63Ld;EsCv3LM;;;;;;;;;;IAUI,YAAA;EtCy3LV;EsCt3LM;;;IAGI,YAAA;IACA,6BAAA;IACA,aAAA;EtCw3LV;EsCr3LM;;IAEI,0CAAA;EtCu3LV;EsCl3LM;IACI,UAAA;EtCo3LV;EsCh3LU;IACI,yBAAA;IACA,sBAAA;EtCk3Ld;EsCh3LU;IACI,0BAAA;IACA,uBAAA;EtCk3Ld;EsC52LE;IACI,aAAA;EtC82LN;EsC52LE;IACI,mCAAA;EtC82LN;EsC52LE;IACI,YAAA;IACA,WAAA;IACA,eAAA;IACA,UAAA;IACA,MAAA;IACA,UAAA;IACA,YAAA;IACA,WAAA;IACA,aAAA;IACA,kBAAA;EtC82LN;EsC32LE;IACI,kBrCzSuB;EDspM7B;EsC32LE;IACI,kBrC5SuB;EDypM7B;EsC32LE;IACI,WAAA;EtC62LN;EsC32LE;IACI,sBAAA;EtC62LN;EsC32LE;IACI,gBAAA;EtC62LN;EsC32LE;IACI,wCAAA;EtC62LN;EsC32LE;IACI,gBAAA;EtC62LN;EsC32LE;IACI,UAAA;IACA,sBAAA;IACA,cAAA;IACA,mBAAA;EtC62LN;EsC32LE;IACI,WAAA;EtC62LN;EsC12LE;IACI,cAAA;EtC42LN;EsC12LE;IACI,yBAAA;EtC42LN;EsC12LE;IACI,WAAA;EtC42LN;EsC12LE;IACI,gBAAA;IACA,WAAA;IACA,WAAA;IACA,aAAA;IACA,6BAAA;IACA,SAAA;IAEA,gBAAA;EtC42LN;EsCz2LM;IACI,4BAAA;IACA,SAAA;EtC22LV;EsCx2LM;IACI,WAAA;IACA,eAAA;IACA,kBAAA;EtC02LV;AACF;AsCp2LA;EACI;IACI,kBAAA;IACA,mBAAA;EtCs2LN;EsCp2LE;IACI,iBAAA;EtCs2LN;AACF;AsCl2LA;EACI;IACI,WAAA;IACA,mBAAA;IACA,kBAAA;IACA,kBAAA;IACA,4CAAA;IACA,iCAAA;EtCo2LN;EsCj2LE;IACI,YAAA;IACA,WAAA;IACA,kBAAA;IACA,UAAA;IACA,MAAA;IACA,UAAA;IAEA,WAAA;IACA,aAAA;IACA,kBAAA;IACA,qCAAA;I5B1hBJ,6BAAA;EVi4MF;EsCn2LM;IACI,UAAA;EtCq2LV;AACF;AsCj2LA;EAEQ;IACI,sBAAA;EtCk2LV;EsC/1LM;IACI,kBAAA;EtCi2LV;EsC/1LM;IACI,mBAAA;EtCi2LV;EsC31LU;IACI,gBAAA;EtC61Ld;AACF;AuCx7MA;EACE,qBAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,YAAA;EACA,aAAA;EACA,UAAA;EACA,iBAAA;EACA,yBAAA;EAGA,iBAAA;EACA,sBAAA;EAEA,wEAAA;AvC07MF;;AuCv7MA;EACE,oBAAA;EACA,MAAA;EACA,YAAA;EACA,kBAAA;EAEA,+BAAA;EACA,uBAAA;AvC07MF;;AuCv7MA;;;EAKI,sBAAA;EACA,eAAA;EACA,gCAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EAEA,0BAAA;AvC07MJ;AuCx7MI;;;EACI,eAAA;EACA,iBAAA;AvC47MR;;AuCx7MA;;EAEE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,qBAAA;EACA,yBtCxDsB;ADm/MxB;;AuCv7MA;EACE,kBAAA;EACA,YAAA;EACA,cAAA;EACA,mBAAA;EACA,sBAAA;EACA,YAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;EACA,yBAAA;EACA,kEAAA;AvC07MF;;AuCv7MA;EACE,8BAAA;EACA,2BAAA;AvC07MF;;AuCv7MA;EACE,gBAAA;AvC07MF;;AuCv7MA;;EAEE,6BAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;EACA,wBAAA;EACA,WAAA;AvC07MF;;AuCt7MA;EAEE,4BAAA;AvCy7MF;;AuCr7MA;EACE,4BAAA;AvCw7MF;;AuCr7MA;EACE,6BAAA;AvCw7MF;;AuCr7MA;EACE,sBAAA;EACA,iBAAA;AvCw7MF;;AuCr7MA;EACE,sBAAA;EACA,6BAAA;AvCw7MF;;AuCp7MA;EACE,yBtC7HsB;ADojNxB;;AuCp7MA;EACE,yBtC/HsB;ADsjNxB;;AuCp7MA;EACE,yBtCpIsB;AD2jNxB;;AuCp7MA;EACE,yBtCtIsB;AD6jNxB;;AuCp7MA;EACE,yBtC/IsB;ADskNxB;;AuCr7MA;EACE,yBtC5IsB;ADokNxB;;AuCr7MA;;;;;EAKE,yBAAA;AvCw7MF;;AwCrlNA;;;;;kCAAA;AAMA;EACE,2BAAA;EACA,4CAAA;EACA,4SAAA;EACA,mBAAA;EACA,kBAAA;AxCwlNF;AwCtlNA;;0BAAA;AAGA;EACE,qBAAA;EACA,gDAAA;EACA,kBAAA;EACA,WAAA;EACA,oBAAA;EACA,0BAAA;EACA,mCAAA;EACA,kCAAA;AxCwlNF;AwCtlNE;EACE,gBAAA;AxCwlNJ;;AwCrlNA;;0BAAA;AAGA;EACE,uBAAA;EACA,oBAAA;AxCwlNF;;AwCtlNA;EACE,cAAA;AxCylNF;;AwCvlNA;EACE,cAAA;AxC0lNF;;AwCxlNA;;oCAAA;AAGA;;EAEE,qBAAA;EACA,oBAAA;EACA,sBAAA;AxC2lNF;;AwCzlNA;EACE,kBAAA;AxC4lNF;;AwC1lNA;;0BAAA;AAGA;EACE,eAAA;EACA,yBAAA;EACA,qBAAA;AxC6lNF;;AwC3lNA;EACE,kBAAA;AxC8lNF;;AwC5lNA;EACE,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;AxC+lNF;;AwC7lNA;EACE,MAAA;EACA,mBAAA;AxCgmNF;;AwC9lNA;;EAEE,kBAAA;EACA,kBAAA;AxCimNF;;AwC5lNQ;EACI,eAAA;AxC+lNZ;;AwC3lNA;;0BAAA;AAGA;EAGE,0CAAA;AxC8lNF;AwC5kNA;EACE;IAKE,uBAAA;ExC+lNF;EwC7lNA;IAKE,yBAAA;ExC+lNF;AACF;AwC7lNA;;0BAAA;AAGA;EACE,gEAAA;EAKA,wBAAA;AxC+lNF;;AwC7lNA;EACE,gEAAA;EAKA,yBAAA;AxCgmNF;;AwC9lNA;EACE,gEAAA;EAKA,yBAAA;AxCimNF;;AwC/lNA;EACE,gEAAA;EAKA,uBAAA;AxCkmNF;;AwChmNA;EACE,gEAAA;EAKA,uBAAA;AxCmmNF;;AwCjmNA;;0BAAA;AAIA;EACI,gBAAA;AxCmmNJ;;AwChmNA;EACI,gBAAA;AxCmmNJ;;AwChmNA;EACI,gBAAA;AxCmmNJ;;AwChmNA;EACI,gBAAA;AxCmmNJ;;AwChmNA;EACI,gBAAA;AxCmmNJ;;AwChmNA;EACI,gBAAA;AxCmmNJ;;AwChmNA;EACI,gBAAA;AxCmmNJ;;AwChmNA;EACI,gBAAA;AxCmmNJ;;AwChmNA;EACI,gBAAA;AxCmmNJ;;AwChmNA;EACI,gBAAA;AxCmmNJ;;AwChmNA;EACI,gBAAA;AxCmmNJ;;AwChmNA;EACI,gBAAA;AxCmmNJ;;AwChmNA;EACI,gBAAA;AxCmmNJ;;AwChmNA;EACI,gBAAA;AxCmmNJ;;AwChmNA;EACI,gBAAA;AxCmmNJ;;AwChmNA;EACI,gBAAA;AxCmmNJ;;AwChmNA;EACI,gBAAA;AxCmmNJ;;AwChmNA;EACI,gBAAA;AxCmmNJ;;AwChmNA;EACI,gBAAA;AxCmmNJ;;AwChmNA;EACI,gBAAA;AxCmmNJ;;AwChmNA;EACI,gBAAA;AxCmmNJ;;AwChmNA;EACI,gBAAA;AxCmmNJ;;AwChmNA;EACI,gBAAA;AxCmmNJ;;AwChmNA;EACI,gBAAA;AxCmmNJ;;AwChmNA;EACI,gBAAA;AxCmmNJ;;AwChmNA;EACI,gBAAA;AxCmmNJ;;AwChmNA;EACI,gBAAA;AxCmmNJ;;AwChmNA;EACI,gBAAA;AxCmmNJ;;AwChmNA;EACI,gBAAA;AxCmmNJ;;AwChmNA;EACI,gBAAA;AxCmmNJ;;AwChmNA;EACI,gBAAA;AxCmmNJ;;AwChmNA;EACI,gBAAA;AxCmmNJ;;AwChmNA;EACI,gBAAA;AxCmmNJ;;AwChmNA;EACI,gBAAA;AxCmmNJ;;AwChmNA;EACI,gBAAA;AxCmmNJ;;AwChmNA;EACI,gBAAA;AxCmmNJ;;AwChmNA;EACI,gBAAA;AxCmmNJ;;AwChmNA;EACI,gBAAA;AxCmmNJ;;AwChmNA;EACI,gBAAA;AxCmmNJ;;AwChmNA;EACI,gBAAA;AxCmmNJ;;AwChmNA;EACI,gBAAA;AxCmmNJ;;AwChmNA;EACI,gBAAA;AxCmmNJ;;AwChmNA;EACI,gBAAA;AxCmmNJ;;AwChmNA;EACI,gBAAA;AxCmmNJ;;AwChmNA;EACI,gBAAA;AxCmmNJ;;AwChmNA;EACI,gBAAA;AxCmmNJ;;AwChmNA;EACI,gBAAA;AxCmmNJ;;AwChmNA;EACI,gBAAA;AxCmmNJ;;AwChmNA;EACI,gBAAA;AxCmmNJ;;AwChmNA;EACI,gBAAA;AxCmmNJ;;AwChmNA;EACI,gBAAA;AxCmmNJ;;AwChmNA;EACI,gBAAA;AxCmmNJ;;AwChmNA;EACI,gBAAA;AxCmmNJ;;AwChmNA;EACI,gBAAA;AxCmmNJ;;AwChmNA;EACI,gBAAA;AxCmmNJ;;AwChmNA;EACI,gBAAA;AxCmmNJ;;AwChmNA;EACI,gBAAA;AxCmmNJ;;AwChmNA;EACI,gBAAA;AxCmmNJ;;AwChmNA;EACI,gBAAA;AxCmmNJ;;AwChmNA;EACI,gBAAA;AxCmmNJ;;AwChmNA;EACI,gBAAA;AxCmmNJ;;AwChmNA;EACI,gBAAA;AxCmmNJ;;AwChmNA;EACI,gBAAA;AxCmmNJ;;AwChmNA;EACI,gBAAA;AxCmmNJ;;AwChmNA;EACI,gBAAA;AxCmmNJ;;AwChmNA;EACI,gBAAA;AxCmmNJ;;AwChmNA;EACI,gBAAA;AxCmmNJ;;AwChmNA;EACI,gBAAA;AxCmmNJ;;AwChmNA;EACI,gBAAA;AxCmmNJ;;AwChmNA;EACI,gBAAA;AxCmmNJ;;AwChmNA;EACI,gBAAA;AxCmmNJ;;AwChmNA;EACI,gBAAA;AxCmmNJ;;AwChmNA;EACI,gBAAA;AxCmmNJ;;AwChmNA;EACI,gBAAA;AxCmmNJ;;AwChmNA;EACI,gBAAA;AxCmmNJ;;AwChmNA;EACI,gBAAA;AxCmmNJ;;AwChmNA;EACI,gBAAA;AxCmmNJ;;AwChmNA;EACI,gBAAA;AxCmmNJ;;AwChmNA;EACI,gBAAA;AxCmmNJ;;AwChmNA;EACI,gBAAA;AxCmmNJ;;AwChmNA;EACI,gBAAA;AxCmmNJ;;AwChmNA;EACI,gBAAA;AxCmmNJ;;AwChmNA;EACI,gBAAA;AxCmmNJ;;AwChmNA;EACI,gBAAA;AxCmmNJ;;AwChmNA;EACI,gBAAA;AxCmmNJ;;AwChmNA;EACI,gBAAA;AxCmmNJ;;AwChmNA;EACI,gBAAA;AxCmmNJ;;AwChmNA;EACI,gBAAA;AxCmmNJ;;AwChmNA;EACI,gBAAA;AxCmmNJ;;AwChmNA;EACI,gBAAA;AxCmmNJ;;AwChmNA;EACI,gBAAA;AxCmmNJ;;AwChmNA;EACI,gBAAA;AxCmmNJ;;AwChmNA;EACI,gBAAA;AxCmmNJ;;AwChmNA;EACI,gBAAA;AxCmmNJ;;AwChmNA;EACI,gBAAA;AxCmmNJ;;AwChmNA;EACI,gBAAA;AxCmmNJ;;AwChmNA;EACI,gBAAA;AxCmmNJ;;AwChmNA;EACI,gBAAA;AxCmmNJ;;AwChmNA;EACI,gBAAA;AxCmmNJ;;AwChmNA;EACI,gBAAA;AxCmmNJ;;AwC/lNA,oCAAA;AC/hBA;;;;;CAAA;AAOA;EAEE,sBAAA;EAEA,yBAAA;AzCioOF;;AyC9nOA;EAEE,mCAAA;AzCioOF;;AyC9nOA;EAEE,sBAAA;AzCioOF;;AyC9nOA;;EAGE,yBAAA;AzCioOF;;AyC9nOA;;EAGE,yBAAA;AzCioOF;AyC7mOA;EACE;IAEE,+BAAA;EzC8nOF;EyC3nOA;IAEE,mCAAA;EzC6nOF;EyC1nOA;IAEE,kCAAA;EzC4nOF;AACF;AyCznOA;EAEE,qBAAA;AzC2nOF;AyCxmOA;EACE;IACE,UAAA;IAEA,mCAAA;EzCunOF;EyCpnOA;IACE,UAAA;IAEA,eAAA;EzCsnOF;AACF;AyCnnOA;EAEE,0BAAA;AzCqnOF;AyCvmOA;EACE;IACE,UAAA;EzCknOF;EyC/mOA;IACE,UAAA;EzCinOF;AACF;AyC9mOA;EAEE,uBAAA;AzCgnOF;AyCjmOA;EACE;IACE,UAAA;EzC8mOF;EyC3mOA;IACE,UAAA;IAEA,kCAAA;EzC6mOF;AACF;AyC1mOA;EAEE,2BAAA;AzC4mOF;AyC7lOA;EACE;IACE,UAAA;EzC0mOF;EyCvmOA;IACE,UAAA;IAEA,mCAAA;EzCymOF;AACF;AyCtmOA;EAEE,yBAAA;AzCwmOF;;A0Ct0OA;EACE,oCAAA;EACA,eAAA;EACA,OAAA;EACA,QAAA;EACA,MAAA;EACA,SAAA;EACA,aAAA;EACA,aAAA;A1Cy0OF;;A0Cv0OA;EACE,sBAAA;EACA,2DAAA;EACA,kBAAA;EACA,sBAAA;EACA,kBAAA;EACA,eAAA;EACA,SAAA;EACA,QAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,aAAA;A1C00OF;A0Cx0OE;EACI,UAAA;A1C00ON;A0Cv0OE;EACI,aAAA;A1Cy0ON;A0Ct0OE;EACI,gBAAA;EACA,cAAA;A1Cw0ON;;A0Cr0OE;EACE,cAAA;EACA,kBAAA;EACA,oBAAA;EACA,kBAAA;EACA,UAAA;EACA,cAAA;A1Cw0OJ;;A0Ct0OE;EACE,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,SAAA;EACA,UAAA;A1Cy0OJ;;A0Cv0OE;EACE,WAAA;EACA,kBAAA;EACA,SAAA;A1C00OJ;;A0Cx0OE;EACE,WAAA;EACA,SAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,eAAA;A1C20OJ;;A0C10OI;EACE,aAAA;A1C60ON;;A0C50OI;EACE,YAAA;A1C+0ON;;A0C90OI;EACE,6BAAA;EACA,yBAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,cAAA;EACA,sBAAA;EACA,wCAAA;EACA,kBAAA;EACA,eAAA;EACA,mBAAA;EAEQ,wDAAA;A1Ci1Od;;A0Ch1OI;EACE,SAAA;A1Cm1ON;;A0Cl1OE;EACE,2BAAA;A1Cq1OJ;;A0Cp1OE;EACE,WAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;EACA,UAAA;EACA,kBAAA;EACA,uBAAA;A1Cu1OJ;;A0Ct1OI;EACE,qBAAA;A1Cy1ON;;A0Cx1OM;EACE,kBAAA;EACA,cAAA;A1C21OR;;A0C11OM;EACE,kBAAA;EACA,WAAA;EACA,WAAA;EAEA,cAAA;EACA,SAAA;EACA,kBAAA;A1C41OR;;A0C31OQ;EAEU,wBAAA;EACR,UAAA;A1C81OV;;A0C71OQ;EAEU,yBAAA;EACR,WAAA;A1Cg2OV;;A0C/1OI;EACE,qBAAA;A1Ck2ON;;A0Cj2OM;EACE,kBAAA;EACA,UAAA;EACA,YAAA;EACA,SAAA;EACA,SAAA;EACA,kBAAA;EACA,iBAAA;EACA,yBAAA;A1Co2OR;;A0Cn2OM;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,SAAA;EACA,YAAA;EACA,yBAAA;A1Cs2OR;;A0Cr2OI;EACE,qBAAA;A1Cw2ON;;A0Cv2OM;EACE,WAAA;EACA,kBAAA;EACA,UAAA;EACA,YAAA;EACA,SAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;EACA,yBAAA;A1C02OR;;A0Cz2OM;EACE,WAAA;EACA,kBAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,iBAAA;EACA,SAAA;EACA,yBAAA;A1C42OR;;A0C32OI;EACE,qBAAA;A1C82ON;;A0C52OM;EACE,WAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,aAAA;EACA,gBAAA;EAEQ,wBAAA;A1C+2OhB;;A0C72OM;EACE,8BAAA;EACA,SAAA;EACA,WAAA;EAEQ,yBAAA;EAEA,2BAAA;A1Cg3OhB;;A0C/2OM;EACE,8BAAA;EACA,UAAA;EACA,UAAA;EAEQ,yBAAA;EAEA,wBAAA;A1Ck3OhB;;A0Cj3OM;EACE,WAAA;EACA,YAAA;EACA,0CAAA;EACA,kBAAA;EACA,uBAAA;EACA,kBAAA;EACA,UAAA;EACA,SAAA;EACA,UAAA;A1Co3OR;;A0Cn3OM;EACE,UAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAAA;EACA,UAAA;EACA,QAAA;EACA,UAAA;EAEQ,yBAAA;A1Cs3OhB;;A0Cr3OM;EACE,WAAA;EACA,yBzClNgB;EyCmNhB,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,UAAA;A1Cw3OR;;A0Cv3OQ;EACE,WAAA;EACA,UAAA;EACA,SAAA;EAEQ,wBAAA;A1C03OlB;;A0Cz3OQ;EACE,WAAA;EACA,UAAA;EACA,SAAA;EAEQ,yBAAA;A1C43OlB;;A0C33OE;EACE,iBAAA;A1C83OJ;A0C92OA;EACE;IAEU,qBAAA;E1Cm4OV;E0Cl4OA;IAEU,sBAAA;E1Co4OV;E0Cn4OA;IAEU,sBAAA;E1Cq4OV;E0Cp4OA;IAEU,mBAAA;E1Cs4OV;AACF;A0C73OA;EACE;IAEU,mBAAA;E1Cy4OV;E0Cx4OA;IAEU,qBAAA;E1C04OV;AACF;A0Cz4OA;EAEU,8BAAA;A1C24OV;;A0C14OE;EAEU,eAAA;A1C64OZ;;A0C34OA;EAEU,8BAAA;A1C84OV;;A0C74OE;EAEU,eAAA;A1Cg5OZ;A0Cx3OA;EACE;IACE,QAAA;IACA,SAAA;IACA,SAAA;E1Cs5OF;E0Cr5OA;IACE,QAAA;IACA,SAAA;IACA,SAAA;E1Cu5OF;E0Ct5OA;IACE,WAAA;IACA,UAAA;IACA,SAAA;E1Cw5OF;E0Cv5OA;IACE,WAAA;IACA,UAAA;IACA,SAAA;E1Cy5OF;E0Cx5OA;IACE,WAAA;IACA,UAAA;IACA,SAAA;E1C05OF;AACF;A0Cv4OA;EACE;IACE,QAAA;IACA,WAAA;IACA,SAAA;E1C+5OF;E0C95OA;IACE,QAAA;IACA,WAAA;IACA,SAAA;E1Cg6OF;E0C/5OA;IACE,WAAA;IACA,QAAA;IACA,SAAA;E1Ci6OF;E0Ch6OA;IACE,WAAA;IACA,UAAA;IACA,SAAA;E1Ck6OF;AACF;A0Cn5OA;EACE;IAEU,yBAAA;E1Cu6OV;E0Ct6OA;IAEU,yBAAA;E1Cw6OV;E0Cv6OA;IAEU,0BAAA;E1Cy6OV;E0Cx6OA;IAEU,0BAAA;E1C06OV;AACF;A0Cz6OA;EAEU,oCAAA;A1C26OV;;A0Cz6OA;EAEU,qCAAA;A1C46OV;;A0C16OA;EAEU,0CAAA;A1C66OV;A0Cj6OA;EACE;IAEU,0BAAA;IACR,UAAA;E1Cg7OF;E0C/6OA;IAEU,wBAAA;IACR,UAAA;E1Ci7OF;AACF;A0Ch7OA;EAEU,kCAAA;A1Ck7OV;A0C35OA;EACE;IAEU,qBAAA;IACR,gBAAA;IACA,UAAA;E1Cu7OF;E0Ct7OA;IAEU,qBAAA;IACR,gBAAA;IACA,UAAA;E1Cw7OF;E0Cv7OA;IAEU,sBAAA;IACR,gBAAA;E1Cy7OF;E0Cx7OA;IAEU,mBAAA;IACR,aAAA;IACA,UAAA;E1C07OF;AACF;A0Cz7OA;EAEU,8BAAA;A1C27OV;A0Cn7OA;EACE;IACE,qBAAA;E1C87OF;E0C77OA;IACE,qBAAA;E1C+7OF;AACF;A0C97OA;EAEU,iDAAA;A1Cg8OV;A0Cx7OA;EACE;IACE,yBAAA;E1Cm8OF;E0Cl8OA;IACE,yBAAA;E1Co8OF;AACF;A0Cn8OA;EAEU,qDAAA;A1Cq8OV;A0C37OA;EACE;IAEU,uBAAA;E1Cw8OV;E0Cv8OA;IAEU,yBAAA;E1Cy8OV;AACF;A2C59PA;EACI,kBAAA;A3C89PJ;;A2C39PA;EACI,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;A3C89PJ;;A2C39PA;EACI,kBAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;EACA,gCAAA;EACA,kBAAA;EACA,YAAA;A3C89PJ;;A2C39PA;EACI,kBAAA;EACA,UAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,uBAAA;A3C89PJ;;A2C39PA;EACI,WAAA;EACA,YAAA;A3C89PJ;;A2C39PA;EACI,SAAA;A3C89PJ;;A2C39PA;EACI,SAAA;A3C89PJ;;A2C39PA;EACI,YAAA;EACA,aAAA;EACA,YAAA;A3C89PJ;;A2C39PA;EACI,kBAAA;EACA,OAAA;EACA,MAAA;EACA,QAAA;EACA,SAAA;EACA,oEAAA;A3C89PJ;;A2C39PA;EACI,iBAAA;EACA,eAAA;EACA,kBAAA;A3C89PJ;;A2C39PA;EACI,kBAAA;A3C89PJ;;A2C39PA;EACI,SAAA;EACA,QAAA;A3C89PJ;;A2C39PA;EACI,MAAA;EACA,QAAA;A3C89PJ;;A2C39PA;EACI,iBAAA;EACA,YAAA;EACA,kBAAA;A3C89PJ;;A2C39PA;EACI,WAAA;EACA,qBAAA;EACA,wBAAA;A3C89PJ;;A2C39PA;EACI,WAAA;A3C89PJ;;A2C39PA;EACI,qBAAA;EACA,YAAA;A3C89PJ;;A2C39PA;EACI,WAAA;A3C89PJ;;A2C39PA;EACI,YAAA;A3C89PJ;;A2C39PA;EACI,YAAA;EACA,WAAA;EACA,qBAAA;EACA,sBAAA;A3C89PJ;;A2C39PA;EACI,eAAA;A3C89PJ;;A2C39PA;EACI,kBAAA;A3C89PJ;;A2C39PA;EACI,qBAAA;EACA,sBAAA;EACA,iBAAA;EACA,iBAAA;A3C89PJ;;A4CnmQA;;;;EAAA;AAMA;EACI,2BAAA;EACA,gCAAA;EACA,oCAAA;EACA,kBAAA;A5CqmQJ;;A4ClmQA;;;;;;EAMI,uBAAA;A5CqmQJ;;A4ClmQA;EACI,yB3CTyB;AD8mQ7B;;A4CnmQA;;EAEI,mCAAA;A5CsmQJ;;A4CnmQA;EACI,kBAAA;EACA,WAAA;A5CsmQJ;;A4CnmQA;EACI,6BAAA;A5CsmQJ;;A4CnmQA;;EAEI,gBAAA;A5CsmQJ;;A4CnmQA;EACI,6BAAA;A5CsmQJ;;A4CnmQA;EACI,YAAA;EACA,cAAA;A5CsmQJ;;A4CnmQA;EACI,WAAA;A5CsmQJ;;A4CnmQA;EACI,SAAA;EACA,UAAA;EACA,SAAA;A5CsmQJ;;A4CnmQA;EACI,iBAAA;A5CsmQJ;;A4CnmQA;EACI,cAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;A5CsmQJ;;A4CnmQA;EACI,eAAA;EACA,4BAAA;EACA,mBAAA;A5CsmQJ;;A4CnmQA;EACI,yDAAA;EACA,8BAAA;A5CsmQJ;;A4CnmQA;EACI,yDAAA;EACA,8BAAA;A5CsmQJ;;A4CnmQA;EACI,0DAAA;EACA,8BAAA;A5CsmQJ;;A4ClmQA;EACI,WAAA;A5CqmQJ;;A4ClmQA;EACI,gBAAA;A5CqmQJ;;A4ClmQA;EACI,iBAAA;A5CqmQJ;;A4ClmQA,gCAAA;AACA;EACI,2CAAA;A5CqmQJ;;A4ClmQA;EACI,kBAAA;A5CqmQJ;;A4ClmQA;EACI,cAAA;A5CqmQJ;;A4ClmQA;;EAEI,yBAAA;EACA,eAAA;A5CqmQJ;;A4ClmQA;EACI,kBAAA;EACA,oCAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,sBAAA;A5CqmQJ;;A4CnmQA;EACI,gB3CyEyB;E2CxEzB,mB3CiE2B;ADqiQ/B;;A4CpmQA;;EAEI,gBAAA;EACA,mBAAA;A5CumQJ;;A4CpmQA;EACI,SAAA;A5CumQJ;;A4CpmQA;EACI,iBAAA;EACA,wBAAA;A5CumQJ;;A4CpmQA;EACI,iBAAA;EACA,iBAAA;A5CumQJ;;A4CpmQA;EACI,kBAAA;EACA,qBAAA;EACA,sBAAA;A5CumQJ;;A4CpmQA;EACI,qBAAA;A5CumQJ;;A4CpmQA;EACI,iBAAA;A5CumQJ;;A4CpmQA;EACI,iBAAA;A5CumQJ;;A4CpmQA;EACI,gBAAA;A5CumQJ;;A4CpmQA;EACI,aAAA;EACA,mB3CK2B;ADkmQ/B;;A4CrmQA;EACI,cAAA;EACA,kBAAA;EACA,6BAAA;EACA,WAAA;EACA,gBAAA;EACA,mBAAA;EACA,wBAAA;A5CwmQJ;;A4CtmQA;EACI,mBAAA;A5CymQJ;;A4CtmQA;;;EAGI,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,iBAAA;A5CymQJ;;A4CtmQA;EACI,oBAAA;EACA,eAAA;A5CymQJ;;A4CtmQA;EACI,aAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,sBAAA;EACA,kBAAA;A5CymQJ;;A4CtmQA;EACI,iBAAA;EACA,qBAAA;EACA,cAAA;EACA,2BAAA;A5CymQJ;;A4CtmQA,wBAAA;AACA;EACI,sBAAA;A5CymQJ;;A4CtmQA;EACI,sBAAA;EACA,sBAAA;A5CymQJ;;A4CtmQA;EACI,qBAAA;EACA,4BAAA;A5CymQJ;;A4CtmQA;EACI,eAAA;A5CymQJ;;A4CtmQA;EACI,gBAAA;A5CymQJ;;A4CtmQA;EACI,2BAAA;EACA,8BAAA;A5CymQJ;;A4CtmQA;EACI,4BAAA;EACA,+BAAA;A5CymQJ;;A4CtmQA,wBAAA;AACA;EACI,UAAA;EACA,SAAA;A5CymQJ;;A4CtmQA;EACI,QAAA;EACA,UAAA;A5CymQJ;;A4CtmQA,8BAAA;AACA;EACI,WAAA;EACA,aAAA;A5CymQJ;;A4CtmQA;EACI,MAAA;EACA,OAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;EACA,gBAAA;A5CymQJ;;A4CpmQI;EACI,cAAA;A5CumQR;A4CrmQQ;EACI,cAAA;EACA,WAAA;EACA,WAAA;A5CumQZ;A4CnmQY;EACI,mB3CnHe;ADwtQ/B;A4CnmQY;EACI,iBAAA;A5CqmQhB;A4ClmQQ;;EAEI,gBAAA;EACA,mBAAA;A5ComQZ;A4C/lQQ;EAGI,YAAA;A5C+lQZ;;A6Cj6QA;EACE,WAAA;EACA,0BAAA;EACA,6BAAA;EACA,0BAAA;EACA,oCAAA;A7Co6QF;;A6Cl6QA;;EAIE,uBAAA;A7Cq6QF;;A6Cn6QA;;EAEE,kBAAA;A7Cs6QF;;A6Cp6QA;;EAEE,mBAAA;A7Cu6QF;;A6Cp6QA;EACE,mBAAA;EACA,gBAAA;EACA,mBAAA;A7Cu6QF;;A6Cr6QA;EACE,WAAA;EACA,qBAAA;A7Cw6QF;;A6Ct6QA;EACE,iBAAA;A7Cy6QF;;A6Cv6QA;EACE,mBAAA;EACA,mBAAA;EACA,gBAAA;A7C06QF;;A6Cx6QA;EACE,kBAAA;EACA,qBAAA;EACA,WAAA;A7C26QF;;A6Cz6QA;EACE,gBAAA;EACA,mBAAA;A7C46QF;;A6C16QA;EACE,SAAA;EACA,mBAAA;EACA,iBAAA;A7C66QF;;A6C36QA;EACE,aAAA;EACA,mBAAA;A7C86QF;;A6C56QA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,YAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;A7C+6QF;;A6C56QA;;;;EAIE,mBAAA;A7C+6QF;;A6C76QA;;EAEE,aAAA;A7Cg7QF;;A6C96QA;;;;;EAKE,eAAA;EACA,kBAAA;A7Ci7QF;;A6C/6QA;;;;;EAKE,kBAAA;EACA,WAAA;EACA,UAAA;EACA,cAAA;EACA,mCAAA;EACA,YAAA;A7Ck7QF;;A6Ch7QA;EACE,YAAA;EACA,gBAAA;EACA,SAAA;A7Cm7QF;;A6Cj7QA;EACE,gBAAA;EACA,uBAAA;A7Co7QF;;A6Cl7QA;EACE,gBAAA;EACA,2BAAA;A7Cq7QF;;A6Cn7QA;;EAEE,WAAA;A7Cs7QF;;A6Cn7QA;EACE,2BAAA;A7Cs7QF;;A6Cn7QA;EACE,gBAAA;EACA,wBAAA;EACA,2BAAA;A7Cs7QF;;A6Cp7QA;;;EAGE,aAAA;A7Cu7QF;;A6Cr7QA;;EAEE,gBAAA;A7Cw7QF;;A6Cr7QA;EACE,wBAAA;EACA,gBAAA;A7Cw7QF;;A6Cr7QA;EACE;;;;IAIE,kBAAA;E7Cw7QF;AACF;A6Ct7QA;EACE,mBAAA;A7Cw7QF;;A6Ct7QA;;;EAGE,QAAA;EACA,UAAA;A7Cy7QF;;A6Ct7QA;;EAEE,oBAAA;A7Cy7QF;;A6Cv7QA;;;EAGE,qBAAA;A7C07QF;;A6Cx7QA;;EAEE,sBAAA;A7C27QF;;A6Cx7QA;EACE,sBAAA;A7C27QF;;A6Cx7QA;EACE,SAAA;A7C27QF;;A6Cz7QA;EACE,eAAA;A7C47QF;;A6C17QA;EACE,gBAAA;A7C67QF;;A6Cv7QI;EACI,YAAA;A7C07QR;A6Ch7QY;;;;;EACI,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,WAAA;EACA,0BAAA;EACA,YAAA;A7Cs7QhB;A6C56QgB;;;;;EACI,aAAA;A7Ck7QpB;A6C56QY;EACI,YAAA;EACA,gBAAA;A7C86QhB;A6Cz6QY;EACI,gBAAA;EACA,QAAA;A7C26QhB;A6Ct6QY;EACI,gBAAA;EACA,SAAA;A7Cw6QhB;A6Cn6QI;;;;;;EAMI,uBAAA;EACA,UAAA;A7Cq6QR;A6Cl6QI;EACI,YAAA;A7Co6QR;;A6C95QQ;;;;;EAKI,mBAAA;A7Ci6QZ;;A6Cz5QI;EACQ,UAAA;A7C45QZ;;A6Cv5QI;;;EAGI,0BAAA;A7C05QR;A6Cp5QQ;;;EACI,wBAAA;A7Cw5QZ;A6Cp5QI;;EAEI,kBAAA;EACA,6BAAA;EACA,eAAA;A7Cs5QR;A6Cj5QQ;;EACI,QAAA;EACA,gBAAA;EACA,SAAA;EACA,YAAA;EACA,WAAA;EACA,cAAA;EACA,kBAAA;EACA,cAAA;EACA,uBAAA;EACA,mBAAA;EACA,wBAAA;EACA,uBAAA;EACA,kBAAA;EACA,8CAAA;EACA,iBAAA;EACA,YAAA;EACA,sBAAA;A7Co5QZ;A6C94QQ;;EACI,YAAA;EACA,cAAA;A7Ci5QZ;A6C54QQ;EACI,aAAA;A7C84QZ;;A6Cr4QQ;;EACI,kBAAA;A7Cy4QZ;A6Cn4QQ;;EACI,QAAA;EACA,SAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;A7Cs4QZ;;A6Ch4QI;;EAEI,kBAAA;EACA,eAAA;A7Cm4QR;A6C93QQ;;EACI,QAAA;EACA,SAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,YAAA;EACA,uBAAA;EACA,mBAAA;EACA,wBAAA;EACA,uBAAA;EACA,kBAAA;EACA,8CAAA;EACA,iBAAA;EACA,YAAA;EACA,yBAAA;A7Ci4QZ;A6C33QQ;;EACI,YAAA;EACA,yBAAA;A7C83QZ;;A6Cx3QI;EACI,kBAAA;A7C23QR;A6Cv3QQ;EACI,kCAAA;A7Cy3QZ;A6Cr3QI;EACI,qBAAA;EACA,qBAAA;EACA,SAAA;EACA,UAAA;A7Cu3QR;A6Cp3QI;EACI,gCAAA;EACA,gBAAA;A7Cs3QR;A6Cl3QQ;EACI,cAAA;A7Co3QZ;A6C/2QQ;EACI,mBAAA;A7Ci3QZ;A6C72QI;EACI,qBAAA;EACA,eAAA;EACA,iBAAA;A7C+2QR;;A6C32QA;EACI,eAAA;EACA,sBAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;A7C82QJ;A6C52QI;EACI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,SAAA;EACA,QAAA;EACA,UAAA;EACA,WAAA;EACA,cAAA;EACA,YAAA;EACA,YAAA;EACA,cAAA;EACA,yBAAA;EACA,uBAAA;EACA,oBAAA;EACA,0CAAA;A7C82QR;A6C32QI;EACI,kBAAA;EACA,YAAA;A7C62QR;A6C12QI;EACI,kBAAA;EACA,QAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,WAAA;A7C42QR;A6Cx2QQ;EACI,yBAAA;A7C02QZ;A6Ct2QI;EACI,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,YAAA;EACA,8BAAA;A7Cw2QR;;A6C71QgB;EACI,mBAAA;A7Cg2QpB;;A6Cz1QA;EACI;IACI,UAAA;E7C41QN;E6Ct1Qc;IAEI,aAAA;E7Cu1QlB;AACF;A8C72RA;;;;EAAA;AAMA;EACC,cAAA;EACA,gBAAA;A9C82RD;;A8C32RA;EACC,iBAAA;A9C82RD;;A8C32RA,WAAA,sCAAA;EACC,cAAA;A9C82RD;;A8C12RA;mGAAA;AAGA;;;;;;;EAOC,kBAAA;A9C42RD;;A8Cz2RA;EACC,sBAAA;A9C42RD;;A8Cz2RA;;EAEC,gBAAA;A9C42RD;;A8Cz2RA;EACC,WAAA;A9C42RD;;A8Cz2RA;EACC,mB7CkE4B;AD0yR7B;;A8Cz2RA,gBAAA,iCAAA;EACC,mBAAA;EACA,YAAA;EACA,yBAAA,EAAA,WAAA;A9C42RD;;A8Cz2RA,cAAA,uCAAA;EACC,8BAAA;EACA,YAAA;EACA,yBAAA,EAAA,WAAA;A9C42RD;;A8Cz2RA,kBAAA,8CAAA;EACC,sCAAA;EACA,mBAAA;A9C42RD;;A8Cx2RA;mGAAA;AAGA;EACC,qBAAA;EACA,UAAA;EACA,WAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,8CAAA;EAEA,uCAAA;EACA,2BAAA;EACA,yBAAA;EAIA,iBAAA;A9Cy2RD;;A8Ct2RA;;;;;;CAAA;AAQA;EACC,kBAAA;EACA,cAAA,EAAA,4DAAA;A9Cw2RD;;A8Cr2RA;EACC,YAAA;EACA,iBAAA;EACA,eAAA;EACA,QAAA;EACA,QAAA;A9Cw2RD;;A8Cr2RA;EACC,YAAA;EACA,iBAAA;EACA,eAAA;EACA,QAAA;EACA,SAAA;A9Cw2RD;;A8Cr2RA;EACC,YAAA;EACA,eAAA;EACA,QAAA;A9Cw2RD;;A8Cr2RA;EACC,YAAA;EACA,eAAA;EACA,QAAA;A9Cw2RD;;A8Cr2RA;EACC,YAAA;EACA,eAAA;EACA,OAAA;EACA,SAAA;A9Cw2RD;;A8Cr2RA;EACC,YAAA;EACA,eAAA;EACA,OAAA;EACA,QAAA;A9Cw2RD;;A8Cr2RA;EACC,YAAA;EACA,eAAA;EACA,OAAA;A9Cw2RD;;A8Cr2RA;EACC,YAAA;EACA,eAAA;EACA,OAAA;A9Cw2RD;;A8Cp2RA;mGAAA;AAGA;EACC,iB7CvD4B;E6CwDzB,6B7C9CyB;E6C+CzB,gB7CgDyB;EejN3B,Y8BmKmB;E9BhKnB,yBAAA;E8BiKE,iBAAA;EAEA,qB7CpJyB;E6CqJzB,c7CrJyB;AD0/R7B;A8Cl2RI;E9B1KF,U8B4KuB;E9BzKvB,0BAAA;E8B0KM,qBAAA;A9Co2RR;A8Cl2RI;EpCtKM,gBoCyKD;EACA,qBAAA;A9Cm2RT;;A8C91RA,yCAAA;AACA;EAA+B,SAAA;EAAW,UAAA;A9Cm2R1C;;A8Cj2RA,oBAAA,cAAA;EACC,iBAAA;A9Co2RD;;A8Cj2RA,mCAAA,cAAA;EACC,2BAAA;EACA,8BAAA;A9Co2RD;;A8Cj2RA,oCAAA,cAAA;EACC,4BAAA;EACA,+BAAA;A9Co2RD;;A8Cj2RA,qBAAA;AAEA,sBAAA,cAAA;EACC,kBAAA;EACA,YAAA,EAAA,kDAAA;EACA,eAAA;EACA,sBAAA;A9Cm2RD;;A8Ch2RA;;;CAAA;AAKA;;;EAGC,cAAA;EACA,yBAAA;A9Ck2RD;;A8C/1RA;;;EAGI,yB7C1MyB;E6C2MzB,qB7C3MyB;E6C4MzB,eAAA;E9BnOF,a8BoOgB;E9BjOhB,yBAAA;E8BkOD,mBAAA;A9Cm2RD;;A8Ch2RA;EACC,yB7C3H4B;AD89R7B;;A8Ch2RA;;;;;;EAMC,yB7ChO4B;E6CiOzB,cAAA;A9Cm2RJ;;A8C91RA;mGAAA;AAGA;EACC,qBAAA;A9Cg2RD;;A8C71RA;;;CAAA;AAKA,2BAAA,yDAAA;EACC,WAAA;EACA,iBAAA;A9C+1RD;;A8C51RA,sCAAA,SAAA;EACC,cAAA;A9C+1RD;;A8C31RA;mGAAA;AAGA;EACC,kBAAA;EpCzQS,4CoC0QT;A9C81RD;;A8C31RA,yBAAA,kDAAA;EACC,gBAAA;A9C81RD;;A8C31RA;EACC,aAAA;A9C81RD;;A8C31RA;EACC,eAAA;A9C81RD;;A8C31RA;;EAEC,WAAA;A9C81RD;;A8C31RA;;EAEC,YAAA;A9C81RD;;A8C31RA,aAAA;AAEA;EACC,iBAAA;EACA,mBAAA;A9C61RD;;A8C11RA;EACC,gBAAA;EACA,eAAA;A9C61RD;;A8C11RA,gBAAA;AAEA;EACC,aAAA,EAAA,oDAAA;A9C41RD;;A8Cx1RA;mGAAA;AAGA;EACC,mBAAA;EACA,iBAAA;A9C01RD;;A8Cv1RA;EACC,SAAA;EACA,SAAA;EACA,gBAAA,EAAA,yDAAA;EACA,mBAAA;A9C01RD;;A8Cv1RA;EACC,WAAA;A9C01RD;;A8Cv1RA;;;;EAIC,gEAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;A9C01RD;;A8Cv1RA;EACC,SAAA,EAAA,6BAAA;A9C01RD;;A8Cv1RA;EACC,YAAA,EAAA,6BAAA;A9C01RD;;A8Ct1RA;mGAAA;AAGA;EACC,WAAA;EACA,mBAAA;EACA,yBAAA;EACA,iBAAA;EACA,cAAA,EAAA,4BAAA;A9Cw1RD;;A8Cr1RA;EACC,iBAAA;EACG,wBAAA;EACA,mB7CzK2B;E6C0K3B,yBAAA;EACA,c7C3VyB;E6C4VzB,gB7CtKyB;E6CuKzB,mBAAA;A9Cw1RJ;;A8Cr1RA;EACC,mBAAA;EACA,iBAAA;EACA,UAAA;EACA,mBAAA;A9Cw1RD;;A8Cr1RA;EACC,oBAAA,EAAA,iCAAA;A9Cw1RD;;A8Cr1RA;EACI,SAAA;A9Cw1RJ;;A8Cr1RA;EACI,gB7C/N2B;ADujS/B;;A8Ct1RA;mGAAA;AAGA,cAAA,mFAAA;EACC,+FAAA;EACA,mBAAA;EACA,eAAA;A9Cw1RD;;A8Cr1RA;EACC;4CAAA;EAEA,iCAAA;EACA,kCAAA;EAEA,8BAAA;EACA,mCAAA;A9Cu1RD;;A8Cp1RA;EACC,gCAAA,EAAA,+BAAA;A9Cu1RD;;A8Cn1RA;mGAAA;AAGA;EACC,kBAAA;A9Cq1RD;;A8Cl1RA;EACC,UAAA;A9Cq1RD;;A8Cl1RA,mDAAA;AAEA;;EAEC,SAAA,EAAA,sCAAA;A9Co1RD;;A8Cj1RA;;EAEC,YAAA,EAAA,sCAAA;A9Co1RD;;A8Cj1RA;;EAEC,yBAAA;A9Co1RD;;A8Cj1RA;EACC,UAAA;A9Co1RD;;A8Ch1RA;EACC,UAAA;A9Cm1RD;;A8Ch1RA;;;CAAA;AAKA;EACC,kBAAA;EACA,UAAA;EACA,mBAAA,EAAA,uCAAA;A9Ck1RD;;A8C/0RA;EACC,UAAA;A9Ck1RD;;A8C/0RA;;EAEC,wCAAA;EACA,gBAAA,EAAA,sCAAA;EACA,yBAAA;EAEA,4DAAA;EACA,gBAAA;A9Ci1RD;;A8C90RA;;EAEC,2CAAA;EACA,aAAA;A9Ci1RD;;A8C70RA;mGAAA;AAGA,eAAA,mEAAA;EACC,kBAAA;EACA,kBAAA;A9C+0RD;;A8C50RA,mBAAA,yCAAA;EACC,kBAAA,EAAA,2BAAA;EACA,WAAA,EAAA,gFAAA;EACA,gBAAA,EAAA,6EAAA;A9C+0RD;;A8C30RA;mGAAA;AAGA;EACC,kBAAA,EAAA,kDAAA;EACA,cAAA,EAAA,2BAAA;EACA,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,yB7Cvf4B,E6CufG,6BAAA;EAC/B,mBAAA,EAAA,sCAAA;A9C60RD;A8C30RI;EACI,yB7C1fqB;ADu0S7B;A8C30RI;EACI,yB7C5fqB;ADy0S7B;A8C30RI;EACI,wC7C9fqB;AD20S7B;A8C30RI;EACI,uC7ChgBqB;AD60S7B;;A8Cz0RA,gEAAA;AACA;;;EAGC,c7CngB4B,E6CmgBP,uBAAA;EACrB,qBAAA,EAAA,uBAAA;A9C40RD;;A8Cz0RA;;EAEC,eAAA,EAAA,qEAAA;A9C40RD;;A8Cz0RA;4BAC4B,yCAAA;EAC3B,mBAAA;A9C40RD;;A8Cz0RA,mBAAA,6CAAA;EACC,UAAA;EACA,gBAAA;EACA,aAAA;EACA,yBAAA,EAAA,WAAA;A9C40RD;;A8Cz0RA;EACC,kBAAA;EACA,UAAA;A9C40RD;;A8Cz0RA;EACC,kBAAA;EACA,UAAA;A9C40RD;;A8Cx0RA;mGAAA;AAGA,mGAAA;AAEA;;EAEC,cAAA;EACA,oBAAA;EACA,iBAAA,EAAA,oCAAA;EACA,yBAAA;EACA,4BAAA;A9Cy0RD;;A8Ct0RA;;EAEC,eAAA;EACA,qBAAA;EACA,kBAAA,EAAA,oCAAA;EACA,0BAAA;EACA,6BAAA;A9Cy0RD;;A8Ct0RA,YAAA;AAEA,0BAAA,kDAAA;EACC,SAAA;EACA,YAAA;EACA,UAAA;EACA,WAAA;EACA,UAAA;A9Cw0RD;;A8Cr0RA,kBAAA;AACA;;;;;;EAMC,WAAA,EAAA,2CAAA;EACA,gBAAA;A9Cw0RD;;A8Cr0RA,kBAAA;AACA;;;;;;EAMC,UAAA,EAAA,2CAAA;EACA,gBAAA;A9Cw0RD;;A8Cp0RA;;;;CAAA;AAMA;EACC,iBAAA,EAAA,qCAAA;EACA,gBAAA;A9Cs0RD;;A8Cl0RA,iCAAA,qCAAA;EACC,mBAAA;EACA,gBAAA;A9Cq0RD;;A8Cl0RA;EACC,iBAAA;A9Cq0RD;;A8Cl0RA,iCAAA,iCAAA;EACC,UAAA;EACA,WAAA;EACA,UAAA;A9Cq0RD;;A8Cj0RA;mGAAA;AAGA,8CAAA;AAEA;EACC,eAAA;EACA,iBAAA;EACA,eAAA;EACA,qBAAA;A9Ck0RD;;A8C/zRA;EACC,0BAAA;A9Ck0RD;;A8C/zRA,cAAA,4DAAA;EACC,aAAA;A9Ck0RD;;A8C/zRA,qDAAA;AAEA;EACC,UAAA,EAAA,iDAAA;A9Ci0RD;;A8C9zRA;EACC,UAAA;EACA,YAAA;A9Ci0RD;;A8C9zRA;EACC,aAAA;A9Ci0RD;;A8C9zRA;mGAAA;AAGA;EACC,kBAAA;EACA,kBAAA;A9Cg0RD;;A8C7zRA;EACC,WAAA;EACA,gBAAA;A9Cg0RD;;A8C7zRA;EACC,YAAA;A9Cg0RD;;A8C7zRA;EACC,qBAAA;A9Cg0RD;;A8C7zRA,qDAAA;AACA,0BAAA,uDAAA;EACC,WAAA;EACA,mBAAA;A9Cg0RD;;A8C7zRA,0DAAA;AACA,qCAAA,uDAAA;EACC,cAAA;A9Cg0RD;;A8C7zRA,eAAA;AAEA;EACC,SAAA;A9C+zRD;;A8C5zRA,4CAAA;AAEA;EACC,kBAAA;A9C8zRD;;A8C3zRA;;EAEC,UAAA;A9C8zRD;;A8C3zRA;EACC,UAAA;A9C8zRD;;A8C3zRA;;EAEC,UAAA;A9C8zRD;;A8C3zRA;EACC,UAAA;A9C8zRD;;A8C1zRA;mGAAA;AAGA,iFAAA;AACA,iGAAA;AACA;;;EAKS,uBAAA;A9C4zRT;;A8CzzRA;mBACmB,6DAAA;EAClB,kBAAA;EACA,UAAA;A9C4zRD;;A8CzzRA;mGAAA;AAGA,sBAAA;AAEA;;EAEC,+DAAA;EACA,gBAAA,EAAA,gEAAA;EACA,mBAAA,EAAA,iEAAA;A9C0zRD;;A8CvzRA;EACC,eAAA,EAAA,gDAAA;A9C0zRD;;A8CvzRA,gGAAA;AAEA;EACC,gBAAA;A9CyzRD;;A8CtzRA;EACC,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;A9CyzRD;;A8CtzRA,gCAAA;AAEA;;EAEC,YAAA;A9CwzRD;;A8CpzRA;EACC,kBAAA;A9CuzRD;;A8CpzRA;EACC,yEAAA;EACA,qBAAA;EACA,iBAAA;A9CuzRD;;A8CpzRA;EACC,YAAA;A9CuzRD;;A8CpzRA;EACC,gBAAA;A9CuzRD;;A8CpzRA;EACC,YAAA;EACA,yBAAA,EAAA,WAAA;EACA;;qDAAA;A9CyzRD;;A8CpzRA;mGAAA;AAGA;EACC,kBAAA;EACA,UAAA,EAAA,uDAAA;A9CszRD;;A8CnzRA;EACC,eAAA,EAAA,qDAAA;A9CszRD;;A8CnzRA;EACC,gBAAA,EAAA,gEAAA;EACA,mBAAA,EAAA,6DAAA;A9CszRD;;A8ClzRA;mGAAA;AAGA,eAAA,wCAAA;EACC,sBAAA;EACA,cAAA;EACA,mBAAA;A9CozRD;;A8CjzRA;EACC,iBAAA;A9CozRD;;A8CjzRA;EACC,gBAAA;A9CozRD;;A8CjzRA;EACC,mBAAA,EAAA,uCAAA;A9CozRD;;A8ChzRA;mGAAA;AAGA;gBACgB,6DAAA;EACf,kBAAA;EACA,UAAA;A9CkzRD;;A8C/yRA;EACC,gBAAA,EAAA,oEAAA;A9CkzRD;;A8C/yRA,sBAAA,oDAAA;EACC,4BAAA;A9CkzRD;;A8C/yRA;EACC,UAAA;A9CkzRD;;A8C/yRA;qBACqB,mEAAA;EACpB,kBAAA;EACA,UAAA;A9CkzRD;;A8C/yRA;;EAEC,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;A9CkzRD;;A8C/yRA;EACC,UAAA;A9CkzRD;;A8C/yRA;EACC,UAAA;A9CkzRD;;A8C/yRA;EACC,UAAA;A9CkzRD;;A8C/yRA;EACC,UAAA;A9CkzRD;;A8C9yRA;mGAAA;AAGA;EACC,aAAA;EACA,gBAAA,EAAA,gDAAA;A9CgzRD;;A8C7yRA;EACC,wBAAA;A9CgzRD;;A8C7yRA,6CAAA,mBAAA;EACC,gBAAA,EAAA,yBAAA;A9CgzRD;;A8C5yRA;mGAAA;AAGA,wCAAA,yDAAA;EACC,kBAAA,EAAA,kEAAA;A9C8yRD;;A8C3yRA;EACC,kBAAA;EACA,OAAA;EACA,QAAA;EACA,oCAAA;A9C8yRD;;A8C1yRA;mGAAA;AAGA;sCACsC,uDAAA;EACrC,kBAAA;A9C4yRD;;A8CzyRA,4CAAA,mDAAA;EACC,oBAAA;A9C4yRD;;A8CzyRA,4CAAA,yCAAA;EACC,oBAAA;A9C4yRD;;A8CzyRA;;EAEC,kBAAA;EACA,UAAA,EAAA,0BAAA;A9C4yRD;;A8CzyRA;EACC,6CAAA;EACA,OAAA;EACA,QAAA;A9C4yRD;;A8CxyRA;mGAAA;AAGA,2BAAA,gDAAA;EACC,sDAAA;EACA,mBAAA;EACA,gBAAA;EAEA,+BAAA;EACA,yBAAA;EACA,0BAAA;A9CyyRD;;A8CtyRA;EACC,sDAAA;EACA,sBAAA;EACA,mBAAA;EAEA,kCAAA;EACA,4BAAA;EACA,6BAAA;A9CwyRD;;A8CpyRA;;;;CAAA;AAMA;EACC,gBAAA,EAAA,+CAAA;A9CsyRD;;A8CnyRA;;EAEC,cAAA;A9CsyRD;;A8CnyRA;EACC,iBAAA;EACA,mBAAA;A9CsyRD;;A8CnyRA,0DAAA;AAEA;EACC,iEAAA;EACA,mBAAA;A9CqyRD;;A8ClyRA;;EAEC,4CAAA;EACA,qBAAA;EACA,mBAAA;A9CqyRD;;A8ClyRA;EACC,aAAA,EAAA,wCAAA;A9CqyRD;;A8ClyRA;EACC,yBAAA,EAAA,4CAAA;A9CqyRD;;A8ClyRA;EACC,cAAA,EAAA,4CAAA;A9CqyRD;;A8ClyRA;EACC,iBAAA,EAAA,kDAAA;EACA,UAAA,EAAA,4BAAA;A9CqyRD;;A8ClyRA,YAAA;AAEA;EACC,OAAA;EACA,QAAA;EACA,SAAA;EACA,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,sBAAA;EACA,kBAAA;EACA,gBAAA;A9CoyRD;;A8CjyRA;EACC,YAAA;A9CoyRD;;A8ChyRI;EACI,qBAAA;A9CmyRR;A8CjyRI;EACI,iB7Cx6BuB;E6Cy6BvB,kB7Cz6BuB;E6C06BvB,mB7C16BuB;AD6sT/B;A8CjyRI;EACI,cAAA;A9CmyRR;A8CjyRI;EACI,eAAA;A9CmyRR;A8CjyRI;;EAEI,mB7Cp7BuB;ADutT/B;A8CjyRI;EACI,mBAAA;A9CmyRR;A8CjyRI;EACI,gBAAA;A9CmyRR;A8CjyRI;EACI,gBAAA;A9CmyRR;;A+CpwTE;EAxDA,wBV7Bc;EU8Bd,yBV9Bc;EU+Bd,iBV9Ba;EU+Bb,cV5BoB;ArC41TtB;;A+CvwTE;;EArEA,cAAA;EAKA,aAAA;A/Ci1TF;;A+C5wTE;EA3FA,qBA4F4B;EAxF5B,2BAwFsC;EArFpC,gBAAA;EAuFA,kBAAA;A/CsxTJ;;A+CnxTE;EAjGA,uBAkG4B;EA9F5B,2BA8FwC;EA3FtC,gBAAA;EA6FA,kBAAA;A/C6xTJ;;A+C1xTE;EAvGA,qBAwG4B;EApG5B,yBAoGsC;EA/FpC,iBAAA;EAiGA,gBAAA;A/CoyTJ;;A+CjyTE;EA7GA,qBA8G4B;EA1G5B,2BA0GsC;EAvGpC,gBAAA;EAyGA,kBAAA;A/C2yTJ;;A+CxyTE;EAnHA,qBAoH4B;EAhH5B,uBAgHsC;EAzGpC,kBAAA;EA2GA,kBAAA;A/CkzTJ;;A+C/yTE;EAzHA,uBA0H4B;EAtH5B,uBAsHwC;EA/GtC,kBAAA;EAiHA,kBAAA;A/CyzTJ;;A+CtzTE;EA/HA,qBAgI4B;EA5H5B,2BA4HsC;EAzHpC,gBAAA;EA2HA,kBAAA;A/Cg0TJ;;A+C7zTE;EArIA,uBAsI4B;EAlI5B,2BAkIwC;EA/HtC,gBAAA;EAiIA,kBAAA;A/Cu0TJ;;A+Cp0TE;EA3IA,mBA6I4B;EAzI5B,yBAyIoC;EApIlC,iBAAA;EAsIA,gBAAA;A/C60TJ;;A+C10TE;EAlJA,mBAmJ4B;EA/I5B,2BA+IoC;EA5IlC,gBAAA;EA8IA,gBAAA;A/Co1TJ;;A+Cj1TE;EAvHA,0BV7Bc;EU8Bd,iBV5Bc;EU+BZ,qBVhCgB;ArC0+TpB;;A+Cn1TE;EAlHA,iBV/Bc;EUgCd,qBV9Be;ArCu+TjB;;A+Cp1TE;EAjHA,UAAA;EACA,iBVvCc;ArCg/ThB;;A+Cr1TE;EA5GA,YAAA;EACA,iBV1CgB;ArC++TlB;;A+Ct1TE;EA3GA,UAAA;EACA,kBV5Ca;ArCi/Tf;;A+Cv1TE;EA1GA,UAAA;EACA,kBV9Ce;ArCm/TjB;;A+Cj8TE;EACE,eA2GY;A/Cy1ThB;A+Cj8TE;EACE,aAuGY;A/C41ThB;;A+Cx8TE;EACE,eA2GY;A/Cg2ThB;A+Cx8TE;EACE,aAuGY;A/Cm2ThB;;A+C/8TE;EACE,eA2GY;A/Cu2ThB;A+C/8TE;EACE,aAuGY;A/C02ThB;;A+Ct9TE;EACE,eA2GY;A/C82ThB;A+Ct9TE;EACE,aAuGY;A/Ci3ThB;;A+C79TE;EACE,eA2GY;A/Cq3ThB;A+C79TE;EACE,aAuGY;A/Cw3ThB;;A+Cp+TE;EACE,eA2GY;A/C43ThB;A+Cp+TE;EACE,aAuGY;A/C+3ThB;;A+C3+TE;EACE,eA2GY;A/Cm4ThB;A+C3+TE;EACE,aAuGY;A/Cs4ThB;;A+Cl/TE;EACE,eA2GY;A/C04ThB;A+Cl/TE;EACE,aAuGY;A/C64ThB;;A+Cz/TE;EACE,eA2GY;A/Ci5ThB;A+Cz/TE;EACE,aAuGY;A/Co5ThB;;A+ChgUE;EACE,eA2GY;A/Cw5ThB;A+ChgUE;EACE,aAuGY;A/C25ThB;;A+CvgUE;EACE,eA2GY;A/C+5ThB;A+CvgUE;EACE,aAuGY;A/Ck6ThB;;A+C9gUE;EACE,eA2GY;A/Cs6ThB;A+C9gUE;EACE,aAuGY;A/Cy6ThB;;A+CrhUE;EACE,eA2GY;A/C66ThB;A+CrhUE;EACE,aAuGY;A/Cg7ThB;;A+C5hUE;EACE,eA2GY;A/Co7ThB;A+C5hUE;EACE,aAuGY;A/Cu7ThB;;A+CniUE;EACE,eA2GY;A/C27ThB;A+CniUE;EACE,aAuGY;A/C87ThB;;A+Cj7TM;EA/NJ,cAAA;EACA,kBAAA;EACA,WAHyC;A/CupU3C;A+ClpUE;EACE,cAAA;EACA,WAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,oBAAA;A/CopUJ;A+CjpUE;EACE,WAAA;EACA,cAAA;EACA,WAAA;A/CmpUJ;A+ChpUE;EACE,cAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;A/CkpUJ;;A+C18TM;EA/NJ,cAAA;EACA,kBAAA;EACA,WAHyC;A/CgrU3C;A+C3qUE;EACE,cAAA;EACA,WAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,sBAAA;A/C6qUJ;A+C1qUE;EACE,WAAA;EACA,cAAA;EACA,WAAA;A/C4qUJ;A+CzqUE;EACE,cAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;A/C2qUJ;;A+Cn+TM;EA/NJ,cAAA;EACA,kBAAA;EACA,WAHyC;A/CysU3C;A+CpsUE;EACE,cAAA;EACA,WAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,8BAAA;A/CssUJ;A+CnsUE;EACE,WAAA;EACA,cAAA;EACA,WAAA;A/CqsUJ;A+ClsUE;EACE,cAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;A/CosUJ;;A+C5/TM;EA/NJ,cAAA;EACA,kBAAA;EACA,WAHyC;A/CkuU3C;A+C7tUE;EACE,cAAA;EACA,WAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,8BAAA;A/C+tUJ;A+C5tUE;EACE,WAAA;EACA,cAAA;EACA,WAAA;A/C8tUJ;A+C3tUE;EACE,cAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;A/C6tUJ;;A+CrhUM;EA/NJ,cAAA;EACA,kBAAA;EACA,WAHyC;A/C2vU3C;A+CtvUE;EACE,cAAA;EACA,WAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,mBAAA;A/CwvUJ;A+CrvUE;EACE,WAAA;EACA,cAAA;EACA,WAAA;A/CuvUJ;A+CpvUE;EACE,cAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;A/CsvUJ;;A+C9iUM;EA/NJ,cAAA;EACA,kBAAA;EACA,WAHyC;A/CoxU3C;A+C/wUE;EACE,cAAA;EACA,WAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,mBAAA;A/CixUJ;A+C9wUE;EACE,WAAA;EACA,cAAA;EACA,WAAA;A/CgxUJ;A+C7wUE;EACE,cAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;A/C+wUJ;;A+CvkUM;EA/NJ,cAAA;EACA,kBAAA;EACA,WAHyC;A/C6yU3C;A+CxyUE;EACE,cAAA;EACA,WAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,8BAAA;A/C0yUJ;A+CvyUE;EACE,WAAA;EACA,cAAA;EACA,WAAA;A/CyyUJ;A+CtyUE;EACE,cAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;A/CwyUJ;;A+ChmUM;EA/NJ,cAAA;EACA,kBAAA;EACA,WAHyC;A/Cs0U3C;A+Cj0UE;EACE,cAAA;EACA,WAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,qBAAA;A/Cm0UJ;A+Ch0UE;EACE,WAAA;EACA,cAAA;EACA,WAAA;A/Ck0UJ;A+C/zUE;EACE,cAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;A/Ci0UJ;;A+CznUM;EA/NJ,cAAA;EACA,kBAAA;EACA,WAHyC;A/C+1U3C;A+C11UE;EACE,cAAA;EACA,WAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,6BAAA;A/C41UJ;A+Cz1UE;EACE,WAAA;EACA,cAAA;EACA,WAAA;A/C21UJ;A+Cx1UE;EACE,cAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;A/C01UJ;;A+ClpUM;EA/NJ,cAAA;EACA,kBAAA;EACA,WAHyC;A/Cw3U3C;A+Cn3UE;EACE,cAAA;EACA,WAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,mBAAA;A/Cq3UJ;A+Cl3UE;EACE,WAAA;EACA,cAAA;EACA,WAAA;A/Co3UJ;A+Cj3UE;EACE,cAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;A/Cm3UJ;;A+C3qUM;EA/NJ,cAAA;EACA,kBAAA;EACA,WAHyC;A/Ci5U3C;A+C54UE;EACE,cAAA;EACA,WAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,sBAAA;A/C84UJ;A+C34UE;EACE,WAAA;EACA,cAAA;EACA,WAAA;A/C64UJ;A+C14UE;EACE,cAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;A/C44UJ;;A+CpsUM;EA/NJ,cAAA;EACA,kBAAA;EACA,WAHyC;A/C06U3C;A+Cr6UE;EACE,cAAA;EACA,WAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,8BAAA;A/Cu6UJ;A+Cp6UE;EACE,WAAA;EACA,cAAA;EACA,WAAA;A/Cs6UJ;A+Cn6UE;EACE,cAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;A/Cq6UJ;;A+C7tUM;EA/NJ,cAAA;EACA,kBAAA;EACA,WAHyC;A/Cm8U3C;A+C97UE;EACE,cAAA;EACA,WAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,mBAAA;A/Cg8UJ;A+C77UE;EACE,WAAA;EACA,cAAA;EACA,WAAA;A/C+7UJ;A+C57UE;EACE,cAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;A/C87UJ;;A+CtvUM;EA/NJ,cAAA;EACA,kBAAA;EACA,WAHyC;A/C49U3C;A+Cv9UE;EACE,cAAA;EACA,WAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,mBAAA;A/Cy9UJ;A+Ct9UE;EACE,WAAA;EACA,cAAA;EACA,WAAA;A/Cw9UJ;A+Cr9UE;EACE,cAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;A/Cu9UJ;;A+C/wUM;EA/NJ,cAAA;EACA,kBAAA;EACA,WAHyC;A/Cq/U3C;A+Ch/UE;EACE,cAAA;EACA,WAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,qBAAA;A/Ck/UJ;A+C/+UE;EACE,WAAA;EACA,cAAA;EACA,WAAA;A/Ci/UJ;A+C9+UE;EACE,cAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;A/Cg/UJ;;A+CxyUM;EA/NJ,cAAA;EACA,kBAAA;EACA,WAHyC;A/C8gV3C;A+CzgVE;EACE,cAAA;EACA,WAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,8BAAA;A/C2gVJ;A+CxgVE;EACE,WAAA;EACA,cAAA;EACA,WAAA;A/C0gVJ;A+CvgVE;EACE,cAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;A/CygVJ;;A+Cj0UM;EA/NJ,cAAA;EACA,kBAAA;EACA,WAHyC;A/CuiV3C;A+CliVE;EACE,cAAA;EACA,WAAA;EACA,WAAA;EACA,QAAA;EACA,SAAA;EACA,mBAAA;A/CoiVJ;A+CjiVE;EACE,WAAA;EACA,cAAA;EACA,WAAA;A/CmiVJ;A+ChiVE;EACE,cAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;A/CkiVJ;;A+Cl1UA;EACI,0BAAA;A/Cq1UJ;;A+Cn1UA;EACI,0BAAA;A/Cs1UJ;;A+Cp1UA;EACI,0BAAA;A/Cu1UJ;;A+Cr1UA;EACI,0BAAA;A/Cw1UJ;;A+Ct1UA;EACI,0BAAA;A/Cy1UJ;;AgD9kVA,8BAAA;AACA;EAEE,kBAAA;EACA,2BAAA;EACA,wBAAA;AhDilVF;;AgDhlVE;EACE;IACE,yBAAA;EhDmlVJ;AACF;AgDnlVE;EACE;IACE,yBAAA;EhDqlVJ;AACF;AgDrlVE;;EAEE,cAAA;EACA,6BAAA;AhDulVJ;;AgDtlVE;EACE,oBAAA;AhDylVJ;;AgDxlVI;EACE,sBAAA;EACA,YAAA;AhD2lVN;;AgD1lVM;EACE,sBAAA;AhD6lVR;;AgD5lVI;EACE,sBAAA;EACA,YAAA;AhD+lVN;;AgD9lVM;EACE,sBAAA;AhDimVR;;AgDhmVE;EACE,aAAA;EACA,kBAAA;EACA,mCAAA;EAGA,kBAAA;EACA,UAAA;EAIA,6DAAA;EACA,WAAA;EACA,mDAAA;EACA,WAAA;AhDmmVJ;;AgDlmVI;EACE,kBAAA;EACA,mCAAA;EACA,sBAAA;EAGA,kBAAA;EAIA,wCAAA;EACA,SAAA;EACA,8CAAA;EACA,WAAA;AhDqmVN;;AgDpmVE;EACE,aAAA;EACA,kBAAA;EACA,mCAAA;EAGA,kBAAA;EACA,UAAA;EAIA,6DAAA;EACA,UAAA;EACA,kDAAA;EACA,UAAA;AhDumVJ;;AgDtmVI;EACE,kBAAA;EACA,mCAAA;EACA,sBAAA;EAGA,kBAAA;EAIA,wCAAA;EACA,QAAA;EACA,6CAAA;EACA,UAAA;AhDymVN;;AgDxmVE;EACE,oBAAA;AhD2mVJ;;AgD1mVI;EACE,sBAAA;EACA,YAAA;AhD6mVN;;AgD5mVM;EACE,sBAAA;AhD+mVR;;AgD9mVI;EACE,sBAAA;EACA,YAAA;AhDinVN;;AgDhnVM;EACE,sBAAA;AhDmnVR;;AgDlnVE;;EAEE,YAAA;AhDqnVJ;;AgDpnVE;EACE,sBAAA;EACA,YAAA;AhDunVJ;;AgDtnVI;EACE,sBAAA;AhDynVN;;AgDxnVE;EACE,sBAAA;EACA,YAAA;AhD2nVJ;;AgD1nVI;EACE,sBAAA;AhD6nVN;;AiD3uVA;;;;;EAAA;AAOA;;EAEE,wBAAA;AjD6uVF;;AiD3uVA;EACE,eAAA;AjD8uVF;;AiD5uVA;EACE,WAAA;EACA,mBAAA;EACA,UAAA;EACA,SAAA;AjD+uVF;AiD7uVI;EACI,kBAAA;AjD+uVR;;AiD3uVA;EACE,6BAAA;EACA,SAAA;EACA,SAAA;EACA,yBAAA;EACA,uBAAA;EACA,uBAAA;EACA,qBAAA;EACA,qBAAA;EACA,YAAA;EACA,sCAAA;EACA,uCAAA;AjD8uVF;;AiD5uVA;EACE,MAAA;EACA,OAAA;EACA,yBAAA;EACA,sBAAA;EACA,UAAA;AjD+uVF;;AiD7uVA;;EAEE,qBAAA;AjDgvVF;;AiD9uVA;EACE,sBAAA;AjDivVF;;AiD/uVA;EACE,WAAA;AjDkvVF;;AiD/uVA;EACE,gBAAA;EACA,UAAA;EACA,YAAA;AjDkvVF;;AiDhvVA;EACE,WAAA;AjDmvVF;;AiDjvVA;EACI,WAAA;AjDovVJ;;AiDlvVA;EACE,aAAA;AjDqvVF;;AiDnvVA;EACE,gBAAA;AjDsvVF;;AiDpvVA;;EAEE,WAAA;EACA,qBAAA;EACA,cAAA;AjDuvVF;;AiDrvVA;;;EAGE,YAAA;AjDwvVF;;AiDtvVA;;;EAGE,gBAAA;AjDyvVF;;AiDvvVA;;EAEE,UAAA;AjD0vVF;;AiDxvVA;;EAEE,YAAA;EACA,kBAAA;EACA,oBAAA;EACA,sBAAA;AjD2vVF;;AiDzvVA;EACE,WAAA;AjD4vVF;;AiD1vVA;;EAEE,mBAAA;AjD6vVF;;AiD3vVA;;EAEE,wBAAA;AjD8vVF;;AiD5vVA;EACE,kBAAA;EACA,oBAAA;EACA,qBAAA;AjD+vVF;;AiD7vVA;EACE,aAAA;AjDgwVF;;AiD9vVA;EACE,qBAAA;EACA,gBAAA;EACA,uBAAA;EACA,WAAA;EACA,gBAAA;AjDiwVF;;AiD/vVA;EACE,aAAA;AjDkwVF;;AiDhwVA;EACE,WAAA;AjDmwVF;;AiDjwVA;EACE,eAAA;EAGQ,sBAAA;EACT,4BAAA;AjDowVD;;AiDlwVA;EACE,gBAAA;EACA,WAAA;EACA,SAAA;EACA,UAAA;EACA,SAAA;EACA,cAAA;EACA,4BAAA;EACA,kBAAA;EACD,wBAAA;EAES,gBAAA;AjDqwVV;;AiDnwVA;EACE,kBAAA;AjDswVF;;AiDpwVA;EACE,WAAA;AjDuwVF;;AiDrwVA;EACE,mBAAA;AjDwwVF;;AiDtwVA;EACE,eAAA;EACA,yBAAA;EAGQ,iBAAA;AjDywVV;;AiDvwVA;EACE,kBAAA;EACA,oBAAA;AjD0wVF;;AiDxwVA;EACE,aAAA;AjD2wVF;;AiDzwVA;EACE,qBAAA;AjD4wVF;;AiD1wVA;EACE,mBAAA;AjD6wVF;;AiD3wVA;EACE,kBAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,yBAAA;EAEQ,+CAAA;EACR,oBAAA;EACA,YAAA;EAGQ,sBAAA;AjD8wVV;;AiD5wVA;EACE,YAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;AjD+wVF;;AiD7wVA;EACE,gBAAA;AjDgxVF;;AiD9wVA;EACE,gBAAA;EACA,SAAA;EACA,gBAAA;AjDixVF;;AiD/wVA;EACE,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,eAAA;EACA,YAAA;AjDkxVF;;AiDhxVA;EACE,kBAAA;AjDmxVF;;AiDjxVA;EACE,aAAA;AjDoxVF;;AiDlxVA;EACE,WAAA;EACA,kCAAA;EACA,mCAAA;EACA,iDAAA;EACA,kBAAA;EACA,YAAA;EACA,SAAA;EACA,aAAA;AjDqxVF;;AiDnxVA;EACE,WAAA;EACA,kCAAA;EACA,mCAAA;EACA,8BAAA;EACA,kBAAA;EACA,YAAA;EACA,UAAA;EACA,aAAA;AjDsxVF;;AiDpxVA;EACE,YAAA;EACA,SAAA;EACA,8CAAA;EACA,gBAAA;AjDuxVF;;AiDrxVA;EACE,YAAA;EACA,SAAA;EACA,2BAAA;EACA,gBAAA;AjDwxVF;;AiDtxVA;EACE,WAAA;EACA,UAAA;AjDyxVF;;AiDvxVA;EACE,WAAA;EACA,UAAA;AjD0xVF;;AiDxxVA;;EAEE,cAAA;AjD2xVF;;AiDzxVA;;;EAGE,gBAAA;AjD4xVF;;AiD1xVA;EACE,WAAA;EAGQ,sBAAA;AjD6xVV;;AiD3xVA;EACE,UAAA;AjD8xVF;;AiD5xVA;EACE,WAAA;EACA,WAAA;EAGQ,sBAAA;AjD+xVV;;AiD7xVA;EACE,WAAA;AjDgyVF;;AiD9xVA;EACE,kBAAA;AjDiyVF;;AiD/xVA;EACE,gBAAA;EACA,WAAA;EACA,WAAA;AjDkyVF;;AiD/xVA;EACI,eAAA;AjDkyVJ;AiD/xVQ;EACI,cAAA;EACA,iBAAA;EACA,WAAA;EACA,gBAAA;EACA,uBAAA;EACA,WAAA;EACA,mBAAA;EACA,aAAA;EACA,eAAA;AjDiyVZ;AiD3xVY;EAEI,6BAAA;AjD4xVhB;AiDvxVY;EACI,oCAAA;EACA,yBAAA;EACA,UAAA;EACA,qBAAA;AjDyxVhB;AiDpxVI;EACI,4BAAA;EACA,aAAA;EACA,kBAAA;AjDsxVR;AiDpxVQ;EACI,cAAA;EACA,mBAAA;AjDsxVZ;AiDlxVI;EACI,mBAAA;AjDoxVR;;AiD/wVA;EACI,yBhD3VoB;EgD4VpB,qBhD5VoB;AD8mWxB;;AkDtnWA;;;;EAAA;AAkBA;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;EACA,gBAAA;EACA,sBAAA;EACA,SAAA;AlD4mWF;;AkDxmWA;EACI,gBAAA;AlD2mWJ;AkDxmWI;EACI,YAAA;EACA,WAAA;AlD0mWR;AkDvmWY;EADJ;IAEQ,WAAA;ElD0mWd;AACF;AkDxmWY;EALJ;IAMQ,WAAA;ElD2mWd;AACF;AkDzmWY;EATJ;IAUQ,WAAA;ElD4mWd;AACF;AkDvmWY;EACI,4CAAA;EACA,wCAAA;EACA,yCAAA;EACA,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,UAAA;EACA,UAAA;AlDymWhB;AkDtmWY;EACI,iCAAA;EACA,wCAAA;EACA,yCAAA;EACA,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,UAAA;EACA,UAAA;AlDwmWhB;AkDpmWQ;EACI,gBAAA;EACA,oBAAA;AlDsmWZ;AkDpmWY;EACI,gBAAA;EACA,kBAAA;AlDsmWhB;AkDnmWY;EACI,yCAAA;EACA,wCAAA;EACA,yCAAA;EACA,mBAAA;EACA,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,UAAA;EACA,aAAA;EACA,SAAA;AlDqmWhB;AkDlmWY;EACI,8BAAA;EACA,wCAAA;EACA,yCAAA;EACA,mBAAA;EACA,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,UAAA;EACA,aAAA;EACA,SAAA;AlDomWhB;AkD7lWY;EACI,UAAA;EACA,UAAA;AlD+lWhB;AkD5lWY;EACI,UAAA;EACA,UAAA;AlD8lWhB;AkD1lWQ;EACI,8BAAA;EACA,qBAAA;EACA,qBAAA;EACA,0BAAA;AlD4lWZ;AkDxlWI;EACI,SAAA;AlD0lWR;AkDvlWI;EACI,cAAA;EACA,eAAA;AlDylWR;AkDtlWI;EACI,gBAAA;AlDwlWR;AkDrlWI;EACI,WAAA;EACA,YAAA;EACA,gBjD4DqB;EiD3DrB,mBjDoDuB;EiDnDvB,WAAA;EACA,kBAAA;AlDulWR;AkDplWI;EACI,YAAA;AlDslWR;AkDnlWI;EAEI,0BAAA;AlDolWR;AkDjlWI;EAEI,4BAAA;AlDklWR;AkD/kWI;EAEI,0BAAA;AlDglWR;AkD7kWI;EAEI,4BAAA;AlD8kWR;AkD3kWI;EAEI,qBAAA;AlD4kWR;AkDzkWI;EAEI,uBAAA;AlD0kWR;AkDvkWI;EAEI,uBAAA;AlDwkWR;AkDrkWI;EAEI,2BAAA;AlDskWR;AkDnkWI;EAEI,gCAAA;AlDokWR;AkDjkWI;EACI,kBAAA;EACA,kBjDzBwB;EiD0BxB,eAAA;AlDmkWR;AkDjkWQ;EAEI,uCAAA;AlDkkWZ;AkD/jWQ;EACI,UAAA;EACA,SAAA;EACA,YAAA;EACA,WAAA;EACA,oBAAA;AlDikWZ;AkD/jWY;EACI,gBAAA;EACA,aAAA;EACA,WAAA;EACA,kBjD5CgB;EiD6ChB,0BAAA;AlDikWhB;AkD9jWY;;EAEI,cjDjOQ;ADiyWxB;AkD3jWI;EACI,WAAA;EACA,SAAA;AlD6jWR;AkD1jWQ;EAGI,kBAAA;AlD0jWZ;AkDrjWQ;EAGI,YAAA;EACA,iBAAA;EACA,WAAA;AlDqjWZ;AkDnjWY;EACI,YAAA;AlDqjWhB;AkDljWY;EAEI,gBAAA;EACA,cjD9Oa;EiD+Ob,mBAAA;AlDmjWhB;AkDhjWY;EAEI,kBjDxFgB;EiDyFhB,YAAA;EACA,WAAA;EACA,iBAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;AlDijWhB;AkD7iWY;EAEI,yBAAA;AlD8iWhB;AkD3iWY;EAEI,qBAAA;AlD4iWhB;AkDziWY;EACI,kBAAA;EACA,gCAAA;EACA,kBjDlGe;EiDmGf,yBAAA;EACA,cjD1Qa;EiD2Qb,gBjDrFa;EiDsFb,mBAAA;EACA,iBjDtJe;ADisW/B;AkDviWQ;EACI,eAAA;AlDyiWZ;AkDviWY;EAEI,mBjD1Ra;ADk0W7B;AkDniWY;EACI,kBjDnIgB;EiDqIhB,YAAA;EACA,iBAAA;EACA,WAAA;EACA,kBAAA;AlDoiWhB;AkDjiWY;EACI,gBAAA;EACA,YAAA;EACA,iBAAA;EACA,cjD3Sa;AD80W7B;AkDhiWY;EACI,YAAA;EACA,iBAAA;EACA,WAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;EACA,WAAA;EACA,kBAAA;AlDkiWhB;AkD/hWY;EAEI,kBAAA;AlDgiWhB;AkD7hWY;EAII,mBjDpUa;EiDqUb,eAAA;AlD4hWhB;AkDzhWY;EAEI,cjDzUa;ADm2W7B;AkDvhWY;EACI,kBAAA;AlDyhWhB;AkDvhWgB;EACI,WAAA;EACA,qBAAA;EACA,qCAAA;EACA,4BjDtWI;EiDuWJ,oCAlW4B;EAmW5B,kBAAA;EACA,WAAA;EACA,UAAA;AlDyhWpB;AkDrhWY;EAEI,yBjDhXQ;EiDiXR,cjD3Qa;ADiyW7B;AkDlhWY;EACI,yBAAA;AlDohWhB;AkDjhWY;EAEI,gBAAA;EACA,cjDzWa;EiD0Wb,mBAAA;AlDkhWhB;AkD/gWY;EAGG,qBAAA;EACC,WAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;AlD+gWhB;AkD7gWgB;EACI,mBjD3XS;AD04W7B;AkD5gWgB;EACI,yBjDjZI;EiDkZJ,cjD5SS;AD0zW7B;AkD3gWgB;EACI,cjDnYS;ADg5W7B;AkD1gWgB;EAEI,gBAAA;EACA,cjDzYS;EiD0YT,mBAAA;AlD2gWpB;AkDlgWQ;;;EACI,6BAAA;AlDsgWZ;AkDjgWgB;;;EACI,cjDhaS;EiDiaT,6BAAA;AlDqgWpB;AkD9/VQ;EACI,YAAA;EACA,iBAAA;AlDggWZ;;AkD1/VI;EACI,eAAA;AlD6/VR;;AkDz/VA;;;;;;EAMI,YAAA;AlD4/VJ;;AkDz/VA;EACI,UAAA;EAKA,uCAAA;AlD4/VJ;AkD1/VI;EAKI,qCAAA;AlD4/VR;AkD1/VI;EACI,UAAA;EAKA,iCAAA;EACA,iEAAA;AlD4/VR;;AkDv/VA;EACI,oBAAA;AlD0/VJ;;AkDv/VA;EAKI,mCAAA;AlD0/VJ;AkDx/VI;EACI,8BAAA;EACA,mCAAA;EACA,oCAAA;EACA,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,UAAA;EACA,aAAA;AlD0/VR;AkDx/VI;EACI,8BAAA;EACA,mCAAA;EACA,oCAAA;EACA,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,UAAA;EACA,aAAA;AlD0/VR;;AmDrgXA,8CAAA;AAGA;;;EAAA;AAIA;;EAEA,2BAAA;EACA,6CAAA;EACA,yBAAA;EAEC,kBAAA;EAGA,iBAAA;EAEA,sBAAA;AnDsgXD;;AmDpgXA;EACC,kBAAA;EACA,cAAA;AnDugXD;;AmDrgXA;EACC,WAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA,EAAA,YAAA;AnDwgXD;;AmDtgXA;EACC,kBAAA;EACA,QAAA;EACA,MAAA;EACA,OAAA;EACA,SAAA;AnDygXD;;AmDvgXA;EACC,kBAAA;EACA,SAAA;EACA,QAAA;AnD0gXD;;AmDxgXA;EACC,kBAAA;EACA,UAAA;AnD2gXD;;AmDzgXA;;EAGC,wDAAA;AnD4gXD;;AmD1gXA;EACC,0BAAA;AnD6gXD;;AmD1gXA;;EAAA;AAGA;;EAGC,+BAAA;AnD6gXD;;AmD1gXA;EAAA;AAEA;EACC,WAAA;AnD6gXD;;AmD3gXA;EACI,kBAAA;EACH,yBlDuC4B;EkDtC5B,2CAAA;EACA,YAAA;EACA,WAAA;EACA,eAAA;EACG,kBAAA;EACA,gBAAA;EACH,aAAA;AnD8gXD;;AmD5gXA;EACC,WAAA;AnD+gXD;;AmD7gXA;EACC,WAAA;EACA,YAAA;EACA,UAAA;EACA,UAAA;AnDghXD;;AmD7gXA;EAAA;AAEA;EACC,0CAAA;EACA,kBAAA;AnDghXD;;AmD9gXA;EACC,mBlD5E4B;EkD6EzB,kBAAA;EAEH,4BAAA;AnDihXD;;AmD9gXA;EAAA;AAEA;EACC,iBAAA;AnDihXD;;AmD/gXA;EACC,iBAAA;AnDkhXD;;AmDhhXA;EAEC,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,4EAAA;EAGA,iCAAA;EACG,8BAAA;EACA,6BAAA;EACA,2BAAA;EACA,yBAAA;AnDghXJ;;AmD9gXA;EAKI,+BAAA;AnDihXJ;;AmD9gXA;EAAA;AAGA;EACC,mBAAA;AnDghXD;;AmD9gXA;;;EAGC,mBAAA;AnDihXD;;AmD9gXA;;EAAA;AAGA;;EAGC,sBAAA;AnDihXD;;AmD/gXA;EACC,kBAAA;EACA,WAAA;AnDkhXD;;AmD/gXA;;EAAA;AAGA;EACC,kBAAA;EACA,kBAAA;AnDkhXD;;AmDhhXA;EACC,WAAA;EACA,eAAA;AnDmhXD;;AmDhhXA;;EAAA;AAGA;EACC,kBAAA;EACA,gBAAA;AnDmhXD;;AmDjhXA;EACC,gBAAA;AnDohXD;;AmDlhXA;EACC,gBAAA;AnDqhXD;;AmDlhXA;;EAAA;AAGA;EACC,eAAA;EACA,YAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;AnDqhXD;;AmDnhXA;EAEC,oCAAA;AnDshXD;;AmDnhXA;EACC,iBAAA;EACA,UAAA;EACA,WAAA;AnDshXD;;AmDphXA;EACC,YAAA;AnDuhXD;;AmDrhXA;EACC,YAAA;AnDwhXD;;AmDrhXA;;EAAA;AAGA;EACC,eAAA;EACA,YAAA;EACA,MAAA;EACA,UAAA;AnDwhXD;;AmDthXA;EAEC,iCAAA;EACA,kBAAA;AnDyhXD;;AmDthXA;EACC,UAAA;EACA,WAAA;EACA,gBAAA;AnDyhXD;;AmDvhXA;EACC,WAAA;AnD0hXD;;AmDxhXA;EACC,WAAA;AnD2hXD;;AmDxhXA;EACC,cAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;AnD2hXD;;AmDzhXA;EAEI,6BAAA;EACA,SAAA;EACA,YAAA;AnD4hXJ;;AmD1hXA;EAEI,6BAAA;EACA,QAAA;EACA,WAAA;AnD6hXJ;;AmDthXE;EAEU,yBlD7JiB;ADqrX7B;;AmDnhXE;EAEU,yBlD/QY;ADoyXxB;;AmDhhXQ;EAEI,yBlDjRY;ADmyXxB;;AmD9gXQ;EAEI,yBlDzRY;ADyyXxB;;AmD5gXQ;EAEI,yBlD9RY;AD4yXxB;;AmD1gXQ;EAEI,yBlDtSY;ADkzXxB;;AoDvzXA,sCAAA;AACA;;;EAAA;AAIA;;EAEE,2BAAA;EACA,6CAAA;EACA,yBAAA;EAEA,kBAAA;EAGA,iBAAA;EAEA,sBAAA;ApD0zXF;;AoDxzXA;EACE,kBAAA;ApD2zXF;;AoDzzXA;;EAEE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;ApD4zXF;;AoD1zXA;EAAA;AAEA;EACE,gBAAA;EACA,UAAA;ApD6zXF;;AoD3zXA;;EAEE,sBAAA;EACA,kBAAA;EACA,UAAA;EACA,MAAA;EACA,QAAA;EACA,yBAAA;EACA,6BAAA;EACA,oCAAA;EACA,qBAAA;EACA,qBAAA;ApD8zXF;;AoD5zXA;EACE,YAAA;EACA,WAAA;ApD+zXF;;AoD7zXA;EACE,WAAA;EACA,UAAA;ApDg0XF;;AoD9zXA;EAAA;AAEA;EACE,OAAA;EACA,WAAA;ApDi0XF;;AoD/zXA;;EAAA;AAGA;EACE,QAAA;ApDk0XF;;AoDh0XA;EACE,SAAA;ApDm0XF;;AoDj0XA;EAEE,2BAAA;EACA,kBAAA;ApDo0XF;;AoDl0XA;EACE,YAAA;EACA,WAAA;ApDq0XF;;AoDn0XA;;EAGE,0BAAA;ApDs0XF;;AoDp0XA;EACE,0BAAA;ApDu0XF;;AoDr0XA;EAAA;AAEA;EACE,WAAA;ApDw0XF;;AoDt0XA;EACE,WAAA;EACA,YAAA;EACA,YAAA;EACA,QAAA;ApDy0XF;;AoDv0XA;EACE,WAAA;ApD00XF;;AoDx0XA;EACE,WAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;ApD20XF;;AoDz0XA;EACE,WAAA;EACA,WAAA;ApD40XF;;AoD10XA;;EAAA;AAGA;EACE,mBAAA;EACA,kBAAA;ApD60XF;;AoD30XA;EACE,kBAAA;ApD80XF;;AoD50XA;EACE,mBAAA;ApD+0XF;;AoD70XA;EAAA;AAEA;EACE,iBAAA;ApDg1XF;;AoD90XA;EACE,iBAAA;ApDi1XF;;AoD/0XA;EACE,2CAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;ApDk1XF;;AoDh1XA;EAAA;AAEA;EAAA;AAEA;EACE,mBAAA;ApDm1XF;;AoDj1XA;;;EAGE,mBAAA;ApDo1XF;;AoDl1XA;;EAAA;AAGA;;EAGE,sBAAA;ApDq1XF;;AoDn1XA;EACE,kBAAA;EACA,WAAA;ApDs1XF;;AoDp1XA;;EAAA;AAGA;EACE,kBAAA;EACA,mBAAA;EACA,kBAAA;ApDu1XF;;AoDr1XA;EACE,WAAA;EACA,eAAA;ApDw1XF;;AoDt1XA;;EAAA;AAGA;EACE,kBAAA;EACA,gBAAA;ApDy1XF;;AoDv1XA;EACE,gBAAA;ApD01XF;;AoDx1XA;EACE,gBAAA;ApD21XF;;AoDz1XA;;EAAA;AAGA;EACE,eAAA;EACA,YAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;ApD41XF;;AoD11XA;EAEE,+BAAA;ApD61XF;;AoD31XA;EAEE,8BAAA;ApD81XF;;AoD51XA;EACE,iBAAA;EACA,UAAA;EACA,WAAA;ApD+1XF;;AoD71XA;EACE,YAAA;ApDg2XF;;AoD91XA;EACE,YAAA;ApDi2XF;;AoD/1XA;;EAAA;AAGA;EACE,eAAA;EACA,YAAA;EACA,MAAA;EACA,UAAA;ApDk2XF;;AoDh2XA;EAEE,6BAAA;EACA,kBAAA;ApDm2XF;;AoDj2XA;EAEE,4BAAA;ApDo2XF;;AoDl2XA;EACE,UAAA;EACA,WAAA;EACA,gBAAA;ApDq2XF;;AoDn2XA;EACE,WAAA;ApDs2XF;;AoDp2XA;EACE,WAAA;ApDu2XF;;AoDr2XA;EACE,cAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;ApDw2XF;;AoDt2XA;EAEE,6BAAA;EACA,SAAA;EACA,YAAA;ApDy2XF;;AoDv2XA;EAEE,6BAAA;EACA,QAAA;EACA,WAAA;ApD02XF;;AoDx2XA;EAEE,4BAAA;EACA,UAAA;EACA,YAAA;ApD22XF;;AoDz2XA;EAEE,8BAAA;EACA,SAAA;EACA,WAAA;ApD42XF;;AoD12XA;EACE,+BAAA;ApD62XF;;AoD12XE;EACE,mBnDtRoB;ADmoYxB;;AoDz2XE;EACE,mBnDhSoB;AD4oYxB;;AoDx2XE;EACE,mBnDlSoB;AD6oYxB;;AoDv2XE;EACE,mBnDtSoB;ADgpYxB;;AoDt2XE;EACE,mBnD7SoB;ADspYxB;;AqD3pYA;EACE,cAAA;EACA,aAAA;EACA,SAAA;ArD8pYF;;AqD5pYA;EACE,iBAAA;EACA,oBAAA;EACA,0BAAA;EACA,eAAA;ArD+pYF;;AqD7pYA;EACE,mBAAA;ArDgqYF;;AqD9pYA;EACE,SAAA;EACA,UAAA;ArDiqYF;;AqD/pYA;EACE,sBAAA;EACA,YAAA;EAGA,aAAA;EAGA,sBAAA;EAGA,oBAAA;ArDkqYF;;AqDhqYA;;;EAGE,mBAAA;ArDmqYF;;AqDjqYA;;EAEE,gBAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;ArDoqYF;;AqDlqYA;;;;EAIE,cAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;ArDqqYF;;AqDnqYA;EACE,cAAA;ArDsqYF;;AqDpqYA;EACE,cAAA;EACA,YAAA;ArDuqYF;;AqDlqYA;EACE,gBAAA;EAGA,SAAA;EACA,uBAAA;EACA,mBAAA;EACA,cAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,aAAA;EACA,6BAAA;EACA,cAAA;EACA,gBAAA;ArDqqYF;AqDnqYI;EACE,mBAAA;ArDqqYN;;AqDjqYA;;;EAGE,cAAA;EACA,qBAAA;ArDoqYF;;AqDlqYA;EACE,kBAAA;EAGA,iBAAA;EACA,yBAAA;EACA,UAAA;EACA,iBAAA;ArDqqYF;;AqDnqYA;EAGE,aAAA;EAGA,mBAAA;EACA,mBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,mBAAA;ArDsqYF;;AqDpqYA;EAGE,YAAA;EACA,eAAA;EACA,kBAAA;EACA,oBAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,SAAA;EACA,iBAAA;ArDuqYF;;AqDrqYA;EACE,qBAAA;EACA,SAAA;EACA,kBAAA;EACA,sBAAA;EACA,gBAAA;EACA,sBAAA;EACA,sBAAA;EACA,kBAAA;EACA,mBAAA;EACA,mBAAA;EACA,iBAAA;EACA,6BAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,WAAA;EACA,oBAAA;EACA,kBAAA;EACA,aAAA;ArDwqYF;;AqDtqYA;EACE,aAAA;ArDyqYF;;AqDtqYE;EAEE,kBAAA;EACA,sBAAA;EACA,WAAA;ArDwqYJ;;AqDrqYA;EACE,cAAA;EACA,yBAAA;EACA,qBAAA;ArDwqYF;;AqDtqYA;EACE,qBAAA;EACA,mBAAA;ArDyqYF;;AqDvqYA;EACE,0BAAA;EACA,6BAAA;ArD0qYF;;AqDxqYA;EACE,yBAAA;EACA,4BAAA;ArD2qYF;;AqDzqYA;EACE,kBAAA;EACA,yBAAA;EACA,4BAAA;ArD4qYF;;AqD1qYA;EACE,kBAAA;EACA,0BAAA;EACA,6BAAA;ArD6qYF;;AqD3qYA;EACE,gBAAA;ArD8qYF;;AqD5qYA;EACE,iBAAA;ArD+qYF;;AqD7qYA;EACE,cAAA;EACA,kBAAA;ArDgrYF;;AqD9qYA;;EAEE,iBAAA;ArDirYF;;AqD9qYA;EACE,eAAA;EACA,oBAAA;ArDirYF;;AqD/qYA;EACE,yBAAA;ArDkrYF;;AqDhrYA;EACE,cAAA;ArDmrYF;;AqDjrYA;EACE,kDAAA;ArDorYF;;AqDlrYA;EACE,yBAAA;EACA,4BAAA;ArDqrYF;;AqDnrYA;EACE,0BAAA;EACA,6BAAA;ArDsrYF;;AqDprYA;EACE,yBAAA;EACA,0BAAA;ArDurYF;;AqDrrYA;EACE,4BAAA;EACA,6BAAA;ArDwrYF;;AqDtrYA;EACE,4BAAA;EACA,6BAAA;ArDyrYF;;AqDvrYA;EACE,yBAAA;EACA,0BAAA;ArD0rYF;;AqDxrYA;EAGE,aAAA;EAGA,mBAAA;ArD2rYF;;AqDzrYA;EACE,oBAAA;ArD4rYF;;AqD1rYA;EACE,oCAAA;ArD6rYF;;AqD3rYA;EACE,0CAAA;EACA,UAAA;EACA,iBAAA;EACA,cAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;ArD8rYF;;AqD5rYA;EACE,kBAAA;EACA,sBAAA;EACA,kBAAA;EAGA,aAAA;EAGA,sBAAA;EAGA,SAAA;EACA,WAAA;EAGA,iBAAA;EACA,yBAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;ArD+rYF;;AqD7rYA;EACE,gBAAA;ArDgsYF;;AqD9rYA;EAGE,aAAA;EAGA,mBAAA;ArDisYF;;AqD9rYA;EAGE,aAAA;EACA,kBAAA;EAGA,sBAAA;EAGA,SAAA;EAEA,4BAAA;EAEA,gBAAA;EACA,YAAA;ArD+rYF;;AqD7rYA;EACE,0BAAA;ArDgsYF;;AqD9rYA;EACE,SAAA;EACA,YAAA;EACA,iBAAA;EACA,gBAAA;ArDisYF;;AqD/rYA;EACE,iBAAA;ArDksYF;;AqDhsYA;;;EAGE,cAAA;EACA,qBAAA;ArDmsYF;;AqDjsYA;EAGE,aAAA;EAGA,mBAAA;EAGA,SAAA;EACA,gBAAA;ArDosYF;;AqDlsYA;EAGE,SAAA;ArDqsYF;;AqDnsYA;EACE,2BAAA;ArDssYF;;AqDpsYA;EACE,oBAAA;EACA,4BAAA;ArDusYF;;AqDrsYA;EACE,kBAAA;EACA,UAAA;EACA,yBAAA;EACA,sBAAA;EACA,0CAAA;EACA,aAAA;ArDwsYF;;AqDtsYA;EACE,eAAA;ArDysYF;;AqDvsYA;EACE,gCAAA;EACA,6BAAA;EACA,iBAAA;ArD0sYF;;AqDxsYA;EAGE,aAAA;EAGA,sBAAA;EAGA,SAAA;EACA,cAAA;ArD2sYF;;AqDzsYA;EACE,WAAA;EACA,sBAAA;EACA,iBAAA;EACA,yBAAA;ArD4sYF;;AqD1sYA;EACE,iBAAA;EACA,mBAAA;ArD6sYF;;AqD3sYA;EACE,kBAAA;EACA,mBAAA;EACA,yBAAA;ArD8sYF;;AqD5sYA;EACE,2BAAA;ArD+sYF;;AqD7sYA;EACE,oBAAA;EACA,4BAAA;ArDgtYF;;AqD9sYA;EACE,0BAAA;ArDitYF;;AqD/sYA;EACE,gBAAA;EACA,gBAAA;EACA,6BAAA;ArDktYF;;AqDhtYA;EACE,iBAAA;ArDmtYF;;AqDjtYA;EACE,yBAAA;ArDotYF;;AqDltYA;EACE,aAAA;ArDqtYF;;AqDntYA;EACE,aAAA;ArDstYF;;AqDptYA;;EAEE,mBAAA;ArDutYF;;AqDrtYA;EACE,WAAA;ArDwtYF;;AqDttYA;EAGE,aAAA;EAGA,sBAAA;EACA,gBAAA;ArDytYF;;AqDvtYA;EAGE,SAAA;ArD0tYF;;AqDxtYA;EACE,6BAAA;EACA,gBAAA;EAGA,aAAA;EAGA,wBAAA;ArD2tYF;;AqDztYA;;EAIE,UAAA;ArD4tYF;;AqD1tYA;EACE,cAAA;ArD6tYF;;AqD3tYA;EACE,kBAAA;ArD8tYF;;AqD5tYA;EACE,SAAA;EACA,OAAA;EACA,kBAAA;EACA,WAAA;EACA,MAAA;ArD+tYF;;AqD7tYA;EACE,UAAA;EACA,QAAA;ArDguYF;;AqD9tYA;EAGE,aAAA;EACA,gBAAA;EACA,gBAAA;EAGA,sBAAA;EAGA,uBAAA;EACA,gBAAA;EACA,kBAAA;ArDiuYF;;AqD/tYA;EAGE,UAAA;EACA,kBAAA;EACA,WAAA;EACA,iBAAA;EAGA,uBAAA;EACA,WAAA;EACA,mBAAA;ArDkuYF;;AqDhuYA;EACE,WAAA;EAGA,SAAA;EACA,qBAAA;EACA,cAAA;EACA,YAAA;EACA,eAAA;ArDmuYF;;AqDjuYA;EACE,2BAAA;ArDouYF;;AqDluYA;EAGE,SAAA;ArDquYF;;AqDnuYA;EACE,iBAAA;ArDsuYF;;AqDpuYA;EACE,kBAAA;ArDuuYF;;AqDruYA;EACE,WAAA;EACA,kBAAA;EACA,oCAAA;EACA,YAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;ArDwuYF;;AqDtuYA;EACE,YAAA;ArDyuYF;;AqDvuYA;EAGE,aAAA;EAGA,sBAAA;EAGA,SAAA;EACA,WAAA;EACA,sBAAA;EACA,aAAA;EACA,iBAAA;EACA,kBAAA;EACA,gBAAA;ArD0uYF;;AqDxuYA;EACE,mBAAA;ArD2uYF;;AqDzuYA;EACE,uBAAA;EACA,WAAA;EACA,kBAAA;ArD4uYF;;AqD1uYA;EACE,kBAAA;EACA,UAAA;ArD6uYF;;AqD3uYA;EACE,sBAAA;EACA,gBAAA;ArD8uYF;;AqD5uYA;EAGE,aAAA;EAGA,cAAA;EAGA,mBAAA;ArD+uYF;;AqD7uYA;EACE,4BAAA;ArDgvYF;;AqD9uYA;EACE,qBAAA;EACA,2BAAA;ArDivYF;;AqD/uYA;EACE,6BAAA;ArDkvYF;;AqDhvYA;EACE,6BAAA;ArDmvYF;;AqDjvYA;EAGE,SAAA;EACA,YAAA;EAGA,sBAAA;EACA,2BAAA;ArDovYF;;AqDlvYA;EACE,oBAAA;EACA,4BAAA;ArDqvYF;;AqDnvYA;EAGE,aAAA;EAGA,SAAA;EAGA,uBAAA;EACA,WAAA;EACA,0BAAA;EACA,gBAAA;EACA,kBAAA;ArDsvYF;;AqDpvYA;EAGE,UAAA;ArDuvYF;;AqDrvYA;EACE,2BAAA;ArDwvYF;;AqDtvYA;EACE,oBAAA;EACA,4BAAA;ArDyvYF;;AqDvvYA;EACE,WAAA;EAGA,iBAAA;EACA,yBAAA;ArD0vYF;;AqDxvYA;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,yBAAA;EACA,oBAAA;ArD2vYF;;AqDzvYA;EACE,WAAA;EACA,kBAAA,EAAA,kDAAA;EACA,cAAA,EAAA,2BAAA;EACA,iBAAA;EACA,kBAAA;EACA,UAAA;EACA,yBpDtoB2B,EoDsoBI,6BAAA;EAE/B,mBAAA,EAAA,sCAAA;EACA,gBAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;ArD2vYF;AqDzvYE;EACE,yBpD9oByB;ADy4Z7B;AqDzvYE;EACE,yBpDhpByB;AD24Z7B;AqDzvYE;EACE,wCpDlpByB;AD64Z7B;AqDzvYE;EACE,uCpDppByB;AD+4Z7B;AqDxvYE;EACE,kBAAA;EACA,UAAA;EACA,mBAAA;EACA,gBAAA;EACA,cAAA;EACA,cAAA;ArD0vYJ;;AqDvvYA;EACE,yBAAA;EACA,wBAAA;EACA,4BAAA;ArD0vYF;;AqDvvYA;EACE,yBpDxkB2B;ADk0Z7B;;AqDxvYA;EACE;IACE,cAAA;ErD2vYF;EqD1vYE;IACE,cAAA;IACA,kBAAA;ErD4vYJ;EqD1vYE;IACE,cAAA;IACA,gBAAA;IACA,UAAA;ErD4vYJ;AACF;AsDl8ZA;EACE,uBAAA;EACA,qBAAA;EACA,sBAAA;AtDo8ZF;;AuDv8ZA;EACE,iBAAA;E7CoCE,4BAAA;AV26ZJ;AwD/8ZE;EACE,yBvDCoB;ADg9ZxB;AwD78ZI;EACE,qBvDJkB;ADm9ZxB;AwDx8ZM;EACE,qBvDZgB;EuDahB,cvDbgB;ADu9ZxB;AwDp8ZI;EACE,yBvDpBkB;AD09ZxB;AwDl8ZE;EACE,yBvDzBoB;AD69ZxB;AwDj8ZE;EACE,qBvD7BoB;ADg+ZxB;AwDl+ZE;EACE,yBvDIoB;ADg+ZxB;AwDh+ZI;EACE,qBvDDkB;ADm+ZxB;AwD39ZM;EACE,qBvDTgB;EuDUhB,cvDVgB;ADu+ZxB;AwDv9ZI;EACE,yBvDjBkB;AD0+ZxB;AwDr9ZE;EACE,yBvDtBoB;AD6+ZxB;AwDp9ZE;EACE,qBvD1BoB;ADg/ZxB;AwDr/ZE;EACE,yBvDKoB;ADk/ZxB;AwDn/ZI;EACE,qBAAA;AxDq/ZN;AwD9+ZM;EACE,qBvDRgB;EuDShB,cvDTgB;ADy/ZxB;AwD1+ZI;EACE,yBvDhBkB;AD4/ZxB;AwDx+ZE;EACE,yBvDrBoB;AD+/ZxB;AwDv+ZE;EACE,qBvDzBoB;ADkgaxB;AwDxgaE;EACE,yBvDGoB;ADugaxB;AwDtgaI;EACE,qBvDFkB;AD0gaxB;AwDjgaM;EACE,qBvDVgB;EuDWhB,cvDXgB;AD8gaxB;AwD7/ZI;EACE,yBvDlBkB;ADihaxB;AwD3/ZE;EACE,yBvDvBoB;ADohaxB;AwD1/ZE;EACE,qBvD3BoB;ADuhaxB;AwD3haE;EACE,yBvDMoB;ADuhaxB;AwDzhaI;EACE,qBvDCkB;AD0haxB;AwDphaM;EACE,qBvDPgB;EuDQhB,cvDRgB;AD8haxB;AwDhhaI;EACE,yBvDfkB;ADiiaxB;AwD9gaE;EACE,yBvDpBoB;ADoiaxB;AwD7gaE;EACE,qBvDxBoB;ADuiaxB;AuD3haE;EACE,0BAAA;EACA,oBAAA;EACA,6BAAA;AvD6haJ;AuD5haI;EACE,kBAAA;AvD8haN;AuD7haM;EACE,ctDGqB;EsDFrB,mBAAA;EACA,gBAAA;EACA,WAAA;EACA,mBAAA;AvD+haR;AuD1haE;EACE,gBAAA;AvD4haJ;AuDzhaE;;;;;;EAME,6BAAA;EACA,gBAAA;AvD2haJ;AuDxhaE;EACE,kBAAA;EACA,eAAA;EACA,kBAAA;AvD0haJ;AuDvhaE;EACE,kBAAA;AvDyhaJ;AuDvhaI;EACE,aAAA;EACA,mBAAA;EAEA,uBAAA;AvDyhaN;AuDrhaE;;EAEE,qBAAA;EACA,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,UAAA;EACA,sBAAA;AvDuhaJ;AuDrhaE;EACE,iBAAA;AvDuhaJ;AuDphaE;EACE,YAAA;EACA,aAAA;EACA,yBAAA;EACA,yBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,oBAAA;EACA,4BAAA;AvDshaJ;AuDphaI;EACE,qBAAA;AvDshaN;AuDlhaE;EACE,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,4CAAA;EACA,QAAA;EACA,SAAA;EACA,yBtDrFyB;EsDuFzB,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AvDmhaJ;AuDhhaE;EACE,eAAA;EACA,cAAA;EACA,YAAA;EACA,OAAA;EACA,qBAAA;EACA,kBAAA;EACA,MAAA;EACA,WAAA;AvDkhaJ;AuD/gaE;EACE,WAAA;AvDihaJ;AuD9gaE;EACE,iBAAA;EACA,eAAA;AvDghaJ;AuD7gaE;EACE,eAAA;AvD+gaJ;AuD7gaI;EACE,gBAAA;AvD+gaN;AuD3gaE;EACE,aAAA;AvD6gaJ;AuD1gaE;EACE,kBAAA;EACA,oBAAA;AvD4gaJ;AuD1gaI;EACE,eAAA;AvD4gaN;AuDxgaE;EACE,kBAAA;AvD0gaJ;AuDvgaE;EACE,yBAAA;AvDygaJ;AuDtgaE;EACE,kBAAA;EACA,gBAAA;EACA,mBAAA;AvDwgaJ;AuDrgaE;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;AvDugaJ;AuDrgaI;EACE,oBAAA;EACA,mBAAA;EACA,YAAA;AvDugaN;AuDpgaI;EACE,kBAAA;EACA,sBAAA;EACA,aAAA;EACA,YAAA;EACA,kBAAA;EACA,ctDrKuB;EsDsKvB,mBAAA;EACA,yBAAA;EACA,oBAAA;EACA,4BAAA;AvDsgaN;AuDngaI;EACE,eAAA;EACA,kBAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;AvDqgaN;AuDhgaM;EACE,qBAAA;AvDkgaR;AuD9/ZI;;EAEE,kBAAA;EACA,cAAA;EACA,WAAA;AvDggaN;AuD5/ZE;EACE,aAAA;AvD8/ZJ;AuD3/ZE;EACE,mBAAA;EACA,mBAAA;AvD6/ZJ;AuD1/ZE;EACE,SAAA;AvD4/ZJ;AuDz/ZE;EACE,yBtDxMyB;ADmsa7B;AuDz/ZI;EACE,cAAA;AvD2/ZN;AuDx/ZI;EACE,oBAAA;EACA,gBAAA;EACA,iBAAA;EACA,yBAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;AvD0/ZN;AuDv/ZI;;;;;EAKE,yBAAA;EACA,gBAAA;AvDy/ZN;AuDt/ZI;EACE,cAAA;EACA,eAAA;EACA,eAAA;AvDw/ZN;AuDp/ZE;EACE,gBAAA;AvDs/ZJ;AuDj/ZI;;E7CzMI,iCAAA;AVksaR;;AyDvwaA;;CAAA;AAIA;EACE,kBAAA;AzDywaF;AyDxwaE;EACE,sBAAA;EACA,eAAA;AzD0waJ;AyDxwaE;EAKE,4BAAA;EACA,iBAAA;EACA,kBAAA;EACA,cAAA;EACA,UAAA;AzD0waJ;AyDvwaI;EACE,UAAA;EACA,mBAAA;EACA,aAAA;AzDywaN;;AyDrwaA;EACE,aAAA;EACA,kBAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,yBAAA;EACA,gBAAA;EACA,qCAAA;EACA,mBAAA;EAEA,4CAAA;EAEA,4BAAA;EACA,gBAAA;AzDwwaF;AyDtwaE;EACE,4CAAA;EACA,mCAAA;EACA,oCAAA;EACA,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,UAAA;EACA,UAAA;AzDwwaJ;AyDtwaE;EACE,iCAAA;EACA,mCAAA;EACA,oCAAA;EACA,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,UAAA;EACA,UAAA;AzDwwaJ;;AyDpwaA;EACE,cAAA;EACA,SAAA;AzDuwaF;;AyDrwaA;EACE,gBAAA;EACA,gBAAA;AzDwwaF;;AyDrwaA;EACE,kBAAA;EACA,YAAA;EACA,kBAAA;AzDwwaF;;AyDrwaA;EACE,WAAA;EACA,SAAA;EACA,gCAAA;AzDwwaF;;AyDtwaA;;EAEE,kBAAA;EACA,YAAA;AzDywaF;;AyDvwaA;EACE,eAAA;AzD0waF;;AyDxwaA;EACE,YAAA;EACA,iBAAA;EACA,WAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;AzD2waF;AyD1waE;EAGE,oCAAA;EACA,cxDIyB;ADswa7B;;AyDrwaI;EACE,kBAAA;EACA,gCAAA;EACA,eAAA;EACA,yBAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,iBAAA;AzDwwaN;AyDtwaI;;EAEE,cxDhGuB;ADw2a7B;;AyDnwaA;;;;;EAKE,mBAAA;EACA,eAAA;AzDswaF;;AyDpwaA;EACE,kBAAA;AzDuwaF;;AyDrwaA;EACE,yBAAA;AzDwwaF;;AyDtwaA;;EAEE,gBAAA;EACA,cAAA;EACA,mBAAA;AzDywaF;;AyDtwaA;EACE,cAAA;AzDywaF;;AyDvwaA;;EAEE,gBAAA;EACA,cAAA;EACA,mBAAA;AzD0waF;;AyDxwaA;EACE,eAAA;EACA,mBAAA;AzD2waF;;AyDzwaA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;AzD4waF;;AyD1waA;;EAEE,eAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;AzD6waF;;AyD1waA;;EAEE,cAAA;EACA,2BAAA,EAAA,eAAA;EACA,yBAAA,EAAA,wBAAA,EACA,cAAA,EACA,YAAA,EACA,2BAAA;EACA,iBAAA;AzD6waF;;AyD1waA;;EAEE,gBAAA;EACA,cAAA;EACA,mBAAA;AzD6waF;;AyD3waA;EACE,eAAA;AzD8waF;;AyD5waA;EACE,mBAAA;AzD+waF;;AyD5waA;EACE,YAAA;EACA,gBAAA;EACA,eAAA;AzD+waF;;AyD7waA;EACE,sBAAA;AzDgxaF;;AyD7waA;EACE,WAAA;EACA,YAAA;AzDgxaF;;AyD7waA;;EAEE,YAAA;EACA,UAAA;EACA,eAAA;AzDgxaF;;AyD9waA;;EAEE,gBAAA;AzDixaF;;AyD9waA;EACE,qBAAA;AzDixaF;;AyD7waE;EACE,WAAA;EACA,WAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;AzDgxaJ;AyD9waE;EACE,QAAA;EACA,6BAAA;AzDgxaJ;;AyD5waA;EACE,aAAA;AzD+waF;;AyD5waA;EACE,WAAA;AzD+waF;AyD9waE;EACE,YAAA;EACA,YAAA;EACA,6BAAA;AzDgxaJ;;AyD3waI;EACE,cxD9PkB;EwD+PlB,kBAAA;EACA,yBAAA;AzD8waN;;AyDzwaA;EACE,YAAA;EACA,kBAAA;AzD4waF;;AyD1waA;EACE,iBAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;EACA,cxDpP2B;EwDyP3B,4BAAA;EAEA,2BAAA,EAAA,eAAA;EACA,yBAAA,EAAA,wBAAA,EACA,cAAA,EACA,YAAA,EACA,2BAAA;EACA,iBAAA;AzD4waF;;AyD1waA;EACE,gBAAA;EACA,cAAA;AzD6waF;;AyD3waA;EACE,gBAAA;AzD8waF;;AyD3waA;EACE,sBAAA;EACA,iBAAA;EACA,WAAA;AzD8waF;;AyD3waA;EACE,WAAA;EACA,gBAAA;EACA,gBAAA;AzD8waF;;AyD5waA;;EAEE,oBAAA;AzD+waF;AyD9waE;;;;EAEE,qBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;EACA,eAAA;EACA,kBAAA;EACA,kBAAA;AzDkxaJ;AyDhxaI;;;;EACE,oCAAA;EACA,cxDpNuB;ADy+a7B;;AyD9waI;EACE,eAAA;AzDixaN;;AyD3waA;EACE,SAAA;AzD8waF;AyD7waE;EACE,4CAAA;EACA,mCAAA;EACA,oCAAA;EACA,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;AzD+waJ;AyD7waE;EACE,iCAAA;EACA,mCAAA;EACA,oCAAA;EACA,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,QAAA;EACA,UAAA;AzD+waJ;;AyDzwaE;EACE,4CAAA;EACA,mCAAA;EACA,oCAAA;EACA,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,UAAA;EACA,UAAA;AzD4waJ;AyD1waE;EACE,iCAAA;EACA,mCAAA;EACA,oCAAA;EACA,WAAA;EACA,qBAAA;EACA,kBAAA;EACA,UAAA;EACA,UAAA;AzD4waJ;;A0DvobI;EACE,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;A1D0obN;A0DzobM;EACE,gBAAA;A1D2obR;;A2DnpbA;;;;;;CAAA;AASA;;CAAA;AAKE;EACE,gBAAA;EACA,+BAAA;EACA,8BAAA;EACA,sBAAA;EACA,sBAAA;EACA,yBAAA;EAEA,uCAAA;EAEA,sBAAA;EACA,gBAAA;EACA,kBAAA;EACA,OAAA;EACA,SAAA;EACA,WAAA;EACA,UAAA;EACA,iCAAA;A3DkpbJ;A2DhpbE;EACE,gBAAA;EACA,qBAAA;EACA,kBAAA;EACA,kBAAA;EACA,iBAAA;A3DkpbJ;A2DhpbE;EACE,eAAA;EACA,cAAA;EACA,iBAAA;A3DkpbJ;A2D9obM;EACE,6BAAA;A3DgpbR;A2D5obU;EACE,yCAAA;EACA,WAAA;A3D8obZ;A2DzobQ;EACE,yCAAA;EACA,WAAA;A3D2obV;A2DvobQ;EACE,cAAA;EACA,eAAA;A3DyobV;A2DpobE;EACE,yB1DqCyB;E0DpCzB,kCAAA;EACA,kBAAA;EACA,sBAAA;EACA,gBAAA;EACA,YAAA;EACA,sBAAA;EACA,yBAAA;EACA,cAAA;EACA,WAAA;A3DsobJ;A2DrobI;EACE,4BAAA;EACA,6BAAA;A3DuobN;A2DnobQ;EACE,yBAAA;EACA,SAAA;A3DqobV;A2DlobM;EACE,yBAAA;EACA,gBAAA;A3DoobR;A2DhobM;EACE,oBAAA;EACA,kBAAA;EACA,6BAAA;A3DkobR;A2DjobQ;EACE,oBAAA;A3DmobV;A2DjobQ;EACE,gBAAA;A3DmobV;A2DhobM;EACE,QAAA;EACA,c1D1FqB;AD4tb7B;A2D/nbI;EACE,c1DxFuB;E0DyFvB,iBAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,OAAA;EACA,cAAA;EACA,eAAA;A3DiobN;A2D/nbI;;EAEE,mBAAA;A3DiobN;A2D/nbI;EACE,WAAA;EACA,mBAAA;EACA,qBAAA;EACA,sBAAA;EACA,iBAAA;A3DiobN;A2DhobM;EACE,aAAA;A3DkobR;A2DhobM;EACE,UAAA;EACA,qBAAA;A3DkobR;A2D/nbQ;EACE,6BAAA;EACA,0CAAA;EACA,mBAAA;EACA,2BAAA;EACA,qBAAA;EACA,SAAA;EACA,QAAA;EACA,kBAAA;EACA,WAAA;A3DiobV;A2D/nbQ;EACE,yB1DZmB;AD6ob7B;A2D/nbQ;EACE,aAAA;A3DiobV;A2D7nbQ;EACE,YAAA;EACA,qBAAA;EACA,eAAA;EACA,cAAA;EACA,QAAA;EACA,kBAAA;EACA,iBAAA;A3D+nbV;A2D7nbQ;EACE,aAAA;A3D+nbV;A2DvnbQ;EACE,qB1DnLc;AD4ybxB;A2DrnbQ;;EAEE,c1DzLc;ADgzbxB;A2DnnbI;EACE,yBAAA;A3DqnbN;A2DpnbM;EACE,oC1DtEqB;E0DuErB,oDAAA;A3DsnbR;A2DrnbQ;EACE,c1DnMc;E0DoMd,6BAAA;A3DunbV;A2D/mbQ;EACE,qB1D1Mc;AD2zbxB;A2D7mbQ;;EAEE,c1DhNc;AD+zbxB;A2D3mbI;EACE,yBAAA;A3D6mbN;A2D5mbM;EACE,wD1DxFqB;E0DyFrB,wEAAA;A3D8mbR;A2D7mbQ;EACE,c1D1Nc;E0D2Nd,6BAAA;A3D+mbV;A2DvmbQ;EACE,qB1DlOc;AD20bxB;A2DrmbQ;;EAEE,c1DxOc;AD+0bxB;A2DnmbI;EACE,yBAAA;A3DqmbN;A2DpmbM;EACE,+B1DtHqB;E0DuHrB,+CAAA;A3DsmbR;A2DrmbQ;EACE,c1DlPc;E0DmPd,6BAAA;A3DumbV;A2D/lbQ;EACE,qB1D7Pc;AD81bxB;A2D7lbQ;;EAEE,c1DnQc;ADk2bxB;A2D3lbI;EACE,yBAAA;A3D6lbN;A2D5lbM;EACE,4B1DxIqB;E0DyIrB,4CAAA;A3D8lbR;A2D7lbQ;EACE,c1D7Qc;E0D8Qd,6BAAA;A3D+lbV;A2DvlbQ;EACE,qB1DzRc;ADk3bxB;A2DrlbQ;;EAEE,c1D/Rc;ADs3bxB;A2DnlbI;EACE,yBAAA;A3DqlbN;A2DplbM;EACE,uD1D7JqB;E0D8JrB,uEAAA;A3DslbR;A2DrlbQ;EACE,c1DzSc;E0D0Sd,6BAAA;A3DulbV;A2DllbE;EACE,yBAAA;A3DolbJ;A2DnlbI;EACE,kBAAA;EACA,c1D3RuB;E0D4RvB,8BAAA;A3DqlbN;A2DplbM;EACE,c1D7RqB;E0D8RrB,6BAAA;A3DslbR;A2DhlbM;EACE,aAAA;A3DklbR;A2DhlbM;EACE,yBAAA;EACA,yBAAA;A3DklbR;A2D/kbI;EACE,yBAAA;A3DilbN;;ACh5bA,8BAAA;A2DVA;EACE,kBAAA;EAGA,aAAA;EAIA,sBAAA;EACA,6BAAA;A5D85bF;;A4D35bE;EACE,iBAAA;A5D85bJ;A4D55bE;EACE,gBAAA;A5D85bJ;A4D55bE;EACE,kBAAA;A5D85bJ;;A4D35bA;EACE,sBAAA;A5D85bF;;A4D55bA;EAGE,YAAA;EAGA,aAAA;EAIA,sBAAA;EAGA,oBAAA;EACA,WAAA;EACA,yBAAA;EACA,cAAA;EACA,mBAAA;A5D+5bF;;A4D75bA;EAGE,cAAA;EAGA,aAAA;EAIA,sBAAA;EACA,yBAAA;EAGA,iBAAA;A5Dg6bF;;A4D95bA;EACE,+BAAA;EACA,4CAAA;A5Di6bF;;A4D/5bA;EACE,4CAAA;A5Dk6bF;;A4Dh6bA;;EAEE,yBAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,YAAA;EACA,yBAAA;EACA,mBAAA;A5Dm6bF;A4Dl6bE;;EACE,aAAA;EACA,sBAAA;EACA,WAAA;A5Dq6bJ;;A4Dl6bA;EACE,kBAAA;A5Dq6bF;;A4Dn6bA;EACE,iBAAA;EACA,aAAA;A5Ds6bF;;A4Dn6bE;EACE,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,qBAAA;EACA,SAAA;EACA,WAAA;EACA,iCAAA;EACA,gBAAA;A5Ds6bJ;;A4Dl6bE;EACE,gBAAA;EACA,SAAA;EACA,kBAAA;EACA,qBAAA;EACA,SAAA;EACA,WAAA;EACA,iCAAA;EACA,gBAAA;EACA,YAAA;A5Dq6bJ;;A4Dj6bE;EACE,gBAAA;EACA,QAAA;EACA,kBAAA;EACA,qBAAA;EACA,SAAA;EACA,WAAA;EACA,iCAAA;EACA,gBAAA;EACA,YAAA;A5Do6bJ;;A4Dj6bA;;EAEE,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,6BAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,mEAAA;EACA,qCAAA;EACA,gBAAA;EACE,mBAAA;EACA,4BAAA;EACG,2BAAA;EAEI,uBAAA;A5Do6bX;;A4Dl6bA;;EAEE,eAAA;A5Dq6bF;;A4Dn6bA;;EAEE,eAAA;A5Ds6bF;;A4Dp6bA;EACE,iBAAA;A5Du6bF;;A4Dr6bA;EACE,gBAAA;A5Dw6bF;;A4Dt6bA;EACE,gBAAA;EACA,uBAAA;A5Dy6bF;A4Dx6bE;EACE,aAAA;A5D06bJ;;A4Dv6bA;EACE,2BAAA;A5D06bF;;A4Dx6bA;;EAEE,UAAA;EACA,QAAA;EACA,yBAAA;EACA,YAAA;EACA,SAAA;EACA,QAAA;EACA,kBAAA;EACA,oBAAA;A5D26bF;;A4Dz6bA;EACE,oCAAA;EACA,uBAAA;EACA,iBAAA;EACA,gBAAA;A5D46bF;;A4D16bA;EACE,oCAAA;EACA,0BAAA;EACA,kBAAA;EACA,iBAAA;A5D66bF;;A4D36bA;EAGE,kBAAA;EAGA,aAAA;EAIA,sBAAA;EACA,cAAA;A5D86bF;;A4D56bA;EACE,4CAAA;A5D+6bF;;A4D76bA;EACE,gBAAA;A5Dg7bF;;A4D96bA;EACE,eAAA;A5Di7bF;;A4D/6bA;EACE,eAAA;A5Dk7bF;;A4Dh7bA;EAGE,cAAA;EAGA,aAAA;EAIA,sBAAA;EAGA,oBAAA;A5Dm7bF;;A4Dj7bA;EAGE,cAAA;EAGA,oBAAA;A5Do7bF;;A4Dj7bA;;EAIE,SAAA;EACA,kBAAA;EACA,uBAAA;EACA,gBAAA;EACA,gBAAA;EACA,qBAAA;EACA,uDAAA;EACA,YAAA;A5Do7bF;;A4Dl7bA;;EAEE,mBAAA;EACA,uBAAA;EACA,qBAAA;EACA,oBAAA;EACA,qBAAA;A5Dq7bF;;A4Dn7bA;EACE,qBAAA;EACA,kBAAA;EACA,SAAA;EACA,kBAAA;EACA,cAAA;A5Ds7bF;;A4Dp7bA;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,QAAA;EACA,SAAA;EAEA,+CAAA;EACA,qCAAA;EACA,sCAAA;EACA,wCAAA;EACA,4DAAA;EACA,eAAA;A5Du7bF;;A4Dr7bA;EAEE,0CAAA;A5Dw7bF;;A4Dt7bA;EACE,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,MAAA;EACA,SAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;A5Dy7bF;;A4Dv7bA;EAGE,cAAA;EAGA,aAAA;EAIA,sBAAA;EACA,0CAAA;A5D07bF;;A4Dx7bA;EACE,2CAAA;A5D27bF;;A4Dz7bA;EACE,eAAA;A5D47bF;;A4D17bA;EACE,+BAAA;A5D67bF;;A4D37bA;EACE,+BAAA;A5D87bF;;A4D57bA;EACE,UAAA;EAGA,aAAA;EAGA,8BAAA;EAGA,oBAAA;EAEA,eAAA;EACA,YAAA;A5D+7bF;;A4Dz7bA;;EAEE,yBAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,YAAA;EACA,yBAAA;EACA,kBAAA;A5D47bF;A4D37bE;;EACE,aAAA;EACA,sBAAA;EACA,WAAA;A5D87bJ;;A4D37bA;EAGE,gBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,SAAA;EACA,kBAAA;EACA,YAAA;EACA,cAAA;EACA,c3DpQ2B;E2DqQ3B,mB3DhXsB;E2DiXtB,yBAAA;EACA,eAAA;EACA,aAAA;A5D87bF;;A4D57bA;EACE,YAAA;EACA,mBAAA;A5D+7bF;;A4D77bA;EACE,yC3DhQ2B;E2DiQ3B,c3DhR2B;ADgtc7B;;A4D97bA;;EAIE,SAAA;EACA,kBAAA;A5Di8bF;;A4D/7bA;EAGE,WAAA;EACA,kBAAA;EACA,gBAAA;EAGA,aAAA;EAIA,mBAAA;EAEA,eAAA;EAGA,mBAAA;EAEA,6BAAA;A5Dk8bF;;A4Dh8bA;EACE,qBAAA;EACA,gBAAA;EACA,mBAAA;A5Dm8bF;;A4Dj8bA;EACE,qBAAA;A5Do8bF;;A4Dl8bA;EACE,gBAAA;A5Dq8bF;;A4Dn8bA;EACE,cAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EAEA,gCAAA;EACA,oCAAA;EACA,yBAAA;EACA,UAAA;EACA,oBAAA;EACA,aAAA;EACA,yBAAA;A5Ds8bF;;A4Dp8bA;EACE,cAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,MAAA;EACA,SAAA;EACA,oCAAA;EACA,yBAAA;EACA,WAAA;EACA,UAAA;EACA,oBAAA;A5Du8bF;;A4Dr8bA;EACE,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,WAAA;EACA,QAAA;EACA,OAAA;EACA,eAAA;EACA,yBAAA;EAEA,2BAAA;EACA,yDAAA;A5Dw8bF;;A4Dt8bA;EACE,UAAA;EACA,UAAA;EACA,mBAAA;A5Dy8bF;;A4Dv8bA;EAEE,0BAAA;A5D08bF;;A4Dx8bA;;EAEE,2BAAA;EACA,kBAAA;EACA,yBAAA;EAGA,iBAAA;A5D28bF;;A4Dx8bA;EACE,aAAA;A5D28bF;;A4Dz8bA;EACE,eAAA;EACA,yBAAA;EACA,cAAA;EACA,gBAAA;A5D48bF;;A4Dz8bA;EACE,qBAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,MAAA;EACA,0BAAA;EACA,kBAAA;A5D48bF;A4D18bE;EACE,eAAA;A5D48bJ;;A6Dp8cA;EACE,sBAAA;A7Du8cF;;A8Dx8cA;EACE,uBAAA;A9D28cF;A8D18cE;;;EAGE,+CAAA;EACA,uBAAA;EACA,UAAA;EACA,0BAAA;EACA,6BAAA;A9D48cJ;A8D38cI;;;EACE,kBAAA;EACA,mBAAA;A9D+8cN;A8D78cI;;;EACE,aAAA;A9Di9cN;;A+Dh+cA;EACE,iBAAA;EACA,iBAAA;A/Dm+cF;A+Dl+cE;;;EAGE,aAAA;EACA,mBAAA;A/Do+cJ;A+Dj+cI;EACE,eAAA;A/Dm+cN;;A+D99cA;EAGM;IACE,iBAAA;E/D+9cN;E+D79cI;IACE,QAAA;E/D+9cN;AACF;A+D19cA;EACE;;;;;;IAME,mBAAA;IACA,kBAAA;E/D49cF;AACF;AgElgdA;EACI,gCAAA;AhEogdJ;;AiEpgdE;EvDwFE,mBuDvFuB;EvD6FvB,8EAAA;EACA,0BAAA;AVg7cJ;AiE5gdE;EACE,WAAA;AjE8gdJ;AiE5gdE;EACE,iBAAA;AjE8gdJ;AiE5gdE;EACE,WAAA;EACA,QAAA;AjE8gdJ;;AiExgdI;EACE,kBAAA;AjE2gdN;AiExgdM;EACE,kBAAA;AjE0gdR;AiErgdI;EACE,iBAAA;EACA,wBAAA;AjEugdN;;AiElgdA;EACE,aAAA;EACA,oBAAA;EACA,QAAA;EACA,SAAA;AjEqgdF;;AiElgdA;EAEI;IACE,WAAA;IACA,YAAA;IACA,oBAAA;IACA,cAAA;IACA,UAAA;EjEogdJ;AACF;AiE//cE;EACE,iBAAA;EACA,yBhEmK0B;AD81c9B;;AiE5/cA;EACE,mBAAA;EACA,qEAAA;EACA,YAAA;AjE+/cF;;AkEhkdA;EACE,gBAAA;EACA,eAAA;EACA,UAAA;AlEmkdF;AkElkdE;EACE,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,iCAAA;EACA,QAAA;EACA,SAAA;EACA,uBAAA;AlEokdJ;AkElkdE;EACE,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,OAAA;EACA,MAAA;EACA,YAAA;EACA,gBAAA;AlEokdJ;AkElkdE;EACE,2BAAA;AlEokdJ;AkEjkdI;EACE,iBAAA;AlEmkdN;AkEjkdI;EACE,sBAAA;AlEmkdN;;AmEjmdA;EACE,sBAAA;EACA,gCAAA;EACA,gBAAA;EACA,gBAAA;EzDiCE,4BAAA;AVwkdJ;;AmErmdA;EACE,gCAAA;AnEwmdF;;AmErmdA;EACE,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,qBAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,yBAAA;EACA,qBAAA;EACA,sBAAA;EzDYE,4BAAA;AVimdJ;AmE1mdE;EACE,iBAAA;EACA,mBAAA;AnE4mdJ;AmE1mdI;EACE,UAAA;EACA,kBAAA;AnE4mdN;AmExmdE;EzDDE,4BAAA;EyDUA,clE1ByB;EkE2BzB,eAAA;EACA,eAAA;EACA,cAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,iBAAA;EACA,qBAAA;EACA,MAAA;EACA,WAAA;EACA,UAAA;AnEumdJ;AmE1ndI;EACE,gBAAA;EACA,kCAAA;EACA,gBAAA;AnE4ndN;AmEzmdE;EtChDG,qB5BVmB;E4BWnB,c5BXmB;ADuqdxB;AmEzmdE;EtCpDG,qB5BLmB;E4BMnB,c5BNmB;ADsqdxB;AmEzmdE;EtCxDG,qB5BPmB;E4BQnB,c5BRmB;AD4qdxB;AmEzmdE;EtC5DG,qB5BNmB;E4BOnB,c5BPmB;AD+qdxB;AmEzmdE;EtChEG,qB5BRmB;E4BSnB,c5BTmB;ADqrdxB;AmEvmdI;EtClEC,qB5BdmB;E4BenB,c5B4FwB;E4B3FxB,yB5BhBmB;AD4rdxB;AmEzmdI;EtCrEC,qB5BTmB;E4BUnB,c5B4FwB;E4B3FxB,yB5BXmB;AD4rdxB;AmE3mdI;EtCxEC,qB5BXmB;E4BYnB,c5B4FwB;E4B3FxB,yB5BbmB;ADmsdxB;AmE7mdI;EtC3EC,qB5BVmB;E4BWnB,c5B4FwB;E4B3FxB,yB5BZmB;ADusdxB;AmE/mdI;EtC9EC,qB5BZmB;E4BanB,c5B4FwB;E4B3FxB,yB5BdmB;AD8sdxB;AmEhndE;EAEE,clESyB;ADwmd7B;;AmE7mdA;EACE,eAAA;EACA,iBAAA;AnEgndF;;AmE9mdA;EACE,uBAAA;EACA,SAAA;EACA,WAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;EACA,YAAA;EACA,WAAA;AnEindF","sourcesContent":["/*!\n\n =========================================================\n * Light Bootstrap Dashboard - v2.0.1\n =========================================================\n\n * Product Page: http://www.creative-tim.com/product/light-bootstrap-dashboard\n * Copyright 2020 Creative Tim (http://www.creative-tim.com)\n * License (http://www.creative-tim.com/license)\n\n =========================================================\n\n * The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.\n\n */\n\n//2022-01-25 Added\n@import \"../../../node_modules/bootstrap/scss/vendor/rfs\";\n@import \"../../../node_modules/bootstrap/scss/functions\";\n//2022-01-25 End Added\n\n@import \"lbd/variables\";\n//2022-01-25 Added\n@import \"../../../node_modules/bootstrap/scss/mixins/border-radius\";\n@import \"../../../node_modules/bootstrap/scss/mixins/forms\";\n//2022-01-25 End Added\n@import \"lbd/mixins\";\n@import \"lbd/modals\";\n\n@import \"lbd/typography\";\n\n// Core CSS\n//2022-01-25 Added\n@import \"lbd/forms\";\n//2022-01-25 End Added\n@import \"lbd/misc\";\n@import \"lbd/sidebar-and-main-panel\";\n@import \"lbd/fixed-plugin\";\n@import \"lbd/modal\";\n\n@import \"lbd/buttons\";\n@import \"lbd/social-buttons\";\n@import \"lbd/inputs\";\n\n@import \"lbd/alerts\";\n@import \"lbd/tables\";\n\n@import \"lbd/checkbox-radio-switch\";\n@import \"lbd/navbars\";\n@import \"lbd/footers\";\n@import \"lbd/tags\";\n@import \"lbd/tabs-navs-pagination\";\n@import \"lbd/progress-bars\";\n@import \"lbd/sliders\";\n\n// Fancy Stuff\n@import \"lbd/dropdown\";\n@import \"lbd/cards\";\n@import \"lbd/chartist\";\n@import \"lbd/responsive\";\n@import \"lbd/bootstrap-switch\";\n\n// Nucleo Icons\n@import \"lbd/partial-nucleo-icons\";\n\n//plugins css\n@import \"lbd/plugins/animate\";\n@import \"lbd/plugins/sweetalert2\";\n\n@import \"lbd/plugins/jquery.jvectormap\";\n@import \"lbd/plugins/bootstrap-table\";\n@import \"lbd/plugins/datatables.net\";\n@import \"lbd/plugins/fullcalendar\";\n@import \"lbd/plugins/chartist\";\n@import \"lbd/plugins/perfect-scrollbar\";\n@import \"lbd/plugins/bootstrap-select\";\n@import \"lbd/plugins/datetime-picker\";\n@import \"lbd/plugins/nouislider\";\n\n// React Differences\n@import \"lbdpr/react-differences\";\n","// General Colors\n\n\n$color-azure:           #0084CA;\n$color-purple:          #9368E9;\n$color-red:             #D61F05;\n$color-green:           #7ABA09;\n$color-orange:          #FFE200;\n$color-blue:            #003380;\n$color-black:           #58595B;\n\n\n/*      light colors         */\n\n$light-blue:                 #CEEEFF;\n$light-azure:                #4CA8D9;\n$light-green:                #E9F3D7;\n$light-orange:               rgba($color-orange, .2);\n$light-red:                  rgba($color-red, .2);\n\n\n$default-color:              #888888 !default;\n\n$black-color:                #000000 !default;\n$black-hr:                   #222222 !default;\n\n$light-gray:                 #E3E3E3 !default;\n$medium-gray:                #A2A2A2 !default;\n$placeholder-gray:           #C3C3C3 !default;\n$medium-dark-gray:           #EAF0F4 !default;\n$dark-gray:                  #58595B !default;\n\n// Gradients colors\n\n$default-color-top:\t                #e6f6ff;\n$default-color-bottom:              #003380;\n\n$blue-color-top: \t\t            #4087ea;\n$blue-color-bottom: \t            #533ce1;\n\n$azure-color-top:   \t            #45c0fd;\n$azure-color-bottom:            \t#4091ff;\n\n$green-color-top: \t                #E9F3D7;\n$green-color-bottom: \t            #7ABA09;\n\n$orange-color-top: \t                #ffb33b;\n// $orange-color-bottom: \t            #ec1657;\n\n$red-color-top: \t                #ff3b30;\n$red-color-bottom: \t                #bb0502;\n\n$purple-color-top: \t                #df55e1;\n$purple-color-bottom: \t            #943bea;\n\n$pink-color-top: \t\t            #ff2a63;\n$pink-color-bottom: \t            #ff2e2e;\n\n$black-color-top:\t \t            #787878;\n$black-color-bottom: \t            #343434;\n\n\n$social-facebook: \t\t\t        #3b5998;\n$social-states-facebook: \t\t\tdarken(#3b5998, 10%) !default;\n$social-twitter: \t\t\t        #55acee;\n$social-states-twitter: \t\t\tdarken(#55acee, 10%) !default;\n$social-pinterest: \t\t\t        #cc2127;\n$social-states-pinterest: \t\t\tdarken(#cc2127, 10%) !default;\n$social-google: \t\t\t        #dd4b39;\n$social-states-google: \t\t\t    darken(#dd4b39, 10%) !default;\n$social-linkedin: \t\t\t        #0976b4;\n$social-states-linkedin: \t\t\tdarken(#0976b4, 10%) !default;\n$social-dribbble: \t\t\t        #ea4c89;\n$social-states-dribble: \t        darken(#ea4c89, 10%) !default;\n$social-github: \t\t\t        #000000;\n$social-states-github: \t\t        darken(#000000, 10%) !default;\n$social-youtube: \t\t\t        #e52d27;\n$social-states-youtube: \t        darken(#e52d27, 10%) !default;\n$social-stumbleupon: \t\t        #eb4924;\n$social-states-stumbleupon:\t        darken(#eb4924, 10%) !default;\n$social-reddit: \t\t\t        #ff4500;\n$social-states-reddit: \t\t        darken(#ff4500, 10%) !default;\n$social-tumblr: \t\t\t        #35465c;\n$social-states-tumblr: \t\t\t    darken(#35465c, 10%) !default;\n$social-behance: \t\t\t        #1769ff;\n$social-states-behance: \t        darken(#1769ff, 10%) !default;\n\n\n$filter-blue:         darken($color-blue, 10%);\n$filter-azure:        darken($color-azure, 10%);\n$filter-green:        darken($color-green, 10%);\n$filter-orange:       darken($color-orange, 10%);\n$filter-red:          darken($color-red, 10%);\n\n\n$white-navbar:              rgba(#FFFFFF, .96);\n$blue-navbar:               lighten($color-blue, 10%);\n$azure-navbar:              lighten($color-azure, 15%);\n$green-navbar:              lighten($color-green, 10%);\n$orange-navbar:             lighten($color-orange, 10%);\n$red-navbar:                lighten($color-red, 10%);\n\n//== Buttons\n//\n//## For each of Bootstrap's buttons, define text, background and border color.\n\n$none:                       0   !default;\n$border-thin:                1px !default;\n$border-thick:               2px !default;\n\n$white-color:                #FFFFFF !default;\n$white-bg:                   #FFFFFF !default;\n\n$smoke-bg:                   #F5F5F5 !default;\n\n$black-bg:                   rgba(30,30,30,.97) !default;\n\n$transparent-bg:             transparent !default;\n\n\n$default-bg:                 $default-color !default;\n$default-states-color:       darken($default-color, 6%) !default;\n\n$primary-color:              $color-azure !default;\n$primary-bg:                 $color-azure !default;\n$primary-states-color:       darken($color-azure, 5%) !default;\n\n$info-color:                 $color-blue !default;\n$info-bg:                    $color-blue !default;\n$info-states-color:          darken($color-blue, 6%) !default;\n\n$success-color:              $color-green !default;\n$success-bg:                 $color-green !default;\n$success-states-color:       darken($color-green, 5%) !default;\n\n$warning-color:              $color-orange !default;\n$warning-bg:                 $color-orange !default;\n$warning-states-color:       darken($color-orange, 7%) !default;\n\n\n$danger-color:               $color-red !default;\n$danger-bg:                  $color-red !default;\n$danger-states-color:        darken($color-red, 8%) !default;\n\n$link-disabled-color:        #666666 !default;\n\n//== Components\n//\n\n$padding-default-vertical:     10px !default;\n$padding-default-horizontal:   15px !default;\n\n\n$padding-base-vertical:         8px !default;\n$padding-base-horizontal:      16px !default;\n\n$padding-round-vertical:        8px !default;\n$padding-round-horizontal:     16px !default;\n\n$padding-simple-vertical:      9px !default;\n$padding-simple-horizontal:    16px !default;\n\n$padding-large-vertical:       14px !default;\n$padding-large-horizontal:     30px !default;\n\n$padding-small-vertical:        5px !default;\n$padding-small-horizontal:     10px !default;\n\n$padding-xs-vertical:           1px !default;\n$padding-xs-horizontal:         5px !default;\n\n$padding-label-vertical:        2px !default;\n$padding-label-horizontal:     12px !default;\n\n$margin-large-vertical:        30px !default;\n$margin-base-vertical:         15px !default;\n\n$margin-base:                  15px !default;\n\n$padding-zero:                   0px !default;\n\n$margin-bottom:                0 0 10px 0 !default;\n$border-radius-small:           3px !default;\n$border-radius-base:            4px !default;\n$border-radius-large:           6px !default;\n$border-radius-extreme:        10px !default;\n\n$border-radius-large-top:      $border-radius-large $border-radius-large 0 0 !default;\n$border-radius-large-bottom:   0 0 $border-radius-large $border-radius-large !default;\n\n$btn-round-radius:             30px !default;\n\n$height-base:                  40px !default;\n\n$font-size-base:               0.875rem !default;\n$font-size-xsmall:             0.60rem !default;\n$font-size-small:              0.75rem !default;\n$font-size-medium:             1rem !default;\n$font-size-large:              1.125rem !default;\n$font-size-large-navbar:       1.25rem !default;\n\n$font-size-h1:                 3.25rem !default;\n$font-size-h2:                 2.25rem !default;\n$font-size-h3:                 1.75rem !default;\n$font-size-h4:                 1.375rem !default;\n$font-size-h5:                 1.125rem !default;\n$font-size-h6:                 0.875rem !default;\n$font-paragraph:               1rem !default;\n$font-size-navbar:             1rem !default;\n$font-size-small:              0.75rem !default;\n\n$font-weight-light:          300 !default;\n$font-weight-normal:         400 !default;\n$font-weight-semi:           500 !default;\n$font-weight-bold:           600 !default;\n\n$line-height-general:          1.5 !default;\n$line-height:                 20px !default;\n$line-height-lg:              54px !default;\n\n$sidebar-width:               calc(100% - 260px) !default;\n\n\n$border-radius-top:        10px 10px 0 0 !default;\n$border-radius-bottom:     0 0 10px 10px !default;\n\n$dropdown-shadow:          1px 2px 3px rgba(0, 0, 0, 0.125);\n\n$general-transition-time:  300ms !default;\n\n$slow-transition-time:           370ms !default;\n$dropdown-coordinates:      29px -50px !default;\n\n$fast-transition-time:           150ms !default;\n$ultra-fast-transition-time:      60ms  !default;\n\n$select-coordinates:         50% -40px !default;\n\n$transition-linear:                                   linear !default;\n$transition-bezier:         cubic-bezier(0.34, 1.61, 0.7, 1) !default;\n$transition-ease:           ease 0s;\n$transition-ease-in:              ease-in !default;\n$transition-ease-out:             ease-out !default;\n\n\n$navbar-padding-a:               10px 15px;\n$navbar-margin-a:                10px  3px;\n\n$padding-social-a:               10px  5px;\n\n$navbar-margin-a-btn:            15px 3px;\n$navbar-margin-a-btn-round:      16px 3px;\n\n$navbar-padding-a-icons:         6px 15px;\n$navbar-margin-a-icons:          6px  3px;\n\n$navbar-padding-brand:           15px 15px;\n$navbar-margin-brand:             7px  0px;\n\n$navbar-margin-brand-icons:      12px auto;\n\n$navbar-margin-btn:              10px  3px;\n\n$height-icon:\t\t\t\t\t 64px !default;\n$width-icon:\t\t\t\t\t 64px !default;\n$padding-icon:\t\t\t\t\t 12px !default;\n$border-radius-icon:\t\t     15px !default;\n\n$size-icon: \t\t\t\t\t 64px;\n$size-icon-sm: \t\t\t\t\t 32px;\n\n$height-icon-sm:\t\t\t\t 32px;\n$width-icon-sm:\t\t\t\t\t 32px;\n$padding-icon-sm:\t\t\t     4px;\n$border-radius-icon-sm:\t\t\t 7px;\n\n$height-icon-message:\t\t\t 40px;\n$width-icon-message:\t\t\t 40px;\n\n$height-icon-message-sm: \t\t 20px;\n$width-icon-message-sm:\t\t\t 20px;\n\n\n\n$topbar-x:             topbar-x !default;\n$topbar-back:          topbar-back !default;\n$bottombar-x:          bottombar-x !default;\n$bottombar-back:       bottombar-back !default;\n\n//== Media queries breakpoints\n//\n//## Define the breakpoints at which your layout will change, adapting to different screen sizes.\n\n// Extra small screen / phone\n//** Deprecated `$screen-xs` as of v3.0.1\n$screen-xs:                  480px !default;\n//** Deprecated `$screen-xs-min` as of v3.2.0\n$screen-xs-min:              $screen-xs !default;\n//** Deprecated `$screen-phone` as of v3.0.1\n$screen-phone:               $screen-xs-min !default;\n\n// Small screen / tablet\n//** Deprecated `$screen-sm` as of v3.0.1\n$screen-sm:                  768px !default;\n$screen-sm-min:              $screen-sm !default;\n//** Deprecated `$screen-tablet` as of v3.0.1\n$screen-tablet:              $screen-sm-min !default;\n\n// Medium screen / desktop\n//** Deprecated `$screen-md` as of v3.0.1\n$screen-md:                  992px !default;\n$screen-md-min:              $screen-md !default;\n//** Deprecated `$screen-desktop` as of v3.0.1\n$screen-desktop:             $screen-md-min !default;\n\n// Large screen / wide desktop\n//** Deprecated `$screen-lg` as of v3.0.1\n$screen-lg:                  1200px !default;\n$screen-lg-min:              $screen-lg !default;\n//** Deprecated `$screen-lg-desktop` as of v3.0.1\n$screen-lg-desktop:          $screen-lg-min !default;\n\n// So media queries don't overlap when required, provide a maximum\n$screen-xs-max:              ($screen-sm-min - 1) !default;\n$screen-sm-max:              ($screen-md-min - 1) !default;\n$screen-md-max:              ($screen-lg-min - 1) !default;\n\n\n$navbar-padding-a:               10px 15px;\n$navbar-margin-a:                10px  3px;\n\n$padding-social-a:               10px  5px;\n\n$navbar-margin-a-btn:            15px 3px;\n$navbar-margin-a-btn-round:      16px 3px;\n\n$navbar-padding-a-icons:         6px 15px;\n$navbar-margin-a-icons:          6px  3px;\n\n$navbar-padding-brand:           15px 15px;\n$navbar-margin-brand:             5px  0px;\n\n$navbar-margin-brand-icons:      12px auto;\n\n$navbar-margin-btn:              15px  3px;\n\n$height-icon:\t\t\t\t\t 64px !default;\n$width-icon:\t\t\t\t\t 64px !default;\n$padding-icon:\t\t\t\t\t 12px !default;\n$border-radius-icon:\t\t     15px !default;\n\n$size-icon: \t\t\t\t\t 64px;\n$size-icon-sm: \t\t\t\t\t 32px;\n\n\n$height-icon-sm:\t\t\t\t 32px;\n$width-icon-sm:\t\t\t\t\t 32px;\n$padding-icon-sm:\t\t\t     4px;\n$border-radius-icon-sm:\t\t\t 7px;\n\n$height-icon-message:\t\t\t 40px;\n$width-icon-message:\t\t\t 40px;\n\n$height-icon-message-sm: \t\t 20px;\n$width-icon-message-sm:\t\t\t 20px;\n\n$default-color-top:             \t#e6f6ff !default;\n$default-color-bottom:              #003380 !default;\n\n$blue-color-top: \t\t            #4087ea;\n$blue-color-bottom: \t            #533ce1;\n\n$azure-color-top:   \t            #45c0fd;\n$azure-color-bottom:            \t#4091ff;\n\n$green-color-top: \t                #E9F3D7;\n$green-color-bottom: \t            #7ABA09;\n\n$orange-color-top: \t                #ffb33b;\n$orange-color-bottom: \t            #ff5221;\n\n$red-color-top: \t                #ff3b30;\n$red-color-bottom: \t                #bb0502;\n\n$purple-color-top: \t                #df55e1;\n$purple-color-bottom: \t            #943bea;\n\n$pink-color-top: \t\t            #ff2a63;\n$pink-color-bottom: \t            #ff2e2e;\n\n$black-color-top:\t \t            #787878;\n$black-color-bottom: \t            #343434;\n\n$social-facebook: \t\t\t#3b5998;\n$social-twitter: \t\t\t#55acee;\n$social-pinterest: \t\t\t#cc2127;\n$social-google: \t\t\t#dd4b39;\n$social-linkedin: \t\t\t#0976b4;\n$social-dribbble: \t\t\t#ea4c89;\n$social-github: \t\t\t#000000;\n$social-youtube: \t\t\t#e52d27;\n$social-stumbleupon: \t\t#eb4924;\n$social-reddit: \t\t\t#ff4500;\n$social-tumblr: \t\t\t#35465c;\n$social-behance: \t\t\t#1769ff;\n\n\n$filter-blue:         darken($primary-color, 10%);\n$filter-azure:        darken($info-color, 10%);\n$filter-green:        darken($success-color, 10%);\n$filter-orange:       darken($warning-color, 10%);\n$filter-red:          darken($danger-color, 10%);\n\n\n$new-blue:            #1DC7EA;\n$new-purple:          #9368E9;\n$new-red:             #D61F05;\n$new-green:           #7ABA09;\n$new-orange:          #FFE200;\n$new-dark-blue:       #1F77D0;\n$new-black:           #58595B;\n\n\n$topbar-x:             topbar-x !default;\n$topbar-back:          topbar-back !default;\n$bottombar-x:          bottombar-x !default;\n$bottombar-back:       bottombar-back !default;\n\n\n$white-navbar:              rgba(#FFFFFF, .96);\n$blue-navbar:               lighten($new-dark-blue, 10%);\n$azure-navbar:              lighten($new-blue, 15%);\n$green-navbar:              lighten($new-green, 10%);\n$orange-navbar:             lighten($new-orange, 10%);\n$red-navbar:                lighten($new-red, 10%);\n\n//2022-01-25 Added\n@import \"../../../../node_modules/bootstrap/scss/variables\";\n\n$text-muted:      $medium-dark-gray;\n// Form validation\n\n// scss-docs-start form-feedback-variables\n$form-feedback-margin-top:          $form-text-margin-top !default;\n$form-feedback-font-size:           $form-text-font-size !default;\n$form-feedback-font-style:          $form-text-font-style !default;\n$form-feedback-valid-color:         $success-color;\n$form-feedback-invalid-color:       $danger-color;\n\n$form-feedback-icon-valid-color:    $form-feedback-valid-color;\n$form-feedback-icon-valid:          url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'><path fill='#{$form-feedback-icon-valid-color}' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/></svg>\");\n$form-feedback-icon-invalid-color:  $form-feedback-invalid-color;\n$form-feedback-icon-invalid:        url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='#{$form-feedback-icon-invalid-color}'><circle cx='6' cy='6' r='4.5'/><path stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/><circle cx='6' cy='8.2' r='.6' fill='#{$form-feedback-icon-invalid-color}' stroke='none'/></svg>\");\n// scss-docs-end form-feedback-variables\n\n// scss-docs-start form-validation-states\n$form-validation-states: (\n        \"valid\": (\n                \"color\": $form-feedback-valid-color,\n                \"icon\": $form-feedback-icon-valid\n        ),\n        \"invalid\": (\n                \"color\": $form-feedback-invalid-color,\n                \"icon\": $form-feedback-icon-invalid\n        )\n);\n// scss-docs-end form-validation-states\n//2022-01-25 End Added\n\n\n","$prefixes: ('', '-moz-', '-webkit-', '-ms-') !default;\n\n@mixin circle-animation(){\n   @for $i from 0 to length($prefixes) {\n        @include circle-animation-details(nth($prefixes, $i + 1));\n   }  \n}\n\n@mixin circle-animation-details($name){\n    #{$name}animation-name: spin;\n    #{$name}animation-duration: 1250ms;\n    #{$name}animation-iteration-count: infinite;\n    #{$name}animation-timing-function: linear;\n\n}\n@keyframes spin {\n    from { transform:rotate(0deg); }\n    to { transform:rotate(360deg); }\n}\n\n@-webkit-keyframes spin {\n    from { -webkit-transform: rotate(0deg); }\n    to { -webkit-transform: rotate(360deg); }\n}\n\n@-moz-keyframes spin {\n    from { -moz-transform: rotate(0deg); }\n    to { -moz-transform: rotate(360deg); }\n}\n\n@-ms-keyframes spin {\n    from { -ms-transform: rotate(0deg); }\n    to { -ms-transform: rotate(360deg); }\n}",".modal{\n    &.show{\n        .modal-dialog{\n            -webkit-transform: translate(0, 30%);\n            -o-transform: translate(0, 30%);\n            transform: translate(0, 30%);\n        }\n    }\n    &.modal-mini{\n        .modal-dialog{\n            max-width: 255px;\n            margin: 0 auto;\n        }\n    }\n    .modal-content{\n        .modal-header{\n            border-bottom: none;\n            padding-top: 24px;\n            padding-right: 24px;\n            padding-bottom: 0;\n            padding-left: 24px;\n\n            .modal-profile{\n                width: 80px;\n                height: 80px;\n                border-radius: 50%;\n                text-align: center;\n                line-height: 5.7;\n                box-shadow: 0px 1px 20px 0px rgba(0, 0, 0, 0.3);\n\n                i{\n                    font-size: 32px;\n                    padding-top: 24px;\n                }\n            }\n        }\n\n        .modal-body{\n            padding-top: 24px;\n            padding-right: 24px;\n            padding-bottom: 16px;\n            padding-left: 24px;\n            line-height: 1.9;\n        }\n\n        .modal-body + .modal-footer{\n            padding-top: 0;\n        }\n\n        .modal-footer{\n            border-top: none;\n            padding-right: 24px;\n            padding-bottom: 16px;\n            padding-left: 24px;\n            -webkit-justify-content: space-between;\n            justify-content: space-between;\n\n            .btn{\n                margin: 0;\n                padding-left: 16px;\n                padding-right: 16px;\n                width: auto;\n\n                &:hover,\n                &focus{\n                    text-decoration: none;\n                }\n            }\n        }\n    }\n}\n","/*           Font Smoothing      */\nbody,\nh1, .h1,\nh2, .h2,\nh3, .h3,\nh4, .h4,\nh5, .h5,\nh6, .h6,\np,\n.navbar,\n.brand,\n.btn-simple,\n.alert,\na,\n.td-name,\ntd,\nbutton.close{\n    -moz-osx-font-smoothing: grayscale;\n    -webkit-font-smoothing: antialiased;\n    font-family: \"Roboto\",\"Helvetica Neue\",Arial,sans-serif;\n    font-weight: $font-weight-normal;\n}\n\nbutton.close{\n    font-size: $font-size-large;\n}\n\nh1, .h1, h2, .h2, h3, .h3, h4, .h4{\n    font-weight: $font-weight-light;\n    margin: $margin-large-vertical 0 $margin-base-vertical;\n}\n\nh1, .h1 {\n    font-size: $font-size-h1;\n}\nh2, .h2{\n    font-size: $font-size-h2;\n}\nh3, .h3{\n    font-size: $font-size-h3;\n    margin: 20px 0 10px;\n}\nh4, .h4{\n    font-size: $font-size-h4;\n    line-height: 30px;\n}\nh5, .h5 {\n    font-size: $font-size-h5;\n    margin-bottom: 15px;\n}\nh6, .h6{\n    font-size: $font-size-h6;\n    font-weight: $font-weight-bold;\n    text-transform: uppercase;\n}\np, .p{\n    font-size: $font-paragraph;\n    line-height: $line-height-general;\n}\n\nh1 small, h2 small, h3 small, h4 small, h5 small, h6 small, .h1 small, .h2 small, .h3 small, .h4 small, .h5 small, .h6 small, h1 .small, h2 .small, h3 .small, h4 .small, h5 .small, h6 .small, .h1 .small, .h2 .small, .h3 .small, .h4 .small, .h5 .small, .h6 .small {\n    color: $dark-gray;\n    font-weight: $font-weight-light;\n    line-height: $line-height-general;\n}\n\nh1 small, h2 small, h3 small, h1 .small, h2 .small, h3 .small {\n    font-size: 60%;\n}\n\nh1 .subtitle{\n    display: block;\n    margin: 0 0 $margin-large-vertical;\n}\n\n.text-muted{\n    color: #9A9A9A;\n}\n.text-primary, .text-primary:hover{\n    color: #1D62F0 !important;\n}\n.text-info, .text-info:hover{\n    color: $info-color !important;\n}\n.text-success, .text-success:hover{\n    color: $success-color !important;\n}\n.text-warning, .text-warning:hover{\n    color: $warning-color !important;\n}\n.text-danger, .text-danger:hover{\n    color: $danger-color !important;\n}\n\n.typo-line{\n    padding-left: 140px;\n    margin-bottom: 40px;\n    position: relative;\n\n    .category{\n        transform: translateY(-50%);\n        top: 50%;\n        left: 0px;\n        position: absolute;\n        font-size: 14px;\n        font-weight: 400;\n        color: #888888;\n        margin-bottom: 0px;\n    }\n}\n\nblockquote{\n    padding: 10px 20px;\n    margin: 0 0 20px;\n    font-size: 17.5px;\n    border-left: 5px solid #eee;\n}\n","// This mixin uses an `if()` technique to be compatible with Dart Sass\n// See https://github.com/sass/sass/issues/1873#issuecomment-152293725 for more details\n\n// scss-docs-start form-validation-mixins\n@mixin form-validation-state-selector($state) {\n  @if ($state == \"valid\" or $state == \"invalid\") {\n    .was-validated #{if(&, \"&\", \"\")}:#{$state},\n    #{if(&, \"&\", \"\")}.is-#{$state} {\n      @content;\n    }\n  } @else {\n    #{if(&, \"&\", \"\")}.is-#{$state} {\n      @content;\n    }\n  }\n}\n\n@mixin form-validation-state(\n  $state,\n  $color,\n  $icon,\n  $tooltip-color: color-contrast($color),\n  $tooltip-bg-color: rgba($color, $form-feedback-tooltip-opacity),\n  $focus-box-shadow: 0 0 $input-btn-focus-blur $input-focus-width rgba($color, $input-btn-focus-color-opacity),\n  $border-color: $color\n) {\n  .#{$state}-feedback {\n    display: none;\n    width: 100%;\n    margin-top: $form-feedback-margin-top;\n    @include font-size($form-feedback-font-size);\n    font-style: $form-feedback-font-style;\n    color: $color;\n  }\n\n  .#{$state}-tooltip {\n    position: absolute;\n    top: 100%;\n    z-index: 5;\n    display: none;\n    max-width: 100%; // Contain to parent when possible\n    padding: $form-feedback-tooltip-padding-y $form-feedback-tooltip-padding-x;\n    margin-top: .1rem;\n    @include font-size($form-feedback-tooltip-font-size);\n    line-height: $form-feedback-tooltip-line-height;\n    color: $tooltip-color;\n    background-color: $tooltip-bg-color;\n    @include border-radius($form-feedback-tooltip-border-radius);\n  }\n\n  @include form-validation-state-selector($state) {\n    ~ .#{$state}-feedback,\n    ~ .#{$state}-tooltip {\n      display: block;\n    }\n  }\n\n  .form-control {\n    @include form-validation-state-selector($state) {\n      border-color: $border-color;\n\n      @if $enable-validation-icons {\n        padding-right: $input-height-inner;\n        background-image: escape-svg($icon);\n        background-repeat: no-repeat;\n        background-position: right $input-height-inner-quarter center;\n        background-size: $input-height-inner-half $input-height-inner-half;\n      }\n\n      &:focus {\n        border-color: $border-color;\n        @if $enable-shadows {\n          @include box-shadow($input-box-shadow, $focus-box-shadow);\n        } @else {\n          // Avoid using mixin so we can pass custom focus shadow properly\n          box-shadow: $focus-box-shadow;\n        }\n      }\n    }\n  }\n\n  // stylelint-disable-next-line selector-no-qualifying-type\n  textarea.form-control {\n    @include form-validation-state-selector($state) {\n      @if $enable-validation-icons {\n        padding-right: $input-height-inner;\n        background-position: top $input-height-inner-quarter right $input-height-inner-quarter;\n      }\n    }\n  }\n\n  .form-select {\n    @include form-validation-state-selector($state) {\n      border-color: $border-color;\n\n      @if $enable-validation-icons {\n        &:not([multiple]):not([size]),\n        &:not([multiple])[size=\"1\"] {\n          --#{$prefix}form-select-bg-icon: #{escape-svg($icon)};\n          padding-right: $form-select-feedback-icon-padding-end;\n          background-position: $form-select-bg-position, $form-select-feedback-icon-position;\n          background-size: $form-select-bg-size, $form-select-feedback-icon-size;\n        }\n      }\n\n      &:focus {\n        border-color: $border-color;\n        @if $enable-shadows {\n          @include box-shadow($form-select-box-shadow, $focus-box-shadow);\n        } @else {\n          // Avoid using mixin so we can pass custom focus shadow properly\n          box-shadow: $focus-box-shadow;\n        }\n      }\n    }\n  }\n\n  .form-control-color {\n    @include form-validation-state-selector($state) {\n      @if $enable-validation-icons {\n        width: add($form-color-width, $input-height-inner);\n      }\n    }\n  }\n\n  .form-check-input {\n    @include form-validation-state-selector($state) {\n      border-color: $border-color;\n\n      &:checked {\n        background-color: $color;\n      }\n\n      &:focus {\n        box-shadow: $focus-box-shadow;\n      }\n\n      ~ .form-check-label {\n        color: $color;\n      }\n    }\n  }\n  .form-check-inline .form-check-input {\n    ~ .#{$state}-feedback {\n      margin-left: .5em;\n    }\n  }\n\n  .input-group {\n    > .form-control:not(:focus),\n    > .form-select:not(:focus),\n    > .form-floating:not(:focus-within) {\n      @include form-validation-state-selector($state) {\n        @if $state == \"valid\" {\n          z-index: 3;\n        } @else if $state == \"invalid\" {\n          z-index: 4;\n        }\n      }\n    }\n  }\n}\n// scss-docs-end form-validation-mixins\n","// Variables\n//\n// Variables should follow the `$component-state-property-size` formula for\n// consistent naming. Ex: $nav-link-disabled-color and $modal-content-box-shadow-xs.\n\n// Color system\n\n// scss-docs-start gray-color-variables\n$white:    #fff !default;\n$gray-100: #f8f9fa !default;\n$gray-200: #e9ecef !default;\n$gray-300: #dee2e6 !default;\n$gray-400: #ced4da !default;\n$gray-500: #adb5bd !default;\n$gray-600: #6c757d !default;\n$gray-700: #495057 !default;\n$gray-800: #343a40 !default;\n$gray-900: #212529 !default;\n$black:    #000 !default;\n// scss-docs-end gray-color-variables\n\n// fusv-disable\n// scss-docs-start gray-colors-map\n$grays: (\n  \"100\": $gray-100,\n  \"200\": $gray-200,\n  \"300\": $gray-300,\n  \"400\": $gray-400,\n  \"500\": $gray-500,\n  \"600\": $gray-600,\n  \"700\": $gray-700,\n  \"800\": $gray-800,\n  \"900\": $gray-900\n) !default;\n// scss-docs-end gray-colors-map\n// fusv-enable\n\n// scss-docs-start color-variables\n$blue:    #0d6efd !default;\n$indigo:  #6610f2 !default;\n$purple:  #6f42c1 !default;\n$pink:    #d63384 !default;\n$red:     #dc3545 !default;\n$orange:  #fd7e14 !default;\n$yellow:  #ffc107 !default;\n$green:   #198754 !default;\n$teal:    #20c997 !default;\n$cyan:    #0dcaf0 !default;\n// scss-docs-end color-variables\n\n// scss-docs-start colors-map\n$colors: (\n  \"blue\":       $blue,\n  \"indigo\":     $indigo,\n  \"purple\":     $purple,\n  \"pink\":       $pink,\n  \"red\":        $red,\n  \"orange\":     $orange,\n  \"yellow\":     $yellow,\n  \"green\":      $green,\n  \"teal\":       $teal,\n  \"cyan\":       $cyan,\n  \"black\":      $black,\n  \"white\":      $white,\n  \"gray\":       $gray-600,\n  \"gray-dark\":  $gray-800\n) !default;\n// scss-docs-end colors-map\n\n// The contrast ratio to reach against white, to determine if color changes from \"light\" to \"dark\". Acceptable values for WCAG 2.2 are 3, 4.5 and 7.\n// See https://www.w3.org/TR/WCAG/#contrast-minimum\n$min-contrast-ratio:   4.5 !default;\n\n// Customize the light and dark text colors for use in our color contrast function.\n$color-contrast-dark:      $black !default;\n$color-contrast-light:     $white !default;\n\n// fusv-disable\n$blue-100: tint-color($blue, 80%) !default;\n$blue-200: tint-color($blue, 60%) !default;\n$blue-300: tint-color($blue, 40%) !default;\n$blue-400: tint-color($blue, 20%) !default;\n$blue-500: $blue !default;\n$blue-600: shade-color($blue, 20%) !default;\n$blue-700: shade-color($blue, 40%) !default;\n$blue-800: shade-color($blue, 60%) !default;\n$blue-900: shade-color($blue, 80%) !default;\n\n$indigo-100: tint-color($indigo, 80%) !default;\n$indigo-200: tint-color($indigo, 60%) !default;\n$indigo-300: tint-color($indigo, 40%) !default;\n$indigo-400: tint-color($indigo, 20%) !default;\n$indigo-500: $indigo !default;\n$indigo-600: shade-color($indigo, 20%) !default;\n$indigo-700: shade-color($indigo, 40%) !default;\n$indigo-800: shade-color($indigo, 60%) !default;\n$indigo-900: shade-color($indigo, 80%) !default;\n\n$purple-100: tint-color($purple, 80%) !default;\n$purple-200: tint-color($purple, 60%) !default;\n$purple-300: tint-color($purple, 40%) !default;\n$purple-400: tint-color($purple, 20%) !default;\n$purple-500: $purple !default;\n$purple-600: shade-color($purple, 20%) !default;\n$purple-700: shade-color($purple, 40%) !default;\n$purple-800: shade-color($purple, 60%) !default;\n$purple-900: shade-color($purple, 80%) !default;\n\n$pink-100: tint-color($pink, 80%) !default;\n$pink-200: tint-color($pink, 60%) !default;\n$pink-300: tint-color($pink, 40%) !default;\n$pink-400: tint-color($pink, 20%) !default;\n$pink-500: $pink !default;\n$pink-600: shade-color($pink, 20%) !default;\n$pink-700: shade-color($pink, 40%) !default;\n$pink-800: shade-color($pink, 60%) !default;\n$pink-900: shade-color($pink, 80%) !default;\n\n$red-100: tint-color($red, 80%) !default;\n$red-200: tint-color($red, 60%) !default;\n$red-300: tint-color($red, 40%) !default;\n$red-400: tint-color($red, 20%) !default;\n$red-500: $red !default;\n$red-600: shade-color($red, 20%) !default;\n$red-700: shade-color($red, 40%) !default;\n$red-800: shade-color($red, 60%) !default;\n$red-900: shade-color($red, 80%) !default;\n\n$orange-100: tint-color($orange, 80%) !default;\n$orange-200: tint-color($orange, 60%) !default;\n$orange-300: tint-color($orange, 40%) !default;\n$orange-400: tint-color($orange, 20%) !default;\n$orange-500: $orange !default;\n$orange-600: shade-color($orange, 20%) !default;\n$orange-700: shade-color($orange, 40%) !default;\n$orange-800: shade-color($orange, 60%) !default;\n$orange-900: shade-color($orange, 80%) !default;\n\n$yellow-100: tint-color($yellow, 80%) !default;\n$yellow-200: tint-color($yellow, 60%) !default;\n$yellow-300: tint-color($yellow, 40%) !default;\n$yellow-400: tint-color($yellow, 20%) !default;\n$yellow-500: $yellow !default;\n$yellow-600: shade-color($yellow, 20%) !default;\n$yellow-700: shade-color($yellow, 40%) !default;\n$yellow-800: shade-color($yellow, 60%) !default;\n$yellow-900: shade-color($yellow, 80%) !default;\n\n$green-100: tint-color($green, 80%) !default;\n$green-200: tint-color($green, 60%) !default;\n$green-300: tint-color($green, 40%) !default;\n$green-400: tint-color($green, 20%) !default;\n$green-500: $green !default;\n$green-600: shade-color($green, 20%) !default;\n$green-700: shade-color($green, 40%) !default;\n$green-800: shade-color($green, 60%) !default;\n$green-900: shade-color($green, 80%) !default;\n\n$teal-100: tint-color($teal, 80%) !default;\n$teal-200: tint-color($teal, 60%) !default;\n$teal-300: tint-color($teal, 40%) !default;\n$teal-400: tint-color($teal, 20%) !default;\n$teal-500: $teal !default;\n$teal-600: shade-color($teal, 20%) !default;\n$teal-700: shade-color($teal, 40%) !default;\n$teal-800: shade-color($teal, 60%) !default;\n$teal-900: shade-color($teal, 80%) !default;\n\n$cyan-100: tint-color($cyan, 80%) !default;\n$cyan-200: tint-color($cyan, 60%) !default;\n$cyan-300: tint-color($cyan, 40%) !default;\n$cyan-400: tint-color($cyan, 20%) !default;\n$cyan-500: $cyan !default;\n$cyan-600: shade-color($cyan, 20%) !default;\n$cyan-700: shade-color($cyan, 40%) !default;\n$cyan-800: shade-color($cyan, 60%) !default;\n$cyan-900: shade-color($cyan, 80%) !default;\n\n$blues: (\n  \"blue-100\": $blue-100,\n  \"blue-200\": $blue-200,\n  \"blue-300\": $blue-300,\n  \"blue-400\": $blue-400,\n  \"blue-500\": $blue-500,\n  \"blue-600\": $blue-600,\n  \"blue-700\": $blue-700,\n  \"blue-800\": $blue-800,\n  \"blue-900\": $blue-900\n) !default;\n\n$indigos: (\n  \"indigo-100\": $indigo-100,\n  \"indigo-200\": $indigo-200,\n  \"indigo-300\": $indigo-300,\n  \"indigo-400\": $indigo-400,\n  \"indigo-500\": $indigo-500,\n  \"indigo-600\": $indigo-600,\n  \"indigo-700\": $indigo-700,\n  \"indigo-800\": $indigo-800,\n  \"indigo-900\": $indigo-900\n) !default;\n\n$purples: (\n  \"purple-100\": $purple-100,\n  \"purple-200\": $purple-200,\n  \"purple-300\": $purple-300,\n  \"purple-400\": $purple-400,\n  \"purple-500\": $purple-500,\n  \"purple-600\": $purple-600,\n  \"purple-700\": $purple-700,\n  \"purple-800\": $purple-800,\n  \"purple-900\": $purple-900\n) !default;\n\n$pinks: (\n  \"pink-100\": $pink-100,\n  \"pink-200\": $pink-200,\n  \"pink-300\": $pink-300,\n  \"pink-400\": $pink-400,\n  \"pink-500\": $pink-500,\n  \"pink-600\": $pink-600,\n  \"pink-700\": $pink-700,\n  \"pink-800\": $pink-800,\n  \"pink-900\": $pink-900\n) !default;\n\n$reds: (\n  \"red-100\": $red-100,\n  \"red-200\": $red-200,\n  \"red-300\": $red-300,\n  \"red-400\": $red-400,\n  \"red-500\": $red-500,\n  \"red-600\": $red-600,\n  \"red-700\": $red-700,\n  \"red-800\": $red-800,\n  \"red-900\": $red-900\n) !default;\n\n$oranges: (\n  \"orange-100\": $orange-100,\n  \"orange-200\": $orange-200,\n  \"orange-300\": $orange-300,\n  \"orange-400\": $orange-400,\n  \"orange-500\": $orange-500,\n  \"orange-600\": $orange-600,\n  \"orange-700\": $orange-700,\n  \"orange-800\": $orange-800,\n  \"orange-900\": $orange-900\n) !default;\n\n$yellows: (\n  \"yellow-100\": $yellow-100,\n  \"yellow-200\": $yellow-200,\n  \"yellow-300\": $yellow-300,\n  \"yellow-400\": $yellow-400,\n  \"yellow-500\": $yellow-500,\n  \"yellow-600\": $yellow-600,\n  \"yellow-700\": $yellow-700,\n  \"yellow-800\": $yellow-800,\n  \"yellow-900\": $yellow-900\n) !default;\n\n$greens: (\n  \"green-100\": $green-100,\n  \"green-200\": $green-200,\n  \"green-300\": $green-300,\n  \"green-400\": $green-400,\n  \"green-500\": $green-500,\n  \"green-600\": $green-600,\n  \"green-700\": $green-700,\n  \"green-800\": $green-800,\n  \"green-900\": $green-900\n) !default;\n\n$teals: (\n  \"teal-100\": $teal-100,\n  \"teal-200\": $teal-200,\n  \"teal-300\": $teal-300,\n  \"teal-400\": $teal-400,\n  \"teal-500\": $teal-500,\n  \"teal-600\": $teal-600,\n  \"teal-700\": $teal-700,\n  \"teal-800\": $teal-800,\n  \"teal-900\": $teal-900\n) !default;\n\n$cyans: (\n  \"cyan-100\": $cyan-100,\n  \"cyan-200\": $cyan-200,\n  \"cyan-300\": $cyan-300,\n  \"cyan-400\": $cyan-400,\n  \"cyan-500\": $cyan-500,\n  \"cyan-600\": $cyan-600,\n  \"cyan-700\": $cyan-700,\n  \"cyan-800\": $cyan-800,\n  \"cyan-900\": $cyan-900\n) !default;\n// fusv-enable\n\n// scss-docs-start theme-color-variables\n$primary:       $blue !default;\n$secondary:     $gray-600 !default;\n$success:       $green !default;\n$info:          $cyan !default;\n$warning:       $yellow !default;\n$danger:        $red !default;\n$light:         $gray-100 !default;\n$dark:          $gray-900 !default;\n// scss-docs-end theme-color-variables\n\n// scss-docs-start theme-colors-map\n$theme-colors: (\n  \"primary\":    $primary,\n  \"secondary\":  $secondary,\n  \"success\":    $success,\n  \"info\":       $info,\n  \"warning\":    $warning,\n  \"danger\":     $danger,\n  \"light\":      $light,\n  \"dark\":       $dark\n) !default;\n// scss-docs-end theme-colors-map\n\n// scss-docs-start theme-text-variables\n$primary-text-emphasis:   shade-color($primary, 60%) !default;\n$secondary-text-emphasis: shade-color($secondary, 60%) !default;\n$success-text-emphasis:   shade-color($success, 60%) !default;\n$info-text-emphasis:      shade-color($info, 60%) !default;\n$warning-text-emphasis:   shade-color($warning, 60%) !default;\n$danger-text-emphasis:    shade-color($danger, 60%) !default;\n$light-text-emphasis:     $gray-700 !default;\n$dark-text-emphasis:      $gray-700 !default;\n// scss-docs-end theme-text-variables\n\n// scss-docs-start theme-bg-subtle-variables\n$primary-bg-subtle:       tint-color($primary, 80%) !default;\n$secondary-bg-subtle:     tint-color($secondary, 80%) !default;\n$success-bg-subtle:       tint-color($success, 80%) !default;\n$info-bg-subtle:          tint-color($info, 80%) !default;\n$warning-bg-subtle:       tint-color($warning, 80%) !default;\n$danger-bg-subtle:        tint-color($danger, 80%) !default;\n$light-bg-subtle:         mix($gray-100, $white) !default;\n$dark-bg-subtle:          $gray-400 !default;\n// scss-docs-end theme-bg-subtle-variables\n\n// scss-docs-start theme-border-subtle-variables\n$primary-border-subtle:   tint-color($primary, 60%) !default;\n$secondary-border-subtle: tint-color($secondary, 60%) !default;\n$success-border-subtle:   tint-color($success, 60%) !default;\n$info-border-subtle:      tint-color($info, 60%) !default;\n$warning-border-subtle:   tint-color($warning, 60%) !default;\n$danger-border-subtle:    tint-color($danger, 60%) !default;\n$light-border-subtle:     $gray-200 !default;\n$dark-border-subtle:      $gray-500 !default;\n// scss-docs-end theme-border-subtle-variables\n\n// Characters which are escaped by the escape-svg function\n$escaped-characters: (\n  (\"<\", \"%3c\"),\n  (\">\", \"%3e\"),\n  (\"#\", \"%23\"),\n  (\"(\", \"%28\"),\n  (\")\", \"%29\"),\n) !default;\n\n// Options\n//\n// Quickly modify global styling by enabling or disabling optional features.\n\n$enable-caret:                true !default;\n$enable-rounded:              true !default;\n$enable-shadows:              false !default;\n$enable-gradients:            false !default;\n$enable-transitions:          true !default;\n$enable-reduced-motion:       true !default;\n$enable-smooth-scroll:        true !default;\n$enable-grid-classes:         true !default;\n$enable-container-classes:    true !default;\n$enable-cssgrid:              false !default;\n$enable-button-pointers:      true !default;\n$enable-rfs:                  true !default;\n$enable-validation-icons:     true !default;\n$enable-negative-margins:     false !default;\n$enable-deprecation-messages: true !default;\n$enable-important-utilities:  true !default;\n\n$enable-dark-mode:            true !default;\n$color-mode-type:             data !default; // `data` or `media-query`\n\n// Prefix for :root CSS variables\n\n$variable-prefix:             bs- !default; // Deprecated in v5.2.0 for the shorter `$prefix`\n$prefix:                      $variable-prefix !default;\n\n// Gradient\n//\n// The gradient which is added to components if `$enable-gradients` is `true`\n// This gradient is also added to elements with `.bg-gradient`\n// scss-docs-start variable-gradient\n$gradient: linear-gradient(180deg, rgba($white, .15), rgba($white, 0)) !default;\n// scss-docs-end variable-gradient\n\n// Spacing\n//\n// Control the default styling of most Bootstrap elements by modifying these\n// variables. Mostly focused on spacing.\n// You can add more entries to the $spacers map, should you need more variation.\n\n// scss-docs-start spacer-variables-maps\n$spacer: 1rem !default;\n$spacers: (\n  0: 0,\n  1: $spacer * .25,\n  2: $spacer * .5,\n  3: $spacer,\n  4: $spacer * 1.5,\n  5: $spacer * 3,\n) !default;\n// scss-docs-end spacer-variables-maps\n\n// Position\n//\n// Define the edge positioning anchors of the position utilities.\n\n// scss-docs-start position-map\n$position-values: (\n  0: 0,\n  50: 50%,\n  100: 100%\n) !default;\n// scss-docs-end position-map\n\n// Body\n//\n// Settings for the `<body>` element.\n\n$body-text-align:           null !default;\n$body-color:                $gray-900 !default;\n$body-bg:                   $white !default;\n\n$body-secondary-color:      rgba($body-color, .75) !default;\n$body-secondary-bg:         $gray-200 !default;\n\n$body-tertiary-color:       rgba($body-color, .5) !default;\n$body-tertiary-bg:          $gray-100 !default;\n\n$body-emphasis-color:       $black !default;\n\n// Links\n//\n// Style anchor elements.\n\n$link-color:                              $primary !default;\n$link-decoration:                         underline !default;\n$link-shade-percentage:                   20% !default;\n$link-hover-color:                        shift-color($link-color, $link-shade-percentage) !default;\n$link-hover-decoration:                   null !default;\n\n$stretched-link-pseudo-element:           after !default;\n$stretched-link-z-index:                  1 !default;\n\n// Icon links\n// scss-docs-start icon-link-variables\n$icon-link-gap:               .375rem !default;\n$icon-link-underline-offset:  .25em !default;\n$icon-link-icon-size:         1em !default;\n$icon-link-icon-transition:   .2s ease-in-out transform !default;\n$icon-link-icon-transform:    translate3d(.25em, 0, 0) !default;\n// scss-docs-end icon-link-variables\n\n// Paragraphs\n//\n// Style p element.\n\n$paragraph-margin-bottom:   1rem !default;\n\n\n// Grid breakpoints\n//\n// Define the minimum dimensions at which your layout will change,\n// adapting to different screen sizes, for use in media queries.\n\n// scss-docs-start grid-breakpoints\n$grid-breakpoints: (\n  xs: 0,\n  sm: 576px,\n  md: 768px,\n  lg: 992px,\n  xl: 1200px,\n  xxl: 1400px\n) !default;\n// scss-docs-end grid-breakpoints\n\n@include _assert-ascending($grid-breakpoints, \"$grid-breakpoints\");\n@include _assert-starts-at-zero($grid-breakpoints, \"$grid-breakpoints\");\n\n\n// Grid containers\n//\n// Define the maximum width of `.container` for different screen sizes.\n\n// scss-docs-start container-max-widths\n$container-max-widths: (\n  sm: 540px,\n  md: 720px,\n  lg: 960px,\n  xl: 1140px,\n  xxl: 1320px\n) !default;\n// scss-docs-end container-max-widths\n\n@include _assert-ascending($container-max-widths, \"$container-max-widths\");\n\n\n// Grid columns\n//\n// Set the number of columns and specify the width of the gutters.\n\n$grid-columns:                12 !default;\n$grid-gutter-width:           1.5rem !default;\n$grid-row-columns:            6 !default;\n\n// Container padding\n\n$container-padding-x: $grid-gutter-width !default;\n\n\n// Components\n//\n// Define common padding and border radius sizes and more.\n\n// scss-docs-start border-variables\n$border-width:                1px !default;\n$border-widths: (\n  1: 1px,\n  2: 2px,\n  3: 3px,\n  4: 4px,\n  5: 5px\n) !default;\n$border-style:                solid !default;\n$border-color:                $gray-300 !default;\n$border-color-translucent:    rgba($black, .175) !default;\n// scss-docs-end border-variables\n\n// scss-docs-start border-radius-variables\n$border-radius:               .375rem !default;\n$border-radius-sm:            .25rem !default;\n$border-radius-lg:            .5rem !default;\n$border-radius-xl:            1rem !default;\n$border-radius-xxl:           2rem !default;\n$border-radius-pill:          50rem !default;\n// scss-docs-end border-radius-variables\n// fusv-disable\n$border-radius-2xl:           $border-radius-xxl !default; // Deprecated in v5.3.0\n// fusv-enable\n\n// scss-docs-start box-shadow-variables\n$box-shadow:                  0 .5rem 1rem rgba($black, .15) !default;\n$box-shadow-sm:               0 .125rem .25rem rgba($black, .075) !default;\n$box-shadow-lg:               0 1rem 3rem rgba($black, .175) !default;\n$box-shadow-inset:            inset 0 1px 2px rgba($black, .075) !default;\n// scss-docs-end box-shadow-variables\n\n$component-active-color:      $white !default;\n$component-active-bg:         $primary !default;\n\n// scss-docs-start focus-ring-variables\n$focus-ring-width:      .25rem !default;\n$focus-ring-opacity:    .25 !default;\n$focus-ring-color:      rgba($primary, $focus-ring-opacity) !default;\n$focus-ring-blur:       0 !default;\n$focus-ring-box-shadow: 0 0 $focus-ring-blur $focus-ring-width $focus-ring-color !default;\n// scss-docs-end focus-ring-variables\n\n// scss-docs-start caret-variables\n$caret-width:                 .3em !default;\n$caret-vertical-align:        $caret-width * .85 !default;\n$caret-spacing:               $caret-width * .85 !default;\n// scss-docs-end caret-variables\n\n$transition-base:             all .2s ease-in-out !default;\n$transition-fade:             opacity .15s linear !default;\n// scss-docs-start collapse-transition\n$transition-collapse:         height .35s ease !default;\n$transition-collapse-width:   width .35s ease !default;\n// scss-docs-end collapse-transition\n\n// stylelint-disable function-disallowed-list\n// scss-docs-start aspect-ratios\n$aspect-ratios: (\n  \"1x1\": 100%,\n  \"4x3\": calc(3 / 4 * 100%),\n  \"16x9\": calc(9 / 16 * 100%),\n  \"21x9\": calc(9 / 21 * 100%)\n) !default;\n// scss-docs-end aspect-ratios\n// stylelint-enable function-disallowed-list\n\n// Typography\n//\n// Font, line-height, and color for body text, headings, and more.\n\n// scss-docs-start font-variables\n// stylelint-disable value-keyword-case\n$font-family-sans-serif:      system-ui, -apple-system, \"Segoe UI\", Roboto, \"Helvetica Neue\", \"Noto Sans\", \"Liberation Sans\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\" !default;\n$font-family-monospace:       SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace !default;\n// stylelint-enable value-keyword-case\n$font-family-base:            var(--#{$prefix}font-sans-serif) !default;\n$font-family-code:            var(--#{$prefix}font-monospace) !default;\n\n// $font-size-root affects the value of `rem`, which is used for as well font sizes, paddings, and margins\n// $font-size-base affects the font size of the body text\n$font-size-root:              null !default;\n$font-size-base:              1rem !default; // Assumes the browser default, typically `16px`\n$font-size-sm:                $font-size-base * .875 !default;\n$font-size-lg:                $font-size-base * 1.25 !default;\n\n$font-weight-lighter:         lighter !default;\n$font-weight-light:           300 !default;\n$font-weight-normal:          400 !default;\n$font-weight-medium:          500 !default;\n$font-weight-semibold:        600 !default;\n$font-weight-bold:            700 !default;\n$font-weight-bolder:          bolder !default;\n\n$font-weight-base:            $font-weight-normal !default;\n\n$line-height-base:            1.5 !default;\n$line-height-sm:              1.25 !default;\n$line-height-lg:              2 !default;\n\n$h1-font-size:                $font-size-base * 2.5 !default;\n$h2-font-size:                $font-size-base * 2 !default;\n$h3-font-size:                $font-size-base * 1.75 !default;\n$h4-font-size:                $font-size-base * 1.5 !default;\n$h5-font-size:                $font-size-base * 1.25 !default;\n$h6-font-size:                $font-size-base !default;\n// scss-docs-end font-variables\n\n// scss-docs-start font-sizes\n$font-sizes: (\n  1: $h1-font-size,\n  2: $h2-font-size,\n  3: $h3-font-size,\n  4: $h4-font-size,\n  5: $h5-font-size,\n  6: $h6-font-size\n) !default;\n// scss-docs-end font-sizes\n\n// scss-docs-start headings-variables\n$headings-margin-bottom:      $spacer * .5 !default;\n$headings-font-family:        null !default;\n$headings-font-style:         null !default;\n$headings-font-weight:        500 !default;\n$headings-line-height:        1.2 !default;\n$headings-color:              inherit !default;\n// scss-docs-end headings-variables\n\n// scss-docs-start display-headings\n$display-font-sizes: (\n  1: 5rem,\n  2: 4.5rem,\n  3: 4rem,\n  4: 3.5rem,\n  5: 3rem,\n  6: 2.5rem\n) !default;\n\n$display-font-family: null !default;\n$display-font-style:  null !default;\n$display-font-weight: 300 !default;\n$display-line-height: $headings-line-height !default;\n// scss-docs-end display-headings\n\n// scss-docs-start type-variables\n$lead-font-size:              $font-size-base * 1.25 !default;\n$lead-font-weight:            300 !default;\n\n$small-font-size:             .875em !default;\n\n$sub-sup-font-size:           .75em !default;\n\n// fusv-disable\n$text-muted:                  var(--#{$prefix}secondary-color) !default; // Deprecated in 5.3.0\n// fusv-enable\n\n$initialism-font-size:        $small-font-size !default;\n\n$blockquote-margin-y:         $spacer !default;\n$blockquote-font-size:        $font-size-base * 1.25 !default;\n$blockquote-footer-color:     $gray-600 !default;\n$blockquote-footer-font-size: $small-font-size !default;\n\n$hr-margin-y:                 $spacer !default;\n$hr-color:                    inherit !default;\n\n// fusv-disable\n$hr-bg-color:                 null !default; // Deprecated in v5.2.0\n$hr-height:                   null !default; // Deprecated in v5.2.0\n// fusv-enable\n\n$hr-border-color:             null !default; // Allows for inherited colors\n$hr-border-width:             var(--#{$prefix}border-width) !default;\n$hr-opacity:                  .25 !default;\n\n// scss-docs-start vr-variables\n$vr-border-width:             var(--#{$prefix}border-width) !default;\n// scss-docs-end vr-variables\n\n$legend-margin-bottom:        .5rem !default;\n$legend-font-size:            1.5rem !default;\n$legend-font-weight:          null !default;\n\n$dt-font-weight:              $font-weight-bold !default;\n\n$list-inline-padding:         .5rem !default;\n\n$mark-padding:                .1875em !default;\n$mark-color:                  $body-color !default;\n$mark-bg:                     $yellow-100 !default;\n// scss-docs-end type-variables\n\n\n// Tables\n//\n// Customizes the `.table` component with basic values, each used across all table variations.\n\n// scss-docs-start table-variables\n$table-cell-padding-y:        .5rem !default;\n$table-cell-padding-x:        .5rem !default;\n$table-cell-padding-y-sm:     .25rem !default;\n$table-cell-padding-x-sm:     .25rem !default;\n\n$table-cell-vertical-align:   top !default;\n\n$table-color:                 var(--#{$prefix}emphasis-color) !default;\n$table-bg:                    var(--#{$prefix}body-bg) !default;\n$table-accent-bg:             transparent !default;\n\n$table-th-font-weight:        null !default;\n\n$table-striped-color:         $table-color !default;\n$table-striped-bg-factor:     .05 !default;\n$table-striped-bg:            rgba(var(--#{$prefix}emphasis-color-rgb), $table-striped-bg-factor) !default;\n\n$table-active-color:          $table-color !default;\n$table-active-bg-factor:      .1 !default;\n$table-active-bg:             rgba(var(--#{$prefix}emphasis-color-rgb), $table-active-bg-factor) !default;\n\n$table-hover-color:           $table-color !default;\n$table-hover-bg-factor:       .075 !default;\n$table-hover-bg:              rgba(var(--#{$prefix}emphasis-color-rgb), $table-hover-bg-factor) !default;\n\n$table-border-factor:         .2 !default;\n$table-border-width:          var(--#{$prefix}border-width) !default;\n$table-border-color:          var(--#{$prefix}border-color) !default;\n\n$table-striped-order:         odd !default;\n$table-striped-columns-order: even !default;\n\n$table-group-separator-color: currentcolor !default;\n\n$table-caption-color:         var(--#{$prefix}secondary-color) !default;\n\n$table-bg-scale:              -80% !default;\n// scss-docs-end table-variables\n\n// scss-docs-start table-loop\n$table-variants: (\n  \"primary\":    shift-color($primary, $table-bg-scale),\n  \"secondary\":  shift-color($secondary, $table-bg-scale),\n  \"success\":    shift-color($success, $table-bg-scale),\n  \"info\":       shift-color($info, $table-bg-scale),\n  \"warning\":    shift-color($warning, $table-bg-scale),\n  \"danger\":     shift-color($danger, $table-bg-scale),\n  \"light\":      $light,\n  \"dark\":       $dark,\n) !default;\n// scss-docs-end table-loop\n\n\n// Buttons + Forms\n//\n// Shared variables that are reassigned to `$input-` and `$btn-` specific variables.\n\n// scss-docs-start input-btn-variables\n$input-btn-padding-y:         .375rem !default;\n$input-btn-padding-x:         .75rem !default;\n$input-btn-font-family:       null !default;\n$input-btn-font-size:         $font-size-base !default;\n$input-btn-line-height:       $line-height-base !default;\n\n$input-btn-focus-width:         $focus-ring-width !default;\n$input-btn-focus-color-opacity: $focus-ring-opacity !default;\n$input-btn-focus-color:         $focus-ring-color !default;\n$input-btn-focus-blur:          $focus-ring-blur !default;\n$input-btn-focus-box-shadow:    $focus-ring-box-shadow !default;\n\n$input-btn-padding-y-sm:      .25rem !default;\n$input-btn-padding-x-sm:      .5rem !default;\n$input-btn-font-size-sm:      $font-size-sm !default;\n\n$input-btn-padding-y-lg:      .5rem !default;\n$input-btn-padding-x-lg:      1rem !default;\n$input-btn-font-size-lg:      $font-size-lg !default;\n\n$input-btn-border-width:      var(--#{$prefix}border-width) !default;\n// scss-docs-end input-btn-variables\n\n\n// Buttons\n//\n// For each of Bootstrap's buttons, define text, background, and border color.\n\n// scss-docs-start btn-variables\n$btn-color:                   var(--#{$prefix}body-color) !default;\n$btn-padding-y:               $input-btn-padding-y !default;\n$btn-padding-x:               $input-btn-padding-x !default;\n$btn-font-family:             $input-btn-font-family !default;\n$btn-font-size:               $input-btn-font-size !default;\n$btn-line-height:             $input-btn-line-height !default;\n$btn-white-space:             null !default; // Set to `nowrap` to prevent text wrapping\n\n$btn-padding-y-sm:            $input-btn-padding-y-sm !default;\n$btn-padding-x-sm:            $input-btn-padding-x-sm !default;\n$btn-font-size-sm:            $input-btn-font-size-sm !default;\n\n$btn-padding-y-lg:            $input-btn-padding-y-lg !default;\n$btn-padding-x-lg:            $input-btn-padding-x-lg !default;\n$btn-font-size-lg:            $input-btn-font-size-lg !default;\n\n$btn-border-width:            $input-btn-border-width !default;\n\n$btn-font-weight:             $font-weight-normal !default;\n$btn-box-shadow:              inset 0 1px 0 rgba($white, .15), 0 1px 1px rgba($black, .075) !default;\n$btn-focus-width:             $input-btn-focus-width !default;\n$btn-focus-box-shadow:        $input-btn-focus-box-shadow !default;\n$btn-disabled-opacity:        .65 !default;\n$btn-active-box-shadow:       inset 0 3px 5px rgba($black, .125) !default;\n\n$btn-link-color:              var(--#{$prefix}link-color) !default;\n$btn-link-hover-color:        var(--#{$prefix}link-hover-color) !default;\n$btn-link-disabled-color:     $gray-600 !default;\n$btn-link-focus-shadow-rgb:   to-rgb(mix(color-contrast($link-color), $link-color, 15%)) !default;\n\n// Allows for customizing button radius independently from global border radius\n$btn-border-radius:           var(--#{$prefix}border-radius) !default;\n$btn-border-radius-sm:        var(--#{$prefix}border-radius-sm) !default;\n$btn-border-radius-lg:        var(--#{$prefix}border-radius-lg) !default;\n\n$btn-transition:              color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$btn-hover-bg-shade-amount:       15% !default;\n$btn-hover-bg-tint-amount:        15% !default;\n$btn-hover-border-shade-amount:   20% !default;\n$btn-hover-border-tint-amount:    10% !default;\n$btn-active-bg-shade-amount:      20% !default;\n$btn-active-bg-tint-amount:       20% !default;\n$btn-active-border-shade-amount:  25% !default;\n$btn-active-border-tint-amount:   10% !default;\n// scss-docs-end btn-variables\n\n\n// Forms\n\n// scss-docs-start form-text-variables\n$form-text-margin-top:                  .25rem !default;\n$form-text-font-size:                   $small-font-size !default;\n$form-text-font-style:                  null !default;\n$form-text-font-weight:                 null !default;\n$form-text-color:                       var(--#{$prefix}secondary-color) !default;\n// scss-docs-end form-text-variables\n\n// scss-docs-start form-label-variables\n$form-label-margin-bottom:              .5rem !default;\n$form-label-font-size:                  null !default;\n$form-label-font-style:                 null !default;\n$form-label-font-weight:                null !default;\n$form-label-color:                      null !default;\n// scss-docs-end form-label-variables\n\n// scss-docs-start form-input-variables\n$input-padding-y:                       $input-btn-padding-y !default;\n$input-padding-x:                       $input-btn-padding-x !default;\n$input-font-family:                     $input-btn-font-family !default;\n$input-font-size:                       $input-btn-font-size !default;\n$input-font-weight:                     $font-weight-base !default;\n$input-line-height:                     $input-btn-line-height !default;\n\n$input-padding-y-sm:                    $input-btn-padding-y-sm !default;\n$input-padding-x-sm:                    $input-btn-padding-x-sm !default;\n$input-font-size-sm:                    $input-btn-font-size-sm !default;\n\n$input-padding-y-lg:                    $input-btn-padding-y-lg !default;\n$input-padding-x-lg:                    $input-btn-padding-x-lg !default;\n$input-font-size-lg:                    $input-btn-font-size-lg !default;\n\n$input-bg:                              var(--#{$prefix}body-bg) !default;\n$input-disabled-color:                  null !default;\n$input-disabled-bg:                     var(--#{$prefix}secondary-bg) !default;\n$input-disabled-border-color:           null !default;\n\n$input-color:                           var(--#{$prefix}body-color) !default;\n$input-border-color:                    var(--#{$prefix}border-color) !default;\n$input-border-width:                    $input-btn-border-width !default;\n$input-box-shadow:                      var(--#{$prefix}box-shadow-inset) !default;\n\n$input-border-radius:                   var(--#{$prefix}border-radius) !default;\n$input-border-radius-sm:                var(--#{$prefix}border-radius-sm) !default;\n$input-border-radius-lg:                var(--#{$prefix}border-radius-lg) !default;\n\n$input-focus-bg:                        $input-bg !default;\n$input-focus-border-color:              tint-color($component-active-bg, 50%) !default;\n$input-focus-color:                     $input-color !default;\n$input-focus-width:                     $input-btn-focus-width !default;\n$input-focus-box-shadow:                $input-btn-focus-box-shadow !default;\n\n$input-placeholder-color:               var(--#{$prefix}secondary-color) !default;\n$input-plaintext-color:                 var(--#{$prefix}body-color) !default;\n\n$input-height-border:                   calc(#{$input-border-width} * 2) !default; // stylelint-disable-line function-disallowed-list\n\n$input-height-inner:                    add($input-line-height * 1em, $input-padding-y * 2) !default;\n$input-height-inner-half:               add($input-line-height * .5em, $input-padding-y) !default;\n$input-height-inner-quarter:            add($input-line-height * .25em, $input-padding-y * .5) !default;\n\n$input-height:                          add($input-line-height * 1em, add($input-padding-y * 2, $input-height-border, false)) !default;\n$input-height-sm:                       add($input-line-height * 1em, add($input-padding-y-sm * 2, $input-height-border, false)) !default;\n$input-height-lg:                       add($input-line-height * 1em, add($input-padding-y-lg * 2, $input-height-border, false)) !default;\n\n$input-transition:                      border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$form-color-width:                      3rem !default;\n// scss-docs-end form-input-variables\n\n// scss-docs-start form-check-variables\n$form-check-input-width:                  1em !default;\n$form-check-min-height:                   $font-size-base * $line-height-base !default;\n$form-check-padding-start:                $form-check-input-width + .5em !default;\n$form-check-margin-bottom:                .125rem !default;\n$form-check-label-color:                  null !default;\n$form-check-label-cursor:                 null !default;\n$form-check-transition:                   null !default;\n\n$form-check-input-active-filter:          brightness(90%) !default;\n\n$form-check-input-bg:                     $input-bg !default;\n$form-check-input-border:                 var(--#{$prefix}border-width) solid var(--#{$prefix}border-color) !default;\n$form-check-input-border-radius:          .25em !default;\n$form-check-radio-border-radius:          50% !default;\n$form-check-input-focus-border:           $input-focus-border-color !default;\n$form-check-input-focus-box-shadow:       $focus-ring-box-shadow !default;\n\n$form-check-input-checked-color:          $component-active-color !default;\n$form-check-input-checked-bg-color:       $component-active-bg !default;\n$form-check-input-checked-border-color:   $form-check-input-checked-bg-color !default;\n$form-check-input-checked-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path fill='none' stroke='#{$form-check-input-checked-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='m6 10 3 3 6-6'/></svg>\") !default;\n$form-check-radio-checked-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='2' fill='#{$form-check-input-checked-color}'/></svg>\") !default;\n\n$form-check-input-indeterminate-color:          $component-active-color !default;\n$form-check-input-indeterminate-bg-color:       $component-active-bg !default;\n$form-check-input-indeterminate-border-color:   $form-check-input-indeterminate-bg-color !default;\n$form-check-input-indeterminate-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path fill='none' stroke='#{$form-check-input-indeterminate-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10h8'/></svg>\") !default;\n\n$form-check-input-disabled-opacity:        .5 !default;\n$form-check-label-disabled-opacity:        $form-check-input-disabled-opacity !default;\n$form-check-btn-check-disabled-opacity:    $btn-disabled-opacity !default;\n\n$form-check-inline-margin-end:    1rem !default;\n// scss-docs-end form-check-variables\n\n// scss-docs-start form-switch-variables\n$form-switch-color:               rgba($black, .25) !default;\n$form-switch-width:               2em !default;\n$form-switch-padding-start:       $form-switch-width + .5em !default;\n$form-switch-bg-image:            url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-color}'/></svg>\") !default;\n$form-switch-border-radius:       $form-switch-width !default;\n$form-switch-transition:          background-position .15s ease-in-out !default;\n\n$form-switch-focus-color:         $input-focus-border-color !default;\n$form-switch-focus-bg-image:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-focus-color}'/></svg>\") !default;\n\n$form-switch-checked-color:       $component-active-color !default;\n$form-switch-checked-bg-image:    url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-checked-color}'/></svg>\") !default;\n$form-switch-checked-bg-position: right center !default;\n// scss-docs-end form-switch-variables\n\n// scss-docs-start input-group-variables\n$input-group-addon-padding-y:           $input-padding-y !default;\n$input-group-addon-padding-x:           $input-padding-x !default;\n$input-group-addon-font-weight:         $input-font-weight !default;\n$input-group-addon-color:               $input-color !default;\n$input-group-addon-bg:                  var(--#{$prefix}tertiary-bg) !default;\n$input-group-addon-border-color:        $input-border-color !default;\n// scss-docs-end input-group-variables\n\n// scss-docs-start form-select-variables\n$form-select-padding-y:             $input-padding-y !default;\n$form-select-padding-x:             $input-padding-x !default;\n$form-select-font-family:           $input-font-family !default;\n$form-select-font-size:             $input-font-size !default;\n$form-select-indicator-padding:     $form-select-padding-x * 3 !default; // Extra padding for background-image\n$form-select-font-weight:           $input-font-weight !default;\n$form-select-line-height:           $input-line-height !default;\n$form-select-color:                 $input-color !default;\n$form-select-bg:                    $input-bg !default;\n$form-select-disabled-color:        null !default;\n$form-select-disabled-bg:           $input-disabled-bg !default;\n$form-select-disabled-border-color: $input-disabled-border-color !default;\n$form-select-bg-position:           right $form-select-padding-x center !default;\n$form-select-bg-size:               16px 12px !default; // In pixels because image dimensions\n$form-select-indicator-color:       $gray-800 !default;\n$form-select-indicator:             url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'><path fill='none' stroke='#{$form-select-indicator-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/></svg>\") !default;\n\n$form-select-feedback-icon-padding-end: $form-select-padding-x * 2.5 + $form-select-indicator-padding !default;\n$form-select-feedback-icon-position:    center right $form-select-indicator-padding !default;\n$form-select-feedback-icon-size:        $input-height-inner-half $input-height-inner-half !default;\n\n$form-select-border-width:        $input-border-width !default;\n$form-select-border-color:        $input-border-color !default;\n$form-select-border-radius:       $input-border-radius !default;\n$form-select-box-shadow:          var(--#{$prefix}box-shadow-inset) !default;\n\n$form-select-focus-border-color:  $input-focus-border-color !default;\n$form-select-focus-width:         $input-focus-width !default;\n$form-select-focus-box-shadow:    0 0 0 $form-select-focus-width $input-btn-focus-color !default;\n\n$form-select-padding-y-sm:        $input-padding-y-sm !default;\n$form-select-padding-x-sm:        $input-padding-x-sm !default;\n$form-select-font-size-sm:        $input-font-size-sm !default;\n$form-select-border-radius-sm:    $input-border-radius-sm !default;\n\n$form-select-padding-y-lg:        $input-padding-y-lg !default;\n$form-select-padding-x-lg:        $input-padding-x-lg !default;\n$form-select-font-size-lg:        $input-font-size-lg !default;\n$form-select-border-radius-lg:    $input-border-radius-lg !default;\n\n$form-select-transition:          $input-transition !default;\n// scss-docs-end form-select-variables\n\n// scss-docs-start form-range-variables\n$form-range-track-width:          100% !default;\n$form-range-track-height:         .5rem !default;\n$form-range-track-cursor:         pointer !default;\n$form-range-track-bg:             var(--#{$prefix}secondary-bg) !default;\n$form-range-track-border-radius:  1rem !default;\n$form-range-track-box-shadow:     var(--#{$prefix}box-shadow-inset) !default;\n\n$form-range-thumb-width:                   1rem !default;\n$form-range-thumb-height:                  $form-range-thumb-width !default;\n$form-range-thumb-bg:                      $component-active-bg !default;\n$form-range-thumb-border:                  0 !default;\n$form-range-thumb-border-radius:           1rem !default;\n$form-range-thumb-box-shadow:              0 .1rem .25rem rgba($black, .1) !default;\n$form-range-thumb-focus-box-shadow:        0 0 0 1px $body-bg, $input-focus-box-shadow !default;\n$form-range-thumb-focus-box-shadow-width:  $input-focus-width !default; // For focus box shadow issue in Edge\n$form-range-thumb-active-bg:               tint-color($component-active-bg, 70%) !default;\n$form-range-thumb-disabled-bg:             var(--#{$prefix}secondary-color) !default;\n$form-range-thumb-transition:              background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n// scss-docs-end form-range-variables\n\n// scss-docs-start form-file-variables\n$form-file-button-color:          $input-color !default;\n$form-file-button-bg:             var(--#{$prefix}tertiary-bg) !default;\n$form-file-button-hover-bg:       var(--#{$prefix}secondary-bg) !default;\n// scss-docs-end form-file-variables\n\n// scss-docs-start form-floating-variables\n$form-floating-height:                  add(3.5rem, $input-height-border) !default;\n$form-floating-line-height:             1.25 !default;\n$form-floating-padding-x:               $input-padding-x !default;\n$form-floating-padding-y:               1rem !default;\n$form-floating-input-padding-t:         1.625rem !default;\n$form-floating-input-padding-b:         .625rem !default;\n$form-floating-label-height:            1.5em !default;\n$form-floating-label-opacity:           .65 !default;\n$form-floating-label-transform:         scale(.85) translateY(-.5rem) translateX(.15rem) !default;\n$form-floating-label-disabled-color:    $gray-600 !default;\n$form-floating-transition:              opacity .1s ease-in-out, transform .1s ease-in-out !default;\n// scss-docs-end form-floating-variables\n\n// Form validation\n\n// scss-docs-start form-feedback-variables\n$form-feedback-margin-top:          $form-text-margin-top !default;\n$form-feedback-font-size:           $form-text-font-size !default;\n$form-feedback-font-style:          $form-text-font-style !default;\n$form-feedback-valid-color:         $success !default;\n$form-feedback-invalid-color:       $danger !default;\n\n$form-feedback-icon-valid-color:    $form-feedback-valid-color !default;\n$form-feedback-icon-valid:          url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'><path fill='#{$form-feedback-icon-valid-color}' d='M2.3 6.73.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1'/></svg>\") !default;\n$form-feedback-icon-invalid-color:  $form-feedback-invalid-color !default;\n$form-feedback-icon-invalid:        url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='#{$form-feedback-icon-invalid-color}'><circle cx='6' cy='6' r='4.5'/><path stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/><circle cx='6' cy='8.2' r='.6' fill='#{$form-feedback-icon-invalid-color}' stroke='none'/></svg>\") !default;\n// scss-docs-end form-feedback-variables\n\n// scss-docs-start form-validation-colors\n$form-valid-color:                  $form-feedback-valid-color !default;\n$form-valid-border-color:           $form-feedback-valid-color !default;\n$form-invalid-color:                $form-feedback-invalid-color !default;\n$form-invalid-border-color:         $form-feedback-invalid-color !default;\n// scss-docs-end form-validation-colors\n\n// scss-docs-start form-validation-states\n$form-validation-states: (\n  \"valid\": (\n    \"color\": var(--#{$prefix}form-valid-color),\n    \"icon\": $form-feedback-icon-valid,\n    \"tooltip-color\": #fff,\n    \"tooltip-bg-color\": var(--#{$prefix}success),\n    \"focus-box-shadow\": 0 0 $input-btn-focus-blur $input-focus-width rgba(var(--#{$prefix}success-rgb), $input-btn-focus-color-opacity),\n    \"border-color\": var(--#{$prefix}form-valid-border-color),\n  ),\n  \"invalid\": (\n    \"color\": var(--#{$prefix}form-invalid-color),\n    \"icon\": $form-feedback-icon-invalid,\n    \"tooltip-color\": #fff,\n    \"tooltip-bg-color\": var(--#{$prefix}danger),\n    \"focus-box-shadow\": 0 0 $input-btn-focus-blur $input-focus-width rgba(var(--#{$prefix}danger-rgb), $input-btn-focus-color-opacity),\n    \"border-color\": var(--#{$prefix}form-invalid-border-color),\n  )\n) !default;\n// scss-docs-end form-validation-states\n\n// Z-index master list\n//\n// Warning: Avoid customizing these values. They're used for a bird's eye view\n// of components dependent on the z-axis and are designed to all work together.\n\n// scss-docs-start zindex-stack\n$zindex-dropdown:                   1000 !default;\n$zindex-sticky:                     1020 !default;\n$zindex-fixed:                      1030 !default;\n$zindex-offcanvas-backdrop:         1040 !default;\n$zindex-offcanvas:                  1045 !default;\n$zindex-modal-backdrop:             1050 !default;\n$zindex-modal:                      1055 !default;\n$zindex-popover:                    1070 !default;\n$zindex-tooltip:                    1080 !default;\n$zindex-toast:                      1090 !default;\n// scss-docs-end zindex-stack\n\n// scss-docs-start zindex-levels-map\n$zindex-levels: (\n  n1: -1,\n  0: 0,\n  1: 1,\n  2: 2,\n  3: 3\n) !default;\n// scss-docs-end zindex-levels-map\n\n\n// Navs\n\n// scss-docs-start nav-variables\n$nav-link-padding-y:                .5rem !default;\n$nav-link-padding-x:                1rem !default;\n$nav-link-font-size:                null !default;\n$nav-link-font-weight:              null !default;\n$nav-link-color:                    var(--#{$prefix}link-color) !default;\n$nav-link-hover-color:              var(--#{$prefix}link-hover-color) !default;\n$nav-link-transition:               color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out !default;\n$nav-link-disabled-color:           var(--#{$prefix}secondary-color) !default;\n$nav-link-focus-box-shadow:         $focus-ring-box-shadow !default;\n\n$nav-tabs-border-color:             var(--#{$prefix}border-color) !default;\n$nav-tabs-border-width:             var(--#{$prefix}border-width) !default;\n$nav-tabs-border-radius:            var(--#{$prefix}border-radius) !default;\n$nav-tabs-link-hover-border-color:  var(--#{$prefix}secondary-bg) var(--#{$prefix}secondary-bg) $nav-tabs-border-color !default;\n$nav-tabs-link-active-color:        var(--#{$prefix}emphasis-color) !default;\n$nav-tabs-link-active-bg:           var(--#{$prefix}body-bg) !default;\n$nav-tabs-link-active-border-color: var(--#{$prefix}border-color) var(--#{$prefix}border-color) $nav-tabs-link-active-bg !default;\n\n$nav-pills-border-radius:           var(--#{$prefix}border-radius) !default;\n$nav-pills-link-active-color:       $component-active-color !default;\n$nav-pills-link-active-bg:          $component-active-bg !default;\n\n$nav-underline-gap:                 1rem !default;\n$nav-underline-border-width:        .125rem !default;\n$nav-underline-link-active-color:   var(--#{$prefix}emphasis-color) !default;\n// scss-docs-end nav-variables\n\n\n// Navbar\n\n// scss-docs-start navbar-variables\n$navbar-padding-y:                  $spacer * .5 !default;\n$navbar-padding-x:                  null !default;\n\n$navbar-nav-link-padding-x:         .5rem !default;\n\n$navbar-brand-font-size:            $font-size-lg !default;\n// Compute the navbar-brand padding-y so the navbar-brand will have the same height as navbar-text and nav-link\n$nav-link-height:                   $font-size-base * $line-height-base + $nav-link-padding-y * 2 !default;\n$navbar-brand-height:               $navbar-brand-font-size * $line-height-base !default;\n$navbar-brand-padding-y:            ($nav-link-height - $navbar-brand-height) * .5 !default;\n$navbar-brand-margin-end:           1rem !default;\n\n$navbar-toggler-padding-y:          .25rem !default;\n$navbar-toggler-padding-x:          .75rem !default;\n$navbar-toggler-font-size:          $font-size-lg !default;\n$navbar-toggler-border-radius:      $btn-border-radius !default;\n$navbar-toggler-focus-width:        $btn-focus-width !default;\n$navbar-toggler-transition:         box-shadow .15s ease-in-out !default;\n\n$navbar-light-color:                rgba(var(--#{$prefix}emphasis-color-rgb), .65) !default;\n$navbar-light-hover-color:          rgba(var(--#{$prefix}emphasis-color-rgb), .8) !default;\n$navbar-light-active-color:         rgba(var(--#{$prefix}emphasis-color-rgb), 1) !default;\n$navbar-light-disabled-color:       rgba(var(--#{$prefix}emphasis-color-rgb), .3) !default;\n$navbar-light-icon-color:           rgba($body-color, .75) !default;\n$navbar-light-toggler-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'><path stroke='#{$navbar-light-icon-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\") !default;\n$navbar-light-toggler-border-color: rgba(var(--#{$prefix}emphasis-color-rgb), .15) !default;\n$navbar-light-brand-color:          $navbar-light-active-color !default;\n$navbar-light-brand-hover-color:    $navbar-light-active-color !default;\n// scss-docs-end navbar-variables\n\n// scss-docs-start navbar-dark-variables\n$navbar-dark-color:                 rgba($white, .55) !default;\n$navbar-dark-hover-color:           rgba($white, .75) !default;\n$navbar-dark-active-color:          $white !default;\n$navbar-dark-disabled-color:        rgba($white, .25) !default;\n$navbar-dark-icon-color:            $navbar-dark-color !default;\n$navbar-dark-toggler-icon-bg:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'><path stroke='#{$navbar-dark-icon-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\") !default;\n$navbar-dark-toggler-border-color:  rgba($white, .1) !default;\n$navbar-dark-brand-color:           $navbar-dark-active-color !default;\n$navbar-dark-brand-hover-color:     $navbar-dark-active-color !default;\n// scss-docs-end navbar-dark-variables\n\n\n// Dropdowns\n//\n// Dropdown menu container and contents.\n\n// scss-docs-start dropdown-variables\n$dropdown-min-width:                10rem !default;\n$dropdown-padding-x:                0 !default;\n$dropdown-padding-y:                .5rem !default;\n$dropdown-spacer:                   .125rem !default;\n$dropdown-font-size:                $font-size-base !default;\n$dropdown-color:                    var(--#{$prefix}body-color) !default;\n$dropdown-bg:                       var(--#{$prefix}body-bg) !default;\n$dropdown-border-color:             var(--#{$prefix}border-color-translucent) !default;\n$dropdown-border-radius:            var(--#{$prefix}border-radius) !default;\n$dropdown-border-width:             var(--#{$prefix}border-width) !default;\n$dropdown-inner-border-radius:      calc(#{$dropdown-border-radius} - #{$dropdown-border-width}) !default; // stylelint-disable-line function-disallowed-list\n$dropdown-divider-bg:               $dropdown-border-color !default;\n$dropdown-divider-margin-y:         $spacer * .5 !default;\n$dropdown-box-shadow:               var(--#{$prefix}box-shadow) !default;\n\n$dropdown-link-color:               var(--#{$prefix}body-color) !default;\n$dropdown-link-hover-color:         $dropdown-link-color !default;\n$dropdown-link-hover-bg:            var(--#{$prefix}tertiary-bg) !default;\n\n$dropdown-link-active-color:        $component-active-color !default;\n$dropdown-link-active-bg:           $component-active-bg !default;\n\n$dropdown-link-disabled-color:      var(--#{$prefix}tertiary-color) !default;\n\n$dropdown-item-padding-y:           $spacer * .25 !default;\n$dropdown-item-padding-x:           $spacer !default;\n\n$dropdown-header-color:             $gray-600 !default;\n$dropdown-header-padding-x:         $dropdown-item-padding-x !default;\n$dropdown-header-padding-y:         $dropdown-padding-y !default;\n// fusv-disable\n$dropdown-header-padding:           $dropdown-header-padding-y $dropdown-header-padding-x !default; // Deprecated in v5.2.0\n// fusv-enable\n// scss-docs-end dropdown-variables\n\n// scss-docs-start dropdown-dark-variables\n$dropdown-dark-color:               $gray-300 !default;\n$dropdown-dark-bg:                  $gray-800 !default;\n$dropdown-dark-border-color:        $dropdown-border-color !default;\n$dropdown-dark-divider-bg:          $dropdown-divider-bg !default;\n$dropdown-dark-box-shadow:          null !default;\n$dropdown-dark-link-color:          $dropdown-dark-color !default;\n$dropdown-dark-link-hover-color:    $white !default;\n$dropdown-dark-link-hover-bg:       rgba($white, .15) !default;\n$dropdown-dark-link-active-color:   $dropdown-link-active-color !default;\n$dropdown-dark-link-active-bg:      $dropdown-link-active-bg !default;\n$dropdown-dark-link-disabled-color: $gray-500 !default;\n$dropdown-dark-header-color:        $gray-500 !default;\n// scss-docs-end dropdown-dark-variables\n\n\n// Pagination\n\n// scss-docs-start pagination-variables\n$pagination-padding-y:              .375rem !default;\n$pagination-padding-x:              .75rem !default;\n$pagination-padding-y-sm:           .25rem !default;\n$pagination-padding-x-sm:           .5rem !default;\n$pagination-padding-y-lg:           .75rem !default;\n$pagination-padding-x-lg:           1.5rem !default;\n\n$pagination-font-size:              $font-size-base !default;\n\n$pagination-color:                  var(--#{$prefix}link-color) !default;\n$pagination-bg:                     var(--#{$prefix}body-bg) !default;\n$pagination-border-radius:          var(--#{$prefix}border-radius) !default;\n$pagination-border-width:           var(--#{$prefix}border-width) !default;\n$pagination-margin-start:           calc(-1 * #{$pagination-border-width}) !default; // stylelint-disable-line function-disallowed-list\n$pagination-border-color:           var(--#{$prefix}border-color) !default;\n\n$pagination-focus-color:            var(--#{$prefix}link-hover-color) !default;\n$pagination-focus-bg:               var(--#{$prefix}secondary-bg) !default;\n$pagination-focus-box-shadow:       $focus-ring-box-shadow !default;\n$pagination-focus-outline:          0 !default;\n\n$pagination-hover-color:            var(--#{$prefix}link-hover-color) !default;\n$pagination-hover-bg:               var(--#{$prefix}tertiary-bg) !default;\n$pagination-hover-border-color:     var(--#{$prefix}border-color) !default; // Todo in v6: remove this?\n\n$pagination-active-color:           $component-active-color !default;\n$pagination-active-bg:              $component-active-bg !default;\n$pagination-active-border-color:    $component-active-bg !default;\n\n$pagination-disabled-color:         var(--#{$prefix}secondary-color) !default;\n$pagination-disabled-bg:            var(--#{$prefix}secondary-bg) !default;\n$pagination-disabled-border-color:  var(--#{$prefix}border-color) !default;\n\n$pagination-transition:              color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$pagination-border-radius-sm:       var(--#{$prefix}border-radius-sm) !default;\n$pagination-border-radius-lg:       var(--#{$prefix}border-radius-lg) !default;\n// scss-docs-end pagination-variables\n\n\n// Placeholders\n\n// scss-docs-start placeholders\n$placeholder-opacity-max:           .5 !default;\n$placeholder-opacity-min:           .2 !default;\n// scss-docs-end placeholders\n\n// Cards\n\n// scss-docs-start card-variables\n$card-spacer-y:                     $spacer !default;\n$card-spacer-x:                     $spacer !default;\n$card-title-spacer-y:               $spacer * .5 !default;\n$card-title-color:                  null !default;\n$card-subtitle-color:               null !default;\n$card-border-width:                 var(--#{$prefix}border-width) !default;\n$card-border-color:                 var(--#{$prefix}border-color-translucent) !default;\n$card-border-radius:                var(--#{$prefix}border-radius) !default;\n$card-box-shadow:                   null !default;\n$card-inner-border-radius:          subtract($card-border-radius, $card-border-width) !default;\n$card-cap-padding-y:                $card-spacer-y * .5 !default;\n$card-cap-padding-x:                $card-spacer-x !default;\n$card-cap-bg:                       rgba(var(--#{$prefix}body-color-rgb), .03) !default;\n$card-cap-color:                    null !default;\n$card-height:                       null !default;\n$card-color:                        null !default;\n$card-bg:                           var(--#{$prefix}body-bg) !default;\n$card-img-overlay-padding:          $spacer !default;\n$card-group-margin:                 $grid-gutter-width * .5 !default;\n// scss-docs-end card-variables\n\n// Accordion\n\n// scss-docs-start accordion-variables\n$accordion-padding-y:                     1rem !default;\n$accordion-padding-x:                     1.25rem !default;\n$accordion-color:                         var(--#{$prefix}body-color) !default;\n$accordion-bg:                            var(--#{$prefix}body-bg) !default;\n$accordion-border-width:                  var(--#{$prefix}border-width) !default;\n$accordion-border-color:                  var(--#{$prefix}border-color) !default;\n$accordion-border-radius:                 var(--#{$prefix}border-radius) !default;\n$accordion-inner-border-radius:           subtract($accordion-border-radius, $accordion-border-width) !default;\n\n$accordion-body-padding-y:                $accordion-padding-y !default;\n$accordion-body-padding-x:                $accordion-padding-x !default;\n\n$accordion-button-padding-y:              $accordion-padding-y !default;\n$accordion-button-padding-x:              $accordion-padding-x !default;\n$accordion-button-color:                  var(--#{$prefix}body-color) !default;\n$accordion-button-bg:                     var(--#{$prefix}accordion-bg) !default;\n$accordion-transition:                    $btn-transition, border-radius .15s ease !default;\n$accordion-button-active-bg:              var(--#{$prefix}primary-bg-subtle) !default;\n$accordion-button-active-color:           var(--#{$prefix}primary-text-emphasis) !default;\n\n// fusv-disable\n$accordion-button-focus-border-color:     $input-focus-border-color !default; // Deprecated in v5.3.3\n// fusv-enable\n$accordion-button-focus-box-shadow:       $btn-focus-box-shadow !default;\n\n$accordion-icon-width:                    1.25rem !default;\n$accordion-icon-color:                    $body-color !default;\n$accordion-icon-active-color:             $primary-text-emphasis !default;\n$accordion-icon-transition:               transform .2s ease-in-out !default;\n$accordion-icon-transform:                rotate(-180deg) !default;\n\n$accordion-button-icon:         url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='none' stroke='#{$accordion-icon-color}' stroke-linecap='round' stroke-linejoin='round'><path d='m2 5 6 6 6-6'/></svg>\") !default;\n$accordion-button-active-icon:  url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='none' stroke='#{$accordion-icon-active-color}' stroke-linecap='round' stroke-linejoin='round'><path d='m2 5 6 6 6-6'/></svg>\") !default;\n// scss-docs-end accordion-variables\n\n// Tooltips\n\n// scss-docs-start tooltip-variables\n$tooltip-font-size:                 $font-size-sm !default;\n$tooltip-max-width:                 200px !default;\n$tooltip-color:                     var(--#{$prefix}body-bg) !default;\n$tooltip-bg:                        var(--#{$prefix}emphasis-color) !default;\n$tooltip-border-radius:             var(--#{$prefix}border-radius) !default;\n$tooltip-opacity:                   .9 !default;\n$tooltip-padding-y:                 $spacer * .25 !default;\n$tooltip-padding-x:                 $spacer * .5 !default;\n$tooltip-margin:                    null !default; // TODO: remove this in v6\n\n$tooltip-arrow-width:               .8rem !default;\n$tooltip-arrow-height:              .4rem !default;\n// fusv-disable\n$tooltip-arrow-color:               null !default; // Deprecated in Bootstrap 5.2.0 for CSS variables\n// fusv-enable\n// scss-docs-end tooltip-variables\n\n// Form tooltips must come after regular tooltips\n// scss-docs-start tooltip-feedback-variables\n$form-feedback-tooltip-padding-y:     $tooltip-padding-y !default;\n$form-feedback-tooltip-padding-x:     $tooltip-padding-x !default;\n$form-feedback-tooltip-font-size:     $tooltip-font-size !default;\n$form-feedback-tooltip-line-height:   null !default;\n$form-feedback-tooltip-opacity:       $tooltip-opacity !default;\n$form-feedback-tooltip-border-radius: $tooltip-border-radius !default;\n// scss-docs-end tooltip-feedback-variables\n\n\n// Popovers\n\n// scss-docs-start popover-variables\n$popover-font-size:                 $font-size-sm !default;\n$popover-bg:                        var(--#{$prefix}body-bg) !default;\n$popover-max-width:                 276px !default;\n$popover-border-width:              var(--#{$prefix}border-width) !default;\n$popover-border-color:              var(--#{$prefix}border-color-translucent) !default;\n$popover-border-radius:             var(--#{$prefix}border-radius-lg) !default;\n$popover-inner-border-radius:       calc(#{$popover-border-radius} - #{$popover-border-width}) !default; // stylelint-disable-line function-disallowed-list\n$popover-box-shadow:                var(--#{$prefix}box-shadow) !default;\n\n$popover-header-font-size:          $font-size-base !default;\n$popover-header-bg:                 var(--#{$prefix}secondary-bg) !default;\n$popover-header-color:              $headings-color !default;\n$popover-header-padding-y:          .5rem !default;\n$popover-header-padding-x:          $spacer !default;\n\n$popover-body-color:                var(--#{$prefix}body-color) !default;\n$popover-body-padding-y:            $spacer !default;\n$popover-body-padding-x:            $spacer !default;\n\n$popover-arrow-width:               1rem !default;\n$popover-arrow-height:              .5rem !default;\n// scss-docs-end popover-variables\n\n// fusv-disable\n// Deprecated in Bootstrap 5.2.0 for CSS variables\n$popover-arrow-color:               $popover-bg !default;\n$popover-arrow-outer-color:         var(--#{$prefix}border-color-translucent) !default;\n// fusv-enable\n\n\n// Toasts\n\n// scss-docs-start toast-variables\n$toast-max-width:                   350px !default;\n$toast-padding-x:                   .75rem !default;\n$toast-padding-y:                   .5rem !default;\n$toast-font-size:                   .875rem !default;\n$toast-color:                       null !default;\n$toast-background-color:            rgba(var(--#{$prefix}body-bg-rgb), .85) !default;\n$toast-border-width:                var(--#{$prefix}border-width) !default;\n$toast-border-color:                var(--#{$prefix}border-color-translucent) !default;\n$toast-border-radius:               var(--#{$prefix}border-radius) !default;\n$toast-box-shadow:                  var(--#{$prefix}box-shadow) !default;\n$toast-spacing:                     $container-padding-x !default;\n\n$toast-header-color:                var(--#{$prefix}secondary-color) !default;\n$toast-header-background-color:     rgba(var(--#{$prefix}body-bg-rgb), .85) !default;\n$toast-header-border-color:         $toast-border-color !default;\n// scss-docs-end toast-variables\n\n\n// Badges\n\n// scss-docs-start badge-variables\n$badge-font-size:                   .75em !default;\n$badge-font-weight:                 $font-weight-bold !default;\n$badge-color:                       $white !default;\n$badge-padding-y:                   .35em !default;\n$badge-padding-x:                   .65em !default;\n$badge-border-radius:               var(--#{$prefix}border-radius) !default;\n// scss-docs-end badge-variables\n\n\n// Modals\n\n// scss-docs-start modal-variables\n$modal-inner-padding:               $spacer !default;\n\n$modal-footer-margin-between:       .5rem !default;\n\n$modal-dialog-margin:               .5rem !default;\n$modal-dialog-margin-y-sm-up:       1.75rem !default;\n\n$modal-title-line-height:           $line-height-base !default;\n\n$modal-content-color:               var(--#{$prefix}body-color) !default;\n$modal-content-bg:                  var(--#{$prefix}body-bg) !default;\n$modal-content-border-color:        var(--#{$prefix}border-color-translucent) !default;\n$modal-content-border-width:        var(--#{$prefix}border-width) !default;\n$modal-content-border-radius:       var(--#{$prefix}border-radius-lg) !default;\n$modal-content-inner-border-radius: subtract($modal-content-border-radius, $modal-content-border-width) !default;\n$modal-content-box-shadow-xs:       var(--#{$prefix}box-shadow-sm) !default;\n$modal-content-box-shadow-sm-up:    var(--#{$prefix}box-shadow) !default;\n\n$modal-backdrop-bg:                 $black !default;\n$modal-backdrop-opacity:            .5 !default;\n\n$modal-header-border-color:         var(--#{$prefix}border-color) !default;\n$modal-header-border-width:         $modal-content-border-width !default;\n$modal-header-padding-y:            $modal-inner-padding !default;\n$modal-header-padding-x:            $modal-inner-padding !default;\n$modal-header-padding:              $modal-header-padding-y $modal-header-padding-x !default; // Keep this for backwards compatibility\n\n$modal-footer-bg:                   null !default;\n$modal-footer-border-color:         $modal-header-border-color !default;\n$modal-footer-border-width:         $modal-header-border-width !default;\n\n$modal-sm:                          300px !default;\n$modal-md:                          500px !default;\n$modal-lg:                          800px !default;\n$modal-xl:                          1140px !default;\n\n$modal-fade-transform:              translate(0, -50px) !default;\n$modal-show-transform:              none !default;\n$modal-transition:                  transform .3s ease-out !default;\n$modal-scale-transform:             scale(1.02) !default;\n// scss-docs-end modal-variables\n\n\n// Alerts\n//\n// Define alert colors, border radius, and padding.\n\n// scss-docs-start alert-variables\n$alert-padding-y:               $spacer !default;\n$alert-padding-x:               $spacer !default;\n$alert-margin-bottom:           1rem !default;\n$alert-border-radius:           var(--#{$prefix}border-radius) !default;\n$alert-link-font-weight:        $font-weight-bold !default;\n$alert-border-width:            var(--#{$prefix}border-width) !default;\n$alert-dismissible-padding-r:   $alert-padding-x * 3 !default; // 3x covers width of x plus default padding on either side\n// scss-docs-end alert-variables\n\n// fusv-disable\n$alert-bg-scale:                -80% !default; // Deprecated in v5.2.0, to be removed in v6\n$alert-border-scale:            -70% !default; // Deprecated in v5.2.0, to be removed in v6\n$alert-color-scale:             40% !default; // Deprecated in v5.2.0, to be removed in v6\n// fusv-enable\n\n// Progress bars\n\n// scss-docs-start progress-variables\n$progress-height:                   1rem !default;\n$progress-font-size:                $font-size-base * .75 !default;\n$progress-bg:                       var(--#{$prefix}secondary-bg) !default;\n$progress-border-radius:            var(--#{$prefix}border-radius) !default;\n$progress-box-shadow:               var(--#{$prefix}box-shadow-inset) !default;\n$progress-bar-color:                $white !default;\n$progress-bar-bg:                   $primary !default;\n$progress-bar-animation-timing:     1s linear infinite !default;\n$progress-bar-transition:           width .6s ease !default;\n// scss-docs-end progress-variables\n\n\n// List group\n\n// scss-docs-start list-group-variables\n$list-group-color:                  var(--#{$prefix}body-color) !default;\n$list-group-bg:                     var(--#{$prefix}body-bg) !default;\n$list-group-border-color:           var(--#{$prefix}border-color) !default;\n$list-group-border-width:           var(--#{$prefix}border-width) !default;\n$list-group-border-radius:          var(--#{$prefix}border-radius) !default;\n\n$list-group-item-padding-y:         $spacer * .5 !default;\n$list-group-item-padding-x:         $spacer !default;\n// fusv-disable\n$list-group-item-bg-scale:          -80% !default; // Deprecated in v5.3.0\n$list-group-item-color-scale:       40% !default; // Deprecated in v5.3.0\n// fusv-enable\n\n$list-group-hover-bg:               var(--#{$prefix}tertiary-bg) !default;\n$list-group-active-color:           $component-active-color !default;\n$list-group-active-bg:              $component-active-bg !default;\n$list-group-active-border-color:    $list-group-active-bg !default;\n\n$list-group-disabled-color:         var(--#{$prefix}secondary-color) !default;\n$list-group-disabled-bg:            $list-group-bg !default;\n\n$list-group-action-color:           var(--#{$prefix}secondary-color) !default;\n$list-group-action-hover-color:     var(--#{$prefix}emphasis-color) !default;\n\n$list-group-action-active-color:    var(--#{$prefix}body-color) !default;\n$list-group-action-active-bg:       var(--#{$prefix}secondary-bg) !default;\n// scss-docs-end list-group-variables\n\n\n// Image thumbnails\n\n// scss-docs-start thumbnail-variables\n$thumbnail-padding:                 .25rem !default;\n$thumbnail-bg:                      var(--#{$prefix}body-bg) !default;\n$thumbnail-border-width:            var(--#{$prefix}border-width) !default;\n$thumbnail-border-color:            var(--#{$prefix}border-color) !default;\n$thumbnail-border-radius:           var(--#{$prefix}border-radius) !default;\n$thumbnail-box-shadow:              var(--#{$prefix}box-shadow-sm) !default;\n// scss-docs-end thumbnail-variables\n\n\n// Figures\n\n// scss-docs-start figure-variables\n$figure-caption-font-size:          $small-font-size !default;\n$figure-caption-color:              var(--#{$prefix}secondary-color) !default;\n// scss-docs-end figure-variables\n\n\n// Breadcrumbs\n\n// scss-docs-start breadcrumb-variables\n$breadcrumb-font-size:              null !default;\n$breadcrumb-padding-y:              0 !default;\n$breadcrumb-padding-x:              0 !default;\n$breadcrumb-item-padding-x:         .5rem !default;\n$breadcrumb-margin-bottom:          1rem !default;\n$breadcrumb-bg:                     null !default;\n$breadcrumb-divider-color:          var(--#{$prefix}secondary-color) !default;\n$breadcrumb-active-color:           var(--#{$prefix}secondary-color) !default;\n$breadcrumb-divider:                quote(\"/\") !default;\n$breadcrumb-divider-flipped:        $breadcrumb-divider !default;\n$breadcrumb-border-radius:          null !default;\n// scss-docs-end breadcrumb-variables\n\n// Carousel\n\n// scss-docs-start carousel-variables\n$carousel-control-color:             $white !default;\n$carousel-control-width:             15% !default;\n$carousel-control-opacity:           .5 !default;\n$carousel-control-hover-opacity:     .9 !default;\n$carousel-control-transition:        opacity .15s ease !default;\n$carousel-control-icon-filter:       null !default;\n\n$carousel-indicator-width:           30px !default;\n$carousel-indicator-height:          3px !default;\n$carousel-indicator-hit-area-height: 10px !default;\n$carousel-indicator-spacer:          3px !default;\n$carousel-indicator-opacity:         .5 !default;\n$carousel-indicator-active-bg:       $white !default;\n$carousel-indicator-active-opacity:  1 !default;\n$carousel-indicator-transition:      opacity .6s ease !default;\n\n$carousel-caption-width:             70% !default;\n$carousel-caption-color:             $white !default;\n$carousel-caption-padding-y:         1.25rem !default;\n$carousel-caption-spacer:            1.25rem !default;\n\n$carousel-control-icon-width:        2rem !default;\n\n$carousel-control-prev-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$carousel-control-color}'><path d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0'/></svg>\") !default;\n$carousel-control-next-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$carousel-control-color}'><path d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708'/></svg>\") !default;\n\n$carousel-transition-duration:       .6s !default;\n$carousel-transition:                transform $carousel-transition-duration ease-in-out !default; // Define transform transition first if using multiple transitions (e.g., `transform 2s ease, opacity .5s ease-out`)\n// scss-docs-end carousel-variables\n\n// scss-docs-start carousel-dark-variables\n$carousel-dark-indicator-active-bg:  $black !default; // Deprecated in v5.3.4\n$carousel-dark-caption-color:        $black !default; // Deprecated in v5.3.4\n$carousel-dark-control-icon-filter:  invert(1) grayscale(100) !default; // Deprecated in v5.3.4\n// scss-docs-end carousel-dark-variables\n\n\n// Spinners\n\n// scss-docs-start spinner-variables\n$spinner-width:           2rem !default;\n$spinner-height:          $spinner-width !default;\n$spinner-vertical-align:  -.125em !default;\n$spinner-border-width:    .25em !default;\n$spinner-animation-speed: .75s !default;\n\n$spinner-width-sm:        1rem !default;\n$spinner-height-sm:       $spinner-width-sm !default;\n$spinner-border-width-sm: .2em !default;\n// scss-docs-end spinner-variables\n\n\n// Close\n\n// scss-docs-start close-variables\n$btn-close-width:            1em !default;\n$btn-close-height:           $btn-close-width !default;\n$btn-close-padding-x:        .25em !default;\n$btn-close-padding-y:        $btn-close-padding-x !default;\n$btn-close-color:            $black !default;\n$btn-close-bg:               url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$btn-close-color}'><path d='M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414'/></svg>\") !default;\n$btn-close-focus-shadow:     $focus-ring-box-shadow !default;\n$btn-close-opacity:          .5 !default;\n$btn-close-hover-opacity:    .75 !default;\n$btn-close-focus-opacity:    1 !default;\n$btn-close-disabled-opacity: .25 !default;\n$btn-close-filter:           null !default;\n$btn-close-white-filter:     invert(1) grayscale(100%) brightness(200%) !default; // Deprecated in v5.3.4\n// scss-docs-end close-variables\n\n\n// Offcanvas\n\n// scss-docs-start offcanvas-variables\n$offcanvas-padding-y:               $modal-inner-padding !default;\n$offcanvas-padding-x:               $modal-inner-padding !default;\n$offcanvas-horizontal-width:        400px !default;\n$offcanvas-vertical-height:         30vh !default;\n$offcanvas-transition-duration:     .3s !default;\n$offcanvas-border-color:            $modal-content-border-color !default;\n$offcanvas-border-width:            $modal-content-border-width !default;\n$offcanvas-title-line-height:       $modal-title-line-height !default;\n$offcanvas-bg-color:                var(--#{$prefix}body-bg) !default;\n$offcanvas-color:                   var(--#{$prefix}body-color) !default;\n$offcanvas-box-shadow:              $modal-content-box-shadow-xs !default;\n$offcanvas-backdrop-bg:             $modal-backdrop-bg !default;\n$offcanvas-backdrop-opacity:        $modal-backdrop-opacity !default;\n// scss-docs-end offcanvas-variables\n\n// Code\n\n$code-font-size:                    $small-font-size !default;\n$code-color:                        $pink !default;\n\n$kbd-padding-y:                     .1875rem !default;\n$kbd-padding-x:                     .375rem !default;\n$kbd-font-size:                     $code-font-size !default;\n$kbd-color:                         var(--#{$prefix}body-bg) !default;\n$kbd-bg:                            var(--#{$prefix}body-color) !default;\n$nested-kbd-font-weight:            null !default; // Deprecated in v5.2.0, removing in v6\n\n$pre-color:                         null !default;\n\n@import \"variables-dark\"; // TODO: can be removed safely in v6, only here to avoid breaking changes in v5.3\n","// stylelint-disable scss/dimension-no-non-numeric-values\n\n// SCSS RFS mixin\n//\n// Automated responsive values for font sizes, paddings, margins and much more\n//\n// Licensed under MIT (https://github.com/twbs/rfs/blob/main/LICENSE)\n\n// Configuration\n\n// Base value\n$rfs-base-value: 1.25rem !default;\n$rfs-unit: rem !default;\n\n@if $rfs-unit != rem and $rfs-unit != px {\n  @error \"`#{$rfs-unit}` is not a valid unit for $rfs-unit. Use `px` or `rem`.\";\n}\n\n// Breakpoint at where values start decreasing if screen width is smaller\n$rfs-breakpoint: 1200px !default;\n$rfs-breakpoint-unit: px !default;\n\n@if $rfs-breakpoint-unit != px and $rfs-breakpoint-unit != em and $rfs-breakpoint-unit != rem {\n  @error \"`#{$rfs-breakpoint-unit}` is not a valid unit for $rfs-breakpoint-unit. Use `px`, `em` or `rem`.\";\n}\n\n// Resize values based on screen height and width\n$rfs-two-dimensional: false !default;\n\n// Factor of decrease\n$rfs-factor: 10 !default;\n\n@if type-of($rfs-factor) != number or $rfs-factor <= 1 {\n  @error \"`#{$rfs-factor}` is not a valid  $rfs-factor, it must be greater than 1.\";\n}\n\n// Mode. Possibilities: \"min-media-query\", \"max-media-query\"\n$rfs-mode: min-media-query !default;\n\n// Generate enable or disable classes. Possibilities: false, \"enable\" or \"disable\"\n$rfs-class: false !default;\n\n// 1 rem = $rfs-rem-value px\n$rfs-rem-value: 16 !default;\n\n// Safari iframe resize bug: https://github.com/twbs/rfs/issues/14\n$rfs-safari-iframe-resize-bug-fix: false !default;\n\n// Disable RFS by setting $enable-rfs to false\n$enable-rfs: true !default;\n\n// Cache $rfs-base-value unit\n$rfs-base-value-unit: unit($rfs-base-value);\n\n@function divide($dividend, $divisor, $precision: 10) {\n  $sign: if($dividend > 0 and $divisor > 0 or $dividend < 0 and $divisor < 0, 1, -1);\n  $dividend: abs($dividend);\n  $divisor: abs($divisor);\n  @if $dividend == 0 {\n    @return 0;\n  }\n  @if $divisor == 0 {\n    @error \"Cannot divide by 0\";\n  }\n  $remainder: $dividend;\n  $result: 0;\n  $factor: 10;\n  @while ($remainder > 0 and $precision >= 0) {\n    $quotient: 0;\n    @while ($remainder >= $divisor) {\n      $remainder: $remainder - $divisor;\n      $quotient: $quotient + 1;\n    }\n    $result: $result * 10 + $quotient;\n    $factor: $factor * .1;\n    $remainder: $remainder * 10;\n    $precision: $precision - 1;\n    @if ($precision < 0 and $remainder >= $divisor * 5) {\n      $result: $result + 1;\n    }\n  }\n  $result: $result * $factor * $sign;\n  $dividend-unit: unit($dividend);\n  $divisor-unit: unit($divisor);\n  $unit-map: (\n    \"px\": 1px,\n    \"rem\": 1rem,\n    \"em\": 1em,\n    \"%\": 1%\n  );\n  @if ($dividend-unit != $divisor-unit and map-has-key($unit-map, $dividend-unit)) {\n    $result: $result * map-get($unit-map, $dividend-unit);\n  }\n  @return $result;\n}\n\n// Remove px-unit from $rfs-base-value for calculations\n@if $rfs-base-value-unit == px {\n  $rfs-base-value: divide($rfs-base-value, $rfs-base-value * 0 + 1);\n}\n@else if $rfs-base-value-unit == rem {\n  $rfs-base-value: divide($rfs-base-value, divide($rfs-base-value * 0 + 1, $rfs-rem-value));\n}\n\n// Cache $rfs-breakpoint unit to prevent multiple calls\n$rfs-breakpoint-unit-cache: unit($rfs-breakpoint);\n\n// Remove unit from $rfs-breakpoint for calculations\n@if $rfs-breakpoint-unit-cache == px {\n  $rfs-breakpoint: divide($rfs-breakpoint, $rfs-breakpoint * 0 + 1);\n}\n@else if $rfs-breakpoint-unit-cache == rem or $rfs-breakpoint-unit-cache == \"em\" {\n  $rfs-breakpoint: divide($rfs-breakpoint, divide($rfs-breakpoint * 0 + 1, $rfs-rem-value));\n}\n\n// Calculate the media query value\n$rfs-mq-value: if($rfs-breakpoint-unit == px, #{$rfs-breakpoint}px, #{divide($rfs-breakpoint, $rfs-rem-value)}#{$rfs-breakpoint-unit});\n$rfs-mq-property-width: if($rfs-mode == max-media-query, max-width, min-width);\n$rfs-mq-property-height: if($rfs-mode == max-media-query, max-height, min-height);\n\n// Internal mixin used to determine which media query needs to be used\n@mixin _rfs-media-query {\n  @if $rfs-two-dimensional {\n    @if $rfs-mode == max-media-query {\n      @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}), (#{$rfs-mq-property-height}: #{$rfs-mq-value}) {\n        @content;\n      }\n    }\n    @else {\n      @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}) and (#{$rfs-mq-property-height}: #{$rfs-mq-value}) {\n        @content;\n      }\n    }\n  }\n  @else {\n    @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}) {\n      @content;\n    }\n  }\n}\n\n// Internal mixin that adds disable classes to the selector if needed.\n@mixin _rfs-rule {\n  @if $rfs-class == disable and $rfs-mode == max-media-query {\n    // Adding an extra class increases specificity, which prevents the media query to override the property\n    &,\n    .disable-rfs &,\n    &.disable-rfs {\n      @content;\n    }\n  }\n  @else if $rfs-class == enable and $rfs-mode == min-media-query {\n    .enable-rfs &,\n    &.enable-rfs {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Internal mixin that adds enable classes to the selector if needed.\n@mixin _rfs-media-query-rule {\n\n  @if $rfs-class == enable {\n    @if $rfs-mode == min-media-query {\n      @content;\n    }\n\n    @include _rfs-media-query () {\n      .enable-rfs &,\n      &.enable-rfs {\n        @content;\n      }\n    }\n  }\n  @else {\n    @if $rfs-class == disable and $rfs-mode == min-media-query {\n      .disable-rfs &,\n      &.disable-rfs {\n        @content;\n      }\n    }\n    @include _rfs-media-query () {\n      @content;\n    }\n  }\n}\n\n// Helper function to get the formatted non-responsive value\n@function rfs-value($values) {\n  // Convert to list\n  $values: if(type-of($values) != list, ($values,), $values);\n\n  $val: \"\";\n\n  // Loop over each value and calculate value\n  @each $value in $values {\n    @if $value == 0 {\n      $val: $val + \" 0\";\n    }\n    @else {\n      // Cache $value unit\n      $unit: if(type-of($value) == \"number\", unit($value), false);\n\n      @if $unit == px {\n        // Convert to rem if needed\n        $val: $val + \" \" + if($rfs-unit == rem, #{divide($value, $value * 0 + $rfs-rem-value)}rem, $value);\n      }\n      @else if $unit == rem {\n        // Convert to px if needed\n        $val: $val + \" \" + if($rfs-unit == px, #{divide($value, $value * 0 + 1) * $rfs-rem-value}px, $value);\n      } @else {\n        // If $value isn't a number (like inherit) or $value has a unit (not px or rem, like 1.5em) or $ is 0, just print the value\n        $val: $val + \" \" + $value;\n      }\n    }\n  }\n\n  // Remove first space\n  @return unquote(str-slice($val, 2));\n}\n\n// Helper function to get the responsive value calculated by RFS\n@function rfs-fluid-value($values) {\n  // Convert to list\n  $values: if(type-of($values) != list, ($values,), $values);\n\n  $val: \"\";\n\n  // Loop over each value and calculate value\n  @each $value in $values {\n    @if $value == 0 {\n      $val: $val + \" 0\";\n    } @else {\n      // Cache $value unit\n      $unit: if(type-of($value) == \"number\", unit($value), false);\n\n      // If $value isn't a number (like inherit) or $value has a unit (not px or rem, like 1.5em) or $ is 0, just print the value\n      @if not $unit or $unit != px and $unit != rem {\n        $val: $val + \" \" + $value;\n      } @else {\n        // Remove unit from $value for calculations\n        $value: divide($value, $value * 0 + if($unit == px, 1, divide(1, $rfs-rem-value)));\n\n        // Only add the media query if the value is greater than the minimum value\n        @if abs($value) <= $rfs-base-value or not $enable-rfs {\n          $val: $val + \" \" + if($rfs-unit == rem, #{divide($value, $rfs-rem-value)}rem, #{$value}px);\n        }\n        @else {\n          // Calculate the minimum value\n          $value-min: $rfs-base-value + divide(abs($value) - $rfs-base-value, $rfs-factor);\n\n          // Calculate difference between $value and the minimum value\n          $value-diff: abs($value) - $value-min;\n\n          // Base value formatting\n          $min-width: if($rfs-unit == rem, #{divide($value-min, $rfs-rem-value)}rem, #{$value-min}px);\n\n          // Use negative value if needed\n          $min-width: if($value < 0, -$min-width, $min-width);\n\n          // Use `vmin` if two-dimensional is enabled\n          $variable-unit: if($rfs-two-dimensional, vmin, vw);\n\n          // Calculate the variable width between 0 and $rfs-breakpoint\n          $variable-width: #{divide($value-diff * 100, $rfs-breakpoint)}#{$variable-unit};\n\n          // Return the calculated value\n          $val: $val + \" calc(\" + $min-width + if($value < 0, \" - \", \" + \") + $variable-width + \")\";\n        }\n      }\n    }\n  }\n\n  // Remove first space\n  @return unquote(str-slice($val, 2));\n}\n\n// RFS mixin\n@mixin rfs($values, $property: font-size) {\n  @if $values != null {\n    $val: rfs-value($values);\n    $fluid-val: rfs-fluid-value($values);\n\n    // Do not print the media query if responsive & non-responsive values are the same\n    @if $val == $fluid-val {\n      #{$property}: $val;\n    }\n    @else {\n      @include _rfs-rule () {\n        #{$property}: if($rfs-mode == max-media-query, $val, $fluid-val);\n\n        // Include safari iframe resize fix if needed\n        min-width: if($rfs-safari-iframe-resize-bug-fix, (0 * 1vw), null);\n      }\n\n      @include _rfs-media-query-rule () {\n        #{$property}: if($rfs-mode == max-media-query, $fluid-val, $val);\n      }\n    }\n  }\n}\n\n// Shorthand helper mixins\n@mixin font-size($value) {\n  @include rfs($value);\n}\n\n@mixin padding($value) {\n  @include rfs($value, padding);\n}\n\n@mixin padding-top($value) {\n  @include rfs($value, padding-top);\n}\n\n@mixin padding-right($value) {\n  @include rfs($value, padding-right);\n}\n\n@mixin padding-bottom($value) {\n  @include rfs($value, padding-bottom);\n}\n\n@mixin padding-left($value) {\n  @include rfs($value, padding-left);\n}\n\n@mixin margin($value) {\n  @include rfs($value, margin);\n}\n\n@mixin margin-top($value) {\n  @include rfs($value, margin-top);\n}\n\n@mixin margin-right($value) {\n  @include rfs($value, margin-right);\n}\n\n@mixin margin-bottom($value) {\n  @include rfs($value, margin-bottom);\n}\n\n@mixin margin-left($value) {\n  @include rfs($value, margin-left);\n}\n","// stylelint-disable property-disallowed-list\n// Single side border-radius\n\n// Helper function to replace negative values with 0\n@function valid-radius($radius) {\n  $return: ();\n  @each $value in $radius {\n    @if type-of($value) == number {\n      $return: append($return, max($value, 0));\n    } @else {\n      $return: append($return, $value);\n    }\n  }\n  @return $return;\n}\n\n// scss-docs-start border-radius-mixins\n@mixin border-radius($radius: $border-radius, $fallback-border-radius: false) {\n  @if $enable-rounded {\n    border-radius: valid-radius($radius);\n  }\n  @else if $fallback-border-radius != false {\n    border-radius: $fallback-border-radius;\n  }\n}\n\n@mixin border-top-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n    border-top-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-right-radius: valid-radius($radius);\n    border-bottom-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-bottom-right-radius: valid-radius($radius);\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-top-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-top-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-bottom-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n// scss-docs-end border-radius-mixins\n","/*     General overwrite     */\nbody,\n.wrapper{\n    min-height: 100vh;\n    position: relative;\n}\na{\n  color: $info-color;\n\n  &:hover, &:focus{\n     color: $info-states-color;\n     text-decoration: none;\n  }\n}\n\na:focus, a:active,\nbutton::-moz-focus-inner,\ninput::-moz-focus-inner,\ninput[type=\"reset\"]::-moz-focus-inner,\ninput[type=\"button\"]::-moz-focus-inner,\ninput[type=\"submit\"]::-moz-focus-inner,\nselect::-moz-focus-inner,\ninput[type=\"file\"] > input[type=\"button\"]::-moz-focus-inner{\n    outline:0;\n}\n.ui-slider-handle:focus,\n.navbar-toggle,\ninput:focus {\n    outline : 0 !important;\n}\n\n/*           Animations              */\n.form-control,\n.input-group-addon,\n.tagsinput,\n.navbar,\n.navbar .alert{\n    @include transition($general-transition-time, $transition-linear);\n}\n\n\n.animation-transition-fast,\n.sidebar .nav .collapse a > span,\n.sidebar .sidebar-wrapper > .nav p,\n.sidebar .user .info > a > span,\n.sidebar .logo a.logo-normal,\n.sidebar .user .info .collapse .nav a > span {\n    @include transition($fast-transition-time, $transition-linear);\n}\n\n.sidebar .nav a,\n.table > tbody > tr .td-actions .btn{\n    @include transition($fast-transition-time, $transition-ease-in);\n}\n\n.btn{\n    @include transition($ultra-fast-transition-time, $transition-ease-in);\n}\n.fa,.fas,.far,.fal,.fad,.fab{\n    width: 18px;\n    text-align: center;\n}\n.margin-top{\n    margin-top: 50px;\n}\n\n.wrapper{\n    position: relative;\n    top: 0;\n    height: 100vh;\n}\n\n.card .map{\n    height: 400px;\n\n    .map-big{\n        height: 350px;\n    }\n}\n\n\n// documentation\n\n.page-header{\n    .page-header-image{\n        background-position: center center;\n        background-size: cover;\n        height: 450px;\n        overflow: hidden;\n        width: 100%;\n        z-index: 1;\n    }\n    .title-container{\n        color: #fff;\n        position: relative;\n        top: 200px;\n        z-index: 3;\n    }\n    .filter:after{\n        background: rgba(0, 0, 0, 0) linear-gradient(to bottom, #9368e9 0%, #943bea 100%) repeat scroll 0 0 / 150% 150%;\n        content: \"\";\n        display: block;\n        height: 450px;\n        left: 0;\n        opacity: 0.77;\n        position: absolute;\n        top: 0;\n        width: 100%;\n        z-index: 2;\n    }\n}\n\n// accordion\n\n.form-control,\n.input-group-addon,\n.tagsinput,\n.navbar .alert,\n.card-collapse.collapse{\n    -webkit-transition: all 300ms linear;\n    -moz-transition: all 300ms linear;\n    -o-transition: all 300ms linear;\n    -ms-transition: all 300ms linear;\n    transition: all 300ms linear;\n}\n\n.card{\n    .card-body.content-full-width{\n        padding: 15px 0px 10px 0px;\n\n        .accordions{\n            .card-title{\n                a{\n                    padding: 0px 0px 5px 15px;\n                }\n            }\n        }\n    }\n}\n","// User select\n// For selecting text on the page\n\n@mixin user-select($select) {\n  -webkit-user-select: $select;\n     -moz-user-select: $select;\n      -ms-user-select: $select; // IE10+\n          user-select: $select;\n}\n\n@mixin box-shadow($shadow...) {\n  -webkit-box-shadow: $shadow; // iOS <4.3 & Android <4.1\n          box-shadow: $shadow;\n}\n\n// Transition w/ opacity\n\n@mixin transition-opacity($time, $type){\n    -webkit-transition: opacity $time $type;\n    -moz-transition: opacity $time $type;\n    -o-transition: opacity $time $type;\n    -ms-transition: opacity $time $type;\n    transition: opacity $time $type;\n}\n\n// Box sizing\n@mixin box-sizing($boxmodel) {\n  -webkit-box-sizing: $boxmodel;\n     -moz-box-sizing: $boxmodel;\n          box-sizing: $boxmodel;\n}\n\n@mixin transition($time, $type){\n    -webkit-transition: all $time $type;\n    -moz-transition: all $time $type;\n    -o-transition: all $time $type;\n    -ms-transition: all $time $type;\n    transition: all $time $type;\n}\n\n@mixin transform-scale($value){\n     -webkit-transform: scale($value);\n        -moz-transform: scale($value);\n        -o-transform: scale($value);\n        -ms-transform: scale($value);\n        transform: scale($value);\n}\n\n@mixin transform-translate-x($value){\n     -webkit-transform:  translate3d($value, 0, 0);\n        -moz-transform: translate3d($value, 0, 0);\n        -o-transform: translate3d($value, 0, 0);\n        -ms-transform: translate3d($value, 0, 0);\n        transform: translate3d($value, 0, 0);\n}\n\n@mixin transform-translate-3d($value){\n    -webkit-transform: translate3d($value, 0, 0);\n    -moz-transform: translate3d($value, 0, 0);\n    -o-transform: translate3d($value, 0, 0);\n    -ms-transform: translate3d($value, 0, 0);\n    transform: translate3d($value, 0, 0);\n}\n\n@mixin transform-translate-y($value){\n     -webkit-transform:  translate3d(0, $value, 0);\n        -moz-transform: translate3d(0, $value, 0);\n        -o-transform: translate3d(0, $value, 0);\n        -ms-transform: translate3d(0, $value, 0);\n        transform: translate3d(0, $value, 0);\n}\n\n@mixin transform-translate-y-dropdown($value){\n     -webkit-transform:  translate3d(0, $value, 0) !important;\n        -moz-transform: translate3d(0, $value, 0) !important;\n        -o-transform: translate3d(0, $value, 0) !important;\n        -ms-transform: translate3d(0, $value, 0) !important;\n        transform: translate3d(0, $value, 0) !important;\n}\n\n@mixin transform-origin($coordinates){\n      -webkit-transform-origin: $coordinates;\n        -moz-transform-origin: $coordinates;\n        -o-transform-origin: $coordinates;\n        -ms-transform-origin: $coordinates;\n        transform-origin: $coordinates;\n}\n\n@mixin icon-gradient ($top-color, $bottom-color){\n    background: $top-color;\n    background: -moz-linear-gradient(top,  $top-color 0%, $bottom-color 100%);\n    background: -webkit-gradient(linear, left top, left bottom, color-stop(0%,$top-color), color-stop(100%,$bottom-color));\n    background: -webkit-linear-gradient(top,  $top-color 0%,$bottom-color 100%);\n    background: -o-linear-gradient(top,  $top-color 0%,$bottom-color 100%);\n    background: -ms-linear-gradient(top,  $top-color 0%,$bottom-color 100%);\n    background: linear-gradient(to bottom,  $top-color 0%,$bottom-color 100%);\n    background-size: 150% 150%;\n}\n\n@mixin radial-gradient($extern-color, $center-color){\n    background: $extern-color;\n    background: -moz-radial-gradient(center, ellipse cover, $center-color 0%, $extern-color 100%); /* FF3.6+ */\n    background: -webkit-gradient(radial, center center, 0px, center center, 100%, color-stop(0%,$center-color), color-stop(100%,$extern-color)); /* Chrome,Safari4+ */\n    background: -webkit-radial-gradient(center, ellipse cover, $center-color 0%,$extern-color 100%); /* Chrome10+,Safari5.1+ */\n    background: -o-radial-gradient(center, ellipse cover, $center-color 0%,$extern-color 100%); /* Opera 12+ */\n    background: -ms-radial-gradient(center, ellipse cover, $center-color 0%,$extern-color 100%); /* IE10+ */\n    background: radial-gradient(ellipse at center, $center-color 0%,$extern-color 100%); /* W3C */\n    background-size: 550% 450%;\n}\n\n@mixin vertical-align {\n  position: relative;\n  top: 50%;\n  -webkit-transform: translateY(-50%);\n  -ms-transform: translateY(-50%);\n  transform: translateY(-50%);\n}\n\n@mixin rotate-180(){\n    filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=2);\n    -webkit-transform: rotate(180deg);\n    -ms-transform: rotate(180deg);\n    transform: rotate(180deg);\n}\n\n@mixin bar-animation($type){\n     -webkit-animation: $type 500ms linear 0s;\n     -moz-animation: $type 500ms linear 0s;\n     animation: $type 500ms 0s;\n     -webkit-animation-fill-mode: forwards;\n     -moz-animation-fill-mode: forwards;\n     animation-fill-mode: forwards;\n}\n\n@mixin topbar-x-rotation(){\n    @keyframes topbar-x {\n      0% {top: 0px; transform: rotate(0deg); }\n      45% {top: 6px; transform: rotate(145deg); }\n      75% {transform: rotate(130deg); }\n      100% {transform: rotate(135deg); }\n    }\n    @-webkit-keyframes topbar-x {\n      0% {top: 0px; -webkit-transform: rotate(0deg); }\n      45% {top: 6px; -webkit-transform: rotate(145deg); }\n      75% {-webkit-transform: rotate(130deg); }\n      100% { -webkit-transform: rotate(135deg); }\n    }\n    @-moz-keyframes topbar-x {\n      0% {top: 0px; -moz-transform: rotate(0deg); }\n      45% {top: 6px; -moz-transform: rotate(145deg); }\n      75% {-moz-transform: rotate(130deg); }\n      100% { -moz-transform: rotate(135deg); }\n    }\n}\n\n@mixin topbar-back-rotation(){\n    @keyframes topbar-back {\n      0% { top: 6px; transform: rotate(135deg); }\n      45% { transform: rotate(-10deg); }\n      75% { transform: rotate(5deg); }\n      100% { top: 0px; transform: rotate(0); }\n    }\n\n    @-webkit-keyframes topbar-back {\n      0% { top: 6px; -webkit-transform: rotate(135deg); }\n      45% { -webkit-transform: rotate(-10deg); }\n      75% { -webkit-transform: rotate(5deg); }\n      100% { top: 0px; -webkit-transform: rotate(0); }\n    }\n\n    @-moz-keyframes topbar-back {\n      0% { top: 6px; -moz-transform: rotate(135deg); }\n      45% { -moz-transform: rotate(-10deg); }\n      75% { -moz-transform: rotate(5deg); }\n      100% { top: 0px; -moz-transform: rotate(0); }\n    }\n}\n\n@mixin bottombar-x-rotation(){\n    @keyframes bottombar-x {\n      0% {bottom: 0px; transform: rotate(0deg);}\n      45% {bottom: 6px; transform: rotate(-145deg);}\n      75% {transform: rotate(-130deg);}\n      100% {transform: rotate(-135deg);}\n    }\n    @-webkit-keyframes bottombar-x {\n      0% {bottom: 0px; -webkit-transform: rotate(0deg);}\n      45% {bottom: 6px; -webkit-transform: rotate(-145deg);}\n      75% {-webkit-transform: rotate(-130deg);}\n      100% {-webkit-transform: rotate(-135deg);}\n    }\n    @-moz-keyframes bottombar-x {\n      0% {bottom: 0px; -moz-transform: rotate(0deg);}\n      45% {bottom: 6px; -moz-transform: rotate(-145deg);}\n      75% {-moz-transform: rotate(-130deg);}\n      100% {-moz-transform: rotate(-135deg);}\n    }\n}\n\n@mixin bottombar-back-rotation{\n    @keyframes bottombar-back {\n      0% { bottom: 6px;transform: rotate(-135deg);}\n      45% { transform: rotate(10deg);}\n      75% { transform: rotate(-5deg);}\n      100% { bottom: 0px;transform: rotate(0);}\n    }\n    @-webkit-keyframes bottombar-back {\n      0% {bottom: 6px;-webkit-transform: rotate(-135deg);}\n      45% {-webkit-transform: rotate(10deg);}\n      75% {-webkit-transform: rotate(-5deg);}\n      100% {bottom: 0px;-webkit-transform: rotate(0);}\n    }\n    @-moz-keyframes bottombar-back {\n      0% {bottom: 6px;-moz-transform: rotate(-135deg);}\n      45% {-moz-transform: rotate(10deg);}\n      75% {-moz-transform: rotate(-5deg);}\n      100% {bottom: 0px;-moz-transform: rotate(0);}\n    }\n\n}\n",".sidebar,\n.main-panel,\n.sidebar-wrapper,\n.navbar-fixed,\n.navbar-minimize{\n    -webkit-transition-property: top,bottom,width;\n    transition-property: top,bottom, width;\n    -webkit-transition-duration: .2s,.2s, .35s;\n    transition-duration: .2s,.2s, .35s;\n    -webkit-transition-timing-function: linear,linear,ease;\n    transition-timing-function: linear,linear,ease;\n    -webkit-overflow-scrolling: touch;\n}\n.animation-transition-general,\n.sidebar .nav p,\n.sidebar .user .photo,\n.bootstrap-navbar .user .photo,\n.sidebar .user a,\n.bootstrap-navbar .user a,\n.login-page .card{\n    @include transition (300ms, linear);\n}\n\n\n    // THE SIDEBAR\n\n.sidebar{\n    position: fixed;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    width: 260px;\n    display: block;\n    z-index: 999;\n    color: #fff;\n    font-weight: 200;\n    background-size: cover;\n    background-position: center center;\n\n    .logo-img{\n        width: 30px;\n        display: inline-block;\n        max-height: 30px;\n\n        img{\n            width: 35px;\n            top: 1px;\n            position: absolute;\n            left: 0px;\n        }\n    }\n\n    .logo{\n        padding: 12px 0px 9px;\n        margin: 0;\n        position: relative;\n        z-index: 4;\n        display: block;\n\n        a.logo-mini{\n            /*float: left;\n            width: 30px;\n            text-align: center;\n            margin-left: 23px;\n            margin-right: 15px;\n            position: relative;*/\n            display: none;\n        }\n\n        a.logo-normal{\n            display: block;\n            opacity: 1;\n            @include transform-translate-x(0px);\n        }\n\n        .simple-text{\n            text-transform: uppercase;\n            padding: $padding-small-vertical $padding-zero;\n            display: inline-block;\n            font-size: $font-size-large;\n            font-weight: $font-weight-normal;\n            line-height: 30px;\n            white-space: nowrap;\n            color: $white-color;\n            overflow: hidden;\n        }\n\n        p{\n            float: left;\n            font-size: 20px;\n            margin: 10px 10px;\n            line-height: 20px;\n        }\n\n        &:before{\n            content: \"\";\n            position: absolute;\n            bottom: 0px;\n            right: 15px;\n            width: calc(100% - 30px);\n            height: 1px;\n        }\n    }\n\n    .sidebar-wrapper{\n        position: relative;\n        max-height: calc(100vh - 75px);\n        min-height: 100%;\n        overflow: auto;\n        width: 260px;\n        z-index: 4;\n        padding-bottom: 100px;\n\n        .nav .nav-item {\n            [data-toggle=\"collapse\"] ~ div{\n                .nav{\n                    .nav-item{\n                        .nav-link{\n                            background: transparent;\n                            padding-left: 55px;\n                            text-transform: capitalize;\n                            padding: 5px 15px 5px 15px;\n                            font-weight: 400;\n                            font-size: 14px;\n                        }\n\n                        &:hover,\n                        &:focus,\n                        &.active{\n                            .nav-link{\n                                background: rgba(255, 255, 255, 0.13);\n                            }\n                        }\n                    }\n                    .sidebar-normal{\n                        left: 15px;\n                    }\n                }\n            }\n        }\n\n        .nav .nav-link{\n            p{\n                margin: 0;\n                line-height: 30px;\n                font-size: 12px;\n                font-weight: 600;\n                text-transform: uppercase;\n                white-space: nowrap;\n                position: relative;\n                color: $info-color;\n                @include transform-translate-x(0px);\n                display: block;\n                height: auto;\n                opacity: 1;\n            }\n        }\n\n        .navbar-form.navbar-search-form{\n            margin-top: 15px;\n            padding-left: 25px;\n\n            input{\n                padding-left: 10px;\n                padding-top: 5px;\n            }\n        }\n    }\n\n    .sidebar-background{\n        /* For browsers that do not support gradients */\n        background: $color-azure;\n        /* For Safari 5.1 to 6.0 */\n        background: -webkit-linear-gradient($default-color-top, #29b1fa, $default-color-bottom);\n        /* For Opera 11.1 to 12.0 */\n        background: -o-linear-gradient($default-color-top, #29b1fa, $default-color-bottom);\n        /* For Firefox 3.6 to 15 */\n        background: -moz-linear-gradient($default-color-top, #29b1fa, $default-color-bottom);\n        /* Standard syntax */\n        background: linear-gradient($default-color-top, #29b1fa, $default-color-bottom);\n        padding: 0px;\n        min-height: 100%;\n        position: absolute;\n        z-index: 1;\n        height: 100%;\n        width: 100%;\n        display: block;\n        top: 0;\n        left: 0;\n        background-size: cover;\n        background-position: center center;\n    }\n\n    .user{\n        border-bottom: 1px solid rgba(255, 255, 255, 0.2);\n        padding-bottom: 20px;\n        margin-top: 20px;\n\n        .photo{\n            width: 34px;\n            height: 34px;\n            overflow: hidden;\n            border-radius: 50%;\n            float: left;\n            margin-right: 11px;\n            margin-left: 23px;\n            z-index: 5;\n            border: 2px solid rgba(255, 255, 255, 0.3);\n\n            img{\n                width: 100%;\n            }\n        }\n        .info{\n            .caret{\n                right: 15px;\n                top: -5px;\n            }\n            a{\n                color: $white-color;\n                padding: 8px 14px;\n                display: block;\n                white-space: nowrap;\n                line-height: 18px;\n            }\n            span{\n                position: relative;\n                display: block;\n            }\n            .collapse{\n                .sidebar-normal{\n                    padding-left: 0;\n                }\n            }\n        }\n\n        .profile-dropdown{\n            text-align: left !important;\n            padding-left: 25px !important;\n\n            .sidebar-mini,\n            .sidebar-normal{\n                margin-right: 0;\n                font-size: 14px;\n            }\n            .sidebar-normal{\n                left: 15px;\n            }\n        }\n    }\n\n    .caret{\n        display: inline-block;\n        width: 0;\n        height: 0;\n        vertical-align: middle;\n        border-top: 4px dashed;\n        border-top: 4px solid\\9;\n        border-right: 4px solid transparent;\n        border-left: 4px solid transparent;\n        margin-top: 13px;\n        position: absolute;\n        right: 0;\n        @include transition(150ms, ease-in);\n    }\n\n    a[data-toggle=\"collapse\"][aria-expanded=\"true\"] .caret,\n    .btn[data-toggle=\"collapse\"][aria-expanded=\"true\"] .caret,\n    a.dropdown-toggle[aria-expanded=\"true\"] .caret{\n        filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=2);\n        -webkit-transform: rotate(180deg);\n        -ms-transform: rotate(180deg);\n        transform: rotate(180deg);\n    }\n\n    .nav{\n        float: none;\n        display: block;\n\n        .nav-item{\n            .nav-link{\n                color: $info-color;\n                margin: 5px 15px 0px 10px;\n                opacity: .86;\n                border-radius: 4px;\n                text-transform: uppercase;\n                line-height: 30px;\n                font-size: 12px;\n                font-weight: 600;\n                padding: 10px 15px;\n                white-space: nowrap;\n\n                &:hover{\n                    color: darken($info-color, 25%);\n                    background: rgba(255, 255, 255, 0.13);\n                    opacity: 1;\n                }\n\n                i{\n                    font-size: 28px;\n                    margin-right: 15px;\n                    width: 30px;\n                    text-align: center;\n                    vertical-align: middle;\n                    float: left;\n                }\n            }\n\n            &:not(.collapse .nav-link):hover .nav-link{\n                background: rgba(255,255,255,0.13);\n                opacity: 1;\n            }\n\n            &.active .nav-link{\n                color: darken($info-color, 25%);\n                opacity: 1;\n                background: rgba(255,255,255,0.23);\n\n            }\n\n            &.separator{\n                margin: 15px 0;\n                border-bottom: 1px solid rgba(255, 255, 255, 0.2);\n\n                & + .nav-item {\n                    margin-top: 31px;\n                }\n            }\n\n        }\n\n    }\n\n    &:after,\n    &:before{\n        display: block;\n        content: \"\";\n        position: absolute;\n        width: 100%;\n        height: 100%;\n        top: 0;\n        left: 0;\n        z-index: 2;\n    }\n\n    &:before{\n        opacity: .33;\n        background: #aaa;\n    }\n\n\n    &[data-image]:after,\n    &.has-image:after{\n        opacity: .95;\n    }\n}\n\n\n.sidebar,\n.bootstrap-navbar{\n    .logo{\n\n        p{\n            float: left;\n            font-size: 20px;\n            margin: 10px 10px;\n            color: $white-color;\n            line-height: 20px;\n            font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n        }\n\n        .logo-text{\n            text-transform: uppercase;\n            padding: 5px 0px 5px 15px;\n            display: block;\n            font-size: $font-size-large;\n            color: $white-color;\n            font-weight: $font-weight-normal;\n            line-height: 30px;\n            white-space: nowrap;\n            overflow: hidden;\n        }\n\n        .logo-image{\n            float: left;\n            height: 40px;\n            width: 40px;\n            margin: 0 10px;\n        }\n\n        .logo-round{\n            border-radius: 50%;\n            display: block;\n            overflow: hidden;\n\n            img{\n                width: 100%;\n            }\n        }\n\n        &:before{\n            content: \"\";\n            position: absolute;\n            bottom: 0px;\n            right: 15px;\n            width: calc(100% - 30px);\n            height: 1px;\n            background-color: rgba($white-color, 0.3);\n        }\n\n    }\n    .logo-mini{\n        .logo-text{\n            text-transform: uppercase;\n            padding: 7px 0px;\n            display: block;\n            font-size: $font-size-large;\n            color: $white-color;\n            font-weight: $font-weight-normal;\n            line-height: 30px;\n            text-align: center;\n            white-space: nowrap;\n            overflow: hidden;\n        }\n    }\n\n    // colors for the sidebar with an image\n\n    &[data-color=\"black\"]:after{\n        @include icon-gradient($default-states-color, rgba($default-states-color,.7));\n    }\n    &[data-color=\"blue\"]:after{\n        @include icon-gradient($color-blue, rgba($blue-color-bottom,.7));\n    }\n    &[data-color=\"azure\"]:after{\n        @include icon-gradient($color-azure, rgba($azure-color-bottom,.7));\n    }\n    &[data-color=\"green\"]:after{\n        @include icon-gradient($color-green, rgba($green-color-bottom,.7));\n    }\n    &[data-color=\"orange\"]:after{\n        @include icon-gradient($color-orange, rgba($orange-color-bottom,.7));\n    }\n    &[data-color=\"red\"]:after{\n        @include icon-gradient($color-red, rgba($red-color-bottom,.7));\n    }\n    &[data-color=\"purple\"]:after{\n        @include icon-gradient($color-purple, rgba($purple-color-bottom,.7));\n    }\n}\n\n    //  MAIN PANEL\n\n\n.main-panel{\n    background: rgba(203,203,210,.15);\n    position: relative;\n    float: right;\n    width: $sidebar-width;\n\n    .content{\n        padding: 30px 15px;\n        min-height: calc(100vh - 123px);\n    }\n\n    .footer{\n        border-top: 1px solid #e7e7e7;\n    }\n\n    .navbar{\n        margin-bottom: 0;\n    }\n}\n\n\n    // SIDEBAR MINI\n\n.sidebar-mini{\n    .sidebar{\n        .logo{\n            a.logo-mini{\n                float: left;\n                /* width: 30px; */\n                text-align: center;\n                margin-left: 23px;\n                margin-right: 15px;\n                position: relative;\n                display: block;\n            }\n        }\n\n        .sidebar-wrapper{\n            .nav{\n                .nav-item:hover{\n                    .collapse{\n                        .nav-item .nav-link{\n                            padding: 5px 15px;\n                        }\n                    }\n                }\n            }\n        }\n    }\n}\n\n\n.sidebar .sidebar-wrapper .nav [data-toggle=\"collapse\"] ~ div > ul > li > a .sidebar-mini,\n.sidebar .sidebar-wrapper .user .info [data-toggle=\"collapse\"] ~ div > ul > li > a .sidebar-mini{\n    text-transform: uppercase;\n    float: left;\n    width: 30px;\n    text-align: center;\n    // margin-right: 15px;\n    letter-spacing: 1px;\n}\n\n.sidebar .sidebar-wrapper > .nav [data-toggle=\"collapse\"] ~ div > ul > li > a .sidebar-normal,\n.sidebar .sidebar-wrapper .user .info [data-toggle=\"collapse\"] ~ div > ul > li > a .sidebar-normal,\n.off-canvas-sidebar .sidebar-wrapper > .nav [data-toggle=\"collapse\"] ~ div > ul > li > a .sidebar-normal,\n.off-canvas-sidebar .sidebar-wrapper .user .info [data-toggle=\"collapse\"] ~ div > ul > li > a .sidebar-normal{\n    margin: 0;\n    position: relative;\n    transform: translateX(0px);\n    opacity: 1;\n    white-space: nowrap;\n    display: inline-block;\n    line-height: 23px;\n}\n.sidebar .nav .nav-item .nav-link .sidebar-mini{\n    padding-left: 5px !important;\n    opacity: .86 !important;\n\n}\n\n\n@media (min-width: $screen-md) {\n    .sidebar-mini{\n        .visible-on-sidebar-regular{\n            display: none !important;\n        }\n        .visible-on-sidebar-mini{\n            display: inline-block !important;\n        }\n        .sidebar{\n            width: 80px;\n            display: block;\n            font-weight: 200;\n            z-index: 999;\n            position: fixed;\n\n            .logo{\n                a.logo-mini{\n                    opacity: 1;\n                }\n\n                a.logo-normal{\n                    opacity: 0;\n                    @include transform-translate-x(-25px);\n                }\n            }\n\n            .sidebar-wrapper{\n                overflow: inherit;\n                width: 80px;\n                box-shadow: none;\n\n                .nav [data-toggle=\"collapse\"] ~ div > ul > li > a .sidebar-normal,\n                .user .info [data-toggle=\"collapse\"] ~ div > ul > li > a .sidebar-normal,\n                .user .info > a > span,\n                > .nav li > a p{\n                    @include transform-translate-x(-25px);\n                    opacity: 0;\n                }\n            }\n\n            .info{\n                .collapse .nav{\n                    li{\n                        >a{\n                            margin: 0;\n                            border-radius: 0;\n                        }\n                    }\n                }\n                .caret{\n                    opacity: 0;\n                }\n\n                [data-toggle=\"collapse\"] ~ div > ul > li:last-child > a{\n                    margin-bottom: 5px;\n                    border-bottom-left-radius: 3px;\n                    border-bottom-right-radius: 3px;\n                }\n\n                [data-toggle=\"collapse\"] ~ div > ul > li:first-child > a{\n                    margin-top: 5px;\n                    border-top-left-radius: 3px;\n                    border-top-right-radius: 3px;\n                }\n            }\n\n            .nav{\n                .nav-item .nav-link{\n                    .sidebar-mini{\n                        padding-left: 30px !important;\n                    }\n                }\n            }\n\n            &:hover{\n                width: 260px;\n\n                .logo{\n                    a.logo-normal{\n                        opacity: 1;\n                        @include transform-translate-x(0px);\n                    }\n                }\n\n                .nav-item [data-toggle=\"collapse\"] ~ div .nav .sidebar-normal{\n                    left: 0;\n                }\n\n                .caret{\n                    opacity: 1;\n                }\n\n                .sidebar-wrapper{\n                    width: 260px;\n\n                    > .nav li > a p,\n                    > .nav [data-toggle=\"collapse\"] ~ div > ul > li > a .sidebar-normal,\n                    .user .info [data-toggle=\"collapse\"] ~ div > ul > li > a .sidebar-normal,\n                    .user .info > a > p,\n                    > .nav li > a .caret,\n                    .user .info a span{\n                        @include transform-translate-x(0px);\n                        opacity: 1;\n                    }\n\n                    > .nav{\n                        li.active{\n                            > a:not([data-toggle=\"collapse\"]){\n                                &:before,\n                                &:after{\n                                   opacity: 0;\n                                }\n                            }\n                        }\n                    }\n                }\n\n                .nav{\n                    .nav-item .nav-link{\n                        .sidebar-mini{\n                            margin-right: 5px !important;\n                        }\n                    }\n                }\n\n                .sidebar-normal{\n                    padding-left: 10px;\n                    padding-right: 10px;\n                    margin: 5px 15px 0px;\n                    border-radius: 4px;\n                    color: #FFFFFF;\n                    opacity: .86;\n                }\n            }\n        }\n\n        .main-panel{\n            width: calc(100% - 80px);\n            margin-left: 80px;\n        }\n\n        .wrapper{\n            height: auto;\n        }\n\n        .sidebar,\n        .main-panel{\n            overflow: visible;\n            max-height: none;\n            height: auto;\n        }\n\n        .navbar-fixed{\n            width: calc(100% - 80px) !important;\n        }\n    }\n}\n\n\n\n.visible-on-sidebar-regular{\n    display: inline-block !important;\n}\n.visible-on-sidebar-mini{\n    display: none !important;\n}\n.navbar-minimize{\n    margin-right: 15px;\n}\n\n\n\n\n\n// Pages Design\n\n.wrapper-full-page{\n    min-height: 100vh;\n    height: 100%;\n\n    .navbar{\n        z-index: 1030;\n        .nav-link{\n            i{\n                font-size: 18px;\n                position: relative;\n                right: 10px;\n                text-align: center;\n            }\n        }\n\n        .nav-item.active{\n            .nav-link{\n                background-color: rgba(255, 255, 255, 0.2) !important;\n            }\n        }\n        .nav-link:not(.btn):hover{\n            background-color: rgba(255, 255, 255, 0.2) !important;\n            border-radius: 0.1875rem;\n            @include transition (300ms, linear);\n        }\n        .navbar-nav{\n            .nav-item .nav-link{\n                padding: 3px 15px;\n            }\n        }\n    }\n\n    .footer{\n        position: relative;\n        z-index: 2;\n        background: transparent;\n        .copyright{\n            color: rgba(255, 255, 255, 0.7);\n            a{\n                opacity: 1;\n            }\n        }\n    }\n}\n\n.full-page{\n    .full-page-background{\n        position: absolute;\n        z-index: 1;\n        height: 100%;\n        width: 100%;\n        display: block;\n        top: 0;\n        left: 0;\n        background-size: cover;\n        background-position: center center;\n    }\n\n    &:before,\n    &:after{\n        display: block;\n        content: \"\";\n        position: absolute;\n        width: 100%;\n        height: 100%;\n        top: 0;\n        left: 0;\n        z-index: 2;\n    }\n\n    &:before{\n        opacity: .33;\n        background: #000000;\n    }\n\n    &.register-page{\n        .content:first-of-type{\n            padding-top: 10vh;\n        }\n    }\n\n    > .content{\n        min-height: calc(100vh - 70px);\n        z-index: 4;\n        position: relative;\n\n        .card-register{\n            .card-title{\n                color: $white-color;\n            }\n            .card-subtitle{\n                margin-top: 10px;\n                margin-bottom: 0;\n                font-size: 21px;\n                color: $white-color;\n            }\n            .footer{\n                background-color: transparent;\n            }\n            .content{\n                padding-top: 5%;\n            }\n\n            .media{\n                color: #FFFFFF;\n                margin-bottom: 15px;\n\n                .icon{\n                    float: left;\n                    margin-right: 5px;\n                    i{\n                        font-size: 36px;\n                    }\n                }\n\n                .media-left,\n                .media-body{\n                    display: table-cell;\n                    vertical-align: top;\n                }\n                .media-body{\n                    overflow: hidden;\n                }\n                h4{\n                    margin: 0 0 5px 15px;\n                    text-align: left;\n                }\n                p{\n                    text-align: justify;\n                    margin-left: 15px;\n                }\n            }\n        }\n    }\n\n    >.content:first-of-type{\n        padding-top: 20vh;\n    }\n\n    &.register-page{\n        .content{\n            padding-top: 10vh;\n        }\n    }\n    &[data-color=\"black\"]:after{\n        @include icon-gradient($default-states-color, $default-states-color);\n    }\n    &[data-color=\"blue\"]:after{\n        @include icon-gradient($new-dark-blue, $blue-color-bottom);\n    }\n    &[data-color=\"azure\"]:after{\n        @include icon-gradient($new-blue, $azure-color-bottom);\n    }\n    &[data-color=\"green\"]:after{\n        @include icon-gradient($new-green, $green-color-bottom);\n    }\n    &[data-color=\"orange\"]:after{\n        @include icon-gradient($new-orange, $orange-color-bottom);\n    }\n    &[data-color=\"red\"]:after{\n        @include icon-gradient($new-red, $red-color-bottom);\n    }\n    &[data-color=\"purple\"]:after{\n        @include icon-gradient($new-purple, $purple-color-bottom);\n    }\n}\n.full-page[data-image]:after,\n.full-page.has-image:after{\n    opacity: .77;\n}\n",".fixed-plugin{\n    .dropdown{\n        .dropdown-menu{\n            border-radius: 10px;\n            li.adjustments-line{\n                border-bottom: 1px solid #ddd;\n            }\n            li{\n                padding: 5px 2px !important;\n            }\n            .button-container{\n                a{\n                    font-size: 14px;\n                }\n            }\n            .adjustments-line{\n                .bootstrap-switch{\n                    position: absolute;\n                    right: 10px !important;\n                }\n                label{\n                    margin-bottom: .6rem !important;\n                }\n            }\n        }\n    }\n}\n\n.fixed-plugin li > a,\n.fixed-plugin .badge{\n    transition: all .34s;\n    -webkit-transition: all .34s;\n    -moz-transition: all .34s;\n}\n\n.fixed-plugin{\n    position: fixed;\n    top: 200px;\n    right: 0;\n    width: 64px;\n    background: rgba(0,0,0,.3);\n    z-index: 1031;\n    border-radius: 8px 0 0 8px;\n    text-align: center;\n}\n.fixed-plugin .fa-cogs{\n    color: #FFFFFF;\n    padding: 10px;\n    border-radius: 0 0 6px 6px;\n    width: auto;\n}\n.fixed-plugin .dropdown-menu{\n    right: 80px;\n    left: auto;\n    width: 290px;\n    border-radius: 0.1875rem;\n    padding: 0 10px;\n}\n.fixed-plugin .dropdown-menu:after, .fixed-plugin .dropdown-menu:before{\n    right: 10px;\n    margin-left: auto;\n    left: auto;\n}\n.fixed-plugin .fa-circle-thin{\n    color: #FFFFFF;\n}\n.fixed-plugin .active .fa-circle-thin{\n    color: #00bbff;\n}\n\n.fixed-plugin .dropdown-menu > .active > a,\n.fixed-plugin .dropdown-menu > .active > a:hover,\n.fixed-plugin .dropdown-menu > .active > a:focus{\n    color: #777777;\n    text-align: center;\n}\n\n.fixed-plugin img{\n    border-radius: 0;\n    width: 100%;\n    height: 100px;\n    margin: 0 auto;\n}\n\n.fixed-plugin .dropdown-menu li > a:hover,\n.fixed-plugin .dropdown-menu li > a:focus{\n    box-shadow: none;\n}\n\n.fixed-plugin .badge{\n    border: 3px solid #FFFFFF;\n    border-radius: 50%;\n    cursor: pointer;\n    display: inline-block;\n    height: 23px;\n    margin-right: 5px;\n    position: relative;\n    width: 23px;\n}\n.fixed-plugin .badge.active,\n.fixed-plugin .badge:hover{\n    border-color: #00bbff;\n}\n\n.fixed-plugin .badge-black{\n    background-color: #777;\n}\n.fixed-plugin .badge-azure{\n    background-color: #2CA8FF;\n}\n.fixed-plugin .badge-green{\n    background-color: #18ce0f;\n}\n.fixed-plugin .badge-orange{\n    background-color: #f96332;\n}\n.fixed-plugin .badge-yellow{\n    background-color: #FFB236;\n}\n.fixed-plugin .badge-red{\n    background-color: #FF3636;\n}\n.fixed-plugin .badge-purple{\n    background-color: #9368E9;\n}\n\n.fixed-plugin h5{\n    font-size: 14px;\n    margin: 10px;\n}\n.fixed-plugin .dropdown-menu li{\n    display: block;\n    padding: 18px 2px;\n    width: 25%;\n    float: left;\n}\n\n.fixed-plugin li.adjustments-line,\n.fixed-plugin li.header-title,\n.fixed-plugin li.button-container{\n    width: 100%;\n    height: 50px;\n    min-height: inherit;\n}\n\n.fixed-plugin li.button-container{\n    height: auto;\n}\n.fixed-plugin li.button-container div{\n    margin-bottom: 5px;\n}\n\n.fixed-plugin #sharrreTitle{\n    text-align: center;\n    padding: 10px 0;\n    height: 50px;\n}\n\n.fixed-plugin li.header-title{\n    height: 30px;\n    line-height: 25px;\n    font-size: 12px;\n    font-weight: 600;\n    text-transform: uppercase;\n}\n\n.fixed-plugin .adjustments-line p{\n    float: left;\n    display: inline-block;\n    margin-bottom: 0;\n    font-size: 1em;\n    color: #3C4858;\n    padding-top: 7px;\n}\n\n.fixed-plugin .adjustments-line a .badge-colors{\n    position: relative;\n    top: -2px;\n}\n\n.fixed-plugin .adjustments-line .togglebutton{\n    float: right;\n}\n\n.fixed-plugin .adjustments-line .togglebutton .toggle{\n    margin-right: 0;\n}\n\n.fixed-plugin .dropdown-menu > li.adjustments-line > a{\n      padding-right: 0;\n      padding-left: 0;\n      /*border-bottom: 1px solid #ddd;*/\n      border-radius: 0;\n      margin: 0;\n}\n.fixed-plugin .dropdown-menu > li > a.img-holder{\n      font-size: 16px;\n      text-align: center;\n      border-radius: 10px;\n      background-color: #FFF;\n      border: 3px solid #FFF;\n      padding-left: 0;\n      padding-right: 0;\n      opacity: 1;\n      cursor: pointer;\n      display: block;\n      max-height: 100px;\n      overflow: hidden;\n      padding: 0;\n}\n\n.fixed-plugin .dropdown-menu > li > a.switch-trigger:hover,\n.fixed-plugin .dropdown-menu > li > a.switch-trigger:focus{\n    background-color: transparent;\n}\n.fixed-plugin .dropdown-menu > li:hover > a.img-holder,\n.fixed-plugin .dropdown-menu > li:focus > a.img-holder{\n    border-color: rgba(0, 187, 255, 0.53);;\n}\n.fixed-plugin .dropdown-menu > .active > a.img-holder,\n.fixed-plugin .dropdown-menu > .active > a.img-holder{\n    border-color: #00bbff;\n    background-color: #FFFFFF;\n}\n\n.fixed-plugin .dropdown-menu > li > a img{\n    margin-top: auto;\n}\n\n.fixed-plugin .btn-social{\n    width: 50%;\n    display: block;\n    width: 48%;\n    float: left;\n    font-weight: 600;\n}\n.fixed-plugin .btn-social i{\n    margin-right: 5px;\n}\n.fixed-plugin .btn-social:first-child{\n    margin-right: 2%;\n}\n\n.fixed-plugin .adjustments-line a:hover,\n.fixed-plugin .adjustments-line a:focus,\n.fixed-plugin .adjustments-line a{\n    color: transparent;\n}\n\n.fixed-plugin .dropdown .dropdown-menu{\n    @include transform-translate-y-dropdown(-5%);\n    top: -40px !important;\n    opacity: 0;\n    left: -303px !important;\n    transform-origin: 0 0;\n}\n.fixed-plugin .dropdown.show .dropdown-menu{\n    opacity: 1;\n    @include transform-translate-y-dropdown(0%);\n    transform-origin: 0 0;\n    left: -303px !important;\n}\n\n.fixed-plugin .dropdown-menu:before,\n.fixed-plugin .dropdown-menu:after{\n    content: \"\";\n    display: inline-block;\n    position: absolute;\n    top: 65px;\n    width: 16px;\n    transform: translateY(-50%);\n    -webkit-transform: translateY(-50%);\n    -moz-transform: translateY(-50%);\n\n}\n.fixed-plugin .dropdown-menu:before{\n    border-bottom: 16px solid rgba(0, 0, 0, 0);\n    border-left: 16px solid rgba(0,0,0,0.2);\n    border-top: 16px solid rgba(0,0,0,0);\n    right: -16px;\n}\n\n.fixed-plugin .dropdown-menu:after{\n    border-bottom: 16px solid rgba(0, 0, 0, 0);\n    border-left: 16px solid #fff;\n    border-top: 16px solid rgba(0,0,0,0);\n    right: -15px;\n}\n\n.wrapper-full-page ~ .fixed-plugin .dropdown.open .dropdown-menu{\n    -webkit-transform: translateY(-17%);\n    -moz-transform: translateY(-17%);\n    -o-transform: translateY(-17%);\n    -ms-transform: translateY(-17%);\n    transform: translateY(-17%);\n}\n\n.wrapper-full-page ~ .fixed-plugin .dropdown .dropdown-menu{\n    -webkit-transform: translateY(-19%);\n    -moz-transform: translateY(-19%);\n    -o-transform: translateY(-19%);\n    -ms-transform: translateY(-19%);\n    transform: translateY(-19%);\n}\n",".modal-header {\n    border: 0 none;\n}\n.modal-content {\n    border: 0 none;\n    border-radius: 10px;\n    box-shadow: 0 0 15px rgba(0, 0, 0, 0.15), 0 0 1px 1px rgba(0, 0, 0, 0.1);\n}\n.modal-dialog {\n    padding-top: 60px;\n}\n.modal-footer {\n    border-top: 0 none;\n    padding: 10px 10px;        \n}\n.modal-footer .modal-footer .btn-default.btn-simple{\n    font-weight: 400;\n}\n\n.modal.fade .modal-dialog {\n    transform: none;\n    -webkit-transform: none;\n    -moz-transform: none;\n}\n.modal.in .modal-dialog {\n    transform: none;\n    -webkit-transform: none;\n    -moz-transform: none;\n}\n.modal-small{\n    .modal-dialog{\n        max-width: 350px;\n    }\n}\n.modal-small{\n    .divider{\n        margin: 0 auto;\n        display: block;\n        width: 14px;\n        position: relative;\n        margin-top: 40px;\n        margin-bottom: 30px;\n        font-size: $font-paragraph;\n    }\n    .divider:after{\n        position: absolute;\n        content: \"\";\n        right: -140px;\n        top: 12px;\n        height: 1px;\n        width: 115px;\n        background-color: $light-gray;\n    }\n    .divider:before{\n        position: absolute;\n        content: \"\";\n        left: -140px;\n        top: 12px;\n        height: 1px;\n        width: 115px;\n        background-color: $light-gray;\n    }\n    .modal-footer{\n        text-align: center;\n    }\n}\n.social-area{\n    text-align: center;\n    \n    .btn-social{\n        margin: 0 10px;\n    }\n}\n.modal-backdrop.in {\n    opacity: 0.25;\n}\n\n\n\n",".btn{\n    border-width: $border-thick;\n    background-color: $transparent-bg;\n    font-weight: $font-weight-normal;\n    padding: $padding-base-vertical $padding-base-horizontal;\n    @include btn-styles($default-color, $default-states-color);\n    margin-bottom: 5px;\n    font-size: $font-size-base;\n    line-height: 1.42857143;\n\n    &:hover,\n    &:focus{\n        outline: 0 !important;\n        box-shadow: none;\n\n    }\n    &:active,\n    &.active,\n    .open > &.dropdown-toggle {\n         @include box-shadow(none);\n         outline: 0 !important;\n    }\n\n    &.btn-icon{\n        padding: $padding-base-vertical;\n    }\n\n}\n\n// Apply the mixin to the buttons\n// .btn-default { @include btn-styles($default-color, $default-states-color); }\n.btn-primary { @include btn-styles($primary-color, $primary-states-color); }\n.btn-success { @include btn-styles($success-color, $success-states-color); }\n.btn-info    { @include btn-styles($info-color, $info-states-color); }\n.btn-warning { @include btn-styles($warning-color, $warning-states-color); }\n.btn-danger  { @include btn-styles($danger-color, $danger-states-color); }\n.btn-neutral {\n    @include btn-styles($white-color, $white-color);\n\n    &:active,\n    &.active,\n    .open > &.dropdown-toggle{\n         background-color: $white-color;\n         color: $default-color;\n    }\n\n    &.btn-fill,\n    &.btn-fill:hover,\n    &.btn-fill:focus{\n        color: $default-color;\n    }\n\n    &.btn-simple:active,\n    &.btn-simple.active{\n        background-color: transparent;\n    }\n}\n\n.btn{\n     &:disabled,\n     &[disabled],\n     &.disabled{\n        @include opacity(.5);\n    }\n}\n.btn-round{\n    border-width: $border-thin;\n    border-radius: $btn-round-radius !important;\n    padding: $padding-round-vertical $padding-round-horizontal;\n\n    &.btn-icon{\n        padding: $padding-round-vertical;\n    }\n}\n\n.btn-lg{\n   @include btn-size($padding-large-vertical, $padding-large-horizontal, $font-size-large, $border-radius-large);\n   font-weight: $font-weight-normal;\n}\n.btn-sm{\n    @include btn-size($padding-small-vertical, $padding-small-horizontal, $font-size-small, $border-radius-small);\n}\n\n.btn-wd {\n    min-width: 140px;\n}\n\n.btn-group.select{\n    width: 100%;\n}\n.btn-group.select .btn{\n    text-align: left;\n}\n.btn-group.select .caret{\n    position: absolute;\n    top: 50%;\n    margin-top: -1px;\n    right: 8px;\n}\n.btn-social{\n    opacity: 0.85;\n}\n","// Mixin for generating new styles\n@mixin btn-styles($btn-color, $btn-states-color) {\n  border: 1px solid $btn-color;\n  color: $white-color;\n  background-color: $btn-color;\n  cursor: pointer;\n\n  &:hover,\n  &:focus,\n  &:active,\n  &.active,\n  .open > &.dropdown-toggle {\n    background-color: $btn-states-color;\n    color: $white-color;\n    border-color: $btn-states-color;\n  }\n\n  &.disabled,\n  &:disabled,\n  &[disabled],\n  fieldset[disabled] & {\n    &,\n    &:hover,\n    &:focus,\n    &.focus,\n    &:active,\n    &.active {\n      background-color: $light-gray;\n      border-color: $medium-dark-gray;\n      cursor: not-allowed;\n      pointer-events: all !important;\n    }\n  }\n\n  &.btn-outline {\n    color: $btn-color;\n    background-color: $transparent-bg;\n    border: 1px solid $btn-color;\n    @include opacity(1);\n\n    &:hover,\n    &:focus,\n    &:active,\n    &.active,\n    .open > &.dropdown-toggle{\n        background-color: $btn-states-color;\n        color: $white-color;\n        border: 1px solid $btn-states-color;\n    }\n\n    .caret{\n        border-top-color: $white-color;\n    }\n  }\n\n  &.btn-link{\n      border-color: $transparent-bg !important;\n      background-color: $transparent-bg !important;\n      color: $default-color;\n\n      &:hover,\n      &:focus,\n      &:active{\n          text-decoration: none;\n          border-color: $transparent-bg;\n          color: $default-states-color;\n      }\n\n  }\n\n  .caret{\n      border-top-color: $btn-color;\n  }\n}\n\n\n@mixin btn-size($padding-vertical, $padding-horizontal, $font-size, $border){\n   font-size: $font-size;\n   border-radius: $border;\n   padding: $padding-vertical $padding-horizontal;\n\n   &.btn-round{\n       padding: $padding-vertical + 1 $padding-horizontal;\n   }\n\n   &.btn-simple{\n       padding: $padding-vertical + 2 $padding-horizontal;\n   }\n\n}\n","// Opacity\n\n@mixin opacity($opacity) {\n  opacity: $opacity;\n  // IE8 filter\n  $opacity-ie: ($opacity * 100);\n  filter: #{alpha(opacity=$opacity-ie)};\n}\n\n@mixin black-filter($opacity){\n    top: 0;\n    left: 0;\n    height: 100%;\n    width: 100%;\n    position: absolute;\n    background-color: rgba(17,17,17,$opacity);\n    display: block;\n    content: \"\";\n    z-index: 1; \n}",".btn-social {\n\tpadding: 8px 9px;\n\n\t.fa,.fas,.far,.fal,.fad,.fab {\n\t\tfont-size: 18px;\n\t\twidth: 20px;\n\t\tvertical-align: middle;\n\t\tdisplay: inline-block;\n\t}\n\n\t&.btn-round {\n\t\tpadding: 8px;\n\t}\n\n\t&.btn-link {\n\t\tpadding: 8px 5px;\n\t\tfont-size: 16px;\n\n\t\t.fa,.fas,.far,.fal,.fad,.fab{\n\t\t\tfont-size: 20px;\n\t\t\tposition: relative;\n\t\t\ttop: -2px;\n\t\t\twidth: 24px;\n\t\t}\n\t}\n\n\n}\n\n.btn-facebook {\n\t@include social-buttons-color($social-facebook, $social-states-facebook);\n}\n\n.btn-twitter {\n\t@include social-buttons-color($social-twitter, $social-states-twitter);\n}\n\n.btn-pinterest {\n\t@include social-buttons-color($social-pinterest, $social-states-pinterest);\n}\n\n.btn-google {\n\t@include social-buttons-color($social-google, $social-states-google);\n}\n\n.btn-linkedin {\n\t@include social-buttons-color($social-linkedin, $social-states-linkedin);\n}\n\n.btn-dribbble {\n\t@include social-buttons-color($social-dribbble, $social-states-dribble);\n}\n\n.btn-github {\n\t@include social-buttons-color($social-github, $social-states-github);\n}\n\n.btn-youtube {\n\t@include social-buttons-color($social-youtube, $social-states-youtube);\n}\n\n.btn-stumbleupon {\n\t@include social-buttons-color($social-stumbleupon, $social-states-stumbleupon);\n}\n\n.btn-reddit {\n\t@include social-buttons-color($social-reddit, $social-states-reddit);\n}\n\n.btn-tumblr {\n\t@include social-buttons-color($social-tumblr, $social-states-tumblr);\n}\n\n.btn-behance{\n\t@include social-buttons-color($social-behance, $social-states-behance);\n}\n","@mixin social-buttons-color ($btn-color, $btn-states-color){\n  border-color: $btn-color;\n  background-color: $btn-color;\n  color: $white-color;\n\n  &:hover,\n  &:focus,\n  &:active,\n  &.active,\n  .open > &.dropdown-toggle {\n    background-color: $btn-states-color;\n    color: $white-color;\n    border-color: $btn-color;\n  }\n\n  &:disabled,\n  &[disabled],\n  &.disabled {\n    background-color: $transparent-bg;\n    border-color: $btn-color;\n  }\n\n  &.btn-outline{\n    color: $btn-color;\n    background-color: $transparent-bg;\n    border: 1px solid $btn-color;\n\n    &:hover,\n    &:focus,\n    &:active,\n    &.active,\n    .open > &.dropdown-toggle{\n        background-color: $btn-states-color;\n        color: $white-color;\n        border: 1px solid $btn-states-color;\n\n    }\n  }\n  &.btn-link {\n    color: $btn-color;\n    background-color: $transparent-bg;\n    border: 1px solid $btn-color;\n\n    &:hover,\n    &:focus,\n    &:active,\n    &.active,\n    .open > &.dropdown-toggle{\n        background-color: $transparent-bg;\n        color: $btn-states-color;\n        border: 1px solid $btn-states-color;\n\n    }\n  }\n\n\n}\n",".form-control::-moz-placeholder{\n   @include placeholder($medium-gray,1);\n}\n.form-control:-moz-placeholder{\n   @include placeholder($medium-gray,1);\n}\n.form-control::-webkit-input-placeholder{\n   @include placeholder($medium-gray,1);\n}\n.form-control:-ms-input-placeholder{\n   @include placeholder($medium-gray,1);\n}\n\n.form-control {\n    background-color: $white-bg;\n    border: 1px solid $light-gray;\n    border-radius: $border-radius-base;\n    font-size: .875rem;\n    color: #565656;\n    @include input-size($padding-base-vertical, $padding-base-horizontal - 4, $height-base);\n    @include box-shadow(none);\n\n    &:focus{\n           background-color: $white-bg;\n           border: 1px solid $medium-dark-gray;\n           @include box-shadow(none);\n           outline: 0 !important;\n           color: #333333;\n    }\n\n    .has-success &,\n    .has-error &,\n    .has-success &:focus,\n    .has-error &:focus{\n        border-color: $light-gray;\n        @include box-shadow(none);\n    }\n\n    .has-success &:focus{\n        border-color: $success-color;\n        color: $success-color;\n    }\n    .has-error &{\n        color: $danger-color;\n    }\n    .has-error &:focus{\n        border-color: $danger-color;\n    }\n\n    & + .form-control-feedback{\n        border-radius: $border-radius-large;\n        font-size: $font-size-base;\n        margin-top: -7px;\n        position: absolute;\n        right: 10px;\n        top: 50%;\n        vertical-align: middle;\n    }\n\n    .open &{\n        border-radius: $border-radius-base $border-radius-base 0 0;\n        border-bottom-color: transparent;\n    }\n}\n\n.input-lg{\n    height: 55px;\n    padding: $padding-large-vertical $padding-large-horizontal;\n}\n\n.has-error{\n    .form-control-feedback{\n        color: $danger-color;\n    }\n}\n.has-success{\n    .form-control-feedback{\n        color: $success-color\n    }\n}\n\n\n.input-group-addon {\n    background-color: $white-color;\n    border: 1px solid $light-gray;\n    border-radius: $border-radius-base;\n\n    .has-success &,\n    .has-error &{\n        background-color: $white-color;\n        border: 1px solid $light-gray;\n    }\n    .has-error .form-control:focus + &{\n        border-color: $danger-color;\n        color: $danger-color;\n    }\n    .has-success .form-control:focus + &{\n        border-color: $success-color;\n        color: $success-color;\n    }\n    .form-control:focus + &,\n    .form-control:focus ~ &{\n        background-color: $white-color;\n        border-color: $dark-gray;\n    }\n}\n\n.input-group .form-control:first-child,\n.input-group-addon:first-child,\n.input-group-btn:first-child > .dropdown-toggle,\n.input-group-btn:last-child > .btn:not(:last-child):not(.dropdown-toggle) {\n    border-right: 0 none;\n}\n.input-group .form-control:last-child,\n.input-group-addon:last-child,\n.input-group-btn:last-child > .dropdown-toggle,\n.input-group-btn:first-child > .btn:not(:first-child) {\n    border-left: 0 none;\n}\n.form-control[disabled], .form-control[readonly], fieldset[disabled] .form-control {\n    background-color: $smoke-bg;\n    color: $default-color;\n    cursor: not-allowed;\n}\n\n.input-group-btn .btn{\n    border-width: $border-thin;\n    padding: $padding-round-vertical $padding-base-horizontal;\n}\n.input-group-btn .btn-default:not(.btn-fill){\n    border-color: $medium-gray;\n}\n\n.input-group-btn:last-child > .btn{\n    margin-left: 0;\n}\n\n.input-group-focus .input-group-addon{\n    border-color: $dark-gray;\n}\n\n.star{\n    color: #FB404B;\n    padding-left: 3px;\n}\n\n.card .card-body {\n    .control-label{\n        text-align: right;\n        padding-top: 18px;\n    }\n    .form-control-static,\n    .col-sm-10 .form-check:first-of-type,\n    .col-sm-4 .form-check:first-of-type{\n        padding-top: 8px;\n    }\n}\n\n.form-group.has-error{\n    .error{\n        color: $danger-color;\n        text-transform: none;\n        margin-bottom: 0;\n    }\n}\n\n.form-group.has-success{\n    .error{\n        display: none !important;\n    }\n}\n","@mixin input-size($padding-vertical, $padding-horizontal, $height){\n    padding: $padding-vertical $padding-horizontal;\n    height: $height;\n}\n\n@mixin placeholder($color, $opacity){\n   color: $color;\n   @include opacity(1);\n}\n\n@mixin light-form(){\n    border-radius: 0;\n    border:0;\n    padding: 0;\n    background-color: transparent;\n\n}",".alert{\n    border: 0;\n    border-radius: 0;\n    color: #FFFFFF;\n    padding: 10px 15px;\n    font-size: 14px;\n\n    .container &{\n        border-radius: 4px;\n\n    }\n    .navbar &{\n        border-radius: 0;\n        left: 0;\n        position: absolute;\n        right: 0;\n        top: 85px;\n        width: 100%;\n        z-index: 3;\n    }\n    .navbar:not(.navbar-transparent) &{\n        top: 70px;\n    }\n\n    span[data-notify=\"icon\"]{\n        font-size: 30px;\n        display: block;\n        left: 15px;\n        position: absolute;\n        top: 50%;\n        margin-top: -15px;\n    }\n\n    i.nc-simple-remove{\n        font-size: 12px !important;\n        font: bold normal normal 14px/1 'nucleo-icons';\n    }\n\n    button.close{\n        border: 0;\n        position: absolute;\n        right: 10px;\n        top: 50%;\n        margin-top: -13px;\n        z-index: 1033;\n        background-color: #FFFFFF;\n        display: block;\n        border-radius: 50%;\n        opacity: .4;\n        line-height: 9px;\n        width: 25px;\n        height: 25px;\n        outline: 0 !important;\n        text-align: center;\n        padding: 3px;\n        font-weight: 300;\n\n        &:hover{\n            opacity: .55;\n        }\n    }\n\n    .close ~ span{\n        display: block;\n        max-width: 89%;\n    }\n\n    &[data-notify=\"container\"]{\n        padding: 10px 10px 10px 20px;\n        border-radius: $border-radius-base;\n    }\n\n    &.alert-with-icon{\n        padding-left: 65px;\n    }\n}\n.alert-primary{\n    background-color: $primary-color;\n}\n.alert-info{\n     background-color: $info-color;\n}\n.alert-success {\n    background-color: $success-color;\n}\n.alert-warning {\n     background-color: $warning-color;\n}\n.alert-danger {\n     background-color: $danger-color;\n}\n",".table{\n    table-layout: fixed;\n    background-color: #FFF;\n    overflow-x: hidden;\n\n   .radio,\n   .checkbox{\n        position: relative;\n        height: 20px;\n        display: block;\n        width: 20px;\n        padding: 0px 0px;\n        margin: 0px 5px;\n   }\n   > thead > tr > th,\n   > tbody > tr > th,\n   > tfoot > tr > th,\n   > thead > tr > td,\n   > tbody > tr > td,\n   > tfoot > tr > td{\n       padding: 12px 8px;\n       vertical-align: middle;\n       border-color: $light-gray;\n   }\n\n    > thead > tr > th{\n        border-bottom-width: 1px;\n        font-size: $font-size-small;\n        text-transform: uppercase;\n        color: $dark-gray;\n        font-weight: $font-weight-normal;\n        padding-bottom: 5px;\n    }\n\n    table > tr > td.td-actions{\n        display: inline-flex !important;\n    }\n\n   .td-actions .btn{\n        @include opacity(0.36);\n\n        &.btn-xs{\n            padding-left: 3px;\n            padding-right: 3px;\n        }\n    }\n    .td-actions{\n        min-width: 90px;\n    }\n\n    > tbody > tr{\n        position: relative;\n        font-size: 14px !important;\n\n\n        &:hover{\n            .td-actions .btn{\n                @include opacity(1);\n            }\n        }\n    }\n    thead th{\n        border-bottom: none !important;\n        border-top: none !important;\n    }\n\n    .btn-info.btn-link{\n        color: $info-color;\n    }\n    .btn-danger.btn-link{\n        color: $danger-color;\n    }\n    .btn-success.btn-link{\n        color: $success-color;\n    }\n    .btn-warning.btn-link{\n        color: $warning-color;\n    }\n\n    .form-check{\n        .form-check-sign,\n        .form-check-sign:before,\n        .form-check-sign:after{\n            margin-top: -14px;\n        }\n    }\n}\n\n.card{\n    .table{\n        tbody td:first-child,\n        thead th:first-child{\n            padding-left: 15px;\n        }\n\n        tbody td:last-child,\n        thead th:last-child{\n            padding-right: 15px;\n        }\n    }\n}\n\n.table-bigboy{\n    > thead > tr > th{\n        font-size: $font-size-h6;\n        text-transform: uppercase;\n        color: $dark-gray;\n        font-weight: $font-weight-normal;\n    }\n    > tbody > tr > td{\n        font-size: $font-size-base;\n\n        b{\n            display: block;\n            margin-bottom: 5px;\n        }\n    }\n    .td-name{\n       font-weight: $font-weight-light;\n       font-size: $font-size-h5;\n    }\n    .td-name{\n        min-width: 240px;\n    }\n    .td-number{\n        text-align: right;\n        min-width: 110px;\n\n        small{\n            margin-right: 3px;\n        }\n    }\n\n    .td-actions{\n        width: 60px;\n        min-width: auto;\n\n        .btn{\n            float: right;\n        }\n    }\n    .img-container{\n        width: 180px;\n        height: 120px;\n        overflow: hidden;\n        display: block;\n\n        border-radius: $border-radius-large;\n\n        img{\n            width: 100%;\n        }\n    }\n\n\n}\n\n.table-with-links{\n    .card-body{\n        padding-bottom: 0 !important;\n\n        .table{\n            .btn{\n                margin-bottom: 0 !important;\n            }\n            tr td{\n                padding: 7px 3px !important;\n            }\n        }\n    }\n}\n\n\n.table-with-switches,\n.regular-table-with-color{\n    .card-body{\n        padding-bottom: 0 !important;\n\n        .table tbody td:last-child{\n            padding-right: 10px !important;\n        }\n    }\n}\n\n.table-big-boy{\n    .card-body{\n        padding-bottom: 0 !important;\n\n        .table tbody td:last-child{\n            padding-right: 10px !important;\n        }\n    }\n}\n\n.bootstrap-table{\n    .table thead th:first-child{\n        padding-left: 0!important;\n    }\n    .dropdown-menu{\n        li{\n            a{\n                display: block;\n                padding: 8px 16px;\n                clear: both;\n                font-weight: 400;\n                line-height: 1.42857143;\n                white-space: nowrap;\n                color: #333;\n\n                &:hover{\n                    background-color: #F5F5F5;\n                }\n            }\n            &.active{\n                a{\n                    background-color: rgba(68, 125, 247, 0.2);\n                }\n            }\n\n        }\n\n    }\n}\n.data-tables{\n    table{\n        tbody{\n            .btn{\n                padding: 3px !important;\n                font-size: 16px !important;\n            }\n        }\n    }\n    .pagination{\n        float: right;\n    }\n    tfoot{\n        font-size: 14px;\n    }\n}\n\n.card-tasks{\n    .table tbody{\n        td:last-child{\n            padding-right: 0;\n            display: inline-flex;\n            .btn{\n                padding: 3px;\n            }\n        }\n        td:first-child{\n            padding-left: 0;\n        }\n    }\n    .table-full-width{\n        padding-bottom: 0 !important;\n    }\n    .card-footer{\n        padding-top: 0;\n    }\n    .table{\n        margin-bottom: 0 !important;\n    }\n}\n\n.table-full-width{\n    margin-left: -15px;\n    margin-right: -15px;\n    padding: 15px !important;\n}\n\n.TableScrollbar{\n    overflow-x: hidden !important\n}\n\n\n\n@include table-row-variant('success', $light-green);\n@include table-row-variant('info', $light-azure);\n@include table-row-variant('warning', $light-orange);\n@include table-row-variant('danger', $light-red);\n","@mixin table-row-variant($state, $background) {\n  .table > thead > tr,\n  .table > tbody > tr,\n  .table > tfoot > tr {\n    > td.#{$state},\n    > th.#{$state},\n    &.#{$state} > td,\n    &.#{$state} > th {\n      background-color: $background;\n    }\n  }\n\n  .table-hover > tbody > tr {\n    > td.#{$state}:hover,\n    > th.#{$state}:hover,\n    &.#{$state}:hover > td,\n    &:hover > .#{$state},\n    &.#{$state}:hover > th {\n      background-color: lighten($background, 3%);\n    }\n  }\n}",".from-check,\n.form-check-radio {\n    margin-bottom: 12px;\n    position: relative;\n}\n\n.form-check{\n    .form-check-label{\n        display: inline-block;\n        position: relative;\n        cursor: pointer;\n        padding-left: 25px;\n        line-height: 26px;\n        margin-bottom: 0;\n        text-transform: capitalize;\n    }\n\n    .form-check-sign::before,\n    .form-check-sign::after{\n        font-family: \"Font Awesome 5 Pro\";\n        content: \"\\f0c8\";\n        color: $success-color;\n        display: inline-block;\n        position: absolute;\n        width: 19px;\n        height: 19px;\n        margin-left: -23px;\n        font-size: 18px;\n        cursor: pointer;\n        @include transition-opacity(.3s, linear);\n    }\n    .form-check-sign::after{\n        font-family: \"Font Awesome 5 Pro\";\n        content: \"\\f14a\";\n        text-align: center;\n        opacity: 0;\n        color: $success-color;\n        border: 0;\n        background-color: inherit;\n        margin-left: -23px;\n        font-weight: bold;\n    }\n    .form-check-sign::before{\n        margin-left: -22px;\n    }\n    &.disabled{\n        .form-check-label{\n            color: $light-gray;\n            opacity: .5;\n            cursor: not-allowed;\n        }\n    }\n\n}\n\n#RegisterValidation .card{\n    .form-check{\n        .form-check-sign:before{\n            margin-left: -27px;\n        }\n    }\n}\n\n.form-check .form-check-input:disabled + .form-check-sign:before,\n.form-check .form-check-input:disabled + .form-check-sign:after,\n.radio input[type=\"radio\"]:disabled + label,\n.form-check .form-check-input:disabled:checked + .form-check-sign::after{\n    color: #ddd;\n    pointer-events: none\n}\n\n.form-check.disabled .form-check-label{\n    cursor: not-allowed;\n}\n\n.form-check input[type=\"checkbox\"],\n.form-check-radio input[type=\"radio\"]{\n    opacity: 0;\n    position: absolute;\n    visibility: hidden;\n}\n.form-check input[type=\"checkbox\"]:checked + .form-check-sign::after{\n    opacity: 1;\n}\n\n.form-check input[type=\"checkbox\"]:checked + .form-check-sign::before{\n    opacity: 0;\n}\n\n.form-control input[type=\"checkbox\"]:disabled + .form-check-sign::before,\n.checkbox input[type=\"checkbox\"]:disabled + .form-check-sign::after{\n    cursor: not-allowed;\n}\n\n.form-check .form-check-label input[type=\"checkbox\"]:disabled + .form-check-sign,\n.form-check-radio input[type=\"radio\"]:disabled + .form-check-sign{\n    pointer-events: none !important;\n}\n\n.form-check.checkbox-inline{\n    display: inline-block;\n}\n\n\n.form-check-radio{\n    .form-check-label{\n        padding-left: 2.2rem;\n    }\n    &.disabled{\n        .form-check-label{\n            color: $light-gray;\n            opacity: .5;\n            cursor: not-allowed;\n        }\n    }\n}\n\n.form-check-radio .form-check-sign::before{\n    font-family: 'Font Awesome 5 Pro';\n    content: \"\\f111\";\n    font-size: 18px;\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n    display: inline-block;\n    position: absolute;\n    opacity: .50;\n    left: 34px;\n}\n\n.form-check-radio input[type=\"radio\"] + .form-check-sign:after,\n.form-check-radio input[type=\"radio\"] {\n    opacity: 0;\n    @include transition-opacity(.3s, linear);\n    content:\" \";\n    display: block;\n    margin-left: 5px;\n    font-size: 18px;\n}\n\n.form-check-radio input[type=\"radio\"]:checked + .form-check-sign::after {\n    font-family: 'Font Awesome 5 Pro';\n    content: \"\\f192\";\n    position: absolute;\n    left: 5.3px;\n    opacity: 1;\n}\n\n.form-check-radio input[type=\"radio\"]:checked + .form-check-sign::after{\n    opacity: 1;\n    @include transition-opacity(.3s, linear);\n}\n\n.form-check input[type=\"radio\"]:checked + .form-check-sign::before{\n    opacity: 0;\n    @include transition-opacity(.3s, linear);\n}\n\n.form-check-radio input[type=\"radio\"]:disabled + .form-check-sign::before,\n.form-check-radio input[type=\"radio\"]:disabled + .form-check-sign::after {\n    color: $light-gray;\n}\n\n.card{\n    &.stacked-form,\n    &.horizontal-form{\n        .form-check{\n            .form-check-label{\n                padding-left: 22px !important;\n            }\n        }\n    }\n}\n",".nav {\n    .nav-item{\n        .nav-link:hover,\n        .nav-link:focus{\n            background-color: transparent;\n        }\n    }\n\n}\n.navbar{\n    border: $none;\n    font-size: $font-size-navbar;\n    border-radius: 0;\n    min-height: 50px;\n    max-height: 61px;\n    background-color: $white-navbar;\n    border-bottom: 1px solid rgba(0, 0, 0, 0.1);\n\n    .navbar-brand {\n        font-weight: 400;\n        margin: 5px 0px;\n        font-size: 18px;\n        color: $default-color;\n\n        &:hover{\n            color: #5e5e5e;\n        }\n    }\n\n    .navbar-wrapper{\n        display: inline-flex;\n        align-items: center;\n    }\n\n    .navbar-toggler{\n        width: 37px;\n        height: 27px;\n        vertical-align: middle;\n        outline: 0;\n        cursor: pointer;\n\n        &.navbar-toggler-left{\n            position: relative;\n            left: 0;\n            padding-left: 0;\n        }\n\n        &.navbar-toggler-right{\n            padding-right: 0;\n        }\n\n        & .navbar-toggler-bar{\n            width: 3px;\n            height: 3px;\n            border-radius: 50%;\n            margin: 0 auto;\n        }\n        .burger-lines{\n            display: block;\n            position: relative;\n            background-color: #888;\n            width: 24px;\n            height: 2px;\n            border-radius: 1px;\n            margin: 4px auto;\n        }\n    }\n\n    .btn-round.btn-icon{\n        padding: 8px 9px;\n    }\n\n\n    .navbar-nav{\n        .nav-item{\n            .nav-link{\n                color: $default-color;\n                padding: $navbar-padding-a;\n                margin: $navbar-margin-a;\n                position: relative;\n                display: inline-flex;\n                line-height: 40px;\n\n                &.btn{\n                    margin: $navbar-margin-a-btn;\n                    padding: $padding-base-vertical $padding-base-horizontal;\n                }\n\n                &.btn-round{\n                    margin: $navbar-margin-a-btn-round;\n                }\n\n                [class^=\"fa\"],\n                [class^=\"fas\"],\n                [class^=\"far\"],\n                [class^=\"fal\"],\n                [class^=\"fad\"],\n                [class^=\"fab\"]{\n                    font-size: $font-size-large + 1;\n                    position: relative;\n                    line-height: 40px;\n                    top: 1px;\n                }\n\n                &:hover{\n                    color: $info-color;\n                }\n\n                .stats{\n                    margin-left: 10px;\n                }\n            }\n\n            .dropdown-menu{\n                border-radius: $border-radius-extreme;\n                margin-top: -5px;\n\n                .dropdown-item{\n                    &:first-child{\n                        border-top-left-radius: 10px;\n                        border-top-right-radius: 10px;\n                    }\n                    &:last-child{\n                        border-bottom-left-radius: 10px;\n                        border-bottom-right-radius: 10px;\n                    }\n                }\n\n                .divider{\n                    height: 1px;\n                    margin: 5px 0;\n                    overflow: hidden;\n                    background-color: #e5e5e5;\n                }\n            }\n        }\n\n        .notification{\n            position: absolute;\n            background-color: #FB404B;\n            text-align: center;\n            border-radius: 10px;\n            min-width: 18px;\n            padding: 0 5px;\n            height: 18px;\n            font-size: 12px;\n            color: $white-color;\n            font-weight: bold;\n            line-height: 18px;\n            top: 10px;\n            left: 7px;\n        }\n\n        .dropdown-toggle:after{\n            display: inline-block;\n            width: 0;\n            height: 0;\n            margin-left: 5px;\n            margin-top: 18px;\n            vertical-align: middle;\n            border-top: 4px dashed;\n            border-top: 4px solid\\9;\n            border-right: 4px solid transparent;\n            border-left: 4px solid transparent;\n        }\n    }\n    .btn{\n       margin: $navbar-margin-btn;\n       font-size: $font-size-base;\n    }\n    .btn-simple{\n        font-size: $font-size-medium;\n    }\n\n    &.fixed{\n        width: calc(100% - #{$sidebar-width});\n        right: 0;\n        left: auto;\n        border-radius: 0;\n    }\n\n}\n\n.navbar-transparent, [class*=\"navbar-ct\"]{\n    .navbar-brand{\n        color: $white-color;\n        margin-left: 10px;\n        @include opacity(.9);\n\n        &:focus,\n        &:hover{\n            background-color: transparent;\n            @include opacity(1);\n            color: $white-color;\n        }\n    }\n\n    .navbar-nav{\n        .nav-item{\n            .nav-link:not(.btn){\n                color: $dark-gray;\n                border-color: $white-color;\n                @include opacity(0.8);\n            }\n        }\n\n        .active,\n        .nav-item{\n            .nav-link:not(.btn),\n            .nav-link:hover:not(.btn),\n            .nav-link:focus:not(.btn),{\n                background-color: transparent;\n                border-radius: 3px;\n                color: #58595B;\n                @include opacity(.8);\n\n                &:focus,\n                &:hover{\n                    @include opacity(1);\n                }\n            }\n        }\n\n        .nav .nav-item .nav-link.btn:hover{\n            background-color: transparent;\n        }\n\n        .show{\n            .nav-link,\n            .nav-link:hover,\n            .nav-link:focus{\n                background-color: transparent;\n                color: $white-color;\n                @include opacity(1);\n            }\n        }\n    }\n\n    .btn-default{\n        color: $white-color;\n        border-color: $white-color;\n    }\n    .btn-default.btn-fill{\n        color: $dark-gray;\n        background-color: $white-color;\n        @include opacity(.9);\n    }\n    .btn-default.btn-fill:hover,\n    .btn-default.btn-fill:focus,\n    .btn-default.btn-fill:active,\n    .btn-default.btn-fill.active,\n    .show .dropdown-toggle.btn-fill.btn-default{\n        border-color: $white-color;\n        @include opacity(1);\n    }\n\n}\n.navbar-transparent{\n    .dropdown-menu .divider{\n        background-color: rgba($white-color,.2);\n    }\n}\n\n\n.navbar-default {\n    background-color: $white-navbar;\n    border-bottom: 1px solid rgba(0, 0, 0, 0.1);\n\n    .navbar-nav{\n        .nav-item{\n            .nav-link:not(.btn){\n                color: $dark-gray;\n            }\n        }\n\n        .active .nav-link,\n        .active .nav-link:not(.btn):hover,\n        .active .nav-link:not(.btn):focus,\n        .nav-item .nav-link:not(.btn):hover,\n        .nav-item .nav-link:not(.btn):focus{\n            background-color: transparent;\n            border-radius: 3px;\n            color: $info-color;\n            @include opacity(1);\n        }\n\n        .show{\n            .nav-link,\n            .nav-link:hover,\n            .nav-link:focus{\n                background-color: transparent;\n                color: $info-color;\n            }\n        }\n\n\n        .navbar-toggle:hover,.navbar-toggle:focus {\n            background-color: transparent;\n        }\n\n    }\n\n    &:not(.navbar-transparent) .btn-default:hover{\n        color: $info-color;\n        border-color: $info-color;\n    }\n    &:not(.navbar-transparent) .btn-neutral,\n    &:not(.navbar-transparent) .btn-neutral:hover,\n    &:not(.navbar-transparent) .btn-neutral:active{\n            color: $dark-gray;\n        }\n}\n\n/*      Navbar with icons            */\n\n.navbar-icons{\n    &.navbar .navbar-brand{\n        margin-top: 12px;\n        margin-bottom: 12px;\n    }\n    .navbar-nav{\n        .nav-item{\n            .nav-link{\n                text-align: center;\n                padding: $navbar-padding-a-icons;\n                margin: $navbar-margin-a-icons;\n            }\n        }\n\n        [class^=\"pe\"] {\n            font-size: 30px;\n            position: relative;\n        }\n        p {\n            margin: 3px 0 0;\n        }\n    }\n}\n\n.navbar-form{\n   @include box-shadow(none);\n   .form-control{\n        @include light-form();\n        height: 22px;\n        font-size: $font-size-navbar;\n        line-height: $line-height-general;\n        color: $light-gray;\n    }\n    .navbar-transparent & .form-control,\n    [class*=\"navbar-ct\"] & .form-control{\n        color: $white-color;\n        border: $none;\n        border-bottom: 1px solid rgba($white-color,.6);\n    }\n\n}\n\n.navbar-ct-blue{\n    @include navbar-color($blue-navbar);\n}\n.navbar-ct-azure{\n    @include navbar-color($azure-navbar);\n}\n.navbar-ct-green{\n    @include navbar-color($green-navbar);\n}\n.navbar-ct-orange{\n    @include navbar-color($orange-navbar);\n}\n.navbar-ct-red{\n    @include navbar-color($red-navbar);\n}\n\n.navbar-transparent{\n    padding-top: 15px;\n    background-color: transparent;\n    border-bottom: 1px solid transparent;\n    z-index: 999;\n    .navbar-toggler{\n        .burger-lines{\n            background: $white-color;\n        }\n    }\n}\n\n.navbar-toggle{\n    margin-top: 19px;\n    margin-bottom: 19px;\n    border: $none;\n\n    .icon-bar {\n        background-color: $white-color;\n    }\n     .navbar-collapse,\n     .navbar-form {\n        border-color: transparent;\n    }\n\n    &.navbar-default .navbar-toggle:hover,\n    &.navbar-default .navbar-toggle:focus {\n        background-color: transparent;\n    }\n}\n\n.main-panel{\n    .navbar-fixed{\n        position: fixed;\n        right: 0;\n        width: calc(100% - 260px);\n        z-index: 1030;\n    }\n    .navbar-fixed + .content{\n        padding-top: 90px;\n    }\n}\n\n.nav-mobile-menu.nav .navbar-search-form{\n    .nc-icon{\n        font-size: 28px;\n        width: 30px;\n        text-align: center;\n        vertical-align: middle;\n        float: left;\n        color: $white-color;\n    }\n\n    .form-control{\n        &::-webkit-input-placeholder { /* Chrome/Opera/Safari */\n            color: $white-color;\n        }\n        &::-moz-placeholder { /* Firefox 19+ */\n            color: $white-color;\n        }\n        &:-ms-input-placeholder { /* IE 10+ */\n            color: $white-color;\n        }\n        &:-moz-placeholder { /* Firefox 18- */\n            color: $white-color;\n        }\n    }\n}\n\n.nav .navbar-search-form{\n    .nc-icon{\n        color: #888888;\n    }\n}\n","@mixin navbar-color($color){\n    background-color: $color;\n}\n\n@mixin center-item(){\n    left: 0;\n    right: 0;\n    margin-right: auto;\n    margin-left: auto;\n    position: absolute;\n}",".footer{\n    background-color: $white-color;\n    width: 100%;\n\n    .footer-menu{\n        height: 41px;\n    }\n\n    nav > ul{\n        list-style: none;\n        margin: 0;\n        padding: 0;\n        font-weight: normal;\n\n        a:not(.btn){\n            color: $dark-gray;\n            display: block;\n            margin-bottom: 3px;\n            &:hover,\n            &:focus{\n                color: $default-states-color;\n            }\n        }\n    }\n    .social-area{\n        padding: 15px 0;\n        h5{\n            padding-bottom: 15px;\n        }\n    }\n    .social-area > a:not(.btn){\n       color: $dark-gray;\n       display: inline-block;\n       vertical-align: top;\n       padding: $padding-social-a;\n       font-size: $font-size-large-navbar;\n       font-weight: normal;\n       line-height: $line-height;\n       text-align: center;\n       &:hover,\n       &:focus{\n           color: $default-states-color;\n       }\n    }\n    .copyright{\n        color: $default-states-color;\n        padding: 10px 15px;\n        margin: 10px 3px;\n        line-height: 20px;\n        font-size: $font-size-base;\n    }\n    hr{\n        border-color: $medium-gray;\n    }\n    .title{\n        color: $default-states-color;\n    }\n}\n\n.footer-default{\n    background-color: $smoke-bg;\n}\n\n.footer:not(.footer-big){\n    nav > ul{\n       font-size: $font-size-base;\n       li{\n            margin-left: 20px;\n            float: left;\n        }\n        a{\n            padding: 10px 0px;\n            margin: 10px 10px 10px 0px;\n        }\n    }\n}\n\n.full-page + .footer li a,\n.full-page + .footer .copyright {\n    color: $dark-gray !important;\n}","\n.bootstrap-tagsinput {\n    // height: $height-base;\n    overflow-y: auto;\n    text-align: left;\n    .badge {\n        // @extend .animation-transition-ultra-fast;\n        cursor: pointer;\n        overflow: hidden;\n        position: relative;\n        margin: 5px 3px 5px 0;\n        padding: 4px 18px !important;\n        @include label-style();\n        background-color: transparent;\n        border: 1px solid $default-color;\n        font-size: 12px !important;\n\n        &.badge-blue,\n        &.badge-blue .tagsinput-remove-link{\n             @include label-color($primary-color);\n        }\n        &.badge-azure,\n        &.badge-azure .tagsinput-remove-link{\n             @include label-color($info-color);\n        }\n        &.badge-green .tag,\n        &.badge-green .tagsinput-remove-link{\n             @include label-color($success-color);\n        }\n        &.badge-orange .tag,\n        &.badge-orange .tagsinput-remove-link{\n             @include label-color($warning-color);\n        }\n        &.badgebadge-red .tag,\n        &.badgebadge-red .tagsinput-remove-link{\n             @include label-color($danger-color);\n        }\n\n        .badge-remove-link{\n            @include transition(60ms, ease-in);\n        }\n\n    }\n    .badge:hover{\n        padding-left: 10px;\n        padding-right: 18px;\n        opacity: 1 !important;\n        visibility: visible !important;\n        .badge-remove-link{\n            opacity: 1 !important;\n            color: black;\n            padding-right: 6px;\n        }\n\n    }\n\n    .tagsinput-add {\n        color: $black-color;\n        cursor: pointer;\n        display: inline-block;\n        font-size: 14px;\n        padding: 5px 6px;\n        vertical-align: top;\n        @include opacity(0.8);\n\n        &:hover,\n        &:focus{\n            @include opacity(1);\n        }\n    }\n    .tagsinput-add:before {\n        content: \"\\f067\";\n        font-family: \"FontAwesome\";\n    }\n\n    .badge-remove-link {\n        // @extend .animation-transition-ultra-fast;\n        cursor: pointer;\n        font-size: 12px;\n        padding: 3px 0;\n        position: absolute;\n        right: -3px;\n        opacity: 0;\n        text-align: right;\n        text-decoration: none;\n        top: 0;\n        width: 100%;\n        z-index: 2;\n    }\n    .tag:hover .tagsinput-remove-link {\n        opacity: 1;\n        padding-right: 6px;\n    }\n    .badge-remove-link:before {\n        content: \"\\f00d\";\n        font-family: \"FontAwesome\";\n        color: $info-color;\n    }\n    .tagsinput-add-container {\n        display: inline-block;\n        vertical-align: middle;\n    }\n    input{\n        background: transparent;\n        border: none;\n        color: $black-color;\n        margin: 0;\n        outline: medium none !important;\n        padding: 0 0 0 5px;\n        vertical-align: top;\n        width: 40px;\n        height: 30px;\n    }\n\n\n    &.badge-fill{\n        & .badge-blue{\n            @include label-color-fill($primary-color);\n        }\n        & .badge-azure{\n            @include label-color-fill($info-color);\n        }\n        &.badge-green{\n            @include label-color-fill($success-color);\n        }\n        &.badge-orange{\n            @include label-color-fill($warning-color);\n        }\n        &.badge-red{\n            @include label-color-fill($danger-color);\n        }\n    }\n    &.badge-fill .tagsinput-remove-link{\n        color: $white-color;\n    }\n}\n","@mixin label-style(){\n     padding: $padding-label-vertical $padding-label-horizontal;\n     border: 1px solid $default-color;\n     border-radius: $border-radius-small;\n     color: $default-color;\n     font-weight: $font-weight-semi;\n     font-size: $font-size-small;\n     text-transform: uppercase;\n     display: inline-block;\n     vertical-align: middle;\n}\n\n@mixin label-color($color){\n     border-color: $color;\n     color: $color;\n}\n@mixin label-color-fill($color){\n     border-color: $color;\n     color: $white-color;\n     background-color: $color;\n}","/*            Navigation menu                */\n.nav-pills {\n\n    > li + li {\n        margin-left: 0;\n    }\n    > li > a {\n        border: 1px solid $info-color;\n        border-radius: 0;\n        color: $info-color;\n        margin-left: -1px;\n\n        &:hover,\n        &:focus{\n            background-color: #F5F5F5;\n        }\n    }\n    > li.active > a,\n    > li.active > a:hover,\n    > li.active > a:focus {\n        background-color: $info-color;\n        color: #FFFFFF;\n    }\n    > li:first-child > a{\n        border-radius: 4px 0 0 4px;\n        margin: 0;\n    }\n    > li:last-child > a{\n        border-radius: 0 4px 4px 0;\n    }\n\n}\n\n.pagination{\n    .page-item{\n        .page-link{\n            border-radius: 50%;\n            margin: 0 2px;\n            color: #797979;\n            padding: 6px 12px;\n\n            &:hover{\n                background-color: #eee;\n                border-color: #ddd;\n            }\n        }\n\n        &.active{\n            .page-link{\n                background-color: #23CCEF;\n                border: 0;\n                color: #FFFFFF !important;\n                padding: 7px 13px;\n            }\n        }\n    }\n\n\n    .page-item{\n        &:first-child,\n        &:last-child{\n            .page-link{\n                border-radius: 50%;\n            }\n        }\n    }\n}\n\n.pagination > li.disabled{\n    opacity: .4;\n}\n\n.pagination.pagination-no-border > li > a,\n.pagination.pagination-no-border > li > span{\n    border: 0;\n}\n.pagination > li > a,\n.pagination > li > span,\n.pagination > li:first-child > a,\n.pagination > li:first-child > span,\n.pagination > li:last-child > a,\n.pagination > li:last-child > span{\n    border-radius: 50%;\n    margin: 0 2px;\n    color: $default-states-color;\n}\n.pagination > li.active > a,\n.pagination > li.active > span,\n.pagination > li.active > a:hover,\n.pagination > li.active > span:hover,\n.pagination > li.active > a:focus,\n.pagination > li.active > span:focus {\n    background-color: $info-color;\n    border: 0;\n    color: #FFFFFF;\n    padding: 7px 13px;\n}\n\n.nav-pills-blue{\n    > li.active {\n        > a,\n        > a:hover,\n        > a:focus{\n           background-color: $color-blue;\n        }\n    }\n}\n\n.pagination-blue{\n    > li.active{\n        a,\n        a:hover,\n        a:focus,\n        span,\n        span:hover,\n        span:focus{\n            background-color: $color-blue !important;\n        }\n    }\n}\n\n.nav-pills-azure{\n    > li.active {\n        > a,\n        > a:hover,\n        > a:focus{\n           background-color: $color-azure;\n        }\n    }\n}\n\n.pagination-azure{\n    li.active{\n        a,\n        a:hover,\n        a:focus,\n        span,\n        span:hover,\n        span:focus{\n            background-color: $color-azure !important;\n        }\n    }\n}\n\n.nav-pills-green{\n    > li.active {\n        > a,\n        > a:hover,\n        > a:focus{\n           background-color: $color-green;\n        }\n    }\n}\n\n.pagination-green{\n    > li.active{\n        a,\n        a:hover,\n        a:focus,\n        span,\n        span:hover,\n        span:focus{\n            background-color: $color-green !important;\n        }\n    }\n}\n\n.nav-pills-orange{\n    > li.active {\n        > a,\n        > a:hover,\n        > a:focus{\n           background-color: $color-orange;\n        }\n    }\n}\n\n.pagination-orange{\n    > li.active{\n        a,\n        a:hover,\n        a:focus,\n        span,\n        span:hover,\n        span:focus{\n            background-color: $color-orange !important;\n        }\n    }\n}\n\n.nav-pills-red{\n    > li.active {\n        > a,\n        > a:hover,\n        > a:focus{\n           background-color: $color-red;\n        }\n    }\n}\n\n.pagination-red{\n    > li.active{\n        a,\n        a:hover,\n        a:focus,\n        span,\n        span:hover,\n        span:focus{\n            background-color: $color-red !important;\n        }\n    }\n}\n\n// Bootstrap Table pagination\n\n.bootstrap-table{\n    .pagination{\n        .page-number{\n            a{\n                padding: 7px 12px;\n            }\n        }\n    }\n}\n\n.nav-pills-blue > li > a {\n    @include pill-style($color-blue);\n}\n.nav-pills-azure > li > a {\n    @include pill-style($color-azure);\n}\n.nav-pills-green > li > a {\n    @include pill-style($color-green);\n}\n.nav-pills-orange > li > a {\n    @include pill-style($color-orange);\n}\n.nav-pills-red > li > a {\n    @include pill-style($color-red);\n}\n\n.nav-text,\n.nav-icons{\n    padding:  $padding-default-vertical 0 0;\n\n    .nav-item .nav-link{\n        display: block;\n        padding: 0px $padding-base-horizontal;\n        color: $dark-gray;\n        text-align: center;\n        @include opacity(0.8);\n\n        &:hover,\n        &:focus{\n            background-color: $transparent-bg;\n            @include opacity(1);\n        }\n    }\n    .nav-item:first-child .nav-link{\n        padding-left: 0;\n    }\n    .nav-item .nav-link.active,\n    .nav-item.active .nav-link{\n       color: $info-color;\n    }\n    // .nav-item.active .nav-link.active{\n    //     color: $info-color;\n    // }\n}\n\n.nav-icons > li{\n    display: inline-block;\n     > a{\n        padding: 0 10px;\n        margin-bottom: 10px;\n    }\n    > a i{\n        font-size: $font-size-h4;\n        margin-bottom: 10px;\n        width: $font-size-h4;\n    }\n}\n\n.nav-icons.nav-stacked > li{\n    display: block;\n    > a {\n        margin-bottom: 20px;\n    }\n}\n\n.nav-blue > li.active a{\n    color: $primary-color;\n}\n.nav-azure > li.active a{\n    color: $info-color;\n}\n.nav-green > li.active a{\n    color: $success-color;\n}\n.nav-orange > li.active a{\n    color: $warning-color;\n}\n.nav-red > li.active a{\n    color: $danger-color;\n}\n\n.nav-text{\n    margin: $margin-bottom;\n\n    > li > a{\n        font-size: $font-size-h6;\n        text-transform: uppercase;\n        padding: 3px 0;\n        text-align: left;\n        font-weight: $font-weight-semi;\n\n    }\n    > li:first-child > a{\n        padding-top: 0;\n    }\n    h4{\n        margin-top: 0;\n    }\n}\n\n.nav-text:not(.nav-stacked){\n    > li{\n        display: inline-block;\n    }\n    > li > a{\n        margin-right: 15px;\n    }\n}\n\n.tab-pane{\n    padding: 15px 0;\n}\n\n.nav-container{\n    display: block;\n    width: 100%;\n    text-align: center;\n}\n.content-full-width{\n    .nav-tabs{\n        li:first-child{\n            padding-left: $padding-default-horizontal;\n        }\n    }\n    .tab-pane{\n        padding: $padding-default-horizontal;\n    }\n}\n\n\n// ACCORDION\n\n.accordions{\n    .card{\n        border: 0;\n        box-shadow: none;\n        margin-bottom: 15px;\n\n        .card-header{\n            padding: 0;\n            border-bottom: 1px solid #DDDDDD !important;\n\n            .card-title{\n                margin-top: 0;\n                margin-bottom: 0;\n                font-size: 18px;\n                color: inherit;\n\n                a{\n                    color: #333;\n                    padding: 0px 0 5px;\n                    display: block;\n                    width: 100%;\n                    font-size: 16px;\n\n                    &:hover{\n                        color: #797979;\n                    }\n                }\n            }\n\n            .caret{\n                display: inline-block;\n                width: 0;\n                height: 0;\n                margin-left: 2px;\n                vertical-align: middle;\n                border-top: 4px dashed;\n                border-top: 4px solid\\9;\n                border-right: 4px solid transparent;\n                border-left: 4px solid transparent;\n                float: right;\n                margin-top: 12px;\n                margin-right: 15px;\n                @include transition(150ms, ease-in);\n\n            }\n            a[data-toggle=\"collapse\"][aria-expanded=\"true\"] .caret,\n            a[data-toggle=\"collapse-hover\"][aria-expanded=\"true\"] .caret{\n                filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=2);\n                -webkit-transform: rotate(180deg);\n                -ms-transform: rotate(180deg);\n                transform: rotate(180deg);\n            }\n        }\n\n        .card-header + .card-collapse{\n            .card-body{\n                box-shadow: inset 0 7px 10px -7px rgba(0, 0, 0, 0.14);\n            }\n        }\n\n        .card-collapse.collapse-hover{\n            -webkit-transition: all 300ms linear;\n            -moz-transition: all 300ms linear;\n            -o-transition: all 300ms linear;\n            -ms-transition: all 300ms linear;\n            transition: all 300ms linear !important;\n        }\n    }\n\n\n}\n\n.card-body-full-width{\n    padding: 15px 0 !important;\n\n    .accordions{\n        .card-header{\n            .card-title{\n                a{\n                    padding: 10px 15px;\n                }\n            }\n        }\n    }\n}\n\n\n\n// PANELS\n\n.content-full-width{\n    .nav-tabs{\n        .nav-item:first-child{\n            padding-left: 15px;\n        }\n    }\n}\n\n.nav-container .nav-icons{\n    .nc-icon{\n        font-weight: 700;\n    }\n}\n\n\n// nav-pills - Wizard\n\n.card-wizard{\n    .nav-tabs{\n        margin-left: -15px;\n        margin-right: -15px;\n        margin-top: 10px;\n        margin-bottom: 10px;\n\n        .nav-item{\n            width: 33.33%;\n            .nav-link{\n                text-align: center;\n                border: none;\n                background-color: #9A9A9A;\n                color: $white-color;\n                text-transform: uppercase;\n                border-radius: unset;\n\n                &.active{\n                    background-color: $info-color;\n                }\n            }\n        }\n    }\n}\n","@mixin pill-style($color){\n    border: 1px solid $color;\n    color: $color;\n}",".progress {\n    background-color: #E5E5E5;\n    border-radius: 3px;\n    box-shadow: none;\n    height: 4px;\n    margin-bottom: 20px;\n}\n.progress-thin{\n    height: 2px;\n}\n\n.progress-bar,\n.progress-bar-primary{\n   background-color: $primary-color;\n}\n.progress-bar-info{\n    background-color: $info-color;\n}\n.progress-bar-success{\n   background-color: $success-color;\n}\n.progress-bar-warning{\n   background-color: $warning-color;\n}\n.progress-bar-danger{\n   background-color: $danger-color;\n}\n","\n/*!\n * jQuery UI Slider 1.10.4\n * http://jqueryui.com\n *\n * Copyright 2014 jQuery Foundation and other contributors\n * Released under the MIT license.\n * http://jquery.org/license\n *\n * http://api.jqueryui.com/slider/#theming\n */\n \n.ui-slider {\n\tposition: relative;\n\ttext-align: left;\n}\n.ui-slider .ui-slider-handle {\n\tposition: absolute;\n\tz-index: 2;\n\twidth: 1.2em;\n\theight: 1.2em;\n\tcursor: default;\n}\n.ui-slider .ui-slider-range {\n\tposition: absolute;\n\tz-index: 1;\n\tfont-size: .7em;\n\tdisplay: block;\n\tborder: 0;\n\tbackground-position: 0 0;\n}\n\n/* For IE8 - See #6727 */\n.ui-slider.ui-state-disabled .ui-slider-handle,\n.ui-slider.ui-state-disabled .ui-slider-range {\n\tfilter: inherit;\n}\n\n.ui-slider-horizontal {\n\theight: 4px;\n}\n.ui-slider-horizontal .ui-slider-handle {\n    margin-left: -10px;\n    top: -7px;\n}\n.ui-slider-horizontal .ui-slider-range {\n\ttop: 0;\n\theight: 100%;\n}\n.ui-slider-horizontal .ui-slider-range-min {\n\tleft: 0;\n}\n.ui-slider-horizontal .ui-slider-range-max {\n\tright: 0;\n}\n\n.ui-slider-vertical {\n\twidth: .8em;\n\theight: 100px;\n}\n.ui-slider-vertical .ui-slider-handle {\n\tleft: -.3em;\n\tmargin-left: 0;\n\tmargin-bottom: -.6em;\n}\n.ui-slider-vertical .ui-slider-range {\n\tleft: 0;\n\twidth: 100%;\n}\n.ui-slider-vertical .ui-slider-range-min {\n\tbottom: 0;\n}\n.ui-slider-vertical .ui-slider-range-max {\n\ttop: 0;\n}\n\n/* Component containers\n----------------------------------*/\n.ui-widget {\n\tfont-size: 1.1em/*{fsDefault}*/;\n}\n.ui-widget .ui-widget {\n\tfont-size: 1em;\n}\n.ui-widget input,\n.ui-widget select,\n.ui-widget textarea,\n.ui-widget button {\n\tfont-size: 1em;\n}\n.ui-widget-content {\n\tbackground-color: #E5E5E5;\n}\n.ui-widget-content a {\n\tcolor: #222222/*{fcContent}*/;\n}\n.ui-widget-header {\n\tbackground: #999999;\n\tcolor: #222222;\n\tfont-weight: bold;\n}\n.ui-widget-header a {\n\tcolor: #222222;\n}\n\n.slider-primary .ui-widget-header{\n   background-color: $primary-color;\n}\n.slider-info .ui-widget-header{\n    background-color: $info-color;\n}\n.slider-success .ui-widget-header{\n   background-color: $success-color;\n}\n.slider-warning .ui-widget-header{\n   background-color: $warning-color;\n}\n.slider-danger .ui-widget-header{\n   background-color: $danger-color;\n}\n\n/* Interaction states\n----------------------------------*/\n.ui-state-default,\n.ui-widget-content .ui-state-default,\n.ui-widget-header .ui-state-default {\n\tbackground: rgb(255,255,255); /* Old browsers */\n    background: -moz-linear-gradient(top,  rgba(255,255,255,1) 0%, rgba(241,241,242,1) 100%); /* FF3.6+ */\n    background: -webkit-gradient(linear, left top, left bottom, color-stop(0%,rgba(255,255,255,1)), color-stop(100%,rgba(241,241,242,1))); /* Chrome,Safari4+ */\n    background: -webkit-linear-gradient(top,  rgba(255,255,255,1) 0%,rgba(241,241,242,1) 100%); /* Chrome10+,Safari5.1+ */\n    background: -o-linear-gradient(top,  rgba(255,255,255,1) 0%,rgba(241,241,242,1) 100%); /* Opera 11.10+ */\n    background: -ms-linear-gradient(top,  rgba(255,255,255,1) 0%,rgba(241,241,242,1) 100%); /* IE10+ */\n    background: linear-gradient(to bottom,  rgba(255,255,255,1) 0%,rgba(241,241,242,1) 100%); /* W3C */\n    filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#ffffff', endColorstr='#f1f1f2',GradientType=0 ); /* IE6-9 */\n    \n    border-radius: 50%;\n    box-shadow: 0 1px 1px #FFFFFF inset, 0 1px 2px rgba(0, 0, 0, 0.4);\n\theight:15px;\n\twidth:15px;\n\tcursor:pointer;\n}\n.ui-state-default a,\n.ui-state-default a:link,\n.ui-state-default a:visited {\n\tcolor: #555555/*{fcDefault}*/;\n\ttext-decoration: none;\n}\n\n.ui-state-hover a,\n.ui-state-hover a:hover,\n.ui-state-hover a:link,\n.ui-state-hover a:visited,\n.ui-state-focus a,\n.ui-state-focus a:hover,\n.ui-state-focus a:link,\n.ui-state-focus a:visited {\n\tcolor: #212121/*{fcHover}*/;\n\ttext-decoration: none;\n}\n.ui-state-active a,\n.ui-state-active a:link,\n.ui-state-active a:visited {\n\tcolor: #212121/*{fcActive}*/;\n\ttext-decoration: none;\n}\n\n/* Interaction Cues\n----------------------------------*/\n.ui-state-highlight,\n.ui-widget-content .ui-state-highlight,\n.ui-widget-header .ui-state-highlight {\n\tborder: 1px solid #fcefa1;\n\tbackground: #fbf9ee;\n\tcolor: #363636;\n}\n.ui-state-highlight a,\n.ui-widget-content .ui-state-highlight a,\n.ui-widget-header .ui-state-highlight a {\n\tcolor: #363636;\n}\n.ui-state-error,\n.ui-widget-content .ui-state-error,\n.ui-widget-header .ui-state-error {\n\tborder: 1px solid $danger-color/*{borderColorError}*/;\n\tbackground-color: $danger-color;\n\tcolor: $danger-color/*{fcError}*/;\n}\n.ui-state-error a,\n.ui-widget-content .ui-state-error a,\n.ui-widget-header .ui-state-error a {\n\tcolor: $danger-color/*{fcError}*/;\n}\n.ui-state-error-text,\n.ui-widget-content .ui-state-error-text,\n.ui-widget-header .ui-state-error-text {\n\tcolor: $danger-color/*{fcError}*/;\n}\n.ui-priority-primary,\n.ui-widget-content .ui-priority-primary,\n.ui-widget-header .ui-priority-primary {\n\tfont-weight: bold;\n}\n.ui-priority-secondary,\n.ui-widget-content .ui-priority-secondary,\n.ui-widget-header .ui-priority-secondary {\n\topacity: .7;\n\tfilter:Alpha(Opacity=70);\n\tfont-weight: normal;\n}\n.ui-state-disabled,\n.ui-widget-content .ui-state-disabled,\n.ui-widget-header .ui-state-disabled {\n\topacity: .35;\n\tfilter:Alpha(Opacity=35);\n\tbackground-image: none;\n}\n.ui-state-disabled .ui-icon {\n\tfilter:Alpha(Opacity=35); /* For IE8 - See #6059 */\n}",".dropdown-menu{\n    visibility: hidden;\n    margin: 0;\n    padding: 0;\n    border-radius: $border-radius-extreme;\n    display: block;\n    z-index: 9000;\n    position: absolute;\n\n    @include opacity(0);\n    @include box-shadow($dropdown-shadow);\n\n    .show &{\n        @include opacity(1);\n        visibility: visible;\n    }\n    .select &{\n       border-radius: $border-radius-bottom;\n       @include box-shadow(none);\n       @include transform-origin($select-coordinates);\n       @include transform-scale(1);\n       @include transition($fast-transition-time, $transition-linear);\n       margin-top: -20px;\n    }\n    .select.show &{\n        margin-top: -1px;\n    }\n\n    .dropdown-item {\n       padding: $padding-base-vertical $padding-base-horizontal;\n       color: #333333;\n\n       img{\n           margin-top: -3px;\n       }\n    }\n    .dropdown-item:focus{\n        outline: 0 !important;\n    }\n\n    .btn-group.select &{\n        min-width: 100%;\n    }\n\n    > li:first-child > a{\n       border-top-left-radius: $border-radius-extreme;\n       border-top-right-radius: $border-radius-extreme;\n    }\n\n    > li:last-child > a{\n        border-bottom-left-radius: $border-radius-extreme;\n        border-bottom-right-radius: $border-radius-extreme;\n    }\n\n    .select & > li:first-child > a{\n        border-radius: 0;\n        border-bottom: 0 none;\n    }\n\n    .dropdown-item:hover,\n    .dropdown-item:focus {\n        background-color: $smoke-bg;\n        color: #333333;\n        opacity: 1;\n        text-decoration: none;\n    }\n\n    &.dropdown-blue > li > a:hover,\n    &.dropdown-blue > li > a:focus{\n        background-color: $light-blue;\n    }\n    &.dropdown-azure > li > a:hover,\n    &.dropdown-azure > li > a:focus{\n        background-color: $light-azure;\n    }\n    &.ct-green > li > a:hover,\n    &.ct-green > li > a:focus{\n        background-color: $light-green;\n    }\n    &.dropdown-orange > li > a:hover,\n    &.dropdown-orange > li > a:focus{\n        background-color: $light-orange;\n    }\n    &.dropdown-red > li > a:hover,\n    &.dropdown-red > li > a:focus{\n        background-color: $light-red;\n    }\n\n    .dropdown-item{\n        i[class*=\"nc-icon\"]{\n            font-size: 18px;\n            text-align: center;\n            line-height: 25px;\n            float: left;\n            padding-right: 10px;\n        }\n    }\n\n    &.dropdown-menu-right{\n        &:before,\n        &:after{\n            right: 12px !important;\n            left: auto !important;\n        }\n    }\n\n}\n\n.dropdown-with-icons{\n    > li > a{\n        padding-left: 0px;\n        line-height: 28px;\n    }\n    i{\n        text-align: center;\n        line-height: 28px;\n        float: left;\n\n        &[class^=\"pe-\"]{\n             font-size: 24px;\n             width: 46px;\n        }\n        &[class^=\"fa\"],\n        &[class^=\"fas\"],\n        &[class^=\"far\"],\n        &[class^=\"fal\"],\n        &[class^=\"fad\"],\n        &[class^=\"fab\"]{\n            font-size: 14px;\n            width: 38px;\n        }\n    }\n}\n\n//fix bug for the select items in btn-group\n.btn-group.select{\n    overflow: hidden;\n}\n.btn-group.select.show{\n    overflow: visible;\n}\n",".card{\n    border-radius: $border-radius-base;\n    background-color: $white-color;\n    margin-bottom: 30px;\n\n    .card-image{\n        width: 100%;\n        overflow: hidden;\n        height: 260px;\n        border-radius: $border-radius-base $border-radius-base 0 0;\n        position: relative;\n        -webkit-transform-style: preserve-3d;\n        -moz-transform-style: preserve-3d;\n        transform-style: preserve-3d;\n\n        img {\n            width: 100%;\n        }\n    }\n    .filter{\n        position: absolute;\n        z-index: 2;\n        background-color: rgba(0,0,0,.68);\n        top: 0;\n        left: 0;\n        width: 100%;\n        height: 100%;\n        text-align: center;\n\n        @include opacity(0);\n\n        .btn{\n            @include vertical-align();\n        }\n    }\n    &:hover .filter{\n        @include opacity(1);\n    }\n    .btn-hover{\n        @include opacity(0);\n    }\n    &:hover .btn-hover{\n        @include opacity(1);\n    }\n    .card-body{\n        padding: 15px 15px 10px 15px;\n    }\n    .card-header{\n        padding: 15px 15px 0;\n        background-color: $white-color;\n        border-bottom: none !important;\n\n    }\n    .card-category,\n    label{\n        font-size: $font-size-base;\n        font-weight: $font-weight-normal;\n        color: $dark-gray;\n        margin-bottom: 0px;\n\n        i{\n            font-size: $font-paragraph;\n        }\n    }\n\n    label{\n        font-size: $font-size-small;\n        margin-bottom: 5px;\n        text-transform: none;\n        a {\n            font-size: $font-size-xsmall;\n        }\n    }\n\n    .card-title{\n        margin: $none;\n        color: $black-color;\n        font-weight: $font-weight-light;\n    }\n    .avatar{\n        height: 100%;\n        overflow: hidden;\n        border-radius: 50%;\n        margin-right: 5px;\n    }\n    .description{\n        font-size: $font-size-base;\n        color: #333;\n    }\n    .card-footer{\n        padding: 15px 15px 10px 15px;\n        background-color: $transparent-bg;\n        line-height: 30px;\n        border-top: none !important;\n        font-size: 14px;\n\n        .legend{\n            padding: 5px 0;\n        }\n\n        hr{\n            margin-top: 5px;\n            margin-bottom: 5px;\n        }\n    }\n    .stats{\n        color: #a9a9a9;\n    }\n\n    .author{\n        font-size: $font-size-small;\n        font-weight: $font-weight-bold;\n        text-transform: uppercase;\n        border-radius: 50%;\n        // width: 100px;\n        // height: 100px;\n        border: 4px solid rgba(255, 255, 255, 0.3);\n        overflow: hidden;\n        margin: 0 auto;\n        -webkit-transition: all 300ms linear;\n        -moz-transition: all 300ms linear;\n        -o-transition: all 300ms linear;\n        -ms-transition: all 300ms linear;\n        transition: all 300ms linear;\n    }\n    .author i{\n        font-size: $font-size-base;\n    }\n    h6{\n        font-size: $font-size-small;\n        margin: 0;\n    }\n    &.card-separator:after{\n        height: 100%;\n        right: -15px;\n        top: 0;\n        width: 1px;\n        background-color: $medium-gray;\n        card-body: \"\";\n        position: absolute;\n    }\n\n    .ct-chart{\n        margin: 30px 0 30px;\n        // height: 245px;\n    }\n\n    .ct-label{\n        font-size: 1rem !important;\n    }\n\n    .alert{\n        border-radius: $border-radius-base;\n        position: relative;\n\n        &.alert-with-icon{\n            padding-left: 65px;\n        }\n    }\n\n    &.card-lock{\n        .card-body .card-title{\n            margin-bottom: 20px;\n            color: $white-color;\n        }\n        .card-header{\n            .author{\n                width: 100px;\n                height: 100px;\n\n            }\n        }\n    }\n}\n\n\n\n.card-stats{\n    .card-body{\n        padding: 15px 15px 0px;\n\n        .numbers{\n            text-align: right;\n\n            p{\n                margin-bottom: 0;\n            }\n        }\n    }\n    .card-footer{\n        padding: 0px 15px 10px 15px;\n    }\n    .icon-big {\n        font-size: 3em;\n        min-height: 64px;\n\n        i{\n            line-height: 59px;\n        }\n    }\n\n\n}\n\n.card-user{\n    .card-image{\n        height: 110px;\n    }\n    .card-image-plain{\n        height: 0;\n        margin-top: 110px;\n    }\n    .author{\n        text-align: center;\n        text-transform: none;\n        margin-top: -70px;\n    }\n    .avatar{\n        width: 124px;\n        height: 124px;\n        border: 5px solid #EEEEEE;\n        position: relative;\n        margin-bottom: 15px;\n\n        &.border-gray{\n            border-color: #EEEEEE;\n        }\n    }\n    .title{\n        line-height: 24px;\n    }\n    .card-body{\n        min-height: 240px;\n    }\n    .card-header.no-padding{\n        padding: 0;\n    }\n\n    .card-footer{\n        .button-container .btn{\n            font-size: 16px;\n        }\n    }\n}\n\n.card-user,\n.card-price{\n    .card-footer{\n        padding: 5px 15px 10px;\n    }\n    hr{\n        margin: 5px 15px;\n    }\n}\n.card-plain{\n    background-color: transparent;\n    box-shadow: none;\n    border-radius: 0;\n\n    .card-image{\n        border-radius: 4px;\n    }\n}\n\n.card.card-plain{\n    border: none !important;\n\n    .card-header{\n        background-color: transparent !important;\n    }\n}\n\n.card{\n    &.card-login{\n        box-shadow: 0 25px 30px -13px rgba(40, 40, 40, 0.4);\n        border-radius: 10px;\n        padding-top: 10px;\n        padding-bottom: 30px;\n        @include transform-translate-y(0px);\n        @include transition(300ms, linear);\n\n        .form-check{\n            margin-left: -12px;\n        }\n        &.card-hidden{\n            opacity: 0;\n            @include transform-translate-y(-60px);\n        }\n    }\n\n    &.card-register{\n        .header-text{\n            hr{\n                border-top: 1px solid rgba(255,255,255,.3);\n            }\n        }\n    }\n}\n","@mixin ct-responsive-svg-container($width: 100%, $ratio: $ct-container-ratio) {\n  display: block;\n  position: relative;\n  width: $width;\n\n  &:before {\n    display: block;\n    float: left;\n    content: \"\";\n    width: 0;\n    height: 0;\n    padding-bottom: $ratio * 100%;\n  }\n\n  &:after {\n    content: \"\";\n    display: table;\n    clear: both;\n  }\n\n  > svg {\n    display: block;\n    position: absolute;\n    top: 0;\n    left: 0;\n  }\n}\n\n@mixin ct-align-justify($ct-text-align: $ct-text-align, $ct-text-justify: $ct-text-justify) {\n  -webkit-box-align: $ct-text-align;\n  -webkit-align-items: $ct-text-align;\n  -ms-flex-align: $ct-text-align;\n  align-items: $ct-text-align;\n  -webkit-box-pack: $ct-text-justify;\n  -webkit-justify-content: $ct-text-justify;\n  -ms-flex-pack: $ct-text-justify;\n  justify-content: $ct-text-justify;\n  // Fallback to text-align for non-flex browsers\n  @if($ct-text-justify == 'flex-start') {\n    text-align: left;\n  } @else if ($ct-text-justify == 'flex-end') {\n    text-align: right;\n  } @else {\n    text-align: center;\n  }\n}\n\n@mixin ct-flex() {\n  // Fallback to block\n  display: block;\n  display: -webkit-box;\n  display: -moz-box;\n  display: -ms-flexbox;\n  display: -webkit-flex;\n  display: flex;\n}\n\n@mixin ct-chart-label($ct-text-color: $ct-text-color, $ct-text-size: $ct-text-size, $ct-text-line-height: $ct-text-line-height) {\n  fill: $ct-text-color;\n  color: $ct-text-color;\n  font-size: $ct-text-size;\n  line-height: $ct-text-line-height;\n}\n\n@mixin ct-chart-grid($ct-grid-color: $ct-grid-color, $ct-grid-width: $ct-grid-width, $ct-grid-dasharray: $ct-grid-dasharray) {\n  stroke: $ct-grid-color;\n  stroke-width: $ct-grid-width;\n\n  @if ($ct-grid-dasharray) {\n    stroke-dasharray: $ct-grid-dasharray;\n  }\n}\n\n@mixin ct-chart-point($ct-point-size: $ct-point-size, $ct-point-shape: $ct-point-shape) {\n  stroke-width: $ct-point-size;\n  stroke-linecap: $ct-point-shape;\n}\n\n@mixin ct-chart-line($ct-line-width: $ct-line-width, $ct-line-dasharray: $ct-line-dasharray) {\n  fill: none;\n  stroke-width: $ct-line-width;\n\n  @if ($ct-line-dasharray) {\n    stroke-dasharray: $ct-line-dasharray;\n  }\n}\n\n@mixin ct-chart-area($ct-area-opacity: $ct-area-opacity) {\n  stroke: none;\n  fill-opacity: $ct-area-opacity;\n}\n\n@mixin ct-chart-bar($ct-bar-width: $ct-bar-width) {\n  fill: none;\n  stroke-width: $ct-bar-width;\n}\n\n@mixin ct-chart-donut($ct-donut-width: $ct-donut-width) {\n  fill: none;\n  stroke-width: $ct-donut-width;\n}\n\n@mixin ct-chart-series-color($color) {\n  .#{$ct-class-point}, .#{$ct-class-line}, .#{$ct-class-bar}, .#{$ct-class-slice-donut} {\n    stroke: $color;\n  }\n\n  .#{$ct-class-slice-pie}, .#{$ct-class-area} {\n    fill: $color;\n  }\n}\n\n@mixin ct-chart($ct-container-ratio: $ct-container-ratio, $ct-text-color: $ct-text-color, $ct-text-size: $ct-text-size, $ct-grid-color: $ct-grid-color, $ct-grid-width: $ct-grid-width, $ct-grid-dasharray: $ct-grid-dasharray, $ct-point-size: $ct-point-size, $ct-point-shape: $ct-point-shape, $ct-line-width: $ct-line-width, $ct-bar-width: $ct-bar-width, $ct-donut-width: $ct-donut-width, $ct-series-names: $ct-series-names, $ct-series-colors: $ct-series-colors) {\n\n  .#{$ct-class-label} {\n    @include ct-chart-label($ct-text-color, $ct-text-size);\n  }\n\n  .#{$ct-class-chart-line} .#{$ct-class-label},\n  .#{$ct-class-chart-bar} .#{$ct-class-label} {\n    @include ct-flex();\n  }\n\n  .#{$ct-class-label}.#{$ct-class-horizontal}.#{$ct-class-start} {\n    @include ct-align-justify(flex-end, flex-start);\n    // Fallback for browsers that don't support foreignObjects\n    text-anchor: start;\n  }\n\n  .#{$ct-class-label}.#{$ct-class-horizontal}.#{$ct-class-end} {\n    @include ct-align-justify(flex-start, flex-start);\n    // Fallback for browsers that don't support foreignObjects\n    text-anchor: start;\n  }\n\n  .#{$ct-class-label}.#{$ct-class-vertical}.#{$ct-class-start} {\n    @include ct-align-justify(flex-end, flex-end);\n    // Fallback for browsers that don't support foreignObjects\n    text-anchor: end;\n  }\n\n  .#{$ct-class-label}.#{$ct-class-vertical}.#{$ct-class-end} {\n    @include ct-align-justify(flex-end, flex-start);\n    // Fallback for browsers that don't support foreignObjects\n    text-anchor: start;\n  }\n\n  .#{$ct-class-chart-bar} .#{$ct-class-label}.#{$ct-class-horizontal}.#{$ct-class-start} {\n    @include ct-align-justify(flex-end, center);\n    // Fallback for browsers that don't support foreignObjects\n    text-anchor: start;\n  }\n\n  .#{$ct-class-chart-bar} .#{$ct-class-label}.#{$ct-class-horizontal}.#{$ct-class-end} {\n    @include ct-align-justify(flex-start, center);\n    // Fallback for browsers that don't support foreignObjects\n    text-anchor: start;\n  }\n\n  .#{$ct-class-chart-bar}.#{$ct-class-horizontal-bars} .#{$ct-class-label}.#{$ct-class-horizontal}.#{$ct-class-start} {\n    @include ct-align-justify(flex-end, flex-start);\n    // Fallback for browsers that don't support foreignObjects\n    text-anchor: start;\n  }\n\n  .#{$ct-class-chart-bar}.#{$ct-class-horizontal-bars} .#{$ct-class-label}.#{$ct-class-horizontal}.#{$ct-class-end} {\n    @include ct-align-justify(flex-start, flex-start);\n    // Fallback for browsers that don't support foreignObjects\n    text-anchor: start;\n  }\n\n  .#{$ct-class-chart-bar}.#{$ct-class-horizontal-bars} .#{$ct-class-label}.#{$ct-class-vertical}.#{$ct-class-start} {\n    //@include ct-chart-label($ct-text-color, $ct-text-size, center, $ct-vertical-text-justify);\n    @include ct-align-justify(center, flex-end);\n    // Fallback for browsers that don't support foreignObjects\n    text-anchor: end;\n  }\n\n  .#{$ct-class-chart-bar}.#{$ct-class-horizontal-bars} .#{$ct-class-label}.#{$ct-class-vertical}.#{$ct-class-end} {\n    @include ct-align-justify(center, flex-start);\n    // Fallback for browsers that don't support foreignObjects\n    text-anchor: end;\n  }\n\n  .#{$ct-class-grid} {\n    @include ct-chart-grid($ct-grid-color, $ct-grid-width, $ct-grid-dasharray);\n  }\n\n  .#{$ct-class-point} {\n    @include ct-chart-point($ct-point-size, $ct-point-shape);\n  }\n\n  .#{$ct-class-line} {\n    @include ct-chart-line($ct-line-width);\n  }\n\n  .#{$ct-class-area} {\n    @include ct-chart-area();\n  }\n\n  .#{$ct-class-bar} {\n    @include ct-chart-bar($ct-bar-width);\n  }\n\n  .#{$ct-class-slice-donut} {\n    @include ct-chart-donut($ct-donut-width);\n  }\n\n  @if $ct-include-colored-series {\n    @for $i from 0 to length($ct-series-names) {\n      .#{$ct-class-series}-#{nth($ct-series-names, $i + 1)} {\n        $color: nth($ct-series-colors, $i + 1);\n\n        @include ct-chart-series-color($color);\n      }\n    }\n  }\n}\n\n@if $ct-include-classes {\n  @include ct-chart();\n\n  @if $ct-include-alternative-responsive-containers {\n    @for $i from 0 to length($ct-scales-names) {\n      .#{nth($ct-scales-names, $i + 1)} {\n        @include ct-responsive-svg-container($ratio: nth($ct-scales, $i + 1));\n      }\n    }\n  }\n}","// Scales for responsive SVG containers\n$ct-scales: ((1), (15/16), (8/9), (5/6), (4/5), (3/4), (2/3), (5/8), (1/1.618), (3/5), (9/16), (8/15), (1/2), (2/5), (3/8), (1/3), (1/4)) !default;\n$ct-scales-names: (ct-square, ct-minor-second, ct-major-second, ct-minor-third, ct-major-third, ct-perfect-fourth, ct-perfect-fifth, ct-minor-sixth, ct-golden-section, ct-major-sixth, ct-minor-seventh, ct-major-seventh, ct-octave, ct-major-tenth, ct-major-eleventh, ct-major-twelfth, ct-double-octave) !default;\n\n// Class names to be used when generating CSS\n$ct-class-chart: ct-chart !default;\n$ct-class-chart-line: ct-chart-line !default;\n$ct-class-chart-bar: ct-chart-bar !default;\n$ct-class-horizontal-bars: ct-horizontal-bars !default;\n$ct-class-chart-pie: ct-chart-pie !default;\n$ct-class-chart-donut: ct-chart-donut !default;\n$ct-class-label: ct-label !default;\n$ct-class-series: ct-series !default;\n$ct-class-line: ct-line !default;\n$ct-class-point: ct-point !default;\n$ct-class-area: ct-area !default;\n$ct-class-bar: ct-bar !default;\n$ct-class-slice-pie: ct-slice-pie !default;\n$ct-class-slice-donut: ct-slice-donut !default;\n$ct-class-grid: ct-grid !default;\n$ct-class-vertical: ct-vertical !default;\n$ct-class-horizontal: ct-horizontal !default;\n$ct-class-start: ct-start !default;\n$ct-class-end: ct-end !default;\n\n// Container ratio\n$ct-container-ratio: (1/1.618) !default;\n\n// Text styles for labels\n$ct-text-color: rgba(0, 0, 0, 0.4) !default;\n$ct-text-size: 1.3rem !default;\n$ct-text-align: flex-start !default;\n$ct-text-justify: flex-start !default;\n$ct-text-line-height: 1;\n\n// Grid styles\n$ct-grid-color: rgba(0, 0, 0, 0.2) !default;\n$ct-grid-dasharray: 2px !default;\n$ct-grid-width: 1px !default;\n\n// Line chart properties\n$ct-line-width: 3px !default;\n$ct-line-dasharray: false !default;\n$ct-point-size: 8px !default;\n// Line chart point, can be either round or square\n$ct-point-shape: round !default;\n// Area fill transparency between 0 and 1\n$ct-area-opacity: 0.8 !default;\n\n// Bar chart bar width\n$ct-bar-width: 10px !default;\n\n// Donut width (If donut width is to big it can cause issues where the shape gets distorted)\n$ct-donut-width: 60px !default;\n\n// If set to true it will include the default classes and generate CSS output. If you're planning to use the mixins you\n// should set this property to false\n$ct-include-classes: true !default;\n\n// If this is set to true the CSS will contain colored series. You can extend or change the color with the\n// properties below\n$ct-include-colored-series: $ct-include-classes !default;\n\n// If set to true this will include all responsive container variations using the scales defined at the top of the script\n$ct-include-alternative-responsive-containers: $ct-include-classes !default;\n\n// Series names and colors. This can be extended or customized as desired. Just add more series and colors.\n$ct-series-names: (a, b, c, d, e, f, g, h, i, j, k, l, m, n, o) !default;\n$ct-series-colors: (\n  $new-blue,\n  $new-red,\n  $new-orange,\n  $new-purple,\n  $new-green,\n  $new-dark-blue,\n  $new-black,\n  $social-google,\n  $social-tumblr,\n  $social-youtube,\n  $social-twitter,\n  $social-pinterest,\n  $social-behance,\n  #6188e2,\n  #a748ca\n) !default;\n","@media (min-width: 992px){\n\n    .navbar-fixed{\n        width: calc(100% + 260px);\n    }\n\n    .navbar-form {\n        padding-left: 15px;\n        padding-right: 5px;\n\n        .input-group{\n            .form-control{\n                margin-left: 10px;\n            }\n        }\n    }\n\n    .nav.nav-mobile-menu{\n        display: none;\n    }\n\n    .navbar{\n        .navbar-nav{\n            .nc-icon{\n                font-weight: 700;\n                margin-top: 10px;\n            }\n            .input-group{\n                .nc-icon{\n                    margin-top: 0;\n                }\n            }\n            .dropdown-menu .dropdown-item{\n                .nc-icon{\n                    margin-top: 0;\n                }\n            }\n        }\n    }\n    .close-layer{\n        display: none;\n    }\n\n    .navbar-nav .nav-item .dropdown-menu, .dropdown .dropdown-menu{\n        @include transform-scale(0);\n        @include transition($slow-transition-time, $transition-bezier);\n    }\n    .navbar-nav .nav-item.show .dropdown-menu, .dropdown.show .dropdown-menu{\n        @include transform-scale(1);\n        @include transform-origin($dropdown-coordinates);\n\n    }\n\n    .sidebar-mini .sidebar .sidebar-wrapper > .nav [data-toggle=\"collapse\"] ~ div > ul > li > a .sidebar-normal, .sidebar-mini .sidebar .sidebar-wrapper .user .info [data-toggle=\"collapse\"] ~ div > ul > li > a .sidebar-normal, .sidebar-mini .sidebar .sidebar-wrapper .user .info > a > span,\n    .sidebar-mini .sidebar .sidebar-wrapper > .nav li > a span,\n    .sidebar-mini .sidebar .sidebar-wrapper > .nav li > a .caret{\n        @include transform-translate-3d(-25px);\n        opacity: 0;\n    }\n\n    .sidebar-mini{\n        .sidebar{\n            .logo{\n                a.logo-mini{\n                    opacity: 1;\n                }\n                a.logo-normal{\n                    opacity: 0;\n                }\n            }\n        }\n    }\n\n    .footer{\n        height: 60px;\n        .footer-menu{\n            float: left;\n        }\n        .copyright{\n            float: right;\n        }\n    }\n    .navbar-nav .nav-item .dropdown-menu:before{\n        border-bottom: 11px solid rgba(0, 0, 0, 0.2);\n        border-left: 11px solid rgba(0, 0, 0, 0);\n        border-right: 11px solid rgba(0, 0, 0, 0);\n        content: \"\";\n        display: inline-block;\n        position: absolute;\n        left: 12px;\n        top: -11px;\n    }\n    .navbar-nav .nav-item .dropdown-menu:after {\n        border-bottom: 11px solid #FFFFFF;\n        border-left: 11px solid rgba(0, 0, 0, 0);\n        border-right: 11px solid rgba(0, 0, 0, 0);\n        content: \"\";\n        display: inline-block;\n        position: absolute;\n        left: 12px;\n        top: -10px;\n    }\n\n    .navbar-nav.navbar-right .nav-item .dropdown-menu:before{\n        left: auto;\n        right: 12px;\n    }\n\n    .navbar-nav.navbar-right .nav-item .dropdown-menu:after{\n        left: auto;\n        right: 12px;\n    }\n\n    .footer:not(.footer-big){\n        nav > ul{\n           li:first-child{\n             margin-left: 0;\n           }\n        }\n    }\n\n    .card{\n        form{\n            [class*=\"col-\"]{\n                padding: 6px;\n            }\n            [class*=\"col-\"]:first-child{\n                padding-left: 15px;\n            }\n            [class*=\"col-\"]:last-child{\n                padding-right: 15px;\n            }\n        }\n    }\n}\n\n/*          Changes for small display      */\n\n@media (max-width: 991px){\n\n    .sidebar{\n        right: 0 !important;\n        left: auto;\n        @include transform-translate-3d(260px);\n        @include transition (0.5s, cubic-bezier(0.685, 0.0473, 0.346, 1));\n    }\n\n    .nav-open{\n        .main-panel{\n            position: absolute;\n            left: 0;\n            @include transform-translate-3d(-260px);\n            @include transition (0.5s, cubic-bezier(0.685, 0.0473, 0.346, 1));\n        }\n\n        .sidebar{\n            @include transform-translate-3d(0px);\n            @include transition (0.5s, cubic-bezier(0.685, 0.0473, 0.346, 1));\n        }\n    }\n\n    .main-panel{\n        // @include transform-translate-3d(0px);\n        @include transition (0.5s, cubic-bezier(0.685, 0.0473, 0.346, 1));\n    }\n\n    .menu-on-left{\n        .sidebar{\n            left: 0 !important;\n            right: auto;\n            @include transform-translate-3d(-260px);\n            @include transition (0.5s, cubic-bezier(0.685, 0.0473, 0.346, 1));\n        }\n        .main-panel{\n            @include transform-translate-3d(0px);\n            @include transition (0.5s, cubic-bezier(0.685, 0.0473, 0.346, 1));\n        }\n    }\n\n        .nav-open{\n            .menu-on-left{\n                .main-panel{\n                    position: absolute;\n                    left: 0;\n                    @include transform-translate-3d(260px);\n                    @include transition (0.5s, cubic-bezier(0.685, 0.0473, 0.346, 1));\n                }\n\n                .sidebar{\n                    @include transform-translate-3d(0px);\n                    @include transition (0.5s, cubic-bezier(0.685, 0.0473, 0.346, 1));\n                }\n            }\n        }\n\n\n\n    .nav-item.active-pro{\n        position: relative !important;\n    }\n\n    .nav-mobile-menu{\n        border-bottom: 1px solid rgba(255, 255, 255, 0.2);\n        margin-bottom: 15px;\n        padding-bottom: 15px;\n        padding-top: 5px;\n\n        .dropdown{\n            .dropdown-menu{\n                position: static !important;\n                float: none;\n                width: auto;\n                color: $white-color;\n                margin-top: 0;\n                background-color: transparent;\n                border: 0;\n                -webkit-box-shadow: none;\n                box-shadow: none;\n                transform: translate3d(0px, 0px, 0px) !important;\n                @include transition (0.5s, cubic-bezier(0.685, 0.0473, 0.346, 1));\n\n                .dropdown-item{\n                    margin: 5px 15px 0px 20px;\n                    border-radius: 4px;\n                    color: $white-color;\n                    opacity: .86;\n                    padding: 8px 50px;\n                    &:hover{\n                        background-color: rgba(255, 255, 255, 0.23)\n                    }\n                    .nc-icon{\n                        margin-left: -40px;\n                    }\n                }\n            }\n\n        }\n        .nav-item{\n            .nav-link{\n                span{\n                    display: inline-block !important;\n                }\n                .no-icon{\n                    padding-left: 50px;\n                }\n            }\n        }\n    }\n    .main-panel{\n        width: 100%;\n    }\n\n    .navbar-brand{\n        padding: 15px 0px;\n    }\n    .navbar-transparent{\n        padding-top: 15px;\n        // background-color: rgba(0, 0, 0, 0.45);\n    }\n    body {\n         position: relative;\n    }\n    .wrapper{\n       left: 0;\n       background-color: white;\n    }\n    .navbar .container{\n        left: 15px;\n        width: 100%;\n        position: relative;\n        top: -10px;\n    }\n\n    .navbar-nav{\n        .nav-item{\n            float: none;\n            position: relative;\n            display: block;\n        }\n    }\n\n    body > .navbar-collapse {\n        position: fixed;\n        display: block;\n        top: 0;\n        height: 100%;\n        right: 0;\n        left: auto;\n        z-index: 1032;\n        visibility: visible;\n        background-color: #999;\n        overflow-y: visible;\n        border-top: none;\n        text-align: left;\n        padding: 0;\n\n        @include transform-translate-x(260px);\n        @include transition (0.33s, cubic-bezier(0.685, 0.0473, 0.346, 1));\n        > ul {\n            position: relative;\n            z-index: 4;\n            overflow-y:scroll;\n            height: calc(100vh - 61px);\n            width: 100%;\n        }\n\n        &::before{\n            top: 0;\n            left: 0;\n            height: 100%;\n            width: 100%;\n            position: absolute;\n            background-color: #282828;\n            display: block;\n            content: \"\";\n            z-index: 1;\n        }\n\n        .logo{\n            position: relative;\n            z-index: 4;\n        }\n\n        .nav li > a{\n            padding: 10px 15px;\n        }\n    }\n    .nav-show .navbar-collapse{\n        @include transform-translate-x(0px);\n    }\n    .nav-show .navbar .container{\n        left: -250px;\n    }\n    .nav-show .wrapper{\n        left: 0;\n        @include transform-translate-x(-260px);\n    }\n    .navbar-toggle .icon-bar {\n          display: block;\n          position: relative;\n          background: #fff;\n          width: 24px;\n          height: 2px;\n          border-radius: 1px;\n          margin: 0 auto;\n    }\n\n    .navbar-header .navbar-toggle {\n        margin: 10px 15px 10px 0;\n        width: 40px;\n        height: 40px;\n    }\n    .bar1,\n    .bar2,\n    .bar3 {\n      outline: 1px solid transparent;\n    }\n    .bar1 {\n      top: 0px;\n      @include bar-animation($topbar-back);\n    }\n    .bar2 {\n      opacity: 1;\n    }\n    .bar3 {\n      bottom: 0px;\n      @include bar-animation($bottombar-back);\n    }\n    .toggled .bar1 {\n      top: 6px;\n      @include bar-animation($topbar-x);\n    }\n    .toggled .bar2 {\n      opacity: 0;\n    }\n    .toggled .bar3 {\n      bottom: 6px;\n      @include bar-animation($bottombar-x);\n    }\n\n    @include topbar-x-rotation();\n    @include topbar-back-rotation();\n    @include bottombar-x-rotation();\n    @include bottombar-back-rotation();\n\n    @-webkit-keyframes fadeIn {\n      0% {opacity: 0;}\n      100% {opacity: 1;}\n    }\n    @-moz-keyframes fadeIn {\n      0% {opacity: 0;}\n      100% {opacity: 1;}\n    }\n    @keyframes fadeIn {\n      0% {opacity: 0;}\n      100% {opacity: 1;}\n    }\n\n    .dropdown-menu .divider{\n        background-color: rgba(229, 229, 229, 0.15);\n    }\n\n    .navbar-nav {\n        margin: 1px 0;\n\n        .show .dropdown-menu .nav-item{\n            .nav-link{\n                padding: 10px 15px 10px 60px;\n            }\n        }\n    }\n\n    [class*=\"navbar-\"] .navbar-nav {\n        & > li > a,\n        > li > a:hover,\n        > li > a:focus,\n        .active > a,\n        .active > a:hover,\n        .active > a:focus,\n        .show .dropdown-menu > li > a,\n        .show .dropdown-menu > li > a:hover,\n        .show .dropdown-menu > li > a:focus,\n        .show .dropdown-menu > li > a:active {\n            color: white;\n        }\n\n        & > li > a,\n        > li > a:hover,\n        > li > a:focus{\n            opacity: .7;\n            background-color: transparent;\n            outline: none;\n        }\n\n        .show .dropdown-menu > li > a:hover,\n        .show .dropdown-menu > li > a:focus{\n            background-color: rgba(255,255,255, .1);\n        }\n\n\n\n        &.navbar-nav .show .dropdown-menu > li > a:active {\n            opacity: 1;\n        }\n\n        & .dropdown > a{\n            &:hover .caret {\n                border-bottom-color: #fff;\n                border-top-color: #fff;\n            }\n            &:active .caret {\n                border-bottom-color: white;\n                border-top-color: white;\n            }\n        }\n\n    }\n\n    .dropdown-menu {\n        display: none;\n    }\n    .navbar-fixed-top {\n        -webkit-backface-visibility: hidden;\n    }\n    #bodyClick {\n        height: 100%;\n        width: 100%;\n        position: fixed;\n        opacity: 0;\n        top: 0;\n        left: auto;\n        right: 250px;\n        content: \"\";\n        z-index: 9999;\n        overflow-x: hidden;\n    }\n\n    .social-line .btn{\n        margin: $margin-bottom;\n    }\n    .subscribe-line .form-control{\n        margin: $margin-bottom;\n    }\n    .social-line.pull-right{\n        float: none;\n    }\n    .social-area.pull-right{\n        float: none !important;\n    }\n    .form-control + .form-control-feedback{\n        margin-top: -8px;\n    }\n    .navbar-toggle:hover,.navbar-toggle:focus {\n        background-color: transparent !important;\n    }\n    .btn.dropdown-toggle{\n        margin-bottom: 0;\n    }\n    .media-post .author{\n        width: 20%;\n        float: none !important;\n        display: block;\n        margin: 0 auto 10px;\n    }\n    .media-post .media-body{\n        width: 100%;\n    }\n\n    .navbar-collapse.collapse.in {\n        display: block;\n    }\n    .navbar-header .collapse, .navbar-toggle {\n        display:block !important;\n    }\n    .navbar-header {\n        float:none;\n    }\n    .navbar-nav .show .dropdown-menu {\n        position: static;\n        float: none;\n        width: auto;\n        margin-top: 0;\n        background-color: transparent;\n        border: 0;\n        -webkit-box-shadow: none;\n        box-shadow: none;\n    }\n    .navbar-collapse{\n        .navbar-nav p{\n            line-height: 40px !important;\n            margin: 0;\n        }\n\n        [class^=\"pe-7s-\"]{\n            float: left;\n            font-size: 20px;\n            margin-right: 10px;\n        }\n    }\n}\n\n//overwrite table responsive for 768px screens\n\n@media (min-width: 992px){\n    .table-full-width{\n        margin-left: -15px;\n        margin-right: -15px;\n    }\n    .table-responsive{\n        overflow: visible;\n    }\n\n}\n\n@media (max-width: 991px){\n    .table-responsive {\n        width: 100%;\n        margin-bottom: 15px;\n        overflow-x: scroll;\n        overflow-y: hidden;\n        -ms-overflow-style: -ms-autohiding-scrollbar;\n        -webkit-overflow-scrolling: touch;\n    }\n\n    .close-layer{\n        height: 100%;\n        width: 100%;\n        position: absolute;\n        opacity: 0;\n        top: 0;\n        left: auto;\n\n        content: \"\";\n        z-index: 9999;\n        overflow-x: hidden;\n        background-color: rgba(0,0,0,.35);\n\n        @include transition($slow-transition-time, $transition-ease-in);\n\n        &.visible{\n            opacity: 1;\n        }\n    }\n}\n\n@media (max-width: 768px){\n    .main-panel{\n        .navbar.navbar-fixed{\n            width: 100% !important;\n        }\n\n        .typo-line{\n            padding-left: 80px;\n        }\n        .slider-success.noUi-target{\n            margin-bottom: 15px;\n        }\n    }\n\n    .card{\n        .card-body{\n            .control-label{\n                text-align: left;\n            }\n        }\n    }\n}\n",".bootstrap-switch {\n  display: inline-block;\n  direction: ltr;\n  cursor: pointer;\n  border-radius: 30px;\n  border: 0;\n  position: relative;\n  text-align: left;\n  overflow: hidden;\n  margin-bottom: 5px;\n  line-height: 8px;\n  width: 61px !important;\n  height: 26px;\n  outline: none;\n  z-index: 0;\n  margin-right: 1px;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  vertical-align: middle;\n  -webkit-transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;\n  transition: border-color ease-in-out .15s, box-shadow ease-in-out .15s;\n}\n\n.bootstrap-switch .bootstrap-switch-container {\n  display: inline-flex;\n  top: 0;\n  height: 26px;\n  border-radius: 4px;\n  -webkit-transform: translate3d(0, 0, 0);\n  transform: translate3d(0, 0, 0);\n  width: 100px !important;\n}\n\n.bootstrap-switch .bootstrap-switch-handle-on,\n.bootstrap-switch .bootstrap-switch-handle-off,\n.bootstrap-switch .bootstrap-switch-label {\n    -webkit-box-sizing: border-box;\n    -moz-box-sizing: border-box;\n    box-sizing: border-box;\n    cursor: pointer;\n    display: inline-block !important;\n    height: 100%;\n    color: #fff;\n    padding: 6px 10px;\n    font-size: 11px;\n    text-indent: -5px;\n    line-height: 15px;\n    -webkit-transition: 0.25s ease-out;\n    transition: 0.25s ease-out;\n\n    i{\n        font-size: 12px;\n        line-height: 14px;\n  }\n}\n\n.bootstrap-switch .bootstrap-switch-handle-on,\n.bootstrap-switch .bootstrap-switch-handle-off {\n  text-align: center;\n  z-index: 1;\n  float: left;\n  width: 50% !important;\n  background-color: $info-color;\n}\n\n\n.bootstrap-switch .bootstrap-switch-label {\n  text-align: center;\n  z-index: 100;\n  color: #333333;\n  background: #ffffff;\n  width: 22px !important;\n  height: 22px;\n  margin: 2px -11px;\n  border-radius: 12px;\n  position: relative;\n  float: left;\n  padding: 0;\n  background-color: #FFFFFF;\n  box-shadow: 0 1px 1px #FFFFFF inset, 0 1px 1px rgba(0, 0, 0, 0.25);\n}\n\n.bootstrap-switch .bootstrap-switch-handle-on {\n  border-bottom-left-radius: 3px;\n  border-top-left-radius: 3px;\n}\n\n.bootstrap-switch .bootstrap-switch-handle-off {\n  text-indent: 6px;\n}\n\n.bootstrap-switch input[type='radio'],\n.bootstrap-switch input[type='checkbox'] {\n  position: absolute !important;\n  top: 0;\n  left: 0;\n  opacity: 0;\n  filter: alpha(opacity=0);\n  z-index: -1;\n}\n\n\n.bootstrap-switch.bootstrap-switch-animate .bootstrap-switch-container {\n  -webkit-transition: margin-left 0.5s;\n  transition: margin-left 0.5s;\n}\n\n\n.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-container {\n  margin-left: -2px !important;\n}\n\n.bootstrap-switch.bootstrap-switch-off .bootstrap-switch-container {\n  margin-left: -37px !important;\n}\n\n.bootstrap-switch.bootstrap-switch-on:hover .bootstrap-switch-label {\n  width: 26px !important;\n  margin: 2px -15px;\n}\n\n.bootstrap-switch.bootstrap-switch-off:hover .bootstrap-switch-label {\n  width: 26px !important;\n  margin: 2px -15px -13px -11px;\n}\n\n\n.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-danger  {\n  background-color: $color-red;\n}\n\n.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-warning  {\n  background-color: $color-orange;\n}\n\n.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-success  {\n  background-color: $color-green;\n}\n\n.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-primary  {\n  background-color: $color-blue;\n}\n\n.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-info  {\n  background-color: $color-azure;\n}\n.bootstrap-switch.bootstrap-switch-on .bootstrap-switch-default  {\n  background-color: $color-black;\n}\n\n.bootstrap-switch.bootstrap-switch-off .bootstrap-switch-danger,\n.bootstrap-switch.bootstrap-switch-off .bootstrap-switch-primary,\n.bootstrap-switch.bootstrap-switch-off .bootstrap-switch-info,\n.bootstrap-switch.bootstrap-switch-off .bootstrap-switch-warning,\n.bootstrap-switch.bootstrap-switch-off .bootstrap-switch-success {\n  background-color: #cfcfca;\n}\n","/*--------------------------------\n\nnucleo-icons Web Font - built using nucleoapp.com\nLicense - nucleoapp.com/license/\n\n-------------------------------- */\n@font-face {\n  font-family: 'nucleo-icons';\n  src: url('~assets/fonts/nucleo-icons.eot');\n  src: url('~assets/fonts/nucleo-icons.eot') format('embedded-opentype'), url('~assets/fonts/nucleo-icons.woff2') format('woff2'), url('~assets/fonts/nucleo-icons.woff') format('woff'), url('~assets/fonts/nucleo-icons.ttf') format('truetype'), url('~assets/fonts/nucleo-icons.svg') format('svg');\n  font-weight: normal;\n  font-style: normal;\n}\n/*------------------------\n\tbase class definition\n-------------------------*/\n.nc-icon {\n  display: inline-block;\n  font: normal normal normal 14px/1 'nucleo-icons';\n  font-size: inherit;\n  speak: none;\n  text-transform: none;\n  /* Better Font Rendering */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n\n  &.icon-bold{\n    font-weight: 700;\n  }\n}\n/*------------------------\n  change icon size\n-------------------------*/\n.nc-icon.lg {\n  font-size: 1.33333333em;\n  vertical-align: -16%;\n}\n.nc-icon.x2 {\n  font-size: 2em;\n}\n.nc-icon.x3 {\n  font-size: 3em;\n}\n/*----------------------------------\n  add a square/circle background\n-----------------------------------*/\n.nc-icon.square,\n.nc-icon.circle {\n  padding: 0.33333333em;\n  vertical-align: -16%;\n  background-color: #eee;\n}\n.nc-icon.circle {\n  border-radius: 50%;\n}\n/*------------------------\n  list icons\n-------------------------*/\n.nc-icon-ul {\n  padding-left: 0;\n  margin-left: 2.14285714em;\n  list-style-type: none;\n}\n.nc-icon-ul > li {\n  position: relative;\n}\n.nc-icon-ul > li > .nc-icon {\n  position: absolute;\n  left: -1.57142857em;\n  top: 0.14285714em;\n  text-align: center;\n}\n.nc-icon-ul > li > .nc-icon.lg {\n  top: 0;\n  left: -1.35714286em;\n}\n.nc-icon-ul > li > .nc-icon.circle,\n.nc-icon-ul > li > .nc-icon.square {\n  top: -0.19047619em;\n  left: -1.9047619em;\n}\n\n.all-icons{\n    .font-icon-list{\n        .font-icon-detail i{\n            font-size: 32px;\n        }\n    }\n}\n/*------------------------\n  spinning icons\n-------------------------*/\n.nc-icon.spin {\n  -webkit-animation: nc-icon-spin 2s infinite linear;\n  -moz-animation: nc-icon-spin 2s infinite linear;\n  animation: nc-icon-spin 2s infinite linear;\n}\n@-webkit-keyframes nc-icon-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n  }\n}\n@-moz-keyframes nc-icon-spin {\n  0% {\n    -moz-transform: rotate(0deg);\n  }\n  100% {\n    -moz-transform: rotate(360deg);\n  }\n}\n@keyframes nc-icon-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n    -moz-transform: rotate(0deg);\n    -ms-transform: rotate(0deg);\n    -o-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n    -moz-transform: rotate(360deg);\n    -ms-transform: rotate(360deg);\n    -o-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n/*------------------------\n  rotated/flipped icons\n-------------------------*/\n.nc-icon.rotate-90 {\n  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=1);\n  -webkit-transform: rotate(90deg);\n  -moz-transform: rotate(90deg);\n  -ms-transform: rotate(90deg);\n  -o-transform: rotate(90deg);\n  transform: rotate(90deg);\n}\n.nc-icon.rotate-180 {\n  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=2);\n  -webkit-transform: rotate(180deg);\n  -moz-transform: rotate(180deg);\n  -ms-transform: rotate(180deg);\n  -o-transform: rotate(180deg);\n  transform: rotate(180deg);\n}\n.nc-icon.rotate-270 {\n  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=3);\n  -webkit-transform: rotate(270deg);\n  -moz-transform: rotate(270deg);\n  -ms-transform: rotate(270deg);\n  -o-transform: rotate(270deg);\n  transform: rotate(270deg);\n}\n.nc-icon.flip-y {\n  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=0);\n  -webkit-transform: scale(-1, 1);\n  -moz-transform: scale(-1, 1);\n  -ms-transform: scale(-1, 1);\n  -o-transform: scale(-1, 1);\n  transform: scale(-1, 1);\n}\n.nc-icon.flip-x {\n  filter: progid:DXImageTransform.Microsoft.BasicImage(rotation=2);\n  -webkit-transform: scale(1, -1);\n  -moz-transform: scale(1, -1);\n  -ms-transform: scale(1, -1);\n  -o-transform: scale(1, -1);\n  transform: scale(1, -1);\n}\n/*------------------------\n\tfont icons\n-------------------------*/\n\n.nc-air-baloon::before {\n    content: \"\\ea01\";\n}\n\n.nc-album-2::before {\n    content: \"\\ea02\";\n}\n\n.nc-alien-33::before {\n    content: \"\\ea03\";\n}\n\n.nc-align-center::before {\n    content: \"\\ea04\";\n}\n\n.nc-align-left-2::before {\n    content: \"\\ea05\";\n}\n\n.nc-ambulance::before {\n    content: \"\\ea06\";\n}\n\n.nc-android::before {\n    content: \"\\ea07\";\n}\n\n.nc-app::before {\n    content: \"\\ea08\";\n}\n\n.nc-apple::before {\n    content: \"\\ea09\";\n}\n\n.nc-atom::before {\n    content: \"\\ea0a\";\n}\n\n.nc-attach-87::before {\n    content: \"\\ea0b\";\n}\n\n.nc-audio-92::before {\n    content: \"\\ea0c\";\n}\n\n.nc-backpack::before {\n    content: \"\\ea0d\";\n}\n\n.nc-badge::before {\n    content: \"\\ea0e\";\n}\n\n.nc-bag::before {\n    content: \"\\ea0f\";\n}\n\n.nc-bank::before {\n    content: \"\\ea10\";\n}\n\n.nc-battery-81::before {\n    content: \"\\ea11\";\n}\n\n.nc-bell-55::before {\n    content: \"\\ea12\";\n}\n\n.nc-bold::before {\n    content: \"\\ea13\";\n}\n\n.nc-bulb-63::before {\n    content: \"\\ea14\";\n}\n\n.nc-bullet-list-67::before {\n    content: \"\\ea15\";\n}\n\n.nc-bus-front-12::before {\n    content: \"\\ea16\";\n}\n\n.nc-button-pause::before {\n    content: \"\\ea17\";\n}\n\n.nc-button-play::before {\n    content: \"\\ea18\";\n}\n\n.nc-button-power::before {\n    content: \"\\ea19\";\n}\n\n.nc-camera-20::before {\n    content: \"\\ea1a\";\n}\n\n.nc-caps-small::before {\n    content: \"\\ea1b\";\n}\n\n.nc-cart-simple::before {\n    content: \"\\ea1c\";\n}\n\n.nc-cctv::before {\n    content: \"\\ea1d\";\n}\n\n.nc-chart-bar-32::before {\n    content: \"\\ea1e\";\n}\n\n.nc-chart-pie-35::before {\n    content: \"\\ea1f\";\n}\n\n.nc-chart-pie-36::before {\n    content: \"\\ea20\";\n}\n\n.nc-chart::before {\n    content: \"\\ea21\";\n}\n\n.nc-chat-round::before {\n    content: \"\\ea22\";\n}\n\n.nc-check-2::before {\n    content: \"\\ea23\";\n}\n\n.nc-circle-09::before {\n    content: \"\\ea24\";\n}\n\n.nc-circle::before {\n    content: \"\\ea25\";\n}\n\n.nc-cloud-download-93::before {\n    content: \"\\ea26\";\n}\n\n.nc-cloud-upload-94::before {\n    content: \"\\ea27\";\n}\n\n.nc-compass-05::before {\n    content: \"\\ea28\";\n}\n\n.nc-controller-modern::before {\n    content: \"\\ea29\";\n}\n\n.nc-credit-card::before {\n    content: \"\\ea2a\";\n}\n\n.nc-delivery-fast::before {\n    content: \"\\ea2b\";\n}\n\n.nc-email-83::before {\n    content: \"\\ea2c\";\n}\n\n.nc-email-85::before {\n    content: \"\\ea2d\";\n}\n\n.nc-explore-2::before {\n    content: \"\\ea2e\";\n}\n\n.nc-fav-remove::before {\n    content: \"\\ea2f\";\n}\n\n.nc-favourite-28::before {\n    content: \"\\ea30\";\n}\n\n.nc-globe-2::before {\n    content: \"\\ea31\";\n}\n\n.nc-grid-45::before {\n    content: \"\\ea32\";\n}\n\n.nc-headphones-2::before {\n    content: \"\\ea33\";\n}\n\n.nc-html5::before {\n    content: \"\\ea34\";\n}\n\n.nc-istanbul::before {\n    content: \"\\ea35\";\n}\n\n.nc-key-25::before {\n    content: \"\\ea36\";\n}\n\n.nc-layers-3::before {\n    content: \"\\ea37\";\n}\n\n.nc-light-3::before {\n    content: \"\\ea38\";\n}\n\n.nc-lock-circle-open::before {\n    content: \"\\ea39\";\n}\n\n.nc-map-big::before {\n    content: \"\\ea3a\";\n}\n\n.nc-mobile::before {\n    content: \"\\ea3c\";\n}\n\n.nc-money-coins::before {\n    content: \"\\ea3b\";\n}\n\n.nc-note-03::before {\n    content: \"\\ea3d\";\n}\n\n.nc-notes::before {\n    content: \"\\ea3e\";\n}\n\n.nc-notification-70::before {\n    content: \"\\ea3f\";\n}\n\n.nc-palette::before {\n    content: \"\\ea40\";\n}\n\n.nc-paper-2::before {\n    content: \"\\ea41\";\n}\n\n.nc-pin-3::before {\n    content: \"\\ea42\";\n}\n\n.nc-planet::before {\n    content: \"\\ea43\";\n}\n\n.nc-preferences-circle-rotate::before {\n    content: \"\\ea44\";\n}\n\n.nc-puzzle-10::before {\n    content: \"\\ea45\";\n}\n\n.nc-quote::before {\n    content: \"\\ea46\";\n}\n\n.nc-refresh-02::before {\n    content: \"\\ea47\";\n}\n\n.nc-ruler-pencil::before {\n    content: \"\\ea48\";\n}\n\n.nc-satisfied::before {\n    content: \"\\ea49\";\n}\n\n.nc-scissors::before {\n    content: \"\\ea4a\";\n}\n\n.nc-send::before {\n    content: \"\\ea4b\";\n}\n\n.nc-settings-90::before {\n    content: \"\\ea4c\";\n}\n\n.nc-settings-gear-64::before {\n    content: \"\\ea4d\";\n}\n\n.nc-settings-tool-66::before {\n    content: \"\\ea4e\";\n}\n\n.nc-simple-add::before {\n    content: \"\\ea4f\";\n}\n\n.nc-simple-delete::before {\n    content: \"\\ea50\";\n}\n\n.nc-simple-remove::before {\n    content: \"\\ea51\";\n}\n\n.nc-single-02::before {\n    content: \"\\ea52\";\n}\n\n.nc-single-copy-04::before {\n    content: \"\\ea53\";\n}\n\n.nc-spaceship::before {\n    content: \"\\ea54\";\n}\n\n.nc-square-pin::before {\n    content: \"\\ea55\";\n}\n\n.nc-stre-down::before {\n    content: \"\\ea56\";\n}\n\n.nc-stre-left::before {\n    content: \"\\ea57\";\n}\n\n.nc-stre-right::before {\n    content: \"\\ea58\";\n}\n\n.nc-stre-up::before {\n    content: \"\\ea59\";\n}\n\n.nc-sun-fog-29::before {\n    content: \"\\ea5a\";\n}\n\n.nc-support-17::before {\n    content: \"\\ea5b\";\n}\n\n.nc-tablet-2::before {\n    content: \"\\ea5c\";\n}\n\n.nc-tag-content::before {\n    content: \"\\ea5d\";\n}\n\n.nc-tap-01::before {\n    content: \"\\ea5e\";\n}\n\n.nc-time-alarm::before {\n    content: \"\\ea5f\";\n}\n\n.nc-tv-2::before {\n    content: \"\\ea60\";\n}\n\n.nc-umbrella-13::before {\n    content: \"\\ea61\";\n}\n\n.nc-vector::before {\n    content: \"\\ea62\";\n}\n\n.nc-watch-time::before {\n    content: \"\\ea63\";\n}\n\n.nc-zoom-split::before {\n    content: \"\\ea64\";\n}\n\n\n/* all icon font classes list here */\n","\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n// This file was modified by Creative Tim to keep only the animation that we need for Bootstrap Notify\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n@charset \"UTF-8\";\n\n/*!\nAnimate.css - http://daneden.me/animate\nLicensed under the MIT license - http://opensource.org/licenses/MIT\n\nCopyright (c) 2015 Daniel Eden\n*/\n\n.animated {\n  -webkit-animation-duration: 1s;\n  animation-duration: 1s;\n  -webkit-animation-fill-mode: both;\n  animation-fill-mode: both;\n}\n\n.animated.infinite {\n  -webkit-animation-iteration-count: infinite;\n  animation-iteration-count: infinite;\n}\n\n.animated.hinge {\n  -webkit-animation-duration: 2s;\n  animation-duration: 2s;\n}\n\n.animated.bounceIn,\n.animated.bounceOut {\n  -webkit-animation-duration: .75s;\n  animation-duration: .75s;\n}\n\n.animated.flipOutX,\n.animated.flipOutY {\n  -webkit-animation-duration: .75s;\n  animation-duration: .75s;\n}\n\n@-webkit-keyframes shake {\n  from, to {\n    -webkit-transform: translate3d(0, 0, 0);\n    transform: translate3d(0, 0, 0);\n  }\n\n  10%, 30%, 50%, 70%, 90% {\n    -webkit-transform: translate3d(-10px, 0, 0);\n    transform: translate3d(-10px, 0, 0);\n  }\n\n  20%, 40%, 60%, 80% {\n    -webkit-transform: translate3d(10px, 0, 0);\n    transform: translate3d(10px, 0, 0);\n  }\n}\n\n@keyframes shake {\n  from, to {\n    -webkit-transform: translate3d(0, 0, 0);\n    transform: translate3d(0, 0, 0);\n  }\n\n  10%, 30%, 50%, 70%, 90% {\n    -webkit-transform: translate3d(-10px, 0, 0);\n    transform: translate3d(-10px, 0, 0);\n  }\n\n  20%, 40%, 60%, 80% {\n    -webkit-transform: translate3d(10px, 0, 0);\n    transform: translate3d(10px, 0, 0);\n  }\n}\n\n.shake {\n  -webkit-animation-name: shake;\n  animation-name: shake;\n}\n\n\n\n@-webkit-keyframes fadeInDown {\n  from {\n    opacity: 0;\n    -webkit-transform: translate3d(0, -100%, 0);\n    transform: translate3d(0, -100%, 0);\n  }\n\n  to {\n    opacity: 1;\n    -webkit-transform: none;\n    transform: none;\n  }\n}\n\n@keyframes fadeInDown {\n  from {\n    opacity: 0;\n    -webkit-transform: translate3d(0, -100%, 0);\n    transform: translate3d(0, -100%, 0);\n  }\n\n  to {\n    opacity: 1;\n    -webkit-transform: none;\n    transform: none;\n  }\n}\n\n.fadeInDown {\n  -webkit-animation-name: fadeInDown;\n  animation-name: fadeInDown;\n}\n\n\n@-webkit-keyframes fadeOut {\n  from {\n    opacity: 1;\n  }\n\n  to {\n    opacity: 0;\n  }\n}\n\n@keyframes fadeOut {\n  from {\n    opacity: 1;\n  }\n\n  to {\n    opacity: 0;\n  }\n}\n\n.fadeOut {\n  -webkit-animation-name: fadeOut;\n  animation-name: fadeOut;\n}\n\n@-webkit-keyframes fadeOutDown {\n  from {\n    opacity: 1;\n  }\n\n  to {\n    opacity: 0;\n    -webkit-transform: translate3d(0, 100%, 0);\n    transform: translate3d(0, 100%, 0);\n  }\n}\n\n@keyframes fadeOutDown {\n  from {\n    opacity: 1;\n  }\n\n  to {\n    opacity: 0;\n    -webkit-transform: translate3d(0, 100%, 0);\n    transform: translate3d(0, 100%, 0);\n  }\n}\n\n.fadeOutDown {\n  -webkit-animation-name: fadeOutDown;\n  animation-name: fadeOutDown;\n}\n\n@-webkit-keyframes fadeOutUp {\n  from {\n    opacity: 1;\n  }\n\n  to {\n    opacity: 0;\n    -webkit-transform: translate3d(0, -100%, 0);\n    transform: translate3d(0, -100%, 0);\n  }\n}\n\n@keyframes fadeOutUp {\n  from {\n    opacity: 1;\n  }\n\n  to {\n    opacity: 0;\n    -webkit-transform: translate3d(0, -100%, 0);\n    transform: translate3d(0, -100%, 0);\n  }\n}\n\n.fadeOutUp {\n  -webkit-animation-name: fadeOutUp;\n  animation-name: fadeOutUp;\n}\n\n","// SweetAlert\n// github.com/limonte/sweetalert2\n\n.sweet-overlay {\n  background-color: rgba(0, 0, 0, 0.4);\n  position: fixed;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  display: none;\n  z-index: 1000; }\n\n.sweet-alert {\n  background-color: #fff;\n  font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  border-radius: 5px;\n  box-sizing: border-box;\n  text-align: center;\n  position: fixed;\n  left: 50%;\n  top: 50%;\n  margin-top: -200px;\n  max-height: 90%;\n  overflow-x: hidden;\n  overflow-y: auto;\n  display: none;\n  z-index: 2000;\n\n  &:focus{\n      outline: 0;\n  }\n\n  button{\n      margin: 0 5px;\n  }\n\n  .form-control{\n      max-width: 300px;\n      margin: 0 auto;\n  }\n}\n  .sweet-alert h2 {\n    color: #575757;\n    text-align: center;\n    text-transform: none;\n    position: relative;\n    padding: 0;\n    display: block;\n}\n  .sweet-alert p {\n    text-align: center;\n    position: relative;\n    float: none;\n    margin: 0;\n    padding: 0;\n}\n  .sweet-alert hr {\n    height: 5px;\n    color: transparent;\n    border: 0;\n}\n  .sweet-alert button.styled {\n    color: #fff;\n    border: 0;\n    box-shadow: none;\n    font-size: 17px;\n    font-weight: 500;\n    border-radius: 5px;\n    padding: 10px 32px;\n    margin: 0 5px;\n    cursor: pointer; }\n    .sweet-alert button.styled:focus {\n      outline: none; }\n    .sweet-alert button.styled.sweet-cancel[disabled] {\n      opacity: .4; }\n    .sweet-alert button.styled.sweet-confirm[disabled] {\n      border: 4px solid transparent;\n      border-color: transparent;\n      width: 40px;\n      height: 40px;\n      padding: 0;\n      margin: 0 30px;\n      vertical-align: middle;\n      background-color: transparent !important;\n      color: transparent;\n      cursor: default;\n      border-radius: 100%;\n      -webkit-animation: rotate-loading 1.5s linear 0s infinite normal;\n              animation: rotate-loading 1.5s linear 0s infinite normal; }\n    .sweet-alert button.styled::-moz-focus-inner {\n      border: 0; }\n  .sweet-alert[data-has-cancel-button=false] button {\n    box-shadow: none !important; }\n  .sweet-alert .icon {\n    width: 80px;\n    height: 80px;\n    border: 4px solid #808080;\n    border-radius: 50%;\n    margin: 20px auto;\n    padding: 0;\n    position: relative;\n    box-sizing: content-box; }\n    .sweet-alert .icon.error {\n      border-color: #f27474; }\n      .sweet-alert .icon.error .x-mark {\n        position: relative;\n        display: block; }\n      .sweet-alert .icon.error .line {\n        position: absolute;\n        height: 5px;\n        width: 47px;\n        // background-color: $color-red;\n        display: block;\n        top: 37px;\n        border-radius: 2px; }\n        .sweet-alert .icon.error .line.left {\n          -webkit-transform: rotate(45deg);\n                  transform: rotate(45deg);\n          left: 17px; }\n        .sweet-alert .icon.error .line.right {\n          -webkit-transform: rotate(-45deg);\n                  transform: rotate(-45deg);\n          right: 16px; }\n    .sweet-alert .icon.warning {\n      border-color: #f8bb86; }\n      .sweet-alert .icon.warning .body {\n        position: absolute;\n        width: 5px;\n        height: 47px;\n        left: 50%;\n        top: 10px;\n        border-radius: 2px;\n        margin-left: -2px;\n        background-color: #f8bb86; }\n      .sweet-alert .icon.warning .dot {\n        position: absolute;\n        width: 7px;\n        height: 7px;\n        border-radius: 50%;\n        margin-left: -3px;\n        left: 50%;\n        bottom: 10px;\n        background-color: #f8bb86; }\n    .sweet-alert .icon.info {\n      border-color: #c9dae1; }\n      .sweet-alert .icon.info::before {\n        content: '';\n        position: absolute;\n        width: 5px;\n        height: 29px;\n        left: 50%;\n        bottom: 17px;\n        border-radius: 2px;\n        margin-left: -2px;\n        background-color: #c9dae1; }\n      .sweet-alert .icon.info::after {\n        content: '';\n        position: absolute;\n        width: 7px;\n        height: 7px;\n        border-radius: 50%;\n        margin-left: -3px;\n        top: 19px;\n        background-color: #c9dae1; }\n    .sweet-alert .icon.success {\n      border-color: #a5dc86;\n    }\n      .sweet-alert .icon.success::before, .sweet-alert .icon.success::after {\n        content: '';\n        border-radius: 50%;\n        position: absolute;\n        width: 60px;\n        height: 120px;\n        background: #fff;\n        -webkit-transform: rotate(45deg);\n                transform: rotate(45deg);\n    }\n      .sweet-alert .icon.success::before {\n        border-radius: 120px 0 0 120px;\n        top: -7px;\n        left: -33px;\n        -webkit-transform: rotate(-45deg);\n                transform: rotate(-45deg);\n        -webkit-transform-origin: 60px 60px;\n                transform-origin: 60px 60px; }\n      .sweet-alert .icon.success::after {\n        border-radius: 0 120px 120px 0;\n        top: -11px;\n        left: 30px;\n        -webkit-transform: rotate(-45deg);\n                transform: rotate(-45deg);\n        -webkit-transform-origin: 0 60px;\n                transform-origin: 0 60px; }\n      .sweet-alert .icon.success .placeholder {\n        width: 80px;\n        height: 80px;\n        border: 4px solid rgba(165, 220, 134, 0.2);\n        border-radius: 50%;\n        box-sizing: content-box;\n        position: absolute;\n        left: -4px;\n        top: -4px;\n        z-index: 2; }\n      .sweet-alert .icon.success .fix {\n        width: 5px;\n        height: 90px;\n        background-color: #fff;\n        position: absolute;\n        left: 28px;\n        top: 8px;\n        z-index: 1;\n        -webkit-transform: rotate(-45deg);\n                transform: rotate(-45deg); }\n      .sweet-alert .icon.success .line {\n        height: 5px;\n        background-color: $color-green;\n        display: block;\n        border-radius: 2px;\n        position: absolute;\n        z-index: 2; }\n        .sweet-alert .icon.success .line.tip {\n          width: 25px;\n          left: 14px;\n          top: 46px;\n          -webkit-transform: rotate(45deg);\n                  transform: rotate(45deg); }\n        .sweet-alert .icon.success .line.long {\n          width: 47px;\n          right: 8px;\n          top: 38px;\n          -webkit-transform: rotate(-45deg);\n                  transform: rotate(-45deg); }\n  .sweet-alert .sweet-image {\n    margin: 20px auto; }\n\n@-webkit-keyframes showSweetAlert {\n  0% {\n    -webkit-transform: scale(0.7);\n            transform: scale(0.7); }\n  45% {\n    -webkit-transform: scale(1.05);\n            transform: scale(1.05); }\n  80% {\n    -webkit-transform: scale(0.95);\n            transform: scale(0.95); }\n  100% {\n    -webkit-transform: scale(1);\n            transform: scale(1); } }\n\n@keyframes showSweetAlert {\n  0% {\n    -webkit-transform: scale(0.7);\n            transform: scale(0.7); }\n  45% {\n    -webkit-transform: scale(1.05);\n            transform: scale(1.05); }\n  80% {\n    -webkit-transform: scale(0.95);\n            transform: scale(0.95); }\n  100% {\n    -webkit-transform: scale(1);\n            transform: scale(1); } }\n\n@-webkit-keyframes hideSweetAlert {\n  0% {\n    -webkit-transform: scale(1);\n            transform: scale(1); }\n  100% {\n    -webkit-transform: scale(0.5);\n            transform: scale(0.5); } }\n\n@keyframes hideSweetAlert {\n  0% {\n    -webkit-transform: scale(1);\n            transform: scale(1); }\n  100% {\n    -webkit-transform: scale(0.5);\n            transform: scale(0.5); } }\n\n.show-sweet-alert {\n  -webkit-animation: showSweetAlert 0.3s;\n          animation: showSweetAlert 0.3s; }\n  .show-sweet-alert.no-animation {\n    -webkit-animation: none;\n            animation: none; }\n\n.hide-sweet-alert {\n  -webkit-animation: hideSweetAlert 0.2s;\n          animation: hideSweetAlert 0.2s; }\n  .hide-sweet-alert.no-animation {\n    -webkit-animation: none;\n            animation: none; }\n\n@-webkit-keyframes animate-success-tip {\n  0% {\n    width: 0;\n    left: 1px;\n    top: 19px; }\n  54% {\n    width: 0;\n    left: 1px;\n    top: 19px; }\n  70% {\n    width: 50px;\n    left: -8px;\n    top: 37px; }\n  84% {\n    width: 17px;\n    left: 21px;\n    top: 48px; }\n  100% {\n    width: 25px;\n    left: 14px;\n    top: 45px; } }\n\n@keyframes animate-success-tip {\n  0% {\n    width: 0;\n    left: 1px;\n    top: 19px; }\n  54% {\n    width: 0;\n    left: 1px;\n    top: 19px; }\n  70% {\n    width: 50px;\n    left: -8px;\n    top: 37px; }\n  84% {\n    width: 17px;\n    left: 21px;\n    top: 48px; }\n  100% {\n    width: 25px;\n    left: 14px;\n    top: 45px; } }\n\n@-webkit-keyframes animate-success-long {\n  0% {\n    width: 0;\n    right: 46px;\n    top: 54px; }\n  65% {\n    width: 0;\n    right: 46px;\n    top: 54px; }\n  84% {\n    width: 55px;\n    right: 0;\n    top: 35px; }\n  100% {\n    width: 47px;\n    right: 8px;\n    top: 38px; } }\n\n@keyframes animate-success-long {\n  0% {\n    width: 0;\n    right: 46px;\n    top: 54px; }\n  65% {\n    width: 0;\n    right: 46px;\n    top: 54px; }\n  84% {\n    width: 55px;\n    right: 0;\n    top: 35px; }\n  100% {\n    width: 47px;\n    right: 8px;\n    top: 38px; } }\n\n@-webkit-keyframes rotatePlaceholder {\n  0% {\n    -webkit-transform: rotate(-45deg);\n            transform: rotate(-45deg); }\n  5% {\n    -webkit-transform: rotate(-45deg);\n            transform: rotate(-45deg); }\n  12% {\n    -webkit-transform: rotate(-405deg);\n            transform: rotate(-405deg); }\n  100% {\n    -webkit-transform: rotate(-405deg);\n            transform: rotate(-405deg); } }\n\n@keyframes rotatePlaceholder {\n  0% {\n    -webkit-transform: rotate(-45deg);\n            transform: rotate(-45deg); }\n  5% {\n    -webkit-transform: rotate(-45deg);\n            transform: rotate(-45deg); }\n  12% {\n    -webkit-transform: rotate(-405deg);\n            transform: rotate(-405deg); }\n  100% {\n    -webkit-transform: rotate(-405deg);\n            transform: rotate(-405deg); } }\n\n.animate-success-tip {\n  -webkit-animation: animate-success-tip 0.75s;\n          animation: animate-success-tip 0.75s; }\n\n.animate-success-long {\n  -webkit-animation: animate-success-long 0.75s;\n          animation: animate-success-long 0.75s; }\n\n.icon.success.animate::after {\n  -webkit-animation: rotatePlaceholder 4.25s ease-in;\n          animation: rotatePlaceholder 4.25s ease-in; }\n\n@-webkit-keyframes animate-error-icon {\n  0% {\n    -webkit-transform: rotateX(100deg);\n            transform: rotateX(100deg);\n    opacity: 0; }\n  100% {\n    -webkit-transform: rotateX(0deg);\n            transform: rotateX(0deg);\n    opacity: 1; } }\n\n@keyframes animate-error-icon {\n  0% {\n    -webkit-transform: rotateX(100deg);\n            transform: rotateX(100deg);\n    opacity: 0; }\n  100% {\n    -webkit-transform: rotateX(0deg);\n            transform: rotateX(0deg);\n    opacity: 1; } }\n\n.animate-error-icon {\n  -webkit-animation: animate-error-icon 0.5s;\n          animation: animate-error-icon 0.5s; }\n\n@-webkit-keyframes animate-x-mark {\n  0% {\n    -webkit-transform: scale(0.4);\n            transform: scale(0.4);\n    margin-top: 26px;\n    opacity: 0; }\n  50% {\n    -webkit-transform: scale(0.4);\n            transform: scale(0.4);\n    margin-top: 26px;\n    opacity: 0; }\n  80% {\n    -webkit-transform: scale(1.15);\n            transform: scale(1.15);\n    margin-top: -6px; }\n  100% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n    margin-top: 0;\n    opacity: 1; } }\n\n@keyframes animate-x-mark {\n  0% {\n    -webkit-transform: scale(0.4);\n            transform: scale(0.4);\n    margin-top: 26px;\n    opacity: 0; }\n  50% {\n    -webkit-transform: scale(0.4);\n            transform: scale(0.4);\n    margin-top: 26px;\n    opacity: 0; }\n  80% {\n    -webkit-transform: scale(1.15);\n            transform: scale(1.15);\n    margin-top: -6px; }\n  100% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n    margin-top: 0;\n    opacity: 1; } }\n\n.animate-x-mark {\n  -webkit-animation: animate-x-mark 0.5s;\n          animation: animate-x-mark 0.5s; }\n\n@-webkit-keyframes pulse-warning {\n  0% {\n    border-color: #f8d486; }\n  100% {\n    border-color: #f8bb86; } }\n\n@keyframes pulse-warning {\n  0% {\n    border-color: #f8d486; }\n  100% {\n    border-color: #f8bb86; } }\n\n.pulse-warning {\n  -webkit-animation: pulse-warning 0.75s infinite alternate;\n          animation: pulse-warning 0.75s infinite alternate; }\n\n@-webkit-keyframes pulse-warning-ins {\n  0% {\n    background-color: #f8d486; }\n  100% {\n    background-color: #f8bb86; } }\n\n@keyframes pulse-warning-ins {\n  0% {\n    background-color: #f8d486; }\n  100% {\n    background-color: #f8bb86; } }\n\n.pulse-warning-ins {\n  -webkit-animation: pulse-warning-ins 0.75s infinite alternate;\n          animation: pulse-warning-ins 0.75s infinite alternate; }\n\n@-webkit-keyframes rotate-loading {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg); }\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg); } }\n\n@keyframes rotate-loading {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg); }\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg); } }\n","svg {\n    touch-action: none;\n}\n\n.jvectormap-container {\n    width: 100%;\n    height: 100%;\n    position: relative;\n    overflow: hidden;\n    touch-action: none;\n}\n\n.jvectormap-tip {\n    position: absolute;\n    display: none;\n    border: solid 1px #CDCDCD;\n    border-radius: 3px;\n    background: #292929;\n    color: white;\n    font-family: sans-serif, Verdana;\n    font-size: smaller;\n    padding: 3px;\n}\n\n.jvectormap-zoomin, .jvectormap-zoomout, .jvectormap-goback {\n    position: absolute;\n    left: 10px;\n    border-radius: 3px;\n    background: #292929;\n    padding: 3px;\n    color: white;\n    cursor: pointer;\n    line-height: 10px;\n    text-align: center;\n    box-sizing: content-box;\n}\n\n.jvectormap-zoomin, .jvectormap-zoomout {\n    width: 10px;\n    height: 10px;\n}\n\n.jvectormap-zoomin {\n    top: 10px;\n}\n\n.jvectormap-zoomout {\n    top: 30px;\n}\n\n.jvectormap-goback {\n    bottom: 10px;\n    z-index: 1000;\n    padding: 6px;\n}\n\n.jvectormap-spinner {\n    position: absolute;\n    left: 0;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    background: center no-repeat url(data:image/gif;base64,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);\n}\n\n.jvectormap-legend-title {\n    font-weight: bold;\n    font-size: 14px;\n    text-align: center;\n}\n\n.jvectormap-legend-cnt {\n    position: absolute;\n}\n\n.jvectormap-legend-cnt-h {\n    bottom: 0;\n    right: 0;\n}\n\n.jvectormap-legend-cnt-v {\n    top: 0;\n    right: 0;\n}\n\n.jvectormap-legend {\n    background: black;\n    color: white;\n    border-radius: 3px;\n}\n\n.jvectormap-legend-cnt-h .jvectormap-legend {\n    float: left;\n    margin: 0 10px 10px 0;\n    padding: 3px 3px 1px 3px;\n}\n\n.jvectormap-legend-cnt-h .jvectormap-legend .jvectormap-legend-tick {\n    float: left;\n}\n\n.jvectormap-legend-cnt-v .jvectormap-legend {\n    margin: 10px 10px 0 0;\n    padding: 3px;\n}\n\n.jvectormap-legend-cnt-h .jvectormap-legend-tick {\n    width: 40px;\n}\n\n.jvectormap-legend-cnt-h .jvectormap-legend-tick-sample {\n    height: 15px;\n}\n\n.jvectormap-legend-cnt-v .jvectormap-legend-tick-sample {\n    height: 20px;\n    width: 20px;\n    display: inline-block;\n    vertical-align: middle;\n}\n\n.jvectormap-legend-tick-text {\n    font-size: 12px;\n}\n\n.jvectormap-legend-cnt-h .jvectormap-legend-tick-text {\n    text-align: center;\n}\n\n.jvectormap-legend-cnt-v .jvectormap-legend-tick-text {\n    display: inline-block;\n    vertical-align: middle;\n    line-height: 20px;\n    padding-left: 3px;\n}","/**\n * @author zhixin wen <wenzhixin2010@gmail.com>\n * version: 1.8.1\n * https://github.com/wenzhixin/bootstrap-table/\n */\n\n.bootstrap-table .table {\n    margin-bottom: 0 !important;\n    border-bottom: 1px solid #dddddd;\n    border-collapse: collapse !important;\n    border-radius: 1px;\n}\n\n.bootstrap-table .table,\n.bootstrap-table .table > tbody > tr > th,\n.bootstrap-table .table > tfoot > tr > th,\n.bootstrap-table .table > thead > tr > td,\n.bootstrap-table .table > tbody > tr > td,\n.bootstrap-table .table > tfoot > tr > td {\n    padding: 8px !important;\n}\n\n.bootstrap-table .table > tbody > .selected{\n    background-color: $light-blue;\n}\n.bootstrap-table .table.table-no-bordered > thead > tr > th,\n.bootstrap-table .table.table-no-bordered > tbody > tr > td {\n    border-right: 2px solid transparent;\n}\n\n.fixed-table-container {\n    position: relative;\n    clear: both;\n}\n\n.fixed-table-container.table-no-bordered {\n    border: 1px solid transparent;\n}\n\n.fixed-table-footer,\n.fixed-table-header {\n    overflow: hidden;\n}\n\n.fixed-table-footer {\n    border-top: 1px solid #dddddd;\n}\n\n.fixed-table-body {\n    height: 100%;\n    overflow: auto;\n}\n\n.fixed-table-container table {\n    width: 100%;\n}\n\n.fixed-table-container thead th {\n    height: 0;\n    padding: 0;\n    margin: 0;\n}\n\n.fixed-table-container thead th:first-child {\n    border-left: none;\n}\n\n.fixed-table-container thead th .th-inner {\n    padding: 0 8px;\n    line-height: 24px;\n    vertical-align: top;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n.fixed-table-container thead th .sortable {\n    cursor: pointer;\n    background-repeat: no-repeat;\n    padding-right: 30px;\n}\n\n.fixed-table-container thead th .both {\n    background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAATCAQAAADYWf5HAAAAkElEQVQoz7X QMQ5AQBCF4dWQSJxC5wwax1Cq1e7BAdxD5SL+Tq/QCM1oNiJidwox0355mXnG/DrEtIQ6azioNZQxI0ykPhTQIwhCR+BmBYtlK7kLJYwWCcJA9M4qdrZrd8pPjZWPtOqdRQy320YSV17OatFC4euts6z39GYMKRPCTKY9UnPQ6P+GtMRfGtPnBCiqhAeJPmkqAAAAAElFTkSuQmCC');\n    background-position: right 2px;\n}\n\n.fixed-table-container thead th .asc {\n    background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAATCAYAAAByUDbMAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAIGNIUk0AAG2YAABzjgAA+swAAIT6AAB5gQAA/RMAADBtAAASKQ0eJk4AAACASURBVHja7NKhDcJQFIbRV1MSEqaoYwYMYyARR6HZowzAHqguUolHYEgxD9MmTYPpA1JEb/KZK476Q4wxfKvwc6x/WKJE3v+nYkc8cfgIwxpXRNQokjBkOLdQ1wlZCrbFbYDdsRmFYYVqAHVdsBiD7dHg8aYGu2l2NmMz9s/YawDpU8qkYQTHqgAAAABJRU5ErkJggg==');\n    background-position: right 5px;\n}\n\n.fixed-table-container thead th .desc {\n    background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAATCAYAAAByUDbMAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAIGNIUk0AAG2YAABzjgAA+swAAIT6AAB5gQAA/RMAADBtAAASKQ0eJk4AAACFSURBVHja7NKhDcJQFIbRWwMJCVPgmKGGMZCIo9DsAQOwRxWLIPEIDCnmYR4JaSp4DYKQis/8NznqRkopvlWM2Ij9BYY1Wtx7arEpwaZokHo6Yf4xFhGBGrcOdMUqIqIUq3DoYEdUxVgGFzhn6ILl61aMZXCLB3bv+1Bsgj1mg7CfeNrnAMXSyqQtsCNeAAAAAElFTkSuQmCC');\n    background-position: right 0px;\n}\n\n\n.fixed-table-container th.detail {\n    width: 30px;\n}\n\n.fixed-table-container tbody tr:first-child td {\n    border-top: none;\n}\n\n.fixed-table-container tbody td:first-child {\n    border-left: none;\n}\n\n/* the same color with .active */\n.fixed-table-container tbody .selected td {\n    background-color: rgba(245, 245, 245, 0.34);\n}\n\n.fixed-table-container .bs-checkbox {\n    text-align: center;\n}\n\n.fixed-table-container .bs-checkbox .th-inner {\n    padding: 8px 0;\n}\n\n.fixed-table-container input[type=\"radio\"],\n.fixed-table-container input[type=\"checkbox\"] {\n    margin: 0 auto !important;\n    cursor: pointer;\n}\n\n.fixed-table-container .no-records-found {\n    text-align: center;\n    background-color: #FFFFFF !important;\n    height: 340px;\n    border-radius: 10px;\n    width: 100%;\n    vertical-align: middle;\n}\n.fixed-table-container .no-records-found td{\n    font-weight: $font-weight-light;\n    font-size: $font-size-h4;\n}\n.fixed-table-pagination div.pagination,\n.fixed-table-pagination .pagination-detail {\n    margin-top: 10px;\n    margin-bottom: 10px;\n}\n\n.fixed-table-pagination div.pagination .pagination {\n    margin: 0;\n}\n\n.fixed-table-pagination .pagination a {\n    padding: 6px 12px;\n    line-height: 1.428571429;\n}\n\n.fixed-table-pagination .pagination-info {\n    line-height: 34px;\n    margin-right: 5px;\n}\n\n.fixed-table-pagination .btn-group {\n    position: relative;\n    display: inline-block;\n    vertical-align: middle;\n}\n\n.fixed-table-pagination .page-list {\n    display: inline-block;\n}\n\n.fixed-table-toolbar{\n    padding: 5px 15px;\n}\n\n.fixed-table-toolbar .columns-left {\n    margin-right: 5px;\n}\n\n.fixed-table-toolbar .columns-right {\n    margin-left: 5px;\n}\n\n.fixed-table-toolbar .columns .btn{\n    margin: 0 2px;\n    border-radius: $btn-round-radius;\n}\n.fixed-table-toolbar .columns label {\n    display: block;\n    padding: 10px 20px;\n    border-bottom: 1px solid #eee;\n    clear: both;\n    margin-bottom: 0;\n    font-weight: normal;\n    line-height: 1.428571429;\n}\n.fixed-table-toolbar .columns li:last-child label{\n    border-bottom: none;\n}\n\n.fixed-table-toolbar .bars,\n.fixed-table-toolbar .search,\n.fixed-table-toolbar .columns {\n    position: relative;\n    margin-top: 10px;\n    margin-bottom: 10px;\n    line-height: 34px;\n}\n\n.fixed-table-pagination li.disabled a {\n    pointer-events: none;\n    cursor: default;\n}\n\n.fixed-table-loading {\n    display: none;\n    position: absolute;\n    top: 42px;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    z-index: 99;\n    background-color: #fff;\n    text-align: center;\n}\n\n.fixed-table-body .card-view .title {\n    font-weight: bold;\n    display: inline-block;\n    min-width: 30%;\n    text-align: left !important;\n}\n\n/* support bootstrap 2 */\n.fixed-table-body thead th .th-inner {\n    box-sizing: border-box;\n}\n\n.table th, .table td {\n    vertical-align: middle;\n    box-sizing: border-box;\n}\n\n.fixed-table-toolbar .btn-group > .btn-group {\n    display: inline-block;\n    margin-left: -1px !important;\n}\n\n.fixed-table-toolbar .dropdown-menu label{\n    cursor: pointer;\n}\n\n.fixed-table-toolbar .btn-group > .btn-group > .btn {\n    border-radius: 0;\n}\n\n.fixed-table-toolbar .btn-group > .btn-group:first-child > .btn {\n    border-top-left-radius: 4px;\n    border-bottom-left-radius: 4px;\n}\n\n.fixed-table-toolbar .btn-group > .btn-group:last-child > .btn {\n    border-top-right-radius: 4px;\n    border-bottom-right-radius: 4px;\n}\n\n/* support bootstrap 3 */\n.bootstrap-table .table thead > tr > th {\n    padding: 0;\n    margin: 0;\n}\n\n.pull-right .dropdown-menu {\n    right: 0;\n    left: auto;\n}\n\n/* calculate scrollbar width */\np.fixed-table-scroll-inner {\n    width: 100%;\n    height: 200px;\n}\n\ndiv.fixed-table-scroll-outer {\n    top: 0;\n    left: 0;\n    visibility: hidden;\n    width: 200px;\n    height: 150px;\n    overflow: hidden;\n}\n\n\n.bootstrap-table{\n    .fixed-table-pagination{\n        margin: 0 10px;\n\n        &:after{\n            display: table;\n            content: \"\";\n            clear: both;\n        }\n\n        .page-list{\n            .btn{\n                border-radius: $btn-round-radius;\n            }\n            .btn-group{\n                margin-right: 5px;\n            }\n        }\n        div.pagination,\n        .pagination-detail{\n            margin-top: 15px;\n            margin-bottom: 15px;\n        }\n    }\n\n    .table{\n        &.table-striped > thead > tr > td,\n        &.table-striped > tbody > tr >td,\n        &.table-striped > tfoot > tr >td{\n            border: none;\n        }\n\n    }\n\n}\n","table.dataTable {\n  clear: both;\n  margin-top: 6px !important;\n  margin-bottom: 6px !important;\n  max-width: none !important;\n  border-collapse: separate !important;\n}\ntable.dataTable td,\ntable.dataTable th {\n  -webkit-box-sizing: content-box;\n  -moz-box-sizing: content-box;\n  box-sizing: content-box;\n}\ntable.dataTable td.dataTables_empty,\ntable.dataTable th.dataTables_empty {\n  text-align: center;\n}\ntable.dataTable.nowrap th,\ntable.dataTable.nowrap td {\n  white-space: nowrap;\n}\n\ndiv.dataTables_wrapper div.dataTables_length label {\n  font-weight: normal;\n  text-align: left;\n  white-space: nowrap;\n}\ndiv.dataTables_wrapper div.dataTables_length select {\n  width: 75px;\n  display: inline-block;\n}\ndiv.dataTables_wrapper div.dataTables_filter {\n  text-align: right;\n}\ndiv.dataTables_wrapper div.dataTables_filter label {\n  font-weight: normal;\n  white-space: nowrap;\n  text-align: left;\n}\ndiv.dataTables_wrapper div.dataTables_filter input {\n  margin-left: 0.5em;\n  display: inline-block;\n  width: auto;\n}\ndiv.dataTables_wrapper div.dataTables_info {\n  padding-top: 8px;\n  white-space: nowrap;\n}\ndiv.dataTables_wrapper div.dataTables_paginate {\n  margin: 0;\n  white-space: nowrap;\n  text-align: right;\n}\ndiv.dataTables_wrapper div.dataTables_paginate ul.pagination {\n  margin: 2px 0;\n  white-space: nowrap;\n}\ndiv.dataTables_wrapper div.dataTables_processing {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  width: 200px;\n  margin-left: -100px;\n  margin-top: -26px;\n  text-align: center;\n  padding: 1em 0;\n}\n\ntable.dataTable thead > tr > th.sorting_asc, table.dataTable thead > tr > th.sorting_desc, table.dataTable thead > tr > th.sorting,\ntable.dataTable thead > tr > td.sorting_asc,\ntable.dataTable thead > tr > td.sorting_desc,\ntable.dataTable thead > tr > td.sorting {\n  padding-right: 30px;\n}\ntable.dataTable thead > tr > th:active,\ntable.dataTable thead > tr > td:active {\n  outline: none;\n}\ntable.dataTable thead .sorting,\ntable.dataTable thead .sorting_asc,\ntable.dataTable thead .sorting_desc,\ntable.dataTable thead .sorting_asc_disabled,\ntable.dataTable thead .sorting_desc_disabled {\n  cursor: pointer;\n  position: relative;\n}\ntable.dataTable thead .sorting:after,\ntable.dataTable thead .sorting_asc:after,\ntable.dataTable thead .sorting_desc:after,\ntable.dataTable thead .sorting_asc_disabled:after,\ntable.dataTable thead .sorting_desc_disabled:after {\n  position: absolute;\n  bottom: 8px;\n  right: 8px;\n  display: block;\n  font-family: 'Glyphicons Halflings';\n  opacity: 0.5;\n}\ntable.dataTable thead .sorting:after {\n  opacity: 0.2;\n  content: \"\\e150\";\n  /* sort */\n}\ntable.dataTable thead .sorting_asc:after {\n  content: \"\\e155\";\n  /* sort-by-attributes */\n}\ntable.dataTable thead .sorting_desc:after {\n  content: \"\\e156\";\n  /* sort-by-attributes-alt */\n}\ntable.dataTable thead .sorting_asc_disabled:after,\ntable.dataTable thead .sorting_desc_disabled:after {\n  color: #eee;\n}\n\ndiv.dataTables_scrollHead table.dataTable {\n  margin-bottom: 0 !important;\n}\n\ndiv.dataTables_scrollBody table {\n  border-top: none;\n  margin-top: 0 !important;\n  margin-bottom: 0 !important;\n}\ndiv.dataTables_scrollBody table thead .sorting:after,\ndiv.dataTables_scrollBody table thead .sorting_asc:after,\ndiv.dataTables_scrollBody table thead .sorting_desc:after {\n  display: none;\n}\ndiv.dataTables_scrollBody table tbody tr:first-child th,\ndiv.dataTables_scrollBody table tbody tr:first-child td {\n  border-top: none;\n}\n\ndiv.dataTables_scrollFoot table {\n  margin-top: 0 !important;\n  border-top: none;\n}\n\n@media screen and (max-width: 767px) {\n  div.dataTables_wrapper div.dataTables_length,\n  div.dataTables_wrapper div.dataTables_filter,\n  div.dataTables_wrapper div.dataTables_info,\n  div.dataTables_wrapper div.dataTables_paginate {\n    text-align: center;\n  }\n}\ntable.dataTable.table-condensed > thead > tr > th {\n  padding-right: 20px;\n}\ntable.dataTable.table-condensed .sorting:after,\ntable.dataTable.table-condensed .sorting_asc:after,\ntable.dataTable.table-condensed .sorting_desc:after {\n  top: 6px;\n  right: 6px;\n}\n\ntable.table-bordered.dataTable th,\ntable.table-bordered.dataTable td {\n  border-left-width: 0;\n}\ntable.table-bordered.dataTable th:last-child, table.table-bordered.dataTable th:last-child,\ntable.table-bordered.dataTable td:last-child,\ntable.table-bordered.dataTable td:last-child {\n  border-right-width: 0;\n}\ntable.table-bordered.dataTable tbody th,\ntable.table-bordered.dataTable tbody td {\n  border-bottom-width: 0;\n}\n\ndiv.dataTables_scrollHead table.table-bordered {\n  border-bottom-width: 0;\n}\n\ndiv.table-responsive > div.dataTables_wrapper > div.row {\n  margin: 0;\n}\ndiv.table-responsive > div.dataTables_wrapper > div.row > div[class^=\"col-\"]:first-child {\n  padding-left: 0;\n}\ndiv.table-responsive > div.dataTables_wrapper > div.row > div[class^=\"col-\"]:last-child {\n  padding-right: 0;\n}\n\n\ntable.dataTable{\n\n    .btn-simple.btn-icon{\n        padding: 3px;\n    }\n\n    thead{\n        .sorting,\n        .sorting_asc,\n        .sorting_desc,\n        .sorting_asc_disabled,\n        .sorting_desc_disabled{\n\n            &:after{\n                position: relative;\n                display: inline-block;\n                bottom: 0px;\n                right: -7px;\n                font-family: 'FontAwesome';\n                opacity: 0.8;\n            }\n\n        }\n\n        .disabled-sorting.sorting,\n        .disabled-sorting.sorting_asc,\n        .disabled-sorting.sorting_desc,\n        .disabled-sorting.sorting_asc_disabled,\n        .disabled-sorting.sorting_desc_disabled{\n                &:after{\n                    display: none;\n                }\n\n        }\n\n        .sorting{\n            &:after{\n                opacity: 0.4;\n                content: \"\\f0dc\";\n            }\n        }\n\n        .sorting_asc{\n            &:after{\n                content: \"\\f0de\";\n                top: 3px;\n            }\n        }\n\n        .sorting_desc{\n            &:after{\n                content: \"\\f0dd\";\n                top: -3px;\n            }\n        }\n    }\n\n    > thead > tr > th,\n    > tbody > tr > th,\n    > tfoot > tr > th,\n    > thead > tr > td,\n    > tbody > tr > td,\n    > tfoot > tr > td{\n        padding: 8px !important;\n        outline: 0;\n    }\n\n    > thead > tr > th{\n        border: none;\n    }\n}\n\n.fresh-datatables{\n    .pagination {\n        > li > a,\n        > li:first-child > a,\n        > li:first-child > span,\n        > li:last-child > a,\n        > li:last-child > span{\n            border-radius: 25px;\n        }\n    }\n}\n\n\n\n.dataTables_paginate{\n    a{\n            outline: 0;\n    }\n}\n\ntable.dataTable.dtr-inline.collapsed {\n    > tbody > tr > td.child,\n    > tbody > tr > th.child,\n    > tbody > tr > td.dataTables_empty{\n        cursor: default !important;\n    }\n\n    > tbody > tr > td.child,\n    > tbody > tr > th.child,\n    > tbody > tr > td.dataTables_empty{\n        &:before{\n            display: none !important;\n        }\n    }\n\n    > tbody > tr > td:first-child,\n    > tbody > tr > th:first-child{\n        position: relative;\n        padding-left: 30px !important;\n        cursor: pointer;\n    }\n\n    > tbody > tr > td:first-child,\n    > tbody > tr > th:first-child{\n        &:before{\n            top: 50%;\n            margin-top: -9px;\n            left: 4px;\n            height: 18px;\n            width: 18px;\n            display: block;\n            position: absolute;\n            color: #518607;\n            border: 0px solid white;\n            border-radius: 14px;\n            box-shadow: 0 0 3px #444;\n            box-sizing: content-box;\n            text-align: center;\n            font-family: 'Courier New', Courier, monospace;\n            line-height: 18px;\n            content: '+';\n            background-color: #FFF;\n        }\n    }\n\n    > tbody > tr.parent > td:first-child,\n    > tbody > tr.parent > th:first-child{\n        &:before{\n            content: '-';\n            color: #ED362C;\n        }\n    }\n\n    > tbody > tr.child td{\n        &:before{\n            display: none;\n        }\n    }\n}\n\n\ntable.dataTable.dtr-inline.collapsed.compact{\n    > tbody > tr > td,\n    > tbody > tr > th{\n        &:first-child{\n            padding-left: 27px;\n        }\n    }\n\n    > tbody > tr > td,\n    > tbody > tr > th{\n        &:first-child:before{\n            top: 5px;\n            left: 4px;\n            height: 14px;\n            width: 14px;\n            border-radius: 14px;\n            line-height: 14px;\n            text-indent: 3px;\n        }\n    }\n}\n\ntable.dataTable.dtr-column{\n    > tbody > tr > td.control,\n    > tbody > tr > th.control{\n        position: relative;\n        cursor: pointer;\n    }\n\n    > tbody > tr > td.control,\n    > tbody > tr > th.control{\n        &:before{\n            top: 50%;\n            left: 50%;\n            height: 16px;\n            width: 16px;\n            margin-top: -10px;\n            margin-left: -10px;\n            display: block;\n            position: absolute;\n            color: white;\n            border: 2px solid white;\n            border-radius: 14px;\n            box-shadow: 0 0 3px #444;\n            box-sizing: content-box;\n            text-align: center;\n            font-family: 'Courier New', Courier, monospace;\n            line-height: 14px;\n            content: '+';\n            background-color: #31b131;\n        }\n    }\n\n    > tbody > tr.parent td.control,\n    > tbody > tr.parent th.control{\n        &:before{\n            content: '-';\n            background-color: #d33333;\n        }\n    }\n}\n\ntable.dataTable{\n    > tbody > tr.child {\n        padding: 0.5em 1em;\n    }\n\n    > tbody > tr.child{\n        &:hover{\n            background: transparent !important;\n        }\n    }\n\n    > tbody > tr.child ul {\n        display: inline-block;\n        list-style-type: none;\n        margin: 0;\n        padding: 0;\n    }\n\n    > tbody > tr.child ul li {\n        border-bottom: 1px solid #efefef;\n        padding: 0.5em 0;\n    }\n\n    > tbody > tr.child ul li{\n        &:first-child{\n            padding-top: 0;\n        }\n    }\n\n    > tbody > tr.child ul li{\n        &:last-child{\n            border-bottom: none;\n        }\n    }\n\n    > tbody > tr.child span.dtr-title {\n        display: inline-block;\n        min-width: 75px;\n        font-weight: bold;\n    }\n}\n\ndiv.dtr-modal {\n    position: fixed;\n    box-sizing: border-box;\n    top: 0;\n    left: 0;\n    height: 100%;\n    width: 100%;\n    z-index: 100;\n    padding: 10em 1em;\n\n    div.dtr-modal-display {\n        position: absolute;\n        top: 0;\n        left: 0;\n        bottom: 0;\n        right: 0;\n        width: 50%;\n        height: 50%;\n        overflow: auto;\n        margin: auto;\n        z-index: 102;\n        overflow: auto;\n        background-color: #f5f5f7;\n        border: 1px solid black;\n        border-radius: 0.5em;\n        box-shadow: 0 12px 30px rgba(0, 0, 0, 0.6);\n    }\n\n    div.dtr-modal-content {\n        position: relative;\n        padding: 1em;\n    }\n\n    div.dtr-modal-close {\n        position: absolute;\n        top: 6px;\n        right: 6px;\n        width: 22px;\n        height: 22px;\n        border: 1px solid #eaeaea;\n        background-color: #f9f9f9;\n        text-align: center;\n        border-radius: 3px;\n        cursor: pointer;\n        z-index: 12;\n    }\n\n    div.dtr-modal-close{\n        &:hover{\n            background-color: #eaeaea;\n        }\n    }\n\n    div.dtr-modal-background {\n        position: fixed;\n        top: 0;\n        left: 0;\n        right: 0;\n        bottom: 0;\n        z-index: 101;\n        background: rgba(0, 0, 0, 0.6);\n    }\n}\n\n.data-tables{\n    .pagination{\n        .paginate_button.page-item{\n            &.first,\n            &.previous,\n            &.next,\n            &.last{\n                .page-link{\n                    border-radius: 25px;\n                }\n            }\n        }\n    }\n}\n\n@media screen and (max-width: 767px) {\n    div.dtr-modal div.dtr-modal-display {\n        width: 95%;\n    }\n\n    .data-tables{\n        .pagination{\n            .paginate_button.page-item{\n                &.first,\n                &.last{\n                    display: none;\n                }\n            }\n        }\n    }\n}\n","/*!\n * FullCalendar v3.6.2 Stylesheet\n * Docs & License: https://fullcalendar.io/\n * (c) 2017 Adam Shaw\n */\n\n.fc {\n\tdirection: ltr;\n\ttext-align: left;\n}\n\n.fc-rtl {\n\ttext-align: right;\n}\n\nbody .fc { /* extra precedence to overcome jqui */\n\tfont-size: 1em;\n}\n\n\n/* Colors\n--------------------------------------------------------------------------------------------------*/\n\n.fc-unthemed th,\n.fc-unthemed td,\n.fc-unthemed thead,\n.fc-unthemed tbody,\n.fc-unthemed .fc-divider,\n.fc-unthemed .fc-row,\n.fc-unthemed .fc-popover {\n\tborder-color: #ddd;\n}\n\n.fc-unthemed .fc-popover {\n\tbackground-color: #fff;\n}\n\n.fc-unthemed .fc-divider,\n.fc-unthemed .fc-popover .fc-header {\n\tbackground: #eee;\n}\n\n.fc-unthemed .fc-popover .fc-header .fc-close {\n\tcolor: #666;\n}\n\n.fc-unthemed .fc-today {\n\tbackground: $smoke-bg;\n}\n\n.fc-highlight { /* when user is selecting cells */\n\tbackground: #bce8f1;\n\topacity: .3;\n\tfilter: alpha(opacity=30); /* for IE */\n}\n\n.fc-bgevent { /* default look for background events */\n\tbackground: rgb(143, 223, 130);\n\topacity: .3;\n\tfilter: alpha(opacity=30); /* for IE */\n}\n\n.fc-nonbusiness { /* default look for non-business-hours areas */\n\t/* will inherit .fc-bgevent's styles */\n\tbackground: #d7d7d7;\n}\n\n\n/* Icons (inline elements with styled text that mock arrow icons)\n--------------------------------------------------------------------------------------------------*/\n\n.fc-icon {\n\tdisplay: inline-block;\n\twidth: 1em;\n\theight: 1em;\n\tline-height: 1em;\n\tfont-size: 1em;\n\ttext-align: center;\n\toverflow: hidden;\n\tfont-family: \"Courier New\", Courier, monospace;\n\n\t/* don't allow browser text-selection */\n\t-webkit-touch-callout: none;\n\t-webkit-user-select: none;\n\t-khtml-user-select: none;\n\t-moz-user-select: none;\n\t-ms-user-select: none;\n\tuser-select: none;\n\t}\n\n/*\nAcceptable font-family overrides for individual icons:\n\t\"Arial\", sans-serif\n\t\"Times New Roman\", serif\n\nNOTE: use percentage font sizes or else old IE chokes\n*/\n\n.fc-icon:after {\n\tposition: relative;\n\tmargin: 0 -1em; /* ensures character will be centered, regardless of width */\n}\n\n.fc-icon-left-single-arrow:after {\n\tcontent: \"\\02039\";\n\tfont-weight: bold;\n\tfont-size: 200%;\n\ttop: -7%;\n\tleft: 3%;\n}\n\n.fc-icon-right-single-arrow:after {\n\tcontent: \"\\0203A\";\n\tfont-weight: bold;\n\tfont-size: 200%;\n\ttop: -7%;\n\tleft: -3%;\n}\n\n.fc-icon-left-double-arrow:after {\n\tcontent: \"\\000AB\";\n\tfont-size: 160%;\n\ttop: -7%;\n}\n\n.fc-icon-right-double-arrow:after {\n\tcontent: \"\\000BB\";\n\tfont-size: 160%;\n\ttop: -7%;\n}\n\n.fc-icon-left-triangle:after {\n\tcontent: \"\\25C4\";\n\tfont-size: 125%;\n\ttop: 3%;\n\tleft: -2%;\n}\n\n.fc-icon-right-triangle:after {\n\tcontent: \"\\25BA\";\n\tfont-size: 125%;\n\ttop: 3%;\n\tleft: 2%;\n}\n\n.fc-icon-down-triangle:after {\n\tcontent: \"\\25BC\";\n\tfont-size: 125%;\n\ttop: 2%;\n}\n\n.fc-icon-x:after {\n\tcontent: \"\\000D7\";\n\tfont-size: 200%;\n\ttop: 6%;\n}\n\n\n/* Buttons (styled <button> tags, normalized to work cross-browser)\n--------------------------------------------------------------------------------------------------*/\n\n.fc button {\n\tborder-width: $border-thin;\n    background-color: $transparent-bg;\n    font-weight: $font-weight-normal;\n\n    @include opacity(.8);\n    padding: $padding-base-vertical $padding-base-horizontal;\n\n    border-color: $default-color;\n    color: $default-color;\n\n\n    &:hover,\n    &:focus{\n        @include opacity(1);\n        outline: 0 !important;\n    }\n    &:active,\n    &.active,\n    .open > &.dropdown-toggle {\n         @include box-shadow(none);\n         outline: 0 !important;\n    }\n\n}\n\n/* Firefox has an annoying inner border */\n.fc button::-moz-focus-inner { margin: 0; padding: 0; }\n\n.fc-state-default { /* non-theme */\n\tborder: 1px solid;\n}\n\n.fc-state-default.fc-corner-left { /* non-theme */\n\tborder-top-left-radius: 4px;\n\tborder-bottom-left-radius: 4px;\n}\n\n.fc-state-default.fc-corner-right { /* non-theme */\n\tborder-top-right-radius: 4px;\n\tborder-bottom-right-radius: 4px;\n}\n\n/* icons in buttons */\n\n.fc button .fc-icon { /* non-theme */\n\tposition: relative;\n\ttop: -0.05em; /* seems to be a good adjustment across browsers */\n\tmargin: 0 .2em;\n\tvertical-align: middle;\n}\n\n/*\n  button states\n  borrowed from twitter bootstrap (http://twitter.github.com/bootstrap/)\n*/\n\n.fc-state-hover,\n.fc-state-active,\n.fc-state-disabled {\n\tcolor: #333333;\n\tbackground-color: #e6e6e6;\n}\n\n.fc button[disabled],\n.fc button[disabled]:focus,\n.fc button[disabled]:hover{\n    background-color: $light-gray;\n    border-color: $light-gray;\n    cursor: default;\n\t@include opacity(.65);\n\tmargin-left: .75em;\n}\n\n.fc-state-hover {\n\tbackground-color: $smoke-bg;\n}\n\n.fc .fc-state-active,\n.fc .fc-state-active:focus,\n.fc .fc-state-active:hover,\n.fc .fc-state-active:active:focus,\n.fc .fc-state-active:active:hover,\n.fc .fc-state-active:active {\n\tbackground-color: $default-color;\n    color: #FFFFFF;\n}\n\n\n\n/* Buttons Groups\n--------------------------------------------------------------------------------------------------*/\n\n.fc-button-group {\n\tdisplay: inline-block;\n}\n\n/*\nevery button that is not first in a button group should scootch over one pixel and cover the\nprevious button's border...\n*/\n\n.fc .fc-button-group > * { /* extra precedence b/c buttons have margin set to zero */\n\tfloat: left;\n\tmargin: 0 0 0 5px;\n}\n\n.fc .fc-button-group > :first-child { /* same */\n\tmargin-left: 0;\n}\n\n\n/* Popover\n--------------------------------------------------------------------------------------------------*/\n\n.fc-popover {\n\tposition: absolute;\n\t@include box-shadow($dropdown-shadow);\n}\n\n.fc-popover .fc-header { /* TODO: be more consistent with fc-head/fc-body */\n\tpadding: 2px 4px;\n}\n\n.fc-popover .fc-header .fc-title {\n\tmargin: 0 2px;\n}\n\n.fc-popover .fc-header .fc-close {\n\tcursor: pointer;\n}\n\n.fc-ltr .fc-popover .fc-header .fc-title,\n.fc-rtl .fc-popover .fc-header .fc-close {\n\tfloat: left;\n}\n\n.fc-rtl .fc-popover .fc-header .fc-title,\n.fc-ltr .fc-popover .fc-header .fc-close {\n\tfloat: right;\n}\n\n/* unthemed */\n\n.fc-unthemed .fc-popover {\n\tborder-width: 1px;\n\tborder-style: solid;\n}\n\n.fc-unthemed .fc-popover .fc-header .fc-close {\n\tfont-size: .9em;\n\tmargin-top: 2px;\n}\n\n/* jqui themed */\n\n.fc-popover > .ui-widget-header + .ui-widget-content {\n\tborder-top: 0; /* where they meet, let the header have the border */\n}\n\n\n/* Misc Reusable Components\n--------------------------------------------------------------------------------------------------*/\n\n.fc-divider {\n\tborder-style: solid;\n\tborder-width: 1px;\n}\n\nhr.fc-divider {\n\theight: 0;\n\tmargin: 0;\n\tpadding: 0 0 2px; /* height is unreliable across browsers, so use padding */\n\tborder-width: 1px 0;\n}\n\n.fc-clear {\n\tclear: both;\n}\n\n.fc-bg,\n.fc-bgevent-skeleton,\n.fc-highlight-skeleton,\n.fc-helper-skeleton {\n\t/* these element should always cling to top-left/right corners */\n\tposition: absolute;\n\ttop: 0;\n\tleft: 0;\n\tright: 0;\n}\n\n.fc-bg {\n\tbottom: 0; /* strech bg to bottom edge */\n}\n\n.fc-bg table {\n\theight: 100%; /* strech bg to bottom edge */\n}\n\n\n/* Tables\n--------------------------------------------------------------------------------------------------*/\n\n.fc table {\n\twidth: 100%;\n\ttable-layout: fixed;\n\tborder-collapse: collapse;\n\tborder-spacing: 0;\n\tfont-size: 1em; /* normalize cross-browser */\n}\n\n.fc th {\n\ttext-align: right;\n    border-bottom-width: 1px;\n    font-size: $font-size-h6;\n    text-transform: uppercase;\n    color: $dark-gray;\n    font-weight: $font-weight-normal;\n    padding-bottom: 3px;\n}\n\n.fc td {\n\tborder-style: solid;\n\tborder-width: 1px;\n\tpadding: 0;\n\tvertical-align: top;\n}\n\n.fc td.fc-today {\n\tborder-style: double; /* overcome neighboring borders */\n}\n\n.fc .fc-widget-header{\n    border: 0;\n}\n\n.fc .fc-head .fc-widget-header{\n    margin-top: $margin-base-vertical;\n}\n/* Fake Table Rows\n--------------------------------------------------------------------------------------------------*/\n\n.fc .fc-row { /* extra precedence to overcome themes w/ .ui-widget-content forcing a 1px border */\n\t/* no visible border by default. but make available if need be (scrollbar width compensation) */\n\tborder-style: solid;\n\tborder-width: 0;\n}\n\n.fc-row table {\n\t/* don't put left/right border on anything within a fake row.\n\t   the outer tbody will worry about this */\n\tborder-left: 0 hidden transparent;\n\tborder-right: 0 hidden transparent;\n\n\t/* no bottom borders on rows */\n\tborder-bottom: 0 hidden transparent;\n}\n\n.fc-row:first-child table {\n\tborder-top: 0 hidden transparent; /* no top border on first row */\n}\n\n\n/* Day Row (used within the header and the DayGrid)\n--------------------------------------------------------------------------------------------------*/\n\n.fc-row {\n\tposition: relative;\n}\n\n.fc-row .fc-bg {\n\tz-index: 1;\n}\n\n/* highlighting cells & background event skeleton */\n\n.fc-row .fc-bgevent-skeleton,\n.fc-row .fc-highlight-skeleton {\n\tbottom: 0; /* stretch skeleton to bottom of row */\n}\n\n.fc-row .fc-bgevent-skeleton table,\n.fc-row .fc-highlight-skeleton table {\n\theight: 100%; /* stretch skeleton to bottom of row */\n}\n\n.fc-row .fc-highlight-skeleton td,\n.fc-row .fc-bgevent-skeleton td {\n\tborder-color: transparent;\n}\n\n.fc-row .fc-bgevent-skeleton {\n\tz-index: 2;\n\n}\n\n.fc-row .fc-highlight-skeleton {\n\tz-index: 3;\n}\n\n/*\nrow content (which contains day/week numbers and events) as well as \"helper\" (which contains\ntemporary rendered events).\n*/\n\n.fc-row .fc-content-skeleton {\n\tposition: relative;\n\tz-index: 4;\n\tpadding-bottom: 2px; /* matches the space above the events */\n}\n\n.fc-row .fc-helper-skeleton {\n\tz-index: 5;\n}\n\n.fc-row .fc-content-skeleton td,\n.fc-row .fc-helper-skeleton td {\n\t/* see-through to the background below */\n\tbackground: none; /* in case <td>s are globally styled */\n\tborder-color: transparent;\n\n\t/* don't put a border between events and/or the day number */\n\tborder-bottom: 0;\n}\n\n.fc-row .fc-content-skeleton tbody td, /* cells with events inside (so NOT the day number cell) */\n.fc-row .fc-helper-skeleton tbody td {\n\t/* don't put a border between event cells */\n\tborder-top: 0;\n}\n\n\n/* Scrolling Container\n--------------------------------------------------------------------------------------------------*/\n\n.fc-scroller { /* this class goes on elements for guaranteed vertical scrollbars */\n\toverflow-y: scroll;\n\toverflow-x: hidden;\n}\n\n.fc-scroller > * { /* we expect an immediate inner element */\n\tposition: relative; /* re-scope all positions */\n\twidth: 100%; /* hack to force re-sizing this inner element when scrollbars appear/disappear */\n\toverflow: hidden; /* don't let negative margins or absolute positioning create further scroll */\n}\n\n\n/* Global Event Styles\n--------------------------------------------------------------------------------------------------*/\n\n.fc-event {\n\tposition: relative; /* for resize handle and other inner positioning */\n\tdisplay: block; /* make the <a> tag block */\n\tfont-size: .85em;\n\tline-height: 1.3;\n\tborder-radius: 2px;\n\tbackground-color: $light-blue; /* default BACKGROUND color */\n\tfont-weight: normal; /* undo jqui's ui-widget-header bold */\n\n    &.event-azure{\n        background-color: $light-azure;\n    }\n    &.event-green{\n        background-color: $light-green;\n    }\n    &.event-orange{\n        background-color: $light-orange;\n    }\n    &.event-red{\n        background-color: $light-red;\n    }\n}\n\n/* overpower some of bootstrap's and jqui's styles on <a> tags */\n.fc-event,\n.fc-event:hover,\n.ui-widget .fc-event {\n\tcolor: $black-color; /* default TEXT color */\n\ttext-decoration: none; /* if <a> has an href */\n}\n\n.fc-event[href],\n.fc-event.fc-draggable {\n\tcursor: pointer; /* give events with links and draggable events a hand mouse pointer */\n}\n\n.fc-not-allowed, /* causes a \"warning\" cursor. applied on body */\n.fc-not-allowed .fc-event { /* to override an event's custom cursor */\n\tcursor: not-allowed;\n}\n\n.fc-event .fc-bg { /* the generic .fc-bg already does position */\n\tz-index: 1;\n\tbackground: #fff;\n\topacity: .25;\n\tfilter: alpha(opacity=25); /* for IE */\n}\n\n.fc-event .fc-content {\n\tposition: relative;\n\tz-index: 2;\n}\n\n.fc-event .fc-resizer {\n\tposition: absolute;\n\tz-index: 3;\n}\n\n\n/* Horizontal Events\n--------------------------------------------------------------------------------------------------*/\n\n/* events that are continuing to/from another week. kill rounded corners and butt up against edge */\n\n.fc-ltr .fc-h-event.fc-not-start,\n.fc-rtl .fc-h-event.fc-not-end {\n\tmargin-left: 0;\n\tborder-left-width: 0;\n\tpadding-left: 1px; /* replace the border with padding */\n\tborder-top-left-radius: 0;\n\tborder-bottom-left-radius: 0;\n}\n\n.fc-ltr .fc-h-event.fc-not-end,\n.fc-rtl .fc-h-event.fc-not-start {\n\tmargin-right: 0;\n\tborder-right-width: 0;\n\tpadding-right: 1px; /* replace the border with padding */\n\tborder-top-right-radius: 0;\n\tborder-bottom-right-radius: 0;\n}\n\n/* resizer */\n\n.fc-h-event .fc-resizer { /* positioned it to overcome the event's borders */\n\ttop: -1px;\n\tbottom: -1px;\n\tleft: -1px;\n\tright: -1px;\n\twidth: 5px;\n}\n\n/* left resizer  */\n.fc-ltr .fc-h-event .fc-start-resizer,\n.fc-ltr .fc-h-event .fc-start-resizer:before,\n.fc-ltr .fc-h-event .fc-start-resizer:after,\n.fc-rtl .fc-h-event .fc-end-resizer,\n.fc-rtl .fc-h-event .fc-end-resizer:before,\n.fc-rtl .fc-h-event .fc-end-resizer:after {\n\tright: auto; /* ignore the right and only use the left */\n\tcursor: w-resize;\n}\n\n/* right resizer */\n.fc-ltr .fc-h-event .fc-end-resizer,\n.fc-ltr .fc-h-event .fc-end-resizer:before,\n.fc-ltr .fc-h-event .fc-end-resizer:after,\n.fc-rtl .fc-h-event .fc-start-resizer,\n.fc-rtl .fc-h-event .fc-start-resizer:before,\n.fc-rtl .fc-h-event .fc-start-resizer:after {\n\tleft: auto; /* ignore the left and only use the right */\n\tcursor: e-resize;\n}\n\n\n/* DayGrid events\n----------------------------------------------------------------------------------------------------\nWe use the full \"fc-day-grid-event\" class instead of using descendants because the event won't\nbe a descendant of the grid when it is being dragged.\n*/\n\n.fc-day-grid-event {\n\tmargin: 2px 5px 0; /* spacing between events and edges */\n\tpadding: 1px 2px;\n}\n\n\n.fc-day-grid-event .fc-content { /* force events to be one-line tall */\n\twhite-space: nowrap;\n\toverflow: hidden;\n}\n\n.fc-day-grid-event .fc-time {\n\tfont-weight: bold;\n}\n\n.fc-day-grid-event .fc-resizer { /* enlarge the default hit area */\n\tleft: -3px;\n\tright: -3px;\n\twidth: 7px;\n}\n\n\n/* Event Limiting\n--------------------------------------------------------------------------------------------------*/\n\n/* \"more\" link that represents hidden events */\n\na.fc-more {\n\tmargin: 1px 3px;\n\tfont-size: .85em;\n\tcursor: pointer;\n\ttext-decoration: none;\n}\n\na.fc-more:hover {\n\ttext-decoration: underline;\n}\n\n.fc-limited { /* rows and cells that are hidden because of a \"more\" link */\n\tdisplay: none;\n}\n\n/* popover that appears when \"more\" link is clicked */\n\n.fc-day-grid .fc-row {\n\tz-index: 1; /* make the \"more\" popover one higher than this */\n}\n\n.fc-more-popover {\n\tz-index: 2;\n\twidth: 220px;\n}\n\n.fc-more-popover .fc-event-container {\n\tpadding: 10px;\n}\n\n/* Toolbar\n--------------------------------------------------------------------------------------------------*/\n\n.fc-toolbar {\n\ttext-align: center;\n\tmargin-bottom: 1em;\n}\n\n.fc-toolbar .fc-left {\n\tfloat: left;\n\tmin-width: 260px;\n}\n\n.fc-toolbar .fc-right {\n\tfloat: right;\n}\n\n.fc-toolbar .fc-center {\n\tdisplay: inline-block;\n}\n\n/* the things within each left/right/center section */\n.fc .fc-toolbar > * > * { /* extra precedence to override button border margins */\n\tfloat: left;\n\tmargin-left: .75em;\n}\n\n/* the first thing within each left/center/right section */\n.fc .fc-toolbar > * > :first-child { /* extra precedence to override button border margins */\n\tmargin-left: 0;\n}\n\n/* title text */\n\n.fc-toolbar h2 {\n\tmargin: 0;\n}\n\n/* button layering (for border precedence) */\n\n.fc-toolbar button {\n\tposition: relative;\n}\n\n.fc-toolbar .fc-state-hover,\n.fc-toolbar .ui-state-hover {\n\tz-index: 2;\n}\n\n.fc-toolbar .fc-state-down {\n\tz-index: 3;\n}\n\n.fc-toolbar .fc-state-active,\n.fc-toolbar .ui-state-active {\n\tz-index: 4;\n}\n\n.fc-toolbar button:focus {\n\tz-index: 5;\n}\n\n\n/* View Structure\n--------------------------------------------------------------------------------------------------*/\n\n/* undo twitter bootstrap's box-sizing rules. normalizes positioning techniques */\n/* don't do this for the toolbar because we'll want bootstrap to style those buttons as some pt */\n.fc-view-container *,\n.fc-view-container *:before,\n.fc-view-container *:after {\n\t-webkit-box-sizing: content-box;\n\t   -moz-box-sizing: content-box;\n\t        box-sizing: content-box;\n}\n\n.fc-view, /* scope positioning and z-index's for everything within the view */\n.fc-view > table { /* so dragged elements can be above the view's main element */\n\tposition: relative;\n\tz-index: 1;\n}\n\n/* BasicView\n--------------------------------------------------------------------------------------------------*/\n\n/* day row structure */\n\n.fc-basicWeek-view .fc-content-skeleton,\n.fc-basicDay-view .fc-content-skeleton {\n\t/* we are sure there are no day numbers in these views, so... */\n\tpadding-top: 1px; /* add a pixel to make sure there are 2px padding above events */\n\tpadding-bottom: 1em; /* ensure a space at bottom of cell for user selecting/clicking */\n}\n\n.fc-basic-view .fc-body .fc-row {\n\tmin-height: 4em; /* ensure that all rows are at least this tall */\n}\n\n/* a \"rigid\" row will take up a constant amount of height because content-skeleton is absolute */\n\n.fc-row.fc-rigid {\n\toverflow: hidden;\n}\n\n.fc-row.fc-rigid .fc-content-skeleton {\n\tposition: absolute;\n\ttop: 0;\n\tleft: 0;\n\tright: 0;\n}\n\n/* week and day number styling */\n\n.fc-basic-view .fc-week-number,\n.fc-basic-view .fc-day-number {\n\tpadding: 8px;\n}\n\n\n.fc-basic-view .fc-week-number {\n\ttext-align: center;\n}\n\n.fc-basic-view .fc-week-number span {\n\t/* work around the way we do column resizing and ensure a minimum width */\n\tdisplay: inline-block;\n\tmin-width: 1.25em;\n}\n\n.fc-ltr .fc-basic-view .fc-day-number {\n\tfloat: right;\n}\n\n.fc-rtl .fc-basic-view .fc-day-number {\n\ttext-align: left;\n}\n\n.fc-other-month .fc-day-number{\n\topacity: 0.3;\n\tfilter: alpha(opacity=30); /* for IE */\n\t/* opacity with small font can sometimes look too faded\n\t   might want to set the 'color' property instead\n\t   making day-numbers bold also fixes the problem */\n}\n\n/* AgendaView all-day area\n--------------------------------------------------------------------------------------------------*/\n\n.fc-agenda-view .fc-day-grid {\n\tposition: relative;\n\tz-index: 2; /* so the \"more..\" popover will be over the time grid */\n}\n\n.fc-agenda-view .fc-day-grid .fc-row {\n\tmin-height: 3em; /* all-day section will never get shorter than this */\n}\n\n.fc-agenda-view .fc-day-grid .fc-row .fc-content-skeleton {\n\tpadding-top: 1px; /* add a pixel to make sure there are 2px padding above events */\n\tpadding-bottom: 1em; /* give space underneath events for clicking/selecting days */\n}\n\n\n/* TimeGrid axis running down the side (for both the all-day area and the slot area)\n--------------------------------------------------------------------------------------------------*/\n\n.fc .fc-axis { /* .fc to overcome default cell styles */\n\tvertical-align: middle;\n\tpadding: 0 4px;\n\twhite-space: nowrap;\n}\n\n.fc-ltr .fc-axis {\n\ttext-align: right;\n}\n\n.fc-rtl .fc-axis {\n\ttext-align: left;\n}\n\n.ui-widget td.fc-axis {\n\tfont-weight: normal; /* overcome jqui theme making it bold */\n}\n\n\n/* TimeGrid Structure\n--------------------------------------------------------------------------------------------------*/\n\n.fc-time-grid-container, /* so scroll container's z-index is below all-day */\n.fc-time-grid { /* so slats/bg/content/etc positions get scoped within here */\n\tposition: relative;\n\tz-index: 1;\n}\n\n.fc-time-grid {\n\tmin-height: 100%; /* so if height setting is 'auto', .fc-bg stretches to fill height */\n}\n\n.fc-time-grid table { /* don't put outer borders on slats/bg/content/etc */\n\tborder: 0 hidden transparent;\n}\n\n.fc-time-grid > .fc-bg {\n\tz-index: 1;\n}\n\n.fc-time-grid .fc-slats,\n.fc-time-grid > hr { /* the <hr> AgendaView injects when grid is shorter than scroller */\n\tposition: relative;\n\tz-index: 2;\n}\n\n.fc-time-grid .fc-bgevent-skeleton,\n.fc-time-grid .fc-content-skeleton {\n\tposition: absolute;\n\ttop: 0;\n\tleft: 0;\n\tright: 0;\n}\n\n.fc-time-grid .fc-bgevent-skeleton {\n\tz-index: 3;\n}\n\n.fc-time-grid .fc-highlight-skeleton {\n\tz-index: 4;\n}\n\n.fc-time-grid .fc-content-skeleton {\n\tz-index: 5;\n}\n\n.fc-time-grid .fc-helper-skeleton {\n\tz-index: 6;\n}\n\n\n/* TimeGrid Slats (lines that run horizontally)\n--------------------------------------------------------------------------------------------------*/\n\n.fc-time-grid .fc-slats td {\n\theight: 1.5em;\n\tborder-bottom: 0; /* each cell is responsible for its top border */\n}\n\n.fc-time-grid .fc-slats .fc-minor td {\n\tborder-top-style: dotted;\n}\n\n.fc-time-grid .fc-slats .ui-widget-content { /* for jqui theme */\n\tbackground: none; /* see through to fc-bg */\n}\n\n\n/* TimeGrid Highlighting Slots\n--------------------------------------------------------------------------------------------------*/\n\n.fc-time-grid .fc-highlight-container { /* a div within a cell within the fc-highlight-skeleton */\n\tposition: relative; /* scopes the left/right of the fc-highlight to be in the column */\n}\n\n.fc-time-grid .fc-highlight {\n\tposition: absolute;\n\tleft: 0;\n\tright: 0;\n\t/* top and bottom will be in by JS */\n}\n\n\n/* TimeGrid Event Containment\n--------------------------------------------------------------------------------------------------*/\n\n.fc-time-grid .fc-event-container, /* a div within a cell within the fc-content-skeleton */\n.fc-time-grid .fc-bgevent-container { /* a div within a cell within the fc-bgevent-skeleton */\n\tposition: relative;\n}\n\n.fc-ltr .fc-time-grid .fc-event-container { /* space on the sides of events for LTR (default) */\n\tmargin: 0 2.5% 0 2px;\n}\n\n.fc-rtl .fc-time-grid .fc-event-container { /* space on the sides of events for RTL */\n\tmargin: 0 2px 0 2.5%;\n}\n\n.fc-time-grid .fc-event,\n.fc-time-grid .fc-bgevent {\n\tposition: absolute;\n\tz-index: 1; /* scope inner z-index's */\n}\n\n.fc-time-grid .fc-bgevent {\n\t/* background events always span full width */\n\tleft: 0;\n\tright: 0;\n}\n\n\n/* Generic Vertical Event\n--------------------------------------------------------------------------------------------------*/\n\n.fc-v-event.fc-not-start { /* events that are continuing from another day */\n\t/* replace space made by the top border with padding */\n\tborder-top-width: 0;\n\tpadding-top: 1px;\n\n\t/* remove top rounded corners */\n\tborder-top-left-radius: 0;\n\tborder-top-right-radius: 0;\n}\n\n.fc-v-event.fc-not-end {\n\t/* replace space made by the top border with padding */\n\tborder-bottom-width: 0;\n\tpadding-bottom: 1px;\n\n\t/* remove bottom rounded corners */\n\tborder-bottom-left-radius: 0;\n\tborder-bottom-right-radius: 0;\n}\n\n\n/* TimeGrid Event Styling\n----------------------------------------------------------------------------------------------------\nWe use the full \"fc-time-grid-event\" class instead of using descendants because the event won't\nbe a descendant of the grid when it is being dragged.\n*/\n\n.fc-time-grid-event {\n\toverflow: hidden; /* don't let the bg flow over rounded corners */\n}\n\n.fc-time-grid-event .fc-time,\n.fc-time-grid-event .fc-title {\n\tpadding: 0 1px;\n}\n\n.fc-time-grid-event .fc-time {\n\tfont-size: .85em;\n\twhite-space: nowrap;\n}\n\n/* short mode, where time and title are on the same line */\n\n.fc-time-grid-event.fc-short .fc-content {\n\t/* don't wrap to second line (now that contents will be inline) */\n\twhite-space: nowrap;\n}\n\n.fc-time-grid-event.fc-short .fc-time,\n.fc-time-grid-event.fc-short .fc-title {\n\t/* put the time and title on the same line */\n\tdisplay: inline-block;\n\tvertical-align: top;\n}\n\n.fc-time-grid-event.fc-short .fc-time span {\n\tdisplay: none; /* don't display the full time text... */\n}\n\n.fc-time-grid-event.fc-short .fc-time:before {\n\tcontent: attr(data-start); /* ...instead, display only the start time */\n}\n\n.fc-time-grid-event.fc-short .fc-time:after {\n\tcontent: \"\\000A0-\\000A0\"; /* seperate with a dash, wrapped in nbsp's */\n}\n\n.fc-time-grid-event.fc-short .fc-title {\n\tfont-size: .85em; /* make the title text the same size as the time */\n\tpadding: 0; /* undo padding from above */\n}\n\n/* resizer */\n\n.fc-time-grid-event .fc-resizer {\n\tleft: 0;\n\tright: 0;\n\tbottom: 0;\n\theight: 8px;\n\toverflow: hidden;\n\tline-height: 8px;\n\tfont-size: 11px;\n\tfont-family: monospace;\n\ttext-align: center;\n\tcursor: s-resize;\n}\n\n.fc-time-grid-event .fc-resizer:after {\n\tcontent: \"=\";\n}\n\n.card-calendar{\n    .content{\n        padding: 0 !important;\n    }\n    .fc-toolbar{\n        padding-top: $padding-default-horizontal;\n        padding-left: $padding-default-horizontal;\n        padding-right: $padding-default-horizontal;\n    }\n    .fc td:first-child{\n        border-left: 0;\n    }\n    .fc td:last-child{\n        border-right: 0;\n    }\n    .fc-basic-view td:last-child.fc-week-number span,\n    .fc-basic-view td:last-child.fc-day-number{\n        padding-right: $padding-default-horizontal;\n    }\n    .fc .fc-day-header:last-child{\n        padding-right: 15px;\n    }\n    .fc .fc-row:last-child td{\n        border-bottom: 0;\n    }\n    .fc .fc-body .fc-widget-content{\n        border-bottom: 0;\n    }\n}\n","@mixin ct-responsive-svg-container($width: 100%, $ratio: $ct-container-ratio) {\n  display: block;\n  position: relative;\n  width: $width;\n\n  &:before {\n    display: block;\n    float: left;\n    content: \"\";\n    width: 0;\n    height: 0;\n    padding-bottom: $ratio * 100%;\n  }\n\n  &:after {\n    content: \"\";\n    display: table;\n    clear: both;\n  }\n\n  > svg {\n    display: block;\n    position: absolute;\n    top: 0;\n    left: 0;\n  }\n}\n\n@mixin ct-align-justify($ct-text-align: $ct-text-align, $ct-text-justify: $ct-text-justify) {\n  -webkit-box-align: $ct-text-align;\n  -webkit-align-items: $ct-text-align;\n  -ms-flex-align: $ct-text-align;\n  align-items: $ct-text-align;\n  -webkit-box-pack: $ct-text-justify;\n  -webkit-justify-content: $ct-text-justify;\n  -ms-flex-pack: $ct-text-justify;\n  justify-content: $ct-text-justify;\n  // Fallback to text-align for non-flex browsers\n  @if($ct-text-justify == 'flex-start') {\n    text-align: left;\n  } @else if ($ct-text-justify == 'flex-end') {\n    text-align: right;\n  } @else {\n    text-align: center;\n  }\n}\n\n@mixin ct-flex() {\n  // Fallback to block\n  display: block;\n  display: -webkit-box;\n  display: -moz-box;\n  display: -ms-flexbox;\n  display: -webkit-flex;\n  display: flex;\n}\n\n@mixin ct-chart-label($ct-text-color: $ct-text-color, $ct-text-size: $ct-text-size, $ct-text-line-height: $ct-text-line-height) {\n  fill: $ct-text-color;\n  color: $ct-text-color;\n  font-size: $ct-text-size;\n  line-height: $ct-text-line-height;\n}\n\n@mixin ct-chart-grid($ct-grid-color: $ct-grid-color, $ct-grid-width: $ct-grid-width, $ct-grid-dasharray: $ct-grid-dasharray) {\n  stroke: $ct-grid-color;\n  stroke-width: $ct-grid-width;\n\n  @if ($ct-grid-dasharray) {\n    stroke-dasharray: $ct-grid-dasharray;\n  }\n}\n\n@mixin ct-chart-point($ct-point-size: $ct-point-size, $ct-point-shape: $ct-point-shape) {\n  stroke-width: $ct-point-size;\n  stroke-linecap: $ct-point-shape;\n}\n\n@mixin ct-chart-line($ct-line-width: $ct-line-width, $ct-line-dasharray: $ct-line-dasharray) {\n  fill: none;\n  stroke-width: $ct-line-width;\n\n  @if ($ct-line-dasharray) {\n    stroke-dasharray: $ct-line-dasharray;\n  }\n}\n\n@mixin ct-chart-area($ct-area-opacity: $ct-area-opacity) {\n  stroke: none;\n  fill-opacity: $ct-area-opacity;\n}\n\n@mixin ct-chart-bar($ct-bar-width: $ct-bar-width) {\n  fill: none;\n  stroke-width: $ct-bar-width;\n}\n\n@mixin ct-chart-donut($ct-donut-width: $ct-donut-width) {\n  fill: none;\n  stroke-width: $ct-donut-width;\n}\n\n@mixin ct-chart-series-color($color) {\n  .#{$ct-class-point}, .#{$ct-class-line}, .#{$ct-class-bar}, .#{$ct-class-slice-donut} {\n    stroke: $color;\n  }\n\n  .#{$ct-class-slice-pie}, .#{$ct-class-area} {\n    fill: $color;\n  }\n}\n\n@mixin ct-chart($ct-container-ratio: $ct-container-ratio, $ct-text-color: $ct-text-color, $ct-text-size: $ct-text-size, $ct-grid-color: $ct-grid-color, $ct-grid-width: $ct-grid-width, $ct-grid-dasharray: $ct-grid-dasharray, $ct-point-size: $ct-point-size, $ct-point-shape: $ct-point-shape, $ct-line-width: $ct-line-width, $ct-bar-width: $ct-bar-width, $ct-donut-width: $ct-donut-width, $ct-series-names: $ct-series-names, $ct-series-colors: $ct-series-colors) {\n\n  .#{$ct-class-label} {\n    @include ct-chart-label($ct-text-color, $ct-text-size);\n  }\n\n  .#{$ct-class-chart-line} .#{$ct-class-label},\n  .#{$ct-class-chart-bar} .#{$ct-class-label} {\n    @include ct-flex();\n  }\n\n  .#{$ct-class-label}.#{$ct-class-horizontal}.#{$ct-class-start} {\n    @include ct-align-justify(flex-end, flex-start);\n    // Fallback for browsers that don't support foreignObjects\n    text-anchor: start;\n  }\n\n  .#{$ct-class-label}.#{$ct-class-horizontal}.#{$ct-class-end} {\n    @include ct-align-justify(flex-start, flex-start);\n    // Fallback for browsers that don't support foreignObjects\n    text-anchor: start;\n  }\n\n  .#{$ct-class-label}.#{$ct-class-vertical}.#{$ct-class-start} {\n    @include ct-align-justify(flex-end, flex-end);\n    // Fallback for browsers that don't support foreignObjects\n    text-anchor: end;\n  }\n\n  .#{$ct-class-label}.#{$ct-class-vertical}.#{$ct-class-end} {\n    @include ct-align-justify(flex-end, flex-start);\n    // Fallback for browsers that don't support foreignObjects\n    text-anchor: start;\n  }\n\n  .#{$ct-class-chart-bar} .#{$ct-class-label}.#{$ct-class-horizontal}.#{$ct-class-start} {\n    @include ct-align-justify(flex-end, center);\n    // Fallback for browsers that don't support foreignObjects\n    text-anchor: start;\n  }\n\n  .#{$ct-class-chart-bar} .#{$ct-class-label}.#{$ct-class-horizontal}.#{$ct-class-end} {\n    @include ct-align-justify(flex-start, center);\n    // Fallback for browsers that don't support foreignObjects\n    text-anchor: start;\n  }\n\n  .#{$ct-class-chart-bar}.#{$ct-class-horizontal-bars} .#{$ct-class-label}.#{$ct-class-horizontal}.#{$ct-class-start} {\n    @include ct-align-justify(flex-end, flex-start);\n    // Fallback for browsers that don't support foreignObjects\n    text-anchor: start;\n  }\n\n  .#{$ct-class-chart-bar}.#{$ct-class-horizontal-bars} .#{$ct-class-label}.#{$ct-class-horizontal}.#{$ct-class-end} {\n    @include ct-align-justify(flex-start, flex-start);\n    // Fallback for browsers that don't support foreignObjects\n    text-anchor: start;\n  }\n\n  .#{$ct-class-chart-bar}.#{$ct-class-horizontal-bars} .#{$ct-class-label}.#{$ct-class-vertical}.#{$ct-class-start} {\n    //@include ct-chart-label($ct-text-color, $ct-text-size, center, $ct-vertical-text-justify);\n    @include ct-align-justify(center, flex-end);\n    // Fallback for browsers that don't support foreignObjects\n    text-anchor: end;\n  }\n\n  .#{$ct-class-chart-bar}.#{$ct-class-horizontal-bars} .#{$ct-class-label}.#{$ct-class-vertical}.#{$ct-class-end} {\n    @include ct-align-justify(center, flex-start);\n    // Fallback for browsers that don't support foreignObjects\n    text-anchor: end;\n  }\n\n  .#{$ct-class-grid} {\n    @include ct-chart-grid($ct-grid-color, $ct-grid-width, $ct-grid-dasharray);\n  }\n\n  .#{$ct-class-point} {\n    @include ct-chart-point($ct-point-size, $ct-point-shape);\n  }\n\n  .#{$ct-class-line} {\n    @include ct-chart-line($ct-line-width);\n  }\n\n  .#{$ct-class-area} {\n    @include ct-chart-area();\n  }\n\n  .#{$ct-class-bar} {\n    @include ct-chart-bar($ct-bar-width);\n  }\n\n  .#{$ct-class-slice-donut} {\n    @include ct-chart-donut($ct-donut-width);\n  }\n\n  @if $ct-include-colored-series {\n    @for $i from 0 to length($ct-series-names) {\n      .#{$ct-class-series}-#{nth($ct-series-names, $i + 1)} {\n        $color: nth($ct-series-colors, $i + 1);\n\n        @include ct-chart-series-color($color);\n      }\n    }\n  }\n}\n\n@if $ct-include-classes {\n  @include ct-chart();\n\n  @if $ct-include-alternative-responsive-containers {\n    @for $i from 0 to length($ct-scales-names) {\n      .#{nth($ct-scales-names, $i + 1)} {\n        @include ct-responsive-svg-container($ratio: nth($ct-scales, $i + 1));\n      }\n    }\n  }\n}\n\n\n.ct-blue{\n    stroke: $color-blue !important;\n}\n.ct-azure{\n    stroke: $color-azure !important;\n}\n.ct-green{\n    stroke: $color-green !important;\n}\n.ct-orange{\n    stroke: $color-orange !important;\n}\n.ct-red{\n    stroke: $color-red !important;\n}\n","/* perfect-scrollbar v0.6.10 */\n.ps-container {\n  -ms-touch-action: none;\n  touch-action: none;\n  overflow: hidden !important;\n  -ms-overflow-style: none; }\n  @supports (-ms-overflow-style: none) {\n    .ps-container {\n      overflow: auto !important; } }\n  @media screen and (-ms-high-contrast: active), (-ms-high-contrast: none) {\n    .ps-container {\n      overflow: auto !important; } }\n  .ps-container.ps-active-x > .ps-scrollbar-x-rail,\n  .ps-container.ps-active-y > .ps-scrollbar-y-rail {\n    display: block;\n    background-color: transparent; }\n  .ps-container.ps-in-scrolling {\n    pointer-events: none; }\n    .ps-container.ps-in-scrolling.ps-x > .ps-scrollbar-x-rail {\n      background-color: #eee;\n      opacity: 0.9; }\n      .ps-container.ps-in-scrolling.ps-x > .ps-scrollbar-x-rail > .ps-scrollbar-x {\n        background-color: #999; }\n    .ps-container.ps-in-scrolling.ps-y > .ps-scrollbar-y-rail {\n      background-color: #eee;\n      opacity: 0.9; }\n      .ps-container.ps-in-scrolling.ps-y > .ps-scrollbar-y-rail > .ps-scrollbar-y {\n        background-color: #999; }\n  .ps-container > .ps-scrollbar-x-rail {\n    display: none;\n    position: absolute;\n    /* please don't change 'position' */\n    -webkit-border-radius: 4px;\n    -moz-border-radius: 4px;\n    border-radius: 4px;\n    opacity: 0;\n    -webkit-transition: background-color .2s linear, opacity .2s linear;\n    -moz-transition: background-color .2s linear, opacity .2s linear;\n    -o-transition: background-color .2s linear, opacity .2s linear;\n    transition: background-color .2s linear, opacity .2s linear;\n    bottom: 3px;\n    /* there must be 'bottom' for ps-scrollbar-x-rail */\n    height: 8px; }\n    .ps-container > .ps-scrollbar-x-rail > .ps-scrollbar-x {\n      position: absolute;\n      /* please don't change 'position' */\n      background-color: #aaa;\n      -webkit-border-radius: 4px;\n      -moz-border-radius: 4px;\n      border-radius: 4px;\n      -webkit-transition: background-color .2s linear;\n      -moz-transition: background-color .2s linear;\n      -o-transition: background-color .2s linear;\n      transition: background-color .2s linear;\n      bottom: 0;\n      /* there must be 'bottom' for ps-scrollbar-x */\n      height: 8px; }\n  .ps-container > .ps-scrollbar-y-rail {\n    display: none;\n    position: absolute;\n    /* please don't change 'position' */\n    -webkit-border-radius: 4px;\n    -moz-border-radius: 4px;\n    border-radius: 4px;\n    opacity: 0;\n    -webkit-transition: background-color .2s linear, opacity .2s linear;\n    -moz-transition: background-color .2s linear, opacity .2s linear;\n    -o-transition: background-color .2s linear, opacity .2s linear;\n    transition: background-color .2s linear, opacity .2s linear;\n    right: 3px;\n    /* there must be 'right' for ps-scrollbar-y-rail */\n    width: 8px; }\n    .ps-container > .ps-scrollbar-y-rail > .ps-scrollbar-y {\n      position: absolute;\n      /* please don't change 'position' */\n      background-color: #aaa;\n      -webkit-border-radius: 4px;\n      -moz-border-radius: 4px;\n      border-radius: 4px;\n      -webkit-transition: background-color .2s linear;\n      -moz-transition: background-color .2s linear;\n      -o-transition: background-color .2s linear;\n      transition: background-color .2s linear;\n      right: 0;\n      /* there must be 'right' for ps-scrollbar-y */\n      width: 8px; }\n  .ps-container:hover.ps-in-scrolling {\n    pointer-events: none; }\n    .ps-container:hover.ps-in-scrolling.ps-x > .ps-scrollbar-x-rail {\n      background-color: #eee;\n      opacity: 0.9; }\n      .ps-container:hover.ps-in-scrolling.ps-x > .ps-scrollbar-x-rail > .ps-scrollbar-x {\n        background-color: #999; }\n    .ps-container:hover.ps-in-scrolling.ps-y > .ps-scrollbar-y-rail {\n      background-color: #eee;\n      opacity: 0.9; }\n      .ps-container:hover.ps-in-scrolling.ps-y > .ps-scrollbar-y-rail > .ps-scrollbar-y {\n        background-color: #999; }\n  .ps-container:hover > .ps-scrollbar-x-rail,\n  .ps-container:hover > .ps-scrollbar-y-rail {\n    opacity: 0.6; }\n  .ps-container:hover > .ps-scrollbar-x-rail:hover {\n    background-color: #eee;\n    opacity: 0.9; }\n    .ps-container:hover > .ps-scrollbar-x-rail:hover > .ps-scrollbar-x {\n      background-color: #999; }\n  .ps-container:hover > .ps-scrollbar-y-rail:hover {\n    background-color: #eee;\n    opacity: 0.9; }\n    .ps-container:hover > .ps-scrollbar-y-rail:hover > .ps-scrollbar-y {\n      background-color: #999; }\n","/*!\n * Bootstrap-select v1.12.2 (http://silviomoreto.github.io/bootstrap-select)\n *\n * Copyright 2013-2017 bootstrap-select\n * Licensed under MIT (https://github.com/silviomoreto/bootstrap-select/blob/master/LICENSE)\n */\n\nselect.bs-select-hidden,\nselect.selectpicker {\n  display: none !important;\n}\n.bootstrap-select {\n  min-width: 100%;\n}\n.bootstrap-select > .dropdown-toggle {\n  width: 100%;\n  padding-right: 25px;\n  z-index: 1;\n  margin: 0;\n\n    &:after{\n        margin-left: -10px;\n    }\n}\n\n.bootstrap-select > select {\n  position: absolute !important;\n  bottom: 0;\n  left: 50%;\n  display: block !important;\n  width: 0.5px !important;\n  height: 100% !important;\n  padding: 0 !important;\n  opacity: 0 !important;\n  border: none;\n  border-top-left-radius: 3px !important;\n  border-top-right-radius: 3px !important;\n}\n.bootstrap-select > select.mobile-device {\n  top: 0;\n  left: 0;\n  display: block !important;\n  width: 100% !important;\n  z-index: 2;\n}\n.has-error .bootstrap-select .dropdown-toggle,\n.error .bootstrap-select .dropdown-toggle {\n  border-color: #b94a48;\n}\n.bootstrap-select.fit-width {\n  width: auto !important;\n}\n.bootstrap-select:not([class*=\"col-\"]):not([class*=\"form-control\"]):not(.input-group-btn) {\n  width: 100%;\n}\n\n.bootstrap-select.form-control {\n  margin-bottom: 0;\n  padding: 0;\n  border: none;\n}\n.bootstrap-select.form-control:not([class*=\"col-\"]) {\n  width: 100%;\n}\n.bootstrap-select.btn-block{\n    width: 100%;\n}\n.bootstrap-select.form-control.input-group-btn {\n  z-index: auto;\n}\n.bootstrap-select.form-control.input-group-btn:not(:first-child):not(:last-child) > .btn {\n  border-radius: 0;\n}\n.bootstrap-select.btn-group:not(.input-group-btn),\n.bootstrap-select.btn-group[class*=\"col-\"] {\n  float: none;\n  display: inline-block;\n  margin-left: 0;\n}\n.bootstrap-select.btn-group.dropdown-menu-right,\n.bootstrap-select.btn-group[class*=\"col-\"].dropdown-menu-right,\n.row .bootstrap-select.btn-group[class*=\"col-\"].dropdown-menu-right {\n  float: right;\n}\n.form-inline .bootstrap-select.btn-group,\n.form-horizontal .bootstrap-select.btn-group,\n.form-group .bootstrap-select.btn-group {\n  margin-bottom: 0;\n}\n.form-group-lg .bootstrap-select.btn-group.form-control,\n.form-group-sm .bootstrap-select.btn-group.form-control {\n  padding: 0;\n}\n.form-group-lg .bootstrap-select.btn-group.form-control .dropdown-toggle,\n.form-group-sm .bootstrap-select.btn-group.form-control .dropdown-toggle {\n  height: 100%;\n  font-size: inherit;\n  line-height: inherit;\n  border-radius: inherit;\n}\n.form-inline .bootstrap-select.btn-group .form-control {\n  width: 100%;\n}\n.bootstrap-select.btn-group.disabled,\n.bootstrap-select.btn-group > .disabled {\n  cursor: not-allowed;\n}\n.bootstrap-select.btn-group.disabled:focus,\n.bootstrap-select.btn-group > .disabled:focus {\n  outline: none !important;\n}\n.bootstrap-select.btn-group.bs-container {\n  position: absolute;\n  height: 0 !important;\n  padding: 0 !important;\n}\n.bootstrap-select.btn-group.bs-container .dropdown-menu {\n  z-index: 1060;\n}\n.bootstrap-select.btn-group .dropdown-toggle .filter-option {\n  display: inline-block;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  width: 100%;\n  text-align: left;\n}\n.bootstrap-select.btn-group .dropdown-toggle .caret {\n  display: none;\n}\n.bootstrap-select.btn-group[class*=\"col-\"] .dropdown-toggle {\n  width: 100%;\n}\n.bootstrap-select.btn-group .dropdown-menu {\n  min-width: 100%;\n  -webkit-box-sizing: border-box;\n     -moz-box-sizing: border-box;\n          box-sizing: border-box;\n max-height: 400px !important;\n}\n.bootstrap-select.btn-group .dropdown-menu.inner {\n  position: static;\n  float: none;\n  border: 0;\n  padding: 0;\n  margin: 0;\n  display: block;\n  max-height: 400px !important;\n  overflow-y: scroll;\n -ms-overflow-style: auto;\n  -webkit-box-shadow: none;\n          box-shadow: none;\n}\n.bootstrap-select.btn-group .dropdown-menu li {\n  position: relative;\n}\n.bootstrap-select.btn-group .dropdown-menu li.active small {\n  color: #fff;\n}\n.bootstrap-select.btn-group .dropdown-menu li.disabled a {\n  cursor: not-allowed;\n}\n.bootstrap-select.btn-group .dropdown-menu li a {\n  cursor: pointer;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n}\n.bootstrap-select.btn-group .dropdown-menu li a.opt {\n  position: relative;\n  padding-left: 2.25em;\n}\n.bootstrap-select.btn-group .dropdown-menu li a span.check-mark {\n  display: none;\n}\n.bootstrap-select.btn-group .dropdown-menu li a span.text {\n  display: inline-block;\n}\n.bootstrap-select.btn-group .dropdown-menu li small {\n  padding-left: 0.5em;\n}\n.bootstrap-select.btn-group .dropdown-menu .notify {\n  position: absolute;\n  bottom: 5px;\n  width: 96%;\n  margin: 0 2%;\n  min-height: 26px;\n  padding: 3px 5px;\n  background: #f5f5f5;\n  border: 1px solid #e3e3e3;\n  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.05);\n          box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.05);\n  pointer-events: none;\n  opacity: 0.9;\n  -webkit-box-sizing: border-box;\n     -moz-box-sizing: border-box;\n          box-sizing: border-box;\n}\n.bootstrap-select.btn-group .no-results {\n  padding: 3px;\n  background: #f5f5f5;\n  margin: 0 5px;\n  white-space: nowrap;\n}\n.bootstrap-select.btn-group.fit-width .dropdown-toggle .filter-option {\n  position: static;\n}\n.bootstrap-select.btn-group.fit-width .dropdown-toggle .caret {\n  position: static;\n  top: auto;\n  margin-top: -1px;\n}\n.bootstrap-select.btn-group.show-tick .dropdown-menu li.selected a span.check-mark {\n  position: absolute;\n  display: inline-block;\n  right: 20px;\n  margin-top: 3px;\n  color: black;\n}\n.bootstrap-select.btn-group.show-tick .dropdown-menu li a span.text {\n  margin-right: 34px;\n}\n.bootstrap-select.show-menu-arrow.open > .dropdown-toggle {\n  z-index: 1061;\n}\n.bootstrap-select.show-menu-arrow .dropdown-toggle:before {\n  content: '';\n  border-left: 7px solid transparent;\n  border-right: 7px solid transparent;\n  border-bottom: 7px solid rgba(204, 204, 204, 0.2);\n  position: absolute;\n  bottom: -4px;\n  left: 9px;\n  display: none;\n}\n.bootstrap-select.show-menu-arrow .dropdown-toggle:after {\n  content: '';\n  border-left: 6px solid transparent;\n  border-right: 6px solid transparent;\n  border-bottom: 6px solid white;\n  position: absolute;\n  bottom: -4px;\n  left: 10px;\n  display: none;\n}\n.bootstrap-select.show-menu-arrow.dropup .dropdown-toggle:before {\n  bottom: auto;\n  top: -3px;\n  border-top: 7px solid rgba(204, 204, 204, 0.2);\n  border-bottom: 0;\n}\n.bootstrap-select.show-menu-arrow.dropup .dropdown-toggle:after {\n  bottom: auto;\n  top: -3px;\n  border-top: 6px solid white;\n  border-bottom: 0;\n}\n.bootstrap-select.show-menu-arrow.pull-right .dropdown-toggle:before {\n  right: 12px;\n  left: auto;\n}\n.bootstrap-select.show-menu-arrow.pull-right .dropdown-toggle:after {\n  right: 13px;\n  left: auto;\n}\n.bootstrap-select.show-menu-arrow.open > .dropdown-toggle:before,\n.bootstrap-select.show-menu-arrow.open > .dropdown-toggle:after {\n  display: block;\n}\n.bs-searchbox,\n.bs-actionsbox,\n.bs-donebutton {\n  padding: 4px 8px;\n}\n.bs-actionsbox {\n  width: 100%;\n  -webkit-box-sizing: border-box;\n     -moz-box-sizing: border-box;\n          box-sizing: border-box;\n}\n.bs-actionsbox .btn-group button {\n  width: 50%;\n}\n.bs-donebutton {\n  float: left;\n  width: 100%;\n  -webkit-box-sizing: border-box;\n     -moz-box-sizing: border-box;\n          box-sizing: border-box;\n}\n.bs-donebutton .btn-group button {\n  width: 100%;\n}\n.bs-searchbox + .bs-actionsbox {\n  padding: 0 8px 4px;\n}\n.bs-searchbox .form-control {\n  margin-bottom: 0;\n  width: 100%;\n  float: none;\n}\n\n.bootstrap-select{\n    margin-top: 5px;\n\n    .dropdown-menu.inner{\n        li a{\n            display: block;\n            padding: 8px 16px;\n            clear: both;\n            font-weight: 400;\n            line-height: 1.42857143;\n            color: #333;\n            white-space: nowrap;\n            outline: none;\n            font-size: 14px;\n        }\n\n        li.disabled a{\n            // color: $default-color-opacity;\n\n            &:hover,\n            &:focus{\n                background-color: transparent;\n            }\n        }\n\n        li{\n            a:hover{\n                background-color: #F5F5F5 !important;\n                color: #333333 !important;\n                opacity: 1;\n                text-decoration: none;\n            }\n        }\n    }\n\n    .dropdown-menu.open{\n        overflow: visible !important;\n        display: none;\n        visibility: hidden;\n\n        &.show{\n            display: block;\n            visibility: visible;\n        }\n    }\n\n    .dropdown-menu.open[x-placement=\"top-start\"]{\n        top: 0px !important;\n    }\n}\n\n\n.show .btn-info.dropdown-toggle{\n    background-color: $info-color;\n    border-color: $info-color;\n}\n","/*!\n * Datetimepicker for Bootstrap 3\n * ! version : 4.7.14\n * https://github.com/Eonasdan/bootstrap-datetimepicker/\n */\n$bs-datetimepicker-timepicker-font-size: 1.2em !default;\n$bs-datetimepicker-active-bg: $info-color !default;\n$bs-datetimepicker-active-color: $white-color !default;\n$bs-datetimepicker-border-radius: $border-radius-base;\n$bs-datetimepicker-btn-hover-bg: $light-gray !default;\n$bs-datetimepicker-disabled-color: $medium-gray !default;\n$bs-datetimepicker-alternate-color: $medium-gray !default;\n$bs-datetimepicker-secondary-border-color: #ccc !default;\n$bs-datetimepicker-secondary-border-color-rgba: rgba(0, 0, 0, 0.2) !default;\n$bs-datetimepicker-primary-border-color: white !default;\n$bs-datetimepicker-text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.25) !default;\n\n\n.sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  margin: -1px;\n  padding: 0;\n  overflow: hidden;\n  clip: rect(0,0,0,0);\n  border: 0;\n}\n\n\n.bootstrap-datetimepicker-widget {\n    list-style: none;\n\n\n    &.dropdown-menu {\n        padding: 4px;\n        width: 19em;\n\n        &.timepicker-sbs {\n            @media (min-width: $screen-sm-min) {\n                width: 38em;\n            }\n\n            @media (min-width: $screen-md-min) {\n                width: 38em;\n            }\n\n            @media (min-width: $screen-lg-min) {\n                width: 38em;\n            }\n        }\n\n        &.bottom {\n\n            &:before {\n                border-bottom: 11px solid rgba(0, 0, 0, 0.2);\n                border-left: 11px solid rgba(0, 0, 0, 0);\n                border-right: 11px solid rgba(0, 0, 0, 0);\n                content: \"\";\n                display: inline-block;\n                position: absolute;\n                left: 12px;\n                top: -11px;\n            }\n\n            &:after {\n                border-bottom: 11px solid #FFFFFF;\n                border-left: 11px solid rgba(0, 0, 0, 0);\n                border-right: 11px solid rgba(0, 0, 0, 0);\n                content: \"\";\n                display: inline-block;\n                position: absolute;\n                left: 12px;\n                top: -10px;\n            }\n        }\n\n        &.top {\n            margin-top: auto;\n            margin-bottom: -20px;\n\n            &.open{\n                margin-top: auto;\n                margin-bottom: 5px;\n            }\n\n            &:before {\n                border-top: 11px solid rgba(0, 0, 0, 0.2);\n                border-left: 11px solid rgba(0, 0, 0, 0);\n                border-right: 11px solid rgba(0, 0, 0, 0);\n                border-bottom: none;\n                content: \"\";\n                display: inline-block;\n                position: absolute;\n                left: 12px;\n                bottom: -11px;\n                top: auto;\n            }\n\n            &:after {\n                border-top: 11px solid #FFFFFF;\n                border-left: 11px solid rgba(0, 0, 0, 0);\n                border-right: 11px solid rgba(0, 0, 0, 0);\n                border-bottom: none;\n                content: \"\";\n                display: inline-block;\n                position: absolute;\n                left: 12px;\n                bottom: -10px;\n                top: auto;\n            }\n        }\n\n\n\n        &.pull-right {\n            &:before {\n                left: auto;\n                right: 6px;\n            }\n\n            &:after {\n                left: auto;\n                right: 7px;\n            }\n        }\n\n        &.open{\n            visibility: visible !important;\n            opacity: 1 !important;\n            top: 120px !important;\n            font-size: 14px !important;\n        }\n    }\n\n    .list-unstyled {\n        margin: 0;\n    }\n\n    a[data-action] {\n        padding: 6px 0;\n        border-width: 0;\n    }\n\n    a[data-action]:active {\n        box-shadow: none;\n    }\n\n    .timepicker-hour, .timepicker-minute, .timepicker-second {\n        width: 56px;\n        height: 56px;\n        font-weight: $font-weight-light;\n        font-size: $font-size-h4;\n        margin: 3px;\n        border-radius: 50%;\n    }\n\n    button[data-action] {\n        padding: 6px;\n    }\n\n    .btn[data-action=\"incrementHours\"]::after {\n        @extend .sr-only;\n        content: \"Increment Hours\";\n    }\n\n    .btn[data-action=\"incrementMinutes\"]::after {\n        @extend .sr-only;\n        content: \"Increment Minutes\";\n    }\n\n    .btn[data-action=\"decrementHours\"]::after {\n        @extend .sr-only;\n        content: \"Decrement Hours\";\n    }\n\n    .btn[data-action=\"decrementMinutes\"]::after {\n        @extend .sr-only;\n        content: \"Decrement Minutes\";\n    }\n\n    .btn[data-action=\"showHours\"]::after {\n        @extend .sr-only;\n        content: \"Show Hours\";\n    }\n\n    .btn[data-action=\"showMinutes\"]::after {\n        @extend .sr-only;\n        content: \"Show Minutes\";\n    }\n\n    .btn[data-action=\"togglePeriod\"]::after {\n        @extend .sr-only;\n        content: \"Toggle AM/PM\";\n    }\n\n    .btn[data-action=\"clear\"]::after {\n        @extend .sr-only;\n        content: \"Clear the picker\";\n    }\n\n    .btn[data-action=\"today\"]::after {\n        @extend .sr-only;\n        content: \"Set the date to today\";\n    }\n\n    .picker-switch {\n        text-align: center;\n        border-radius: $bs-datetimepicker-border-radius;\n        font-size: 14px;\n\n        &::after {\n            @extend .sr-only;\n            content: \"Toggle Date and Time Screens\";\n        }\n\n        td {\n            padding: 0;\n            margin: 0;\n            height: auto;\n            width: auto;\n            line-height: inherit;\n\n            span {\n                line-height: 2.5;\n                height: 2.5em;\n                width: 100%;\n                border-radius: $bs-datetimepicker-border-radius;\n                margin: 2px 0px !important;\n            }\n\n            a,\n            a:hover{\n                color: $info-color;\n            }\n        }\n    }\n\n    table {\n        width: 100%;\n        margin: 0;\n\n\n        & td > div,\n        & th > div {\n            // @extend .animation-transition-fast;\n            text-align: center;\n\n        }\n\n\n        & th {\n            // @extend .animation-transition-fast;\n\n            height: 20px;\n            line-height: 20px;\n            width: 20px;\n\n            &.picker-switch {\n                width: 145px;\n            }\n\n            &.disabled,\n            &.disabled:hover {\n                background: none;\n                color: $bs-datetimepicker-disabled-color;\n                cursor: not-allowed;\n            }\n\n            &.prev span,\n            &.next span{\n                border-radius: $bs-datetimepicker-border-radius;\n                height: 27px;\n                width: 27px;\n                line-height: 28px;\n                font-size: 12px;\n                border-radius: 50%;\n                text-align: center;\n\n            }\n\n            &.prev::after {\n                @extend .sr-only;\n                content: \"Previous Month\";\n            }\n\n            &.next::after {\n                @extend .sr-only;\n                content: \"Next Month\";\n            }\n\n            &.dow{\n                text-align: center;\n                border-bottom: 1px solid $light-gray;\n                font-size: $font-size-small;\n                text-transform: uppercase;\n                color: $dark-gray;\n                font-weight: $font-weight-normal;\n                padding-bottom: 5px;\n                padding-top: $padding-default-vertical;\n            }\n        }\n\n        & thead tr:first-child th{\n            cursor: pointer;\n\n            &:hover span,\n            &.picker-switch:hover{\n                background: $bs-datetimepicker-btn-hover-bg;\n            }\n        }\n\n        & td{\n            > div {\n                border-radius: $bs-datetimepicker-border-radius;\n\n                height: 54px;\n                line-height: 54px;\n                width: 54px;\n                text-align: center;\n            }\n\n            &.cw > div {\n                font-size: .8em;\n                height: 20px;\n                line-height: 20px;\n                color: $bs-datetimepicker-alternate-color;\n            }\n\n            &.day > div {\n                height: 30px;\n                line-height: 30px;\n                width: 30px;\n                text-align: center;\n                padding: 0px;\n                border-radius: 50%;\n                margin: 0 auto;\n                z-index: -1;\n                position: relative;\n            }\n\n            &.minute > div,\n            &.hour > div{\n                border-radius: 50%;\n            }\n\n            &.day:hover > div,\n            &.hour:hover > div,\n            &.minute:hover > div,\n            &.second:hover > div {\n                background: $bs-datetimepicker-btn-hover-bg;\n                cursor: pointer;\n            }\n\n            &.old > div,\n            &.new > div{\n                color: $bs-datetimepicker-alternate-color;\n            }\n\n            &.today > div{\n                position: relative;\n\n                &:before {\n                    content: '';\n                    display: inline-block;\n                    border: 0 0 7px 7px solid transparent;\n                    border-bottom-color: $bs-datetimepicker-active-bg;\n                    border-top-color: $bs-datetimepicker-secondary-border-color-rgba;\n                    position: absolute;\n                    bottom: 4px;\n                    right: 4px;\n                }\n            }\n\n            &.active > div,\n            &.active:hover > div {\n                background-color: $info-bg;\n                color: $bs-datetimepicker-active-color;\n\n            }\n\n            &.active.today:before > div{\n                border-bottom-color: #fff;\n            }\n\n            &.disabled > div,\n            &.disabled:hover > div {\n                background: none;\n                color: $bs-datetimepicker-disabled-color;\n                cursor: not-allowed;\n            }\n\n            span {\n                // @extend .animation-transition-fast;\n\n               display: inline-block;\n                width: 56px;\n                height: 56px;\n                line-height: 56px;\n                margin: 3px 3px;\n                cursor: pointer;\n                border-radius: 50%;\n                text-align: center;\n\n                &:hover {\n                    background: $bs-datetimepicker-btn-hover-bg;\n                }\n\n                &.active {\n                    background-color: $bs-datetimepicker-active-bg;\n                    color: $bs-datetimepicker-active-color;\n                }\n\n                &.old {\n                    color: $bs-datetimepicker-alternate-color;\n                }\n\n                &.disabled,\n                &.disabled:hover {\n                    background: none;\n                    color: $bs-datetimepicker-disabled-color;\n                    cursor: not-allowed;\n                }\n            }\n        }\n    }\n\n    .timepicker-picker,\n    .timepicker-hours,\n    .timepicker-minutes{\n        span{\n            border-radius: 50% !important;\n        }\n\n        .table-condensed{\n            td{\n                a{\n                    color: $default-color;\n                    background-color: transparent;\n                }\n            }\n        }\n    }\n\n    &.usetwentyfour {\n        td.hour {\n            height: 27px;\n            line-height: 27px;\n        }\n    }\n}\n\n.input-group.date {\n    & .input-group-addon {\n        cursor: pointer;\n    }\n}\n\n.table-condensed>tbody>tr>td,\n.table-condensed>tbody>tr>th,\n.table-condensed>tfoot>tr>td,\n.table-condensed>tfoot>tr>th,\n.table-condensed>thead>tr>td,\n.table-condensed>thead>tr>th{\n    padding: 1px;\n}\n\n.bootstrap-datetimepicker-widget{\n    opacity: 0;\n    -webkit-transform: translate3d(0px, -10px, 0px);\n    -moz-transform: translate3d(0, -10px, 0);\n    -o-transform: translate3d(0, -10px, 0);\n    -ms-transform: translate3d(0, -10px, 0);\n    transform: translate3d(0px, -10px, 0px);\n\n    &.top{\n        -webkit-transform: translate3d(0px, 0px, 0px);\n        -moz-transform: translate3d(0, 0px, 0);\n        -o-transform: translate3d(0, 0px, 0);\n        -ms-transform: translate3d(0, 0px, 0);\n        transform: translate3d(0px, 0px, 0px);\n    }\n    &.open{\n        opacity: 1;\n        -webkit-transform: translate3d(0, 5px, 0);\n        -moz-transform: translate3d(0, 5px, 0);\n        -o-transform: translate3d(0, 5px, 0);\n        -ms-transform: translate3d(0, 5px, 0);\n        transform: translate3d(0, 5px, 0);\n        transition: transform 0.5s cubic-bezier(0.215, 0.61, 0.355, 1) 0s;\n    }\n}\n\n\n.bootstrap-datetimepicker-widget.dropdown-menu.top{\n    top: auto !important;\n}\n\n.bootstrap-datetimepicker-widget.open.top{\n    -webkit-transform: translate3d(0, -10px, 0);\n    -moz-transform: translate3d(0, -10px, 0);\n    -o-transform: translate3d(0, -10px, 0);\n    -ms-transform: translate3d(0, -10px, 0);\n    transform: translate3d(0, -10px, 0);\n\n    &:before{\n        border-top: 11px solid #DCD9D1;\n        border-left: 11px solid transparent;\n        border-right: 11px solid transparent;\n        content: \"\";\n        display: inline-block;\n        position: absolute;\n        left: 12px;\n        bottom: -12px;\n    }\n    &:after{\n        border-top: 11px solid $white-color;\n        border-left: 11px solid transparent;\n        border-right: 11px solid transparent;\n        content: \"\";\n        display: inline-block;\n        position: absolute;\n        left: 12px;\n        bottom: -11px;\n    }\n}\n","/*! nouislider - 9.1.0 - 2016-12-10 16:00:32 */\n\n\n/* Functional styling;\n * These styles are required for noUiSlider to function.\n * You don't need to change these rules to apply your design.\n */\n.noUi-target,\n.noUi-target * {\n-webkit-touch-callout: none;\n-webkit-tap-highlight-color: rgba(0,0,0,0);\n-webkit-user-select: none;\n-ms-touch-action: none;\n\ttouch-action: none;\n-ms-user-select: none;\n-moz-user-select: none;\n\tuser-select: none;\n-moz-box-sizing: border-box;\n\tbox-sizing: border-box;\n}\n.noUi-target {\n\tposition: relative;\n\tdirection: ltr;\n}\n.noUi-base {\n\twidth: 100%;\n\theight: 100%;\n\tposition: relative;\n\tz-index: 1; /* Fix 401 */\n}\n.noUi-connect {\n\tposition: absolute;\n\tright: 0;\n\ttop: 0;\n\tleft: 0;\n\tbottom: 0;\n}\n.noUi-origin {\n\tposition: absolute;\n\theight: 0;\n\twidth: 0;\n}\n.noUi-handle {\n\tposition: relative;\n\tz-index: 1;\n}\n.noUi-state-tap .noUi-connect,\n.noUi-state-tap .noUi-origin {\n-webkit-transition: top 0.3s, right 0.3s, bottom 0.3s, left 0.3s;\n\ttransition: top 0.3s, right 0.3s, bottom 0.3s, left 0.3s;\n}\n.noUi-state-drag * {\n\tcursor: inherit !important;\n}\n\n/* Painting and performance;\n * Browsers can paint handles in their own layer.\n */\n.noUi-base,\n.noUi-handle {\n\t-webkit-transform: translate3d(0,0,0);\n\ttransform: translate3d(0,0,0);\n}\n\n/* Slider size and handle placement;\n */\n.noUi-horizontal {\n\theight: 4px;\n}\n.noUi-horizontal .noUi-handle {\n    border-radius: 50%;\n\tbackground-color: $white-color;\n\tbox-shadow: 0 1px 13px 0 rgba(0, 0, 0, 0.2);\n\theight:15px;\n\twidth:15px;\n\tcursor:pointer;\n    margin-left: -10px;\n    margin-top: -6px;\n\toutline: none;\n}\n.noUi-vertical {\n\twidth: 18px;\n}\n.noUi-vertical .noUi-handle {\n\twidth: 28px;\n\theight: 34px;\n\tleft: -6px;\n\ttop: -17px;\n}\n\n/* Styling;\n */\n.noUi-target {\n\tbackground-color: rgba(182, 182, 182, .3);\n\tborder-radius: 3px;\n}\n.noUi-connect {\n\tbackground: $default-color;\n    border-radius: 3px;\n-webkit-transition: background 450ms;\n\ttransition: background 450ms;\n}\n\n/* Handles and cursors;\n */\n.noUi-draggable {\n\tcursor: ew-resize;\n}\n.noUi-vertical .noUi-draggable {\n\tcursor: ns-resize;\n}\n.noUi-handle {\n\t// border: 1px solid #D9D9D9;\n\tborder-radius: 3px;\n\tbackground: #FFF;\n\tcursor: default;\n\tbox-shadow: inset 0 0 1px #FFF,\n\t\t\t\tinset 0 1px 7px #EBEBEB,\n\t\t\t\t0 3px 6px -3px #BBB;\n\t-webkit-transition: $general-transition-time $transition-ease;\n    -moz-transition: $general-transition-time $transition-ease;\n    -ms-transition: $general-transition-time $transition-ease;\n    -o-transform: $general-transition-time $transition-ease;\n    transition: $general-transition-time $transition-ease;\n}\n.noUi-active {\n\t-webkit-transform: scale3d(1.5,1.5,1);\n    -moz-transform: scale3d(1.5,1.5,1);\n    -ms-transform: scale3d(1.5,1.5,1);\n    -o-transform: scale3d(1.5,1.5,1);\n    transform: scale3d(1.5,1.5,1);\n}\n\n/* Disabled state;\n */\n\n[disabled] .noUi-connect {\n\tbackground: #B8B8B8;\n}\n[disabled].noUi-target,\n[disabled].noUi-handle,\n[disabled] .noUi-handle {\n\tcursor: not-allowed;\n}\n\n/* Base;\n *\n */\n.noUi-pips,\n.noUi-pips * {\n-moz-box-sizing: border-box;\n\tbox-sizing: border-box;\n}\n.noUi-pips {\n\tposition: absolute;\n\tcolor: #999;\n}\n\n/* Values;\n *\n */\n.noUi-value {\n\tposition: absolute;\n\ttext-align: center;\n}\n.noUi-value-sub {\n\tcolor: #ccc;\n\tfont-size: 10px;\n}\n\n/* Markings;\n *\n */\n.noUi-marker {\n\tposition: absolute;\n\tbackground: #CCC;\n}\n.noUi-marker-sub {\n\tbackground: #AAA;\n}\n.noUi-marker-large {\n\tbackground: #AAA;\n}\n\n/* Horizontal layout;\n *\n */\n.noUi-pips-horizontal {\n\tpadding: 10px 0;\n\theight: 80px;\n\ttop: 100%;\n\tleft: 0;\n\twidth: 100%;\n}\n.noUi-value-horizontal {\n\t-webkit-transform: translate3d(-50%,50%,0);\n\ttransform: translate3d(-50%,50%,0);\n}\n\n.noUi-marker-horizontal.noUi-marker {\n\tmargin-left: -1px;\n\twidth: 2px;\n\theight: 5px;\n}\n.noUi-marker-horizontal.noUi-marker-sub {\n\theight: 10px;\n}\n.noUi-marker-horizontal.noUi-marker-large {\n\theight: 15px;\n}\n\n/* Vertical layout;\n *\n */\n.noUi-pips-vertical {\n\tpadding: 0 10px;\n\theight: 100%;\n\ttop: 0;\n\tleft: 100%;\n}\n.noUi-value-vertical {\n\t-webkit-transform: translate3d(0,50%,0);\n\ttransform: translate3d(0,50%,0);\n\tpadding-left: 25px;\n}\n\n.noUi-marker-vertical.noUi-marker {\n\twidth: 5px;\n\theight: 2px;\n\tmargin-top: -1px;\n}\n.noUi-marker-vertical.noUi-marker-sub {\n\twidth: 10px;\n}\n.noUi-marker-vertical.noUi-marker-large {\n\twidth: 15px;\n}\n\n.noUi-tooltip {\n\tdisplay: block;\n\tposition: absolute;\n\tborder: 1px solid #D9D9D9;\n\tborder-radius: 3px;\n\tbackground: #fff;\n\tcolor: #000;\n\tpadding: 5px;\n\ttext-align: center;\n}\n.noUi-horizontal .noUi-tooltip {\n-webkit-transform: translate(-50%, 0);\n    transform: translate(-50%, 0);\n    left: 50%;\n    bottom: 120%;\n}\n.noUi-vertical .noUi-tooltip {\n-webkit-transform: translate(0, -50%);\n    transform: translate(0, -50%);\n    top: 50%;\n    right: 120%;\n}\n\n\n\n\n\t.slider-neutral{\n\t\t& .noUi-connect,\n        &.noUi-connect{\n            background-color: $white-color;\n        }\n\t}\n\n\t.slider-primary{\n\t\t& .noUi-connect,\n        &.noUi-connect{\n            background-color: $primary-color;\n        }\n\t}\n\n    .slider-info{\n        & .noUi-connect,\n        &.noUi-connect{\n            background-color: $info-color;\n        }\n    }\n    .slider-success{\n        & .noUi-connect,\n        &.noUi-connect{\n            background-color: $success-color;\n        }\n    }\n    .slider-warning{\n        & .noUi-connect,\n        &.noUi-connect{\n            background-color: $warning-color;\n        }\n    }\n    .slider-danger{\n        & .noUi-connect,\n        &.noUi-connect{\n            background-color: $danger-color;\n        }\n    }\n","/*! nouislider - 14.6.3 - 11/19/2020 */\n/* Functional styling;\n * These styles are required for noUiSlider to function.\n * You don't need to change these rules to apply your design.\n */\n.noUi-target,\n.noUi-target * {\n  -webkit-touch-callout: none;\n  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);\n  -webkit-user-select: none;\n  -ms-touch-action: none;\n  touch-action: none;\n  -ms-user-select: none;\n  -moz-user-select: none;\n  user-select: none;\n  -moz-box-sizing: border-box;\n  box-sizing: border-box;\n}\n.noUi-target {\n  position: relative;\n}\n.noUi-base,\n.noUi-connects {\n  width: 100%;\n  height: 100%;\n  position: relative;\n  z-index: 1;\n}\n/* Wrapper for all connect elements.\n */\n.noUi-connects {\n  overflow: hidden;\n  z-index: 0;\n}\n.noUi-connect,\n.noUi-origin {\n  will-change: transform;\n  position: absolute;\n  z-index: 1;\n  top: 0;\n  right: 0;\n  -ms-transform-origin: 0 0;\n  -webkit-transform-origin: 0 0;\n  -webkit-transform-style: preserve-3d;\n  transform-origin: 0 0;\n  transform-style: flat;\n}\n.noUi-connect {\n  height: 100%;\n  width: 100%;\n}\n.noUi-origin {\n  height: 10%;\n  width: 10%;\n}\n/* Offset direction\n */\n.noUi-txt-dir-rtl.noUi-horizontal .noUi-origin {\n  left: 0;\n  right: auto;\n}\n/* Give origins 0 height/width so they don't interfere with clicking the\n * connect elements.\n */\n.noUi-vertical .noUi-origin {\n  width: 0;\n}\n.noUi-horizontal .noUi-origin {\n  height: 0;\n}\n.noUi-handle {\n  -webkit-backface-visibility: hidden;\n  backface-visibility: hidden;\n  position: absolute;\n}\n.noUi-touch-area {\n  height: 100%;\n  width: 100%;\n}\n.noUi-state-tap .noUi-connect,\n.noUi-state-tap .noUi-origin {\n  -webkit-transition: transform 0.3s;\n  transition: transform 0.3s;\n}\n.noUi-state-drag * {\n  cursor: inherit !important;\n}\n/* Slider size and handle placement;\n */\n.noUi-horizontal {\n  height: 4px;\n}\n.noUi-horizontal .noUi-handle {\n  width: 15px;\n  height: 15px;\n  right: -10px;\n  top: 0px;\n}\n.noUi-vertical {\n  width: 18px;\n}\n.noUi-vertical .noUi-handle {\n  width: 15px;\n  height: 15px;\n  right: -6px;\n  top: -17px;\n}\n.noUi-txt-dir-rtl.noUi-horizontal .noUi-handle {\n  left: -17px;\n  right: auto;\n}\n/* Styling;\n * Giving the connect element a border radius causes issues with using transform: scale\n */\n.noUi-target {\n  background: #FAFAFA;\n  border-radius: 4px;\n}\n.noUi-connects {\n  border-radius: 3px;\n}\n.noUi-connect {\n  background: #3FB8AF;\n}\n/* Handles and cursors;\n */\n.noUi-draggable {\n  cursor: ew-resize;\n}\n.noUi-vertical .noUi-draggable {\n  cursor: ns-resize;\n}\n.noUi-handle {\n  box-shadow: 0 1px 13px 0 rgba(0, 0, 0, 0.2);\n  border-radius: 50%;\n  background: #FFF;\n  cursor: default;\n  transition: $general-transition-time $transition-ease;\n}\n/* Handle stripes;\n */\n/* Disabled state;\n */\n[disabled] .noUi-connect {\n  background: #B8B8B8;\n}\n[disabled].noUi-target,\n[disabled].noUi-handle,\n[disabled] .noUi-handle {\n  cursor: not-allowed;\n}\n/* Base;\n *\n */\n.noUi-pips,\n.noUi-pips * {\n  -moz-box-sizing: border-box;\n  box-sizing: border-box;\n}\n.noUi-pips {\n  position: absolute;\n  color: #999;\n}\n/* Values;\n *\n */\n.noUi-value {\n  position: absolute;\n  white-space: nowrap;\n  text-align: center;\n}\n.noUi-value-sub {\n  color: #ccc;\n  font-size: 10px;\n}\n/* Markings;\n *\n */\n.noUi-marker {\n  position: absolute;\n  background: #CCC;\n}\n.noUi-marker-sub {\n  background: #AAA;\n}\n.noUi-marker-large {\n  background: #AAA;\n}\n/* Horizontal layout;\n *\n */\n.noUi-pips-horizontal {\n  padding: 10px 0;\n  height: 80px;\n  top: 100%;\n  left: 0;\n  width: 100%;\n}\n.noUi-value-horizontal {\n  -webkit-transform: translate(-50%, 50%);\n  transform: translate(-50%, 50%);\n}\n.noUi-rtl .noUi-value-horizontal {\n  -webkit-transform: translate(50%, 50%);\n  transform: translate(50%, 50%);\n}\n.noUi-marker-horizontal.noUi-marker {\n  margin-left: -1px;\n  width: 2px;\n  height: 5px;\n}\n.noUi-marker-horizontal.noUi-marker-sub {\n  height: 10px;\n}\n.noUi-marker-horizontal.noUi-marker-large {\n  height: 15px;\n}\n/* Vertical layout;\n *\n */\n.noUi-pips-vertical {\n  padding: 0 10px;\n  height: 100%;\n  top: 0;\n  left: 100%;\n}\n.noUi-value-vertical {\n  -webkit-transform: translate(0, -50%);\n  transform: translate(0, -50%);\n  padding-left: 25px;\n}\n.noUi-rtl .noUi-value-vertical {\n  -webkit-transform: translate(0, 50%);\n  transform: translate(0, 50%);\n}\n.noUi-marker-vertical.noUi-marker {\n  width: 5px;\n  height: 2px;\n  margin-top: -1px;\n}\n.noUi-marker-vertical.noUi-marker-sub {\n  width: 10px;\n}\n.noUi-marker-vertical.noUi-marker-large {\n  width: 15px;\n}\n.noUi-tooltip {\n  display: block;\n  position: absolute;\n  border: 1px solid #D9D9D9;\n  border-radius: 3px;\n  background: #fff;\n  color: #000;\n  padding: 5px;\n  text-align: center;\n  white-space: nowrap;\n}\n.noUi-horizontal .noUi-tooltip {\n  -webkit-transform: translate(-50%, 0);\n  transform: translate(-50%, 0);\n  left: 50%;\n  bottom: 120%;\n}\n.noUi-vertical .noUi-tooltip {\n  -webkit-transform: translate(0, -50%);\n  transform: translate(0, -50%);\n  top: 50%;\n  right: 120%;\n}\n.noUi-horizontal .noUi-origin > .noUi-tooltip {\n  -webkit-transform: translate(50%, 0);\n  transform: translate(50%, 0);\n  left: auto;\n  bottom: 10px;\n}\n.noUi-vertical .noUi-origin > .noUi-tooltip {\n  -webkit-transform: translate(0, -18px);\n  transform: translate(0, -18px);\n  top: auto;\n  right: 28px;\n}\n.noUi-active {\n  transform: scale3d(1.5,1.5,1);\n}\n.slider-primary {\n  .noUi-connect{\n    background: $color-blue;\n  }\n}\n.slider-info {\n  .noUi-connect{\n    background: $color-azure;\n  }\n}\n.slider-success {\n  .noUi-connect {\n    background: $color-green;\n  }\n}\n.slider-warning {\n  .noUi-connect {\n    background: $color-orange;\n  }\n}\n.slider-danger {\n  .noUi-connect {\n    background: $color-red;\n  }\n}\n",".rbc-btn {\n  color: inherit;\n  font: inherit;\n  margin: 0;\n}\nbutton.rbc-btn {\n  overflow: visible;\n  text-transform: none;\n  -webkit-appearance: button;\n  cursor: pointer;\n}\nbutton[disabled].rbc-btn {\n  cursor: not-allowed;\n}\nbutton.rbc-input::-moz-focus-inner {\n  border: 0;\n  padding: 0;\n}\n.rbc-calendar {\n  box-sizing: border-box;\n  height: 100%;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-align-items: stretch;\n  -ms-flex-align: stretch;\n  align-items: stretch;\n}\n.rbc-calendar *,\n.rbc-calendar *:before,\n.rbc-calendar *:after {\n  box-sizing: inherit;\n}\n.rbc-abs-full,\n.rbc-row-bg {\n  overflow: hidden;\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n}\n.rbc-ellipsis,\n.rbc-event-label,\n.rbc-row-segment .rbc-event-content,\n.rbc-show-more {\n  display: block;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.rbc-rtl {\n  direction: rtl;\n}\n.rbc-off-range {\n  color: #333333;\n  opacity: 0.3;\n}\n// .rbc-off-range-bg {\n//   background: #e5e5e5;\n// }\n.rbc-header {\n  overflow: hidden;\n  -webkit-flex: 1 0 0%;\n  -ms-flex: 1 0 0%;\n  flex: 1 0 0%;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  padding: 0 3px;\n  text-align: right;\n  vertical-align: middle;\n  font-size: .875em;\n  min-height: 0;\n  border-bottom: 1px solid #DDD;\n  color: #999999;\n  font-weight: 400;\n  &:last-child{\n    span{\n      padding-right: 15px;\n    }\n  }\n}\n.rbc-header > a,\n.rbc-header > a:active,\n.rbc-header > a:visited {\n  color: inherit;\n  text-decoration: none;\n}\n.rbc-row-content {\n  position: relative;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  -webkit-user-select: none;\n  z-index: 4;\n  min-height: 153px;\n}\n.rbc-toolbar {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-align-items: center;\n  -ms-flex-align: center;\n  align-items: center;\n  margin-bottom: 10px;\n  font-size: 16px;\n  padding-top: 20px;\n  padding-left: 20px;\n  padding-right: 20px;\n}\n.rbc-toolbar .rbc-toolbar-label {\n  -webkit-flex-grow: 1;\n  -ms-flex-positive: 1;\n  flex-grow: 1;\n  padding: 0 10px;\n  text-align: center;\n  font-family: inherit;\n  line-height: 1.5em;\n  color: inherit;\n  font-weight: 300;\n  margin: 0;\n  font-size: 2.25em;\n}\n.rbc-toolbar button {\n  display: inline-block;\n  margin: 0;\n  text-align: center;\n  vertical-align: middle;\n  background: none;\n  background-image: none;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  line-height: normal;\n  white-space: nowrap;\n  border-width: 1px;\n  background-color: transparent;\n  font-weight: 400;\n  padding: 8px 16px;\n  border-color: #888;\n  color: #888;\n  font-family: inherit;\n  font-size: inherit;\n  font: inherit;\n}\n.rbc-toolbar button:focus {\n  outline: none;\n}\n.rbc-toolbar button.rbc-active {\n  &,\n  &:hover {\n    border-color: #888;\n    background-color: #888;\n    color: #fff;\n  }\n}\n.rbc-toolbar button:hover {\n  color: #373a3c;\n  background-color: #e6e6e6;\n  border-color: #adadad;\n}\n.rbc-btn-group {\n  display: inline-block;\n  white-space: nowrap;\n}\n.rbc-btn-group > button:first-child:not(:last-child) {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.rbc-btn-group > button:last-child:not(:first-child) {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.rbc-rtl .rbc-btn-group > button:first-child:not(:last-child) {\n  border-radius: 4px;\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.rbc-rtl .rbc-btn-group > button:last-child:not(:first-child) {\n  border-radius: 4px;\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.rbc-btn-group > button:not(:first-child):not(:last-child) {\n  border-radius: 0;\n}\n.rbc-btn-group button + button {\n  margin-left: -1px;\n}\n.rbc-rtl .rbc-btn-group button + button {\n  margin-left: 0;\n  margin-right: -1px;\n}\n.rbc-btn-group + .rbc-btn-group,\n.rbc-btn-group + button {\n  margin-left: 10px;\n}\n\n.rbc-slot-selecting .rbc-event {\n  cursor: inherit;\n  pointer-events: none;\n}\n.rbc-event.rbc-selected {\n  background-color: #265985;\n}\n.rbc-event-label {\n  font-size: 80%;\n}\n.rbc-event-overlaps {\n  box-shadow: -1px 1px 5px 0px rgba(51, 51, 51, 0.5);\n}\n.rbc-event-continues-prior {\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n}\n.rbc-event-continues-after {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.rbc-event-continues-earlier {\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n.rbc-event-continues-later {\n  border-bottom-left-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.rbc-event-continues-day-after {\n  border-bottom-left-radius: 0;\n  border-bottom-right-radius: 0;\n}\n.rbc-event-continues-day-prior {\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n.rbc-row {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n}\n.rbc-row-segment {\n  padding: 2px 6px 1px;\n}\n.rbc-selected-cell {\n  background-color: rgba(0, 0, 0, 0.1);\n}\n.rbc-show-more {\n  background-color: rgba(255, 255, 255, 0.3);\n  z-index: 4;\n  font-weight: bold;\n  font-size: 85%;\n  height: auto;\n  line-height: normal;\n  white-space: nowrap;\n}\n.rbc-month-view {\n  position: relative;\n  border: 1px solid #DDD;\n  border-bottom: 0px;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-flex: 1 0 0;\n  -ms-flex: 1 0 0px;\n  flex: 1 0 0;\n  width: 100%;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  -webkit-user-select: none;\n  height: 100%;\n  border-left: none;\n  border-right: none;\n}\n.rbc-month-view {\n  border-top: none;\n}\n.rbc-month-header {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n}\n\n.rbc-month-row {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  position: relative;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-flex: 1 0 0;\n  -ms-flex: 1 0 0px;\n  flex: 1 0 0;\n  // -webkit-flex-basis: 0px;\n  -ms-flex-preferred-size: 0px;\n  // flex-basis: 0px;\n  overflow: hidden;\n  height: 100%;\n}\n.rbc-month-row + .rbc-month-row {\n  border-top: 1px solid #DDD;\n}\n.rbc-date-cell {\n  flex: 1 1;\n  min-width: 0;\n  padding-left: 5px;\n  text-align: left;\n}\n.rbc-date-cell.rbc-now {\n  font-weight: bold;\n}\n.rbc-date-cell > a,\n.rbc-date-cell > a:active,\n.rbc-date-cell > a:visited {\n  color: inherit;\n  text-decoration: none;\n}\n.rbc-row-bg {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-flex: 1 0 0;\n  -ms-flex: 1 0 0px;\n  flex: 1 0 0;\n  overflow: hidden;\n}\n.rbc-day-bg {\n  -webkit-flex: 1 0 0%;\n  -ms-flex: 1 0 0%;\n  flex: 1 0 0%;\n}\n.rbc-day-bg + .rbc-day-bg {\n  border-left: 1px solid #DDD;\n}\n.rbc-rtl .rbc-day-bg + .rbc-day-bg {\n  border-left-width: 0;\n  border-right: 1px solid #DDD;\n}\n.rbc-overlay {\n  position: absolute;\n  z-index: 5;\n  border: 1px solid #e5e5e5;\n  background-color: #fff;\n  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.25);\n  padding: 10px;\n}\n.rbc-overlay > * + * {\n  margin-top: 1px;\n}\n.rbc-overlay-header {\n  border-bottom: 1px solid #e5e5e5;\n  margin: -10px -10px 5px -10px;\n  padding: 2px 10px;\n}\n.rbc-agenda-view {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-flex: 1 0 0;\n  -ms-flex: 1 0 0px;\n  flex: 1 0 0;\n  overflow: auto;\n}\n.rbc-agenda-view table.rbc-agenda-table {\n  width: 100%;\n  border: 1px solid #DDD;\n  border-spacing: 0;\n  border-collapse: collapse;\n}\n.rbc-agenda-view table.rbc-agenda-table tbody > tr > td {\n  padding: 5px 10px;\n  vertical-align: top;\n}\n.rbc-agenda-view table.rbc-agenda-table .rbc-agenda-time-cell {\n  padding-left: 15px;\n  padding-right: 15px;\n  text-transform: lowercase;\n}\n.rbc-agenda-view table.rbc-agenda-table tbody > tr > td + td {\n  border-left: 1px solid #DDD;\n}\n.rbc-rtl .rbc-agenda-view table.rbc-agenda-table tbody > tr > td + td {\n  border-left-width: 0;\n  border-right: 1px solid #DDD;\n}\n.rbc-agenda-view table.rbc-agenda-table tbody > tr + tr {\n  border-top: 1px solid #DDD;\n}\n.rbc-agenda-view table.rbc-agenda-table thead > tr > th {\n  padding: 3px 5px;\n  text-align: left;\n  border-bottom: 1px solid #DDD;\n}\n.rbc-rtl .rbc-agenda-view table.rbc-agenda-table thead > tr > th {\n  text-align: right;\n}\n.rbc-agenda-time-cell {\n  text-transform: lowercase;\n}\n.rbc-agenda-time-cell .rbc-continues-after:after {\n  content: ' »';\n}\n.rbc-agenda-time-cell .rbc-continues-prior:before {\n  content: '« ';\n}\n.rbc-agenda-date-cell,\n.rbc-agenda-time-cell {\n  white-space: nowrap;\n}\n.rbc-agenda-event-cell {\n  width: 100%;\n}\n.rbc-time-column {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  min-height: 100%;\n}\n.rbc-time-column .rbc-timeslot-group {\n  -webkit-flex: 1;\n  -ms-flex: 1;\n  flex: 1;\n}\n.rbc-timeslot-group {\n  border-bottom: 1px solid #DDD;\n  min-height: 40px;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-flex-flow: column nowrap;\n  -ms-flex-flow: column nowrap;\n  flex-flow: column nowrap;\n}\n.rbc-time-gutter,\n.rbc-header-gutter {\n  -webkit-flex: none;\n  -ms-flex: none;\n  flex: none;\n}\n.rbc-label {\n  padding: 0 5px;\n}\n.rbc-day-slot {\n  position: relative;\n}\n.rbc-day-slot .rbc-events-container {\n  bottom: 0;\n  left: 0;\n  position: absolute;\n  right: 10px;\n  top: 0;\n}\n.rbc-day-slot .rbc-events-container.rbc-is-rtl {\n  left: 10px;\n  right: 0;\n}\n.rbc-day-slot .rbc-event {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  max-height: 100%;\n  min-height: 20px;\n  -webkit-flex-flow: column wrap;\n  -ms-flex-flow: column wrap;\n  flex-flow: column wrap;\n  -webkit-align-items: flex-start;\n  -ms-flex-align: start;\n  align-items: flex-start;\n  overflow: hidden;\n  position: absolute;\n}\n.rbc-day-slot .rbc-event-label {\n  -webkit-flex: none;\n  -ms-flex: none;\n  flex: none;\n  padding-right: 5px;\n  width: auto;\n  font-weight: bold;\n  -webkit-box-sizing: content-box;\n  -moz-box-sizing: content-box;\n  box-sizing: content-box;\n  color: #fff;\n  white-space: nowrap;\n}\n.rbc-day-slot .rbc-event-content {\n  width: 100%;\n  -webkit-flex: 1 1 0;\n  -ms-flex: 1 1 0px;\n  flex: 1 1 0;\n  word-wrap: break-word;\n  line-height: 1;\n  height: 100%;\n  min-height: 1em;\n}\n.rbc-day-slot .rbc-time-slot + .rbc-time-slot{\n  border-top: 1px dotted #ddd;\n}\n.rbc-time-slot {\n  -webkit-flex: 1 0 0;\n  -ms-flex: 1 0 0px;\n  flex: 1 0 0;\n}\n.rbc-time-slot.rbc-now {\n  font-weight: bold;\n}\n.rbc-day-header {\n  text-align: center;\n}\n.rbc-slot-selection {\n  z-index: 10;\n  position: absolute;\n  background-color: rgba(0, 0, 0, 0.5);\n  color: white;\n  font-size: 75%;\n  width: 100%;\n  padding: 3px;\n}\n.rbc-slot-selecting {\n  cursor: move;\n}\n.rbc-time-view {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-flex: 1;\n  -ms-flex: 1;\n  flex: 1;\n  width: 100%;\n  border: 1px solid #DDD;\n  min-height: 0;\n  border-left: none;\n  border-right: none;\n  border-top: none;\n}\n.rbc-time-view .rbc-time-gutter {\n  white-space: nowrap;\n}\n.rbc-time-view .rbc-allday-cell {\n  box-sizing: content-box;\n  width: 100%;\n  position: relative;\n}\n.rbc-time-view .rbc-allday-events {\n  position: relative;\n  z-index: 4;\n}\n.rbc-time-view .rbc-row {\n  box-sizing: border-box;\n  min-height: 20px;\n}\n.rbc-time-header {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-flex: 0 0 auto;\n  -ms-flex: 0 0 auto;\n  flex: 0 0 auto;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n}\n.rbc-time-header.rbc-overflowing {\n  border-right: 1px solid #DDD;\n}\n.rbc-rtl .rbc-time-header.rbc-overflowing {\n  border-right-width: 0;\n  border-left: 1px solid #DDD;\n}\n.rbc-time-header > .rbc-row:first-child {\n  border-bottom: 1px solid #DDD;\n}\n.rbc-time-header > .rbc-row.rbc-row-resource {\n  border-bottom: 1px solid #DDD;\n}\n.rbc-time-header-content {\n  -webkit-flex: 1;\n  -ms-flex: 1;\n  flex: 1;\n  min-width: 0;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  border-left: 1px solid #DDD;\n}\n.rbc-rtl .rbc-time-header-content {\n  border-left-width: 0;\n  border-right: 1px solid #DDD;\n}\n.rbc-time-content {\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-flex: 1 0 0%;\n  -ms-flex: 1 0 0%;\n  flex: 1 0 0%;\n  -webkit-align-items: flex-start;\n  -ms-flex-align: start;\n  align-items: flex-start;\n  width: 100%;\n  border-top: 2px solid #DDD;\n  overflow-y: auto;\n  position: relative;\n}\n.rbc-time-content > .rbc-time-gutter {\n  -webkit-flex: none;\n  -ms-flex: none;\n  flex: none;\n}\n.rbc-time-content > * + * > * {\n  border-left: 1px solid #DDD;\n}\n.rbc-rtl .rbc-time-content > * + * > * {\n  border-left-width: 0;\n  border-right: 1px solid #DDD;\n}\n.rbc-time-content > .rbc-day-slot {\n  width: 100%;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  -webkit-user-select: none;\n}\n.rbc-current-time-indicator {\n  position: absolute;\n  z-index: 3;\n  height: 1px;\n  background-color: #74ad31;\n  pointer-events: none;\n}\n.rbc-event {\n  width: 100%;\n  position: relative; /* for resize handle and other inner positioning */\n  display: block; /* make the <a> tag block */\n  font-size: .85em;\n  border-radius: 2px;\n  padding: 0;\n  background-color: $light-blue; /* default BACKGROUND color */\n  // @include shadow-big-color($brand-success);\n  font-weight: normal; /* undo jqui's ui-widget-header bold */\n  text-align: left;\n  border: none;\n  padding-bottom: 1px;\n  line-height: 1.2;\n\n  &.rbc-event-azure{\n    background-color: $light-azure;\n  }\n  &.rbc-event-green{\n    background-color: $light-green;\n  }\n  &.rbc-event-orange{\n    background-color: $light-orange;\n  }\n  &.rbc-event-red{\n    background-color: $light-red;\n  }\n\n  .rbc-event-content{\n    position: relative;\n    z-index: 2;\n    white-space: nowrap;\n    overflow: hidden;\n    color: inherit;\n    padding: 0 5px;\n  }\n}\n.rbc-day-slot .rbc-event {\n  display: block !important;\n  height: unset !important;\n  max-height: unset !important;\n}\n\n.rbc-today{\n  background-color: $smoke-bg;\n}\n@media screen and (max-width: 1373px){\n  .rbc-toolbar {\n    display: block;\n    .rbc-btn-group{\n      display: block;\n      text-align: center;\n    }\n    .rbc-toolbar-label{\n      display: block;\n      flex-grow: unset;\n      padding: 0;\n    }\n  }\n}\n",".sweet-alert {\n  margin: auto!important;\n  top: unset!important;\n  left: unset!important;\n}\n",".card-wizard{\n  min-height: 410px;\n  // box-shadow: $box-shadow;\n  @include transition($general-transition-time, $transition-linear);\n  &[data-color=\"primary\"]{\n    @include set-wizard-color($primary-color);\n  }\n  &[data-color=\"green\"]{\n    @include set-wizard-color($success-color);\n  }\n  &[data-color=\"orange\"]{\n    @include set-wizard-color($warning-color);\n  }\n  &[data-color=\"red\"]{\n    @include set-wizard-color($danger-color);\n  }\n  &[data-color=\"blue\"]{\n    @include set-wizard-color($info-color);\n  }\n\n  .card-header {\n    padding: 15px 0 !important;\n    padding-bottom: 40px;\n    background-color: transparent;\n    .card-title{\n      margin-bottom: 0px;\n      & + .description{\n        color: $dark-gray;\n        font-size: 0.875rem;\n        font-weight: 400;\n        margin: 0px;\n        margin-bottom: 40px;\n      }\n    }\n  }\n\n  .nav-pills .nav-item .nav-link{\n    padding: .75rem;\n  }\n\n  .nav-pills .nav-item .nav-link,\n  .nav-pills .nav-item .nav-link.active,\n  .nav-pills .nav-item .nav-link:hover,\n  .nav-pills .nav-item .nav-link:focus,\n  .nav-pills .nav-item .nav-link.active:focus,\n  .nav-pills .nav-item .nav-link.active:hover{\n    background-color: transparent;\n    box-shadow: none;\n  }\n\n  .picture-container{\n    position: relative;\n    cursor: pointer;\n    text-align: center;\n  }\n\n  .wizard-navigation{\n    position: relative;\n\n    .nav-link{\n      display: flex;\n      align-items: center;\n      -ms-flex-pack: center;\n      justify-content: center;\n    }\n  }\n\n  .wizard-navigation .nav-link i,\n  .moving-tab i{\n    display: inline-block;\n    font-size: 19px;\n    line-height: 18px;\n    margin-right: 6px;\n    padding: 0;\n    vertical-align: bottom;\n  }\n  .moving-tab i{\n    margin-right: 9px;\n  }\n\n  .picture{\n    width: 106px;\n    height: 106px;\n    background-color: #999999;\n    border: 1px solid $light-gray;\n    color: #FFFFFF;\n    border-radius: 50%;\n    margin: 5px auto;\n    overflow: hidden;\n    transition: all 0.2s;\n    -webkit-transition: all 0.2s;\n\n    &:hover{\n      border-color: #2ca8ff;\n    }\n  }\n\n  .moving-tab{\n    position: absolute;\n    text-align: center;\n    padding: .75rem;\n    font-size: 1rem;\n    text-transform: uppercase;\n    -webkit-font-smoothing: subpixel-antialiased;\n    top: 0px;\n    left: 0px;\n    background-color: $default-color;\n    // box-shadow: $box-shadow;\n    color: $white-color !important;\n    cursor: pointer;\n    font-weight: 400;\n    line-height: 18px;\n  }\n\n  .picture input[type=\"file\"] {\n    cursor: pointer;\n    display: block;\n    height: 100%;\n    left: 0;\n    opacity: 0 !important;\n    position: absolute;\n    top: 0;\n    width: 100%;\n  }\n\n  .picture-src{\n    width: 100%;\n  }\n\n  .tab-content{\n    min-height: 355px;\n    padding: 20px 0;\n  }\n\n  .wizard-footer{\n    padding: 0 15px;\n\n    .checkbox{\n      margin-top: 16px;\n    }\n  }\n\n  .disabled{\n    display: none;\n  }\n\n  .wizard-header{\n    text-align: center;\n    padding: 25px 0 35px;\n\n    h5{\n      margin: 5px 0 0;\n    }\n  }\n\n  .nav-pills > li{\n    text-align: center;\n  }\n\n  .btn{\n    text-transform: uppercase;\n  }\n\n  .info-text{\n    text-align: center;\n    font-weight: 300;\n    margin: 10px 0 30px;\n  }\n\n  .choice{\n    text-align: center;\n    cursor: pointer;\n    margin-top: 20px;\n\n    &[disabled]{\n      pointer-events: none;\n      cursor: not-allowed;\n      opacity: .5;\n    }\n\n    .icon{\n      text-align: center;\n      vertical-align: middle;\n      height: 116px;\n      width: 116px;\n      border-radius: 50%;\n      color: $default-color;\n      margin: 0 auto 20px;\n      border: 1px solid $light-gray;\n      transition: all 0.2s;\n      -webkit-transition: all 0.2s;\n    }\n\n    i{\n      font-size: 30px;\n      line-height: 116px;\n      position: absolute;\n      left: 0;\n      right: 0;\n    }\n\n    &:hover,\n    &.active{\n      .icon{\n        border-color: #2ca8ff;\n      }\n    }\n\n    input[type=\"radio\"],\n    input[type=\"checkbox\"]{\n      position: absolute;\n      left: -10000px;\n      z-index: -1;\n    }\n  }\n\n  .btn-finish{\n    display: none;\n  }\n\n  .card-title + .description{\n    font-size: $font-size-base + 3;\n    margin-bottom: 32px;\n  }\n\n  .wizard-title{\n    margin: 0;\n  }\n\n  .nav-pills{\n    background-color: $dark-gray;\n\n    > li + li {\n      margin-left: 0;\n    }\n\n    > li > a {\n      border: 0 !important;\n      border-radius: 0 ;\n      line-height: 18px;\n      text-transform: uppercase;\n      font-size: 1rem;\n      font-weight: 400;\n      min-width: 100px;\n      text-align: center;\n      color: $white-color !important;\n    }\n\n    > li.active > a,\n    > li.active > a:hover,\n    > li.active > a:focus,\n    > li > a:hover,\n    > li > a:focus{\n      background-color: inherit;\n      box-shadow: none;\n    }\n\n    > li i{\n      display: block;\n      font-size: 30px;\n      padding: 15px 0;\n    }\n  }\n\n  .form-group.select-wizard {\n    margin-top: 15px;\n  }\n\n  .dropdown.show,\n  .dropup.show {\n    .dropdown-menu {\n      @include transform-translate-y(0px);\n    }\n  }\n}\n","@mixin set-wizard-color($color) {\n  .moving-tab{\n    background-color: $color;\n  }\n\n  .picture{\n    &:hover{\n      border-color: $color;\n    }\n  }\n\n  .choice{\n    &:hover,\n    &.active{\n      .icon{\n        border-color: $color;\n        color: $color;\n      }\n    }\n  }\n\n  .checkbox input[type=checkbox]:checked + .checkbox-material{\n    .check{\n      background-color: $color;\n    }\n  }\n\n  .radio input[type=radio]:checked ~ .check {\n    background-color: $color;\n  }\n\n  .radio input[type=radio]:checked ~ .circle {\n    border-color: $color;\n  }\n}\n","/*!\n* https://github.com/YouCanBookMe/react-datetime\n*/\n\n.rdt {\n  position: relative;\n  .form-control:read-only{\n    background-color: #fff;\n    cursor: pointer\n  }\n  .rdtPicker {\n    -webkit-transition: all 150ms linear;\n    -moz-transition: all 150ms linear;\n    -o-transition: all 150ms linear;\n    -ms-transition: all 150ms linear;\n    transition: all 150ms linear;\n    margin-top: -20px;\n    visibility: hidden;\n    display: block;\n    opacity: 0;\n  }\n  &.rdtOpen {\n    .rdtPicker {\n      opacity: 1;\n      visibility: visible;\n      margin-top: 0;\n    }\n  }\n}\n.rdtPicker {\n  display: none;\n  position: absolute;\n  width: 260px;\n  padding: 4px;\n  margin-top: 1px;\n  z-index: 99999 !important;\n  background: #fff;\n  border: 1px solid rgba(0, 0, 0, 0.15);\n  border-radius: 10px;\n  -webkit-box-shadow: 1px 2px 3px rgba(0, 0, 0, 0.125);\n  box-shadow: 1px 2px 3px rgba(0, 0, 0, 0.125);\n  -webkit-background-clip: padding-box;\n  background-clip: padding-box;\n  min-width: 160px;\n  \n  &:before {\n    border-bottom: 11px solid rgba(0, 0, 0, 0.2);\n    border-left: 11px solid transparent;\n    border-right: 11px solid transparent;\n    content: \"\";\n    display: inline-block;\n    position: absolute;\n    left: 12px;\n    top: -11px;\n  }\n  &:after {\n    border-bottom: 11px solid #ffffff;\n    border-left: 11px solid transparent;\n    border-right: 11px solid transparent;\n    content: \"\";\n    display: inline-block;\n    position: absolute;\n    left: 12px;\n    top: -10px;\n  }\n}\n\n.rdtOpen .rdtPicker {\n  display: block;\n  top: 49px;\n}\n.rdtStatic .rdtPicker {\n  box-shadow: none;\n  position: static;\n}\n\n.rdtPicker .rdtTimeToggle {\n  text-align: center;\n  padding: 5px;\n  border-radius: 4px;\n}\n\n.rdtPicker table {\n  width: 100%;\n  margin: 0;\n  border-color: $white-color !important;\n}\n.rdtPicker td,\n.rdtPicker th {\n  text-align: center;\n  padding: 1px;\n}\n.rdtPicker td {\n  cursor: pointer;\n}\n.rdtDay {\n  height: 30px;\n  line-height: 33px;\n  width: 30px;\n  text-align: center;\n  padding: 0px;\n  border-radius: 50%;\n  &.rdtToday.rdtActive,\n  &.rdtActive,\n  &.rdtActive:hover {\n    background-color: $color-azure !important;\n    color: $white-color;\n  }\n}\n.rdtDays {\n  tr {\n    .dow {\n      text-align: center;\n      border-bottom: 1px solid #e3e3e3;\n      font-size: 12px;\n      text-transform: uppercase;\n      color: #9a9a9a;\n      font-weight: 400;\n      padding-bottom: 5px;\n      padding-top: 10px;\n    }\n    .rdtOld,\n    .rdtNew {\n      color: $medium-gray;\n    }\n  }\n}\n\n.rdtPicker td.rdtDay:hover,\n.rdtPicker td.rdtHour:hover,\n.rdtPicker td.rdtMinute:hover,\n.rdtPicker td.rdtSecond:hover,\n.rdtPicker .rdtTimeToggle:hover {\n  background: #eeeeee;\n  cursor: pointer;\n}\n.rdtPicker td.rdtToday {\n  position: relative;\n}\n.rdtPicker td.rdtActive.rdtToday:before {\n  border-bottom-color: #fff;\n}\n.rdtPicker td.rdtDisabled,\n.rdtPicker td.rdtDisabled:hover {\n  background: none;\n  color: #999999;\n  cursor: not-allowed;\n}\n\n.rdtPicker td span.rdtOld {\n  color: #999999;\n}\n.rdtPicker td span.rdtDisabled,\n.rdtPicker td span.rdtDisabled:hover {\n  background: none;\n  color: #999999;\n  cursor: not-allowed;\n}\n.rdtPicker .dow {\n  width: 14.2857%;\n  border-bottom: none;\n}\n.rdtPicker th.rdtSwitch {\n  width: 50px;\n  padding: 5px;\n  border-radius: 4px;\n}\n.rdtPicker th.rdtNext,\n.rdtPicker th.rdtPrev {\n  font-size: 21px;\n  vertical-align: top;\n  border-radius: 50%;\n  line-height: 33px;\n}\n\n.rdtPrev span,\n.rdtNext span {\n  display: block;\n  -webkit-touch-callout: none; /* iOS Safari */\n  -webkit-user-select: none; /* Chrome/Safari/Opera */\n  -khtml-user-select: none; /* Konqueror */\n  -moz-user-select: none; /* Firefox */\n  -ms-user-select: none; /* Internet Explorer/Edge */\n  user-select: none;\n}\n\n.rdtPicker th.rdtDisabled,\n.rdtPicker th.rdtDisabled:hover {\n  background: none;\n  color: #999999;\n  cursor: not-allowed;\n}\n.rdtPicker thead tr:first-child th {\n  cursor: pointer;\n}\n.rdtPicker thead tr:first-child th:hover {\n  background: #eeeeee;\n}\n\n.rdtPicker button {\n  border: none;\n  background: none;\n  cursor: pointer;\n}\n.rdtPicker button:hover {\n  background-color: #eee;\n}\n\n.rdtPicker thead button {\n  width: 100%;\n  height: 100%;\n}\n\ntd.rdtMonth,\ntd.rdtYear {\n  height: 50px;\n  width: 25%;\n  cursor: pointer;\n}\ntd.rdtMonth:hover,\ntd.rdtYear:hover {\n  background: #eee;\n}\n\n.rdtCounters {\n  display: inline-block;\n}\n\n.rdtCounters {\n  > div {\n    float: left;\n    width: 40px;\n    font-weight: 300;\n    margin: 3px;\n    border-radius: 50%;\n  }\n  .rdtCounterSeparator {\n    width: 0;\n    border: 1px solid transparent;\n  }\n}\n\n.rdtCounter {\n  height: 100px;\n}\n\n.rdtCounter {\n  width: 40px;\n  .rdtCount {\n    padding: 7px;\n    height: 40px;\n    border: 1px solid transparent;\n  }\n}\n.rdtCounters {\n  .rdtCounter:last-child {\n    .rdtCount {\n      color: $color-azure;\n      border-radius: 50%;\n      border: 1px solid $color-azure;\n    }\n  }\n}\n\n.rdtCounterSeparator {\n  padding: 7px;\n  line-height: 100px;\n}\n.rdtCounter .rdtBtn {\n  line-height: 40px;\n  cursor: pointer;\n  display: block;\n  border-radius: 50%;\n  color: $medium-dark-gray;\n  -webkit-transition: all 60ms ease-in;\n  -moz-transition: all 60ms ease-in;\n  -o-transition: all 60ms ease-in;\n  -ms-transition: all 60ms ease-in;\n  transition: all 60ms ease-in;\n\n  -webkit-touch-callout: none; /* iOS Safari */\n  -webkit-user-select: none; /* Chrome/Safari/Opera */\n  -khtml-user-select: none; /* Konqueror */\n  -moz-user-select: none; /* Firefox */\n  -ms-user-select: none; /* Internet Explorer/Edge */\n  user-select: none;\n}\n.rdtCounter .rdtBtn:hover {\n  background: #eee;\n  color: #797979;\n}\n.rdtCounter .rdtCount {\n  font-size: 1.2em;\n}\n\n.rdtMilli {\n  vertical-align: middle;\n  padding-left: 8px;\n  width: 48px;\n}\n\n.rdtMilli input {\n  width: 100%;\n  font-size: 1.2em;\n  margin-top: 37px;\n}\n.rdtMonths,\n.rdtYears {\n  padding-bottom: 10px;\n  .rdtMonth,\n  .rdtYear {\n    display: inline-block;\n    width: 56px;\n    height: 56px;\n    line-height: 56px;\n    margin: 3px 3px;\n    cursor: pointer;\n    border-radius: 50%;\n    text-align: center;\n\n    &.rdtActive {\n      background-color: $color-azure !important;\n      color: $white-color;\n    }\n  }\n}\n\n.rdtTime {\n  .rdtCounters {\n    .rdtCounterSeparator + .rdtCounter + .rdtCounter .rdtCount {\n      font-size: 1rem;\n    }\n  }\n}\n\n//Customs SCSS\n.right{\n  right: 0%;\n  &:before {\n    border-bottom: 11px solid rgba(0, 0, 0, 0.2);\n    border-left: 11px solid transparent;\n    border-right: 11px solid transparent;\n    content: \"\";\n    display: inline-block;\n    position: absolute;\n    right: 12px;\n    top: -11px;\n  }\n  &:after {\n    border-bottom: 11px solid #ffffff;\n    border-left: 11px solid transparent;\n    border-right: 11px solid transparent;\n    content: \"\";\n    display: inline-block;\n    position: absolute;\n    right: 12px;\n    left: \"\";\n    top: -10px;\n  }\n}\n\n.left{\n\n  &:before {\n    border-bottom: 11px solid rgba(0, 0, 0, 0.2);\n    border-left: 11px solid transparent;\n    border-right: 11px solid transparent;\n    content: \"\";\n    display: inline-block;\n    position: absolute;\n    left: 12px;\n    top: -11px;\n  }\n  &:after {\n    border-bottom: 11px solid #ffffff;\n    border-left: 11px solid transparent;\n    border-right: 11px solid transparent;\n    content: \"\";\n    display: inline-block;\n    position: absolute;\n    left: 12px;\n    top: -10px;\n  }\n}",".rna-container{\n  .alert {\n    button.close{\n      color: #000;\n      display: flex;\n      justify-content: center;\n      align-items: center;\n      span {\n        margin-top: -4px;\n      }\n    }\n  }\n}\n","/**\n* React Select v1.0.0-rc.10\n* ============\n* Created by Jed Watson and Joss Mackison for KeystoneJS, https://www.keystonejs.com/\n* https://twitter.com/jedwatson https://twitter.com/jossmackison https://twitter.com/keystonejs\n* MIT License: https://github.com/JedWatson/react-select\n*/\n\n\n/*\nThis file was modified entirely by Creative Tim for React-Select v2.0.0\n*/\n\n.react-select {\n  .react-select__menu{\n    border-radius: 0;\n    border-bottom-right-radius: 4px;\n    border-bottom-left-radius: 4px;\n    background-color: #fff;\n    border: 1px solid #ccc;\n    border-top-color: #e6e6e6;\n    -webkit-box-shadow: 0 1px 0 rgba(0,0,0,.06);\n    box-shadow: 0 1px 0 rgba(0,0,0,.06);\n    -webkit-box-sizing: border-box;\n    box-sizing: border-box;\n    margin-top: -1px;\n    position: absolute;\n    left: 0;\n    top: 100%;\n    width: 100%;\n    z-index: 5;\n    -webkit-overflow-scrolling: touch;\n  }\n  .react-select__menu-list {\n    overflow-y: auto;\n    padding-bottom: unset;\n    padding-top: unset;\n    position: relative;\n    max-height: 200px;\n  }\n  .react-select__option {\n    cursor: pointer;\n    display: block;\n    padding: 8px 10px;\n  }\n  .react-select__menu{\n    .react-select__option{\n      &,&:active{\n        background-color: transparent;\n      }\n      &.react-select__option--is-selected{\n        &,&:not(:first-child),&.react-select__option--is-focused:not(:first-child){\n          &,&:active{\n            background-color: rgba(0,126,255,.04);\n            color: #333;\n          }\n        }\n      }\n      &:not(:first-child).react-select__option--is-focused:not(:first-child) {\n        &,&:active{\n          background-color: rgba(0,126,255,.08);\n          color: #333;\n        }\n      }\n      &.react-select__option--is-disabled {\n        &,&:active{\n          color: #cccccc;\n          cursor: default;\n        }\n      }\n    }\n  }\n  .react-select__control{\n    background-color: $white-color;\n    border-color: #d9d9d9 #ccc #b3b3b3;\n    border-radius: 4px;\n    border: 1px solid #ccc;\n    min-height: 36px;\n    height: 36px;\n    box-sizing: border-box;\n    border-collapse: separate;\n    display: table;\n    width: 100%;\n    &.react-select__control--menu-is-open{\n      border-bottom-left-radius: 0;\n      border-bottom-right-radius: 0;\n    }\n    &.react-select__control--is-focused{\n      .react-select__dropdown-indicator{\n        &:after{\n          transform: rotate(180deg);\n          top: -4px;\n        }\n      }\n      &,&:hover{\n        border: 1px solid $primary-color;\n        box-shadow: none;\n      }\n    }\n    .react-select__value-container--has-value{\n      .react-select__multi-value{\n        display: inline-flex;\n        border-radius: 4px;\n        background-color: transparent;\n        & + div:not(.react-select__multi-value){\n          display: inline-flex;\n        }\n        .react-select__multi-value__label{\n          font-size: 0.9em;\n        }\n      }\n      .react-select__single-value{\n        top: 48%;\n        color: $black-color;\n      }\n    }\n    .react-select__placeholder{\n      color: $medium-dark-gray;\n      line-height: 34px;\n      padding-left: 10px;\n      padding-right: 10px;\n      font-size: 14px;\n      left: 0;\n      margin-left: 0;\n      margin-right: 0;\n    }\n    .react-select__value-container,\n    .react-select__indicators{\n      display: table-cell;\n    }\n    .react-select__indicators {\n      width: 60px;\n      padding-right: 10px;\n      align-items: flex-end;\n      vertical-align: middle;\n      text-align: right;\n      .react-select__indicator-separator{\n        display: none;\n      }\n      .react-select__indicator {\n        padding: 0;\n        display: inline-block;\n      }\n      .react-select__dropdown-indicator{\n        &:after{\n          transition: all 150ms ease 0s;\n          border-color: #999 transparent transparent;\n          border-style: solid;\n          border-width: 5px 5px 2.5px;\n          display: inline-block;\n          height: 0;\n          width: 0;\n          position: relative;\n          content: \"\";\n        }\n        &:hover:after{\n          border-top-color: $link-disabled-color;\n        }\n        & > * {\n          display: none;\n        }\n      }\n      .react-select__clear-indicator{\n        &:before{\n          content: \"\\D7\";\n          display: inline-block;\n          font-size: 18px;\n          line-height: 1;\n          top: 2px;\n          position: relative;\n          margin-right: 3px;\n        }\n        & > * {\n          display: none;\n        }\n      }\n    }\n  }\n  &.primary{\n    .react-select__control{\n      &.react-select__control--is-focused{\n        &,&:hover{\n          border-color: $primary-color;\n        }\n      }\n      .react-select__value-container--has-value{\n        .react-select__single-value,\n        .react-select__multi-value__label{\n          color: $primary-color;\n        }\n      }\n    }\n    .react-select__multi-value{\n      border: 1px solid $primary-color;\n      .react-select__multi-value__remove{\n        color: $primary-states-color;\n        border-left: 1px solid $primary-states-color;\n        &:hover{\n          color: $primary-color;\n          background-color: transparent;\n        }\n      }\n    }\n  }\n  &.success{\n    .react-select__control{\n      &.react-select__control--is-focused{\n        &,&:hover{\n          border-color: $success-color;\n        }\n      }\n      .react-select__value-container--has-value{\n        .react-select__single-value,\n        .react-select__multi-value__label{\n          color: $success-color;\n        }\n      }\n    }\n    .react-select__multi-value{\n      border: 1px solid $success-color;\n      .react-select__multi-value__remove{\n        color: $success-states-color;\n        border-left: 1px solid $success-states-color;\n        &:hover{\n          color: $success-color;\n          background-color: transparent;\n        }\n      }\n    }\n  }\n  &.info{\n    .react-select__control{\n      &.react-select__control--is-focused{\n        &,&:hover{\n          border-color: $info-color;\n        }\n      }\n      .react-select__value-container--has-value{\n        .react-select__single-value,\n        .react-select__multi-value__label{\n          color: $info-color;\n        }\n      }\n    }\n    .react-select__multi-value{\n      border: 1px solid $info-color;\n      .react-select__multi-value__remove{\n        color: $info-states-color;\n        border-left: 1px solid $info-states-color;\n        &:hover{\n          color: $info-color;\n          background-color: transparent;\n        }\n      }\n    }\n  }\n  &.warning{\n    .react-select__control{\n      &.react-select__control--is-focused{\n        &,&:hover{\n          border-color: $warning-color;\n        }\n      }\n      .react-select__value-container--has-value{\n        .react-select__single-value,\n        .react-select__multi-value__label{\n          color: $warning-color;\n        }\n      }\n    }\n    .react-select__multi-value{\n      border: 1px solid $warning-color;\n      .react-select__multi-value__remove{\n        color: $warning-states-color;\n        border-left: 1px solid $warning-states-color;\n        &:hover{\n          color: $warning-color;\n          background-color: transparent;\n        }\n      }\n    }\n  }\n  &.danger{\n    .react-select__control{\n      &.react-select__control--is-focused{\n        &,&:hover{\n          border-color: $danger-color;\n        }\n      }\n      .react-select__value-container--has-value{\n        .react-select__single-value,\n        .react-select__multi-value__label{\n          color: $danger-color;\n        }\n      }\n    }\n    .react-select__multi-value{\n      border: 1px solid $danger-color;\n      .react-select__multi-value__remove{\n        color: $danger-states-color;\n        border-left: 1px solid $danger-states-color;\n        &:hover{\n          color: $danger-color;\n          background-color: transparent;\n        }\n      }\n    }\n  }\n  .react-select__multi-value{\n    border: 1px solid $dark-gray;\n    .react-select__multi-value__remove{\n      position: relative;\n      color: $medium-dark-gray;\n      border-left: 1px solid $medium-dark-gray;\n      &:hover{\n        color: $dark-gray;\n        background-color: transparent;\n      }\n    }\n  }\n  &.react-select--is-disabled{\n    .react-select__multi-value--is-disabled{\n      .react-select__multi-value__remove {\n        display: none;\n      }\n      &.react-select__multi-value{\n        background-color: #fcfcfc;\n        border: 1px solid #e3e3e3;\n      }\n    }\n    .react-select__control--is-disabled{\n      background-color: #f9f9f9;\n    }\n  }\n}\n","@import \"../../lbd/variables\";\n\n.ReactTable {\n  position: relative;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  background-color: transparent;\n}\n.ReactTable {\n  .actions-right {\n    text-align: right;\n  }\n  .actions-left {\n    text-align: left;\n  }\n  .actions-center {\n    text-align: center;\n  }\n}\n.ReactTable * {\n  box-sizing: border-box;\n}\n.ReactTable .rt-table {\n  -webkit-box-flex: 1;\n  -ms-flex: auto 1;\n  flex: auto 1;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-box-align: stretch;\n  -ms-flex-align: stretch;\n  align-items: stretch;\n  width: 100%;\n  border-collapse: collapse;\n  overflow: auto;\n  table-layout: fixed;\n}\n.ReactTable .rt-thead {\n  -webkit-box-flex: 1;\n  -ms-flex: 1 0 auto;\n  flex: 1 0 auto;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n.ReactTable .rt-thead.-headerGroups {\n  background: rgba(0, 0, 0, 0.03);\n  border-bottom: 1px solid rgba(0, 0, 0, 0.05);\n}\n.ReactTable .rt-thead.-filters {\n  border-bottom: 1px solid rgba(0, 0, 0, 0.05);\n}\n.ReactTable .rt-thead.-filters input,\n.ReactTable .rt-thead.-filters select {\n  border: 1px solid #e3e3e3;\n  border-radius: 4px;\n  color: #565656;\n  font-weight: 400;\n  height: 36px;\n  background-color: inherit;\n  padding-left: 0.8em;\n  &:focus {\n    outline: none;\n    border: 1px solid #aaa;\n    color: #333;\n  }\n}\n.ReactTable .rt-thead .rt-tr {\n  text-align: center;\n}\n.ReactTable .rt-thead .rt-th:last-child {\n  text-align: right;\n  margin: unset;\n}\n.ReactTable .rt-thead .rt-th.-cursor-pointer > div:first-of-type {\n  &:after {\n    opacity: 0.4;\n    content: \"\\F0DC\";\n    position: relative;\n    display: inline-block;\n    bottom: 0;\n    right: -7px;\n    font-family: \"Font Awesome 5 Pro\";\n    font-weight: 900;\n  }\n}\n.ReactTable .rt-thead .rt-th.-cursor-pointer.-sort-desc > div:first-of-type {\n  &:after {\n    content: \"\\F0DD\";\n    top: -3px;\n    position: relative;\n    display: inline-block;\n    bottom: 0;\n    right: -7px;\n    font-family: \"Font Awesome 5 Pro\";\n    font-weight: 900;\n    opacity: 0.8;\n  }\n}\n.ReactTable .rt-thead .rt-th.-cursor-pointer.-sort-asc > div:first-of-type {\n  &:after {\n    content: \"\\F0DE\";\n    top: 3px;\n    position: relative;\n    display: inline-block;\n    bottom: 0;\n    right: -7px;\n    font-family: \"Font Awesome 5 Pro\";\n    font-weight: 900;\n    opacity: 0.8;\n  }\n}\n.ReactTable .rt-thead .rt-th,\n.ReactTable .rt-thead .rt-td {\n  font-size: 1.063rem;\n  text-align: left;\n  font-weight: 300;\n  line-height: 2.5em !important;\n  padding: 5px 5px;\n  line-height: normal;\n  position: relative;\n  transition: box-shadow 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);\n  box-shadow: inset 0 0 0 0 transparent;\n  overflow: hidden;\n    white-space: nowrap;\n    -moz-text-overflow: ellipsis;        \n       -ms-text-overflow: ellipsis;\n        -o-text-overflow: ellipsis;\n           text-overflow: ellipsis;\n}\n.ReactTable .rt-thead .rt-th.-cursor-pointer,\n.ReactTable .rt-thead .rt-td.-cursor-pointer {\n  cursor: pointer;\n}\n.ReactTable .rt-thead .rt-th:last-child,\n.ReactTable .rt-thead .rt-td:last-child {\n  border-right: 0;\n}\n.ReactTable .rt-thead .rt-resizable-header {\n  overflow: visible;\n}\n.ReactTable .rt-thead .rt-resizable-header:last-child {\n  overflow: hidden;\n}\n.ReactTable .rt-thead .rt-resizable-header-content {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  &:focus {\n    outline: none;\n  }\n}\n.ReactTable .rt-thead .rt-header-pivot {\n  border-right-color: #f7f7f7;\n}\n.ReactTable .rt-thead .rt-header-pivot:after,\n.ReactTable .rt-thead .rt-header-pivot:before {\n  left: 100%;\n  top: 50%;\n  border: solid transparent;\n  content: \" \";\n  height: 0;\n  width: 0;\n  position: absolute;\n  pointer-events: none;\n}\n.ReactTable .rt-thead .rt-header-pivot:after {\n  border-color: rgba(255, 255, 255, 0);\n  border-left-color: #fff;\n  border-width: 8px;\n  margin-top: -8px;\n}\n.ReactTable .rt-thead .rt-header-pivot:before {\n  border-color: rgba(102, 102, 102, 0);\n  border-left-color: #f7f7f7;\n  border-width: 10px;\n  margin-top: -10px;\n}\n.ReactTable .rt-tbody {\n  -webkit-box-flex: 99999;\n  -ms-flex: 99999 1 auto;\n  flex: 99999 1 auto;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  overflow: auto;\n}\n.ReactTable .rt-tbody .rt-tr-group {\n  border-bottom: solid 1px rgba(0, 0, 0, 0.05);\n}\n.ReactTable .rt-tbody .rt-tr-group:last-child {\n  border-bottom: 0;\n}\n.ReactTable .rt-tbody .rt-td:last-child {\n  border-right: 0;\n}\n.ReactTable .rt-tbody .rt-expandable {\n  cursor: pointer;\n}\n.ReactTable .rt-tr-group {\n  -webkit-box-flex: 1;\n  -ms-flex: 1 0 auto;\n  flex: 1 0 auto;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  -webkit-box-align: stretch;\n  -ms-flex-align: stretch;\n  align-items: stretch;\n}\n.ReactTable .rt-tr {\n  -webkit-box-flex: 1;\n  -ms-flex: 1 0 auto;\n  flex: 1 0 auto;\n  display: -webkit-inline-box;\n  display: -ms-inline-flexbox;\n  display: inline-flex;\n  //display: inline-block;\n}\n.ReactTable .rt-th,\n.ReactTable .rt-td {\n  -webkit-box-flex: 1;\n  -ms-flex: 1 0 0px;\n  flex: 1 0 0;\n  white-space: unset;\n  text-overflow: ellipsis;\n  padding: 7px 5px;\n  overflow: hidden;\n  transition: 0.3s ease;\n  transition-property: width, min-width, padding, opacity;\n  margin: auto;\n}\n.ReactTable .rt-th.-hidden,\n.ReactTable .rt-td.-hidden {\n  width: 0 !important;\n  min-width: 0 !important;\n  padding: 0 !important;\n  border: 0 !important;\n  opacity: 0 !important;\n}\n.ReactTable .rt-expander {\n  display: inline-block;\n  position: relative;\n  margin: 0;\n  color: transparent;\n  margin: 0 10px;\n}\n.ReactTable .rt-expander:after {\n  content: \"\";\n  position: absolute;\n  width: 0;\n  height: 0;\n  top: 50%;\n  left: 50%;\n  -webkit-transform: translate(-50%, -50%) rotate(-90deg);\n  transform: translate(-50%, -50%) rotate(-90deg);\n  border-left: 5.04px solid transparent;\n  border-right: 5.04px solid transparent;\n  border-top: 7px solid rgba(0, 0, 0, 0.8);\n  transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);\n  cursor: pointer;\n}\n.ReactTable .rt-expander.-open:after {\n  -webkit-transform: translate(-50%, -50%) rotate(0);\n  transform: translate(-50%, -50%) rotate(0);\n}\n.ReactTable .rt-resizer {\n  display: inline-block;\n  position: absolute;\n  width: 36px;\n  top: 0;\n  bottom: 0;\n  right: -18px;\n  cursor: col-resize;\n  z-index: 10;\n}\n.ReactTable .rt-tfoot {\n  -webkit-box-flex: 1;\n  -ms-flex: 1 0 auto;\n  flex: 1 0 auto;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  box-shadow: 0 0 15px 0 rgba(0, 0, 0, 0.15);\n}\n.ReactTable .rt-tfoot .rt-td {\n  border-right: 1px solid rgba(0, 0, 0, 0.05);\n}\n.ReactTable .rt-tfoot .rt-td:last-child {\n  border-right: 0;\n}\n.ReactTable.-striped .rt-tr.-odd {\n  background: rgba(0, 0, 0, 0.03);\n}\n.ReactTable.-highlight .rt-tbody .rt-tr:not(.-padRow):hover {\n  background: rgba(0, 0, 0, 0.05);\n}\n.ReactTable .-pagination {\n  z-index: 1;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n  -ms-flex-pack: justify;\n  justify-content: space-between;\n  -webkit-box-align: stretch;\n  -ms-flex-align: stretch;\n  align-items: stretch;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  padding: 3px;\n}\n// .ReactTable .rt-thead.-filters select, .ReactTable .-pagination .select-wrap select{\n//\n//\n// }\n.ReactTable .-pagination input,\n.ReactTable .-pagination select {\n  border: 1px solid #e3e3e3;\n  border-radius: 4px;\n  color: #565656;\n  font-weight: 400;\n  height: 36px;\n  background-color: inherit;\n  text-align: center;\n  &:focus {\n    outline: none;\n    border: 1px solid #aaa;\n    color: #333;\n  }\n}\n.ReactTable .-pagination .-btn {\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  display: block;\n  width: 100%;\n  height: 100%;\n  border: 0;\n  border-radius: 3px;\n  padding: 6px;\n  font-size: 1em;\n  color: $white-color;\n  background: $primary-color;\n  transition: all 0.1s ease;\n  cursor: pointer;\n  outline: none;\n}\n.ReactTable .-pagination .-btn[disabled] {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n.ReactTable .-pagination .-btn:not([disabled]):hover {\n  background: $primary-states-color;\n  color: $white-color;\n}\n.ReactTable .-pagination .-previous,\n.ReactTable .-pagination .-next {\n  -webkit-box-flex: 1;\n  -ms-flex: 1;\n  flex: 1;\n  text-align: center;\n}\n.ReactTable .-pagination .-center {\n  -webkit-box-flex: 1.5;\n  -ms-flex: 1.5;\n  flex: 1.5;\n  text-align: center;\n  margin-bottom: 0;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -ms-flex-wrap: wrap;\n  flex-wrap: wrap;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  align-items: center;\n  -ms-flex-pack: distribute;\n  justify-content: space-around;\n}\n.ReactTable .-pagination .-pageInfo {\n  display: inline-block;\n  margin: 3px 10px;\n  white-space: nowrap;\n}\n.ReactTable .-pagination .-pageJump {\n  display: inline-block;\n}\n.ReactTable .-pagination .-pageSizeOptions {\n  margin: 3px 10px;\n}\n.ReactTable .rt-noData {\n  display: block;\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  -webkit-transform: translate(-50%, -50%);\n  transform: translate(-50%, -50%);\n  background: rgba(255, 255, 255, 0.8);\n  transition: all 0.3s ease;\n  z-index: 1;\n  pointer-events: none;\n  padding: 20px;\n  color: rgba(0, 0, 0, 0.5);\n}\n.ReactTable .-loading {\n  display: block;\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 0;\n  bottom: 0;\n  background: rgba(255, 255, 255, 0.8);\n  transition: all 0.3s ease;\n  z-index: -1;\n  opacity: 0;\n  pointer-events: none;\n}\n.ReactTable .-loading > div {\n  position: absolute;\n  display: block;\n  text-align: center;\n  width: 100%;\n  top: 50%;\n  left: 0;\n  font-size: 15px;\n  color: rgba(0, 0, 0, 0.6);\n  -webkit-transform: translateY(-52%);\n  transform: translateY(-52%);\n  transition: all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);\n}\n.ReactTable .-loading.-active {\n  opacity: 1;\n  z-index: 2;\n  pointer-events: all;\n}\n.ReactTable .-loading.-active > div {\n  -webkit-transform: translateY(50%);\n  transform: translateY(50%);\n}\n.ReactTable .rt-resizing .rt-th,\n.ReactTable .rt-resizing .rt-td {\n  transition: none !important;\n  cursor: col-resize;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n\n.ReactTable .rt-thead .rt-th:focus {\n  outline: none;\n}\n.ReactTable .rt-thead .rt-th {\n  font-size: 12px;\n  text-transform: uppercase;\n  color: #9a9a9a;\n  font-weight: 400;\n}\n\n.resizer {\n  display: inline-block;\n  background: blue;\n  width: 10px;\n  height: 100%;\n  position: absolute;\n  right: 0;\n  top: 0;\n  transform: translateX(50%);\n  touch-action:none;\n\n  &.isResizing {\n    background: red;\n  }\n}",".alert{\n  border-radius: .25rem;\n}\n",".fixed-plugin{\n  background-color: unset;\n  .dropdown-toggle,\n  .dropdown-toggle:focus,\n  .dropdown-toggle:active {\n    background-color: rgba(0, 0, 0, 0.3) !important;\n    border: none !important;\n    padding: 0;\n    border-top-right-radius: 0;\n    border-bottom-right-radius: 0;\n    .fa-cogs {\n      padding-left: 15px;\n      padding-right: 15px;\n    }\n    &::after{\n      display: none;\n    }\n  }\n}\n",".navbar {\n  min-height: unset;\n  max-height: unset;\n  .btn,\n  .navbar-brand,\n  .navbar-nav .nav-item .nav-link  {\n    margin: unset;\n    align-items: center;\n  }\n  .navbar-nav {\n    .dropdown-toggle:after {\n      margin-top: 0px;\n    }\n  }\n}\n\n@media (min-width: 992px) {\n  .navbar {\n    .navbar-nav {\n      .nc-icon {\n        margin-top: unset;\n      }\n      .notification {\n        top: 0px;\n      }\n    }\n  }\n}\n\n@media (max-width: 991.98px){\n  .navbar-expand-lg>.container,\n  .navbar-expand-lg>.container-fluid,\n  .navbar-expand-lg>.container-lg,\n  .navbar-expand-lg>.container-md,\n  .navbar-expand-lg>.container-sm,\n  .navbar-expand-lg>.container-xl {\n    padding-right: 15px;\n    padding-left: 15px;\n  }\n}\n",".card-header-tabs {\n    border-bottom: 1px solid #dee2e6;  \n}\n",".sidebar {\n  &[data-color=\"black\"]:after{\n    @include icon-gradient(#282828, rgba(#111,.7));\n  }\n  .logo a.logo-mini,.logo-img {\n    width: 40px;\n  }\n  .logo a.logo-mini {\n    margin-right: 5px;\n  }\n  .logo-img img{\n    width: 40px;\n    top: 6px;\n  }\n}\n\n.sidebar-mini {\n  .sidebar {\n    .nav .nav-item .nav-link {\n      padding: 10px 12px;\n    }\n    &:hover {\n      .nav .nav-item .nav-link {\n        padding: 10px 15px;\n      }\n    }\n  }\n  .main-panel {\n    .navbar.fixed-top {\n      margin-left: auto;\n      width: calc(100% - 80px);\n    }\n  }\n}\n\n.close-layer {\n  display: none;\n  pointer-events: none;\n  width: 0;\n  height: 0;\n}\n\n@media (max-width: 991px){\n  .nav-open {\n    .close-layer {\n      width: 100%;\n      height: 100%;\n      pointer-events: auto;\n      display: block;\n      opacity: 1;\n    }\n  }\n}\n\n.main-panel {\n  .navbar.fixed-top {\n    margin-left: auto;\n    width: $sidebar-width;\n  }\n}\n\n\n.full-page[data-color=\"black\"]:after {\n  background: #282828;\n  background: linear-gradient(180deg,#282828 0,rgba(17,17,17,.4));\n  opacity: .9;\n}\n",".custom-switch {\n  min-height: 26px;\n  min-width: 62px;\n  padding: 0;\n  .custom-control-label::after {\n    width: 22px!important;\n    height: 22px!important;\n    border-radius: 22px;\n    transition: all .15s ease-in-out;\n    top: 2px;\n    left: 2px;\n    background-color: white;\n  }\n  .custom-control-label::before {\n    width: 62px!important;\n    height: 26px!important;\n    border-radius: 26px;\n    left: 0;\n    top: 0;\n    border: #ddd;\n    background: #ddd;\n  }\n  .custom-control-input:checked~.custom-control-label::after {\n    transform: translateX(36px);\n  }\n  &:hover{\n    .custom-control-input:checked~.custom-control-label::after{\n      margin-left: -6px;\n    }\n    .custom-control-label::after{\n      width: 28px !important;\n    }\n  }\n}\n",".react-tagsinput {\n  background-color: #fff;\n  border-bottom: 2px solid #efefef;\n  overflow: hidden;\n  padding-top: 5px;\n  @include transition(60ms, ease-in);\n}\n\n.react-tagsinput--focused {\n  border-bottom: 2px solid #2196f3;\n}\n\n.react-tagsinput-tag {\n  cursor: pointer;\n  overflow: hidden;\n  position: relative;\n  margin: 5px 3px 5px 0;\n  padding: 2px 12px;\n  border: 1px solid #888888;\n  border-radius: 3px;\n  color: #888888;\n  font-weight: 500;\n  font-size: 12px;\n  text-transform: uppercase;\n  display: inline-block;\n  vertical-align: middle;\n  @include transition(60ms, ease-in);\n\n  &:hover {\n    padding-left: 8px;\n    padding-right: 16px;\n\n    a {\n      opacity: 1;\n      padding-right: 4px;\n    }\n  }\n\n  a {\n    &::before {\n      content: \"\\f00d\";\n      font-family: \"Font Awesome 5 Free\";\n      font-weight: 900;\n    }\n\n    // @extend .animation-transition-ultra-fast;\n    @include transition(60ms, ease-in);\n    color: $default-color;\n    cursor: pointer;\n    font-size: 12px;\n    padding: 2px 0;\n    position: absolute;\n    right: 0;\n    opacity: 0;\n    text-align: right;\n    text-decoration: none;\n    top: 0;\n    width: 100%;\n    z-index: 2;\n  }\n\n  &.tag-blue,\n  &.tag-blue a {\n    @include label-color($primary-color);\n  }\n  &.tag-azure,\n  &.tag-azure a {\n    @include label-color($info-color);\n  }\n  &.tag-green,\n  &.tag-green a {\n    @include label-color($success-color);\n  }\n  &.tag-orange,\n  &.tag-orange a {\n    @include label-color($warning-color);\n  }\n  &.tag-red,\n  &.tag-red a {\n    @include label-color($danger-color);\n  }\n\n  &.tag-fill {\n    &.tag-blue {\n      @include label-color-fill($primary-color);\n    }\n    &.tag-azure {\n      @include label-color-fill($info-color);\n    }\n    &.tag-green {\n      @include label-color-fill($success-color);\n    }\n    &.tag-orange {\n      @include label-color-fill($warning-color);\n    }\n    &.tag-red {\n      @include label-color-fill($danger-color);\n    }\n  }\n  &.tag-fill,\n  &.tag-fill a {\n    color: $white-color;\n  }\n}\n\n.react-tagsinput-remove {\n  cursor: pointer;\n  font-weight: bold;\n}\n.react-tagsinput-input {\n  background: transparent;\n  border: 0;\n  color: #777;\n  font-family: sans-serif;\n  font-size: 13px;\n  font-weight: 400;\n  margin-bottom: 6px;\n  margin-top: 1px;\n  outline: none;\n  padding: 5px;\n  width: 80px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
